
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("2OYZx", function(module, exports) {
$parcel$export(module.exports, "ProformaIntlProvider", () => $faaba593c4ca0eea$export$f345b4b8e42e419e);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $dTM5i = parcelRequire("dTM5i");

var $fhtbn = parcelRequire("fhtbn");
const $faaba593c4ca0eea$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
    const { language: language, country: country } = (0, $fhtbn.getCodesFromLocale)(locale) ?? {};
    const lazyMessages = (0, $fhtbn.useLazyMessages)(messages, language ?? (0, $fhtbn.DEFAULT_LOCALE), country);
    // Read an ancestor IntlProvider's messages (if any) so that translations
    // owned by the consumer app remain available to content rendered beneath
    // this provider — notably custom renderers passed into proforma surfaces
    // that call <FormattedMessage /> with consumer-owned ids.
    //
    // We read IntlContext directly rather than using useIntl() because useIntl()
    // throws when there is no ancestor provider, and this component is
    // documented to work standalone. Package-owned messages are spread last so
    // they always win on id collisions, preserving the library's canonical
    // translations.
    const parentIntl = (0, $bSJIT.useContext)((0, $fK3tS.Context));
    const parentMessages = parentIntl === null || parentIntl === void 0 ? void 0 : parentIntl.messages;
    // `IntlProvider` expects a homogeneous Record<string, string> or
    // Record<string, MessageFormatElement[]>. The parent bundle may contain
    // pre-compiled MessageFormatElement[] values, while our lazy bundle is
    // always plain strings; mixing them at the type level is fine at runtime
    // because react-intl handles both per-entry.
    // Hence casting mergedMessages to Record<string, string> is purely done to
    // satisfy Typescript.
    const mergedMessages = (0, $bSJIT.useMemo)(()=>lazyMessages !== undefined ? {
            ...parentMessages ?? {},
            ...lazyMessages
        } : undefined, [
        parentMessages,
        lazyMessages
    ]);
    if (mergedMessages === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        messages: mergedMessages,
        locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
        defaultLocale: (0, $fhtbn.DEFAULT_LOCALE),
        defaultRichTextElements: (0, $fhtbn.DEFAULT_RICH_TEXT_ELEMENTS)
    }, children);
};

});
parcelRegister("fhtbn", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $0a20d9f181dd4ba3$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "DEFAULT_RICH_TEXT_ELEMENTS", () => $0a20d9f181dd4ba3$export$20839b2a3f182514);
$parcel$export(module.exports, "getCodesFromLocale", () => $0a20d9f181dd4ba3$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyMessages", () => $0a20d9f181dd4ba3$export$7ddce3b5511cfaa8);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");
const $0a20d9f181dd4ba3$export$1af4c7e47ad72f44 = 'en';
const $0a20d9f181dd4ba3$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $0a20d9f181dd4ba3$export$20839b2a3f182514 = {
    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            weight: "bold"
        }, chunks),
    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            as: "strong"
        }, chunks)
};
const $0a20d9f181dd4ba3$export$4d25b49b6dc1b540 = (locale)=>{
    const match = $0a20d9f181dd4ba3$var$localeRegex.exec(locale);
    if (match) {
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    }
    // TODO: Use error service to log:
    // eslint-disable-next-line no-console
    console.error('Unable to determine language and country from invalid locale.');
    return undefined;
};
const $0a20d9f181dd4ba3$var$loadLazyMessages = async (lazyMessages, language, country)=>{
    var _await, _ref;
    return ((_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) ?? {};
};
const $0a20d9f181dd4ba3$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
    const [messages, setMessages] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        $0a20d9f181dd4ba3$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
    }, [
        country,
        language,
        lazyMessages,
        setMessages
    ]);
    return messages;
};

});


parcelRegister("5JwFL", function(module, exports) {
$parcel$export(module.exports, "useFormRendererState", () => $d7bf5c3455b9c71a$export$21879c660c728e30);
$parcel$export(module.exports, "usePublicFormRendererState", () => $d7bf5c3455b9c71a$export$2ecc69efdd0f0d82);
$parcel$export(module.exports, "useFormRenderMode", () => $d7bf5c3455b9c71a$export$5172973f7afd647c);
$parcel$export(module.exports, "useFormField", () => $d7bf5c3455b9c71a$export$b0aeb07a3112de27);
$parcel$export(module.exports, "useFormRendererActions", () => $d7bf5c3455b9c71a$export$42884c6d1601da93);
$parcel$export(module.exports, "usePublicFormRendererActions", () => $d7bf5c3455b9c71a$export$e2f3fbdb7126e4d9);
$parcel$export(module.exports, "FormRendererContainer", () => $d7bf5c3455b9c71a$export$ac3852cc00d01fb0);
$parcel$export(module.exports, "useAttachmentConfiguration", () => $d7bf5c3455b9c71a$export$457ceef4315cacf6);
$parcel$export(module.exports, "useCurrentValues", () => $d7bf5c3455b9c71a$export$fc3e9fca0ef8e147);
$parcel$export(module.exports, "useCurrentValue", () => $d7bf5c3455b9c71a$export$d38bf533b9056693);
$parcel$export(module.exports, "useFieldCustomError", () => $d7bf5c3455b9c71a$export$e0aa08f9b4d99fd8);
$parcel$export(module.exports, "useFieldInvalid", () => $d7bf5c3455b9c71a$export$51afe934cbbf72eb);
$parcel$export(module.exports, "useFieldRequired", () => $d7bf5c3455b9c71a$export$1a2489b59e0f6d90);
$parcel$export(module.exports, "useFieldValidationErrors", () => $d7bf5c3455b9c71a$export$6b78b103358325f6);
$parcel$export(module.exports, "useLifecycleHandlers", () => $d7bf5c3455b9c71a$export$1c401cef1281dfe7);
$parcel$export(module.exports, "useRenderers", () => $d7bf5c3455b9c71a$export$1c246cb86ce77ce4);
$parcel$export(module.exports, "useTotalFormAttachments", () => $d7bf5c3455b9c71a$export$c9cec29e337d4de1);

var $gfNVK = parcelRequire("gfNVK");
var $adFyB = parcelRequire("adFyB");
var $7CE69 = parcelRequire("7CE69");

var $gkoaJ = parcelRequire("gkoaJ");

var $4ve8e = parcelRequire("4ve8e");

var $i0Lo9 = parcelRequire("i0Lo9");

var $ZC397 = parcelRequire("ZC397");

var $40O90 = parcelRequire("40O90");

var $4HPol = parcelRequire("4HPol");

var $9Mnjx = parcelRequire("9Mnjx");

var $eyjhg = parcelRequire("eyjhg");

var $gvi18 = parcelRequire("gvi18");

var $6Caju = parcelRequire("6Caju");

var $izEf6 = parcelRequire("izEf6");

var $air4B = parcelRequire("air4B");

var $aCDyQ = parcelRequire("aCDyQ");

var $HuWcQ = parcelRequire("HuWcQ");

var $jutXJ = parcelRequire("jutXJ");

var $5sdW4 = parcelRequire("5sdW4");

var $a5VDB = parcelRequire("a5VDB");
const $d7bf5c3455b9c71a$var$FormRendererStore = (0, $7CE69.createStore)({
    initialState: {
        asyncFields: {},
        fieldCustomErrors: {},
        formFields: {},
        formSections: [],
        lifecycleHandlers: {},
        modifiedValues: {},
        renderers: {},
        renderMode: (0, $gkoaJ.FormRenderMode).VIEW,
        fieldVisibility: {
            fieldSet: []
        },
        fieldValidation: {},
        defaultValidators: (0, $4ve8e.buildDefaultFormFieldValidators)(),
        securityCriticalValidators: (0, $4ve8e.buildSecurityCriticalValidators)(),
        formId: ''
    },
    actions: $i0Lo9.actions,
    name: 'FormRendererStore'
});
const $d7bf5c3455b9c71a$export$21879c660c728e30 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore);
const $d7bf5c3455b9c71a$export$2ecc69efdd0f0d82 = ()=>{
    const fileUploadProgress = $d7bf5c3455b9c71a$export$f65eee9b2825749e();
    const hasModifiedValues = $d7bf5c3455b9c71a$export$b8907aa3c6ac8b69();
    return {
        isFileUploadInProgress: fileUploadProgress,
        hasModifiedValues: hasModifiedValues
    };
};
const $d7bf5c3455b9c71a$export$5172973f7afd647c = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $jutXJ.renderModeSelector)
});
const $d7bf5c3455b9c71a$export$b0aeb07a3112de27 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $ZC397.formFieldSelector)
});
const $d7bf5c3455b9c71a$export$42884c6d1601da93 = (0, $gfNVK.createActionsHook)($d7bf5c3455b9c71a$var$FormRendererStore);
const $d7bf5c3455b9c71a$export$e2f3fbdb7126e4d9 = ()=>{
    const { clearModifiedValues: clearModifiedValues, getFieldIdsFailingValidation: getFieldIdsFailingValidation, getFieldValues: getFieldValues, setFieldCustomErrors: setFieldCustomErrors, updateModifiedValue: updateModifiedValue, getVisibleFieldValues: getVisibleFieldValues } = $d7bf5c3455b9c71a$export$42884c6d1601da93();
    return {
        clearModifiedValues: clearModifiedValues,
        getFieldIdsFailingValidation: getFieldIdsFailingValidation,
        getFieldValues: getFieldValues,
        setFieldCustomErrors: setFieldCustomErrors,
        updateModifiedValue: updateModifiedValue,
        getVisibleFieldValues: getVisibleFieldValues
    };
};
const $d7bf5c3455b9c71a$export$ac3852cc00d01fb0 = (0, $adFyB.createContainer)($d7bf5c3455b9c71a$var$FormRendererStore);
const $d7bf5c3455b9c71a$export$457ceef4315cacf6 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $40O90.attachmentConfigurationSelector)
});
const $d7bf5c3455b9c71a$export$fc3e9fca0ef8e147 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $9Mnjx.currentValuesSelector)
});
const $d7bf5c3455b9c71a$export$d38bf533b9056693 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $4HPol.currentValueSelector)
});
const $d7bf5c3455b9c71a$export$e0aa08f9b4d99fd8 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $eyjhg.fieldCustomErrorSelector)
});
const $d7bf5c3455b9c71a$export$51afe934cbbf72eb = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $gvi18.fieldInvalidSelector)
});
const $d7bf5c3455b9c71a$export$1a2489b59e0f6d90 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $6Caju.fieldRequiredSelector)
});
const $d7bf5c3455b9c71a$export$6b78b103358325f6 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $izEf6.fieldValidationErrorsSelector)
});
const $d7bf5c3455b9c71a$export$f65eee9b2825749e = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $air4B.fileUploadProgressSelector)
});
const $d7bf5c3455b9c71a$export$1c401cef1281dfe7 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $HuWcQ.lifecycleHandlersSelector)
});
const $d7bf5c3455b9c71a$export$b8907aa3c6ac8b69 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $aCDyQ.hasModifiedValuesSelector)
});
const $d7bf5c3455b9c71a$export$1c246cb86ce77ce4 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $5sdW4.renderersSelector)
});
const $d7bf5c3455b9c71a$export$c9cec29e337d4de1 = (0, $gfNVK.createStateHook)($d7bf5c3455b9c71a$var$FormRendererStore, {
    selector: (0, $a5VDB.totalFormAttachmentsSelector)
});

});
parcelRegister("gkoaJ", function(module, exports) {
$parcel$export(module.exports, "FormRenderMode", () => $ebe5009e31b8edcf$export$2c15e9795788a85d);
/**
 * How a form is rendered
 */ // oxlint-disable-next-line eslint/no-redeclare
const $ebe5009e31b8edcf$export$2c15e9795788a85d = {
    /**
   * Render a form with all fields as input elements
   */ EDIT: 'edit',
    /**
   * Render a form with all fields as disabled input elements
   */ PREVIEW: 'preview',
    /**
   * Render a form with all field values as plain text
   */ VIEW: 'view'
};

});

parcelRegister("4ve8e", function(module, exports) {
$parcel$export(module.exports, "buildDefaultFormFieldValidators", () => $143b288bffa556b4$export$a072028e5a0fb7c2);
$parcel$export(module.exports, "buildSecurityCriticalValidators", () => $143b288bffa556b4$export$66f0e796dfec7a2a);

var $2nfpZ = parcelRequire("2nfpZ");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $lFDjE = parcelRequire("lFDjE");

var $eqLbu = parcelRequire("eqLbu");

var $e0sS2 = parcelRequire("e0sS2");

var $5U9IG = parcelRequire("5U9IG");

var $6mKvs = parcelRequire("6mKvs");

var $k6x2A = parcelRequire("k6x2A");

var $euTuW = parcelRequire("euTuW");

var $jg5hp = parcelRequire("jg5hp");

var $9y0Zb = parcelRequire("9y0Zb");

var $g4L6R = parcelRequire("g4L6R");
const $143b288bffa556b4$export$a072028e5a0fb7c2 = (intl)=>({
        [(0, $2nfpZ.FormFieldType).ATTACHMENT]: (field, defaultFormFieldValidators, value)=>(0, $eqLbu.getAttachmentValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asFilesValue)(value)),
        [(0, $2nfpZ.FormFieldType).CASCADING_SELECT]: (field, defaultFormFieldValidators, value)=>{
            var _asFormOptionField;
            return (0, $euTuW.getOptionValidationErrors)(((_asFormOptionField = (0, $kVXLM.asFormOptionField)(field)) === null || _asFormOptionField === void 0 ? void 0 : _asFormOptionField.options) ?? [], field.validation, field.label, intl, (0, $i86qj.asOptionsValue)(value));
        },
        [(0, $2nfpZ.FormFieldType).SINGLE_SELECT]: (field, defaultFormFieldValidators, value)=>{
            var _asFormOptionField2;
            return (0, $euTuW.getOptionValidationErrors)(((_asFormOptionField2 = (0, $kVXLM.asFormOptionField)(field)) === null || _asFormOptionField2 === void 0 ? void 0 : _asFormOptionField2.options) ?? [], field.validation, field.label, intl, (0, $i86qj.asOptionsValue)(value));
        },
        [(0, $2nfpZ.FormFieldType).MULTIPLE_SELECT]: (field, defaultFormFieldValidators, value)=>{
            var _asFormOptionField3;
            return (0, $euTuW.getOptionValidationErrors)(((_asFormOptionField3 = (0, $kVXLM.asFormOptionField)(field)) === null || _asFormOptionField3 === void 0 ? void 0 : _asFormOptionField3.options) ?? [], field.validation, field.label, intl, (0, $i86qj.asOptionsValue)(value));
        },
        [(0, $2nfpZ.FormFieldType).CHECKBOX]: (field, defaultFormFieldValidators, value)=>{
            var _asFormOptionField4;
            return (0, $euTuW.getOptionValidationErrors)(((_asFormOptionField4 = (0, $kVXLM.asFormOptionField)(field)) === null || _asFormOptionField4 === void 0 ? void 0 : _asFormOptionField4.options) ?? [], field.validation, field.label, intl, (0, $i86qj.asOptionsValue)(value));
        },
        [(0, $2nfpZ.FormFieldType).RADIO]: (field, defaultFormFieldValidators, value)=>{
            var _asFormOptionField5;
            return (0, $euTuW.getOptionValidationErrors)(((_asFormOptionField5 = (0, $kVXLM.asFormOptionField)(field)) === null || _asFormOptionField5 === void 0 ? void 0 : _asFormOptionField5.options) ?? [], field.validation, field.label, intl, (0, $i86qj.asOptionsValue)(value));
        },
        [(0, $2nfpZ.FormFieldType).DATE]: (field, defaultFormFieldValidators, value)=>{
            var _asDateValue;
            return (0, $e0sS2.getDateValidationErrors)(field.validation, field.label, intl, (_asDateValue = (0, $i86qj.asDateValue)(value)) === null || _asDateValue === void 0 ? void 0 : _asDateValue.date);
        },
        [(0, $2nfpZ.FormFieldType).DATE_TIME]: (field, defaultFormFieldValidators, value)=>(0, $5U9IG.getDateTimeValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asDateTimeValue)(value)),
        [(0, $2nfpZ.FormFieldType).LOCAL_TIME]: (field, defaultFormFieldValidators, value)=>{
            var _asLocalTimeValue;
            return (0, $9y0Zb.getTimeValidationErrors)(field.validation, field.label, intl, (_asLocalTimeValue = (0, $i86qj.asLocalTimeValue)(value)) === null || _asLocalTimeValue === void 0 ? void 0 : _asLocalTimeValue.localTime);
        },
        [(0, $2nfpZ.FormFieldType).RICH_TEXT_PARAGRAPH]: (field, defaultFormFieldValidators, value)=>(0, $lFDjE.getRichTextValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asAdfValue)(value)),
        [(0, $2nfpZ.FormFieldType).NUMBER]: (field, defaultFormFieldValidators, value)=>(0, $k6x2A.getNumberValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asNumberValue)(value)),
        [(0, $2nfpZ.FormFieldType).SHORT_TEXT]: (field, defaultFormFieldValidators, value)=>(0, $jg5hp.getTextValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).LONG_TEXT]: (field, defaultFormFieldValidators, value)=>(0, $jg5hp.getTextValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).URL]: (field, defaultFormFieldValidators, value)=>(0, $g4L6R.getUrlValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).EMAIL]: (field, defaultFormFieldValidators, value)=>(0, $6mKvs.getEmailValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).PARAGRAPH]: (field, defaultFormFieldValidators, value)=>(0, $jg5hp.getTextValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).RATING]: (field, defaultFormFieldValidators, value)=>(0, $k6x2A.getNumberValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asNumberValue)(value)),
        [(0, $2nfpZ.FormFieldType).SCALE]: (field, defaultFormFieldValidators, value)=>(0, $k6x2A.getNumberValidationErrors)(field.validation, field.label, intl, (0, $i86qj.asNumberValue)(value))
    });
const $143b288bffa556b4$export$66f0e796dfec7a2a = (intl)=>({
        [(0, $2nfpZ.FormFieldType).EMAIL]: (_field, _defaultFormFieldValidators, value)=>(0, $6mKvs.getEmailFormatErrors)(intl, (0, $i86qj.asTextValue)(value)),
        [(0, $2nfpZ.FormFieldType).URL]: (_field, _defaultFormFieldValidators, value)=>(0, $g4L6R.getUrlFormatErrors)(intl, (0, $i86qj.asTextValue)(value))
    });

});
parcelRegister("2nfpZ", function(module, exports) {
$parcel$export(module.exports, "FormFieldType", () => $9083684168e43fd2$export$db212fbac945da1b);
$parcel$export(module.exports, "FORM_OPTION_FIELD_TYPES", () => $9083684168e43fd2$export$12307656d08f4847);
$parcel$export(module.exports, "FORM_TEXT_FIELD_TYPES", () => $9083684168e43fd2$export$d9a3195834788f7e);
$parcel$export(module.exports, "FORM_RANKING_FIELD_TYPES", () => $9083684168e43fd2$export$3a2baf5506508e3c);
const $9083684168e43fd2$export$db212fbac945da1b = {
    ATTACHMENT: 'attachment',
    CASCADING_SELECT: 'cascadingSelect',
    SINGLE_SELECT: 'singleSelect',
    MULTIPLE_SELECT: 'multipleSelect',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    RATING: 'rating',
    SCALE: 'scale',
    DATE: 'date',
    DATE_TIME: 'dateTime',
    LOCAL_TIME: 'localTime',
    NUMBER: 'number',
    RICH_TEXT_PARAGRAPH: 'richTextParagraph',
    EMAIL: 'email',
    LONG_TEXT: 'longText',
    PARAGRAPH: 'paragraph',
    SHORT_TEXT: 'shortText',
    URL: 'url',
    CUSTOM: 'custom'
};
const $9083684168e43fd2$export$12307656d08f4847 = [
    $9083684168e43fd2$export$db212fbac945da1b.CASCADING_SELECT,
    $9083684168e43fd2$export$db212fbac945da1b.SINGLE_SELECT,
    $9083684168e43fd2$export$db212fbac945da1b.MULTIPLE_SELECT,
    $9083684168e43fd2$export$db212fbac945da1b.CHECKBOX,
    $9083684168e43fd2$export$db212fbac945da1b.RADIO
];
const $9083684168e43fd2$export$d9a3195834788f7e = [
    $9083684168e43fd2$export$db212fbac945da1b.EMAIL,
    $9083684168e43fd2$export$db212fbac945da1b.LONG_TEXT,
    $9083684168e43fd2$export$db212fbac945da1b.PARAGRAPH,
    $9083684168e43fd2$export$db212fbac945da1b.SHORT_TEXT,
    $9083684168e43fd2$export$db212fbac945da1b.URL
];
const $9083684168e43fd2$export$3a2baf5506508e3c = [
    $9083684168e43fd2$export$db212fbac945da1b.RATING,
    $9083684168e43fd2$export$db212fbac945da1b.SCALE
];

});

parcelRegister("i86qj", function(module, exports) {
$parcel$export(module.exports, "asAdfValue", () => $d09a6f90c130d3a8$export$66be9ea255ebd33e);
$parcel$export(module.exports, "asDateTimeValue", () => $d09a6f90c130d3a8$export$7bb606c8737f4fa1);
$parcel$export(module.exports, "asDateValue", () => $d09a6f90c130d3a8$export$487536c088c8456b);
$parcel$export(module.exports, "asFilesValue", () => $d09a6f90c130d3a8$export$588543e203236c4b);
$parcel$export(module.exports, "asLocalTimeValue", () => $d09a6f90c130d3a8$export$a41fe93036a4f796);
$parcel$export(module.exports, "asModifiedFilesValue", () => $d09a6f90c130d3a8$export$a43efc1fe3b199ae);
$parcel$export(module.exports, "asNumberValue", () => $d09a6f90c130d3a8$export$e0103605c09cfe79);
$parcel$export(module.exports, "asOptionsValue", () => $d09a6f90c130d3a8$export$a9556b001634798e);
$parcel$export(module.exports, "asTextValue", () => $d09a6f90c130d3a8$export$999467445028f8e1);
$parcel$export(module.exports, "isOptionsValue", () => $d09a6f90c130d3a8$export$33c7a540ebc0a650);
$parcel$export(module.exports, "isNumberValue", () => $d09a6f90c130d3a8$export$3ff5e9927c3257c6);
$parcel$export(module.exports, "isDateValue", () => $d09a6f90c130d3a8$export$14759b5514e9ff67);
$parcel$export(module.exports, "isDateTimeValue", () => $d09a6f90c130d3a8$export$70ffef27d62e47d);
$parcel$export(module.exports, "isLocalTimeValue", () => $d09a6f90c130d3a8$export$a7da7ea29e6e3676);
$parcel$export(module.exports, "isTextValue", () => $d09a6f90c130d3a8$export$e3a34768eb54be7c);
const $d09a6f90c130d3a8$export$66be9ea255ebd33e = (fieldValue)=>fieldValue && 'adf' in fieldValue ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$7bb606c8737f4fa1 = (fieldValue)=>fieldValue && ('date' in fieldValue || 'localTime' in fieldValue) ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$487536c088c8456b = (fieldValue)=>fieldValue && 'date' in fieldValue && !('localTime' in fieldValue) ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$588543e203236c4b = (fieldValue)=>fieldValue && 'files' in fieldValue ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$a41fe93036a4f796 = (fieldValue)=>fieldValue && 'localTime' in fieldValue && !('date' in fieldValue) ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$a43efc1fe3b199ae = (fieldValue)=>fieldValue && 'fileStatus' in fieldValue ? fieldValue : fieldValue === null ? null : undefined;
const $d09a6f90c130d3a8$export$e0103605c09cfe79 = (fieldValue)=>fieldValue && 'number' in fieldValue ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$a9556b001634798e = (fieldValue)=>fieldValue && 'options' in fieldValue ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$999467445028f8e1 = (fieldValue)=>fieldValue && 'text' in fieldValue ? fieldValue : undefined;
const $d09a6f90c130d3a8$export$33c7a540ebc0a650 = (val)=>$d09a6f90c130d3a8$export$a9556b001634798e(val) !== undefined;
const $d09a6f90c130d3a8$export$3ff5e9927c3257c6 = (val)=>$d09a6f90c130d3a8$export$e0103605c09cfe79(val) !== undefined;
const $d09a6f90c130d3a8$export$14759b5514e9ff67 = (val)=>$d09a6f90c130d3a8$export$487536c088c8456b(val) !== undefined;
const $d09a6f90c130d3a8$export$70ffef27d62e47d = (val)=>$d09a6f90c130d3a8$export$7bb606c8737f4fa1(val) !== undefined;
const $d09a6f90c130d3a8$export$a7da7ea29e6e3676 = (val)=>$d09a6f90c130d3a8$export$a41fe93036a4f796(val) !== undefined;
const $d09a6f90c130d3a8$export$e3a34768eb54be7c = (val)=>$d09a6f90c130d3a8$export$999467445028f8e1(val) !== undefined;
const $d09a6f90c130d3a8$export$d12d5b995d58aed0 = (val)=>$d09a6f90c130d3a8$export$66be9ea255ebd33e(val) !== undefined;

});

parcelRegister("kVXLM", function(module, exports) {
$parcel$export(module.exports, "asFormAdfField", () => $6726351edf43f5e1$export$ab4869be4118d46b);
$parcel$export(module.exports, "asFormDateField", () => $6726351edf43f5e1$export$babd13fc60584683);
$parcel$export(module.exports, "asFormDateTimeField", () => $6726351edf43f5e1$export$3698bad7425aff64);
$parcel$export(module.exports, "asFormLocalTimeField", () => $6726351edf43f5e1$export$e532d960b9a84e34);
$parcel$export(module.exports, "asFormNumberField", () => $6726351edf43f5e1$export$d8fe12382557a2b8);
$parcel$export(module.exports, "asFormOptionField", () => $6726351edf43f5e1$export$2f3197b4ecf79d91);
$parcel$export(module.exports, "asFormRankingField", () => $6726351edf43f5e1$export$c87d245b4dd607b3);
$parcel$export(module.exports, "asFormTextField", () => $6726351edf43f5e1$export$45d1a2a753a7039b);
$parcel$export(module.exports, "toOptions", () => $6726351edf43f5e1$export$fc271ba434f65243);
$parcel$export(module.exports, "toRadioOptions", () => $6726351edf43f5e1$export$e15cd04030e5aaed);

var $2nfpZ = parcelRequire("2nfpZ");
const $6726351edf43f5e1$export$ab4869be4118d46b = (formField)=>formField && formField.type === (0, $2nfpZ.FormFieldType).RICH_TEXT_PARAGRAPH ? formField : undefined;
const $6726351edf43f5e1$export$ec8462dc36ef7d6 = (formField)=>formField && formField.type === (0, $2nfpZ.FormFieldType).ATTACHMENT ? formField : undefined;
const $6726351edf43f5e1$export$babd13fc60584683 = (formField)=>(formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).DATE ? formField : undefined;
const $6726351edf43f5e1$export$3698bad7425aff64 = (formField)=>(formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).DATE_TIME ? formField : undefined;
const $6726351edf43f5e1$export$e532d960b9a84e34 = (formField)=>(formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).LOCAL_TIME ? formField : undefined;
const $6726351edf43f5e1$export$d8fe12382557a2b8 = (formField)=>formField && formField.type === (0, $2nfpZ.FormFieldType).NUMBER ? formField : undefined;
const $6726351edf43f5e1$export$2f3197b4ecf79d91 = (formField)=>formField && (0, $2nfpZ.FORM_OPTION_FIELD_TYPES).includes(formField.type) ? formField : undefined;
const $6726351edf43f5e1$export$c87d245b4dd607b3 = (formField)=>formField && (0, $2nfpZ.FORM_RANKING_FIELD_TYPES).includes(formField.type) ? formField : undefined;
const $6726351edf43f5e1$export$45d1a2a753a7039b = (formField)=>formField && (0, $2nfpZ.FORM_TEXT_FIELD_TYPES).includes(formField.type) ? formField : undefined;
const $6726351edf43f5e1$export$fc271ba434f65243 = (options)=>(options === null || options === void 0 ? void 0 : options.map((option)=>({
            label: option.label,
            value: option.id,
            avatar: option === null || option === void 0 ? void 0 : option.avatar,
            byline: option === null || option === void 0 ? void 0 : option.byline
        }))) ?? [];
const $6726351edf43f5e1$export$e15cd04030e5aaed = (options)=>(options === null || options === void 0 ? void 0 : options.map((option)=>({
            label: option.label,
            value: option.id
        }))) ?? [];

});

parcelRegister("lFDjE", function(module, exports) {
$parcel$export(module.exports, "getRichTextValidationErrors", () => $d1521dd770d41a52$export$8d25830fe28ca0d4);

var $c6WhP = parcelRequire("c6WhP");

var $bGEoB = parcelRequire("bGEoB");

var $jg5hp = parcelRequire("jg5hp");
const $d1521dd770d41a52$var$wikiTransformer = new (0, $bGEoB.WikiMarkupTransformer)();
const $d1521dd770d41a52$var$jsonTransformer = new (0, $c6WhP.JSONTransformer)();
const $d1521dd770d41a52$export$8d25830fe28ca0d4 = (validation, fieldLabel, intl, adf)=>{
    if (adf) {
        const pmNode = $d1521dd770d41a52$var$jsonTransformer.parse(adf.adf);
        return (0, $jg5hp.getTextValidationErrors)(validation, fieldLabel, intl, {
            text: $d1521dd770d41a52$var$wikiTransformer.encode(pmNode)
        });
    }
    return (0, $jg5hp.getTextValidationErrors)(validation, fieldLabel, intl, undefined);
};

});
parcelRegister("bGEoB", function(module, exports) {
$parcel$export(module.exports, "WikiMarkupTransformer", () => $c921a578a659ad7a$export$caaa00407b56b900);

var $auxFA = parcelRequire("auxFA");

var $hud8R = parcelRequire("hud8R");

var $cAWrX = parcelRequire("cAWrX");

var $6gTMF = parcelRequire("6gTMF");
class $c921a578a659ad7a$export$caaa00407b56b900 {
    constructor(schema = (0, $auxFA.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $hud8R.encode)(node, $c921a578a659ad7a$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $cAWrX.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($c921a578a659ad7a$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $6gTMF.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $c921a578a659ad7a$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $c921a578a659ad7a$export$2e2bcd8739ae039 = $c921a578a659ad7a$export$caaa00407b56b900;

});
parcelRegister("hud8R", function(module, exports) {
$parcel$export(module.exports, "encode", () => $04ecd998c5822496$export$c564cdbbe6da493);

var $d62Ux = parcelRequire("d62Ux");

var $42v31 = parcelRequire("42v31");

var $1EX0U = parcelRequire("1EX0U");

var $dwcNc = parcelRequire("dwcNc");

var $9tZQo = parcelRequire("9tZQo");

var $2gzsW = parcelRequire("2gzsW");

var $9RMDG = parcelRequire("9RMDG");

var $5STAp = parcelRequire("5STAp");

var $3qRms = parcelRequire("3qRms");

var $gW4iP = parcelRequire("gW4iP");

var $f8uxT = parcelRequire("f8uxT");

var $9CMfw = parcelRequire("9CMfw");

var $fPI4K = parcelRequire("fPI4K");

var $709SY = parcelRequire("709SY");

var $8DeKg = parcelRequire("8DeKg");

var $6rfTP = parcelRequire("6rfTP");

var $ijipD = parcelRequire("ijipD");

var $3PR9u = parcelRequire("3PR9u");

var $g7IiT = parcelRequire("g7IiT");

var $gAgju = parcelRequire("gAgju");
const $04ecd998c5822496$var$nodeEncoderMapping = {
    blockquote: $42v31.blockquote,
    bulletList: $dwcNc.bulletList,
    taskList: $g7IiT.taskList,
    decisionList: $9RMDG.decisionList,
    codeBlock: $2gzsW.codeBlock,
    doc: $5STAp.doc,
    heading: $f8uxT.heading,
    caption: $9tZQo.caption,
    mediaGroup: $9CMfw.mediaGroup,
    mediaInline: $fPI4K.mediaInline,
    mediaSingle: (0, $9CMfw.mediaGroup),
    orderedList: $709SY.orderedList,
    panel: $8DeKg.panel,
    paragraph: $6rfTP.paragraph,
    rule: $ijipD.rule,
    table: $3PR9u.table,
    blockCard: $d62Ux.blockCard,
    embedCard: $3qRms.embedCard,
    expand: $gW4iP.expand,
    bodiedSyncBlock: $1EX0U.bodiedSyncBlock
};
function $04ecd998c5822496$export$c564cdbbe6da493(node, context) {
    const encoder = $04ecd998c5822496$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $gAgju.unknown)(node);
    } catch (err) {
        return (0, $gAgju.unknown)(node);
    }
}

});
parcelRegister("d62Ux", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $4f564fdcf6d35708$export$c4c2f833baaebdb8);

var $gAgju = parcelRequire("gAgju");
const $4f564fdcf6d35708$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $gAgju.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});
parcelRegister("gAgju", function(module, exports) {
$parcel$export(module.exports, "unknown", () => $465fb35504ee34f3$export$19282c40b967aec6);

var $c6WhP = parcelRequire("c6WhP");
const $465fb35504ee34f3$var$jsonTransformer = new (0, $c6WhP.JSONTransformer)();
const $465fb35504ee34f3$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($465fb35504ee34f3$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("42v31", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $487a714d50f9f2f9$export$67dc04e652a298ca);

var $hud8R = parcelRequire("hud8R");
const $487a714d50f9f2f9$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("1EX0U", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $64f707a8273ee190$export$e92c7e4302dd4371);

var $hud8R = parcelRequire("hud8R");
const $64f707a8273ee190$export$e92c7e4302dd4371 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("dwcNc", function(module, exports) {
$parcel$export(module.exports, "bulletList", () => $93ab141dc2a90eb3$export$a140c94e5ea26bee);

var $hkAMl = parcelRequire("hkAMl");
const $93ab141dc2a90eb3$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $hkAMl.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("hkAMl", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $f673efcb59191af3$export$76c7e83ecc9cdf05);

var $hud8R = parcelRequire("hud8R");

var $2gzsW = parcelRequire("2gzsW");

var $9CMfw = parcelRequire("9CMfw");

var $fPI4K = parcelRequire("fPI4K");

var $6rfTP = parcelRequire("6rfTP");

var $gAgju = parcelRequire("gAgju");
const $f673efcb59191af3$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $6rfTP.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
            case 'taskList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const nestedList = (0, $hud8R.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $2gzsW.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $fPI4K.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $9CMfw.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $gAgju.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("2gzsW", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $297195e09d5ec300$export$7bb0d5c671655cc4);

var $ipg1R = parcelRequire("ipg1R");
const $297195e09d5ec300$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $297195e09d5ec300$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $ipg1R.inlines)(n, {
            parent: node
        });
    });
    if ($297195e09d5ec300$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});
parcelRegister("ipg1R", function(module, exports) {
$parcel$export(module.exports, "inlines", () => $318f2779b9a5ebd0$export$96c94bfc00b85760);

var $kDqhh = parcelRequire("kDqhh");

var $gmOGP = parcelRequire("gmOGP");

var $B4xhH = parcelRequire("B4xhH");

var $kjJvq = parcelRequire("kjJvq");

var $fPI4K = parcelRequire("fPI4K");

var $1cXWt = parcelRequire("1cXWt");

var $2hd6U = parcelRequire("2hd6U");

var $3umWF = parcelRequire("3umWF");

var $gAgju = parcelRequire("gAgju");
const $318f2779b9a5ebd0$var$inlinesEncoderMapping = {
    emoji: $gmOGP.emoji,
    hardBreak: $B4xhH.hardBreak,
    mediaInline: $fPI4K.mediaInline,
    mention: $1cXWt.mention,
    text: $3umWF.text,
    inlineCard: $kjJvq.inlineCard,
    status: $2hd6U.status,
    date: $kDqhh.date
};
const $318f2779b9a5ebd0$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $318f2779b9a5ebd0$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $gAgju.unknown)(node);
};

});
parcelRegister("kDqhh", function(module, exports) {
$parcel$export(module.exports, "date", () => $d676b5ea2964205c$export$324d90190a8b822a);
const $d676b5ea2964205c$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});

parcelRegister("gmOGP", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $3dabaee272b2ca08$export$a19185d1233fc4b2);

var $blnBA = parcelRequire("blnBA");

var $gAgju = parcelRequire("gAgju");
const $3dabaee272b2ca08$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $blnBA.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $gAgju.unknown)(node);
};

});
parcelRegister("blnBA", function(module, exports) {
$parcel$export(module.exports, "mapping", () => $649c0bcb011fc8c3$export$83e1f26587c4acd2);
const $649c0bcb011fc8c3$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});


parcelRegister("B4xhH", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $0f353bc1cc571892$export$371da9dd35aba193);
const $0f353bc1cc571892$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("kjJvq", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $963e60b708a8d1eb$export$cbf8224b64e0d942);

var $6gTMF = parcelRequire("6gTMF");

var $gAgju = parcelRequire("gAgju");
const $963e60b708a8d1eb$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $gAgju.unknown)(node);
    const match = node.attrs.url.match((0, $6gTMF.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});
parcelRegister("6gTMF", function(module, exports) {
$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $b961d530a74475aa$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $b961d530a74475aa$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $b961d530a74475aa$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $b961d530a74475aa$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $b961d530a74475aa$export$cd8701ad7512efee);

var $h54xF = parcelRequire("h54xF");
const $b961d530a74475aa$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $b961d530a74475aa$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $b961d530a74475aa$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $b961d530a74475aa$var$fallback(input, position);
    const issue = $b961d530a74475aa$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $b961d530a74475aa$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $h54xF.isNotBlank)(charBefore) && $b961d530a74475aa$var$isNotAllowedChars(charBefore) || (0, $h54xF.isNotBlank)(charAfter) && $b961d530a74475aa$var$isNotAllowedChars(charAfter)) return $b961d530a74475aa$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $b961d530a74475aa$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $b961d530a74475aa$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $b961d530a74475aa$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $b961d530a74475aa$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $b961d530a74475aa$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $b961d530a74475aa$var$withInlineCardFromTextStamp = (issue)=>$b961d530a74475aa$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b961d530a74475aa$var$ALLOWED_CHARS_REGEX = /\s|\(|\)|!|\.|\,|\/|\:/;
const $b961d530a74475aa$var$isNotAllowedChars = (char)=>!$b961d530a74475aa$var$ALLOWED_CHARS_REGEX.test(char);
const $b961d530a74475aa$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});
parcelRegister("h54xF", function(module, exports) {
$parcel$export(module.exports, "hasAnyOfMarks", () => $958c29529404890b$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $958c29529404890b$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $958c29529404890b$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $958c29529404890b$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $958c29529404890b$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $958c29529404890b$export$83347051c3437dc9);
function $958c29529404890b$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $958c29529404890b$var$DIGIT_REGEX = /^\d$/;
function $958c29529404890b$export$727d9dbc4fbb948f(value) {
    return !!value.match($958c29529404890b$var$DIGIT_REGEX);
}
function $958c29529404890b$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $958c29529404890b$export$4d9e7a1c098df5e2(value) {
    return !$958c29529404890b$export$7ee701e290d9865(value);
}
const $958c29529404890b$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $958c29529404890b$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});



parcelRegister("fPI4K", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $69d0e698a8d57b77$export$38bab695e3f720f1);
const $69d0e698a8d57b77$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    var _context$conversion;
    const fileName = (context === null || context === void 0 || (_context$conversion = context.conversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion.mediaConversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion[node.attrs.id]) === null || _context$conversion === void 0 ? void 0 : _context$conversion.transform) ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("1cXWt", function(module, exports) {
$parcel$export(module.exports, "mention", () => $5b20767f11778da1$export$db83999c14438df4);
const $5b20767f11778da1$var$PREFIX = 'accountid:';
const $5b20767f11778da1$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $5b20767f11778da1$var$addPrefix = (content)=>content.toLowerCase().startsWith($5b20767f11778da1$var$PREFIX) ? content : `${$5b20767f11778da1$var$PREFIX}${content}`;
const $5b20767f11778da1$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $5b20767f11778da1$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $5b20767f11778da1$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("2hd6U", function(module, exports) {
$parcel$export(module.exports, "status", () => $ee380e02eac238f4$export$471f7ae5c4103ae1);

var $564jB = parcelRequire("564jB");
const $ee380e02eac238f4$var$color = {
    grey: '#97A0AF',
    purple: '#6554C0',
    blue: '#00B8D9',
    red: '#FF5630',
    yellow: '#FF991F',
    green: '#36B37E',
    // Teal — color.text.accent.teal.bolder
    '#B3F5FF': '#164555',
    // Green — reuses the legacy `green` value rather than emitting a second, near-identical green
    '#ABF5D1': '#36B37E',
    // Lime — a hue with no legacy name, so it takes its own color.text.accent.lime.bolder
    '#D3F1A7': '#37471F',
    // Yellow — takes its own color.text.accent.yellow.bolder. It cannot reuse the legacy `yellow`
    // value the way #ABF5D1 reuses `green`, because that value is `Y400` #FF991F, which is
    // orange-hued (33°) despite the name.
    '#FFF0B3': '#533F04',
    // Orange — reuses the legacy `yellow` value, which is the orange-hued one, rather than emitting
    // a second, near-identical orange
    '#FCE4A6': '#FF991F',
    // Magenta — color.text.accent.magenta.bolder
    '#FDD0EC': '#50253F'
};
const $ee380e02eac238f4$var$normalizeColor = (value)=>value.startsWith('#') ? value.toUpperCase() : value;
const $ee380e02eac238f4$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    const key = $ee380e02eac238f4$var$normalizeColor(node.attrs.color ?? '');
    newAttrs.color = $ee380e02eac238f4$var$color[key] ?? $ee380e02eac238f4$var$color['grey'];
    return (0, $564jB.textColor)(text, newAttrs);
};

});
parcelRegister("564jB", function(module, exports) {
$parcel$export(module.exports, "textColor", () => $08fbf08003e6921d$export$32f78bffcd82ff28);
const $08fbf08003e6921d$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});


parcelRegister("3umWF", function(module, exports) {
$parcel$export(module.exports, "text", () => $2c6984f00b01d124$export$6f093cfa640b7166);

var $gTSEm = parcelRequire("gTSEm");

var $1CF37 = parcelRequire("1CF37");

var $564jB = parcelRequire("564jB");

var $feCfe = parcelRequire("feCfe");

var $h13Ja = parcelRequire("h13Ja");

var $i4IZL = parcelRequire("i4IZL");

var $eE2s4 = parcelRequire("eE2s4");

var $fBVah = parcelRequire("fBVah");

var $52gEw = parcelRequire("52gEw");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $2c6984f00b01d124$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $feCfe.em)
    ],
    [
        'strike',
        (0, $i4IZL.strike)
    ],
    [
        'strong',
        (0, $eE2s4.strong)
    ],
    [
        'subsup',
        (0, $fBVah.subsup)
    ],
    [
        'underline',
        (0, $52gEw.underline)
    ],
    [
        'textColor',
        (0, $564jB.textColor)
    ],
    [
        'link',
        (0, $h13Ja.link)
    ],
    [
        'code',
        (0, $1CF37.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $2c6984f00b01d124$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $2c6984f00b01d124$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $2c6984f00b01d124$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $2c6984f00b01d124$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $2c6984f00b01d124$var$escapingWikiFormatter(text) {
    const pattern = [
        $2c6984f00b01d124$var$MENTION_ESCAPE_PATTERN,
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        ...(0, $gTSEm.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($2c6984f00b01d124$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($2c6984f00b01d124$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $2c6984f00b01d124$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $2c6984f00b01d124$var$isEscapeNeeded(node, parent) ? $2c6984f00b01d124$var$escapingWikiFormatter(node.text) : node.text;
    $2c6984f00b01d124$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("gTSEm", function(module, exports) {
$parcel$export(module.exports, "macroKeywordTokenMap", () => $c25741331bbbdac9$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $c25741331bbbdac9$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $c25741331bbbdac9$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $c25741331bbbdac9$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $c25741331bbbdac9$export$bcec6d03770b152c);

var $gMTfd = parcelRequire("gMTfd");

var $6KDra = parcelRequire("6KDra");
const $c25741331bbbdac9$export$afcd7edeca61ca93 = [
    {
        type: (0, $gMTfd.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $gMTfd.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $gMTfd.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $gMTfd.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $gMTfd.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $gMTfd.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $gMTfd.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $gMTfd.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $c25741331bbbdac9$var$keywordTokenMap = {
    '[': (0, $gMTfd.TokenType).LINK_FORMAT,
    http: (0, $gMTfd.TokenType).LINK_TEXT,
    ftp: (0, $gMTfd.TokenType).LINK_TEXT,
    jamfselfservice: (0, $gMTfd.TokenType).LINK_TEXT,
    irc: (0, $gMTfd.TokenType).LINK_TEXT,
    mailto: (0, $gMTfd.TokenType).LINK_TEXT,
    '\\\\': (0, $gMTfd.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $gMTfd.TokenType).HARD_BREAK,
    '\n': (0, $gMTfd.TokenType).HARD_BREAK,
    '\r\n': (0, $gMTfd.TokenType).HARD_BREAK,
    '!': (0, $gMTfd.TokenType).MEDIA,
    '----': (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $gMTfd.TokenType).DELETED,
    '{+}': (0, $gMTfd.TokenType).INSERTED,
    '{*}': (0, $gMTfd.TokenType).STRONG,
    '{^}': (0, $gMTfd.TokenType).SUPERSCRIPT,
    '{~}': (0, $gMTfd.TokenType).SUBSCRIPT,
    '{_}': (0, $gMTfd.TokenType).EMPHASIS,
    '{{{}': (0, $gMTfd.TokenType).MONOSPACE,
    '{??}': (0, $gMTfd.TokenType).CITATION,
    '-': (0, $gMTfd.TokenType).DELETED,
    '+': (0, $gMTfd.TokenType).INSERTED,
    '*': (0, $gMTfd.TokenType).STRONG,
    '^': (0, $gMTfd.TokenType).SUPERSCRIPT,
    '~': (0, $gMTfd.TokenType).SUBSCRIPT,
    _: (0, $gMTfd.TokenType).EMPHASIS,
    '{{': (0, $gMTfd.TokenType).MONOSPACE,
    '??': (0, $gMTfd.TokenType).CITATION
};
const $c25741331bbbdac9$var$keywordTokenMapKeys = Object.keys($c25741331bbbdac9$var$keywordTokenMap);
function $c25741331bbbdac9$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $c25741331bbbdac9$export$afcd7edeca61ca93.length; i++){
        const keyword = $c25741331bbbdac9$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $c25741331bbbdac9$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $c25741331bbbdac9$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($c25741331bbbdac9$var$keywordTokenMapKeys[i])) return {
            type: $c25741331bbbdac9$var$keywordTokenMap[$c25741331bbbdac9$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $gMTfd.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $c25741331bbbdac9$var$leadingKeywordTokenMap = [
    {
        type: (0, $gMTfd.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $gMTfd.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $gMTfd.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $gMTfd.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $6KDra.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $gMTfd.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $c25741331bbbdac9$export$68162fc57528b560(input) {
    for(let i = 0; i < $c25741331bbbdac9$var$leadingKeywordTokenMap.length; i++){
        const keyword = $c25741331bbbdac9$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $c25741331bbbdac9$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $gMTfd.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("gMTfd", function(module, exports) {
$parcel$export(module.exports, "TokenType", () => $b241157dd6cb261e$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $b241157dd6cb261e$export$af8f4e8328578827);

var $bdG2O = parcelRequire("bdG2O");

var $lTzuF = parcelRequire("lTzuF");

var $7IJWD = parcelRequire("7IJWD");

var $5QiNj = parcelRequire("5QiNj");

var $bLA40 = parcelRequire("bLA40");

var $5H9Ha = parcelRequire("5H9Ha");

var $3zHhi = parcelRequire("3zHhi");

var $ntdHx = parcelRequire("ntdHx");

var $3yyka = parcelRequire("3yyka");

var $bSwvv = parcelRequire("bSwvv");

var $b5ACy = parcelRequire("b5ACy");

var $9NWN1 = parcelRequire("9NWN1");

var $274RH = parcelRequire("274RH");

var $2eWeA = parcelRequire("2eWeA");

var $6gTMF = parcelRequire("6gTMF");

var $ht2K2 = parcelRequire("ht2K2");

var $8BR3C = parcelRequire("8BR3C");

var $6KDra = parcelRequire("6KDra");

var $lKn2G = parcelRequire("lKn2G");

var $hqiZ5 = parcelRequire("hqiZ5");

var $a1hLt = parcelRequire("a1hLt");

var $3kz4Q = parcelRequire("3kz4Q");

var $6DPzT = parcelRequire("6DPzT");

var $73Foi = parcelRequire("73Foi");

var $jO87J = parcelRequire("jO87J");

var $bPeRF = parcelRequire("bPeRF");

var $f24cd = parcelRequire("f24cd");

var $gX9Ct = parcelRequire("gX9Ct");

var $dloK2 = parcelRequire("dloK2");

var $1A388 = parcelRequire("1A388");
var $b241157dd6cb261e$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    // {adf}
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    // {anchor}
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    // {code}
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    // {quote}
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    // {noformat}
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    // {panel}
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    // {color}
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    // {loremipsum}
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    // \\, \r, \n, \r\n
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    // --
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    // ---
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    // ----
    TokenType["STRONG"] = "STRONG";
    // *strong*
    TokenType["MONOSPACE"] = "MONOSPACE";
    // {{text}}
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    // ^superscript^
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    // ^subscript^
    TokenType["EMPHASIS"] = "EMPHASIS";
    // _emphasis_
    TokenType["CITATION"] = "CITATION";
    // ??citation??
    TokenType["DELETED"] = "DELETED";
    // -deleted-
    TokenType["INSERTED"] = "INSERTED";
    // +deleted+
    TokenType["EMOJI"] = "EMOJI";
    // :)
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $b241157dd6cb261e$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $ntdHx.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $1A388.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $6DPzT.quadrupleDashSymbol),
    ["RULER"]: (0, $jO87J.ruler),
    ["STRONG"]: (0, $bPeRF.strong),
    ["MONOSPACE"]: (0, $hqiZ5.monospace),
    ["SUPERSCRIPT"]: (0, $gX9Ct.superscript),
    ["SUBSCRIPT"]: (0, $f24cd.subscript),
    ["EMPHASIS"]: (0, $bSwvv.emphasis),
    ["CITATION"]: (0, $5QiNj.citation),
    ["DELETED"]: (0, $3zHhi.deleted),
    ["INSERTED"]: (0, $2eWeA.inserted),
    ["HARD_BREAK"]: (0, $9NWN1.hardbreak),
    ["LINK_FORMAT"]: (0, $8BR3C.linkFormat),
    ["LINK_TEXT"]: (0, $ht2K2.linkText),
    ["HEADING"]: (0, $274RH.heading),
    ["MEDIA"]: (0, $lKn2G.media),
    ["LIST"]: (0, $6KDra.list),
    ["QUOTE"]: (0, $7IJWD.blockquote),
    ["TABLE"]: (0, $dloK2.table),
    ["EMOJI"]: (0, $3yyka.emoji),
    ["ADF_MACRO"]: (0, $bdG2O.adfMacro),
    ["ANCHOR_MACRO"]: (0, $lTzuF.anchorMacro),
    ["CODE_MACRO"]: (0, $bLA40.codeMacro),
    ["QUOTE_MACRO"]: (0, $73Foi.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $a1hLt.noformatMacro),
    ["PANEL_MACRO"]: (0, $3kz4Q.panelMacro),
    ["COLOR_MACRO"]: (0, $5H9Ha.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $b5ACy.forceLineBreak),
    ["ISSUE_KEY"]: (0, $6gTMF.issueKey)
};
function $b241157dd6cb261e$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $b241157dd6cb261e$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $b241157dd6cb261e$var$fallback(input, position);
    }
    return $b241157dd6cb261e$var$fallback(input, position);
}
function $b241157dd6cb261e$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("bdG2O", function(module, exports) {
$parcel$export(module.exports, "adfMacro", () => $aeb23d11d3d9b582$export$8fb4b58db8f664fb);

var $5jHGS = parcelRequire("5jHGS");
const $aeb23d11d3d9b582$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $aeb23d11d3d9b582$var$rawContentProcessor
    });
};
const $aeb23d11d3d9b582$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});
parcelRegister("5jHGS", function(module, exports) {
$parcel$export(module.exports, "commonMacro", () => $f73a65b4a0decf82$export$b6a12943ac1bb1ba);
function $f73a65b4a0decf82$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
   * Forging the opening regex, the result would look something like
   * /^\{(quote)(?::([^\{\n\}]*))?\}/i
   */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $f73a65b4a0decf82$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
     * Some macros do not have a closing symbol, for example
     * {anchor:here} {loremipsum}
     */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
   * Forging the closing regex, the result would look something like
   * /\{quote\}/
   */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $f73a65b4a0decf82$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});


parcelRegister("lTzuF", function(module, exports) {
$parcel$export(module.exports, "anchorMacro", () => $3d457e443949a930$export$e660dadc21580fa2);

var $5jHGS = parcelRequire("5jHGS");
const $3d457e443949a930$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $3d457e443949a930$var$rawContentProcessor
    });
};
const $3d457e443949a930$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("7IJWD", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $ba6fce56ba07c62a$export$67dc04e652a298ca);

var $73Foi = parcelRequire("73Foi");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ba6fce56ba07c62a$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $ba6fce56ba07c62a$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($ba6fce56ba07c62a$var$BLOCKQUOTE_REGEXP);
    if (!match) return $ba6fce56ba07c62a$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $73Foi.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $ba6fce56ba07c62a$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("73Foi", function(module, exports) {
$parcel$export(module.exports, "quoteMacro", () => $1e51f0563fb25ba3$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $1e51f0563fb25ba3$export$c2a5e4612254bfa);

var $cvz28 = parcelRequire("cvz28");

var $jO5UR = parcelRequire("jO5UR");

var $h54xF = parcelRequire("h54xF");

var $5jHGS = parcelRequire("5jHGS");
const $1e51f0563fb25ba3$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $1e51f0563fb25ba3$export$c2a5e4612254bfa,
        context: context
    });
};
const $1e51f0563fb25ba3$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $1e51f0563fb25ba3$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $cvz28.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $jO5UR.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $1e51f0563fb25ba3$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $1e51f0563fb25ba3$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $1e51f0563fb25ba3$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
           * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
           */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
           * If a heading is inside a list item
           * - h1. Bold, Uppercase
           * - h2. Bold, Italic
           * - h3. Bold
           * - h4. Bold, Gray
           * - h5. Gray, Italic
           * - h6. Gray
           */ contentBuffer.push($1e51f0563fb25ba3$var$transformHeading(n, schema));
            break;
        default:
            /**
         * Anything else should be lifted
         */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $1e51f0563fb25ba3$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $h54xF.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $h54xF.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $h54xF.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("cvz28", function(module, exports) {
$parcel$export(module.exports, "parseString", () => $d4ee48905b9558e5$export$960addfb9e5a0cde);

var $3uxhZ = parcelRequire("3uxhZ");

var $gMTfd = parcelRequire("gMTfd");

var $gTSEm = parcelRequire("gTSEm");

var $eFvMd = parcelRequire("eFvMd");

var $ex8vr = parcelRequire("ex8vr");

var $jO5UR = parcelRequire("jO5UR");
const $d4ee48905b9558e5$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $d4ee48905b9558e5$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $d4ee48905b9558e5$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $gMTfd.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $d4ee48905b9558e5$var$processState.NEWLINE:
                {
                    /**
           * During this state, the parser will trim leading
           * spaces and looking for any leading keywords.
           */ const substring = input.substring(index);
                    const length = (0, $eFvMd.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $gTSEm.parseLeadingKeyword)(substring) || (0, $gTSEm.parseMacroKeyword)(substring) || (0, $gTSEm.parseOtherKeyword)(substring) || (0, $gTSEm.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $d4ee48905b9558e5$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $d4ee48905b9558e5$var$processState.BUFFER;
                        continue;
                    }
                }
            case $d4ee48905b9558e5$var$processState.BUFFER:
                {
                    /**
           * During this state, the parser will start
           * saving plaintext into the buffer until it hits
           * a keyword
           */ const substring = input.substring(index);
                    /**
           * If the previous char is not a alphanumeric, we will parse
           * format keywords.
           * If the previous char is '{', we need to skip parse macro
           * keyword
           */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $gTSEm.parseOtherKeyword)(substring);
                    else match = (0, $gTSEm.parseMacroKeyword)(substring) || (0, $gTSEm.parseOtherKeyword)(substring) || (0, $gTSEm.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $d4ee48905b9558e5$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $d4ee48905b9558e5$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $d4ee48905b9558e5$var$processState.TOKEN:
                {
                    const token = (0, $gMTfd.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
                   Whenever more than two consecutive newLines are encountered, we start a new paragraph
                 */ if (newLines.length >= 2 && (tokenType !== (0, $gMTfd.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $jO5UR.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $d4ee48905b9558e5$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $d4ee48905b9558e5$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $3uxhZ.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $gMTfd.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $gMTfd.TokenType).HARD_BREAK) state = $d4ee48905b9558e5$var$processState.NEWLINE;
                    else state = $d4ee48905b9558e5$var$processState.BUFFER;
                    continue;
                }
            case $d4ee48905b9558e5$var$processState.ESCAPE:
                {
                    const token = (0, $ex8vr.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $d4ee48905b9558e5$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $jO5UR.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $3uxhZ.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $d4ee48905b9558e5$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    var _currentNodes;
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && (_currentNodes = currentNodes[currentNodes.length - 1]) !== null && _currentNodes !== void 0 && _currentNodes.isBlock) return false;
    if (buffer.length === 0) {
        var _nextNodes$, _nextNodes$2, _currentNodes2;
        if (nextNodes.length === 0) return false;
        if (((_nextNodes$ = nextNodes[0]) === null || _nextNodes$ === void 0 ? void 0 : _nextNodes$.type.name) === 'hardBreak') return false;
        if ((_nextNodes$2 = nextNodes[0]) !== null && _nextNodes$2 !== void 0 && _nextNodes$2.isBlock || (_currentNodes2 = currentNodes[currentNodes.length - 1]) !== null && _currentNodes2 !== void 0 && _currentNodes2.isBlock) return false;
    }
    return true;
}
function $d4ee48905b9558e5$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    var _currentNodes3, _nextNodes$3;
    return currentNodes.length > 0 && ((_currentNodes3 = currentNodes[currentNodes.length - 1]) === null || _currentNodes3 === void 0 ? void 0 : _currentNodes3.type.name) === 'mediaGroup' && ((_nextNodes$3 = nextNodes[0]) === null || _nextNodes$3 === void 0 ? void 0 : _nextNodes$3.type.name) === 'mediaGroup';
}

});
parcelRegister("3uxhZ", function(module, exports) {
$parcel$export(module.exports, "createTextNode", () => $03198716bc0a4a77$export$b2ce9ad90858ed7a);
function $03198716bc0a4a77$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("eFvMd", function(module, exports) {
$parcel$export(module.exports, "parseNewlineOnly", () => $610cfa9b2350d48e$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $610cfa9b2350d48e$export$9c597b035e16623b);
function $610cfa9b2350d48e$export$877995a80ec11782(input) {
    const newlineLength = $610cfa9b2350d48e$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $610cfa9b2350d48e$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $610cfa9b2350d48e$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $610cfa9b2350d48e$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("ex8vr", function(module, exports) {
$parcel$export(module.exports, "escapeHandler", () => $03596af2cddd3348$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $03596af2cddd3348$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $03596af2cddd3348$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
   * Ported from Jira:
   * If previous char is also a backslash, then this is not a valid escape
   */ if ($03596af2cddd3348$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("jO5UR", function(module, exports) {
$parcel$export(module.exports, "normalizePMNodes", () => $cd37294d47f0c1b0$export$e21f6b7efdaf8b5d);

var $2CPAc = parcelRequire("2CPAc");
function $cd37294d47f0c1b0$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $cd37294d47f0c1b0$var$normalizeMediaGroups,
        $cd37294d47f0c1b0$export$2cef2a4c047f9887,
        $cd37294d47f0c1b0$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $cd37294d47f0c1b0$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes){
        var _node$type;
        if ((node === null || node === void 0 || (_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'nestedExpand' && parentNode === 'doc') output.push($cd37294d47f0c1b0$var$convertNodeToExpand(node, schema));
        else output.push(node);
    }
    return output;
}
function $cd37294d47f0c1b0$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $2CPAc.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $2CPAc.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $2CPAc.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $cd37294d47f0c1b0$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($cd37294d47f0c1b0$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($cd37294d47f0c1b0$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($cd37294d47f0c1b0$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $cd37294d47f0c1b0$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $cd37294d47f0c1b0$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $cd37294d47f0c1b0$var$isHardBreak(n, separatorBuffer) || !$cd37294d47f0c1b0$var$isEmptyTextNode(n) || $cd37294d47f0c1b0$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $cd37294d47f0c1b0$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $cd37294d47f0c1b0$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $cd37294d47f0c1b0$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $cd37294d47f0c1b0$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $cd37294d47f0c1b0$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("2CPAc", function(module, exports) {
$parcel$export(module.exports, "createEmptyParagraphNode", () => $579a4c890bce2256$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $579a4c890bce2256$export$f0eaed48ea684567);
function $579a4c890bce2256$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $579a4c890bce2256$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});





parcelRegister("5QiNj", function(module, exports) {
$parcel$export(module.exports, "citation", () => $280e4f22b9ff4911$export$258632c953c109e9);

var $8Wy8t = parcelRequire("8Wy8t");

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $280e4f22b9ff4911$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $8Wy8t.EM_DASH} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("8Wy8t", function(module, exports) {
$parcel$export(module.exports, "EM_DASH", () => $f84e8c5e0fcbc364$export$3bca9fae3002bd9b);
const $f84e8c5e0fcbc364$export$3bca9fae3002bd9b = "\u2014";

});

parcelRegister("gsDpQ", function(module, exports) {
$parcel$export(module.exports, "commonFormatter", () => $54e92e31a1db47a7$export$a71d57024d3da1c5);

var $ex8vr = parcelRequire("ex8vr");

var $gMTfd = parcelRequire("gMTfd");

var $gTSEm = parcelRequire("gTSEm");

var $8BR3C = parcelRequire("8BR3C");

var $eFvMd = parcelRequire("eFvMd");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $54e92e31a1db47a7$var$ALPHANUMERIC_OR_NON_ASCII_REGEX = /[a-zA-Z0-9]|[^\u0000-\u007F]/;
const $54e92e31a1db47a7$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $54e92e31a1db47a7$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $54e92e31a1db47a7$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $54e92e31a1db47a7$var$processState.START:
                {
                    if (position > 0) {
                        /**
             * If the previous char is a alphanumeric, then it's not a valid
             * formatter
             */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && $54e92e31a1db47a7$var$ALPHANUMERIC_OR_NON_ASCII_REGEX.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $54e92e31a1db47a7$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                    state = $54e92e31a1db47a7$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $54e92e31a1db47a7$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $eFvMd.parseNewlineOnly)(input.substring(index));
                    if (length) return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $54e92e31a1db47a7$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $54e92e31a1db47a7$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $54e92e31a1db47a7$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $54e92e31a1db47a7$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $54e92e31a1db47a7$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                /**
           * If the closing symbol is followed by a alphanumeric, it's
           * not a valid formatter, and we keep looking for
           * next valid closing formatter.
           * ESS-1402: checking for the non-breaking space after closing symbol.
           */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && $54e92e31a1db47a7$var$ALPHANUMERIC_OR_NON_ASCII_REGEX.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
           * If the closing symbol has an empty space before it,
           * it's not a valid formatter
           */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $54e92e31a1db47a7$var$processState.INLINE_MACRO:
                {
                    const match = (0, $gTSEm.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        break;
                    }
                    /**
           * Is not a problem send an empty context because we're only checking
           * if it has a nested macro inside.
           */ const token = (0, $gMTfd.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $gMTfd.TokenType).COLOR_MACRO) {
                        /**
             * {color} is valid in formatter, we simply jump over the length
             */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                }
            case $54e92e31a1db47a7$var$processState.LINK_FORMAT:
                {
                    /**
           * We should "fly over" the link format and we dont want
           * -awesome [link|https://www.atlass-ian.com] nice
           * to be a strike through because of the '-' in link
           *
           * Also, is not a problem send an empty context because we're only
           * checking if it has a nested macro inside.
           */ const token = (0, $8BR3C.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $54e92e31a1db47a7$var$processState.BUFFER;
                        continue;
                    }
                    return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
                }
            case $54e92e31a1db47a7$var$processState.ESCAPE:
                {
                    const token = (0, $ex8vr.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $54e92e31a1db47a7$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $54e92e31a1db47a7$var$fallback(input, position, openingSymbolLength);
}
function $54e92e31a1db47a7$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("8BR3C", function(module, exports) {
$parcel$export(module.exports, "linkFormat", () => $d26afd3f50cec67d$export$e1f888a4b6f2ee53);

var $gMTfd = parcelRequire("gMTfd");

var $cvz28 = parcelRequire("cvz28");

var $iI2HU = parcelRequire("iI2HU");

var $aHbYC = parcelRequire("aHbYC");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $d26afd3f50cec67d$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $d26afd3f50cec67d$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($d26afd3f50cec67d$var$LINK_FORMAT_REGEXP);
    /**
   * The following token types will be ignored in parsing
   * the content of a table cell
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TABLE,
        (0, $gMTfd.TokenType).RULER,
        // We want to avoid recursion
        (0, $gMTfd.TokenType).LINK_TEXT,
        (0, $gMTfd.TokenType).LINK_FORMAT
    ];
    if (!match) return $d26afd3f50cec67d$var$fallback();
    const content = (0, $iI2HU.parseContentLink)(match[1]);
    const resolvedLink = (0, $aHbYC.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $cvz28.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $d26afd3f50cec67d$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("iI2HU", function(module, exports) {
$parcel$export(module.exports, "parseContentLink", () => $2a7c81978a471386$export$3a250a08d37b0eae);

var $h54xF = parcelRequire("h54xF");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $2a7c81978a471386$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $2a7c81978a471386$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $2a7c81978a471386$var$divideOn(buffer, '|');
    const body = new (0, $h54xF.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $2a7c81978a471386$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $2a7c81978a471386$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $2a7c81978a471386$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $2a7c81978a471386$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $2a7c81978a471386$var$extractNumber(buf) {
    const digits = new (0, $h54xF.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $h54xF.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $2a7c81978a471386$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $h54xF.StringBuffer)(linkText);
    const linkBody = $2a7c81978a471386$var$extractLinkBody(buf);
    const linkTitle = $2a7c81978a471386$var$trimIfPossible($2a7c81978a471386$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $2a7c81978a471386$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $2a7c81978a471386$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $h54xF.StringBuffer)(notLinkBody);
        shortcutName = $2a7c81978a471386$var$trimIfPossible($2a7c81978a471386$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $h54xF.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $h54xF.StringBuffer)(notLinkBody);
    if ((0, $h54xF.isBlank)(shortcutName)) {
        spaceKey = $2a7c81978a471386$var$trimIfPossible($2a7c81978a471386$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $2a7c81978a471386$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $2a7c81978a471386$var$trimIfPossible($2a7c81978a471386$var$divideAfter(buf, '^'));
        anchor = $2a7c81978a471386$var$trimIfPossible($2a7c81978a471386$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});

parcelRegister("aHbYC", function(module, exports) {
$parcel$export(module.exports, "resolveLink", () => $56ed7eb2690bf22e$export$c2baa561eb017101);

var $av72l = parcelRequire("av72l");

var $cRCTN = parcelRequire("cRCTN");

var $kiqWE = parcelRequire("kiqWE");

var $jJjzr = parcelRequire("jJjzr");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $56ed7eb2690bf22e$var$linkResolverStrategies = [
    (0, $av72l.attachmentLinkResolver),
    (0, $kiqWE.mentionLinkResolver),
    (0, $cRCTN.issueLinkResolver),
    (0, $jJjzr.urlLinkResolver)
];
function $56ed7eb2690bf22e$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $56ed7eb2690bf22e$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("av72l", function(module, exports) {
$parcel$export(module.exports, "attachmentLinkResolver", () => $1019223ad728c621$export$ce918f41a76b8445);

var $720er = parcelRequire("720er");
function $1019223ad728c621$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $720er.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("720er", function(module, exports) {
$parcel$export(module.exports, "default", () => $2565c93ad9f5d8cf$export$2e2bcd8739ae039);
function $2565c93ad9f5d8cf$export$2e2bcd8739ae039(schema, filename, context = {}) {
    var _context$conversion;
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = (context === null || context === void 0 || (_context$conversion = context.conversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion.mediaConversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion[filename]) === null || _context$conversion === void 0 ? void 0 : _context$conversion.transform) ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("cRCTN", function(module, exports) {
$parcel$export(module.exports, "issueLinkResolver", () => $5dfdd2b4af6404eb$export$f40ed0efa65d4e8);

var $6gTMF = parcelRequire("6gTMF");
function $5dfdd2b4af6404eb$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Depricated should be removed in the next major release
    linkTitle === 'block-link') return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $6gTMF.getIssue)(context, originalLinkText);
    if (issue) return (0, $6gTMF.buildInlineCard)(schema, issue);
    return undefined;
}

});

parcelRegister("kiqWE", function(module, exports) {
$parcel$export(module.exports, "mentionLinkResolver", () => $03f971a64aeb25aa$export$1da3b34e38fc6ca8);
function $03f971a64aeb25aa$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("jJjzr", function(module, exports) {
$parcel$export(module.exports, "urlLinkResolver", () => $663c02753288a7e4$export$b737d556d2167f9);

var $7nI18 = parcelRequire("7nI18");

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $663c02753288a7e4$var$MAILTO_PREFIX_REGEX = /^mailto:/;
function $663c02753288a7e4$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $7nI18.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).LINK_TEXT,
        (0, $gMTfd.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $cvz28.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: textRepresentation.replace($663c02753288a7e4$var$MAILTO_PREFIX_REGEX, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$663c02753288a7e4$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $663c02753288a7e4$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});





parcelRegister("bLA40", function(module, exports) {
$parcel$export(module.exports, "codeMacro", () => $b7ffbe8fd3a627f6$export$db6c131ac26c7700);

var $5PoGV = parcelRequire("5PoGV");

var $2Rbo3 = parcelRequire("2Rbo3");

var $5jHGS = parcelRequire("5jHGS");
const $b7ffbe8fd3a627f6$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $b7ffbe8fd3a627f6$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $b7ffbe8fd3a627f6$var$rawContentProcessor
    });
};
const $b7ffbe8fd3a627f6$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $5PoGV.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $2Rbo3.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $b7ffbe8fd3a627f6$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $b7ffbe8fd3a627f6$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $b7ffbe8fd3a627f6$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});
parcelRegister("5PoGV", function(module, exports) {
$parcel$export(module.exports, "parseAttrs", () => $41a34475a4e3b79d$export$e1a9355cfd8f6c64);
function $41a34475a4e3b79d$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("2Rbo3", function(module, exports) {
$parcel$export(module.exports, "title", () => $bf53df8af177b827$export$fb184b623420d9be);
function $bf53df8af177b827$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("5H9Ha", function(module, exports) {
$parcel$export(module.exports, "colorMacro", () => $a0e9f5f063d6a971$export$b557be495948d995);

var $gMTfd = parcelRequire("gMTfd");

var $j8AgX = parcelRequire("j8AgX");

var $cvz28 = parcelRequire("cvz28");

var $5PoGV = parcelRequire("5PoGV");

var $h54xF = parcelRequire("h54xF");

var $5jHGS = parcelRequire("5jHGS");
const $a0e9f5f063d6a971$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $a0e9f5f063d6a971$var$rawContentProcessor
    });
};
const $a0e9f5f063d6a971$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TABLE
    ];
    const parsedAttrs = (0, $5PoGV.parseAttrs)(rawAttrs);
    const content = (0, $cvz28.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $j8AgX.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("j8AgX", function(module, exports) {
$parcel$export(module.exports, "getEditorColor", () => $2d3e6d644d9f4b2a$export$c0cfc6f23e0b7578);

var $iu0j1 = parcelRequire("iu0j1");
function $2d3e6d644d9f4b2a$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $iu0j1.normalizeHexColor)(keys[0]);
}

});


parcelRegister("3zHhi", function(module, exports) {
$parcel$export(module.exports, "deleted", () => $bad2ee03263a5045$export$bccbf0c716f226f4);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $bad2ee03263a5045$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ntdHx", function(module, exports) {
$parcel$export(module.exports, "doubleDashSymbol", () => $cd9736686664638a$export$65e3ca7c95899a2d);

var $dBmzd = parcelRequire("dBmzd");
const $cd9736686664638a$var$token = {
    type: 'text',
    text: '\u2013',
    // EN DASH
    length: 2
};
const $cd9736686664638a$var$fallback = {
    ...$cd9736686664638a$var$token,
    text: '--'
};
const $cd9736686664638a$export$65e3ca7c95899a2d = (0, $dBmzd.createDashTokenParser)($cd9736686664638a$var$token, $cd9736686664638a$var$fallback);

});
parcelRegister("dBmzd", function(module, exports) {
$parcel$export(module.exports, "createDashTokenParser", () => $b7a5da07805741f4$export$d43b58865d429e3c);
const $b7a5da07805741f4$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
   * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
   *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
   *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
   */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$b7a5da07805741f4$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$b7a5da07805741f4$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b7a5da07805741f4$var$WHITESPACE_REGEX = /\s/;
const $b7a5da07805741f4$var$isSpace = (char)=>{
    return $b7a5da07805741f4$var$WHITESPACE_REGEX.test(char);
};

});


parcelRegister("3yyka", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $a2553766ee5caa98$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2553766ee5caa98$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $a2553766ee5caa98$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
   * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
   */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $a2553766ee5caa98$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $a2553766ee5caa98$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($a2553766ee5caa98$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $a2553766ee5caa98$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $a2553766ee5caa98$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("bSwvv", function(module, exports) {
$parcel$export(module.exports, "emphasis", () => $d7dcaceb2c768b4d$export$bef81ba411953b51);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $d7dcaceb2c768b4d$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a  mark
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("b5ACy", function(module, exports) {
$parcel$export(module.exports, "forceLineBreak", () => $48dfe01ddc76fbf4$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $48dfe01ddc76fbf4$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $48dfe01ddc76fbf4$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $48dfe01ddc76fbf4$var$fallback(input, position);
    }
    const match = input.substring(position).match($48dfe01ddc76fbf4$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $48dfe01ddc76fbf4$var$fallback(input, position);
};
function $48dfe01ddc76fbf4$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});

parcelRegister("9NWN1", function(module, exports) {
$parcel$export(module.exports, "hardbreak", () => $4c80fbf311909bed$export$ac55bb44695749c1);

var $eFvMd = parcelRequire("eFvMd");
const $4c80fbf311909bed$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $eFvMd.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("274RH", function(module, exports) {
$parcel$export(module.exports, "heading", () => $c450e019f7fdbae9$export$46e4a324ac90507f);

var $cvz28 = parcelRequire("cvz28");

var $gMTfd = parcelRequire("gMTfd");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $c450e019f7fdbae9$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $c450e019f7fdbae9$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a strong mark
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($c450e019f7fdbae9$var$HEADING_REGEXP);
    if (!match) return $c450e019f7fdbae9$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $cvz28.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
     * If the heading fails to rendering, we want to skip the text
     * "h1."
     */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $c450e019f7fdbae9$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("2eWeA", function(module, exports) {
$parcel$export(module.exports, "inserted", () => $220c2c5520494f3c$export$744ba74fb86b8ca7);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $220c2c5520494f3c$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ht2K2", function(module, exports) {
$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $a2918fdf5b69297e$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $a2918fdf5b69297e$export$cb7bcf09a05b7705);

var $7nI18 = parcelRequire("7nI18");

var $cGUvO = parcelRequire("cGUvO");
const $a2918fdf5b69297e$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $a2918fdf5b69297e$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($a2918fdf5b69297e$export$f69d1dce349473aa);
    if (!matches) return $a2918fdf5b69297e$var$fallback(input, position);
    const match = $a2918fdf5b69297e$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $cGUvO.decode)($a2918fdf5b69297e$var$unescape(match[0]));
    if (!(0, $7nI18.isSafeUrl)(url)) return $a2918fdf5b69297e$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $a2918fdf5b69297e$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $a2918fdf5b69297e$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2918fdf5b69297e$var$BAD_END_CHARS_REGEX = /[.,>)\];}"\'!]*$/;
// removes bad characters from the end of regex match
function $a2918fdf5b69297e$var$trimBadEndChar(input) {
    return [
        input[0].replace($a2918fdf5b69297e$var$BAD_END_CHARS_REGEX, ''),
        input[1],
        input[2].replace($a2918fdf5b69297e$var$BAD_END_CHARS_REGEX, '')
    ];
}

});
parcelRegister("cGUvO", function(module, exports) {
$parcel$export(module.exports, "decode", () => $8597a813297a3d33$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $8597a813297a3d33$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});


parcelRegister("6KDra", function(module, exports) {
$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $33c4076b5717f375$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $33c4076b5717f375$export$8837f4fc672e936d);

var $ehAJL = parcelRequire("ehAJL");

var $cvz28 = parcelRequire("cvz28");

var $jO5UR = parcelRequire("jO5UR");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gTSEm = parcelRequire("gTSEm");

var $eFvMd = parcelRequire("eFvMd");
const $33c4076b5717f375$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $33c4076b5717f375$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$33c4076b5717f375$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $33c4076b5717f375$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $33c4076b5717f375$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $33c4076b5717f375$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $33c4076b5717f375$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a listItem
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).LIST,
        (0, $gMTfd.TokenType).TABLE
    ];
    let index = position;
    let state = $33c4076b5717f375$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $33c4076b5717f375$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($33c4076b5717f375$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($33c4076b5717f375$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($33c4076b5717f375$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $33c4076b5717f375$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $ehAJL.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
               * There is a builder, so we are in the middle of building a list
               * and now there is a new list item
               */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $cvz28.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $33c4076b5717f375$var$sanitize((0, $jO5UR.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $ehAJL.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $ehAJL.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($33c4076b5717f375$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $33c4076b5717f375$var$processState.END;
                        continue;
                    }
                    state = $33c4076b5717f375$var$processState.BUFFER;
                    continue;
                }
            case $33c4076b5717f375$var$processState.BUFFER:
                {
                    const length = (0, $eFvMd.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $33c4076b5717f375$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $33c4076b5717f375$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $33c4076b5717f375$var$processState.MACRO:
                {
                    const match = (0, $gTSEm.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $33c4076b5717f375$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $gMTfd.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $33c4076b5717f375$var$processState.BUFFER;
                    continue;
                }
            case $33c4076b5717f375$var$processState.END:
                if (!builder) // Something is really wrong here
                return $33c4076b5717f375$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $cvz28.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $33c4076b5717f375$var$sanitize((0, $jO5UR.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $33c4076b5717f375$var$sanitize((0, $jO5UR.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $33c4076b5717f375$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
           * If a blockquote is inside a list item
           * - Convert it to paragraph
           */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
           * If a heading is inside a list item
           * - Convert the heading to paragraph
           * - Convert text to upper case
           * - Mark text with strong.
           */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $33c4076b5717f375$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("ehAJL", function(module, exports) {
$parcel$export(module.exports, "getType", () => $307941457c2bd37c$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $307941457c2bd37c$export$876cfa3161bef296);
const $307941457c2bd37c$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $307941457c2bd37c$var$ORDERED_LIST_REGEX = /#$/;
function $307941457c2bd37c$export$e2b5c5db9e2009fd(bullets) {
    return $307941457c2bd37c$var$ORDERED_LIST_REGEX.test(bullets) ? 'orderedList' : 'bulletList';
}
class $307941457c2bd37c$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
   * Build prosemirror bulletList or orderedList node
   * @param {List} list
   * @returns {PMNode}
   */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
         * If the node is not a listItem, then we need to
         * wrap exisintg list and break out
         */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
   * Build prosemirror listItem node
   * This function would possibly return non listItem nodes
   * which we need to break out later
   * @param {ListItem} item
   */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
       * Skip empty paragraph
       */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($307941457c2bd37c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $307941457c2bd37c$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
   * Return the type of the base list
   * @returns {ListType}
   */ get type() {
        return this.root.type;
    }
    /**
   * Add a list item to the builder
   * @param {AddArgs[]} items
   */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $307941457c2bd37c$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
   * Compile a prosemirror node from the root list
   * @returns {PMNode[]}
   */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) {
            // If the first element is a list node, try to create a wrapper listItem
            // (list as first child, no paragraph) for flexible list indentation.
            // If the schema doesn't support this variant, fall back to prepending
            // an empty paragraph.
            const listTypes = [
                'bulletList',
                'orderedList',
                'taskList'
            ];
            if (content.length > 0 && listTypes.indexOf(content[0].type.name) !== -1) try {
                return schema.nodes.listItem.createChecked({}, content);
            } catch  {
            // Schema doesn't support list as first child of listItem,
            // fall back to prepending an empty paragraph
            }
            // If the content is empty or the first element is not paragraph or mediaSingle,
            // this is likely a nested list where the top-level list item has no text content.
            // For example: *# item 1
            // In this case we create an empty paragraph for the top level listNode.
            content.unshift(this.schema.nodes.paragraph.createChecked());
        }
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
   * Add an item at the same level as the current list item
   * @param {ListType} type
   * @param {PMNode} content
   * @returns {PMNode}
   */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
   * Append the past content to the last accessed list node (multiline entries)
   * @param {PMNode[]} content
   */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
   * Created a nested list structure of N depth under the current node
   * @param {number} depth
   * @param {ListType} type
   */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
   * Find the Nth list ancestor of the current list
   * @param {number} depth
   */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("lKn2G", function(module, exports) {
$parcel$export(module.exports, "media", () => $4110d7bd7203b170$export$987d49ffe1b0900f);

var $2QwaD = parcelRequire("2QwaD");

var $5PoGV = parcelRequire("5PoGV");

var $gsDpQ = parcelRequire("gsDpQ");
const $4110d7bd7203b170$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
     * !image.gif|align=right, vspace=4|ignore-this!
     * If it splits into more than 2 items, we ignore the rest
     */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $2QwaD.default)(schema, rawContent, (0, $5PoGV.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("2QwaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $67361621ab5f9119$export$2e2bcd8739ae039);

var $ht2K2 = parcelRequire("ht2K2");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $67361621ab5f9119$var$WRAPPING_QUOTES_REGEX = /^"(.+)"$/;
const $67361621ab5f9119$var$defaultWidth = 200;
const $67361621ab5f9119$var$defaultHeight = 183;
const $67361621ab5f9119$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $67361621ab5f9119$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    var _context$defaults, _context$defaults3;
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if ((context === null || context === void 0 || (_context$defaults = context.defaults) === null || _context$defaults === void 0 || (_context$defaults = _context$defaults.media) === null || _context$defaults === void 0 ? void 0 : _context$defaults.width) !== null) {
        var _context$defaults2;
        mediaNodeAttrs.width = (context === null || context === void 0 || (_context$defaults2 = context.defaults) === null || _context$defaults2 === void 0 || (_context$defaults2 = _context$defaults2.media) === null || _context$defaults2 === void 0 ? void 0 : _context$defaults2.width) ?? $67361621ab5f9119$var$defaultWidth;
    }
    if ((context === null || context === void 0 || (_context$defaults3 = context.defaults) === null || _context$defaults3 === void 0 || (_context$defaults3 = _context$defaults3.media) === null || _context$defaults3 === void 0 ? void 0 : _context$defaults3.height) !== null) {
        var _context$defaults4;
        mediaNodeAttrs.height = (context === null || context === void 0 || (_context$defaults4 = context.defaults) === null || _context$defaults4 === void 0 || (_context$defaults4 = _context$defaults4.media) === null || _context$defaults4 === void 0 ? void 0 : _context$defaults4.height) ?? $67361621ab5f9119$var$defaultHeight;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $67361621ab5f9119$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        const href = attrs.href.replace($67361621ab5f9119$var$WRAPPING_QUOTES_REGEX, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        const altText = attrs.alt.replace($67361621ab5f9119$var$WRAPPING_QUOTES_REGEX, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $ht2K2.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        var _context$conversion;
        // try to look up media ID from conversion context
        const id = (context === null || context === void 0 || (_context$conversion = context.conversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion.mediaConversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion[filename]) === null || _context$conversion === void 0 ? void 0 : _context$conversion.transform) ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});


parcelRegister("hqiZ5", function(module, exports) {
$parcel$export(module.exports, "monospace", () => $da9761389fe58cec$export$2b90969bbc9ff4c9);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $da9761389fe58cec$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).ADF_MACRO,
        (0, $gMTfd.TokenType).ANCHOR_MACRO,
        (0, $gMTfd.TokenType).CODE_MACRO,
        (0, $gMTfd.TokenType).QUOTE_MACRO,
        (0, $gMTfd.TokenType).NOFORMAT_MACRO,
        (0, $gMTfd.TokenType).PANEL_MACRO,
        (0, $gMTfd.TokenType).COLOR_MACRO,
        (0, $gMTfd.TokenType).LOREM_MACRO,
        (0, $gMTfd.TokenType).QUOTE,
        (0, $gMTfd.TokenType).STRING,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).LINK_FORMAT,
        (0, $gMTfd.TokenType).LINK_TEXT,
        (0, $gMTfd.TokenType).MEDIA,
        (0, $gMTfd.TokenType).HEADING,
        (0, $gMTfd.TokenType).LIST,
        (0, $gMTfd.TokenType).TABLE,
        (0, $gMTfd.TokenType).RULER,
        (0, $gMTfd.TokenType).HARD_BREAK,
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).STRONG,
        (0, $gMTfd.TokenType).MONOSPACE,
        (0, $gMTfd.TokenType).SUPERSCRIPT,
        (0, $gMTfd.TokenType).SUBSCRIPT,
        (0, $gMTfd.TokenType).EMPHASIS,
        (0, $gMTfd.TokenType).CITATION,
        (0, $gMTfd.TokenType).DELETED,
        (0, $gMTfd.TokenType).INSERTED,
        (0, $gMTfd.TokenType).EMOJI,
        (0, $gMTfd.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("a1hLt", function(module, exports) {
$parcel$export(module.exports, "noformatMacro", () => $f26eee5b6cd9b761$export$9199752eb9b2d5b4);

var $5PoGV = parcelRequire("5PoGV");

var $2Rbo3 = parcelRequire("2Rbo3");

var $5jHGS = parcelRequire("5jHGS");
const $f26eee5b6cd9b761$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $f26eee5b6cd9b761$var$rawContentProcessor
    });
};
const $f26eee5b6cd9b761$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $5PoGV.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $2Rbo3.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("3kz4Q", function(module, exports) {
$parcel$export(module.exports, "panelMacro", () => $dde82e753e707739$export$5d7bf7e31a674541);

var $cvz28 = parcelRequire("cvz28");

var $5PoGV = parcelRequire("5PoGV");

var $jO5UR = parcelRequire("jO5UR");

var $htq25 = parcelRequire("htq25");

var $2Rbo3 = parcelRequire("2Rbo3");

var $5jHGS = parcelRequire("5jHGS");
const $dde82e753e707739$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $dde82e753e707739$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5jHGS.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $dde82e753e707739$var$rawContentProcessor
    });
};
const $dde82e753e707739$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $5PoGV.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $htq25.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $cvz28.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $jO5UR.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $2Rbo3.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($dde82e753e707739$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $dde82e753e707739$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $dde82e753e707739$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("htq25", function(module, exports) {
$parcel$export(module.exports, "getPanelType", () => $0a9468c5aa31bcc4$export$fa00fa3d6c22a747);

var $jiXNn = parcelRequire("jiXNn");
const $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $0a9468c5aa31bcc4$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $0a9468c5aa31bcc4$export$fa00fa3d6c22a747(attrs) {
    const rgb = $0a9468c5aa31bcc4$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($0a9468c5aa31bcc4$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $0a9468c5aa31bcc4$var$distanceOfRgb($0a9468c5aa31bcc4$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $0a9468c5aa31bcc4$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $0a9468c5aa31bcc4$var$generateRgb(color) {
    switch(true){
        case $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.hexShort.test(color) || $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $0a9468c5aa31bcc4$var$parseHex(color);
        case $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $0a9468c5aa31bcc4$var$parseRgb(color);
        case $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $0a9468c5aa31bcc4$var$parsePrgb(color);
        default:
            return $0a9468c5aa31bcc4$var$parseColorName(color);
    }
}
function $0a9468c5aa31bcc4$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $0a9468c5aa31bcc4$var$parseRgb(rgb) {
    const result = rgb.match($0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $0a9468c5aa31bcc4$var$parsePrgb(prgb) {
    const result = prgb.match($0a9468c5aa31bcc4$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $0a9468c5aa31bcc4$var$parseColorName(color) {
    return (0, $jiXNn.default)[color];
}

});
parcelRegister("jiXNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eafd6445235835c$export$2e2bcd8739ae039);
const $2eafd6445235835c$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $2eafd6445235835c$export$2e2bcd8739ae039 = $2eafd6445235835c$var$mapping;

});



parcelRegister("6DPzT", function(module, exports) {
$parcel$export(module.exports, "quadrupleDashSymbol", () => $597c29a088ceb085$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $597c29a088ceb085$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $597c29a088ceb085$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($597c29a088ceb085$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("jO87J", function(module, exports) {
$parcel$export(module.exports, "ruler", () => $b54845b40c22393d$export$f9adada2013e846e);

var $a6GOs = parcelRequire("a6GOs");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b54845b40c22393d$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $b54845b40c22393d$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($b54845b40c22393d$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $a6GOs.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("a6GOs", function(module, exports) {
$parcel$export(module.exports, "createRuleNode", () => $d79bc52e9b44f0f9$export$4267f2e5716b018a);
const $d79bc52e9b44f0f9$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d79bc52e9b44f0f9$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d79bc52e9b44f0f9$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d79bc52e9b44f0f9$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("bPeRF", function(module, exports) {
$parcel$export(module.exports, "strong", () => $add306ab95994312$export$59ae2c325a998f89);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $add306ab95994312$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a strong mark
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("f24cd", function(module, exports) {
$parcel$export(module.exports, "subscript", () => $f34603c05dead3f4$export$bc5390e4688d2822);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $f34603c05dead3f4$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a  mark
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("gX9Ct", function(module, exports) {
$parcel$export(module.exports, "superscript", () => $12628652aab55ca2$export$b4aab94a5fcfcead);

var $cvz28 = parcelRequire("cvz28");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $gsDpQ = parcelRequire("gsDpQ");
const $12628652aab55ca2$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a  mark
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).ISSUE_KEY,
        (0, $gMTfd.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $cvz28.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $h54xF.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $gsDpQ.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("dloK2", function(module, exports) {
$parcel$export(module.exports, "table", () => $5c88185e577fd573$export$9852986a3ec5f6a0);

var $6dJFq = parcelRequire("6dJFq");

var $cvz28 = parcelRequire("cvz28");

var $jO5UR = parcelRequire("jO5UR");

var $h54xF = parcelRequire("h54xF");

var $gMTfd = parcelRequire("gMTfd");

var $3yyka = parcelRequire("3yyka");

var $gTSEm = parcelRequire("gTSEm");

var $8BR3C = parcelRequire("8BR3C");

var $lKn2G = parcelRequire("lKn2G");

var $eFvMd = parcelRequire("eFvMd");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c88185e577fd573$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c88185e577fd573$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $5c88185e577fd573$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $5c88185e577fd573$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
   * The following token types will be ignored in parsing
   * the content of a table cell
   */ const ignoreTokenTypes = [
        (0, $gMTfd.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $gMTfd.TokenType).TABLE,
        (0, $gMTfd.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $5c88185e577fd573$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $5c88185e577fd573$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($5c88185e577fd573$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $6dJFq.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $5c88185e577fd573$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $5c88185e577fd573$var$processState.END_TABLE;
                    continue;
                }
            case $5c88185e577fd573$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($5c88185e577fd573$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $5c88185e577fd573$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $5c88185e577fd573$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($5c88185e577fd573$var$CELL_REGEXP);
                    if (cellMatch) currentState = $5c88185e577fd573$var$processState.CLOSE_ROW;
                    else currentState = $5c88185e577fd573$var$processState.BUFFER;
                    continue;
                }
            case $5c88185e577fd573$var$processState.BUFFER:
                {
                    const length = (0, $eFvMd.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($5c88185e577fd573$var$EMPTY_LINE_REGEXP)) currentState = $5c88185e577fd573$var$processState.CLOSE_ROW;
                        else {
                            currentState = $5c88185e577fd573$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $5c88185e577fd573$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($5c88185e577fd573$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $5c88185e577fd573$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $5c88185e577fd573$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $5c88185e577fd573$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $5c88185e577fd573$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $5c88185e577fd573$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $5c88185e577fd573$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $5c88185e577fd573$var$processState.NEW_ROW;
                    continue;
                }
            case $5c88185e577fd573$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $5c88185e577fd573$var$processState.MEDIA:
                {
                    const token = (0, $lKn2G.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5c88185e577fd573$var$processState.BUFFER;
                    continue;
                }
            case $5c88185e577fd573$var$processState.EMOJI:
                {
                    const token = (0, $3yyka.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5c88185e577fd573$var$processState.BUFFER;
                    continue;
                }
            case $5c88185e577fd573$var$processState.LINK:
                {
                    /**
           * We should "fly over" the link format and we dont want
           * -awesome [link|https://www.atlass-ian.com] nice
           * to be a strike through because of the '-' in link
           */ const token = (0, $8BR3C.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $5c88185e577fd573$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $5c88185e577fd573$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $5c88185e577fd573$var$processState.MACRO:
                {
                    const match = (0, $gTSEm.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $5c88185e577fd573$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $gMTfd.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5c88185e577fd573$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
   * If there are left over content which didn't have a closing |
   * For example
   * |cell1|cell2|cell3
   * we still want to create a new cell for the last cell3 if it's
   * not empty.
   */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $5c88185e577fd573$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $5c88185e577fd573$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $cvz28.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $5c88185e577fd573$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $jO5UR.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $5c88185e577fd573$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $5c88185e577fd573$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5c88185e577fd573$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $5c88185e577fd573$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $5c88185e577fd573$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $h54xF.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $5c88185e577fd573$var$traverseContent(node, mark, schema);
}

});
parcelRegister("6dJFq", function(module, exports) {
$parcel$export(module.exports, "TableBuilder", () => $e9cc615e9962ec7e$export$9e18c07f56f31a89);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9cc615e9962ec7e$var$TABLE_HEADER_REGEX = /\|\|/;
/**
 * Return the cell type based on the delimeter
 */ function $e9cc615e9962ec7e$var$getType(style) {
    return $e9cc615e9962ec7e$var$TABLE_HEADER_REGEX.test(style) ? 'tableHeader' : 'tableCell';
}
class $e9cc615e9962ec7e$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
   * Build prosemirror table node
   * @returns {PMNode}
   */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
   * Build prosemirror tr node
   * @returns {PMNode}
   */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
   * Build prosemirror td/th node
   * @param {TableCell} cell
   * @returns {PMNode}
   */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
   * Return the type of the base element
   * @returns {string}
   */ get type() {
        return 'table';
    }
    /**
   * Add new cells to the table
   * @param {AddCellArgs[]} cells
   */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $e9cc615e9962ec7e$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
   * Build a prosemirror table from the data
   * @returns {PMNode}
   */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
   * Add a new row to the table
   */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("1A388", function(module, exports) {
$parcel$export(module.exports, "tripleDashSymbol", () => $7ac1e726b469c6e1$export$edbcd749367de060);

var $dBmzd = parcelRequire("dBmzd");
const $7ac1e726b469c6e1$var$token = {
    type: 'text',
    text: '\u2014',
    // EM DASH
    length: 3
};
const $7ac1e726b469c6e1$var$fallback = {
    ...$7ac1e726b469c6e1$var$token,
    text: '---'
};
const $7ac1e726b469c6e1$export$edbcd749367de060 = (0, $dBmzd.createDashTokenParser)($7ac1e726b469c6e1$var$token, $7ac1e726b469c6e1$var$fallback);

});



parcelRegister("1CF37", function(module, exports) {
$parcel$export(module.exports, "code", () => $79acf9522ab6627b$export$6565f9f03506010b);
const $79acf9522ab6627b$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("feCfe", function(module, exports) {
$parcel$export(module.exports, "em", () => $30ac0a10b94322c7$export$c63c6f932822f543);

var $9YboW = parcelRequire("9YboW");
const $30ac0a10b94322c7$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $9YboW.baseMarkPattern)(text.substring(2), '??');
    return (0, $9YboW.baseMarkPattern)(text, '_');
};

});
parcelRegister("9YboW", function(module, exports) {
$parcel$export(module.exports, "baseMarkPattern", () => $0b9108dfa4a31e3a$export$3d8aed7830783c75);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0b9108dfa4a31e3a$var$ONLY_WHITESPACE_REGEX = /^\s*$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0b9108dfa4a31e3a$var$LEADING_WHITESPACE_REGEX = /^\s*/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0b9108dfa4a31e3a$var$TRAILING_WHITESPACE_REGEX = /\s*$/;
const $0b9108dfa4a31e3a$export$3d8aed7830783c75 = (text, token)=>{
    if ($0b9108dfa4a31e3a$var$ONLY_WHITESPACE_REGEX.test(text)) /**
     * If it's a string with only whitespaces, wiki renderer
     * will behave incorrect if we apply format on it
     */ return text;
    return text.replace($0b9108dfa4a31e3a$var$LEADING_WHITESPACE_REGEX, `$&${token}`).replace($0b9108dfa4a31e3a$var$TRAILING_WHITESPACE_REGEX, `${token}$&`);
};

});


parcelRegister("h13Ja", function(module, exports) {
$parcel$export(module.exports, "link", () => $30e94f91aec8b443$export$9c30223ca0a664fb);
const $30e94f91aec8b443$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("i4IZL", function(module, exports) {
$parcel$export(module.exports, "strike", () => $e7d5fcd0d37902b0$export$4899a95d70ec5056);

var $9YboW = parcelRequire("9YboW");
const $e7d5fcd0d37902b0$export$4899a95d70ec5056 = (text)=>{
    return (0, $9YboW.baseMarkPattern)(text, '-');
};

});

parcelRegister("eE2s4", function(module, exports) {
$parcel$export(module.exports, "strong", () => $289a7f266415650a$export$59ae2c325a998f89);

var $9YboW = parcelRequire("9YboW");
const $289a7f266415650a$export$59ae2c325a998f89 = (text)=>{
    return (0, $9YboW.baseMarkPattern)(text, '*');
};

});

parcelRegister("fBVah", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $3ab3618999fde636$export$b3401ee80eb31041);

var $9YboW = parcelRequire("9YboW");
const $3ab3618999fde636$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $9YboW.baseMarkPattern)(text, '~');
    else return (0, $9YboW.baseMarkPattern)(text, '^');
};

});

parcelRegister("52gEw", function(module, exports) {
$parcel$export(module.exports, "underline", () => $5ac86311c5beb002$export$425327af25286e5e);

var $9YboW = parcelRequire("9YboW");
const $5ac86311c5beb002$export$425327af25286e5e = (text)=>{
    return (0, $9YboW.baseMarkPattern)(text, '+');
};

});




parcelRegister("9CMfw", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $c1cf9381436a5415$export$2855e964765eac9);

var $9tZQo = parcelRequire("9tZQo");

var $7KV4u = parcelRequire("7KV4u");

var $gAgju = parcelRequire("gAgju");
const $c1cf9381436a5415$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $7KV4u.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $9tZQo.caption)(n, opts));
                break;
            default:
                result.push((0, $gAgju.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("9tZQo", function(module, exports) {
$parcel$export(module.exports, "caption", () => $923fd92a7bb6d82e$export$8e3c2dfdc4f0453d);

var $ipg1R = parcelRequire("ipg1R");
const $923fd92a7bb6d82e$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $ipg1R.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("7KV4u", function(module, exports) {
$parcel$export(module.exports, "media", () => $5fa21e8597a2231e$export$987d49ffe1b0900f);
const $5fa21e8597a2231e$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    var _context$conversion2;
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark === null || linkMark === void 0 ? void 0 : linkMark.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else {
        var _context$conversion;
        fileName = (context === null || context === void 0 || (_context$conversion = context.conversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion.mediaConversion) === null || _context$conversion === void 0 || (_context$conversion = _context$conversion[node.attrs.id]) === null || _context$conversion === void 0 ? void 0 : _context$conversion.transform) ?? node.attrs.id;
    }
    if ((context === null || context === void 0 || (_context$conversion2 = context.conversion) === null || _context$conversion2 === void 0 || (_context$conversion2 = _context$conversion2.mediaConversion) === null || _context$conversion2 === void 0 || (_context$conversion2 = _context$conversion2[node.attrs.id]) === null || _context$conversion2 === void 0 ? void 0 : _context$conversion2.embed) === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});


parcelRegister("6rfTP", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $377091bc5f2886c2$export$9c206ddddb32a9b);

var $ipg1R = parcelRequire("ipg1R");
const $377091bc5f2886c2$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $ipg1R.inlines)(n, {
            context: context
        });
    });
    return result;
};

});



parcelRegister("9RMDG", function(module, exports) {
$parcel$export(module.exports, "decisionList", () => $cd6d35e777a59706$export$62d45a65fb43d95e);

var $bTla9 = parcelRequire("bTla9");
const $cd6d35e777a59706$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bTla9.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("bTla9", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $d4f8ace8d7d8382e$export$6959e16eeff859b4);

var $ipg1R = parcelRequire("ipg1R");
const $d4f8ace8d7d8382e$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $ipg1R.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("5STAp", function(module, exports) {
$parcel$export(module.exports, "doc", () => $cda12d14acb37401$export$2a111da947c407d2);

var $hud8R = parcelRequire("hud8R");
const $cda12d14acb37401$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("3qRms", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $7ca40af62a9ce24f$export$be4283d9a1cb1ff6);

var $gAgju = parcelRequire("gAgju");
const $7ca40af62a9ce24f$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $gAgju.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});

parcelRegister("gW4iP", function(module, exports) {
$parcel$export(module.exports, "expand", () => $9b934235538519b2$export$9f77e0932fb78f72);

var $hud8R = parcelRequire("hud8R");
const $9b934235538519b2$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("f8uxT", function(module, exports) {
$parcel$export(module.exports, "heading", () => $ee02f24e0df3a725$export$46e4a324ac90507f);

var $ipg1R = parcelRequire("ipg1R");
const $ee02f24e0df3a725$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $ipg1R.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("709SY", function(module, exports) {
$parcel$export(module.exports, "orderedList", () => $5833e8d620aae200$export$a5dc81035676e7a);

var $hkAMl = parcelRequire("hkAMl");
const $5833e8d620aae200$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $hkAMl.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("8DeKg", function(module, exports) {
$parcel$export(module.exports, "panel", () => $a2cb545972ac31c4$export$21f42ab9b6679f44);

var $hud8R = parcelRequire("hud8R");
const $a2cb545972ac31c4$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $a2cb545972ac31c4$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    return `{panel:bgColor=${$a2cb545972ac31c4$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("ijipD", function(module, exports) {
$parcel$export(module.exports, "rule", () => $d1343b686405d918$export$fbeb3a3956e8a3c7);
const $d1343b686405d918$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("3PR9u", function(module, exports) {
$parcel$export(module.exports, "table", () => $4339e8d36c9c4f4e$export$9852986a3ec5f6a0);

var $hud8R = parcelRequire("hud8R");

var $gAgju = parcelRequire("gAgju");
const $4339e8d36c9c4f4e$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($4339e8d36c9c4f4e$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $gAgju.unknown)(node);
    }
};
const $4339e8d36c9c4f4e$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$4339e8d36c9c4f4e$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $4339e8d36c9c4f4e$var$tableCell = (node, { context: context } = {})=>{
    if ($4339e8d36c9c4f4e$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hud8R.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $4339e8d36c9c4f4e$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("g7IiT", function(module, exports) {
$parcel$export(module.exports, "taskList", () => $c67e55bcb447b483$export$375b6afcc5f4d291);

var $e6afv = parcelRequire("e6afv");
const $c67e55bcb447b483$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($c67e55bcb447b483$var$nestedNode(item, depth + 1));
        else result.push((0, $e6afv.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $c67e55bcb447b483$export$375b6afcc5f4d291 = (node)=>{
    return $c67e55bcb447b483$var$nestedNode(node);
};

});
parcelRegister("e6afv", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $b11d180593fd47b8$export$6d8b0ef52e2e6390);

var $ipg1R = parcelRequire("ipg1R");
const $b11d180593fd47b8$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $ipg1R.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $ipg1R.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});



parcelRegister("cAWrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b096d89ff3f56fbe$export$2e2bcd8739ae039);

var $cvz28 = parcelRequire("cvz28");

var $jO5UR = parcelRequire("jO5UR");
class $b096d89ff3f56fbe$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
   * Convert reduced macros tree into prosemirror model tree
   */ getProseMirrorModel(context) {
        const content = (0, $cvz28.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $jO5UR.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});


parcelRegister("jg5hp", function(module, exports) {
$parcel$export(module.exports, "getTextValidationErrors", () => $8799e70ed670c816$export$ec8a9e5bcf83f749);

var $lV0Co = parcelRequire("lV0Co");

var $82gbm = parcelRequire("82gbm");

var $j15pg = parcelRequire("j15pg");

var $gCFqc = parcelRequire("gCFqc");
const $8799e70ed670c816$var$wordCounter = (text)=>(text.trim().match(/\S+/g) || []).length;
const $8799e70ed670c816$var$shouldValidateWordCount = (wordCount)=>Boolean(wordCount);
const $8799e70ed670c816$export$ec8a9e5bcf83f749 = (validation, fieldLabel, intl, textValue)=>{
    if (Object.keys(validation).length === 0) return [];
    if (!textValue) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    const { text: text } = textValue;
    const trimmedText = text.trim();
    const wordCount = validation.minimumWords || validation.maximumWords ? $8799e70ed670c816$var$wordCounter(trimmedText) : undefined;
    if (trimmedText.length === 0) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    if (trimmedText.length > 0) {
        // the char count in the trimmed text does not match the char count in the validation rule
        if (validation.minimumCharacters && validation.minimumCharacters === validation.maximumCharacters && trimmedText.length !== validation.minimumCharacters) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).exactCharacters, {
                minimum: validation.minimumCharacters
            }))
        ];
        // the word count in the trimmed text does not match the word count in the validation rule
        if (validation.minimumWords && validation.minimumWords === validation.maximumWords && wordCount !== validation.minimumWords) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).exactWords, {
                minimum: validation.minimumWords
            }))
        ];
        // the char count in the trimmed text is outside the [min,max] range in the validation rule
        if (validation.minimumCharacters && validation.maximumCharacters && (trimmedText.length < validation.minimumCharacters || trimmedText.length > validation.maximumCharacters)) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).betweenCharacters, {
                minimum: validation.minimumCharacters,
                maximum: validation.maximumCharacters
            }))
        ];
        // the word count in the trimmed text is outside the [min,max] range in the validation rule
        if (validation.minimumWords && validation.maximumWords && $8799e70ed670c816$var$shouldValidateWordCount(wordCount) && (wordCount < validation.minimumWords || wordCount > validation.maximumWords)) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).betweenWords, {
                minimum: validation.minimumWords,
                maximum: validation.maximumWords
            }))
        ];
        // the char count in the trimmed text is below the min value in the validation rule
        if (validation.minimumCharacters && trimmedText.length < validation.minimumCharacters) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).minimumCharacters, {
                minimum: validation.minimumCharacters - 1
            }))
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the word count in the trimmed text is below the min value in the validation rule
        if (validation.minimumWords && $8799e70ed670c816$var$shouldValidateWordCount(wordCount) && wordCount < validation.minimumWords) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).minimumWords, {
                minimum: validation.minimumWords - 1
            }))
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the char count in the trimmed text is above the max value in the validation rule
        if (validation.maximumCharacters && trimmedText.length > validation.maximumCharacters) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).maximumCharacters, {
                maximum: validation.maximumCharacters + 1
            }))
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the word count in the trimmed text is above the max value in the validation rule
        if (validation.maximumWords && $8799e70ed670c816$var$shouldValidateWordCount(wordCount) && wordCount > validation.maximumWords) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).maximumWords, {
                maximum: validation.maximumWords + 1
            }))
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // a custom regex pattern was provided
        if (validation.regexValidation && validation.regexValidation.pattern) try {
            let isMatch = false;
            try {
                const patternString = validation.regexValidation.pattern instanceof RegExp ? validation.regexValidation.pattern.source : validation.regexValidation.pattern;
                isMatch = (0, $lV0Co.RE2JS).compile(patternString).matcher(text).find();
            } catch  {
                isMatch = text.match(validation.regexValidation.pattern) !== null;
            }
            if (!isMatch) {
                if (validation.regexValidation.mismatchMessage) return [
                    (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).regexCustomMessage, {
                        message: validation.regexValidation.mismatchMessage
                    }))
                ];
                return [
                    (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).regexDefaultMessage))
                ];
            }
        } catch  {
            return [
                (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $gCFqc.messages).regexInvalidMessage))
            ];
        }
    }
    return [];
};

});
parcelRegister("lV0Co", function(module, exports) {
$parcel$export(module.exports, "RE2JS", () => $ff4f66a262d5170f$export$e46efc5f33420715);
/*!
 * re2js
 * RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
 *
 * @version v1.3.3
 * @author Alexey Vasiliev
 * @homepage https://github.com/le0pard/re2js#readme
 * @repository github:le0pard/re2js
 * @license MIT
 */ //// Parser flags.
class $ff4f66a262d5170f$var$RE2Flags {
    // Fold case during matching (case-insensitive).
    static FOLD_CASE = 0x01;
    // Treat pattern as a literal string instead of a regexp.
    static LITERAL = 0x02;
    // Allow character classes like [^a-z] and [[:space:]] to match newline.
    static CLASS_NL = 0x04;
    // Allow '.' to match newline.
    static DOT_NL = 0x08;
    // Treat ^ and $ as only matching at beginning and end of text, not
    // around embedded newlines.  (Perl's default).
    static ONE_LINE = 0x10;
    // Make repetition operators default to non-greedy.
    static NON_GREEDY = 0x20;
    // allow Perl extensions:
    //   non-capturing parens - (?: )
    //   non-greedy operators - *? +? ?? {}?
    //   flag edits - (?i) (?-i) (?i: )
    //     i - FoldCase
    //     m - !OneLine
    //     s - DotNL
    //     U - NonGreedy
    //   line ends: \A \z
    //   \Q and \E to disable/enable metacharacters
    //   (?P<name>expr) for named captures
    // \C (any byte) is not supported.
    static PERL_X = 0x40;
    // Allow \p{Han}, \P{Han} for Unicode group and negation.
    static UNICODE_GROUPS = 0x80;
    // Regexp END_TEXT was $, not \z.  Internal use only.
    static WAS_DOLLAR = 0x100;
    static MATCH_NL = $ff4f66a262d5170f$var$RE2Flags.CLASS_NL | $ff4f66a262d5170f$var$RE2Flags.DOT_NL;
    // As close to Perl as possible.
    static PERL = $ff4f66a262d5170f$var$RE2Flags.CLASS_NL | $ff4f66a262d5170f$var$RE2Flags.ONE_LINE | $ff4f66a262d5170f$var$RE2Flags.PERL_X | $ff4f66a262d5170f$var$RE2Flags.UNICODE_GROUPS;
    // POSIX syntax.
    static POSIX = 0;
    //// Anchors
    static UNANCHORED = 0;
    static ANCHOR_START = 1;
    static ANCHOR_BOTH = 2;
}
/**
 * Various constants and helper for unicode codepoints.
 */ class $ff4f66a262d5170f$var$Codepoint {
    // codePointAt(0)
    static CODES = new Map([
        [
            '\x07',
            7
        ],
        [
            '\b',
            8
        ],
        [
            '\t',
            9
        ],
        [
            '\n',
            10
        ],
        [
            '\v',
            11
        ],
        [
            '\f',
            12
        ],
        [
            '\r',
            13
        ],
        [
            ' ',
            32
        ],
        [
            '"',
            34
        ],
        [
            '$',
            36
        ],
        [
            '&',
            38
        ],
        [
            '(',
            40
        ],
        [
            ')',
            41
        ],
        [
            '*',
            42
        ],
        [
            '+',
            43
        ],
        [
            '-',
            45
        ],
        [
            '.',
            46
        ],
        [
            '0',
            48
        ],
        [
            '1',
            49
        ],
        [
            '2',
            50
        ],
        [
            '3',
            51
        ],
        [
            '4',
            52
        ],
        [
            '5',
            53
        ],
        [
            '6',
            54
        ],
        [
            '7',
            55
        ],
        [
            '8',
            56
        ],
        [
            '9',
            57
        ],
        [
            ':',
            58
        ],
        [
            '<',
            60
        ],
        [
            '>',
            62
        ],
        [
            '?',
            63
        ],
        [
            'A',
            65
        ],
        [
            'B',
            66
        ],
        [
            'C',
            67
        ],
        [
            'F',
            70
        ],
        [
            'P',
            80
        ],
        [
            'Q',
            81
        ],
        [
            'U',
            85
        ],
        [
            'Z',
            90
        ],
        [
            '[',
            91
        ],
        [
            '\\',
            92
        ],
        [
            ']',
            93
        ],
        [
            '^',
            94
        ],
        [
            '_',
            95
        ],
        [
            'a',
            97
        ],
        [
            'b',
            98
        ],
        [
            'f',
            102
        ],
        [
            'i',
            105
        ],
        [
            'm',
            109
        ],
        [
            'n',
            110
        ],
        [
            'r',
            114
        ],
        [
            's',
            115
        ],
        [
            't',
            116
        ],
        [
            'v',
            118
        ],
        [
            'x',
            120
        ],
        [
            'z',
            122
        ],
        [
            '{',
            123
        ],
        [
            '|',
            124
        ],
        [
            '}',
            125
        ]
    ]);
    // convert unicode codepoint to upper case codepoint
    // return same codepoint, if cannot do it (or codepoint not have upper variation)
    static toUpperCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toUpperCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toLowerCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
    // convert unicode codepoint to lower case codepoint
    // return same codepoint, if cannot do it (or codepoint not have lower variation)
    static toLowerCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toLowerCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toUpperCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
}
class $ff4f66a262d5170f$var$UnicodeRangeTable {
    SIZE = 3;
    constructor(data){
        this.data = data; // A Uint32Array
    }
    // High-performance getters that do NOT allocate memory
    getLo(index) {
        return this.data[index * this.SIZE];
    }
    getHi(index) {
        return this.data[index * this.SIZE + 1];
    }
    getStride(index) {
        return this.data[index * this.SIZE + 2];
    }
    // Convenience getter (slower, for debugging or non-critical paths)
    get(index) {
        const i = index * this.SIZE;
        // Returns [lo, hi, stride]
        return [
            this.data[i],
            this.data[i + 1],
            this.data[i + 2]
        ];
    }
    get length() {
        return this.data.length / this.SIZE;
    }
}
// GENERATED BY tools/scripts/genUnicodeTable.js; DO NOT EDIT.
// yarn node ./tools/scripts/genUnicodeTable.js > src/UnicodeTables.js
class $ff4f66a262d5170f$var$UnicodeTables {
    static CASE_ORBIT = new Map([
        [
            75,
            107
        ],
        [
            107,
            8490
        ],
        [
            8490,
            75
        ],
        [
            83,
            115
        ],
        [
            115,
            383
        ],
        [
            383,
            83
        ],
        [
            181,
            924
        ],
        [
            924,
            956
        ],
        [
            956,
            181
        ],
        [
            197,
            229
        ],
        [
            229,
            8491
        ],
        [
            8491,
            197
        ],
        [
            452,
            453
        ],
        [
            453,
            454
        ],
        [
            454,
            452
        ],
        [
            455,
            456
        ],
        [
            456,
            457
        ],
        [
            457,
            455
        ],
        [
            458,
            459
        ],
        [
            459,
            460
        ],
        [
            460,
            458
        ],
        [
            497,
            498
        ],
        [
            498,
            499
        ],
        [
            499,
            497
        ],
        [
            837,
            921
        ],
        [
            921,
            953
        ],
        [
            953,
            8126
        ],
        [
            8126,
            837
        ],
        [
            914,
            946
        ],
        [
            946,
            976
        ],
        [
            976,
            914
        ],
        [
            917,
            949
        ],
        [
            949,
            1013
        ],
        [
            1013,
            917
        ],
        [
            920,
            952
        ],
        [
            952,
            977
        ],
        [
            977,
            1012
        ],
        [
            1012,
            920
        ],
        [
            922,
            954
        ],
        [
            954,
            1008
        ],
        [
            1008,
            922
        ],
        [
            928,
            960
        ],
        [
            960,
            982
        ],
        [
            982,
            928
        ],
        [
            929,
            961
        ],
        [
            961,
            1009
        ],
        [
            1009,
            929
        ],
        [
            931,
            962
        ],
        [
            962,
            963
        ],
        [
            963,
            931
        ],
        [
            934,
            966
        ],
        [
            966,
            981
        ],
        [
            981,
            934
        ],
        [
            937,
            969
        ],
        [
            969,
            8486
        ],
        [
            8486,
            937
        ],
        [
            1042,
            1074
        ],
        [
            1074,
            7296
        ],
        [
            7296,
            1042
        ],
        [
            1044,
            1076
        ],
        [
            1076,
            7297
        ],
        [
            7297,
            1044
        ],
        [
            1054,
            1086
        ],
        [
            1086,
            7298
        ],
        [
            7298,
            1054
        ],
        [
            1057,
            1089
        ],
        [
            1089,
            7299
        ],
        [
            7299,
            1057
        ],
        [
            1058,
            1090
        ],
        [
            1090,
            7300
        ],
        [
            7300,
            7301
        ],
        [
            7301,
            1058
        ],
        [
            1066,
            1098
        ],
        [
            1098,
            7302
        ],
        [
            7302,
            1066
        ],
        [
            1122,
            1123
        ],
        [
            1123,
            7303
        ],
        [
            7303,
            1122
        ],
        [
            7304,
            42570
        ],
        [
            42570,
            42571
        ],
        [
            42571,
            7304
        ],
        [
            7776,
            7777
        ],
        [
            7777,
            7835
        ],
        [
            7835,
            7776
        ],
        [
            223,
            7838
        ],
        [
            7838,
            223
        ],
        [
            8064,
            8072
        ],
        [
            8072,
            8064
        ],
        [
            8065,
            8073
        ],
        [
            8073,
            8065
        ],
        [
            8066,
            8074
        ],
        [
            8074,
            8066
        ],
        [
            8067,
            8075
        ],
        [
            8075,
            8067
        ],
        [
            8068,
            8076
        ],
        [
            8076,
            8068
        ],
        [
            8069,
            8077
        ],
        [
            8077,
            8069
        ],
        [
            8070,
            8078
        ],
        [
            8078,
            8070
        ],
        [
            8071,
            8079
        ],
        [
            8079,
            8071
        ],
        [
            8080,
            8088
        ],
        [
            8088,
            8080
        ],
        [
            8081,
            8089
        ],
        [
            8089,
            8081
        ],
        [
            8082,
            8090
        ],
        [
            8090,
            8082
        ],
        [
            8083,
            8091
        ],
        [
            8091,
            8083
        ],
        [
            8084,
            8092
        ],
        [
            8092,
            8084
        ],
        [
            8085,
            8093
        ],
        [
            8093,
            8085
        ],
        [
            8086,
            8094
        ],
        [
            8094,
            8086
        ],
        [
            8087,
            8095
        ],
        [
            8095,
            8087
        ],
        [
            8096,
            8104
        ],
        [
            8104,
            8096
        ],
        [
            8097,
            8105
        ],
        [
            8105,
            8097
        ],
        [
            8098,
            8106
        ],
        [
            8106,
            8098
        ],
        [
            8099,
            8107
        ],
        [
            8107,
            8099
        ],
        [
            8100,
            8108
        ],
        [
            8108,
            8100
        ],
        [
            8101,
            8109
        ],
        [
            8109,
            8101
        ],
        [
            8102,
            8110
        ],
        [
            8110,
            8102
        ],
        [
            8103,
            8111
        ],
        [
            8111,
            8103
        ],
        [
            8115,
            8124
        ],
        [
            8124,
            8115
        ],
        [
            8131,
            8140
        ],
        [
            8140,
            8131
        ],
        [
            912,
            8147
        ],
        [
            8147,
            912
        ],
        [
            944,
            8163
        ],
        [
            8163,
            944
        ],
        [
            8179,
            8188
        ],
        [
            8188,
            8179
        ],
        [
            64261,
            64262
        ],
        [
            64262,
            64261
        ],
        [
            66560,
            66600
        ],
        [
            66600,
            66560
        ],
        [
            66561,
            66601
        ],
        [
            66601,
            66561
        ],
        [
            66562,
            66602
        ],
        [
            66602,
            66562
        ],
        [
            66563,
            66603
        ],
        [
            66603,
            66563
        ],
        [
            66564,
            66604
        ],
        [
            66604,
            66564
        ],
        [
            66565,
            66605
        ],
        [
            66605,
            66565
        ],
        [
            66566,
            66606
        ],
        [
            66606,
            66566
        ],
        [
            66567,
            66607
        ],
        [
            66607,
            66567
        ],
        [
            66568,
            66608
        ],
        [
            66608,
            66568
        ],
        [
            66569,
            66609
        ],
        [
            66609,
            66569
        ],
        [
            66570,
            66610
        ],
        [
            66610,
            66570
        ],
        [
            66571,
            66611
        ],
        [
            66611,
            66571
        ],
        [
            66572,
            66612
        ],
        [
            66612,
            66572
        ],
        [
            66573,
            66613
        ],
        [
            66613,
            66573
        ],
        [
            66574,
            66614
        ],
        [
            66614,
            66574
        ],
        [
            66575,
            66615
        ],
        [
            66615,
            66575
        ],
        [
            66576,
            66616
        ],
        [
            66616,
            66576
        ],
        [
            66577,
            66617
        ],
        [
            66617,
            66577
        ],
        [
            66578,
            66618
        ],
        [
            66618,
            66578
        ],
        [
            66579,
            66619
        ],
        [
            66619,
            66579
        ],
        [
            66580,
            66620
        ],
        [
            66620,
            66580
        ],
        [
            66581,
            66621
        ],
        [
            66621,
            66581
        ],
        [
            66582,
            66622
        ],
        [
            66622,
            66582
        ],
        [
            66583,
            66623
        ],
        [
            66623,
            66583
        ],
        [
            66584,
            66624
        ],
        [
            66624,
            66584
        ],
        [
            66585,
            66625
        ],
        [
            66625,
            66585
        ],
        [
            66586,
            66626
        ],
        [
            66626,
            66586
        ],
        [
            66587,
            66627
        ],
        [
            66627,
            66587
        ],
        [
            66588,
            66628
        ],
        [
            66628,
            66588
        ],
        [
            66589,
            66629
        ],
        [
            66629,
            66589
        ],
        [
            66590,
            66630
        ],
        [
            66630,
            66590
        ],
        [
            66591,
            66631
        ],
        [
            66631,
            66591
        ],
        [
            66592,
            66632
        ],
        [
            66632,
            66592
        ],
        [
            66593,
            66633
        ],
        [
            66633,
            66593
        ],
        [
            66594,
            66634
        ],
        [
            66634,
            66594
        ],
        [
            66595,
            66635
        ],
        [
            66635,
            66595
        ],
        [
            66596,
            66636
        ],
        [
            66636,
            66596
        ],
        [
            66597,
            66637
        ],
        [
            66637,
            66597
        ],
        [
            66598,
            66638
        ],
        [
            66638,
            66598
        ],
        [
            66599,
            66639
        ],
        [
            66639,
            66599
        ],
        [
            66736,
            66776
        ],
        [
            66776,
            66736
        ],
        [
            66737,
            66777
        ],
        [
            66777,
            66737
        ],
        [
            66738,
            66778
        ],
        [
            66778,
            66738
        ],
        [
            66739,
            66779
        ],
        [
            66779,
            66739
        ],
        [
            66740,
            66780
        ],
        [
            66780,
            66740
        ],
        [
            66741,
            66781
        ],
        [
            66781,
            66741
        ],
        [
            66742,
            66782
        ],
        [
            66782,
            66742
        ],
        [
            66743,
            66783
        ],
        [
            66783,
            66743
        ],
        [
            66744,
            66784
        ],
        [
            66784,
            66744
        ],
        [
            66745,
            66785
        ],
        [
            66785,
            66745
        ],
        [
            66746,
            66786
        ],
        [
            66786,
            66746
        ],
        [
            66747,
            66787
        ],
        [
            66787,
            66747
        ],
        [
            66748,
            66788
        ],
        [
            66788,
            66748
        ],
        [
            66749,
            66789
        ],
        [
            66789,
            66749
        ],
        [
            66750,
            66790
        ],
        [
            66790,
            66750
        ],
        [
            66751,
            66791
        ],
        [
            66791,
            66751
        ],
        [
            66752,
            66792
        ],
        [
            66792,
            66752
        ],
        [
            66753,
            66793
        ],
        [
            66793,
            66753
        ],
        [
            66754,
            66794
        ],
        [
            66794,
            66754
        ],
        [
            66755,
            66795
        ],
        [
            66795,
            66755
        ],
        [
            66756,
            66796
        ],
        [
            66796,
            66756
        ],
        [
            66757,
            66797
        ],
        [
            66797,
            66757
        ],
        [
            66758,
            66798
        ],
        [
            66798,
            66758
        ],
        [
            66759,
            66799
        ],
        [
            66799,
            66759
        ],
        [
            66760,
            66800
        ],
        [
            66800,
            66760
        ],
        [
            66761,
            66801
        ],
        [
            66801,
            66761
        ],
        [
            66762,
            66802
        ],
        [
            66802,
            66762
        ],
        [
            66763,
            66803
        ],
        [
            66803,
            66763
        ],
        [
            66764,
            66804
        ],
        [
            66804,
            66764
        ],
        [
            66765,
            66805
        ],
        [
            66805,
            66765
        ],
        [
            66766,
            66806
        ],
        [
            66806,
            66766
        ],
        [
            66767,
            66807
        ],
        [
            66807,
            66767
        ],
        [
            66768,
            66808
        ],
        [
            66808,
            66768
        ],
        [
            66769,
            66809
        ],
        [
            66809,
            66769
        ],
        [
            66770,
            66810
        ],
        [
            66810,
            66770
        ],
        [
            66771,
            66811
        ],
        [
            66811,
            66771
        ],
        [
            66928,
            66967
        ],
        [
            66967,
            66928
        ],
        [
            66929,
            66968
        ],
        [
            66968,
            66929
        ],
        [
            66930,
            66969
        ],
        [
            66969,
            66930
        ],
        [
            66931,
            66970
        ],
        [
            66970,
            66931
        ],
        [
            66932,
            66971
        ],
        [
            66971,
            66932
        ],
        [
            66933,
            66972
        ],
        [
            66972,
            66933
        ],
        [
            66934,
            66973
        ],
        [
            66973,
            66934
        ],
        [
            66935,
            66974
        ],
        [
            66974,
            66935
        ],
        [
            66936,
            66975
        ],
        [
            66975,
            66936
        ],
        [
            66937,
            66976
        ],
        [
            66976,
            66937
        ],
        [
            66938,
            66977
        ],
        [
            66977,
            66938
        ],
        [
            66940,
            66979
        ],
        [
            66979,
            66940
        ],
        [
            66941,
            66980
        ],
        [
            66980,
            66941
        ],
        [
            66942,
            66981
        ],
        [
            66981,
            66942
        ],
        [
            66943,
            66982
        ],
        [
            66982,
            66943
        ],
        [
            66944,
            66983
        ],
        [
            66983,
            66944
        ],
        [
            66945,
            66984
        ],
        [
            66984,
            66945
        ],
        [
            66946,
            66985
        ],
        [
            66985,
            66946
        ],
        [
            66947,
            66986
        ],
        [
            66986,
            66947
        ],
        [
            66948,
            66987
        ],
        [
            66987,
            66948
        ],
        [
            66949,
            66988
        ],
        [
            66988,
            66949
        ],
        [
            66950,
            66989
        ],
        [
            66989,
            66950
        ],
        [
            66951,
            66990
        ],
        [
            66990,
            66951
        ],
        [
            66952,
            66991
        ],
        [
            66991,
            66952
        ],
        [
            66953,
            66992
        ],
        [
            66992,
            66953
        ],
        [
            66954,
            66993
        ],
        [
            66993,
            66954
        ],
        [
            66956,
            66995
        ],
        [
            66995,
            66956
        ],
        [
            66957,
            66996
        ],
        [
            66996,
            66957
        ],
        [
            66958,
            66997
        ],
        [
            66997,
            66958
        ],
        [
            66959,
            66998
        ],
        [
            66998,
            66959
        ],
        [
            66960,
            66999
        ],
        [
            66999,
            66960
        ],
        [
            66961,
            67000
        ],
        [
            67000,
            66961
        ],
        [
            66962,
            67001
        ],
        [
            67001,
            66962
        ],
        [
            66964,
            67003
        ],
        [
            67003,
            66964
        ],
        [
            66965,
            67004
        ],
        [
            67004,
            66965
        ],
        [
            68736,
            68800
        ],
        [
            68800,
            68736
        ],
        [
            68737,
            68801
        ],
        [
            68801,
            68737
        ],
        [
            68738,
            68802
        ],
        [
            68802,
            68738
        ],
        [
            68739,
            68803
        ],
        [
            68803,
            68739
        ],
        [
            68740,
            68804
        ],
        [
            68804,
            68740
        ],
        [
            68741,
            68805
        ],
        [
            68805,
            68741
        ],
        [
            68742,
            68806
        ],
        [
            68806,
            68742
        ],
        [
            68743,
            68807
        ],
        [
            68807,
            68743
        ],
        [
            68744,
            68808
        ],
        [
            68808,
            68744
        ],
        [
            68745,
            68809
        ],
        [
            68809,
            68745
        ],
        [
            68746,
            68810
        ],
        [
            68810,
            68746
        ],
        [
            68747,
            68811
        ],
        [
            68811,
            68747
        ],
        [
            68748,
            68812
        ],
        [
            68812,
            68748
        ],
        [
            68749,
            68813
        ],
        [
            68813,
            68749
        ],
        [
            68750,
            68814
        ],
        [
            68814,
            68750
        ],
        [
            68751,
            68815
        ],
        [
            68815,
            68751
        ],
        [
            68752,
            68816
        ],
        [
            68816,
            68752
        ],
        [
            68753,
            68817
        ],
        [
            68817,
            68753
        ],
        [
            68754,
            68818
        ],
        [
            68818,
            68754
        ],
        [
            68755,
            68819
        ],
        [
            68819,
            68755
        ],
        [
            68756,
            68820
        ],
        [
            68820,
            68756
        ],
        [
            68757,
            68821
        ],
        [
            68821,
            68757
        ],
        [
            68758,
            68822
        ],
        [
            68822,
            68758
        ],
        [
            68759,
            68823
        ],
        [
            68823,
            68759
        ],
        [
            68760,
            68824
        ],
        [
            68824,
            68760
        ],
        [
            68761,
            68825
        ],
        [
            68825,
            68761
        ],
        [
            68762,
            68826
        ],
        [
            68826,
            68762
        ],
        [
            68763,
            68827
        ],
        [
            68827,
            68763
        ],
        [
            68764,
            68828
        ],
        [
            68828,
            68764
        ],
        [
            68765,
            68829
        ],
        [
            68829,
            68765
        ],
        [
            68766,
            68830
        ],
        [
            68830,
            68766
        ],
        [
            68767,
            68831
        ],
        [
            68831,
            68767
        ],
        [
            68768,
            68832
        ],
        [
            68832,
            68768
        ],
        [
            68769,
            68833
        ],
        [
            68833,
            68769
        ],
        [
            68770,
            68834
        ],
        [
            68834,
            68770
        ],
        [
            68771,
            68835
        ],
        [
            68835,
            68771
        ],
        [
            68772,
            68836
        ],
        [
            68836,
            68772
        ],
        [
            68773,
            68837
        ],
        [
            68837,
            68773
        ],
        [
            68774,
            68838
        ],
        [
            68838,
            68774
        ],
        [
            68775,
            68839
        ],
        [
            68839,
            68775
        ],
        [
            68776,
            68840
        ],
        [
            68840,
            68776
        ],
        [
            68777,
            68841
        ],
        [
            68841,
            68777
        ],
        [
            68778,
            68842
        ],
        [
            68842,
            68778
        ],
        [
            68779,
            68843
        ],
        [
            68843,
            68779
        ],
        [
            68780,
            68844
        ],
        [
            68844,
            68780
        ],
        [
            68781,
            68845
        ],
        [
            68845,
            68781
        ],
        [
            68782,
            68846
        ],
        [
            68846,
            68782
        ],
        [
            68783,
            68847
        ],
        [
            68847,
            68783
        ],
        [
            68784,
            68848
        ],
        [
            68848,
            68784
        ],
        [
            68785,
            68849
        ],
        [
            68849,
            68785
        ],
        [
            68786,
            68850
        ],
        [
            68850,
            68786
        ],
        [
            68944,
            68976
        ],
        [
            68976,
            68944
        ],
        [
            68945,
            68977
        ],
        [
            68977,
            68945
        ],
        [
            68946,
            68978
        ],
        [
            68978,
            68946
        ],
        [
            68947,
            68979
        ],
        [
            68979,
            68947
        ],
        [
            68948,
            68980
        ],
        [
            68980,
            68948
        ],
        [
            68949,
            68981
        ],
        [
            68981,
            68949
        ],
        [
            68950,
            68982
        ],
        [
            68982,
            68950
        ],
        [
            68951,
            68983
        ],
        [
            68983,
            68951
        ],
        [
            68952,
            68984
        ],
        [
            68984,
            68952
        ],
        [
            68953,
            68985
        ],
        [
            68985,
            68953
        ],
        [
            68954,
            68986
        ],
        [
            68986,
            68954
        ],
        [
            68955,
            68987
        ],
        [
            68987,
            68955
        ],
        [
            68956,
            68988
        ],
        [
            68988,
            68956
        ],
        [
            68957,
            68989
        ],
        [
            68989,
            68957
        ],
        [
            68958,
            68990
        ],
        [
            68990,
            68958
        ],
        [
            68959,
            68991
        ],
        [
            68991,
            68959
        ],
        [
            68960,
            68992
        ],
        [
            68992,
            68960
        ],
        [
            68961,
            68993
        ],
        [
            68993,
            68961
        ],
        [
            68962,
            68994
        ],
        [
            68994,
            68962
        ],
        [
            68963,
            68995
        ],
        [
            68995,
            68963
        ],
        [
            68964,
            68996
        ],
        [
            68996,
            68964
        ],
        [
            68965,
            68997
        ],
        [
            68997,
            68965
        ],
        [
            71840,
            71872
        ],
        [
            71872,
            71840
        ],
        [
            71841,
            71873
        ],
        [
            71873,
            71841
        ],
        [
            71842,
            71874
        ],
        [
            71874,
            71842
        ],
        [
            71843,
            71875
        ],
        [
            71875,
            71843
        ],
        [
            71844,
            71876
        ],
        [
            71876,
            71844
        ],
        [
            71845,
            71877
        ],
        [
            71877,
            71845
        ],
        [
            71846,
            71878
        ],
        [
            71878,
            71846
        ],
        [
            71847,
            71879
        ],
        [
            71879,
            71847
        ],
        [
            71848,
            71880
        ],
        [
            71880,
            71848
        ],
        [
            71849,
            71881
        ],
        [
            71881,
            71849
        ],
        [
            71850,
            71882
        ],
        [
            71882,
            71850
        ],
        [
            71851,
            71883
        ],
        [
            71883,
            71851
        ],
        [
            71852,
            71884
        ],
        [
            71884,
            71852
        ],
        [
            71853,
            71885
        ],
        [
            71885,
            71853
        ],
        [
            71854,
            71886
        ],
        [
            71886,
            71854
        ],
        [
            71855,
            71887
        ],
        [
            71887,
            71855
        ],
        [
            71856,
            71888
        ],
        [
            71888,
            71856
        ],
        [
            71857,
            71889
        ],
        [
            71889,
            71857
        ],
        [
            71858,
            71890
        ],
        [
            71890,
            71858
        ],
        [
            71859,
            71891
        ],
        [
            71891,
            71859
        ],
        [
            71860,
            71892
        ],
        [
            71892,
            71860
        ],
        [
            71861,
            71893
        ],
        [
            71893,
            71861
        ],
        [
            71862,
            71894
        ],
        [
            71894,
            71862
        ],
        [
            71863,
            71895
        ],
        [
            71895,
            71863
        ],
        [
            71864,
            71896
        ],
        [
            71896,
            71864
        ],
        [
            71865,
            71897
        ],
        [
            71897,
            71865
        ],
        [
            71866,
            71898
        ],
        [
            71898,
            71866
        ],
        [
            71867,
            71899
        ],
        [
            71899,
            71867
        ],
        [
            71868,
            71900
        ],
        [
            71900,
            71868
        ],
        [
            71869,
            71901
        ],
        [
            71901,
            71869
        ],
        [
            71870,
            71902
        ],
        [
            71902,
            71870
        ],
        [
            71871,
            71903
        ],
        [
            71903,
            71871
        ],
        [
            93760,
            93792
        ],
        [
            93792,
            93760
        ],
        [
            93761,
            93793
        ],
        [
            93793,
            93761
        ],
        [
            93762,
            93794
        ],
        [
            93794,
            93762
        ],
        [
            93763,
            93795
        ],
        [
            93795,
            93763
        ],
        [
            93764,
            93796
        ],
        [
            93796,
            93764
        ],
        [
            93765,
            93797
        ],
        [
            93797,
            93765
        ],
        [
            93766,
            93798
        ],
        [
            93798,
            93766
        ],
        [
            93767,
            93799
        ],
        [
            93799,
            93767
        ],
        [
            93768,
            93800
        ],
        [
            93800,
            93768
        ],
        [
            93769,
            93801
        ],
        [
            93801,
            93769
        ],
        [
            93770,
            93802
        ],
        [
            93802,
            93770
        ],
        [
            93771,
            93803
        ],
        [
            93803,
            93771
        ],
        [
            93772,
            93804
        ],
        [
            93804,
            93772
        ],
        [
            93773,
            93805
        ],
        [
            93805,
            93773
        ],
        [
            93774,
            93806
        ],
        [
            93806,
            93774
        ],
        [
            93775,
            93807
        ],
        [
            93807,
            93775
        ],
        [
            93776,
            93808
        ],
        [
            93808,
            93776
        ],
        [
            93777,
            93809
        ],
        [
            93809,
            93777
        ],
        [
            93778,
            93810
        ],
        [
            93810,
            93778
        ],
        [
            93779,
            93811
        ],
        [
            93811,
            93779
        ],
        [
            93780,
            93812
        ],
        [
            93812,
            93780
        ],
        [
            93781,
            93813
        ],
        [
            93813,
            93781
        ],
        [
            93782,
            93814
        ],
        [
            93814,
            93782
        ],
        [
            93783,
            93815
        ],
        [
            93815,
            93783
        ],
        [
            93784,
            93816
        ],
        [
            93816,
            93784
        ],
        [
            93785,
            93817
        ],
        [
            93817,
            93785
        ],
        [
            93786,
            93818
        ],
        [
            93818,
            93786
        ],
        [
            93787,
            93819
        ],
        [
            93819,
            93787
        ],
        [
            93788,
            93820
        ],
        [
            93820,
            93788
        ],
        [
            93789,
            93821
        ],
        [
            93821,
            93789
        ],
        [
            93790,
            93822
        ],
        [
            93822,
            93790
        ],
        [
            93791,
            93823
        ],
        [
            93823,
            93791
        ],
        [
            125184,
            125218
        ],
        [
            125218,
            125184
        ],
        [
            125185,
            125219
        ],
        [
            125219,
            125185
        ],
        [
            125186,
            125220
        ],
        [
            125220,
            125186
        ],
        [
            125187,
            125221
        ],
        [
            125221,
            125187
        ],
        [
            125188,
            125222
        ],
        [
            125222,
            125188
        ],
        [
            125189,
            125223
        ],
        [
            125223,
            125189
        ],
        [
            125190,
            125224
        ],
        [
            125224,
            125190
        ],
        [
            125191,
            125225
        ],
        [
            125225,
            125191
        ],
        [
            125192,
            125226
        ],
        [
            125226,
            125192
        ],
        [
            125193,
            125227
        ],
        [
            125227,
            125193
        ],
        [
            125194,
            125228
        ],
        [
            125228,
            125194
        ],
        [
            125195,
            125229
        ],
        [
            125229,
            125195
        ],
        [
            125196,
            125230
        ],
        [
            125230,
            125196
        ],
        [
            125197,
            125231
        ],
        [
            125231,
            125197
        ],
        [
            125198,
            125232
        ],
        [
            125232,
            125198
        ],
        [
            125199,
            125233
        ],
        [
            125233,
            125199
        ],
        [
            125200,
            125234
        ],
        [
            125234,
            125200
        ],
        [
            125201,
            125235
        ],
        [
            125235,
            125201
        ],
        [
            125202,
            125236
        ],
        [
            125236,
            125202
        ],
        [
            125203,
            125237
        ],
        [
            125237,
            125203
        ],
        [
            125204,
            125238
        ],
        [
            125238,
            125204
        ],
        [
            125205,
            125239
        ],
        [
            125239,
            125205
        ],
        [
            125206,
            125240
        ],
        [
            125240,
            125206
        ],
        [
            125207,
            125241
        ],
        [
            125241,
            125207
        ],
        [
            125208,
            125242
        ],
        [
            125242,
            125208
        ],
        [
            125209,
            125243
        ],
        [
            125243,
            125209
        ],
        [
            125210,
            125244
        ],
        [
            125244,
            125210
        ],
        [
            125211,
            125245
        ],
        [
            125245,
            125211
        ],
        [
            125212,
            125246
        ],
        [
            125246,
            125212
        ],
        [
            125213,
            125247
        ],
        [
            125247,
            125213
        ],
        [
            125214,
            125248
        ],
        [
            125248,
            125214
        ],
        [
            125215,
            125249
        ],
        [
            125249,
            125215
        ],
        [
            125216,
            125250
        ],
        [
            125250,
            125216
        ],
        [
            125217,
            125251
        ],
        [
            125251,
            125217
        ]
    ]);
    static C = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        0,
        31,
        1,
        127,
        159,
        1,
        173,
        888,
        715,
        889,
        896,
        7,
        897,
        899,
        1,
        907,
        909,
        2,
        930,
        1328,
        398,
        1367,
        1368,
        1,
        1419,
        1420,
        1,
        1424,
        1480,
        56,
        1481,
        1487,
        1,
        1515,
        1518,
        1,
        1525,
        1541,
        1,
        1564,
        1757,
        193,
        1806,
        1807,
        1,
        1867,
        1868,
        1,
        1970,
        1983,
        1,
        2043,
        2044,
        1,
        2094,
        2095,
        1,
        2111,
        2140,
        29,
        2141,
        2143,
        2,
        2155,
        2159,
        1,
        2191,
        2198,
        1,
        2274,
        2436,
        162,
        2445,
        2446,
        1,
        2449,
        2450,
        1,
        2473,
        2481,
        8,
        2483,
        2485,
        1,
        2490,
        2491,
        1,
        2501,
        2502,
        1,
        2505,
        2506,
        1,
        2511,
        2518,
        1,
        2520,
        2523,
        1,
        2526,
        2532,
        6,
        2533,
        2559,
        26,
        2560,
        2564,
        4,
        2571,
        2574,
        1,
        2577,
        2578,
        1,
        2601,
        2609,
        8,
        2612,
        2618,
        3,
        2619,
        2621,
        2,
        2627,
        2630,
        1,
        2633,
        2634,
        1,
        2638,
        2640,
        1,
        2642,
        2648,
        1,
        2653,
        2655,
        2,
        2656,
        2661,
        1,
        2679,
        2688,
        1,
        2692,
        2702,
        10,
        2706,
        2729,
        23,
        2737,
        2740,
        3,
        2746,
        2747,
        1,
        2758,
        2766,
        4,
        2767,
        2769,
        2,
        2770,
        2783,
        1,
        2788,
        2789,
        1,
        2802,
        2808,
        1,
        2816,
        2820,
        4,
        2829,
        2830,
        1,
        2833,
        2834,
        1,
        2857,
        2865,
        8,
        2868,
        2874,
        6,
        2875,
        2885,
        10,
        2886,
        2889,
        3,
        2890,
        2894,
        4,
        2895,
        2900,
        1,
        2904,
        2907,
        1,
        2910,
        2916,
        6,
        2917,
        2936,
        19,
        2937,
        2945,
        1,
        2948,
        2955,
        7,
        2956,
        2957,
        1,
        2961,
        2966,
        5,
        2967,
        2968,
        1,
        2971,
        2973,
        2,
        2976,
        2978,
        1,
        2981,
        2983,
        1,
        2987,
        2989,
        1,
        3002,
        3005,
        1,
        3011,
        3013,
        1,
        3017,
        3022,
        5,
        3023,
        3025,
        2,
        3026,
        3030,
        1,
        3032,
        3045,
        1,
        3067,
        3071,
        1,
        3085,
        3089,
        4,
        3113,
        3130,
        17,
        3131,
        3141,
        10,
        3145,
        3150,
        5,
        3151,
        3156,
        1,
        3159,
        3163,
        4,
        3164,
        3166,
        2,
        3167,
        3172,
        5,
        3173,
        3184,
        11,
        3185,
        3190,
        1,
        3213,
        3217,
        4,
        3241,
        3252,
        11,
        3258,
        3259,
        1,
        3269,
        3273,
        4,
        3278,
        3284,
        1,
        3287,
        3292,
        1,
        3295,
        3300,
        5,
        3301,
        3312,
        11,
        3316,
        3327,
        1,
        3341,
        3345,
        4,
        3397,
        3401,
        4,
        3408,
        3411,
        1,
        3428,
        3429,
        1,
        3456,
        3460,
        4,
        3479,
        3481,
        1,
        3506,
        3516,
        10,
        3518,
        3519,
        1,
        3527,
        3529,
        1,
        3531,
        3534,
        1,
        3541,
        3543,
        2,
        3552,
        3557,
        1,
        3568,
        3569,
        1,
        3573,
        3584,
        1,
        3643,
        3646,
        1,
        3676,
        3712,
        1,
        3715,
        3717,
        2,
        3723,
        3748,
        25,
        3750,
        3774,
        24,
        3775,
        3781,
        6,
        3783,
        3791,
        8,
        3802,
        3803,
        1,
        3808,
        3839,
        1,
        3912,
        3949,
        37,
        3950,
        3952,
        1,
        3992,
        4029,
        37,
        4045,
        4059,
        14,
        4060,
        4095,
        1,
        4294,
        4296,
        2,
        4297,
        4300,
        1,
        4302,
        4303,
        1,
        4681,
        4686,
        5,
        4687,
        4695,
        8,
        4697,
        4702,
        5,
        4703,
        4745,
        42,
        4750,
        4751,
        1,
        4785,
        4790,
        5,
        4791,
        4799,
        8,
        4801,
        4806,
        5,
        4807,
        4823,
        16,
        4881,
        4886,
        5,
        4887,
        4955,
        68,
        4956,
        4989,
        33,
        4990,
        4991,
        1,
        5018,
        5023,
        1,
        5110,
        5111,
        1,
        5118,
        5119,
        1,
        5789,
        5791,
        1,
        5881,
        5887,
        1,
        5910,
        5918,
        1,
        5943,
        5951,
        1,
        5972,
        5983,
        1,
        5997,
        6001,
        4,
        6004,
        6015,
        1,
        6110,
        6111,
        1,
        6122,
        6127,
        1,
        6138,
        6143,
        1,
        6158,
        6170,
        12,
        6171,
        6175,
        1,
        6265,
        6271,
        1,
        6315,
        6319,
        1,
        6390,
        6399,
        1,
        6431,
        6444,
        13,
        6445,
        6447,
        1,
        6460,
        6463,
        1,
        6465,
        6467,
        1,
        6510,
        6511,
        1,
        6517,
        6527,
        1,
        6572,
        6575,
        1,
        6602,
        6607,
        1,
        6619,
        6621,
        1,
        6684,
        6685,
        1,
        6751,
        6781,
        30,
        6782,
        6794,
        12,
        6795,
        6799,
        1,
        6810,
        6815,
        1,
        6830,
        6831,
        1,
        6863,
        6911,
        1,
        6989,
        7156,
        167,
        7157,
        7163,
        1,
        7224,
        7226,
        1,
        7242,
        7244,
        1,
        7307,
        7311,
        1,
        7355,
        7356,
        1,
        7368,
        7375,
        1,
        7419,
        7423,
        1,
        7958,
        7959,
        1,
        7966,
        7967,
        1,
        8006,
        8007,
        1,
        8014,
        8015,
        1,
        8024,
        8030,
        2,
        8062,
        8063,
        1,
        8117,
        8133,
        16,
        8148,
        8149,
        1,
        8156,
        8176,
        20,
        8177,
        8181,
        4,
        8191,
        8203,
        12,
        8204,
        8207,
        1,
        8234,
        8238,
        1,
        8288,
        8303,
        1,
        8306,
        8307,
        1,
        8335,
        8349,
        14,
        8350,
        8351,
        1,
        8385,
        8399,
        1,
        8433,
        8447,
        1,
        8588,
        8591,
        1,
        9258,
        9279,
        1,
        9291,
        9311,
        1,
        11124,
        11125,
        1,
        11158,
        11508,
        350,
        11509,
        11512,
        1,
        11558,
        11560,
        2,
        11561,
        11564,
        1,
        11566,
        11567,
        1,
        11624,
        11630,
        1,
        11633,
        11646,
        1,
        11671,
        11679,
        1,
        11687,
        11743,
        8,
        11870,
        11903,
        1,
        11930,
        12020,
        90,
        12021,
        12031,
        1,
        12246,
        12271,
        1,
        12352,
        12439,
        87,
        12440,
        12544,
        104,
        12545,
        12548,
        1,
        12592,
        12687,
        95,
        12774,
        12782,
        1,
        12831,
        42125,
        29294,
        42126,
        42127,
        1,
        42183,
        42191,
        1,
        42540,
        42559,
        1,
        42744,
        42751,
        1,
        42958,
        42959,
        1,
        42962,
        42964,
        2,
        42973,
        42993,
        1,
        43053,
        43055,
        1,
        43066,
        43071,
        1,
        43128,
        43135,
        1,
        43206,
        43213,
        1,
        43226,
        43231,
        1,
        43348,
        43358,
        1,
        43389,
        43391,
        1,
        43470,
        43482,
        12,
        43483,
        43485,
        1,
        43519,
        43575,
        56,
        43576,
        43583,
        1,
        43598,
        43599,
        1,
        43610,
        43611,
        1,
        43715,
        43738,
        1,
        43767,
        43776,
        1,
        43783,
        43784,
        1,
        43791,
        43792,
        1,
        43799,
        43807,
        1,
        43815,
        43823,
        8,
        43884,
        43887,
        1,
        44014,
        44015,
        1,
        44026,
        44031,
        1,
        55204,
        55215,
        1,
        55239,
        55242,
        1,
        55292,
        63743,
        1,
        64110,
        64111,
        1,
        64218,
        64255,
        1,
        64263,
        64274,
        1,
        64280,
        64284,
        1,
        64311,
        64317,
        6,
        64319,
        64325,
        3,
        64451,
        64466,
        1,
        64912,
        64913,
        1,
        64968,
        64974,
        1,
        64976,
        65007,
        1,
        65050,
        65055,
        1,
        65107,
        65127,
        20,
        65132,
        65135,
        1,
        65141,
        65277,
        136,
        65278,
        65280,
        1,
        65471,
        65473,
        1,
        65480,
        65481,
        1,
        65488,
        65489,
        1,
        65496,
        65497,
        1,
        65501,
        65503,
        1,
        65511,
        65519,
        8,
        65520,
        65531,
        1,
        65534,
        65535,
        1,
        65548,
        65575,
        27,
        65595,
        65598,
        3,
        65614,
        65615,
        1,
        65630,
        65663,
        1,
        65787,
        65791,
        1,
        65795,
        65798,
        1,
        65844,
        65846,
        1,
        65935,
        65949,
        14,
        65950,
        65951,
        1,
        65953,
        65999,
        1,
        66046,
        66175,
        1,
        66205,
        66207,
        1,
        66257,
        66271,
        1,
        66300,
        66303,
        1,
        66340,
        66348,
        1,
        66379,
        66383,
        1,
        66427,
        66431,
        1,
        66462,
        66500,
        38,
        66501,
        66503,
        1,
        66518,
        66559,
        1,
        66718,
        66719,
        1,
        66730,
        66735,
        1,
        66772,
        66775,
        1,
        66812,
        66815,
        1,
        66856,
        66863,
        1,
        66916,
        66926,
        1,
        66939,
        66955,
        16,
        66963,
        66966,
        3,
        66978,
        66994,
        16,
        67002,
        67005,
        3,
        67006,
        67007,
        1,
        67060,
        67071,
        1,
        67383,
        67391,
        1,
        67414,
        67423,
        1,
        67432,
        67455,
        1,
        67462,
        67505,
        43,
        67515,
        67583,
        1,
        67590,
        67591,
        1,
        67593,
        67638,
        45,
        67641,
        67643,
        1,
        67645,
        67646,
        1,
        67670,
        67743,
        73,
        67744,
        67750,
        1,
        67760,
        67807,
        1,
        67827,
        67830,
        3,
        67831,
        67834,
        1,
        67868,
        67870,
        1,
        67898,
        67902,
        1,
        67904,
        67967,
        1,
        68024,
        68027,
        1,
        68048,
        68049,
        1,
        68100,
        68103,
        3,
        68104,
        68107,
        1,
        68116,
        68120,
        4,
        68150,
        68151,
        1,
        68155,
        68158,
        1,
        68169,
        68175,
        1,
        68185,
        68191,
        1,
        68256,
        68287,
        1,
        68327,
        68330,
        1,
        68343,
        68351,
        1,
        68406,
        68408,
        1,
        68438,
        68439,
        1,
        68467,
        68471,
        1,
        68498,
        68504,
        1,
        68509,
        68520,
        1,
        68528,
        68607,
        1,
        68681,
        68735,
        1,
        68787,
        68799,
        1,
        68851,
        68857,
        1,
        68904,
        68911,
        1,
        68922,
        68927,
        1,
        68966,
        68968,
        1,
        68998,
        69005,
        1,
        69008,
        69215,
        1,
        69247,
        69290,
        43,
        69294,
        69295,
        1,
        69298,
        69313,
        1,
        69317,
        69371,
        1,
        69416,
        69423,
        1,
        69466,
        69487,
        1,
        69514,
        69551,
        1,
        69580,
        69599,
        1,
        69623,
        69631,
        1,
        69710,
        69713,
        1,
        69750,
        69758,
        1,
        69821,
        69827,
        6,
        69828,
        69839,
        1,
        69865,
        69871,
        1,
        69882,
        69887,
        1,
        69941,
        69960,
        19,
        69961,
        69967,
        1,
        70007,
        70015,
        1,
        70112,
        70133,
        21,
        70134,
        70143,
        1,
        70162,
        70210,
        48,
        70211,
        70271,
        1,
        70279,
        70281,
        2,
        70286,
        70302,
        16,
        70314,
        70319,
        1,
        70379,
        70383,
        1,
        70394,
        70399,
        1,
        70404,
        70413,
        9,
        70414,
        70417,
        3,
        70418,
        70441,
        23,
        70449,
        70452,
        3,
        70458,
        70469,
        11,
        70470,
        70473,
        3,
        70474,
        70478,
        4,
        70479,
        70481,
        2,
        70482,
        70486,
        1,
        70488,
        70492,
        1,
        70500,
        70501,
        1,
        70509,
        70511,
        1,
        70517,
        70527,
        1,
        70538,
        70540,
        2,
        70541,
        70543,
        2,
        70582,
        70593,
        11,
        70595,
        70596,
        1,
        70598,
        70603,
        5,
        70614,
        70617,
        3,
        70618,
        70624,
        1,
        70627,
        70655,
        1,
        70748,
        70754,
        6,
        70755,
        70783,
        1,
        70856,
        70863,
        1,
        70874,
        71039,
        1,
        71094,
        71095,
        1,
        71134,
        71167,
        1,
        71237,
        71247,
        1,
        71258,
        71263,
        1,
        71277,
        71295,
        1,
        71354,
        71359,
        1,
        71370,
        71375,
        1,
        71396,
        71423,
        1,
        71451,
        71452,
        1,
        71468,
        71471,
        1,
        71495,
        71679,
        1,
        71740,
        71839,
        1,
        71923,
        71934,
        1,
        71943,
        71944,
        1,
        71946,
        71947,
        1,
        71956,
        71959,
        3,
        71990,
        71993,
        3,
        71994,
        72007,
        13,
        72008,
        72015,
        1,
        72026,
        72095,
        1,
        72104,
        72105,
        1,
        72152,
        72153,
        1,
        72165,
        72191,
        1,
        72264,
        72271,
        1,
        72355,
        72367,
        1,
        72441,
        72447,
        1,
        72458,
        72639,
        1,
        72674,
        72687,
        1,
        72698,
        72703,
        1,
        72713,
        72759,
        46,
        72774,
        72783,
        1,
        72813,
        72815,
        1,
        72848,
        72849,
        1,
        72872,
        72887,
        15,
        72888,
        72959,
        1,
        72967,
        72970,
        3,
        73015,
        73017,
        1,
        73019,
        73022,
        3,
        73032,
        73039,
        1,
        73050,
        73055,
        1,
        73062,
        73065,
        3,
        73103,
        73106,
        3,
        73113,
        73119,
        1,
        73130,
        73439,
        1,
        73465,
        73471,
        1,
        73489,
        73531,
        42,
        73532,
        73533,
        1,
        73563,
        73647,
        1,
        73649,
        73663,
        1,
        73714,
        73726,
        1,
        74650,
        74751,
        1,
        74863,
        74869,
        6,
        74870,
        74879,
        1,
        75076,
        77711,
        1,
        77811,
        77823,
        1,
        78896,
        78911,
        1,
        78934,
        78943,
        1,
        82939,
        82943,
        1,
        83527,
        90367,
        1,
        90426,
        92159,
        1,
        92729,
        92735,
        1,
        92767,
        92778,
        11,
        92779,
        92781,
        1,
        92863,
        92874,
        11,
        92875,
        92879,
        1,
        92910,
        92911,
        1,
        92918,
        92927,
        1,
        92998,
        93007,
        1,
        93018,
        93026,
        8,
        93048,
        93052,
        1,
        93072,
        93503,
        1,
        93562,
        93759,
        1,
        93851,
        93951,
        1,
        94027,
        94030,
        1,
        94088,
        94094,
        1,
        94112,
        94175,
        1,
        94181,
        94191,
        1,
        94194,
        94207,
        1,
        100344,
        100351,
        1,
        101590,
        101630,
        1,
        101641,
        110575,
        1,
        110580,
        110588,
        8,
        110591,
        110883,
        292,
        110884,
        110897,
        1,
        110899,
        110927,
        1,
        110931,
        110932,
        1,
        110934,
        110947,
        1,
        110952,
        110959,
        1,
        111356,
        113663,
        1,
        113771,
        113775,
        1,
        113789,
        113791,
        1,
        113801,
        113807,
        1,
        113818,
        113819,
        1,
        113824,
        117759,
        1,
        118010,
        118015,
        1,
        118452,
        118527,
        1,
        118574,
        118575,
        1,
        118599,
        118607,
        1,
        118724,
        118783,
        1,
        119030,
        119039,
        1,
        119079,
        119080,
        1,
        119155,
        119162,
        1,
        119275,
        119295,
        1,
        119366,
        119487,
        1,
        119508,
        119519,
        1,
        119540,
        119551,
        1,
        119639,
        119647,
        1,
        119673,
        119807,
        1,
        119893,
        119965,
        72,
        119968,
        119969,
        1,
        119971,
        119972,
        1,
        119975,
        119976,
        1,
        119981,
        119994,
        13,
        119996,
        120004,
        8,
        120070,
        120075,
        5,
        120076,
        120085,
        9,
        120093,
        120122,
        29,
        120127,
        120133,
        6,
        120135,
        120137,
        1,
        120145,
        120486,
        341,
        120487,
        120780,
        293,
        120781,
        121484,
        703,
        121485,
        121498,
        1,
        121504,
        121520,
        16,
        121521,
        122623,
        1,
        122655,
        122660,
        1,
        122667,
        122879,
        1,
        122887,
        122905,
        18,
        122906,
        122914,
        8,
        122917,
        122923,
        6,
        122924,
        122927,
        1,
        122990,
        123022,
        1,
        123024,
        123135,
        1,
        123181,
        123183,
        1,
        123198,
        123199,
        1,
        123210,
        123213,
        1,
        123216,
        123535,
        1,
        123567,
        123583,
        1,
        123642,
        123646,
        1,
        123648,
        124111,
        1,
        124154,
        124367,
        1,
        124411,
        124414,
        1,
        124416,
        124895,
        1,
        124903,
        124908,
        5,
        124911,
        124927,
        16,
        125125,
        125126,
        1,
        125143,
        125183,
        1,
        125260,
        125263,
        1,
        125274,
        125277,
        1,
        125280,
        126064,
        1,
        126133,
        126208,
        1,
        126270,
        126463,
        1,
        126468,
        126496,
        28,
        126499,
        126501,
        2,
        126502,
        126504,
        2,
        126515,
        126520,
        5,
        126522,
        126524,
        2,
        126525,
        126529,
        1,
        126531,
        126534,
        1,
        126536,
        126540,
        2,
        126544,
        126547,
        3,
        126549,
        126550,
        1,
        126552,
        126560,
        2,
        126563,
        126565,
        2,
        126566,
        126571,
        5,
        126579,
        126589,
        5,
        126591,
        126602,
        11,
        126620,
        126624,
        1,
        126628,
        126634,
        6,
        126652,
        126703,
        1,
        126706,
        126975,
        1,
        127020,
        127023,
        1,
        127124,
        127135,
        1,
        127151,
        127152,
        1,
        127168,
        127184,
        16,
        127222,
        127231,
        1,
        127406,
        127461,
        1,
        127491,
        127503,
        1,
        127548,
        127551,
        1,
        127561,
        127567,
        1,
        127570,
        127583,
        1,
        127590,
        127743,
        1,
        128728,
        128731,
        1,
        128749,
        128751,
        1,
        128765,
        128767,
        1,
        128887,
        128890,
        1,
        128986,
        128991,
        1,
        129004,
        129007,
        1,
        129009,
        129023,
        1,
        129036,
        129039,
        1,
        129096,
        129103,
        1,
        129114,
        129119,
        1,
        129160,
        129167,
        1,
        129198,
        129199,
        1,
        129212,
        129215,
        1,
        129218,
        129279,
        1,
        129620,
        129631,
        1,
        129646,
        129647,
        1,
        129661,
        129663,
        1,
        129674,
        129678,
        1,
        129735,
        129741,
        1,
        129757,
        129758,
        1,
        129770,
        129775,
        1,
        129785,
        129791,
        1,
        129939,
        130042,
        103,
        130043,
        131071,
        1,
        173792,
        173823,
        1,
        177978,
        177983,
        1,
        178206,
        178207,
        1,
        183970,
        183983,
        1,
        191457,
        191471,
        1,
        192094,
        194559,
        1,
        195102,
        196607,
        1,
        201547,
        201551,
        1,
        205744,
        917759,
        1,
        918000,
        1114111,
        1
    ]));
    static Cc = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        0,
        31,
        1,
        127,
        159,
        1
    ]));
    static Cf = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        173,
        1536,
        1363,
        1537,
        1541,
        1,
        1564,
        1757,
        193,
        1807,
        2192,
        385,
        2193,
        2274,
        81,
        6158,
        8203,
        2045,
        8204,
        8207,
        1,
        8234,
        8238,
        1,
        8288,
        8292,
        1,
        8294,
        8303,
        1,
        65279,
        65529,
        250,
        65530,
        65531,
        1,
        69821,
        69837,
        16,
        78896,
        78911,
        1,
        113824,
        113827,
        1,
        119155,
        119162,
        1,
        917505,
        917536,
        31,
        917537,
        917631,
        1
    ]));
    static Co = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        57344,
        63743,
        1,
        983040,
        1048573,
        1,
        1048576,
        1114109,
        1
    ]));
    static Cs = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        55296,
        57343,
        1
    ]));
    static L = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        65,
        90,
        1,
        97,
        122,
        1,
        170,
        181,
        11,
        186,
        192,
        6,
        193,
        214,
        1,
        216,
        246,
        1,
        248,
        705,
        1,
        710,
        721,
        1,
        736,
        740,
        1,
        748,
        750,
        2,
        880,
        884,
        1,
        886,
        887,
        1,
        890,
        893,
        1,
        895,
        902,
        7,
        904,
        906,
        1,
        908,
        910,
        2,
        911,
        929,
        1,
        931,
        1013,
        1,
        1015,
        1153,
        1,
        1162,
        1327,
        1,
        1329,
        1366,
        1,
        1369,
        1376,
        7,
        1377,
        1416,
        1,
        1488,
        1514,
        1,
        1519,
        1522,
        1,
        1568,
        1610,
        1,
        1646,
        1647,
        1,
        1649,
        1747,
        1,
        1749,
        1765,
        16,
        1766,
        1774,
        8,
        1775,
        1786,
        11,
        1787,
        1788,
        1,
        1791,
        1808,
        17,
        1810,
        1839,
        1,
        1869,
        1957,
        1,
        1969,
        1994,
        25,
        1995,
        2026,
        1,
        2036,
        2037,
        1,
        2042,
        2048,
        6,
        2049,
        2069,
        1,
        2074,
        2084,
        10,
        2088,
        2112,
        24,
        2113,
        2136,
        1,
        2144,
        2154,
        1,
        2160,
        2183,
        1,
        2185,
        2190,
        1,
        2208,
        2249,
        1,
        2308,
        2361,
        1,
        2365,
        2384,
        19,
        2392,
        2401,
        1,
        2417,
        2432,
        1,
        2437,
        2444,
        1,
        2447,
        2448,
        1,
        2451,
        2472,
        1,
        2474,
        2480,
        1,
        2482,
        2486,
        4,
        2487,
        2489,
        1,
        2493,
        2510,
        17,
        2524,
        2525,
        1,
        2527,
        2529,
        1,
        2544,
        2545,
        1,
        2556,
        2565,
        9,
        2566,
        2570,
        1,
        2575,
        2576,
        1,
        2579,
        2600,
        1,
        2602,
        2608,
        1,
        2610,
        2611,
        1,
        2613,
        2614,
        1,
        2616,
        2617,
        1,
        2649,
        2652,
        1,
        2654,
        2674,
        20,
        2675,
        2676,
        1,
        2693,
        2701,
        1,
        2703,
        2705,
        1,
        2707,
        2728,
        1,
        2730,
        2736,
        1,
        2738,
        2739,
        1,
        2741,
        2745,
        1,
        2749,
        2768,
        19,
        2784,
        2785,
        1,
        2809,
        2821,
        12,
        2822,
        2828,
        1,
        2831,
        2832,
        1,
        2835,
        2856,
        1,
        2858,
        2864,
        1,
        2866,
        2867,
        1,
        2869,
        2873,
        1,
        2877,
        2908,
        31,
        2909,
        2911,
        2,
        2912,
        2913,
        1,
        2929,
        2947,
        18,
        2949,
        2954,
        1,
        2958,
        2960,
        1,
        2962,
        2965,
        1,
        2969,
        2970,
        1,
        2972,
        2974,
        2,
        2975,
        2979,
        4,
        2980,
        2984,
        4,
        2985,
        2986,
        1,
        2990,
        3001,
        1,
        3024,
        3077,
        53,
        3078,
        3084,
        1,
        3086,
        3088,
        1,
        3090,
        3112,
        1,
        3114,
        3129,
        1,
        3133,
        3160,
        27,
        3161,
        3162,
        1,
        3165,
        3168,
        3,
        3169,
        3200,
        31,
        3205,
        3212,
        1,
        3214,
        3216,
        1,
        3218,
        3240,
        1,
        3242,
        3251,
        1,
        3253,
        3257,
        1,
        3261,
        3293,
        32,
        3294,
        3296,
        2,
        3297,
        3313,
        16,
        3314,
        3332,
        18,
        3333,
        3340,
        1,
        3342,
        3344,
        1,
        3346,
        3386,
        1,
        3389,
        3406,
        17,
        3412,
        3414,
        1,
        3423,
        3425,
        1,
        3450,
        3455,
        1,
        3461,
        3478,
        1,
        3482,
        3505,
        1,
        3507,
        3515,
        1,
        3517,
        3520,
        3,
        3521,
        3526,
        1,
        3585,
        3632,
        1,
        3634,
        3635,
        1,
        3648,
        3654,
        1,
        3713,
        3714,
        1,
        3716,
        3718,
        2,
        3719,
        3722,
        1,
        3724,
        3747,
        1,
        3749,
        3751,
        2,
        3752,
        3760,
        1,
        3762,
        3763,
        1,
        3773,
        3776,
        3,
        3777,
        3780,
        1,
        3782,
        3804,
        22,
        3805,
        3807,
        1,
        3840,
        3904,
        64,
        3905,
        3911,
        1,
        3913,
        3948,
        1,
        3976,
        3980,
        1,
        4096,
        4138,
        1,
        4159,
        4176,
        17,
        4177,
        4181,
        1,
        4186,
        4189,
        1,
        4193,
        4197,
        4,
        4198,
        4206,
        8,
        4207,
        4208,
        1,
        4213,
        4225,
        1,
        4238,
        4256,
        18,
        4257,
        4293,
        1,
        4295,
        4301,
        6,
        4304,
        4346,
        1,
        4348,
        4680,
        1,
        4682,
        4685,
        1,
        4688,
        4694,
        1,
        4696,
        4698,
        2,
        4699,
        4701,
        1,
        4704,
        4744,
        1,
        4746,
        4749,
        1,
        4752,
        4784,
        1,
        4786,
        4789,
        1,
        4792,
        4798,
        1,
        4800,
        4802,
        2,
        4803,
        4805,
        1,
        4808,
        4822,
        1,
        4824,
        4880,
        1,
        4882,
        4885,
        1,
        4888,
        4954,
        1,
        4992,
        5007,
        1,
        5024,
        5109,
        1,
        5112,
        5117,
        1,
        5121,
        5740,
        1,
        5743,
        5759,
        1,
        5761,
        5786,
        1,
        5792,
        5866,
        1,
        5873,
        5880,
        1,
        5888,
        5905,
        1,
        5919,
        5937,
        1,
        5952,
        5969,
        1,
        5984,
        5996,
        1,
        5998,
        6000,
        1,
        6016,
        6067,
        1,
        6103,
        6108,
        5,
        6176,
        6264,
        1,
        6272,
        6276,
        1,
        6279,
        6312,
        1,
        6314,
        6320,
        6,
        6321,
        6389,
        1,
        6400,
        6430,
        1,
        6480,
        6509,
        1,
        6512,
        6516,
        1,
        6528,
        6571,
        1,
        6576,
        6601,
        1,
        6656,
        6678,
        1,
        6688,
        6740,
        1,
        6823,
        6917,
        94,
        6918,
        6963,
        1,
        6981,
        6988,
        1,
        7043,
        7072,
        1,
        7086,
        7087,
        1,
        7098,
        7141,
        1,
        7168,
        7203,
        1,
        7245,
        7247,
        1,
        7258,
        7293,
        1,
        7296,
        7306,
        1,
        7312,
        7354,
        1,
        7357,
        7359,
        1,
        7401,
        7404,
        1,
        7406,
        7411,
        1,
        7413,
        7414,
        1,
        7418,
        7424,
        6,
        7425,
        7615,
        1,
        7680,
        7957,
        1,
        7960,
        7965,
        1,
        7968,
        8005,
        1,
        8008,
        8013,
        1,
        8016,
        8023,
        1,
        8025,
        8031,
        2,
        8032,
        8061,
        1,
        8064,
        8116,
        1,
        8118,
        8124,
        1,
        8126,
        8130,
        4,
        8131,
        8132,
        1,
        8134,
        8140,
        1,
        8144,
        8147,
        1,
        8150,
        8155,
        1,
        8160,
        8172,
        1,
        8178,
        8180,
        1,
        8182,
        8188,
        1,
        8305,
        8319,
        14,
        8336,
        8348,
        1,
        8450,
        8455,
        5,
        8458,
        8467,
        1,
        8469,
        8473,
        4,
        8474,
        8477,
        1,
        8484,
        8490,
        2,
        8491,
        8493,
        1,
        8495,
        8505,
        1,
        8508,
        8511,
        1,
        8517,
        8521,
        1,
        8526,
        8579,
        53,
        8580,
        11264,
        2684,
        11265,
        11492,
        1,
        11499,
        11502,
        1,
        11506,
        11507,
        1,
        11520,
        11557,
        1,
        11559,
        11565,
        6,
        11568,
        11623,
        1,
        11631,
        11648,
        17,
        11649,
        11670,
        1,
        11680,
        11686,
        1,
        11688,
        11694,
        1,
        11696,
        11702,
        1,
        11704,
        11710,
        1,
        11712,
        11718,
        1,
        11720,
        11726,
        1,
        11728,
        11734,
        1,
        11736,
        11742,
        1,
        11823,
        12293,
        470,
        12294,
        12337,
        43,
        12338,
        12341,
        1,
        12347,
        12348,
        1,
        12353,
        12438,
        1,
        12445,
        12447,
        1,
        12449,
        12538,
        1,
        12540,
        12543,
        1,
        12549,
        12591,
        1,
        12593,
        12686,
        1,
        12704,
        12735,
        1,
        12784,
        12799,
        1,
        13312,
        19903,
        1,
        19968,
        42124,
        1,
        42192,
        42237,
        1,
        42240,
        42508,
        1,
        42512,
        42527,
        1,
        42538,
        42539,
        1,
        42560,
        42606,
        1,
        42623,
        42653,
        1,
        42656,
        42725,
        1,
        42775,
        42783,
        1,
        42786,
        42888,
        1,
        42891,
        42957,
        1,
        42960,
        42961,
        1,
        42963,
        42965,
        2,
        42966,
        42972,
        1,
        42994,
        43009,
        1,
        43011,
        43013,
        1,
        43015,
        43018,
        1,
        43020,
        43042,
        1,
        43072,
        43123,
        1,
        43138,
        43187,
        1,
        43250,
        43255,
        1,
        43259,
        43261,
        2,
        43262,
        43274,
        12,
        43275,
        43301,
        1,
        43312,
        43334,
        1,
        43360,
        43388,
        1,
        43396,
        43442,
        1,
        43471,
        43488,
        17,
        43489,
        43492,
        1,
        43494,
        43503,
        1,
        43514,
        43518,
        1,
        43520,
        43560,
        1,
        43584,
        43586,
        1,
        43588,
        43595,
        1,
        43616,
        43638,
        1,
        43642,
        43646,
        4,
        43647,
        43695,
        1,
        43697,
        43701,
        4,
        43702,
        43705,
        3,
        43706,
        43709,
        1,
        43712,
        43714,
        2,
        43739,
        43741,
        1,
        43744,
        43754,
        1,
        43762,
        43764,
        1,
        43777,
        43782,
        1,
        43785,
        43790,
        1,
        43793,
        43798,
        1,
        43808,
        43814,
        1,
        43816,
        43822,
        1,
        43824,
        43866,
        1,
        43868,
        43881,
        1,
        43888,
        44002,
        1,
        44032,
        55203,
        1,
        55216,
        55238,
        1,
        55243,
        55291,
        1,
        63744,
        64109,
        1,
        64112,
        64217,
        1,
        64256,
        64262,
        1,
        64275,
        64279,
        1,
        64285,
        64287,
        2,
        64288,
        64296,
        1,
        64298,
        64310,
        1,
        64312,
        64316,
        1,
        64318,
        64320,
        2,
        64321,
        64323,
        2,
        64324,
        64326,
        2,
        64327,
        64433,
        1,
        64467,
        64829,
        1,
        64848,
        64911,
        1,
        64914,
        64967,
        1,
        65008,
        65019,
        1,
        65136,
        65140,
        1,
        65142,
        65276,
        1,
        65313,
        65338,
        1,
        65345,
        65370,
        1,
        65382,
        65470,
        1,
        65474,
        65479,
        1,
        65482,
        65487,
        1,
        65490,
        65495,
        1,
        65498,
        65500,
        1,
        65536,
        65547,
        1,
        65549,
        65574,
        1,
        65576,
        65594,
        1,
        65596,
        65597,
        1,
        65599,
        65613,
        1,
        65616,
        65629,
        1,
        65664,
        65786,
        1,
        66176,
        66204,
        1,
        66208,
        66256,
        1,
        66304,
        66335,
        1,
        66349,
        66368,
        1,
        66370,
        66377,
        1,
        66384,
        66421,
        1,
        66432,
        66461,
        1,
        66464,
        66499,
        1,
        66504,
        66511,
        1,
        66560,
        66717,
        1,
        66736,
        66771,
        1,
        66776,
        66811,
        1,
        66816,
        66855,
        1,
        66864,
        66915,
        1,
        66928,
        66938,
        1,
        66940,
        66954,
        1,
        66956,
        66962,
        1,
        66964,
        66965,
        1,
        66967,
        66977,
        1,
        66979,
        66993,
        1,
        66995,
        67001,
        1,
        67003,
        67004,
        1,
        67008,
        67059,
        1,
        67072,
        67382,
        1,
        67392,
        67413,
        1,
        67424,
        67431,
        1,
        67456,
        67461,
        1,
        67463,
        67504,
        1,
        67506,
        67514,
        1,
        67584,
        67589,
        1,
        67592,
        67594,
        2,
        67595,
        67637,
        1,
        67639,
        67640,
        1,
        67644,
        67647,
        3,
        67648,
        67669,
        1,
        67680,
        67702,
        1,
        67712,
        67742,
        1,
        67808,
        67826,
        1,
        67828,
        67829,
        1,
        67840,
        67861,
        1,
        67872,
        67897,
        1,
        67968,
        68023,
        1,
        68030,
        68031,
        1,
        68096,
        68112,
        16,
        68113,
        68115,
        1,
        68117,
        68119,
        1,
        68121,
        68149,
        1,
        68192,
        68220,
        1,
        68224,
        68252,
        1,
        68288,
        68295,
        1,
        68297,
        68324,
        1,
        68352,
        68405,
        1,
        68416,
        68437,
        1,
        68448,
        68466,
        1,
        68480,
        68497,
        1,
        68608,
        68680,
        1,
        68736,
        68786,
        1,
        68800,
        68850,
        1,
        68864,
        68899,
        1,
        68938,
        68965,
        1,
        68975,
        68997,
        1,
        69248,
        69289,
        1,
        69296,
        69297,
        1,
        69314,
        69316,
        1,
        69376,
        69404,
        1,
        69415,
        69424,
        9,
        69425,
        69445,
        1,
        69488,
        69505,
        1,
        69552,
        69572,
        1,
        69600,
        69622,
        1,
        69635,
        69687,
        1,
        69745,
        69746,
        1,
        69749,
        69763,
        14,
        69764,
        69807,
        1,
        69840,
        69864,
        1,
        69891,
        69926,
        1,
        69956,
        69959,
        3,
        69968,
        70002,
        1,
        70006,
        70019,
        13,
        70020,
        70066,
        1,
        70081,
        70084,
        1,
        70106,
        70108,
        2,
        70144,
        70161,
        1,
        70163,
        70187,
        1,
        70207,
        70208,
        1,
        70272,
        70278,
        1,
        70280,
        70282,
        2,
        70283,
        70285,
        1,
        70287,
        70301,
        1,
        70303,
        70312,
        1,
        70320,
        70366,
        1,
        70405,
        70412,
        1,
        70415,
        70416,
        1,
        70419,
        70440,
        1,
        70442,
        70448,
        1,
        70450,
        70451,
        1,
        70453,
        70457,
        1,
        70461,
        70480,
        19,
        70493,
        70497,
        1,
        70528,
        70537,
        1,
        70539,
        70542,
        3,
        70544,
        70581,
        1,
        70583,
        70609,
        26,
        70611,
        70656,
        45,
        70657,
        70708,
        1,
        70727,
        70730,
        1,
        70751,
        70753,
        1,
        70784,
        70831,
        1,
        70852,
        70853,
        1,
        70855,
        71040,
        185,
        71041,
        71086,
        1,
        71128,
        71131,
        1,
        71168,
        71215,
        1,
        71236,
        71296,
        60,
        71297,
        71338,
        1,
        71352,
        71424,
        72,
        71425,
        71450,
        1,
        71488,
        71494,
        1,
        71680,
        71723,
        1,
        71840,
        71903,
        1,
        71935,
        71942,
        1,
        71945,
        71948,
        3,
        71949,
        71955,
        1,
        71957,
        71958,
        1,
        71960,
        71983,
        1,
        71999,
        72001,
        2,
        72096,
        72103,
        1,
        72106,
        72144,
        1,
        72161,
        72163,
        2,
        72192,
        72203,
        11,
        72204,
        72242,
        1,
        72250,
        72272,
        22,
        72284,
        72329,
        1,
        72349,
        72368,
        19,
        72369,
        72440,
        1,
        72640,
        72672,
        1,
        72704,
        72712,
        1,
        72714,
        72750,
        1,
        72768,
        72818,
        50,
        72819,
        72847,
        1,
        72960,
        72966,
        1,
        72968,
        72969,
        1,
        72971,
        73008,
        1,
        73030,
        73056,
        26,
        73057,
        73061,
        1,
        73063,
        73064,
        1,
        73066,
        73097,
        1,
        73112,
        73440,
        328,
        73441,
        73458,
        1,
        73474,
        73476,
        2,
        73477,
        73488,
        1,
        73490,
        73523,
        1,
        73648,
        73728,
        80,
        73729,
        74649,
        1,
        74880,
        75075,
        1,
        77712,
        77808,
        1,
        77824,
        78895,
        1,
        78913,
        78918,
        1,
        78944,
        82938,
        1,
        82944,
        83526,
        1,
        90368,
        90397,
        1,
        92160,
        92728,
        1,
        92736,
        92766,
        1,
        92784,
        92862,
        1,
        92880,
        92909,
        1,
        92928,
        92975,
        1,
        92992,
        92995,
        1,
        93027,
        93047,
        1,
        93053,
        93071,
        1,
        93504,
        93548,
        1,
        93760,
        93823,
        1,
        93952,
        94026,
        1,
        94032,
        94099,
        67,
        94100,
        94111,
        1,
        94176,
        94177,
        1,
        94179,
        94208,
        29,
        94209,
        100343,
        1,
        100352,
        101589,
        1,
        101631,
        101640,
        1,
        110576,
        110579,
        1,
        110581,
        110587,
        1,
        110589,
        110590,
        1,
        110592,
        110882,
        1,
        110898,
        110928,
        30,
        110929,
        110930,
        1,
        110933,
        110948,
        15,
        110949,
        110951,
        1,
        110960,
        111355,
        1,
        113664,
        113770,
        1,
        113776,
        113788,
        1,
        113792,
        113800,
        1,
        113808,
        113817,
        1,
        119808,
        119892,
        1,
        119894,
        119964,
        1,
        119966,
        119967,
        1,
        119970,
        119973,
        3,
        119974,
        119977,
        3,
        119978,
        119980,
        1,
        119982,
        119993,
        1,
        119995,
        119997,
        2,
        119998,
        120003,
        1,
        120005,
        120069,
        1,
        120071,
        120074,
        1,
        120077,
        120084,
        1,
        120086,
        120092,
        1,
        120094,
        120121,
        1,
        120123,
        120126,
        1,
        120128,
        120132,
        1,
        120134,
        120138,
        4,
        120139,
        120144,
        1,
        120146,
        120485,
        1,
        120488,
        120512,
        1,
        120514,
        120538,
        1,
        120540,
        120570,
        1,
        120572,
        120596,
        1,
        120598,
        120628,
        1,
        120630,
        120654,
        1,
        120656,
        120686,
        1,
        120688,
        120712,
        1,
        120714,
        120744,
        1,
        120746,
        120770,
        1,
        120772,
        120779,
        1,
        122624,
        122654,
        1,
        122661,
        122666,
        1,
        122928,
        122989,
        1,
        123136,
        123180,
        1,
        123191,
        123197,
        1,
        123214,
        123536,
        322,
        123537,
        123565,
        1,
        123584,
        123627,
        1,
        124112,
        124139,
        1,
        124368,
        124397,
        1,
        124400,
        124896,
        496,
        124897,
        124902,
        1,
        124904,
        124907,
        1,
        124909,
        124910,
        1,
        124912,
        124926,
        1,
        124928,
        125124,
        1,
        125184,
        125251,
        1,
        125259,
        126464,
        1205,
        126465,
        126467,
        1,
        126469,
        126495,
        1,
        126497,
        126498,
        1,
        126500,
        126503,
        3,
        126505,
        126514,
        1,
        126516,
        126519,
        1,
        126521,
        126523,
        2,
        126530,
        126535,
        5,
        126537,
        126541,
        2,
        126542,
        126543,
        1,
        126545,
        126546,
        1,
        126548,
        126551,
        3,
        126553,
        126561,
        2,
        126562,
        126564,
        2,
        126567,
        126570,
        1,
        126572,
        126578,
        1,
        126580,
        126583,
        1,
        126585,
        126588,
        1,
        126590,
        126592,
        2,
        126593,
        126601,
        1,
        126603,
        126619,
        1,
        126625,
        126627,
        1,
        126629,
        126633,
        1,
        126635,
        126651,
        1,
        131072,
        173791,
        1,
        173824,
        177977,
        1,
        177984,
        178205,
        1,
        178208,
        183969,
        1,
        183984,
        191456,
        1,
        191472,
        192093,
        1,
        194560,
        195101,
        1,
        196608,
        201546,
        1,
        201552,
        205743,
        1
    ]));
    static foldL = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        837,
        837,
        1
    ]));
    static Ll = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        97,
        122,
        1,
        181,
        223,
        42,
        224,
        246,
        1,
        248,
        255,
        1,
        257,
        311,
        2,
        312,
        328,
        2,
        329,
        375,
        2,
        378,
        382,
        2,
        383,
        384,
        1,
        387,
        389,
        2,
        392,
        396,
        4,
        397,
        402,
        5,
        405,
        409,
        4,
        410,
        411,
        1,
        414,
        417,
        3,
        419,
        421,
        2,
        424,
        426,
        2,
        427,
        429,
        2,
        432,
        436,
        4,
        438,
        441,
        3,
        442,
        445,
        3,
        446,
        447,
        1,
        454,
        460,
        3,
        462,
        476,
        2,
        477,
        495,
        2,
        496,
        499,
        3,
        501,
        505,
        4,
        507,
        563,
        2,
        564,
        569,
        1,
        572,
        575,
        3,
        576,
        578,
        2,
        583,
        591,
        2,
        592,
        659,
        1,
        661,
        687,
        1,
        881,
        883,
        2,
        887,
        891,
        4,
        892,
        893,
        1,
        912,
        940,
        28,
        941,
        974,
        1,
        976,
        977,
        1,
        981,
        983,
        1,
        985,
        1007,
        2,
        1008,
        1011,
        1,
        1013,
        1019,
        3,
        1020,
        1072,
        52,
        1073,
        1119,
        1,
        1121,
        1153,
        2,
        1163,
        1215,
        2,
        1218,
        1230,
        2,
        1231,
        1327,
        2,
        1376,
        1416,
        1,
        4304,
        4346,
        1,
        4349,
        4351,
        1,
        5112,
        5117,
        1,
        7296,
        7304,
        1,
        7306,
        7424,
        118,
        7425,
        7467,
        1,
        7531,
        7543,
        1,
        7545,
        7578,
        1,
        7681,
        7829,
        2,
        7830,
        7837,
        1,
        7839,
        7935,
        2,
        7936,
        7943,
        1,
        7952,
        7957,
        1,
        7968,
        7975,
        1,
        7984,
        7991,
        1,
        8000,
        8005,
        1,
        8016,
        8023,
        1,
        8032,
        8039,
        1,
        8048,
        8061,
        1,
        8064,
        8071,
        1,
        8080,
        8087,
        1,
        8096,
        8103,
        1,
        8112,
        8116,
        1,
        8118,
        8119,
        1,
        8126,
        8130,
        4,
        8131,
        8132,
        1,
        8134,
        8135,
        1,
        8144,
        8147,
        1,
        8150,
        8151,
        1,
        8160,
        8167,
        1,
        8178,
        8180,
        1,
        8182,
        8183,
        1,
        8458,
        8462,
        4,
        8463,
        8467,
        4,
        8495,
        8505,
        5,
        8508,
        8509,
        1,
        8518,
        8521,
        1,
        8526,
        8580,
        54,
        11312,
        11359,
        1,
        11361,
        11365,
        4,
        11366,
        11372,
        2,
        11377,
        11379,
        2,
        11380,
        11382,
        2,
        11383,
        11387,
        1,
        11393,
        11491,
        2,
        11492,
        11500,
        8,
        11502,
        11507,
        5,
        11520,
        11557,
        1,
        11559,
        11565,
        6,
        42561,
        42605,
        2,
        42625,
        42651,
        2,
        42787,
        42799,
        2,
        42800,
        42801,
        1,
        42803,
        42865,
        2,
        42866,
        42872,
        1,
        42874,
        42876,
        2,
        42879,
        42887,
        2,
        42892,
        42894,
        2,
        42897,
        42899,
        2,
        42900,
        42901,
        1,
        42903,
        42921,
        2,
        42927,
        42933,
        6,
        42935,
        42947,
        2,
        42952,
        42954,
        2,
        42957,
        42961,
        4,
        42963,
        42971,
        2,
        42998,
        43002,
        4,
        43824,
        43866,
        1,
        43872,
        43880,
        1,
        43888,
        43967,
        1,
        64256,
        64262,
        1,
        64275,
        64279,
        1,
        65345,
        65370,
        1,
        66600,
        66639,
        1,
        66776,
        66811,
        1,
        66967,
        66977,
        1,
        66979,
        66993,
        1,
        66995,
        67001,
        1,
        67003,
        67004,
        1,
        68800,
        68850,
        1,
        68976,
        68997,
        1,
        71872,
        71903,
        1,
        93792,
        93823,
        1,
        119834,
        119859,
        1,
        119886,
        119892,
        1,
        119894,
        119911,
        1,
        119938,
        119963,
        1,
        119990,
        119993,
        1,
        119995,
        119997,
        2,
        119998,
        120003,
        1,
        120005,
        120015,
        1,
        120042,
        120067,
        1,
        120094,
        120119,
        1,
        120146,
        120171,
        1,
        120198,
        120223,
        1,
        120250,
        120275,
        1,
        120302,
        120327,
        1,
        120354,
        120379,
        1,
        120406,
        120431,
        1,
        120458,
        120485,
        1,
        120514,
        120538,
        1,
        120540,
        120545,
        1,
        120572,
        120596,
        1,
        120598,
        120603,
        1,
        120630,
        120654,
        1,
        120656,
        120661,
        1,
        120688,
        120712,
        1,
        120714,
        120719,
        1,
        120746,
        120770,
        1,
        120772,
        120777,
        1,
        120779,
        122624,
        1845,
        122625,
        122633,
        1,
        122635,
        122654,
        1,
        122661,
        122666,
        1,
        125218,
        125251,
        1
    ]));
    static foldLl = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        65,
        90,
        1,
        192,
        214,
        1,
        216,
        222,
        1,
        256,
        302,
        2,
        306,
        310,
        2,
        313,
        327,
        2,
        330,
        376,
        2,
        377,
        381,
        2,
        385,
        386,
        1,
        388,
        390,
        2,
        391,
        393,
        2,
        394,
        395,
        1,
        398,
        401,
        1,
        403,
        404,
        1,
        406,
        408,
        1,
        412,
        413,
        1,
        415,
        416,
        1,
        418,
        422,
        2,
        423,
        425,
        2,
        428,
        430,
        2,
        431,
        433,
        2,
        434,
        435,
        1,
        437,
        439,
        2,
        440,
        444,
        4,
        452,
        453,
        1,
        455,
        456,
        1,
        458,
        459,
        1,
        461,
        475,
        2,
        478,
        494,
        2,
        497,
        498,
        1,
        500,
        502,
        2,
        503,
        504,
        1,
        506,
        562,
        2,
        570,
        571,
        1,
        573,
        574,
        1,
        577,
        579,
        2,
        580,
        582,
        1,
        584,
        590,
        2,
        837,
        880,
        43,
        882,
        886,
        4,
        895,
        902,
        7,
        904,
        906,
        1,
        908,
        910,
        2,
        911,
        913,
        2,
        914,
        929,
        1,
        931,
        939,
        1,
        975,
        984,
        9,
        986,
        1006,
        2,
        1012,
        1015,
        3,
        1017,
        1018,
        1,
        1021,
        1071,
        1,
        1120,
        1152,
        2,
        1162,
        1216,
        2,
        1217,
        1229,
        2,
        1232,
        1326,
        2,
        1329,
        1366,
        1,
        4256,
        4293,
        1,
        4295,
        4301,
        6,
        5024,
        5109,
        1,
        7305,
        7312,
        7,
        7313,
        7354,
        1,
        7357,
        7359,
        1,
        7680,
        7828,
        2,
        7838,
        7934,
        2,
        7944,
        7951,
        1,
        7960,
        7965,
        1,
        7976,
        7983,
        1,
        7992,
        7999,
        1,
        8008,
        8013,
        1,
        8025,
        8031,
        2,
        8040,
        8047,
        1,
        8072,
        8079,
        1,
        8088,
        8095,
        1,
        8104,
        8111,
        1,
        8120,
        8124,
        1,
        8136,
        8140,
        1,
        8152,
        8155,
        1,
        8168,
        8172,
        1,
        8184,
        8188,
        1,
        8486,
        8490,
        4,
        8491,
        8498,
        7,
        8579,
        11264,
        2685,
        11265,
        11311,
        1,
        11360,
        11362,
        2,
        11363,
        11364,
        1,
        11367,
        11373,
        2,
        11374,
        11376,
        1,
        11378,
        11381,
        3,
        11390,
        11392,
        1,
        11394,
        11490,
        2,
        11499,
        11501,
        2,
        11506,
        42560,
        31054,
        42562,
        42604,
        2,
        42624,
        42650,
        2,
        42786,
        42798,
        2,
        42802,
        42862,
        2,
        42873,
        42877,
        2,
        42878,
        42886,
        2,
        42891,
        42893,
        2,
        42896,
        42898,
        2,
        42902,
        42922,
        2,
        42923,
        42926,
        1,
        42928,
        42932,
        1,
        42934,
        42948,
        2,
        42949,
        42951,
        1,
        42953,
        42955,
        2,
        42956,
        42960,
        4,
        42966,
        42972,
        2,
        42997,
        65313,
        22316,
        65314,
        65338,
        1,
        66560,
        66599,
        1,
        66736,
        66771,
        1,
        66928,
        66938,
        1,
        66940,
        66954,
        1,
        66956,
        66962,
        1,
        66964,
        66965,
        1,
        68736,
        68786,
        1,
        68944,
        68965,
        1,
        71840,
        71871,
        1,
        93760,
        93791,
        1,
        125184,
        125217,
        1
    ]));
    static Lm = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        688,
        705,
        1,
        710,
        721,
        1,
        736,
        740,
        1,
        748,
        750,
        2,
        884,
        890,
        6,
        1369,
        1600,
        231,
        1765,
        1766,
        1,
        2036,
        2037,
        1,
        2042,
        2074,
        32,
        2084,
        2088,
        4,
        2249,
        2417,
        168,
        3654,
        3782,
        128,
        4348,
        6103,
        1755,
        6211,
        6823,
        612,
        7288,
        7293,
        1,
        7468,
        7530,
        1,
        7544,
        7579,
        35,
        7580,
        7615,
        1,
        8305,
        8319,
        14,
        8336,
        8348,
        1,
        11388,
        11389,
        1,
        11631,
        11823,
        192,
        12293,
        12337,
        44,
        12338,
        12341,
        1,
        12347,
        12445,
        98,
        12446,
        12540,
        94,
        12541,
        12542,
        1,
        40981,
        42232,
        1251,
        42233,
        42237,
        1,
        42508,
        42623,
        115,
        42652,
        42653,
        1,
        42775,
        42783,
        1,
        42864,
        42888,
        24,
        42994,
        42996,
        1,
        43000,
        43001,
        1,
        43471,
        43494,
        23,
        43632,
        43741,
        109,
        43763,
        43764,
        1,
        43868,
        43871,
        1,
        43881,
        65392,
        21511,
        65438,
        65439,
        1,
        67456,
        67461,
        1,
        67463,
        67504,
        1,
        67506,
        67514,
        1,
        68942,
        68975,
        33,
        92992,
        92995,
        1,
        93504,
        93506,
        1,
        93547,
        93548,
        1,
        94099,
        94111,
        1,
        94176,
        94177,
        1,
        94179,
        110576,
        16397,
        110577,
        110579,
        1,
        110581,
        110587,
        1,
        110589,
        110590,
        1,
        122928,
        122989,
        1,
        123191,
        123197,
        1,
        124139,
        125259,
        1120
    ]));
    static Lo = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        170,
        186,
        16,
        443,
        448,
        5,
        449,
        451,
        1,
        660,
        1488,
        828,
        1489,
        1514,
        1,
        1519,
        1522,
        1,
        1568,
        1599,
        1,
        1601,
        1610,
        1,
        1646,
        1647,
        1,
        1649,
        1747,
        1,
        1749,
        1774,
        25,
        1775,
        1786,
        11,
        1787,
        1788,
        1,
        1791,
        1808,
        17,
        1810,
        1839,
        1,
        1869,
        1957,
        1,
        1969,
        1994,
        25,
        1995,
        2026,
        1,
        2048,
        2069,
        1,
        2112,
        2136,
        1,
        2144,
        2154,
        1,
        2160,
        2183,
        1,
        2185,
        2190,
        1,
        2208,
        2248,
        1,
        2308,
        2361,
        1,
        2365,
        2384,
        19,
        2392,
        2401,
        1,
        2418,
        2432,
        1,
        2437,
        2444,
        1,
        2447,
        2448,
        1,
        2451,
        2472,
        1,
        2474,
        2480,
        1,
        2482,
        2486,
        4,
        2487,
        2489,
        1,
        2493,
        2510,
        17,
        2524,
        2525,
        1,
        2527,
        2529,
        1,
        2544,
        2545,
        1,
        2556,
        2565,
        9,
        2566,
        2570,
        1,
        2575,
        2576,
        1,
        2579,
        2600,
        1,
        2602,
        2608,
        1,
        2610,
        2611,
        1,
        2613,
        2614,
        1,
        2616,
        2617,
        1,
        2649,
        2652,
        1,
        2654,
        2674,
        20,
        2675,
        2676,
        1,
        2693,
        2701,
        1,
        2703,
        2705,
        1,
        2707,
        2728,
        1,
        2730,
        2736,
        1,
        2738,
        2739,
        1,
        2741,
        2745,
        1,
        2749,
        2768,
        19,
        2784,
        2785,
        1,
        2809,
        2821,
        12,
        2822,
        2828,
        1,
        2831,
        2832,
        1,
        2835,
        2856,
        1,
        2858,
        2864,
        1,
        2866,
        2867,
        1,
        2869,
        2873,
        1,
        2877,
        2908,
        31,
        2909,
        2911,
        2,
        2912,
        2913,
        1,
        2929,
        2947,
        18,
        2949,
        2954,
        1,
        2958,
        2960,
        1,
        2962,
        2965,
        1,
        2969,
        2970,
        1,
        2972,
        2974,
        2,
        2975,
        2979,
        4,
        2980,
        2984,
        4,
        2985,
        2986,
        1,
        2990,
        3001,
        1,
        3024,
        3077,
        53,
        3078,
        3084,
        1,
        3086,
        3088,
        1,
        3090,
        3112,
        1,
        3114,
        3129,
        1,
        3133,
        3160,
        27,
        3161,
        3162,
        1,
        3165,
        3168,
        3,
        3169,
        3200,
        31,
        3205,
        3212,
        1,
        3214,
        3216,
        1,
        3218,
        3240,
        1,
        3242,
        3251,
        1,
        3253,
        3257,
        1,
        3261,
        3293,
        32,
        3294,
        3296,
        2,
        3297,
        3313,
        16,
        3314,
        3332,
        18,
        3333,
        3340,
        1,
        3342,
        3344,
        1,
        3346,
        3386,
        1,
        3389,
        3406,
        17,
        3412,
        3414,
        1,
        3423,
        3425,
        1,
        3450,
        3455,
        1,
        3461,
        3478,
        1,
        3482,
        3505,
        1,
        3507,
        3515,
        1,
        3517,
        3520,
        3,
        3521,
        3526,
        1,
        3585,
        3632,
        1,
        3634,
        3635,
        1,
        3648,
        3653,
        1,
        3713,
        3714,
        1,
        3716,
        3718,
        2,
        3719,
        3722,
        1,
        3724,
        3747,
        1,
        3749,
        3751,
        2,
        3752,
        3760,
        1,
        3762,
        3763,
        1,
        3773,
        3776,
        3,
        3777,
        3780,
        1,
        3804,
        3807,
        1,
        3840,
        3904,
        64,
        3905,
        3911,
        1,
        3913,
        3948,
        1,
        3976,
        3980,
        1,
        4096,
        4138,
        1,
        4159,
        4176,
        17,
        4177,
        4181,
        1,
        4186,
        4189,
        1,
        4193,
        4197,
        4,
        4198,
        4206,
        8,
        4207,
        4208,
        1,
        4213,
        4225,
        1,
        4238,
        4352,
        114,
        4353,
        4680,
        1,
        4682,
        4685,
        1,
        4688,
        4694,
        1,
        4696,
        4698,
        2,
        4699,
        4701,
        1,
        4704,
        4744,
        1,
        4746,
        4749,
        1,
        4752,
        4784,
        1,
        4786,
        4789,
        1,
        4792,
        4798,
        1,
        4800,
        4802,
        2,
        4803,
        4805,
        1,
        4808,
        4822,
        1,
        4824,
        4880,
        1,
        4882,
        4885,
        1,
        4888,
        4954,
        1,
        4992,
        5007,
        1,
        5121,
        5740,
        1,
        5743,
        5759,
        1,
        5761,
        5786,
        1,
        5792,
        5866,
        1,
        5873,
        5880,
        1,
        5888,
        5905,
        1,
        5919,
        5937,
        1,
        5952,
        5969,
        1,
        5984,
        5996,
        1,
        5998,
        6000,
        1,
        6016,
        6067,
        1,
        6108,
        6176,
        68,
        6177,
        6210,
        1,
        6212,
        6264,
        1,
        6272,
        6276,
        1,
        6279,
        6312,
        1,
        6314,
        6320,
        6,
        6321,
        6389,
        1,
        6400,
        6430,
        1,
        6480,
        6509,
        1,
        6512,
        6516,
        1,
        6528,
        6571,
        1,
        6576,
        6601,
        1,
        6656,
        6678,
        1,
        6688,
        6740,
        1,
        6917,
        6963,
        1,
        6981,
        6988,
        1,
        7043,
        7072,
        1,
        7086,
        7087,
        1,
        7098,
        7141,
        1,
        7168,
        7203,
        1,
        7245,
        7247,
        1,
        7258,
        7287,
        1,
        7401,
        7404,
        1,
        7406,
        7411,
        1,
        7413,
        7414,
        1,
        7418,
        8501,
        1083,
        8502,
        8504,
        1,
        11568,
        11623,
        1,
        11648,
        11670,
        1,
        11680,
        11686,
        1,
        11688,
        11694,
        1,
        11696,
        11702,
        1,
        11704,
        11710,
        1,
        11712,
        11718,
        1,
        11720,
        11726,
        1,
        11728,
        11734,
        1,
        11736,
        11742,
        1,
        12294,
        12348,
        54,
        12353,
        12438,
        1,
        12447,
        12449,
        2,
        12450,
        12538,
        1,
        12543,
        12549,
        6,
        12550,
        12591,
        1,
        12593,
        12686,
        1,
        12704,
        12735,
        1,
        12784,
        12799,
        1,
        13312,
        19903,
        1,
        19968,
        40980,
        1,
        40982,
        42124,
        1,
        42192,
        42231,
        1,
        42240,
        42507,
        1,
        42512,
        42527,
        1,
        42538,
        42539,
        1,
        42606,
        42656,
        50,
        42657,
        42725,
        1,
        42895,
        42999,
        104,
        43003,
        43009,
        1,
        43011,
        43013,
        1,
        43015,
        43018,
        1,
        43020,
        43042,
        1,
        43072,
        43123,
        1,
        43138,
        43187,
        1,
        43250,
        43255,
        1,
        43259,
        43261,
        2,
        43262,
        43274,
        12,
        43275,
        43301,
        1,
        43312,
        43334,
        1,
        43360,
        43388,
        1,
        43396,
        43442,
        1,
        43488,
        43492,
        1,
        43495,
        43503,
        1,
        43514,
        43518,
        1,
        43520,
        43560,
        1,
        43584,
        43586,
        1,
        43588,
        43595,
        1,
        43616,
        43631,
        1,
        43633,
        43638,
        1,
        43642,
        43646,
        4,
        43647,
        43695,
        1,
        43697,
        43701,
        4,
        43702,
        43705,
        3,
        43706,
        43709,
        1,
        43712,
        43714,
        2,
        43739,
        43740,
        1,
        43744,
        43754,
        1,
        43762,
        43777,
        15,
        43778,
        43782,
        1,
        43785,
        43790,
        1,
        43793,
        43798,
        1,
        43808,
        43814,
        1,
        43816,
        43822,
        1,
        43968,
        44002,
        1,
        44032,
        55203,
        1,
        55216,
        55238,
        1,
        55243,
        55291,
        1,
        63744,
        64109,
        1,
        64112,
        64217,
        1,
        64285,
        64287,
        2,
        64288,
        64296,
        1,
        64298,
        64310,
        1,
        64312,
        64316,
        1,
        64318,
        64320,
        2,
        64321,
        64323,
        2,
        64324,
        64326,
        2,
        64327,
        64433,
        1,
        64467,
        64829,
        1,
        64848,
        64911,
        1,
        64914,
        64967,
        1,
        65008,
        65019,
        1,
        65136,
        65140,
        1,
        65142,
        65276,
        1,
        65382,
        65391,
        1,
        65393,
        65437,
        1,
        65440,
        65470,
        1,
        65474,
        65479,
        1,
        65482,
        65487,
        1,
        65490,
        65495,
        1,
        65498,
        65500,
        1,
        65536,
        65547,
        1,
        65549,
        65574,
        1,
        65576,
        65594,
        1,
        65596,
        65597,
        1,
        65599,
        65613,
        1,
        65616,
        65629,
        1,
        65664,
        65786,
        1,
        66176,
        66204,
        1,
        66208,
        66256,
        1,
        66304,
        66335,
        1,
        66349,
        66368,
        1,
        66370,
        66377,
        1,
        66384,
        66421,
        1,
        66432,
        66461,
        1,
        66464,
        66499,
        1,
        66504,
        66511,
        1,
        66640,
        66717,
        1,
        66816,
        66855,
        1,
        66864,
        66915,
        1,
        67008,
        67059,
        1,
        67072,
        67382,
        1,
        67392,
        67413,
        1,
        67424,
        67431,
        1,
        67584,
        67589,
        1,
        67592,
        67594,
        2,
        67595,
        67637,
        1,
        67639,
        67640,
        1,
        67644,
        67647,
        3,
        67648,
        67669,
        1,
        67680,
        67702,
        1,
        67712,
        67742,
        1,
        67808,
        67826,
        1,
        67828,
        67829,
        1,
        67840,
        67861,
        1,
        67872,
        67897,
        1,
        67968,
        68023,
        1,
        68030,
        68031,
        1,
        68096,
        68112,
        16,
        68113,
        68115,
        1,
        68117,
        68119,
        1,
        68121,
        68149,
        1,
        68192,
        68220,
        1,
        68224,
        68252,
        1,
        68288,
        68295,
        1,
        68297,
        68324,
        1,
        68352,
        68405,
        1,
        68416,
        68437,
        1,
        68448,
        68466,
        1,
        68480,
        68497,
        1,
        68608,
        68680,
        1,
        68864,
        68899,
        1,
        68938,
        68941,
        1,
        68943,
        69248,
        305,
        69249,
        69289,
        1,
        69296,
        69297,
        1,
        69314,
        69316,
        1,
        69376,
        69404,
        1,
        69415,
        69424,
        9,
        69425,
        69445,
        1,
        69488,
        69505,
        1,
        69552,
        69572,
        1,
        69600,
        69622,
        1,
        69635,
        69687,
        1,
        69745,
        69746,
        1,
        69749,
        69763,
        14,
        69764,
        69807,
        1,
        69840,
        69864,
        1,
        69891,
        69926,
        1,
        69956,
        69959,
        3,
        69968,
        70002,
        1,
        70006,
        70019,
        13,
        70020,
        70066,
        1,
        70081,
        70084,
        1,
        70106,
        70108,
        2,
        70144,
        70161,
        1,
        70163,
        70187,
        1,
        70207,
        70208,
        1,
        70272,
        70278,
        1,
        70280,
        70282,
        2,
        70283,
        70285,
        1,
        70287,
        70301,
        1,
        70303,
        70312,
        1,
        70320,
        70366,
        1,
        70405,
        70412,
        1,
        70415,
        70416,
        1,
        70419,
        70440,
        1,
        70442,
        70448,
        1,
        70450,
        70451,
        1,
        70453,
        70457,
        1,
        70461,
        70480,
        19,
        70493,
        70497,
        1,
        70528,
        70537,
        1,
        70539,
        70542,
        3,
        70544,
        70581,
        1,
        70583,
        70609,
        26,
        70611,
        70656,
        45,
        70657,
        70708,
        1,
        70727,
        70730,
        1,
        70751,
        70753,
        1,
        70784,
        70831,
        1,
        70852,
        70853,
        1,
        70855,
        71040,
        185,
        71041,
        71086,
        1,
        71128,
        71131,
        1,
        71168,
        71215,
        1,
        71236,
        71296,
        60,
        71297,
        71338,
        1,
        71352,
        71424,
        72,
        71425,
        71450,
        1,
        71488,
        71494,
        1,
        71680,
        71723,
        1,
        71935,
        71942,
        1,
        71945,
        71948,
        3,
        71949,
        71955,
        1,
        71957,
        71958,
        1,
        71960,
        71983,
        1,
        71999,
        72001,
        2,
        72096,
        72103,
        1,
        72106,
        72144,
        1,
        72161,
        72163,
        2,
        72192,
        72203,
        11,
        72204,
        72242,
        1,
        72250,
        72272,
        22,
        72284,
        72329,
        1,
        72349,
        72368,
        19,
        72369,
        72440,
        1,
        72640,
        72672,
        1,
        72704,
        72712,
        1,
        72714,
        72750,
        1,
        72768,
        72818,
        50,
        72819,
        72847,
        1,
        72960,
        72966,
        1,
        72968,
        72969,
        1,
        72971,
        73008,
        1,
        73030,
        73056,
        26,
        73057,
        73061,
        1,
        73063,
        73064,
        1,
        73066,
        73097,
        1,
        73112,
        73440,
        328,
        73441,
        73458,
        1,
        73474,
        73476,
        2,
        73477,
        73488,
        1,
        73490,
        73523,
        1,
        73648,
        73728,
        80,
        73729,
        74649,
        1,
        74880,
        75075,
        1,
        77712,
        77808,
        1,
        77824,
        78895,
        1,
        78913,
        78918,
        1,
        78944,
        82938,
        1,
        82944,
        83526,
        1,
        90368,
        90397,
        1,
        92160,
        92728,
        1,
        92736,
        92766,
        1,
        92784,
        92862,
        1,
        92880,
        92909,
        1,
        92928,
        92975,
        1,
        93027,
        93047,
        1,
        93053,
        93071,
        1,
        93507,
        93546,
        1,
        93952,
        94026,
        1,
        94032,
        94208,
        176,
        94209,
        100343,
        1,
        100352,
        101589,
        1,
        101631,
        101640,
        1,
        110592,
        110882,
        1,
        110898,
        110928,
        30,
        110929,
        110930,
        1,
        110933,
        110948,
        15,
        110949,
        110951,
        1,
        110960,
        111355,
        1,
        113664,
        113770,
        1,
        113776,
        113788,
        1,
        113792,
        113800,
        1,
        113808,
        113817,
        1,
        122634,
        123136,
        502,
        123137,
        123180,
        1,
        123214,
        123536,
        322,
        123537,
        123565,
        1,
        123584,
        123627,
        1,
        124112,
        124138,
        1,
        124368,
        124397,
        1,
        124400,
        124896,
        496,
        124897,
        124902,
        1,
        124904,
        124907,
        1,
        124909,
        124910,
        1,
        124912,
        124926,
        1,
        124928,
        125124,
        1,
        126464,
        126467,
        1,
        126469,
        126495,
        1,
        126497,
        126498,
        1,
        126500,
        126503,
        3,
        126505,
        126514,
        1,
        126516,
        126519,
        1,
        126521,
        126523,
        2,
        126530,
        126535,
        5,
        126537,
        126541,
        2,
        126542,
        126543,
        1,
        126545,
        126546,
        1,
        126548,
        126551,
        3,
        126553,
        126561,
        2,
        126562,
        126564,
        2,
        126567,
        126570,
        1,
        126572,
        126578,
        1,
        126580,
        126583,
        1,
        126585,
        126588,
        1,
        126590,
        126592,
        2,
        126593,
        126601,
        1,
        126603,
        126619,
        1,
        126625,
        126627,
        1,
        126629,
        126633,
        1,
        126635,
        126651,
        1,
        131072,
        173791,
        1,
        173824,
        177977,
        1,
        177984,
        178205,
        1,
        178208,
        183969,
        1,
        183984,
        191456,
        1,
        191472,
        192093,
        1,
        194560,
        195101,
        1,
        196608,
        201546,
        1,
        201552,
        205743,
        1
    ]));
    static Lt = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        453,
        459,
        3,
        498,
        8072,
        7574,
        8073,
        8079,
        1,
        8088,
        8095,
        1,
        8104,
        8111,
        1,
        8124,
        8140,
        16,
        8188,
        8188,
        1
    ]));
    static foldLt = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        452,
        454,
        2,
        455,
        457,
        2,
        458,
        460,
        2,
        497,
        499,
        2,
        8064,
        8071,
        1,
        8080,
        8087,
        1,
        8096,
        8103,
        1,
        8115,
        8131,
        16,
        8179,
        8179,
        1
    ]));
    static Lu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        65,
        90,
        1,
        192,
        214,
        1,
        216,
        222,
        1,
        256,
        310,
        2,
        313,
        327,
        2,
        330,
        376,
        2,
        377,
        381,
        2,
        385,
        386,
        1,
        388,
        390,
        2,
        391,
        393,
        2,
        394,
        395,
        1,
        398,
        401,
        1,
        403,
        404,
        1,
        406,
        408,
        1,
        412,
        413,
        1,
        415,
        416,
        1,
        418,
        422,
        2,
        423,
        425,
        2,
        428,
        430,
        2,
        431,
        433,
        2,
        434,
        435,
        1,
        437,
        439,
        2,
        440,
        444,
        4,
        452,
        461,
        3,
        463,
        475,
        2,
        478,
        494,
        2,
        497,
        500,
        3,
        502,
        504,
        1,
        506,
        562,
        2,
        570,
        571,
        1,
        573,
        574,
        1,
        577,
        579,
        2,
        580,
        582,
        1,
        584,
        590,
        2,
        880,
        882,
        2,
        886,
        895,
        9,
        902,
        904,
        2,
        905,
        906,
        1,
        908,
        910,
        2,
        911,
        913,
        2,
        914,
        929,
        1,
        931,
        939,
        1,
        975,
        978,
        3,
        979,
        980,
        1,
        984,
        1006,
        2,
        1012,
        1015,
        3,
        1017,
        1018,
        1,
        1021,
        1071,
        1,
        1120,
        1152,
        2,
        1162,
        1216,
        2,
        1217,
        1229,
        2,
        1232,
        1326,
        2,
        1329,
        1366,
        1,
        4256,
        4293,
        1,
        4295,
        4301,
        6,
        5024,
        5109,
        1,
        7305,
        7312,
        7,
        7313,
        7354,
        1,
        7357,
        7359,
        1,
        7680,
        7828,
        2,
        7838,
        7934,
        2,
        7944,
        7951,
        1,
        7960,
        7965,
        1,
        7976,
        7983,
        1,
        7992,
        7999,
        1,
        8008,
        8013,
        1,
        8025,
        8031,
        2,
        8040,
        8047,
        1,
        8120,
        8123,
        1,
        8136,
        8139,
        1,
        8152,
        8155,
        1,
        8168,
        8172,
        1,
        8184,
        8187,
        1,
        8450,
        8455,
        5,
        8459,
        8461,
        1,
        8464,
        8466,
        1,
        8469,
        8473,
        4,
        8474,
        8477,
        1,
        8484,
        8490,
        2,
        8491,
        8493,
        1,
        8496,
        8499,
        1,
        8510,
        8511,
        1,
        8517,
        8579,
        62,
        11264,
        11311,
        1,
        11360,
        11362,
        2,
        11363,
        11364,
        1,
        11367,
        11373,
        2,
        11374,
        11376,
        1,
        11378,
        11381,
        3,
        11390,
        11392,
        1,
        11394,
        11490,
        2,
        11499,
        11501,
        2,
        11506,
        42560,
        31054,
        42562,
        42604,
        2,
        42624,
        42650,
        2,
        42786,
        42798,
        2,
        42802,
        42862,
        2,
        42873,
        42877,
        2,
        42878,
        42886,
        2,
        42891,
        42893,
        2,
        42896,
        42898,
        2,
        42902,
        42922,
        2,
        42923,
        42926,
        1,
        42928,
        42932,
        1,
        42934,
        42948,
        2,
        42949,
        42951,
        1,
        42953,
        42955,
        2,
        42956,
        42960,
        4,
        42966,
        42972,
        2,
        42997,
        65313,
        22316,
        65314,
        65338,
        1,
        66560,
        66599,
        1,
        66736,
        66771,
        1,
        66928,
        66938,
        1,
        66940,
        66954,
        1,
        66956,
        66962,
        1,
        66964,
        66965,
        1,
        68736,
        68786,
        1,
        68944,
        68965,
        1,
        71840,
        71871,
        1,
        93760,
        93791,
        1,
        119808,
        119833,
        1,
        119860,
        119885,
        1,
        119912,
        119937,
        1,
        119964,
        119966,
        2,
        119967,
        119973,
        3,
        119974,
        119977,
        3,
        119978,
        119980,
        1,
        119982,
        119989,
        1,
        120016,
        120041,
        1,
        120068,
        120069,
        1,
        120071,
        120074,
        1,
        120077,
        120084,
        1,
        120086,
        120092,
        1,
        120120,
        120121,
        1,
        120123,
        120126,
        1,
        120128,
        120132,
        1,
        120134,
        120138,
        4,
        120139,
        120144,
        1,
        120172,
        120197,
        1,
        120224,
        120249,
        1,
        120276,
        120301,
        1,
        120328,
        120353,
        1,
        120380,
        120405,
        1,
        120432,
        120457,
        1,
        120488,
        120512,
        1,
        120546,
        120570,
        1,
        120604,
        120628,
        1,
        120662,
        120686,
        1,
        120720,
        120744,
        1,
        120778,
        125184,
        4406,
        125185,
        125217,
        1
    ]));
    static Upper = this.Lu;
    static foldLu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        97,
        122,
        1,
        181,
        223,
        42,
        224,
        246,
        1,
        248,
        255,
        1,
        257,
        303,
        2,
        307,
        311,
        2,
        314,
        328,
        2,
        331,
        375,
        2,
        378,
        382,
        2,
        383,
        384,
        1,
        387,
        389,
        2,
        392,
        396,
        4,
        402,
        405,
        3,
        409,
        411,
        1,
        414,
        417,
        3,
        419,
        421,
        2,
        424,
        429,
        5,
        432,
        436,
        4,
        438,
        441,
        3,
        445,
        447,
        2,
        453,
        454,
        1,
        456,
        457,
        1,
        459,
        460,
        1,
        462,
        476,
        2,
        477,
        495,
        2,
        498,
        499,
        1,
        501,
        505,
        4,
        507,
        543,
        2,
        547,
        563,
        2,
        572,
        575,
        3,
        576,
        578,
        2,
        583,
        591,
        2,
        592,
        596,
        1,
        598,
        599,
        1,
        601,
        603,
        2,
        604,
        608,
        4,
        609,
        611,
        2,
        612,
        614,
        1,
        616,
        620,
        1,
        623,
        625,
        2,
        626,
        629,
        3,
        637,
        640,
        3,
        642,
        643,
        1,
        647,
        652,
        1,
        658,
        669,
        11,
        670,
        837,
        167,
        881,
        883,
        2,
        887,
        891,
        4,
        892,
        893,
        1,
        940,
        943,
        1,
        945,
        974,
        1,
        976,
        977,
        1,
        981,
        983,
        1,
        985,
        1007,
        2,
        1008,
        1011,
        1,
        1013,
        1019,
        3,
        1072,
        1119,
        1,
        1121,
        1153,
        2,
        1163,
        1215,
        2,
        1218,
        1230,
        2,
        1231,
        1327,
        2,
        1377,
        1414,
        1,
        4304,
        4346,
        1,
        4349,
        4351,
        1,
        5112,
        5117,
        1,
        7296,
        7304,
        1,
        7306,
        7545,
        239,
        7549,
        7566,
        17,
        7681,
        7829,
        2,
        7835,
        7841,
        6,
        7843,
        7935,
        2,
        7936,
        7943,
        1,
        7952,
        7957,
        1,
        7968,
        7975,
        1,
        7984,
        7991,
        1,
        8000,
        8005,
        1,
        8017,
        8023,
        2,
        8032,
        8039,
        1,
        8048,
        8061,
        1,
        8112,
        8113,
        1,
        8126,
        8144,
        18,
        8145,
        8160,
        15,
        8161,
        8165,
        4,
        8526,
        8580,
        54,
        11312,
        11359,
        1,
        11361,
        11365,
        4,
        11366,
        11372,
        2,
        11379,
        11382,
        3,
        11393,
        11491,
        2,
        11500,
        11502,
        2,
        11507,
        11520,
        13,
        11521,
        11557,
        1,
        11559,
        11565,
        6,
        42561,
        42605,
        2,
        42625,
        42651,
        2,
        42787,
        42799,
        2,
        42803,
        42863,
        2,
        42874,
        42876,
        2,
        42879,
        42887,
        2,
        42892,
        42897,
        5,
        42899,
        42900,
        1,
        42903,
        42921,
        2,
        42933,
        42947,
        2,
        42952,
        42954,
        2,
        42957,
        42961,
        4,
        42967,
        42971,
        2,
        42998,
        43859,
        861,
        43888,
        43967,
        1,
        65345,
        65370,
        1,
        66600,
        66639,
        1,
        66776,
        66811,
        1,
        66967,
        66977,
        1,
        66979,
        66993,
        1,
        66995,
        67001,
        1,
        67003,
        67004,
        1,
        68800,
        68850,
        1,
        68976,
        68997,
        1,
        71872,
        71903,
        1,
        93792,
        93823,
        1,
        125218,
        125251,
        1
    ]));
    static M = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        768,
        879,
        1,
        1155,
        1161,
        1,
        1425,
        1469,
        1,
        1471,
        1473,
        2,
        1474,
        1476,
        2,
        1477,
        1479,
        2,
        1552,
        1562,
        1,
        1611,
        1631,
        1,
        1648,
        1750,
        102,
        1751,
        1756,
        1,
        1759,
        1764,
        1,
        1767,
        1768,
        1,
        1770,
        1773,
        1,
        1809,
        1840,
        31,
        1841,
        1866,
        1,
        1958,
        1968,
        1,
        2027,
        2035,
        1,
        2045,
        2070,
        25,
        2071,
        2073,
        1,
        2075,
        2083,
        1,
        2085,
        2087,
        1,
        2089,
        2093,
        1,
        2137,
        2139,
        1,
        2199,
        2207,
        1,
        2250,
        2273,
        1,
        2275,
        2307,
        1,
        2362,
        2364,
        1,
        2366,
        2383,
        1,
        2385,
        2391,
        1,
        2402,
        2403,
        1,
        2433,
        2435,
        1,
        2492,
        2494,
        2,
        2495,
        2500,
        1,
        2503,
        2504,
        1,
        2507,
        2509,
        1,
        2519,
        2530,
        11,
        2531,
        2558,
        27,
        2561,
        2563,
        1,
        2620,
        2622,
        2,
        2623,
        2626,
        1,
        2631,
        2632,
        1,
        2635,
        2637,
        1,
        2641,
        2672,
        31,
        2673,
        2677,
        4,
        2689,
        2691,
        1,
        2748,
        2750,
        2,
        2751,
        2757,
        1,
        2759,
        2761,
        1,
        2763,
        2765,
        1,
        2786,
        2787,
        1,
        2810,
        2815,
        1,
        2817,
        2819,
        1,
        2876,
        2878,
        2,
        2879,
        2884,
        1,
        2887,
        2888,
        1,
        2891,
        2893,
        1,
        2901,
        2903,
        1,
        2914,
        2915,
        1,
        2946,
        3006,
        60,
        3007,
        3010,
        1,
        3014,
        3016,
        1,
        3018,
        3021,
        1,
        3031,
        3072,
        41,
        3073,
        3076,
        1,
        3132,
        3134,
        2,
        3135,
        3140,
        1,
        3142,
        3144,
        1,
        3146,
        3149,
        1,
        3157,
        3158,
        1,
        3170,
        3171,
        1,
        3201,
        3203,
        1,
        3260,
        3262,
        2,
        3263,
        3268,
        1,
        3270,
        3272,
        1,
        3274,
        3277,
        1,
        3285,
        3286,
        1,
        3298,
        3299,
        1,
        3315,
        3328,
        13,
        3329,
        3331,
        1,
        3387,
        3388,
        1,
        3390,
        3396,
        1,
        3398,
        3400,
        1,
        3402,
        3405,
        1,
        3415,
        3426,
        11,
        3427,
        3457,
        30,
        3458,
        3459,
        1,
        3530,
        3535,
        5,
        3536,
        3540,
        1,
        3542,
        3544,
        2,
        3545,
        3551,
        1,
        3570,
        3571,
        1,
        3633,
        3636,
        3,
        3637,
        3642,
        1,
        3655,
        3662,
        1,
        3761,
        3764,
        3,
        3765,
        3772,
        1,
        3784,
        3790,
        1,
        3864,
        3865,
        1,
        3893,
        3897,
        2,
        3902,
        3903,
        1,
        3953,
        3972,
        1,
        3974,
        3975,
        1,
        3981,
        3991,
        1,
        3993,
        4028,
        1,
        4038,
        4139,
        101,
        4140,
        4158,
        1,
        4182,
        4185,
        1,
        4190,
        4192,
        1,
        4194,
        4196,
        1,
        4199,
        4205,
        1,
        4209,
        4212,
        1,
        4226,
        4237,
        1,
        4239,
        4250,
        11,
        4251,
        4253,
        1,
        4957,
        4959,
        1,
        5906,
        5909,
        1,
        5938,
        5940,
        1,
        5970,
        5971,
        1,
        6002,
        6003,
        1,
        6068,
        6099,
        1,
        6109,
        6155,
        46,
        6156,
        6157,
        1,
        6159,
        6277,
        118,
        6278,
        6313,
        35,
        6432,
        6443,
        1,
        6448,
        6459,
        1,
        6679,
        6683,
        1,
        6741,
        6750,
        1,
        6752,
        6780,
        1,
        6783,
        6832,
        49,
        6833,
        6862,
        1,
        6912,
        6916,
        1,
        6964,
        6980,
        1,
        7019,
        7027,
        1,
        7040,
        7042,
        1,
        7073,
        7085,
        1,
        7142,
        7155,
        1,
        7204,
        7223,
        1,
        7376,
        7378,
        1,
        7380,
        7400,
        1,
        7405,
        7412,
        7,
        7415,
        7417,
        1,
        7616,
        7679,
        1,
        8400,
        8432,
        1,
        11503,
        11505,
        1,
        11647,
        11744,
        97,
        11745,
        11775,
        1,
        12330,
        12335,
        1,
        12441,
        12442,
        1,
        42607,
        42610,
        1,
        42612,
        42621,
        1,
        42654,
        42655,
        1,
        42736,
        42737,
        1,
        43010,
        43014,
        4,
        43019,
        43043,
        24,
        43044,
        43047,
        1,
        43052,
        43136,
        84,
        43137,
        43188,
        51,
        43189,
        43205,
        1,
        43232,
        43249,
        1,
        43263,
        43302,
        39,
        43303,
        43309,
        1,
        43335,
        43347,
        1,
        43392,
        43395,
        1,
        43443,
        43456,
        1,
        43493,
        43561,
        68,
        43562,
        43574,
        1,
        43587,
        43596,
        9,
        43597,
        43643,
        46,
        43644,
        43645,
        1,
        43696,
        43698,
        2,
        43699,
        43700,
        1,
        43703,
        43704,
        1,
        43710,
        43711,
        1,
        43713,
        43755,
        42,
        43756,
        43759,
        1,
        43765,
        43766,
        1,
        44003,
        44010,
        1,
        44012,
        44013,
        1,
        64286,
        65024,
        738,
        65025,
        65039,
        1,
        65056,
        65071,
        1,
        66045,
        66272,
        227,
        66422,
        66426,
        1,
        68097,
        68099,
        1,
        68101,
        68102,
        1,
        68108,
        68111,
        1,
        68152,
        68154,
        1,
        68159,
        68325,
        166,
        68326,
        68900,
        574,
        68901,
        68903,
        1,
        68969,
        68973,
        1,
        69291,
        69292,
        1,
        69372,
        69375,
        1,
        69446,
        69456,
        1,
        69506,
        69509,
        1,
        69632,
        69634,
        1,
        69688,
        69702,
        1,
        69744,
        69747,
        3,
        69748,
        69759,
        11,
        69760,
        69762,
        1,
        69808,
        69818,
        1,
        69826,
        69888,
        62,
        69889,
        69890,
        1,
        69927,
        69940,
        1,
        69957,
        69958,
        1,
        70003,
        70016,
        13,
        70017,
        70018,
        1,
        70067,
        70080,
        1,
        70089,
        70092,
        1,
        70094,
        70095,
        1,
        70188,
        70199,
        1,
        70206,
        70209,
        3,
        70367,
        70378,
        1,
        70400,
        70403,
        1,
        70459,
        70460,
        1,
        70462,
        70468,
        1,
        70471,
        70472,
        1,
        70475,
        70477,
        1,
        70487,
        70498,
        11,
        70499,
        70502,
        3,
        70503,
        70508,
        1,
        70512,
        70516,
        1,
        70584,
        70592,
        1,
        70594,
        70597,
        3,
        70599,
        70602,
        1,
        70604,
        70608,
        1,
        70610,
        70625,
        15,
        70626,
        70709,
        83,
        70710,
        70726,
        1,
        70750,
        70832,
        82,
        70833,
        70851,
        1,
        71087,
        71093,
        1,
        71096,
        71104,
        1,
        71132,
        71133,
        1,
        71216,
        71232,
        1,
        71339,
        71351,
        1,
        71453,
        71467,
        1,
        71724,
        71738,
        1,
        71984,
        71989,
        1,
        71991,
        71992,
        1,
        71995,
        71998,
        1,
        72000,
        72002,
        2,
        72003,
        72145,
        142,
        72146,
        72151,
        1,
        72154,
        72160,
        1,
        72164,
        72193,
        29,
        72194,
        72202,
        1,
        72243,
        72249,
        1,
        72251,
        72254,
        1,
        72263,
        72273,
        10,
        72274,
        72283,
        1,
        72330,
        72345,
        1,
        72751,
        72758,
        1,
        72760,
        72767,
        1,
        72850,
        72871,
        1,
        72873,
        72886,
        1,
        73009,
        73014,
        1,
        73018,
        73020,
        2,
        73021,
        73023,
        2,
        73024,
        73029,
        1,
        73031,
        73098,
        67,
        73099,
        73102,
        1,
        73104,
        73105,
        1,
        73107,
        73111,
        1,
        73459,
        73462,
        1,
        73472,
        73473,
        1,
        73475,
        73524,
        49,
        73525,
        73530,
        1,
        73534,
        73538,
        1,
        73562,
        78912,
        5350,
        78919,
        78933,
        1,
        90398,
        90415,
        1,
        92912,
        92916,
        1,
        92976,
        92982,
        1,
        94031,
        94033,
        2,
        94034,
        94087,
        1,
        94095,
        94098,
        1,
        94180,
        94192,
        12,
        94193,
        113821,
        19628,
        113822,
        118528,
        4706,
        118529,
        118573,
        1,
        118576,
        118598,
        1,
        119141,
        119145,
        1,
        119149,
        119154,
        1,
        119163,
        119170,
        1,
        119173,
        119179,
        1,
        119210,
        119213,
        1,
        119362,
        119364,
        1,
        121344,
        121398,
        1,
        121403,
        121452,
        1,
        121461,
        121476,
        15,
        121499,
        121503,
        1,
        121505,
        121519,
        1,
        122880,
        122886,
        1,
        122888,
        122904,
        1,
        122907,
        122913,
        1,
        122915,
        122916,
        1,
        122918,
        122922,
        1,
        123023,
        123184,
        161,
        123185,
        123190,
        1,
        123566,
        123628,
        62,
        123629,
        123631,
        1,
        124140,
        124143,
        1,
        124398,
        124399,
        1,
        125136,
        125142,
        1,
        125252,
        125258,
        1,
        917760,
        917999,
        1
    ]));
    static foldM = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        921,
        953,
        32,
        8126,
        8126,
        1
    ]));
    static Mc = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2307,
        2363,
        56,
        2366,
        2368,
        1,
        2377,
        2380,
        1,
        2382,
        2383,
        1,
        2434,
        2435,
        1,
        2494,
        2496,
        1,
        2503,
        2504,
        1,
        2507,
        2508,
        1,
        2519,
        2563,
        44,
        2622,
        2624,
        1,
        2691,
        2750,
        59,
        2751,
        2752,
        1,
        2761,
        2763,
        2,
        2764,
        2818,
        54,
        2819,
        2878,
        59,
        2880,
        2887,
        7,
        2888,
        2891,
        3,
        2892,
        2903,
        11,
        3006,
        3007,
        1,
        3009,
        3010,
        1,
        3014,
        3016,
        1,
        3018,
        3020,
        1,
        3031,
        3073,
        42,
        3074,
        3075,
        1,
        3137,
        3140,
        1,
        3202,
        3203,
        1,
        3262,
        3264,
        2,
        3265,
        3268,
        1,
        3271,
        3272,
        1,
        3274,
        3275,
        1,
        3285,
        3286,
        1,
        3315,
        3330,
        15,
        3331,
        3390,
        59,
        3391,
        3392,
        1,
        3398,
        3400,
        1,
        3402,
        3404,
        1,
        3415,
        3458,
        43,
        3459,
        3535,
        76,
        3536,
        3537,
        1,
        3544,
        3551,
        1,
        3570,
        3571,
        1,
        3902,
        3903,
        1,
        3967,
        4139,
        172,
        4140,
        4145,
        5,
        4152,
        4155,
        3,
        4156,
        4182,
        26,
        4183,
        4194,
        11,
        4195,
        4196,
        1,
        4199,
        4205,
        1,
        4227,
        4228,
        1,
        4231,
        4236,
        1,
        4239,
        4250,
        11,
        4251,
        4252,
        1,
        5909,
        5940,
        31,
        6070,
        6078,
        8,
        6079,
        6085,
        1,
        6087,
        6088,
        1,
        6435,
        6438,
        1,
        6441,
        6443,
        1,
        6448,
        6449,
        1,
        6451,
        6456,
        1,
        6681,
        6682,
        1,
        6741,
        6743,
        2,
        6753,
        6755,
        2,
        6756,
        6765,
        9,
        6766,
        6770,
        1,
        6916,
        6965,
        49,
        6971,
        6973,
        2,
        6974,
        6977,
        1,
        6979,
        6980,
        1,
        7042,
        7073,
        31,
        7078,
        7079,
        1,
        7082,
        7143,
        61,
        7146,
        7148,
        1,
        7150,
        7154,
        4,
        7155,
        7204,
        49,
        7205,
        7211,
        1,
        7220,
        7221,
        1,
        7393,
        7415,
        22,
        12334,
        12335,
        1,
        43043,
        43044,
        1,
        43047,
        43136,
        89,
        43137,
        43188,
        51,
        43189,
        43203,
        1,
        43346,
        43347,
        1,
        43395,
        43444,
        49,
        43445,
        43450,
        5,
        43451,
        43454,
        3,
        43455,
        43456,
        1,
        43567,
        43568,
        1,
        43571,
        43572,
        1,
        43597,
        43643,
        46,
        43645,
        43755,
        110,
        43758,
        43759,
        1,
        43765,
        44003,
        238,
        44004,
        44006,
        2,
        44007,
        44009,
        2,
        44010,
        44012,
        2,
        69632,
        69634,
        2,
        69762,
        69808,
        46,
        69809,
        69810,
        1,
        69815,
        69816,
        1,
        69932,
        69957,
        25,
        69958,
        70018,
        60,
        70067,
        70069,
        1,
        70079,
        70080,
        1,
        70094,
        70188,
        94,
        70189,
        70190,
        1,
        70194,
        70195,
        1,
        70197,
        70368,
        171,
        70369,
        70370,
        1,
        70402,
        70403,
        1,
        70462,
        70463,
        1,
        70465,
        70468,
        1,
        70471,
        70472,
        1,
        70475,
        70477,
        1,
        70487,
        70498,
        11,
        70499,
        70584,
        85,
        70585,
        70586,
        1,
        70594,
        70597,
        3,
        70599,
        70602,
        1,
        70604,
        70605,
        1,
        70607,
        70709,
        102,
        70710,
        70711,
        1,
        70720,
        70721,
        1,
        70725,
        70832,
        107,
        70833,
        70834,
        1,
        70841,
        70843,
        2,
        70844,
        70846,
        1,
        70849,
        71087,
        238,
        71088,
        71089,
        1,
        71096,
        71099,
        1,
        71102,
        71216,
        114,
        71217,
        71218,
        1,
        71227,
        71228,
        1,
        71230,
        71340,
        110,
        71342,
        71343,
        1,
        71350,
        71454,
        104,
        71456,
        71457,
        1,
        71462,
        71724,
        262,
        71725,
        71726,
        1,
        71736,
        71984,
        248,
        71985,
        71989,
        1,
        71991,
        71992,
        1,
        71997,
        72000,
        3,
        72002,
        72145,
        143,
        72146,
        72147,
        1,
        72156,
        72159,
        1,
        72164,
        72249,
        85,
        72279,
        72280,
        1,
        72343,
        72751,
        408,
        72766,
        72873,
        107,
        72881,
        72884,
        3,
        73098,
        73102,
        1,
        73107,
        73108,
        1,
        73110,
        73461,
        351,
        73462,
        73475,
        13,
        73524,
        73525,
        1,
        73534,
        73535,
        1,
        73537,
        90410,
        16873,
        90411,
        90412,
        1,
        94033,
        94087,
        1,
        94192,
        94193,
        1,
        119141,
        119142,
        1,
        119149,
        119154,
        1
    ]));
    static Me = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1160,
        1161,
        1,
        6846,
        8413,
        1567,
        8414,
        8416,
        1,
        8418,
        8420,
        1,
        42608,
        42610,
        1
    ]));
    static Mn = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        768,
        879,
        1,
        1155,
        1159,
        1,
        1425,
        1469,
        1,
        1471,
        1473,
        2,
        1474,
        1476,
        2,
        1477,
        1479,
        2,
        1552,
        1562,
        1,
        1611,
        1631,
        1,
        1648,
        1750,
        102,
        1751,
        1756,
        1,
        1759,
        1764,
        1,
        1767,
        1768,
        1,
        1770,
        1773,
        1,
        1809,
        1840,
        31,
        1841,
        1866,
        1,
        1958,
        1968,
        1,
        2027,
        2035,
        1,
        2045,
        2070,
        25,
        2071,
        2073,
        1,
        2075,
        2083,
        1,
        2085,
        2087,
        1,
        2089,
        2093,
        1,
        2137,
        2139,
        1,
        2199,
        2207,
        1,
        2250,
        2273,
        1,
        2275,
        2306,
        1,
        2362,
        2364,
        2,
        2369,
        2376,
        1,
        2381,
        2385,
        4,
        2386,
        2391,
        1,
        2402,
        2403,
        1,
        2433,
        2492,
        59,
        2497,
        2500,
        1,
        2509,
        2530,
        21,
        2531,
        2558,
        27,
        2561,
        2562,
        1,
        2620,
        2625,
        5,
        2626,
        2631,
        5,
        2632,
        2635,
        3,
        2636,
        2637,
        1,
        2641,
        2672,
        31,
        2673,
        2677,
        4,
        2689,
        2690,
        1,
        2748,
        2753,
        5,
        2754,
        2757,
        1,
        2759,
        2760,
        1,
        2765,
        2786,
        21,
        2787,
        2810,
        23,
        2811,
        2815,
        1,
        2817,
        2876,
        59,
        2879,
        2881,
        2,
        2882,
        2884,
        1,
        2893,
        2901,
        8,
        2902,
        2914,
        12,
        2915,
        2946,
        31,
        3008,
        3021,
        13,
        3072,
        3076,
        4,
        3132,
        3134,
        2,
        3135,
        3136,
        1,
        3142,
        3144,
        1,
        3146,
        3149,
        1,
        3157,
        3158,
        1,
        3170,
        3171,
        1,
        3201,
        3260,
        59,
        3263,
        3270,
        7,
        3276,
        3277,
        1,
        3298,
        3299,
        1,
        3328,
        3329,
        1,
        3387,
        3388,
        1,
        3393,
        3396,
        1,
        3405,
        3426,
        21,
        3427,
        3457,
        30,
        3530,
        3538,
        8,
        3539,
        3540,
        1,
        3542,
        3633,
        91,
        3636,
        3642,
        1,
        3655,
        3662,
        1,
        3761,
        3764,
        3,
        3765,
        3772,
        1,
        3784,
        3790,
        1,
        3864,
        3865,
        1,
        3893,
        3897,
        2,
        3953,
        3966,
        1,
        3968,
        3972,
        1,
        3974,
        3975,
        1,
        3981,
        3991,
        1,
        3993,
        4028,
        1,
        4038,
        4141,
        103,
        4142,
        4144,
        1,
        4146,
        4151,
        1,
        4153,
        4154,
        1,
        4157,
        4158,
        1,
        4184,
        4185,
        1,
        4190,
        4192,
        1,
        4209,
        4212,
        1,
        4226,
        4229,
        3,
        4230,
        4237,
        7,
        4253,
        4957,
        704,
        4958,
        4959,
        1,
        5906,
        5908,
        1,
        5938,
        5939,
        1,
        5970,
        5971,
        1,
        6002,
        6003,
        1,
        6068,
        6069,
        1,
        6071,
        6077,
        1,
        6086,
        6089,
        3,
        6090,
        6099,
        1,
        6109,
        6155,
        46,
        6156,
        6157,
        1,
        6159,
        6277,
        118,
        6278,
        6313,
        35,
        6432,
        6434,
        1,
        6439,
        6440,
        1,
        6450,
        6457,
        7,
        6458,
        6459,
        1,
        6679,
        6680,
        1,
        6683,
        6742,
        59,
        6744,
        6750,
        1,
        6752,
        6754,
        2,
        6757,
        6764,
        1,
        6771,
        6780,
        1,
        6783,
        6832,
        49,
        6833,
        6845,
        1,
        6847,
        6862,
        1,
        6912,
        6915,
        1,
        6964,
        6966,
        2,
        6967,
        6970,
        1,
        6972,
        6978,
        6,
        7019,
        7027,
        1,
        7040,
        7041,
        1,
        7074,
        7077,
        1,
        7080,
        7081,
        1,
        7083,
        7085,
        1,
        7142,
        7144,
        2,
        7145,
        7149,
        4,
        7151,
        7153,
        1,
        7212,
        7219,
        1,
        7222,
        7223,
        1,
        7376,
        7378,
        1,
        7380,
        7392,
        1,
        7394,
        7400,
        1,
        7405,
        7412,
        7,
        7416,
        7417,
        1,
        7616,
        7679,
        1,
        8400,
        8412,
        1,
        8417,
        8421,
        4,
        8422,
        8432,
        1,
        11503,
        11505,
        1,
        11647,
        11744,
        97,
        11745,
        11775,
        1,
        12330,
        12333,
        1,
        12441,
        12442,
        1,
        42607,
        42612,
        5,
        42613,
        42621,
        1,
        42654,
        42655,
        1,
        42736,
        42737,
        1,
        43010,
        43014,
        4,
        43019,
        43045,
        26,
        43046,
        43052,
        6,
        43204,
        43205,
        1,
        43232,
        43249,
        1,
        43263,
        43302,
        39,
        43303,
        43309,
        1,
        43335,
        43345,
        1,
        43392,
        43394,
        1,
        43443,
        43446,
        3,
        43447,
        43449,
        1,
        43452,
        43453,
        1,
        43493,
        43561,
        68,
        43562,
        43566,
        1,
        43569,
        43570,
        1,
        43573,
        43574,
        1,
        43587,
        43596,
        9,
        43644,
        43696,
        52,
        43698,
        43700,
        1,
        43703,
        43704,
        1,
        43710,
        43711,
        1,
        43713,
        43756,
        43,
        43757,
        43766,
        9,
        44005,
        44008,
        3,
        44013,
        64286,
        20273,
        65024,
        65039,
        1,
        65056,
        65071,
        1,
        66045,
        66272,
        227,
        66422,
        66426,
        1,
        68097,
        68099,
        1,
        68101,
        68102,
        1,
        68108,
        68111,
        1,
        68152,
        68154,
        1,
        68159,
        68325,
        166,
        68326,
        68900,
        574,
        68901,
        68903,
        1,
        68969,
        68973,
        1,
        69291,
        69292,
        1,
        69372,
        69375,
        1,
        69446,
        69456,
        1,
        69506,
        69509,
        1,
        69633,
        69688,
        55,
        69689,
        69702,
        1,
        69744,
        69747,
        3,
        69748,
        69759,
        11,
        69760,
        69761,
        1,
        69811,
        69814,
        1,
        69817,
        69818,
        1,
        69826,
        69888,
        62,
        69889,
        69890,
        1,
        69927,
        69931,
        1,
        69933,
        69940,
        1,
        70003,
        70016,
        13,
        70017,
        70070,
        53,
        70071,
        70078,
        1,
        70089,
        70092,
        1,
        70095,
        70191,
        96,
        70192,
        70193,
        1,
        70196,
        70198,
        2,
        70199,
        70206,
        7,
        70209,
        70367,
        158,
        70371,
        70378,
        1,
        70400,
        70401,
        1,
        70459,
        70460,
        1,
        70464,
        70502,
        38,
        70503,
        70508,
        1,
        70512,
        70516,
        1,
        70587,
        70592,
        1,
        70606,
        70610,
        2,
        70625,
        70626,
        1,
        70712,
        70719,
        1,
        70722,
        70724,
        1,
        70726,
        70750,
        24,
        70835,
        70840,
        1,
        70842,
        70847,
        5,
        70848,
        70850,
        2,
        70851,
        71090,
        239,
        71091,
        71093,
        1,
        71100,
        71101,
        1,
        71103,
        71104,
        1,
        71132,
        71133,
        1,
        71219,
        71226,
        1,
        71229,
        71231,
        2,
        71232,
        71339,
        107,
        71341,
        71344,
        3,
        71345,
        71349,
        1,
        71351,
        71453,
        102,
        71455,
        71458,
        3,
        71459,
        71461,
        1,
        71463,
        71467,
        1,
        71727,
        71735,
        1,
        71737,
        71738,
        1,
        71995,
        71996,
        1,
        71998,
        72003,
        5,
        72148,
        72151,
        1,
        72154,
        72155,
        1,
        72160,
        72193,
        33,
        72194,
        72202,
        1,
        72243,
        72248,
        1,
        72251,
        72254,
        1,
        72263,
        72273,
        10,
        72274,
        72278,
        1,
        72281,
        72283,
        1,
        72330,
        72342,
        1,
        72344,
        72345,
        1,
        72752,
        72758,
        1,
        72760,
        72765,
        1,
        72767,
        72850,
        83,
        72851,
        72871,
        1,
        72874,
        72880,
        1,
        72882,
        72883,
        1,
        72885,
        72886,
        1,
        73009,
        73014,
        1,
        73018,
        73020,
        2,
        73021,
        73023,
        2,
        73024,
        73029,
        1,
        73031,
        73104,
        73,
        73105,
        73109,
        4,
        73111,
        73459,
        348,
        73460,
        73472,
        12,
        73473,
        73526,
        53,
        73527,
        73530,
        1,
        73536,
        73538,
        2,
        73562,
        78912,
        5350,
        78919,
        78933,
        1,
        90398,
        90409,
        1,
        90413,
        90415,
        1,
        92912,
        92916,
        1,
        92976,
        92982,
        1,
        94031,
        94095,
        64,
        94096,
        94098,
        1,
        94180,
        113821,
        19641,
        113822,
        118528,
        4706,
        118529,
        118573,
        1,
        118576,
        118598,
        1,
        119143,
        119145,
        1,
        119163,
        119170,
        1,
        119173,
        119179,
        1,
        119210,
        119213,
        1,
        119362,
        119364,
        1,
        121344,
        121398,
        1,
        121403,
        121452,
        1,
        121461,
        121476,
        15,
        121499,
        121503,
        1,
        121505,
        121519,
        1,
        122880,
        122886,
        1,
        122888,
        122904,
        1,
        122907,
        122913,
        1,
        122915,
        122916,
        1,
        122918,
        122922,
        1,
        123023,
        123184,
        161,
        123185,
        123190,
        1,
        123566,
        123628,
        62,
        123629,
        123631,
        1,
        124140,
        124143,
        1,
        124398,
        124399,
        1,
        125136,
        125142,
        1,
        125252,
        125258,
        1,
        917760,
        917999,
        1
    ]));
    static foldMn = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        921,
        953,
        32,
        8126,
        8126,
        1
    ]));
    static N = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        48,
        57,
        1,
        178,
        179,
        1,
        185,
        188,
        3,
        189,
        190,
        1,
        1632,
        1641,
        1,
        1776,
        1785,
        1,
        1984,
        1993,
        1,
        2406,
        2415,
        1,
        2534,
        2543,
        1,
        2548,
        2553,
        1,
        2662,
        2671,
        1,
        2790,
        2799,
        1,
        2918,
        2927,
        1,
        2930,
        2935,
        1,
        3046,
        3058,
        1,
        3174,
        3183,
        1,
        3192,
        3198,
        1,
        3302,
        3311,
        1,
        3416,
        3422,
        1,
        3430,
        3448,
        1,
        3558,
        3567,
        1,
        3664,
        3673,
        1,
        3792,
        3801,
        1,
        3872,
        3891,
        1,
        4160,
        4169,
        1,
        4240,
        4249,
        1,
        4969,
        4988,
        1,
        5870,
        5872,
        1,
        6112,
        6121,
        1,
        6128,
        6137,
        1,
        6160,
        6169,
        1,
        6470,
        6479,
        1,
        6608,
        6618,
        1,
        6784,
        6793,
        1,
        6800,
        6809,
        1,
        6992,
        7001,
        1,
        7088,
        7097,
        1,
        7232,
        7241,
        1,
        7248,
        7257,
        1,
        8304,
        8308,
        4,
        8309,
        8313,
        1,
        8320,
        8329,
        1,
        8528,
        8578,
        1,
        8581,
        8585,
        1,
        9312,
        9371,
        1,
        9450,
        9471,
        1,
        10102,
        10131,
        1,
        11517,
        12295,
        778,
        12321,
        12329,
        1,
        12344,
        12346,
        1,
        12690,
        12693,
        1,
        12832,
        12841,
        1,
        12872,
        12879,
        1,
        12881,
        12895,
        1,
        12928,
        12937,
        1,
        12977,
        12991,
        1,
        42528,
        42537,
        1,
        42726,
        42735,
        1,
        43056,
        43061,
        1,
        43216,
        43225,
        1,
        43264,
        43273,
        1,
        43472,
        43481,
        1,
        43504,
        43513,
        1,
        43600,
        43609,
        1,
        44016,
        44025,
        1,
        65296,
        65305,
        1,
        65799,
        65843,
        1,
        65856,
        65912,
        1,
        65930,
        65931,
        1,
        66273,
        66299,
        1,
        66336,
        66339,
        1,
        66369,
        66378,
        9,
        66513,
        66517,
        1,
        66720,
        66729,
        1,
        67672,
        67679,
        1,
        67705,
        67711,
        1,
        67751,
        67759,
        1,
        67835,
        67839,
        1,
        67862,
        67867,
        1,
        68028,
        68029,
        1,
        68032,
        68047,
        1,
        68050,
        68095,
        1,
        68160,
        68168,
        1,
        68221,
        68222,
        1,
        68253,
        68255,
        1,
        68331,
        68335,
        1,
        68440,
        68447,
        1,
        68472,
        68479,
        1,
        68521,
        68527,
        1,
        68858,
        68863,
        1,
        68912,
        68921,
        1,
        68928,
        68937,
        1,
        69216,
        69246,
        1,
        69405,
        69414,
        1,
        69457,
        69460,
        1,
        69573,
        69579,
        1,
        69714,
        69743,
        1,
        69872,
        69881,
        1,
        69942,
        69951,
        1,
        70096,
        70105,
        1,
        70113,
        70132,
        1,
        70384,
        70393,
        1,
        70736,
        70745,
        1,
        70864,
        70873,
        1,
        71248,
        71257,
        1,
        71360,
        71369,
        1,
        71376,
        71395,
        1,
        71472,
        71483,
        1,
        71904,
        71922,
        1,
        72016,
        72025,
        1,
        72688,
        72697,
        1,
        72784,
        72812,
        1,
        73040,
        73049,
        1,
        73120,
        73129,
        1,
        73552,
        73561,
        1,
        73664,
        73684,
        1,
        74752,
        74862,
        1,
        90416,
        90425,
        1,
        92768,
        92777,
        1,
        92864,
        92873,
        1,
        93008,
        93017,
        1,
        93019,
        93025,
        1,
        93552,
        93561,
        1,
        93824,
        93846,
        1,
        118000,
        118009,
        1,
        119488,
        119507,
        1,
        119520,
        119539,
        1,
        119648,
        119672,
        1,
        120782,
        120831,
        1,
        123200,
        123209,
        1,
        123632,
        123641,
        1,
        124144,
        124153,
        1,
        124401,
        124410,
        1,
        125127,
        125135,
        1,
        125264,
        125273,
        1,
        126065,
        126123,
        1,
        126125,
        126127,
        1,
        126129,
        126132,
        1,
        126209,
        126253,
        1,
        126255,
        126269,
        1,
        127232,
        127244,
        1,
        130032,
        130041,
        1
    ]));
    static Nd = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        48,
        57,
        1,
        1632,
        1641,
        1,
        1776,
        1785,
        1,
        1984,
        1993,
        1,
        2406,
        2415,
        1,
        2534,
        2543,
        1,
        2662,
        2671,
        1,
        2790,
        2799,
        1,
        2918,
        2927,
        1,
        3046,
        3055,
        1,
        3174,
        3183,
        1,
        3302,
        3311,
        1,
        3430,
        3439,
        1,
        3558,
        3567,
        1,
        3664,
        3673,
        1,
        3792,
        3801,
        1,
        3872,
        3881,
        1,
        4160,
        4169,
        1,
        4240,
        4249,
        1,
        6112,
        6121,
        1,
        6160,
        6169,
        1,
        6470,
        6479,
        1,
        6608,
        6617,
        1,
        6784,
        6793,
        1,
        6800,
        6809,
        1,
        6992,
        7001,
        1,
        7088,
        7097,
        1,
        7232,
        7241,
        1,
        7248,
        7257,
        1,
        42528,
        42537,
        1,
        43216,
        43225,
        1,
        43264,
        43273,
        1,
        43472,
        43481,
        1,
        43504,
        43513,
        1,
        43600,
        43609,
        1,
        44016,
        44025,
        1,
        65296,
        65305,
        1,
        66720,
        66729,
        1,
        68912,
        68921,
        1,
        68928,
        68937,
        1,
        69734,
        69743,
        1,
        69872,
        69881,
        1,
        69942,
        69951,
        1,
        70096,
        70105,
        1,
        70384,
        70393,
        1,
        70736,
        70745,
        1,
        70864,
        70873,
        1,
        71248,
        71257,
        1,
        71360,
        71369,
        1,
        71376,
        71395,
        1,
        71472,
        71481,
        1,
        71904,
        71913,
        1,
        72016,
        72025,
        1,
        72688,
        72697,
        1,
        72784,
        72793,
        1,
        73040,
        73049,
        1,
        73120,
        73129,
        1,
        73552,
        73561,
        1,
        90416,
        90425,
        1,
        92768,
        92777,
        1,
        92864,
        92873,
        1,
        93008,
        93017,
        1,
        93552,
        93561,
        1,
        118000,
        118009,
        1,
        120782,
        120831,
        1,
        123200,
        123209,
        1,
        123632,
        123641,
        1,
        124144,
        124153,
        1,
        124401,
        124410,
        1,
        125264,
        125273,
        1,
        130032,
        130041,
        1
    ]));
    static Nl = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5870,
        5872,
        1,
        8544,
        8578,
        1,
        8581,
        8584,
        1,
        12295,
        12321,
        26,
        12322,
        12329,
        1,
        12344,
        12346,
        1,
        42726,
        42735,
        1,
        65856,
        65908,
        1,
        66369,
        66378,
        9,
        66513,
        66517,
        1,
        74752,
        74862,
        1
    ]));
    static No = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        178,
        179,
        1,
        185,
        188,
        3,
        189,
        190,
        1,
        2548,
        2553,
        1,
        2930,
        2935,
        1,
        3056,
        3058,
        1,
        3192,
        3198,
        1,
        3416,
        3422,
        1,
        3440,
        3448,
        1,
        3882,
        3891,
        1,
        4969,
        4988,
        1,
        6128,
        6137,
        1,
        6618,
        8304,
        1686,
        8308,
        8313,
        1,
        8320,
        8329,
        1,
        8528,
        8543,
        1,
        8585,
        9312,
        727,
        9313,
        9371,
        1,
        9450,
        9471,
        1,
        10102,
        10131,
        1,
        11517,
        12690,
        1173,
        12691,
        12693,
        1,
        12832,
        12841,
        1,
        12872,
        12879,
        1,
        12881,
        12895,
        1,
        12928,
        12937,
        1,
        12977,
        12991,
        1,
        43056,
        43061,
        1,
        65799,
        65843,
        1,
        65909,
        65912,
        1,
        65930,
        65931,
        1,
        66273,
        66299,
        1,
        66336,
        66339,
        1,
        67672,
        67679,
        1,
        67705,
        67711,
        1,
        67751,
        67759,
        1,
        67835,
        67839,
        1,
        67862,
        67867,
        1,
        68028,
        68029,
        1,
        68032,
        68047,
        1,
        68050,
        68095,
        1,
        68160,
        68168,
        1,
        68221,
        68222,
        1,
        68253,
        68255,
        1,
        68331,
        68335,
        1,
        68440,
        68447,
        1,
        68472,
        68479,
        1,
        68521,
        68527,
        1,
        68858,
        68863,
        1,
        69216,
        69246,
        1,
        69405,
        69414,
        1,
        69457,
        69460,
        1,
        69573,
        69579,
        1,
        69714,
        69733,
        1,
        70113,
        70132,
        1,
        71482,
        71483,
        1,
        71914,
        71922,
        1,
        72794,
        72812,
        1,
        73664,
        73684,
        1,
        93019,
        93025,
        1,
        93824,
        93846,
        1,
        119488,
        119507,
        1,
        119520,
        119539,
        1,
        119648,
        119672,
        1,
        125127,
        125135,
        1,
        126065,
        126123,
        1,
        126125,
        126127,
        1,
        126129,
        126132,
        1,
        126209,
        126253,
        1,
        126255,
        126269,
        1,
        127232,
        127244,
        1
    ]));
    static P = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        33,
        35,
        1,
        37,
        42,
        1,
        44,
        47,
        1,
        58,
        59,
        1,
        63,
        64,
        1,
        91,
        93,
        1,
        95,
        123,
        28,
        125,
        161,
        36,
        167,
        171,
        4,
        182,
        183,
        1,
        187,
        191,
        4,
        894,
        903,
        9,
        1370,
        1375,
        1,
        1417,
        1418,
        1,
        1470,
        1472,
        2,
        1475,
        1478,
        3,
        1523,
        1524,
        1,
        1545,
        1546,
        1,
        1548,
        1549,
        1,
        1563,
        1565,
        2,
        1566,
        1567,
        1,
        1642,
        1645,
        1,
        1748,
        1792,
        44,
        1793,
        1805,
        1,
        2039,
        2041,
        1,
        2096,
        2110,
        1,
        2142,
        2404,
        262,
        2405,
        2416,
        11,
        2557,
        2678,
        121,
        2800,
        3191,
        391,
        3204,
        3572,
        368,
        3663,
        3674,
        11,
        3675,
        3844,
        169,
        3845,
        3858,
        1,
        3860,
        3898,
        38,
        3899,
        3901,
        1,
        3973,
        4048,
        75,
        4049,
        4052,
        1,
        4057,
        4058,
        1,
        4170,
        4175,
        1,
        4347,
        4960,
        613,
        4961,
        4968,
        1,
        5120,
        5742,
        622,
        5787,
        5788,
        1,
        5867,
        5869,
        1,
        5941,
        5942,
        1,
        6100,
        6102,
        1,
        6104,
        6106,
        1,
        6144,
        6154,
        1,
        6468,
        6469,
        1,
        6686,
        6687,
        1,
        6816,
        6822,
        1,
        6824,
        6829,
        1,
        6990,
        6991,
        1,
        7002,
        7008,
        1,
        7037,
        7039,
        1,
        7164,
        7167,
        1,
        7227,
        7231,
        1,
        7294,
        7295,
        1,
        7360,
        7367,
        1,
        7379,
        8208,
        829,
        8209,
        8231,
        1,
        8240,
        8259,
        1,
        8261,
        8273,
        1,
        8275,
        8286,
        1,
        8317,
        8318,
        1,
        8333,
        8334,
        1,
        8968,
        8971,
        1,
        9001,
        9002,
        1,
        10088,
        10101,
        1,
        10181,
        10182,
        1,
        10214,
        10223,
        1,
        10627,
        10648,
        1,
        10712,
        10715,
        1,
        10748,
        10749,
        1,
        11513,
        11516,
        1,
        11518,
        11519,
        1,
        11632,
        11776,
        144,
        11777,
        11822,
        1,
        11824,
        11855,
        1,
        11858,
        11869,
        1,
        12289,
        12291,
        1,
        12296,
        12305,
        1,
        12308,
        12319,
        1,
        12336,
        12349,
        13,
        12448,
        12539,
        91,
        42238,
        42239,
        1,
        42509,
        42511,
        1,
        42611,
        42622,
        11,
        42738,
        42743,
        1,
        43124,
        43127,
        1,
        43214,
        43215,
        1,
        43256,
        43258,
        1,
        43260,
        43310,
        50,
        43311,
        43359,
        48,
        43457,
        43469,
        1,
        43486,
        43487,
        1,
        43612,
        43615,
        1,
        43742,
        43743,
        1,
        43760,
        43761,
        1,
        44011,
        64830,
        20819,
        64831,
        65040,
        209,
        65041,
        65049,
        1,
        65072,
        65106,
        1,
        65108,
        65121,
        1,
        65123,
        65128,
        5,
        65130,
        65131,
        1,
        65281,
        65283,
        1,
        65285,
        65290,
        1,
        65292,
        65295,
        1,
        65306,
        65307,
        1,
        65311,
        65312,
        1,
        65339,
        65341,
        1,
        65343,
        65371,
        28,
        65373,
        65375,
        2,
        65376,
        65381,
        1,
        65792,
        65794,
        1,
        66463,
        66512,
        49,
        66927,
        67671,
        744,
        67871,
        67903,
        32,
        68176,
        68184,
        1,
        68223,
        68336,
        113,
        68337,
        68342,
        1,
        68409,
        68415,
        1,
        68505,
        68508,
        1,
        68974,
        69293,
        319,
        69461,
        69465,
        1,
        69510,
        69513,
        1,
        69703,
        69709,
        1,
        69819,
        69820,
        1,
        69822,
        69825,
        1,
        69952,
        69955,
        1,
        70004,
        70005,
        1,
        70085,
        70088,
        1,
        70093,
        70107,
        14,
        70109,
        70111,
        1,
        70200,
        70205,
        1,
        70313,
        70612,
        299,
        70613,
        70615,
        2,
        70616,
        70731,
        115,
        70732,
        70735,
        1,
        70746,
        70747,
        1,
        70749,
        70854,
        105,
        71105,
        71127,
        1,
        71233,
        71235,
        1,
        71264,
        71276,
        1,
        71353,
        71484,
        131,
        71485,
        71486,
        1,
        71739,
        72004,
        265,
        72005,
        72006,
        1,
        72162,
        72255,
        93,
        72256,
        72262,
        1,
        72346,
        72348,
        1,
        72350,
        72354,
        1,
        72448,
        72457,
        1,
        72673,
        72769,
        96,
        72770,
        72773,
        1,
        72816,
        72817,
        1,
        73463,
        73464,
        1,
        73539,
        73551,
        1,
        73727,
        74864,
        1137,
        74865,
        74868,
        1,
        77809,
        77810,
        1,
        92782,
        92783,
        1,
        92917,
        92983,
        66,
        92984,
        92987,
        1,
        92996,
        93549,
        553,
        93550,
        93551,
        1,
        93847,
        93850,
        1,
        94178,
        113823,
        19645,
        121479,
        121483,
        1,
        124415,
        125278,
        863,
        125279,
        125279,
        1
    ]));
    static Pc = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        95,
        8255,
        8160,
        8256,
        8276,
        20,
        65075,
        65076,
        1,
        65101,
        65103,
        1,
        65343,
        65343,
        1
    ]));
    static Pd = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        45,
        1418,
        1373,
        1470,
        5120,
        3650,
        6150,
        8208,
        2058,
        8209,
        8213,
        1,
        11799,
        11802,
        3,
        11834,
        11835,
        1,
        11840,
        11869,
        29,
        12316,
        12336,
        20,
        12448,
        65073,
        52625,
        65074,
        65112,
        38,
        65123,
        65293,
        170,
        68974,
        69293,
        319
    ]));
    static Pe = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        41,
        93,
        52,
        125,
        3899,
        3774,
        3901,
        5788,
        1887,
        8262,
        8318,
        56,
        8334,
        8969,
        635,
        8971,
        9002,
        31,
        10089,
        10101,
        2,
        10182,
        10215,
        33,
        10217,
        10223,
        2,
        10628,
        10648,
        2,
        10713,
        10715,
        2,
        10749,
        11811,
        1062,
        11813,
        11817,
        2,
        11862,
        11868,
        2,
        12297,
        12305,
        2,
        12309,
        12315,
        2,
        12318,
        12319,
        1,
        64830,
        65048,
        218,
        65078,
        65092,
        2,
        65096,
        65114,
        18,
        65116,
        65118,
        2,
        65289,
        65341,
        52,
        65373,
        65379,
        3
    ]));
    static Pf = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        187,
        8217,
        8030,
        8221,
        8250,
        29,
        11779,
        11781,
        2,
        11786,
        11789,
        3,
        11805,
        11809,
        4
    ]));
    static Pi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        171,
        8216,
        8045,
        8219,
        8220,
        1,
        8223,
        8249,
        26,
        11778,
        11780,
        2,
        11785,
        11788,
        3,
        11804,
        11808,
        4
    ]));
    static Po = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        33,
        35,
        1,
        37,
        39,
        1,
        42,
        46,
        2,
        47,
        58,
        11,
        59,
        63,
        4,
        64,
        92,
        28,
        161,
        167,
        6,
        182,
        183,
        1,
        191,
        894,
        703,
        903,
        1370,
        467,
        1371,
        1375,
        1,
        1417,
        1472,
        55,
        1475,
        1478,
        3,
        1523,
        1524,
        1,
        1545,
        1546,
        1,
        1548,
        1549,
        1,
        1563,
        1565,
        2,
        1566,
        1567,
        1,
        1642,
        1645,
        1,
        1748,
        1792,
        44,
        1793,
        1805,
        1,
        2039,
        2041,
        1,
        2096,
        2110,
        1,
        2142,
        2404,
        262,
        2405,
        2416,
        11,
        2557,
        2678,
        121,
        2800,
        3191,
        391,
        3204,
        3572,
        368,
        3663,
        3674,
        11,
        3675,
        3844,
        169,
        3845,
        3858,
        1,
        3860,
        3973,
        113,
        4048,
        4052,
        1,
        4057,
        4058,
        1,
        4170,
        4175,
        1,
        4347,
        4960,
        613,
        4961,
        4968,
        1,
        5742,
        5867,
        125,
        5868,
        5869,
        1,
        5941,
        5942,
        1,
        6100,
        6102,
        1,
        6104,
        6106,
        1,
        6144,
        6149,
        1,
        6151,
        6154,
        1,
        6468,
        6469,
        1,
        6686,
        6687,
        1,
        6816,
        6822,
        1,
        6824,
        6829,
        1,
        6990,
        6991,
        1,
        7002,
        7008,
        1,
        7037,
        7039,
        1,
        7164,
        7167,
        1,
        7227,
        7231,
        1,
        7294,
        7295,
        1,
        7360,
        7367,
        1,
        7379,
        8214,
        835,
        8215,
        8224,
        9,
        8225,
        8231,
        1,
        8240,
        8248,
        1,
        8251,
        8254,
        1,
        8257,
        8259,
        1,
        8263,
        8273,
        1,
        8275,
        8277,
        2,
        8278,
        8286,
        1,
        11513,
        11516,
        1,
        11518,
        11519,
        1,
        11632,
        11776,
        144,
        11777,
        11782,
        5,
        11783,
        11784,
        1,
        11787,
        11790,
        3,
        11791,
        11798,
        1,
        11800,
        11801,
        1,
        11803,
        11806,
        3,
        11807,
        11818,
        11,
        11819,
        11822,
        1,
        11824,
        11833,
        1,
        11836,
        11839,
        1,
        11841,
        11843,
        2,
        11844,
        11855,
        1,
        11858,
        11860,
        1,
        12289,
        12291,
        1,
        12349,
        12539,
        190,
        42238,
        42239,
        1,
        42509,
        42511,
        1,
        42611,
        42622,
        11,
        42738,
        42743,
        1,
        43124,
        43127,
        1,
        43214,
        43215,
        1,
        43256,
        43258,
        1,
        43260,
        43310,
        50,
        43311,
        43359,
        48,
        43457,
        43469,
        1,
        43486,
        43487,
        1,
        43612,
        43615,
        1,
        43742,
        43743,
        1,
        43760,
        43761,
        1,
        44011,
        65040,
        21029,
        65041,
        65046,
        1,
        65049,
        65072,
        23,
        65093,
        65094,
        1,
        65097,
        65100,
        1,
        65104,
        65106,
        1,
        65108,
        65111,
        1,
        65119,
        65121,
        1,
        65128,
        65130,
        2,
        65131,
        65281,
        150,
        65282,
        65283,
        1,
        65285,
        65287,
        1,
        65290,
        65294,
        2,
        65295,
        65306,
        11,
        65307,
        65311,
        4,
        65312,
        65340,
        28,
        65377,
        65380,
        3,
        65381,
        65792,
        411,
        65793,
        65794,
        1,
        66463,
        66512,
        49,
        66927,
        67671,
        744,
        67871,
        67903,
        32,
        68176,
        68184,
        1,
        68223,
        68336,
        113,
        68337,
        68342,
        1,
        68409,
        68415,
        1,
        68505,
        68508,
        1,
        69461,
        69465,
        1,
        69510,
        69513,
        1,
        69703,
        69709,
        1,
        69819,
        69820,
        1,
        69822,
        69825,
        1,
        69952,
        69955,
        1,
        70004,
        70005,
        1,
        70085,
        70088,
        1,
        70093,
        70107,
        14,
        70109,
        70111,
        1,
        70200,
        70205,
        1,
        70313,
        70612,
        299,
        70613,
        70615,
        2,
        70616,
        70731,
        115,
        70732,
        70735,
        1,
        70746,
        70747,
        1,
        70749,
        70854,
        105,
        71105,
        71127,
        1,
        71233,
        71235,
        1,
        71264,
        71276,
        1,
        71353,
        71484,
        131,
        71485,
        71486,
        1,
        71739,
        72004,
        265,
        72005,
        72006,
        1,
        72162,
        72255,
        93,
        72256,
        72262,
        1,
        72346,
        72348,
        1,
        72350,
        72354,
        1,
        72448,
        72457,
        1,
        72673,
        72769,
        96,
        72770,
        72773,
        1,
        72816,
        72817,
        1,
        73463,
        73464,
        1,
        73539,
        73551,
        1,
        73727,
        74864,
        1137,
        74865,
        74868,
        1,
        77809,
        77810,
        1,
        92782,
        92783,
        1,
        92917,
        92983,
        66,
        92984,
        92987,
        1,
        92996,
        93549,
        553,
        93550,
        93551,
        1,
        93847,
        93850,
        1,
        94178,
        113823,
        19645,
        121479,
        121483,
        1,
        124415,
        125278,
        863,
        125279,
        125279,
        1
    ]));
    static Ps = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        40,
        91,
        51,
        123,
        3898,
        3775,
        3900,
        5787,
        1887,
        8218,
        8222,
        4,
        8261,
        8317,
        56,
        8333,
        8968,
        635,
        8970,
        9001,
        31,
        10088,
        10100,
        2,
        10181,
        10214,
        33,
        10216,
        10222,
        2,
        10627,
        10647,
        2,
        10712,
        10714,
        2,
        10748,
        11810,
        1062,
        11812,
        11816,
        2,
        11842,
        11861,
        19,
        11863,
        11867,
        2,
        12296,
        12304,
        2,
        12308,
        12314,
        2,
        12317,
        64831,
        52514,
        65047,
        65077,
        30,
        65079,
        65091,
        2,
        65095,
        65113,
        18,
        65115,
        65117,
        2,
        65288,
        65339,
        51,
        65371,
        65375,
        4,
        65378,
        65378,
        1
    ]));
    static S = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        36,
        43,
        7,
        60,
        62,
        1,
        94,
        96,
        2,
        124,
        126,
        2,
        162,
        166,
        1,
        168,
        169,
        1,
        172,
        174,
        2,
        175,
        177,
        1,
        180,
        184,
        4,
        215,
        247,
        32,
        706,
        709,
        1,
        722,
        735,
        1,
        741,
        747,
        1,
        749,
        751,
        2,
        752,
        767,
        1,
        885,
        900,
        15,
        901,
        1014,
        113,
        1154,
        1421,
        267,
        1422,
        1423,
        1,
        1542,
        1544,
        1,
        1547,
        1550,
        3,
        1551,
        1758,
        207,
        1769,
        1789,
        20,
        1790,
        2038,
        248,
        2046,
        2047,
        1,
        2184,
        2546,
        362,
        2547,
        2554,
        7,
        2555,
        2801,
        246,
        2928,
        3059,
        131,
        3060,
        3066,
        1,
        3199,
        3407,
        208,
        3449,
        3647,
        198,
        3841,
        3843,
        1,
        3859,
        3861,
        2,
        3862,
        3863,
        1,
        3866,
        3871,
        1,
        3892,
        3896,
        2,
        4030,
        4037,
        1,
        4039,
        4044,
        1,
        4046,
        4047,
        1,
        4053,
        4056,
        1,
        4254,
        4255,
        1,
        5008,
        5017,
        1,
        5741,
        6107,
        366,
        6464,
        6622,
        158,
        6623,
        6655,
        1,
        7009,
        7018,
        1,
        7028,
        7036,
        1,
        8125,
        8127,
        2,
        8128,
        8129,
        1,
        8141,
        8143,
        1,
        8157,
        8159,
        1,
        8173,
        8175,
        1,
        8189,
        8190,
        1,
        8260,
        8274,
        14,
        8314,
        8316,
        1,
        8330,
        8332,
        1,
        8352,
        8384,
        1,
        8448,
        8449,
        1,
        8451,
        8454,
        1,
        8456,
        8457,
        1,
        8468,
        8470,
        2,
        8471,
        8472,
        1,
        8478,
        8483,
        1,
        8485,
        8489,
        2,
        8494,
        8506,
        12,
        8507,
        8512,
        5,
        8513,
        8516,
        1,
        8522,
        8525,
        1,
        8527,
        8586,
        59,
        8587,
        8592,
        5,
        8593,
        8967,
        1,
        8972,
        9000,
        1,
        9003,
        9257,
        1,
        9280,
        9290,
        1,
        9372,
        9449,
        1,
        9472,
        10087,
        1,
        10132,
        10180,
        1,
        10183,
        10213,
        1,
        10224,
        10626,
        1,
        10649,
        10711,
        1,
        10716,
        10747,
        1,
        10750,
        11123,
        1,
        11126,
        11157,
        1,
        11159,
        11263,
        1,
        11493,
        11498,
        1,
        11856,
        11857,
        1,
        11904,
        11929,
        1,
        11931,
        12019,
        1,
        12032,
        12245,
        1,
        12272,
        12287,
        1,
        12292,
        12306,
        14,
        12307,
        12320,
        13,
        12342,
        12343,
        1,
        12350,
        12351,
        1,
        12443,
        12444,
        1,
        12688,
        12689,
        1,
        12694,
        12703,
        1,
        12736,
        12773,
        1,
        12783,
        12800,
        17,
        12801,
        12830,
        1,
        12842,
        12871,
        1,
        12880,
        12896,
        16,
        12897,
        12927,
        1,
        12938,
        12976,
        1,
        12992,
        13311,
        1,
        19904,
        19967,
        1,
        42128,
        42182,
        1,
        42752,
        42774,
        1,
        42784,
        42785,
        1,
        42889,
        42890,
        1,
        43048,
        43051,
        1,
        43062,
        43065,
        1,
        43639,
        43641,
        1,
        43867,
        43882,
        15,
        43883,
        64297,
        20414,
        64434,
        64450,
        1,
        64832,
        64847,
        1,
        64975,
        65020,
        45,
        65021,
        65023,
        1,
        65122,
        65124,
        2,
        65125,
        65126,
        1,
        65129,
        65284,
        155,
        65291,
        65308,
        17,
        65309,
        65310,
        1,
        65342,
        65344,
        2,
        65372,
        65374,
        2,
        65504,
        65510,
        1,
        65512,
        65518,
        1,
        65532,
        65533,
        1,
        65847,
        65855,
        1,
        65913,
        65929,
        1,
        65932,
        65934,
        1,
        65936,
        65948,
        1,
        65952,
        66000,
        48,
        66001,
        66044,
        1,
        67703,
        67704,
        1,
        68296,
        69006,
        710,
        69007,
        71487,
        2480,
        73685,
        73713,
        1,
        92988,
        92991,
        1,
        92997,
        113820,
        20823,
        117760,
        117999,
        1,
        118016,
        118451,
        1,
        118608,
        118723,
        1,
        118784,
        119029,
        1,
        119040,
        119078,
        1,
        119081,
        119140,
        1,
        119146,
        119148,
        1,
        119171,
        119172,
        1,
        119180,
        119209,
        1,
        119214,
        119274,
        1,
        119296,
        119361,
        1,
        119365,
        119552,
        187,
        119553,
        119638,
        1,
        120513,
        120539,
        26,
        120571,
        120597,
        26,
        120629,
        120655,
        26,
        120687,
        120713,
        26,
        120745,
        120771,
        26,
        120832,
        121343,
        1,
        121399,
        121402,
        1,
        121453,
        121460,
        1,
        121462,
        121475,
        1,
        121477,
        121478,
        1,
        123215,
        123647,
        432,
        126124,
        126128,
        4,
        126254,
        126704,
        450,
        126705,
        126976,
        271,
        126977,
        127019,
        1,
        127024,
        127123,
        1,
        127136,
        127150,
        1,
        127153,
        127167,
        1,
        127169,
        127183,
        1,
        127185,
        127221,
        1,
        127245,
        127405,
        1,
        127462,
        127490,
        1,
        127504,
        127547,
        1,
        127552,
        127560,
        1,
        127568,
        127569,
        1,
        127584,
        127589,
        1,
        127744,
        128727,
        1,
        128732,
        128748,
        1,
        128752,
        128764,
        1,
        128768,
        128886,
        1,
        128891,
        128985,
        1,
        128992,
        129003,
        1,
        129008,
        129024,
        16,
        129025,
        129035,
        1,
        129040,
        129095,
        1,
        129104,
        129113,
        1,
        129120,
        129159,
        1,
        129168,
        129197,
        1,
        129200,
        129211,
        1,
        129216,
        129217,
        1,
        129280,
        129619,
        1,
        129632,
        129645,
        1,
        129648,
        129660,
        1,
        129664,
        129673,
        1,
        129679,
        129734,
        1,
        129742,
        129756,
        1,
        129759,
        129769,
        1,
        129776,
        129784,
        1,
        129792,
        129938,
        1,
        129940,
        130031,
        1
    ]));
    static Sc = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        36,
        162,
        126,
        163,
        165,
        1,
        1423,
        1547,
        124,
        2046,
        2047,
        1,
        2546,
        2547,
        1,
        2555,
        2801,
        246,
        3065,
        3647,
        582,
        6107,
        8352,
        2245,
        8353,
        8384,
        1,
        43064,
        65020,
        21956,
        65129,
        65284,
        155,
        65504,
        65505,
        1,
        65509,
        65510,
        1,
        73693,
        73696,
        1,
        123647,
        126128,
        2481
    ]));
    static Sk = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        94,
        96,
        2,
        168,
        175,
        7,
        180,
        184,
        4,
        706,
        709,
        1,
        722,
        735,
        1,
        741,
        747,
        1,
        749,
        751,
        2,
        752,
        767,
        1,
        885,
        900,
        15,
        901,
        2184,
        1283,
        8125,
        8127,
        2,
        8128,
        8129,
        1,
        8141,
        8143,
        1,
        8157,
        8159,
        1,
        8173,
        8175,
        1,
        8189,
        8190,
        1,
        12443,
        12444,
        1,
        42752,
        42774,
        1,
        42784,
        42785,
        1,
        42889,
        42890,
        1,
        43867,
        43882,
        15,
        43883,
        64434,
        20551,
        64435,
        64450,
        1,
        65342,
        65344,
        2,
        65507,
        127995,
        62488,
        127996,
        127999,
        1
    ]));
    static Sm = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43,
        60,
        17,
        61,
        62,
        1,
        124,
        126,
        2,
        172,
        177,
        5,
        215,
        247,
        32,
        1014,
        1542,
        528,
        1543,
        1544,
        1,
        8260,
        8274,
        14,
        8314,
        8316,
        1,
        8330,
        8332,
        1,
        8472,
        8512,
        40,
        8513,
        8516,
        1,
        8523,
        8592,
        69,
        8593,
        8596,
        1,
        8602,
        8603,
        1,
        8608,
        8614,
        3,
        8622,
        8654,
        32,
        8655,
        8658,
        3,
        8660,
        8692,
        32,
        8693,
        8959,
        1,
        8992,
        8993,
        1,
        9084,
        9115,
        31,
        9116,
        9139,
        1,
        9180,
        9185,
        1,
        9655,
        9665,
        10,
        9720,
        9727,
        1,
        9839,
        10176,
        337,
        10177,
        10180,
        1,
        10183,
        10213,
        1,
        10224,
        10239,
        1,
        10496,
        10626,
        1,
        10649,
        10711,
        1,
        10716,
        10747,
        1,
        10750,
        11007,
        1,
        11056,
        11076,
        1,
        11079,
        11084,
        1,
        64297,
        65122,
        825,
        65124,
        65126,
        1,
        65291,
        65308,
        17,
        65309,
        65310,
        1,
        65372,
        65374,
        2,
        65506,
        65513,
        7,
        65514,
        65516,
        1,
        69006,
        69007,
        1,
        120513,
        120539,
        26,
        120571,
        120597,
        26,
        120629,
        120655,
        26,
        120687,
        120713,
        26,
        120745,
        120771,
        26,
        126704,
        126705,
        1
    ]));
    static So = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        166,
        169,
        3,
        174,
        176,
        2,
        1154,
        1421,
        267,
        1422,
        1550,
        128,
        1551,
        1758,
        207,
        1769,
        1789,
        20,
        1790,
        2038,
        248,
        2554,
        2928,
        374,
        3059,
        3064,
        1,
        3066,
        3199,
        133,
        3407,
        3449,
        42,
        3841,
        3843,
        1,
        3859,
        3861,
        2,
        3862,
        3863,
        1,
        3866,
        3871,
        1,
        3892,
        3896,
        2,
        4030,
        4037,
        1,
        4039,
        4044,
        1,
        4046,
        4047,
        1,
        4053,
        4056,
        1,
        4254,
        4255,
        1,
        5008,
        5017,
        1,
        5741,
        6464,
        723,
        6622,
        6655,
        1,
        7009,
        7018,
        1,
        7028,
        7036,
        1,
        8448,
        8449,
        1,
        8451,
        8454,
        1,
        8456,
        8457,
        1,
        8468,
        8470,
        2,
        8471,
        8478,
        7,
        8479,
        8483,
        1,
        8485,
        8489,
        2,
        8494,
        8506,
        12,
        8507,
        8522,
        15,
        8524,
        8525,
        1,
        8527,
        8586,
        59,
        8587,
        8597,
        10,
        8598,
        8601,
        1,
        8604,
        8607,
        1,
        8609,
        8610,
        1,
        8612,
        8613,
        1,
        8615,
        8621,
        1,
        8623,
        8653,
        1,
        8656,
        8657,
        1,
        8659,
        8661,
        2,
        8662,
        8691,
        1,
        8960,
        8967,
        1,
        8972,
        8991,
        1,
        8994,
        9000,
        1,
        9003,
        9083,
        1,
        9085,
        9114,
        1,
        9140,
        9179,
        1,
        9186,
        9257,
        1,
        9280,
        9290,
        1,
        9372,
        9449,
        1,
        9472,
        9654,
        1,
        9656,
        9664,
        1,
        9666,
        9719,
        1,
        9728,
        9838,
        1,
        9840,
        10087,
        1,
        10132,
        10175,
        1,
        10240,
        10495,
        1,
        11008,
        11055,
        1,
        11077,
        11078,
        1,
        11085,
        11123,
        1,
        11126,
        11157,
        1,
        11159,
        11263,
        1,
        11493,
        11498,
        1,
        11856,
        11857,
        1,
        11904,
        11929,
        1,
        11931,
        12019,
        1,
        12032,
        12245,
        1,
        12272,
        12287,
        1,
        12292,
        12306,
        14,
        12307,
        12320,
        13,
        12342,
        12343,
        1,
        12350,
        12351,
        1,
        12688,
        12689,
        1,
        12694,
        12703,
        1,
        12736,
        12773,
        1,
        12783,
        12800,
        17,
        12801,
        12830,
        1,
        12842,
        12871,
        1,
        12880,
        12896,
        16,
        12897,
        12927,
        1,
        12938,
        12976,
        1,
        12992,
        13311,
        1,
        19904,
        19967,
        1,
        42128,
        42182,
        1,
        43048,
        43051,
        1,
        43062,
        43063,
        1,
        43065,
        43639,
        574,
        43640,
        43641,
        1,
        64832,
        64847,
        1,
        64975,
        65021,
        46,
        65022,
        65023,
        1,
        65508,
        65512,
        4,
        65517,
        65518,
        1,
        65532,
        65533,
        1,
        65847,
        65855,
        1,
        65913,
        65929,
        1,
        65932,
        65934,
        1,
        65936,
        65948,
        1,
        65952,
        66000,
        48,
        66001,
        66044,
        1,
        67703,
        67704,
        1,
        68296,
        71487,
        3191,
        73685,
        73692,
        1,
        73697,
        73713,
        1,
        92988,
        92991,
        1,
        92997,
        113820,
        20823,
        117760,
        117999,
        1,
        118016,
        118451,
        1,
        118608,
        118723,
        1,
        118784,
        119029,
        1,
        119040,
        119078,
        1,
        119081,
        119140,
        1,
        119146,
        119148,
        1,
        119171,
        119172,
        1,
        119180,
        119209,
        1,
        119214,
        119274,
        1,
        119296,
        119361,
        1,
        119365,
        119552,
        187,
        119553,
        119638,
        1,
        120832,
        121343,
        1,
        121399,
        121402,
        1,
        121453,
        121460,
        1,
        121462,
        121475,
        1,
        121477,
        121478,
        1,
        123215,
        126124,
        2909,
        126254,
        126976,
        722,
        126977,
        127019,
        1,
        127024,
        127123,
        1,
        127136,
        127150,
        1,
        127153,
        127167,
        1,
        127169,
        127183,
        1,
        127185,
        127221,
        1,
        127245,
        127405,
        1,
        127462,
        127490,
        1,
        127504,
        127547,
        1,
        127552,
        127560,
        1,
        127568,
        127569,
        1,
        127584,
        127589,
        1,
        127744,
        127994,
        1,
        128000,
        128727,
        1,
        128732,
        128748,
        1,
        128752,
        128764,
        1,
        128768,
        128886,
        1,
        128891,
        128985,
        1,
        128992,
        129003,
        1,
        129008,
        129024,
        16,
        129025,
        129035,
        1,
        129040,
        129095,
        1,
        129104,
        129113,
        1,
        129120,
        129159,
        1,
        129168,
        129197,
        1,
        129200,
        129211,
        1,
        129216,
        129217,
        1,
        129280,
        129619,
        1,
        129632,
        129645,
        1,
        129648,
        129660,
        1,
        129664,
        129673,
        1,
        129679,
        129734,
        1,
        129742,
        129756,
        1,
        129759,
        129769,
        1,
        129776,
        129784,
        1,
        129792,
        129938,
        1,
        129940,
        130031,
        1
    ]));
    static Z = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        32,
        160,
        128,
        5760,
        8192,
        2432,
        8193,
        8202,
        1,
        8232,
        8233,
        1,
        8239,
        8287,
        48,
        12288,
        12288,
        1
    ]));
    static Zl = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        8232,
        8232,
        1
    ]));
    static Zp = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        8233,
        8233,
        1
    ]));
    static Zs = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        32,
        160,
        128,
        5760,
        8192,
        2432,
        8193,
        8202,
        1,
        8239,
        8287,
        48,
        12288,
        12288,
        1
    ]));
    static Adlam = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        125184,
        125259,
        1,
        125264,
        125273,
        1,
        125278,
        125279,
        1
    ]));
    static Ahom = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71424,
        71450,
        1,
        71453,
        71467,
        1,
        71472,
        71494,
        1
    ]));
    static Anatolian_Hieroglyphs = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        82944,
        83526,
        1
    ]));
    static Arabic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1536,
        1540,
        1,
        1542,
        1547,
        1,
        1549,
        1562,
        1,
        1564,
        1566,
        1,
        1568,
        1599,
        1,
        1601,
        1610,
        1,
        1622,
        1647,
        1,
        1649,
        1756,
        1,
        1758,
        1791,
        1,
        1872,
        1919,
        1,
        2160,
        2190,
        1,
        2192,
        2193,
        1,
        2199,
        2273,
        1,
        2275,
        2303,
        1,
        64336,
        64450,
        1,
        64467,
        64829,
        1,
        64832,
        64911,
        1,
        64914,
        64967,
        1,
        64975,
        65008,
        33,
        65009,
        65023,
        1,
        65136,
        65140,
        1,
        65142,
        65276,
        1,
        69216,
        69246,
        1,
        69314,
        69316,
        1,
        69372,
        69375,
        1,
        126464,
        126467,
        1,
        126469,
        126495,
        1,
        126497,
        126498,
        1,
        126500,
        126503,
        3,
        126505,
        126514,
        1,
        126516,
        126519,
        1,
        126521,
        126523,
        2,
        126530,
        126535,
        5,
        126537,
        126541,
        2,
        126542,
        126543,
        1,
        126545,
        126546,
        1,
        126548,
        126551,
        3,
        126553,
        126561,
        2,
        126562,
        126564,
        2,
        126567,
        126570,
        1,
        126572,
        126578,
        1,
        126580,
        126583,
        1,
        126585,
        126588,
        1,
        126590,
        126592,
        2,
        126593,
        126601,
        1,
        126603,
        126619,
        1,
        126625,
        126627,
        1,
        126629,
        126633,
        1,
        126635,
        126651,
        1,
        126704,
        126705,
        1
    ]));
    static Armenian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1329,
        1366,
        1,
        1369,
        1418,
        1,
        1421,
        1423,
        1,
        64275,
        64279,
        1
    ]));
    static Avestan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68352,
        68405,
        1,
        68409,
        68415,
        1
    ]));
    static Balinese = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6912,
        6988,
        1,
        6990,
        7039,
        1
    ]));
    static Bamum = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        42656,
        42743,
        1,
        92160,
        92728,
        1
    ]));
    static Bassa_Vah = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        92880,
        92909,
        1,
        92912,
        92917,
        1
    ]));
    static Batak = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        7104,
        7155,
        1,
        7164,
        7167,
        1
    ]));
    static Bengali = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2432,
        2435,
        1,
        2437,
        2444,
        1,
        2447,
        2448,
        1,
        2451,
        2472,
        1,
        2474,
        2480,
        1,
        2482,
        2486,
        4,
        2487,
        2489,
        1,
        2492,
        2500,
        1,
        2503,
        2504,
        1,
        2507,
        2510,
        1,
        2519,
        2524,
        5,
        2525,
        2527,
        2,
        2528,
        2531,
        1,
        2534,
        2558,
        1
    ]));
    static Bhaiksuki = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72704,
        72712,
        1,
        72714,
        72758,
        1,
        72760,
        72773,
        1,
        72784,
        72812,
        1
    ]));
    static Bopomofo = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        746,
        747,
        1,
        12549,
        12591,
        1,
        12704,
        12735,
        1
    ]));
    static Brahmi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69632,
        69709,
        1,
        69714,
        69749,
        1,
        69759,
        69759,
        1
    ]));
    static Braille = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        10240,
        10495,
        1
    ]));
    static Buginese = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6656,
        6683,
        1,
        6686,
        6687,
        1
    ]));
    static Buhid = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5952,
        5971,
        1
    ]));
    static Canadian_Aboriginal = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5120,
        5759,
        1,
        6320,
        6389,
        1,
        72368,
        72383,
        1
    ]));
    static Carian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66208,
        66256,
        1
    ]));
    static Caucasian_Albanian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66864,
        66915,
        1,
        66927,
        66927,
        1
    ]));
    static Chakma = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69888,
        69940,
        1,
        69942,
        69959,
        1
    ]));
    static Cham = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43520,
        43574,
        1,
        43584,
        43597,
        1,
        43600,
        43609,
        1,
        43612,
        43615,
        1
    ]));
    static Cherokee = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5024,
        5109,
        1,
        5112,
        5117,
        1,
        43888,
        43967,
        1
    ]));
    static Chorasmian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69552,
        69579,
        1
    ]));
    static Common = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        0,
        64,
        1,
        91,
        96,
        1,
        123,
        169,
        1,
        171,
        185,
        1,
        187,
        191,
        1,
        215,
        247,
        32,
        697,
        735,
        1,
        741,
        745,
        1,
        748,
        767,
        1,
        884,
        894,
        10,
        901,
        903,
        2,
        1541,
        1548,
        7,
        1563,
        1567,
        4,
        1600,
        1757,
        157,
        2274,
        2404,
        130,
        2405,
        3647,
        1242,
        4053,
        4056,
        1,
        4347,
        5867,
        1520,
        5868,
        5869,
        1,
        5941,
        5942,
        1,
        6146,
        6147,
        1,
        6149,
        7379,
        1230,
        7393,
        7401,
        8,
        7402,
        7404,
        1,
        7406,
        7411,
        1,
        7413,
        7415,
        1,
        7418,
        8192,
        774,
        8193,
        8203,
        1,
        8206,
        8292,
        1,
        8294,
        8304,
        1,
        8308,
        8318,
        1,
        8320,
        8334,
        1,
        8352,
        8384,
        1,
        8448,
        8485,
        1,
        8487,
        8489,
        1,
        8492,
        8497,
        1,
        8499,
        8525,
        1,
        8527,
        8543,
        1,
        8585,
        8587,
        1,
        8592,
        9257,
        1,
        9280,
        9290,
        1,
        9312,
        10239,
        1,
        10496,
        11123,
        1,
        11126,
        11157,
        1,
        11159,
        11263,
        1,
        11776,
        11869,
        1,
        12272,
        12292,
        1,
        12294,
        12296,
        2,
        12297,
        12320,
        1,
        12336,
        12343,
        1,
        12348,
        12351,
        1,
        12443,
        12444,
        1,
        12448,
        12539,
        91,
        12540,
        12688,
        148,
        12689,
        12703,
        1,
        12736,
        12773,
        1,
        12783,
        12832,
        49,
        12833,
        12895,
        1,
        12927,
        13007,
        1,
        13055,
        13144,
        89,
        13145,
        13311,
        1,
        19904,
        19967,
        1,
        42752,
        42785,
        1,
        42888,
        42890,
        1,
        43056,
        43065,
        1,
        43310,
        43471,
        161,
        43867,
        43882,
        15,
        43883,
        64830,
        20947,
        64831,
        65040,
        209,
        65041,
        65049,
        1,
        65072,
        65106,
        1,
        65108,
        65126,
        1,
        65128,
        65131,
        1,
        65279,
        65281,
        2,
        65282,
        65312,
        1,
        65339,
        65344,
        1,
        65371,
        65381,
        1,
        65392,
        65438,
        46,
        65439,
        65504,
        65,
        65505,
        65510,
        1,
        65512,
        65518,
        1,
        65529,
        65533,
        1,
        65792,
        65794,
        1,
        65799,
        65843,
        1,
        65847,
        65855,
        1,
        65936,
        65948,
        1,
        66000,
        66044,
        1,
        66273,
        66299,
        1,
        113824,
        113827,
        1,
        117760,
        118009,
        1,
        118016,
        118451,
        1,
        118608,
        118723,
        1,
        118784,
        119029,
        1,
        119040,
        119078,
        1,
        119081,
        119142,
        1,
        119146,
        119162,
        1,
        119171,
        119172,
        1,
        119180,
        119209,
        1,
        119214,
        119274,
        1,
        119488,
        119507,
        1,
        119520,
        119539,
        1,
        119552,
        119638,
        1,
        119648,
        119672,
        1,
        119808,
        119892,
        1,
        119894,
        119964,
        1,
        119966,
        119967,
        1,
        119970,
        119973,
        3,
        119974,
        119977,
        3,
        119978,
        119980,
        1,
        119982,
        119993,
        1,
        119995,
        119997,
        2,
        119998,
        120003,
        1,
        120005,
        120069,
        1,
        120071,
        120074,
        1,
        120077,
        120084,
        1,
        120086,
        120092,
        1,
        120094,
        120121,
        1,
        120123,
        120126,
        1,
        120128,
        120132,
        1,
        120134,
        120138,
        4,
        120139,
        120144,
        1,
        120146,
        120485,
        1,
        120488,
        120779,
        1,
        120782,
        120831,
        1,
        126065,
        126132,
        1,
        126209,
        126269,
        1,
        126976,
        127019,
        1,
        127024,
        127123,
        1,
        127136,
        127150,
        1,
        127153,
        127167,
        1,
        127169,
        127183,
        1,
        127185,
        127221,
        1,
        127232,
        127405,
        1,
        127462,
        127487,
        1,
        127489,
        127490,
        1,
        127504,
        127547,
        1,
        127552,
        127560,
        1,
        127568,
        127569,
        1,
        127584,
        127589,
        1,
        127744,
        128727,
        1,
        128732,
        128748,
        1,
        128752,
        128764,
        1,
        128768,
        128886,
        1,
        128891,
        128985,
        1,
        128992,
        129003,
        1,
        129008,
        129024,
        16,
        129025,
        129035,
        1,
        129040,
        129095,
        1,
        129104,
        129113,
        1,
        129120,
        129159,
        1,
        129168,
        129197,
        1,
        129200,
        129211,
        1,
        129216,
        129217,
        1,
        129280,
        129619,
        1,
        129632,
        129645,
        1,
        129648,
        129660,
        1,
        129664,
        129673,
        1,
        129679,
        129734,
        1,
        129742,
        129756,
        1,
        129759,
        129769,
        1,
        129776,
        129784,
        1,
        129792,
        129938,
        1,
        129940,
        130041,
        1,
        917505,
        917536,
        31,
        917537,
        917631,
        1
    ]));
    static foldCommon = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        924,
        956,
        32
    ]));
    static Coptic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        994,
        1007,
        1,
        11392,
        11507,
        1,
        11513,
        11519,
        1
    ]));
    static Cuneiform = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        73728,
        74649,
        1,
        74752,
        74862,
        1,
        74864,
        74868,
        1,
        74880,
        75075,
        1
    ]));
    static Cypriot = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67584,
        67589,
        1,
        67592,
        67594,
        2,
        67595,
        67637,
        1,
        67639,
        67640,
        1,
        67644,
        67647,
        3
    ]));
    static Cypro_Minoan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        77712,
        77810,
        1
    ]));
    static Cyrillic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1024,
        1156,
        1,
        1159,
        1327,
        1,
        7296,
        7306,
        1,
        7467,
        7544,
        77,
        11744,
        11775,
        1,
        42560,
        42655,
        1,
        65070,
        65071,
        1,
        122928,
        122989,
        1,
        123023,
        123023,
        1
    ]));
    static Deseret = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66560,
        66639,
        1
    ]));
    static Devanagari = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2304,
        2384,
        1,
        2389,
        2403,
        1,
        2406,
        2431,
        1,
        43232,
        43263,
        1,
        72448,
        72457,
        1
    ]));
    static Dives_Akuru = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71936,
        71942,
        1,
        71945,
        71948,
        3,
        71949,
        71955,
        1,
        71957,
        71958,
        1,
        71960,
        71989,
        1,
        71991,
        71992,
        1,
        71995,
        72006,
        1,
        72016,
        72025,
        1
    ]));
    static Dogra = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71680,
        71739,
        1
    ]));
    static Duployan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        113664,
        113770,
        1,
        113776,
        113788,
        1,
        113792,
        113800,
        1,
        113808,
        113817,
        1,
        113820,
        113823,
        1
    ]));
    static Egyptian_Hieroglyphs = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        77824,
        78933,
        1,
        78944,
        82938,
        1
    ]));
    static Elbasan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66816,
        66855,
        1
    ]));
    static Elymaic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69600,
        69622,
        1
    ]));
    static Ethiopic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        4608,
        4680,
        1,
        4682,
        4685,
        1,
        4688,
        4694,
        1,
        4696,
        4698,
        2,
        4699,
        4701,
        1,
        4704,
        4744,
        1,
        4746,
        4749,
        1,
        4752,
        4784,
        1,
        4786,
        4789,
        1,
        4792,
        4798,
        1,
        4800,
        4802,
        2,
        4803,
        4805,
        1,
        4808,
        4822,
        1,
        4824,
        4880,
        1,
        4882,
        4885,
        1,
        4888,
        4954,
        1,
        4957,
        4988,
        1,
        4992,
        5017,
        1,
        11648,
        11670,
        1,
        11680,
        11686,
        1,
        11688,
        11694,
        1,
        11696,
        11702,
        1,
        11704,
        11710,
        1,
        11712,
        11718,
        1,
        11720,
        11726,
        1,
        11728,
        11734,
        1,
        11736,
        11742,
        1,
        43777,
        43782,
        1,
        43785,
        43790,
        1,
        43793,
        43798,
        1,
        43808,
        43814,
        1,
        43816,
        43822,
        1,
        124896,
        124902,
        1,
        124904,
        124907,
        1,
        124909,
        124910,
        1,
        124912,
        124926,
        1
    ]));
    static Garay = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68928,
        68965,
        1,
        68969,
        68997,
        1,
        69006,
        69007,
        1
    ]));
    static Georgian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        4256,
        4293,
        1,
        4295,
        4301,
        6,
        4304,
        4346,
        1,
        4348,
        4351,
        1,
        7312,
        7354,
        1,
        7357,
        7359,
        1,
        11520,
        11557,
        1,
        11559,
        11565,
        6
    ]));
    static Glagolitic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        11264,
        11359,
        1,
        122880,
        122886,
        1,
        122888,
        122904,
        1,
        122907,
        122913,
        1,
        122915,
        122916,
        1,
        122918,
        122922,
        1
    ]));
    static Gothic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66352,
        66378,
        1
    ]));
    static Grantha = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70400,
        70403,
        1,
        70405,
        70412,
        1,
        70415,
        70416,
        1,
        70419,
        70440,
        1,
        70442,
        70448,
        1,
        70450,
        70451,
        1,
        70453,
        70457,
        1,
        70460,
        70468,
        1,
        70471,
        70472,
        1,
        70475,
        70477,
        1,
        70480,
        70487,
        7,
        70493,
        70499,
        1,
        70502,
        70508,
        1,
        70512,
        70516,
        1
    ]));
    static Greek = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        880,
        883,
        1,
        885,
        887,
        1,
        890,
        893,
        1,
        895,
        900,
        5,
        902,
        904,
        2,
        905,
        906,
        1,
        908,
        910,
        2,
        911,
        929,
        1,
        931,
        993,
        1,
        1008,
        1023,
        1,
        7462,
        7466,
        1,
        7517,
        7521,
        1,
        7526,
        7530,
        1,
        7615,
        7936,
        321,
        7937,
        7957,
        1,
        7960,
        7965,
        1,
        7968,
        8005,
        1,
        8008,
        8013,
        1,
        8016,
        8023,
        1,
        8025,
        8031,
        2,
        8032,
        8061,
        1,
        8064,
        8116,
        1,
        8118,
        8132,
        1,
        8134,
        8147,
        1,
        8150,
        8155,
        1,
        8157,
        8175,
        1,
        8178,
        8180,
        1,
        8182,
        8190,
        1,
        8486,
        43877,
        35391,
        65856,
        65934,
        1,
        65952,
        119296,
        53344,
        119297,
        119365,
        1
    ]));
    static foldGreek = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        181,
        837,
        656
    ]));
    static Gujarati = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2689,
        2691,
        1,
        2693,
        2701,
        1,
        2703,
        2705,
        1,
        2707,
        2728,
        1,
        2730,
        2736,
        1,
        2738,
        2739,
        1,
        2741,
        2745,
        1,
        2748,
        2757,
        1,
        2759,
        2761,
        1,
        2763,
        2765,
        1,
        2768,
        2784,
        16,
        2785,
        2787,
        1,
        2790,
        2801,
        1,
        2809,
        2815,
        1
    ]));
    static Gunjala_Gondi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        73056,
        73061,
        1,
        73063,
        73064,
        1,
        73066,
        73102,
        1,
        73104,
        73105,
        1,
        73107,
        73112,
        1,
        73120,
        73129,
        1
    ]));
    static Gurmukhi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2561,
        2563,
        1,
        2565,
        2570,
        1,
        2575,
        2576,
        1,
        2579,
        2600,
        1,
        2602,
        2608,
        1,
        2610,
        2611,
        1,
        2613,
        2614,
        1,
        2616,
        2617,
        1,
        2620,
        2622,
        2,
        2623,
        2626,
        1,
        2631,
        2632,
        1,
        2635,
        2637,
        1,
        2641,
        2649,
        8,
        2650,
        2652,
        1,
        2654,
        2662,
        8,
        2663,
        2678,
        1
    ]));
    static Gurung_Khema = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        90368,
        90425,
        1
    ]));
    static Han = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        11904,
        11929,
        1,
        11931,
        12019,
        1,
        12032,
        12245,
        1,
        12293,
        12295,
        2,
        12321,
        12329,
        1,
        12344,
        12347,
        1,
        13312,
        19903,
        1,
        19968,
        40959,
        1,
        63744,
        64109,
        1,
        64112,
        64217,
        1,
        94178,
        94179,
        1,
        94192,
        94193,
        1,
        131072,
        173791,
        1,
        173824,
        177977,
        1,
        177984,
        178205,
        1,
        178208,
        183969,
        1,
        183984,
        191456,
        1,
        191472,
        192093,
        1,
        194560,
        195101,
        1,
        196608,
        201546,
        1,
        201552,
        205743,
        1
    ]));
    static Hangul = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        4352,
        4607,
        1,
        12334,
        12335,
        1,
        12593,
        12686,
        1,
        12800,
        12830,
        1,
        12896,
        12926,
        1,
        43360,
        43388,
        1,
        44032,
        55203,
        1,
        55216,
        55238,
        1,
        55243,
        55291,
        1,
        65440,
        65470,
        1,
        65474,
        65479,
        1,
        65482,
        65487,
        1,
        65490,
        65495,
        1,
        65498,
        65500,
        1
    ]));
    static Hanifi_Rohingya = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68864,
        68903,
        1,
        68912,
        68921,
        1
    ]));
    static Hanunoo = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5920,
        5940,
        1
    ]));
    static Hatran = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67808,
        67826,
        1,
        67828,
        67829,
        1,
        67835,
        67839,
        1
    ]));
    static Hebrew = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1425,
        1479,
        1,
        1488,
        1514,
        1,
        1519,
        1524,
        1,
        64285,
        64310,
        1,
        64312,
        64316,
        1,
        64318,
        64320,
        2,
        64321,
        64323,
        2,
        64324,
        64326,
        2,
        64327,
        64335,
        1
    ]));
    static Hiragana = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        12353,
        12438,
        1,
        12445,
        12447,
        1,
        110593,
        110879,
        1,
        110898,
        110928,
        30,
        110929,
        110930,
        1,
        127488,
        127488,
        1
    ]));
    static Imperial_Aramaic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67648,
        67669,
        1,
        67671,
        67679,
        1
    ]));
    static Inherited = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        768,
        879,
        1,
        1157,
        1158,
        1,
        1611,
        1621,
        1,
        1648,
        2385,
        737,
        2386,
        2388,
        1,
        6832,
        6862,
        1,
        7376,
        7378,
        1,
        7380,
        7392,
        1,
        7394,
        7400,
        1,
        7405,
        7412,
        7,
        7416,
        7417,
        1,
        7616,
        7679,
        1,
        8204,
        8205,
        1,
        8400,
        8432,
        1,
        12330,
        12333,
        1,
        12441,
        12442,
        1,
        65024,
        65039,
        1,
        65056,
        65069,
        1,
        66045,
        66272,
        227,
        70459,
        118528,
        48069,
        118529,
        118573,
        1,
        118576,
        118598,
        1,
        119143,
        119145,
        1,
        119163,
        119170,
        1,
        119173,
        119179,
        1,
        119210,
        119213,
        1,
        917760,
        917999,
        1
    ]));
    static foldInherited = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        921,
        953,
        32,
        8126,
        8126,
        1
    ]));
    static Inscriptional_Pahlavi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68448,
        68466,
        1,
        68472,
        68479,
        1
    ]));
    static Inscriptional_Parthian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68416,
        68437,
        1,
        68440,
        68447,
        1
    ]));
    static Javanese = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43392,
        43469,
        1,
        43472,
        43481,
        1,
        43486,
        43487,
        1
    ]));
    static Kaithi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69760,
        69826,
        1,
        69837,
        69837,
        1
    ]));
    static Kannada = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3200,
        3212,
        1,
        3214,
        3216,
        1,
        3218,
        3240,
        1,
        3242,
        3251,
        1,
        3253,
        3257,
        1,
        3260,
        3268,
        1,
        3270,
        3272,
        1,
        3274,
        3277,
        1,
        3285,
        3286,
        1,
        3293,
        3294,
        1,
        3296,
        3299,
        1,
        3302,
        3311,
        1,
        3313,
        3315,
        1
    ]));
    static Katakana = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        12449,
        12538,
        1,
        12541,
        12543,
        1,
        12784,
        12799,
        1,
        13008,
        13054,
        1,
        13056,
        13143,
        1,
        65382,
        65391,
        1,
        65393,
        65437,
        1,
        110576,
        110579,
        1,
        110581,
        110587,
        1,
        110589,
        110590,
        1,
        110592,
        110880,
        288,
        110881,
        110882,
        1,
        110933,
        110948,
        15,
        110949,
        110951,
        1
    ]));
    static Kawi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        73472,
        73488,
        1,
        73490,
        73530,
        1,
        73534,
        73562,
        1
    ]));
    static Kayah_Li = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43264,
        43309,
        1,
        43311,
        43311,
        1
    ]));
    static Kharoshthi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68096,
        68099,
        1,
        68101,
        68102,
        1,
        68108,
        68115,
        1,
        68117,
        68119,
        1,
        68121,
        68149,
        1,
        68152,
        68154,
        1,
        68159,
        68168,
        1,
        68176,
        68184,
        1
    ]));
    static Khitan_Small_Script = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        94180,
        101120,
        6940,
        101121,
        101589,
        1,
        101631,
        101631,
        1
    ]));
    static Khmer = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6016,
        6109,
        1,
        6112,
        6121,
        1,
        6128,
        6137,
        1,
        6624,
        6655,
        1
    ]));
    static Khojki = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70144,
        70161,
        1,
        70163,
        70209,
        1
    ]));
    static Khudawadi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70320,
        70378,
        1,
        70384,
        70393,
        1
    ]));
    static Kirat_Rai = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        93504,
        93561,
        1
    ]));
    static Lao = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3713,
        3714,
        1,
        3716,
        3718,
        2,
        3719,
        3722,
        1,
        3724,
        3747,
        1,
        3749,
        3751,
        2,
        3752,
        3773,
        1,
        3776,
        3780,
        1,
        3782,
        3784,
        2,
        3785,
        3790,
        1,
        3792,
        3801,
        1,
        3804,
        3807,
        1
    ]));
    static Latin = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        65,
        90,
        1,
        97,
        122,
        1,
        170,
        186,
        16,
        192,
        214,
        1,
        216,
        246,
        1,
        248,
        696,
        1,
        736,
        740,
        1,
        7424,
        7461,
        1,
        7468,
        7516,
        1,
        7522,
        7525,
        1,
        7531,
        7543,
        1,
        7545,
        7614,
        1,
        7680,
        7935,
        1,
        8305,
        8319,
        14,
        8336,
        8348,
        1,
        8490,
        8491,
        1,
        8498,
        8526,
        28,
        8544,
        8584,
        1,
        11360,
        11391,
        1,
        42786,
        42887,
        1,
        42891,
        42957,
        1,
        42960,
        42961,
        1,
        42963,
        42965,
        2,
        42966,
        42972,
        1,
        42994,
        43007,
        1,
        43824,
        43866,
        1,
        43868,
        43876,
        1,
        43878,
        43881,
        1,
        64256,
        64262,
        1,
        65313,
        65338,
        1,
        65345,
        65370,
        1,
        67456,
        67461,
        1,
        67463,
        67504,
        1,
        67506,
        67514,
        1,
        122624,
        122654,
        1,
        122661,
        122666,
        1
    ]));
    static Lepcha = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        7168,
        7223,
        1,
        7227,
        7241,
        1,
        7245,
        7247,
        1
    ]));
    static Limbu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6400,
        6430,
        1,
        6432,
        6443,
        1,
        6448,
        6459,
        1,
        6464,
        6468,
        4,
        6469,
        6479,
        1
    ]));
    static Linear_A = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67072,
        67382,
        1,
        67392,
        67413,
        1,
        67424,
        67431,
        1
    ]));
    static Linear_B = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        65536,
        65547,
        1,
        65549,
        65574,
        1,
        65576,
        65594,
        1,
        65596,
        65597,
        1,
        65599,
        65613,
        1,
        65616,
        65629,
        1,
        65664,
        65786,
        1
    ]));
    static Lisu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        42192,
        42239,
        1,
        73648,
        73648,
        1
    ]));
    static Lycian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66176,
        66204,
        1
    ]));
    static Lydian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67872,
        67897,
        1,
        67903,
        67903,
        1
    ]));
    static Mahajani = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69968,
        70006,
        1
    ]));
    static Makasar = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        73440,
        73464,
        1
    ]));
    static Malayalam = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3328,
        3340,
        1,
        3342,
        3344,
        1,
        3346,
        3396,
        1,
        3398,
        3400,
        1,
        3402,
        3407,
        1,
        3412,
        3427,
        1,
        3430,
        3455,
        1
    ]));
    static Mandaic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2112,
        2139,
        1,
        2142,
        2142,
        1
    ]));
    static Manichaean = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68288,
        68326,
        1,
        68331,
        68342,
        1
    ]));
    static Marchen = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72816,
        72847,
        1,
        72850,
        72871,
        1,
        72873,
        72886,
        1
    ]));
    static Masaram_Gondi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72960,
        72966,
        1,
        72968,
        72969,
        1,
        72971,
        73014,
        1,
        73018,
        73020,
        2,
        73021,
        73023,
        2,
        73024,
        73031,
        1,
        73040,
        73049,
        1
    ]));
    static Medefaidrin = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        93760,
        93850,
        1
    ]));
    static Meetei_Mayek = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43744,
        43766,
        1,
        43968,
        44013,
        1,
        44016,
        44025,
        1
    ]));
    static Mende_Kikakui = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        124928,
        125124,
        1,
        125127,
        125142,
        1
    ]));
    static Meroitic_Cursive = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68000,
        68023,
        1,
        68028,
        68047,
        1,
        68050,
        68095,
        1
    ]));
    static Meroitic_Hieroglyphs = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67968,
        67999,
        1
    ]));
    static Miao = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        93952,
        94026,
        1,
        94031,
        94087,
        1,
        94095,
        94111,
        1
    ]));
    static Modi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71168,
        71236,
        1,
        71248,
        71257,
        1
    ]));
    static Mongolian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6144,
        6145,
        1,
        6148,
        6150,
        2,
        6151,
        6169,
        1,
        6176,
        6264,
        1,
        6272,
        6314,
        1,
        71264,
        71276,
        1
    ]));
    static Mro = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        92736,
        92766,
        1,
        92768,
        92777,
        1,
        92782,
        92783,
        1
    ]));
    static Multani = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70272,
        70278,
        1,
        70280,
        70282,
        2,
        70283,
        70285,
        1,
        70287,
        70301,
        1,
        70303,
        70313,
        1
    ]));
    static Myanmar = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        4096,
        4255,
        1,
        43488,
        43518,
        1,
        43616,
        43647,
        1,
        71376,
        71395,
        1
    ]));
    static Nabataean = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67712,
        67742,
        1,
        67751,
        67759,
        1
    ]));
    static Nag_Mundari = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        124112,
        124153,
        1
    ]));
    static Nandinagari = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72096,
        72103,
        1,
        72106,
        72151,
        1,
        72154,
        72164,
        1
    ]));
    static New_Tai_Lue = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6528,
        6571,
        1,
        6576,
        6601,
        1,
        6608,
        6618,
        1,
        6622,
        6623,
        1
    ]));
    static Newa = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70656,
        70747,
        1,
        70749,
        70753,
        1
    ]));
    static Nko = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1984,
        2042,
        1,
        2045,
        2047,
        1
    ]));
    static Nushu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        94177,
        110960,
        16783,
        110961,
        111355,
        1
    ]));
    static Nyiakeng_Puachue_Hmong = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        123136,
        123180,
        1,
        123184,
        123197,
        1,
        123200,
        123209,
        1,
        123214,
        123215,
        1
    ]));
    static Ogham = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5760,
        5788,
        1
    ]));
    static Ol_Chiki = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        7248,
        7295,
        1
    ]));
    static Ol_Onal = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        124368,
        124410,
        1,
        124415,
        124415,
        1
    ]));
    static Old_Hungarian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68736,
        68786,
        1,
        68800,
        68850,
        1,
        68858,
        68863,
        1
    ]));
    static Old_Italic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66304,
        66339,
        1,
        66349,
        66351,
        1
    ]));
    static Old_North_Arabian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68224,
        68255,
        1
    ]));
    static Old_Permic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66384,
        66426,
        1
    ]));
    static Old_Persian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66464,
        66499,
        1,
        66504,
        66517,
        1
    ]));
    static Old_Sogdian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69376,
        69415,
        1
    ]));
    static Old_South_Arabian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68192,
        68223,
        1
    ]));
    static Old_Turkic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68608,
        68680,
        1
    ]));
    static Old_Uyghur = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69488,
        69513,
        1
    ]));
    static Oriya = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2817,
        2819,
        1,
        2821,
        2828,
        1,
        2831,
        2832,
        1,
        2835,
        2856,
        1,
        2858,
        2864,
        1,
        2866,
        2867,
        1,
        2869,
        2873,
        1,
        2876,
        2884,
        1,
        2887,
        2888,
        1,
        2891,
        2893,
        1,
        2901,
        2903,
        1,
        2908,
        2909,
        1,
        2911,
        2915,
        1,
        2918,
        2935,
        1
    ]));
    static Osage = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66736,
        66771,
        1,
        66776,
        66811,
        1
    ]));
    static Osmanya = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66688,
        66717,
        1,
        66720,
        66729,
        1
    ]));
    static Pahawh_Hmong = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        92928,
        92997,
        1,
        93008,
        93017,
        1,
        93019,
        93025,
        1,
        93027,
        93047,
        1,
        93053,
        93071,
        1
    ]));
    static Palmyrene = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67680,
        67711,
        1
    ]));
    static Pau_Cin_Hau = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72384,
        72440,
        1
    ]));
    static Phags_Pa = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43072,
        43127,
        1
    ]));
    static Phoenician = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67840,
        67867,
        1,
        67871,
        67871,
        1
    ]));
    static Psalter_Pahlavi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        68480,
        68497,
        1,
        68505,
        68508,
        1,
        68521,
        68527,
        1
    ]));
    static Rejang = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43312,
        43347,
        1,
        43359,
        43359,
        1
    ]));
    static Runic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5792,
        5866,
        1,
        5870,
        5880,
        1
    ]));
    static Samaritan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2048,
        2093,
        1,
        2096,
        2110,
        1
    ]));
    static Saurashtra = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43136,
        43205,
        1,
        43214,
        43225,
        1
    ]));
    static Sharada = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70016,
        70111,
        1
    ]));
    static Shavian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66640,
        66687,
        1
    ]));
    static Siddham = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71040,
        71093,
        1,
        71096,
        71133,
        1
    ]));
    static SignWriting = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        120832,
        121483,
        1,
        121499,
        121503,
        1,
        121505,
        121519,
        1
    ]));
    static Sinhala = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3457,
        3459,
        1,
        3461,
        3478,
        1,
        3482,
        3505,
        1,
        3507,
        3515,
        1,
        3517,
        3520,
        3,
        3521,
        3526,
        1,
        3530,
        3535,
        5,
        3536,
        3540,
        1,
        3542,
        3544,
        2,
        3545,
        3551,
        1,
        3558,
        3567,
        1,
        3570,
        3572,
        1,
        70113,
        70132,
        1
    ]));
    static Sogdian = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69424,
        69465,
        1
    ]));
    static Sora_Sompeng = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69840,
        69864,
        1,
        69872,
        69881,
        1
    ]));
    static Soyombo = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72272,
        72354,
        1
    ]));
    static Sundanese = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        7040,
        7103,
        1,
        7360,
        7367,
        1
    ]));
    static Sunuwar = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72640,
        72673,
        1,
        72688,
        72697,
        1
    ]));
    static Syloti_Nagri = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43008,
        43052,
        1
    ]));
    static Syriac = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1792,
        1805,
        1,
        1807,
        1866,
        1,
        1869,
        1871,
        1,
        2144,
        2154,
        1
    ]));
    static Tagalog = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5888,
        5909,
        1,
        5919,
        5919,
        1
    ]));
    static Tagbanwa = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        5984,
        5996,
        1,
        5998,
        6000,
        1,
        6002,
        6003,
        1
    ]));
    static Tai_Le = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6480,
        6509,
        1,
        6512,
        6516,
        1
    ]));
    static Tai_Tham = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        6688,
        6750,
        1,
        6752,
        6780,
        1,
        6783,
        6793,
        1,
        6800,
        6809,
        1,
        6816,
        6829,
        1
    ]));
    static Tai_Viet = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        43648,
        43714,
        1,
        43739,
        43743,
        1
    ]));
    static Takri = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71296,
        71353,
        1,
        71360,
        71369,
        1
    ]));
    static Tamil = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        2946,
        2947,
        1,
        2949,
        2954,
        1,
        2958,
        2960,
        1,
        2962,
        2965,
        1,
        2969,
        2970,
        1,
        2972,
        2974,
        2,
        2975,
        2979,
        4,
        2980,
        2984,
        4,
        2985,
        2986,
        1,
        2990,
        3001,
        1,
        3006,
        3010,
        1,
        3014,
        3016,
        1,
        3018,
        3021,
        1,
        3024,
        3031,
        7,
        3046,
        3066,
        1,
        73664,
        73713,
        1,
        73727,
        73727,
        1
    ]));
    static Tangsa = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        92784,
        92862,
        1,
        92864,
        92873,
        1
    ]));
    static Tangut = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        94176,
        94208,
        32,
        94209,
        100343,
        1,
        100352,
        101119,
        1,
        101632,
        101640,
        1
    ]));
    static Telugu = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3072,
        3084,
        1,
        3086,
        3088,
        1,
        3090,
        3112,
        1,
        3114,
        3129,
        1,
        3132,
        3140,
        1,
        3142,
        3144,
        1,
        3146,
        3149,
        1,
        3157,
        3158,
        1,
        3160,
        3162,
        1,
        3165,
        3168,
        3,
        3169,
        3171,
        1,
        3174,
        3183,
        1,
        3191,
        3199,
        1
    ]));
    static Thaana = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        1920,
        1969,
        1
    ]));
    static Thai = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3585,
        3642,
        1,
        3648,
        3675,
        1
    ]));
    static Tibetan = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        3840,
        3911,
        1,
        3913,
        3948,
        1,
        3953,
        3991,
        1,
        3993,
        4028,
        1,
        4030,
        4044,
        1,
        4046,
        4052,
        1,
        4057,
        4058,
        1
    ]));
    static Tifinagh = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        11568,
        11623,
        1,
        11631,
        11632,
        1,
        11647,
        11647,
        1
    ]));
    static Tirhuta = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70784,
        70855,
        1,
        70864,
        70873,
        1
    ]));
    static Todhri = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        67008,
        67059,
        1
    ]));
    static Toto = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        123536,
        123566,
        1
    ]));
    static Tulu_Tigalari = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        70528,
        70537,
        1,
        70539,
        70542,
        3,
        70544,
        70581,
        1,
        70583,
        70592,
        1,
        70594,
        70597,
        3,
        70599,
        70602,
        1,
        70604,
        70613,
        1,
        70615,
        70616,
        1,
        70625,
        70626,
        1
    ]));
    static Ugaritic = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66432,
        66461,
        1,
        66463,
        66463,
        1
    ]));
    static Vai = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        42240,
        42539,
        1
    ]));
    static Vithkuqi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        66928,
        66938,
        1,
        66940,
        66954,
        1,
        66956,
        66962,
        1,
        66964,
        66965,
        1,
        66967,
        66977,
        1,
        66979,
        66993,
        1,
        66995,
        67001,
        1,
        67003,
        67004,
        1
    ]));
    static Wancho = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        123584,
        123641,
        1,
        123647,
        123647,
        1
    ]));
    static Warang_Citi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        71840,
        71922,
        1,
        71935,
        71935,
        1
    ]));
    static Yezidi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        69248,
        69289,
        1,
        69291,
        69293,
        1,
        69296,
        69297,
        1
    ]));
    static Yi = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        40960,
        42124,
        1,
        42128,
        42182,
        1
    ]));
    static Zanabazar_Square = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        72192,
        72263,
        1
    ]));
    static CATEGORIES = new Map([
        [
            'C',
            $ff4f66a262d5170f$var$UnicodeTables.C
        ],
        [
            'Cc',
            $ff4f66a262d5170f$var$UnicodeTables.Cc
        ],
        [
            'Cf',
            $ff4f66a262d5170f$var$UnicodeTables.Cf
        ],
        [
            'Co',
            $ff4f66a262d5170f$var$UnicodeTables.Co
        ],
        [
            'Cs',
            $ff4f66a262d5170f$var$UnicodeTables.Cs
        ],
        [
            'L',
            $ff4f66a262d5170f$var$UnicodeTables.L
        ],
        [
            'Ll',
            $ff4f66a262d5170f$var$UnicodeTables.Ll
        ],
        [
            'Lm',
            $ff4f66a262d5170f$var$UnicodeTables.Lm
        ],
        [
            'Lo',
            $ff4f66a262d5170f$var$UnicodeTables.Lo
        ],
        [
            'Lt',
            $ff4f66a262d5170f$var$UnicodeTables.Lt
        ],
        [
            'Lu',
            $ff4f66a262d5170f$var$UnicodeTables.Lu
        ],
        [
            'M',
            $ff4f66a262d5170f$var$UnicodeTables.M
        ],
        [
            'Mc',
            $ff4f66a262d5170f$var$UnicodeTables.Mc
        ],
        [
            'Me',
            $ff4f66a262d5170f$var$UnicodeTables.Me
        ],
        [
            'Mn',
            $ff4f66a262d5170f$var$UnicodeTables.Mn
        ],
        [
            'N',
            $ff4f66a262d5170f$var$UnicodeTables.N
        ],
        [
            'Nd',
            $ff4f66a262d5170f$var$UnicodeTables.Nd
        ],
        [
            'Nl',
            $ff4f66a262d5170f$var$UnicodeTables.Nl
        ],
        [
            'No',
            $ff4f66a262d5170f$var$UnicodeTables.No
        ],
        [
            'P',
            $ff4f66a262d5170f$var$UnicodeTables.P
        ],
        [
            'Pc',
            $ff4f66a262d5170f$var$UnicodeTables.Pc
        ],
        [
            'Pd',
            $ff4f66a262d5170f$var$UnicodeTables.Pd
        ],
        [
            'Pe',
            $ff4f66a262d5170f$var$UnicodeTables.Pe
        ],
        [
            'Pf',
            $ff4f66a262d5170f$var$UnicodeTables.Pf
        ],
        [
            'Pi',
            $ff4f66a262d5170f$var$UnicodeTables.Pi
        ],
        [
            'Po',
            $ff4f66a262d5170f$var$UnicodeTables.Po
        ],
        [
            'Ps',
            $ff4f66a262d5170f$var$UnicodeTables.Ps
        ],
        [
            'S',
            $ff4f66a262d5170f$var$UnicodeTables.S
        ],
        [
            'Sc',
            $ff4f66a262d5170f$var$UnicodeTables.Sc
        ],
        [
            'Sk',
            $ff4f66a262d5170f$var$UnicodeTables.Sk
        ],
        [
            'Sm',
            $ff4f66a262d5170f$var$UnicodeTables.Sm
        ],
        [
            'So',
            $ff4f66a262d5170f$var$UnicodeTables.So
        ],
        [
            'Z',
            $ff4f66a262d5170f$var$UnicodeTables.Z
        ],
        [
            'Zl',
            $ff4f66a262d5170f$var$UnicodeTables.Zl
        ],
        [
            'Zp',
            $ff4f66a262d5170f$var$UnicodeTables.Zp
        ],
        [
            'Zs',
            $ff4f66a262d5170f$var$UnicodeTables.Zs
        ]
    ]);
    static SCRIPTS = new Map([
        [
            'Adlam',
            $ff4f66a262d5170f$var$UnicodeTables.Adlam
        ],
        [
            'Ahom',
            $ff4f66a262d5170f$var$UnicodeTables.Ahom
        ],
        [
            'Anatolian_Hieroglyphs',
            $ff4f66a262d5170f$var$UnicodeTables.Anatolian_Hieroglyphs
        ],
        [
            'Arabic',
            $ff4f66a262d5170f$var$UnicodeTables.Arabic
        ],
        [
            'Armenian',
            $ff4f66a262d5170f$var$UnicodeTables.Armenian
        ],
        [
            'Avestan',
            $ff4f66a262d5170f$var$UnicodeTables.Avestan
        ],
        [
            'Balinese',
            $ff4f66a262d5170f$var$UnicodeTables.Balinese
        ],
        [
            'Bamum',
            $ff4f66a262d5170f$var$UnicodeTables.Bamum
        ],
        [
            'Bassa_Vah',
            $ff4f66a262d5170f$var$UnicodeTables.Bassa_Vah
        ],
        [
            'Batak',
            $ff4f66a262d5170f$var$UnicodeTables.Batak
        ],
        [
            'Bengali',
            $ff4f66a262d5170f$var$UnicodeTables.Bengali
        ],
        [
            'Bhaiksuki',
            $ff4f66a262d5170f$var$UnicodeTables.Bhaiksuki
        ],
        [
            'Bopomofo',
            $ff4f66a262d5170f$var$UnicodeTables.Bopomofo
        ],
        [
            'Brahmi',
            $ff4f66a262d5170f$var$UnicodeTables.Brahmi
        ],
        [
            'Braille',
            $ff4f66a262d5170f$var$UnicodeTables.Braille
        ],
        [
            'Buginese',
            $ff4f66a262d5170f$var$UnicodeTables.Buginese
        ],
        [
            'Buhid',
            $ff4f66a262d5170f$var$UnicodeTables.Buhid
        ],
        [
            'Canadian_Aboriginal',
            $ff4f66a262d5170f$var$UnicodeTables.Canadian_Aboriginal
        ],
        [
            'Carian',
            $ff4f66a262d5170f$var$UnicodeTables.Carian
        ],
        [
            'Caucasian_Albanian',
            $ff4f66a262d5170f$var$UnicodeTables.Caucasian_Albanian
        ],
        [
            'Chakma',
            $ff4f66a262d5170f$var$UnicodeTables.Chakma
        ],
        [
            'Cham',
            $ff4f66a262d5170f$var$UnicodeTables.Cham
        ],
        [
            'Cherokee',
            $ff4f66a262d5170f$var$UnicodeTables.Cherokee
        ],
        [
            'Chorasmian',
            $ff4f66a262d5170f$var$UnicodeTables.Chorasmian
        ],
        [
            'Common',
            $ff4f66a262d5170f$var$UnicodeTables.Common
        ],
        [
            'Coptic',
            $ff4f66a262d5170f$var$UnicodeTables.Coptic
        ],
        [
            'Cuneiform',
            $ff4f66a262d5170f$var$UnicodeTables.Cuneiform
        ],
        [
            'Cypriot',
            $ff4f66a262d5170f$var$UnicodeTables.Cypriot
        ],
        [
            'Cypro_Minoan',
            $ff4f66a262d5170f$var$UnicodeTables.Cypro_Minoan
        ],
        [
            'Cyrillic',
            $ff4f66a262d5170f$var$UnicodeTables.Cyrillic
        ],
        [
            'Deseret',
            $ff4f66a262d5170f$var$UnicodeTables.Deseret
        ],
        [
            'Devanagari',
            $ff4f66a262d5170f$var$UnicodeTables.Devanagari
        ],
        [
            'Dives_Akuru',
            $ff4f66a262d5170f$var$UnicodeTables.Dives_Akuru
        ],
        [
            'Dogra',
            $ff4f66a262d5170f$var$UnicodeTables.Dogra
        ],
        [
            'Duployan',
            $ff4f66a262d5170f$var$UnicodeTables.Duployan
        ],
        [
            'Egyptian_Hieroglyphs',
            $ff4f66a262d5170f$var$UnicodeTables.Egyptian_Hieroglyphs
        ],
        [
            'Elbasan',
            $ff4f66a262d5170f$var$UnicodeTables.Elbasan
        ],
        [
            'Elymaic',
            $ff4f66a262d5170f$var$UnicodeTables.Elymaic
        ],
        [
            'Ethiopic',
            $ff4f66a262d5170f$var$UnicodeTables.Ethiopic
        ],
        [
            'Garay',
            $ff4f66a262d5170f$var$UnicodeTables.Garay
        ],
        [
            'Georgian',
            $ff4f66a262d5170f$var$UnicodeTables.Georgian
        ],
        [
            'Glagolitic',
            $ff4f66a262d5170f$var$UnicodeTables.Glagolitic
        ],
        [
            'Gothic',
            $ff4f66a262d5170f$var$UnicodeTables.Gothic
        ],
        [
            'Grantha',
            $ff4f66a262d5170f$var$UnicodeTables.Grantha
        ],
        [
            'Greek',
            $ff4f66a262d5170f$var$UnicodeTables.Greek
        ],
        [
            'Gujarati',
            $ff4f66a262d5170f$var$UnicodeTables.Gujarati
        ],
        [
            'Gunjala_Gondi',
            $ff4f66a262d5170f$var$UnicodeTables.Gunjala_Gondi
        ],
        [
            'Gurmukhi',
            $ff4f66a262d5170f$var$UnicodeTables.Gurmukhi
        ],
        [
            'Gurung_Khema',
            $ff4f66a262d5170f$var$UnicodeTables.Gurung_Khema
        ],
        [
            'Han',
            $ff4f66a262d5170f$var$UnicodeTables.Han
        ],
        [
            'Hangul',
            $ff4f66a262d5170f$var$UnicodeTables.Hangul
        ],
        [
            'Hanifi_Rohingya',
            $ff4f66a262d5170f$var$UnicodeTables.Hanifi_Rohingya
        ],
        [
            'Hanunoo',
            $ff4f66a262d5170f$var$UnicodeTables.Hanunoo
        ],
        [
            'Hatran',
            $ff4f66a262d5170f$var$UnicodeTables.Hatran
        ],
        [
            'Hebrew',
            $ff4f66a262d5170f$var$UnicodeTables.Hebrew
        ],
        [
            'Hiragana',
            $ff4f66a262d5170f$var$UnicodeTables.Hiragana
        ],
        [
            'Imperial_Aramaic',
            $ff4f66a262d5170f$var$UnicodeTables.Imperial_Aramaic
        ],
        [
            'Inherited',
            $ff4f66a262d5170f$var$UnicodeTables.Inherited
        ],
        [
            'Inscriptional_Pahlavi',
            $ff4f66a262d5170f$var$UnicodeTables.Inscriptional_Pahlavi
        ],
        [
            'Inscriptional_Parthian',
            $ff4f66a262d5170f$var$UnicodeTables.Inscriptional_Parthian
        ],
        [
            'Javanese',
            $ff4f66a262d5170f$var$UnicodeTables.Javanese
        ],
        [
            'Kaithi',
            $ff4f66a262d5170f$var$UnicodeTables.Kaithi
        ],
        [
            'Kannada',
            $ff4f66a262d5170f$var$UnicodeTables.Kannada
        ],
        [
            'Katakana',
            $ff4f66a262d5170f$var$UnicodeTables.Katakana
        ],
        [
            'Kawi',
            $ff4f66a262d5170f$var$UnicodeTables.Kawi
        ],
        [
            'Kayah_Li',
            $ff4f66a262d5170f$var$UnicodeTables.Kayah_Li
        ],
        [
            'Kharoshthi',
            $ff4f66a262d5170f$var$UnicodeTables.Kharoshthi
        ],
        [
            'Khitan_Small_Script',
            $ff4f66a262d5170f$var$UnicodeTables.Khitan_Small_Script
        ],
        [
            'Khmer',
            $ff4f66a262d5170f$var$UnicodeTables.Khmer
        ],
        [
            'Khojki',
            $ff4f66a262d5170f$var$UnicodeTables.Khojki
        ],
        [
            'Khudawadi',
            $ff4f66a262d5170f$var$UnicodeTables.Khudawadi
        ],
        [
            'Kirat_Rai',
            $ff4f66a262d5170f$var$UnicodeTables.Kirat_Rai
        ],
        [
            'Lao',
            $ff4f66a262d5170f$var$UnicodeTables.Lao
        ],
        [
            'Latin',
            $ff4f66a262d5170f$var$UnicodeTables.Latin
        ],
        [
            'Lepcha',
            $ff4f66a262d5170f$var$UnicodeTables.Lepcha
        ],
        [
            'Limbu',
            $ff4f66a262d5170f$var$UnicodeTables.Limbu
        ],
        [
            'Linear_A',
            $ff4f66a262d5170f$var$UnicodeTables.Linear_A
        ],
        [
            'Linear_B',
            $ff4f66a262d5170f$var$UnicodeTables.Linear_B
        ],
        [
            'Lisu',
            $ff4f66a262d5170f$var$UnicodeTables.Lisu
        ],
        [
            'Lycian',
            $ff4f66a262d5170f$var$UnicodeTables.Lycian
        ],
        [
            'Lydian',
            $ff4f66a262d5170f$var$UnicodeTables.Lydian
        ],
        [
            'Mahajani',
            $ff4f66a262d5170f$var$UnicodeTables.Mahajani
        ],
        [
            'Makasar',
            $ff4f66a262d5170f$var$UnicodeTables.Makasar
        ],
        [
            'Malayalam',
            $ff4f66a262d5170f$var$UnicodeTables.Malayalam
        ],
        [
            'Mandaic',
            $ff4f66a262d5170f$var$UnicodeTables.Mandaic
        ],
        [
            'Manichaean',
            $ff4f66a262d5170f$var$UnicodeTables.Manichaean
        ],
        [
            'Marchen',
            $ff4f66a262d5170f$var$UnicodeTables.Marchen
        ],
        [
            'Masaram_Gondi',
            $ff4f66a262d5170f$var$UnicodeTables.Masaram_Gondi
        ],
        [
            'Medefaidrin',
            $ff4f66a262d5170f$var$UnicodeTables.Medefaidrin
        ],
        [
            'Meetei_Mayek',
            $ff4f66a262d5170f$var$UnicodeTables.Meetei_Mayek
        ],
        [
            'Mende_Kikakui',
            $ff4f66a262d5170f$var$UnicodeTables.Mende_Kikakui
        ],
        [
            'Meroitic_Cursive',
            $ff4f66a262d5170f$var$UnicodeTables.Meroitic_Cursive
        ],
        [
            'Meroitic_Hieroglyphs',
            $ff4f66a262d5170f$var$UnicodeTables.Meroitic_Hieroglyphs
        ],
        [
            'Miao',
            $ff4f66a262d5170f$var$UnicodeTables.Miao
        ],
        [
            'Modi',
            $ff4f66a262d5170f$var$UnicodeTables.Modi
        ],
        [
            'Mongolian',
            $ff4f66a262d5170f$var$UnicodeTables.Mongolian
        ],
        [
            'Mro',
            $ff4f66a262d5170f$var$UnicodeTables.Mro
        ],
        [
            'Multani',
            $ff4f66a262d5170f$var$UnicodeTables.Multani
        ],
        [
            'Myanmar',
            $ff4f66a262d5170f$var$UnicodeTables.Myanmar
        ],
        [
            'Nabataean',
            $ff4f66a262d5170f$var$UnicodeTables.Nabataean
        ],
        [
            'Nag_Mundari',
            $ff4f66a262d5170f$var$UnicodeTables.Nag_Mundari
        ],
        [
            'Nandinagari',
            $ff4f66a262d5170f$var$UnicodeTables.Nandinagari
        ],
        [
            'New_Tai_Lue',
            $ff4f66a262d5170f$var$UnicodeTables.New_Tai_Lue
        ],
        [
            'Newa',
            $ff4f66a262d5170f$var$UnicodeTables.Newa
        ],
        [
            'Nko',
            $ff4f66a262d5170f$var$UnicodeTables.Nko
        ],
        [
            'Nushu',
            $ff4f66a262d5170f$var$UnicodeTables.Nushu
        ],
        [
            'Nyiakeng_Puachue_Hmong',
            $ff4f66a262d5170f$var$UnicodeTables.Nyiakeng_Puachue_Hmong
        ],
        [
            'Ogham',
            $ff4f66a262d5170f$var$UnicodeTables.Ogham
        ],
        [
            'Ol_Chiki',
            $ff4f66a262d5170f$var$UnicodeTables.Ol_Chiki
        ],
        [
            'Ol_Onal',
            $ff4f66a262d5170f$var$UnicodeTables.Ol_Onal
        ],
        [
            'Old_Hungarian',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Hungarian
        ],
        [
            'Old_Italic',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Italic
        ],
        [
            'Old_North_Arabian',
            $ff4f66a262d5170f$var$UnicodeTables.Old_North_Arabian
        ],
        [
            'Old_Permic',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Permic
        ],
        [
            'Old_Persian',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Persian
        ],
        [
            'Old_Sogdian',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Sogdian
        ],
        [
            'Old_South_Arabian',
            $ff4f66a262d5170f$var$UnicodeTables.Old_South_Arabian
        ],
        [
            'Old_Turkic',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Turkic
        ],
        [
            'Old_Uyghur',
            $ff4f66a262d5170f$var$UnicodeTables.Old_Uyghur
        ],
        [
            'Oriya',
            $ff4f66a262d5170f$var$UnicodeTables.Oriya
        ],
        [
            'Osage',
            $ff4f66a262d5170f$var$UnicodeTables.Osage
        ],
        [
            'Osmanya',
            $ff4f66a262d5170f$var$UnicodeTables.Osmanya
        ],
        [
            'Pahawh_Hmong',
            $ff4f66a262d5170f$var$UnicodeTables.Pahawh_Hmong
        ],
        [
            'Palmyrene',
            $ff4f66a262d5170f$var$UnicodeTables.Palmyrene
        ],
        [
            'Pau_Cin_Hau',
            $ff4f66a262d5170f$var$UnicodeTables.Pau_Cin_Hau
        ],
        [
            'Phags_Pa',
            $ff4f66a262d5170f$var$UnicodeTables.Phags_Pa
        ],
        [
            'Phoenician',
            $ff4f66a262d5170f$var$UnicodeTables.Phoenician
        ],
        [
            'Psalter_Pahlavi',
            $ff4f66a262d5170f$var$UnicodeTables.Psalter_Pahlavi
        ],
        [
            'Rejang',
            $ff4f66a262d5170f$var$UnicodeTables.Rejang
        ],
        [
            'Runic',
            $ff4f66a262d5170f$var$UnicodeTables.Runic
        ],
        [
            'Samaritan',
            $ff4f66a262d5170f$var$UnicodeTables.Samaritan
        ],
        [
            'Saurashtra',
            $ff4f66a262d5170f$var$UnicodeTables.Saurashtra
        ],
        [
            'Sharada',
            $ff4f66a262d5170f$var$UnicodeTables.Sharada
        ],
        [
            'Shavian',
            $ff4f66a262d5170f$var$UnicodeTables.Shavian
        ],
        [
            'Siddham',
            $ff4f66a262d5170f$var$UnicodeTables.Siddham
        ],
        [
            'SignWriting',
            $ff4f66a262d5170f$var$UnicodeTables.SignWriting
        ],
        [
            'Sinhala',
            $ff4f66a262d5170f$var$UnicodeTables.Sinhala
        ],
        [
            'Sogdian',
            $ff4f66a262d5170f$var$UnicodeTables.Sogdian
        ],
        [
            'Sora_Sompeng',
            $ff4f66a262d5170f$var$UnicodeTables.Sora_Sompeng
        ],
        [
            'Soyombo',
            $ff4f66a262d5170f$var$UnicodeTables.Soyombo
        ],
        [
            'Sundanese',
            $ff4f66a262d5170f$var$UnicodeTables.Sundanese
        ],
        [
            'Sunuwar',
            $ff4f66a262d5170f$var$UnicodeTables.Sunuwar
        ],
        [
            'Syloti_Nagri',
            $ff4f66a262d5170f$var$UnicodeTables.Syloti_Nagri
        ],
        [
            'Syriac',
            $ff4f66a262d5170f$var$UnicodeTables.Syriac
        ],
        [
            'Tagalog',
            $ff4f66a262d5170f$var$UnicodeTables.Tagalog
        ],
        [
            'Tagbanwa',
            $ff4f66a262d5170f$var$UnicodeTables.Tagbanwa
        ],
        [
            'Tai_Le',
            $ff4f66a262d5170f$var$UnicodeTables.Tai_Le
        ],
        [
            'Tai_Tham',
            $ff4f66a262d5170f$var$UnicodeTables.Tai_Tham
        ],
        [
            'Tai_Viet',
            $ff4f66a262d5170f$var$UnicodeTables.Tai_Viet
        ],
        [
            'Takri',
            $ff4f66a262d5170f$var$UnicodeTables.Takri
        ],
        [
            'Tamil',
            $ff4f66a262d5170f$var$UnicodeTables.Tamil
        ],
        [
            'Tangsa',
            $ff4f66a262d5170f$var$UnicodeTables.Tangsa
        ],
        [
            'Tangut',
            $ff4f66a262d5170f$var$UnicodeTables.Tangut
        ],
        [
            'Telugu',
            $ff4f66a262d5170f$var$UnicodeTables.Telugu
        ],
        [
            'Thaana',
            $ff4f66a262d5170f$var$UnicodeTables.Thaana
        ],
        [
            'Thai',
            $ff4f66a262d5170f$var$UnicodeTables.Thai
        ],
        [
            'Tibetan',
            $ff4f66a262d5170f$var$UnicodeTables.Tibetan
        ],
        [
            'Tifinagh',
            $ff4f66a262d5170f$var$UnicodeTables.Tifinagh
        ],
        [
            'Tirhuta',
            $ff4f66a262d5170f$var$UnicodeTables.Tirhuta
        ],
        [
            'Todhri',
            $ff4f66a262d5170f$var$UnicodeTables.Todhri
        ],
        [
            'Toto',
            $ff4f66a262d5170f$var$UnicodeTables.Toto
        ],
        [
            'Tulu_Tigalari',
            $ff4f66a262d5170f$var$UnicodeTables.Tulu_Tigalari
        ],
        [
            'Ugaritic',
            $ff4f66a262d5170f$var$UnicodeTables.Ugaritic
        ],
        [
            'Vai',
            $ff4f66a262d5170f$var$UnicodeTables.Vai
        ],
        [
            'Vithkuqi',
            $ff4f66a262d5170f$var$UnicodeTables.Vithkuqi
        ],
        [
            'Wancho',
            $ff4f66a262d5170f$var$UnicodeTables.Wancho
        ],
        [
            'Warang_Citi',
            $ff4f66a262d5170f$var$UnicodeTables.Warang_Citi
        ],
        [
            'Yezidi',
            $ff4f66a262d5170f$var$UnicodeTables.Yezidi
        ],
        [
            'Yi',
            $ff4f66a262d5170f$var$UnicodeTables.Yi
        ],
        [
            'Zanabazar_Square',
            $ff4f66a262d5170f$var$UnicodeTables.Zanabazar_Square
        ]
    ]);
    static FOLD_CATEGORIES = new Map([
        [
            'L',
            $ff4f66a262d5170f$var$UnicodeTables.foldL
        ],
        [
            'Ll',
            $ff4f66a262d5170f$var$UnicodeTables.foldLl
        ],
        [
            'Lt',
            $ff4f66a262d5170f$var$UnicodeTables.foldLt
        ],
        [
            'Lu',
            $ff4f66a262d5170f$var$UnicodeTables.foldLu
        ],
        [
            'M',
            $ff4f66a262d5170f$var$UnicodeTables.foldM
        ],
        [
            'Mn',
            $ff4f66a262d5170f$var$UnicodeTables.foldMn
        ]
    ]);
    static FOLD_SCRIPT = new Map([
        [
            'Common',
            $ff4f66a262d5170f$var$UnicodeTables.foldCommon
        ],
        [
            'Greek',
            $ff4f66a262d5170f$var$UnicodeTables.foldGreek
        ],
        [
            'Inherited',
            $ff4f66a262d5170f$var$UnicodeTables.foldInherited
        ]
    ]);
    static Print = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        33,
        126,
        1,
        161,
        172,
        1,
        174,
        887,
        1,
        890,
        895,
        1,
        900,
        906,
        1,
        908,
        910,
        2,
        911,
        929,
        1,
        931,
        1327,
        1,
        1329,
        1366,
        1,
        1369,
        1418,
        1,
        1421,
        1423,
        1,
        1425,
        1479,
        1,
        1488,
        1514,
        1,
        1519,
        1524,
        1,
        1542,
        1563,
        1,
        1565,
        1756,
        1,
        1758,
        1805,
        1,
        1808,
        1866,
        1,
        1869,
        1969,
        1,
        1984,
        2042,
        1,
        2045,
        2093,
        1,
        2096,
        2110,
        1,
        2112,
        2139,
        1,
        2142,
        2144,
        2,
        2145,
        2154,
        1,
        2160,
        2190,
        1,
        2199,
        2273,
        1,
        2275,
        2435,
        1,
        2437,
        2444,
        1,
        2447,
        2448,
        1,
        2451,
        2472,
        1,
        2474,
        2480,
        1,
        2482,
        2486,
        4,
        2487,
        2489,
        1,
        2492,
        2500,
        1,
        2503,
        2504,
        1,
        2507,
        2510,
        1,
        2519,
        2524,
        5,
        2525,
        2527,
        2,
        2528,
        2531,
        1,
        2534,
        2558,
        1,
        2561,
        2563,
        1,
        2565,
        2570,
        1,
        2575,
        2576,
        1,
        2579,
        2600,
        1,
        2602,
        2608,
        1,
        2610,
        2611,
        1,
        2613,
        2614,
        1,
        2616,
        2617,
        1,
        2620,
        2622,
        2,
        2623,
        2626,
        1,
        2631,
        2632,
        1,
        2635,
        2637,
        1,
        2641,
        2649,
        8,
        2650,
        2652,
        1,
        2654,
        2662,
        8,
        2663,
        2678,
        1,
        2689,
        2691,
        1,
        2693,
        2701,
        1,
        2703,
        2705,
        1,
        2707,
        2728,
        1,
        2730,
        2736,
        1,
        2738,
        2739,
        1,
        2741,
        2745,
        1,
        2748,
        2757,
        1,
        2759,
        2761,
        1,
        2763,
        2765,
        1,
        2768,
        2784,
        16,
        2785,
        2787,
        1,
        2790,
        2801,
        1,
        2809,
        2815,
        1,
        2817,
        2819,
        1,
        2821,
        2828,
        1,
        2831,
        2832,
        1,
        2835,
        2856,
        1,
        2858,
        2864,
        1,
        2866,
        2867,
        1,
        2869,
        2873,
        1,
        2876,
        2884,
        1,
        2887,
        2888,
        1,
        2891,
        2893,
        1,
        2901,
        2903,
        1,
        2908,
        2909,
        1,
        2911,
        2915,
        1,
        2918,
        2935,
        1,
        2946,
        2947,
        1,
        2949,
        2954,
        1,
        2958,
        2960,
        1,
        2962,
        2965,
        1,
        2969,
        2970,
        1,
        2972,
        2974,
        2,
        2975,
        2979,
        4,
        2980,
        2984,
        4,
        2985,
        2986,
        1,
        2990,
        3001,
        1,
        3006,
        3010,
        1,
        3014,
        3016,
        1,
        3018,
        3021,
        1,
        3024,
        3031,
        7,
        3046,
        3066,
        1,
        3072,
        3084,
        1,
        3086,
        3088,
        1,
        3090,
        3112,
        1,
        3114,
        3129,
        1,
        3132,
        3140,
        1,
        3142,
        3144,
        1,
        3146,
        3149,
        1,
        3157,
        3158,
        1,
        3160,
        3162,
        1,
        3165,
        3168,
        3,
        3169,
        3171,
        1,
        3174,
        3183,
        1,
        3191,
        3212,
        1,
        3214,
        3216,
        1,
        3218,
        3240,
        1,
        3242,
        3251,
        1,
        3253,
        3257,
        1,
        3260,
        3268,
        1,
        3270,
        3272,
        1,
        3274,
        3277,
        1,
        3285,
        3286,
        1,
        3293,
        3294,
        1,
        3296,
        3299,
        1,
        3302,
        3311,
        1,
        3313,
        3315,
        1,
        3328,
        3340,
        1,
        3342,
        3344,
        1,
        3346,
        3396,
        1,
        3398,
        3400,
        1,
        3402,
        3407,
        1,
        3412,
        3427,
        1,
        3430,
        3455,
        1,
        3457,
        3459,
        1,
        3461,
        3478,
        1,
        3482,
        3505,
        1,
        3507,
        3515,
        1,
        3517,
        3520,
        3,
        3521,
        3526,
        1,
        3530,
        3535,
        5,
        3536,
        3540,
        1,
        3542,
        3544,
        2,
        3545,
        3551,
        1,
        3558,
        3567,
        1,
        3570,
        3572,
        1,
        3585,
        3642,
        1,
        3647,
        3675,
        1,
        3713,
        3714,
        1,
        3716,
        3718,
        2,
        3719,
        3722,
        1,
        3724,
        3747,
        1,
        3749,
        3751,
        2,
        3752,
        3773,
        1,
        3776,
        3780,
        1,
        3782,
        3784,
        2,
        3785,
        3790,
        1,
        3792,
        3801,
        1,
        3804,
        3807,
        1,
        3840,
        3911,
        1,
        3913,
        3948,
        1,
        3953,
        3991,
        1,
        3993,
        4028,
        1,
        4030,
        4044,
        1,
        4046,
        4058,
        1,
        4096,
        4293,
        1,
        4295,
        4301,
        6,
        4304,
        4680,
        1,
        4682,
        4685,
        1,
        4688,
        4694,
        1,
        4696,
        4698,
        2,
        4699,
        4701,
        1,
        4704,
        4744,
        1,
        4746,
        4749,
        1,
        4752,
        4784,
        1,
        4786,
        4789,
        1,
        4792,
        4798,
        1,
        4800,
        4802,
        2,
        4803,
        4805,
        1,
        4808,
        4822,
        1,
        4824,
        4880,
        1,
        4882,
        4885,
        1,
        4888,
        4954,
        1,
        4957,
        4988,
        1,
        4992,
        5017,
        1,
        5024,
        5109,
        1,
        5112,
        5117,
        1,
        5120,
        5759,
        1,
        5761,
        5788,
        1,
        5792,
        5880,
        1,
        5888,
        5909,
        1,
        5919,
        5942,
        1,
        5952,
        5971,
        1,
        5984,
        5996,
        1,
        5998,
        6000,
        1,
        6002,
        6003,
        1,
        6016,
        6109,
        1,
        6112,
        6121,
        1,
        6128,
        6137,
        1,
        6144,
        6157,
        1,
        6159,
        6169,
        1,
        6176,
        6264,
        1,
        6272,
        6314,
        1,
        6320,
        6389,
        1,
        6400,
        6430,
        1,
        6432,
        6443,
        1,
        6448,
        6459,
        1,
        6464,
        6468,
        4,
        6469,
        6509,
        1,
        6512,
        6516,
        1,
        6528,
        6571,
        1,
        6576,
        6601,
        1,
        6608,
        6618,
        1,
        6622,
        6683,
        1,
        6686,
        6750,
        1,
        6752,
        6780,
        1,
        6783,
        6793,
        1,
        6800,
        6809,
        1,
        6816,
        6829,
        1,
        6832,
        6862,
        1,
        6912,
        6988,
        1,
        6990,
        7155,
        1,
        7164,
        7223,
        1,
        7227,
        7241,
        1,
        7245,
        7306,
        1,
        7312,
        7354,
        1,
        7357,
        7367,
        1,
        7376,
        7418,
        1,
        7424,
        7957,
        1,
        7960,
        7965,
        1,
        7968,
        8005,
        1,
        8008,
        8013,
        1,
        8016,
        8023,
        1,
        8025,
        8031,
        2,
        8032,
        8061,
        1,
        8064,
        8116,
        1,
        8118,
        8132,
        1,
        8134,
        8147,
        1,
        8150,
        8155,
        1,
        8157,
        8175,
        1,
        8178,
        8180,
        1,
        8182,
        8190,
        1,
        8208,
        8231,
        1,
        8240,
        8286,
        1,
        8304,
        8305,
        1,
        8308,
        8334,
        1,
        8336,
        8348,
        1,
        8352,
        8384,
        1,
        8400,
        8432,
        1,
        8448,
        8587,
        1,
        8592,
        9257,
        1,
        9280,
        9290,
        1,
        9312,
        11123,
        1,
        11126,
        11157,
        1,
        11159,
        11507,
        1,
        11513,
        11557,
        1,
        11559,
        11565,
        6,
        11568,
        11623,
        1,
        11631,
        11632,
        1,
        11647,
        11670,
        1,
        11680,
        11686,
        1,
        11688,
        11694,
        1,
        11696,
        11702,
        1,
        11704,
        11710,
        1,
        11712,
        11718,
        1,
        11720,
        11726,
        1,
        11728,
        11734,
        1,
        11736,
        11742,
        1,
        11744,
        11869,
        1,
        11904,
        11929,
        1,
        11931,
        12019,
        1,
        12032,
        12245,
        1,
        12272,
        12287,
        1,
        12289,
        12351,
        1,
        12353,
        12438,
        1,
        12441,
        12543,
        1,
        12549,
        12591,
        1,
        12593,
        12686,
        1,
        12688,
        12773,
        1,
        12783,
        12830,
        1,
        12832,
        42124,
        1,
        42128,
        42182,
        1,
        42192,
        42539,
        1,
        42560,
        42743,
        1,
        42752,
        42957,
        1,
        42960,
        42961,
        1,
        42963,
        42965,
        2,
        42966,
        42972,
        1,
        42994,
        43052,
        1,
        43056,
        43065,
        1,
        43072,
        43127,
        1,
        43136,
        43205,
        1,
        43214,
        43225,
        1,
        43232,
        43347,
        1,
        43359,
        43388,
        1,
        43392,
        43469,
        1,
        43471,
        43481,
        1,
        43486,
        43518,
        1,
        43520,
        43574,
        1,
        43584,
        43597,
        1,
        43600,
        43609,
        1,
        43612,
        43714,
        1,
        43739,
        43766,
        1,
        43777,
        43782,
        1,
        43785,
        43790,
        1,
        43793,
        43798,
        1,
        43808,
        43814,
        1,
        43816,
        43822,
        1,
        43824,
        43883,
        1,
        43888,
        44013,
        1,
        44016,
        44025,
        1,
        44032,
        55203,
        1,
        55216,
        55238,
        1,
        55243,
        55291,
        1,
        63744,
        64109,
        1,
        64112,
        64217,
        1,
        64256,
        64262,
        1,
        64275,
        64279,
        1,
        64285,
        64310,
        1,
        64312,
        64316,
        1,
        64318,
        64320,
        2,
        64321,
        64323,
        2,
        64324,
        64326,
        2,
        64327,
        64450,
        1,
        64467,
        64911,
        1,
        64914,
        64967,
        1,
        64975,
        65008,
        33,
        65009,
        65049,
        1,
        65056,
        65106,
        1,
        65108,
        65126,
        1,
        65128,
        65131,
        1,
        65136,
        65140,
        1,
        65142,
        65276,
        1,
        65281,
        65470,
        1,
        65474,
        65479,
        1,
        65482,
        65487,
        1,
        65490,
        65495,
        1,
        65498,
        65500,
        1,
        65504,
        65510,
        1,
        65512,
        65518,
        1,
        65532,
        65533,
        1,
        65536,
        65547,
        1,
        65549,
        65574,
        1,
        65576,
        65594,
        1,
        65596,
        65597,
        1,
        65599,
        65613,
        1,
        65616,
        65629,
        1,
        65664,
        65786,
        1,
        65792,
        65794,
        1,
        65799,
        65843,
        1,
        65847,
        65934,
        1,
        65936,
        65948,
        1,
        65952,
        66000,
        48,
        66001,
        66045,
        1,
        66176,
        66204,
        1,
        66208,
        66256,
        1,
        66272,
        66299,
        1,
        66304,
        66339,
        1,
        66349,
        66378,
        1,
        66384,
        66426,
        1,
        66432,
        66461,
        1,
        66463,
        66499,
        1,
        66504,
        66517,
        1,
        66560,
        66717,
        1,
        66720,
        66729,
        1,
        66736,
        66771,
        1,
        66776,
        66811,
        1,
        66816,
        66855,
        1,
        66864,
        66915,
        1,
        66927,
        66938,
        1,
        66940,
        66954,
        1,
        66956,
        66962,
        1,
        66964,
        66965,
        1,
        66967,
        66977,
        1,
        66979,
        66993,
        1,
        66995,
        67001,
        1,
        67003,
        67004,
        1,
        67008,
        67059,
        1,
        67072,
        67382,
        1,
        67392,
        67413,
        1,
        67424,
        67431,
        1,
        67456,
        67461,
        1,
        67463,
        67504,
        1,
        67506,
        67514,
        1,
        67584,
        67589,
        1,
        67592,
        67594,
        2,
        67595,
        67637,
        1,
        67639,
        67640,
        1,
        67644,
        67647,
        3,
        67648,
        67669,
        1,
        67671,
        67742,
        1,
        67751,
        67759,
        1,
        67808,
        67826,
        1,
        67828,
        67829,
        1,
        67835,
        67867,
        1,
        67871,
        67897,
        1,
        67903,
        67968,
        65,
        67969,
        68023,
        1,
        68028,
        68047,
        1,
        68050,
        68099,
        1,
        68101,
        68102,
        1,
        68108,
        68115,
        1,
        68117,
        68119,
        1,
        68121,
        68149,
        1,
        68152,
        68154,
        1,
        68159,
        68168,
        1,
        68176,
        68184,
        1,
        68192,
        68255,
        1,
        68288,
        68326,
        1,
        68331,
        68342,
        1,
        68352,
        68405,
        1,
        68409,
        68437,
        1,
        68440,
        68466,
        1,
        68472,
        68497,
        1,
        68505,
        68508,
        1,
        68521,
        68527,
        1,
        68608,
        68680,
        1,
        68736,
        68786,
        1,
        68800,
        68850,
        1,
        68858,
        68903,
        1,
        68912,
        68921,
        1,
        68928,
        68965,
        1,
        68969,
        68997,
        1,
        69006,
        69007,
        1,
        69216,
        69246,
        1,
        69248,
        69289,
        1,
        69291,
        69293,
        1,
        69296,
        69297,
        1,
        69314,
        69316,
        1,
        69372,
        69415,
        1,
        69424,
        69465,
        1,
        69488,
        69513,
        1,
        69552,
        69579,
        1,
        69600,
        69622,
        1,
        69632,
        69709,
        1,
        69714,
        69749,
        1,
        69759,
        69820,
        1,
        69822,
        69826,
        1,
        69840,
        69864,
        1,
        69872,
        69881,
        1,
        69888,
        69940,
        1,
        69942,
        69959,
        1,
        69968,
        70006,
        1,
        70016,
        70111,
        1,
        70113,
        70132,
        1,
        70144,
        70161,
        1,
        70163,
        70209,
        1,
        70272,
        70278,
        1,
        70280,
        70282,
        2,
        70283,
        70285,
        1,
        70287,
        70301,
        1,
        70303,
        70313,
        1,
        70320,
        70378,
        1,
        70384,
        70393,
        1,
        70400,
        70403,
        1,
        70405,
        70412,
        1,
        70415,
        70416,
        1,
        70419,
        70440,
        1,
        70442,
        70448,
        1,
        70450,
        70451,
        1,
        70453,
        70457,
        1,
        70459,
        70468,
        1,
        70471,
        70472,
        1,
        70475,
        70477,
        1,
        70480,
        70487,
        7,
        70493,
        70499,
        1,
        70502,
        70508,
        1,
        70512,
        70516,
        1,
        70528,
        70537,
        1,
        70539,
        70542,
        3,
        70544,
        70581,
        1,
        70583,
        70592,
        1,
        70594,
        70597,
        3,
        70599,
        70602,
        1,
        70604,
        70613,
        1,
        70615,
        70616,
        1,
        70625,
        70626,
        1,
        70656,
        70747,
        1,
        70749,
        70753,
        1,
        70784,
        70855,
        1,
        70864,
        70873,
        1,
        71040,
        71093,
        1,
        71096,
        71133,
        1,
        71168,
        71236,
        1,
        71248,
        71257,
        1,
        71264,
        71276,
        1,
        71296,
        71353,
        1,
        71360,
        71369,
        1,
        71376,
        71395,
        1,
        71424,
        71450,
        1,
        71453,
        71467,
        1,
        71472,
        71494,
        1,
        71680,
        71739,
        1,
        71840,
        71922,
        1,
        71935,
        71942,
        1,
        71945,
        71948,
        3,
        71949,
        71955,
        1,
        71957,
        71958,
        1,
        71960,
        71989,
        1,
        71991,
        71992,
        1,
        71995,
        72006,
        1,
        72016,
        72025,
        1,
        72096,
        72103,
        1,
        72106,
        72151,
        1,
        72154,
        72164,
        1,
        72192,
        72263,
        1,
        72272,
        72354,
        1,
        72368,
        72440,
        1,
        72448,
        72457,
        1,
        72640,
        72673,
        1,
        72688,
        72697,
        1,
        72704,
        72712,
        1,
        72714,
        72758,
        1,
        72760,
        72773,
        1,
        72784,
        72812,
        1,
        72816,
        72847,
        1,
        72850,
        72871,
        1,
        72873,
        72886,
        1,
        72960,
        72966,
        1,
        72968,
        72969,
        1,
        72971,
        73014,
        1,
        73018,
        73020,
        2,
        73021,
        73023,
        2,
        73024,
        73031,
        1,
        73040,
        73049,
        1,
        73056,
        73061,
        1,
        73063,
        73064,
        1,
        73066,
        73102,
        1,
        73104,
        73105,
        1,
        73107,
        73112,
        1,
        73120,
        73129,
        1,
        73440,
        73464,
        1,
        73472,
        73488,
        1,
        73490,
        73530,
        1,
        73534,
        73562,
        1,
        73648,
        73664,
        16,
        73665,
        73713,
        1,
        73727,
        74649,
        1,
        74752,
        74862,
        1,
        74864,
        74868,
        1,
        74880,
        75075,
        1,
        77712,
        77810,
        1,
        77824,
        78895,
        1,
        78912,
        78933,
        1,
        78944,
        82938,
        1,
        82944,
        83526,
        1,
        90368,
        90425,
        1,
        92160,
        92728,
        1,
        92736,
        92766,
        1,
        92768,
        92777,
        1,
        92782,
        92862,
        1,
        92864,
        92873,
        1,
        92880,
        92909,
        1,
        92912,
        92917,
        1,
        92928,
        92997,
        1,
        93008,
        93017,
        1,
        93019,
        93025,
        1,
        93027,
        93047,
        1,
        93053,
        93071,
        1,
        93504,
        93561,
        1,
        93760,
        93850,
        1,
        93952,
        94026,
        1,
        94031,
        94087,
        1,
        94095,
        94111,
        1,
        94176,
        94180,
        1,
        94192,
        94193,
        1,
        94208,
        100343,
        1,
        100352,
        101589,
        1,
        101631,
        101640,
        1,
        110576,
        110579,
        1,
        110581,
        110587,
        1,
        110589,
        110590,
        1,
        110592,
        110882,
        1,
        110898,
        110928,
        30,
        110929,
        110930,
        1,
        110933,
        110948,
        15,
        110949,
        110951,
        1,
        110960,
        111355,
        1,
        113664,
        113770,
        1,
        113776,
        113788,
        1,
        113792,
        113800,
        1,
        113808,
        113817,
        1,
        113820,
        113823,
        1,
        117760,
        118009,
        1,
        118016,
        118451,
        1,
        118528,
        118573,
        1,
        118576,
        118598,
        1,
        118608,
        118723,
        1,
        118784,
        119029,
        1,
        119040,
        119078,
        1,
        119081,
        119154,
        1,
        119163,
        119274,
        1,
        119296,
        119365,
        1,
        119488,
        119507,
        1,
        119520,
        119539,
        1,
        119552,
        119638,
        1,
        119648,
        119672,
        1,
        119808,
        119892,
        1,
        119894,
        119964,
        1,
        119966,
        119967,
        1,
        119970,
        119973,
        3,
        119974,
        119977,
        3,
        119978,
        119980,
        1,
        119982,
        119993,
        1,
        119995,
        119997,
        2,
        119998,
        120003,
        1,
        120005,
        120069,
        1,
        120071,
        120074,
        1,
        120077,
        120084,
        1,
        120086,
        120092,
        1,
        120094,
        120121,
        1,
        120123,
        120126,
        1,
        120128,
        120132,
        1,
        120134,
        120138,
        4,
        120139,
        120144,
        1,
        120146,
        120485,
        1,
        120488,
        120779,
        1,
        120782,
        121483,
        1,
        121499,
        121503,
        1,
        121505,
        121519,
        1,
        122624,
        122654,
        1,
        122661,
        122666,
        1,
        122880,
        122886,
        1,
        122888,
        122904,
        1,
        122907,
        122913,
        1,
        122915,
        122916,
        1,
        122918,
        122922,
        1,
        122928,
        122989,
        1,
        123023,
        123136,
        113,
        123137,
        123180,
        1,
        123184,
        123197,
        1,
        123200,
        123209,
        1,
        123214,
        123215,
        1,
        123536,
        123566,
        1,
        123584,
        123641,
        1,
        123647,
        124112,
        465,
        124113,
        124153,
        1,
        124368,
        124410,
        1,
        124415,
        124896,
        481,
        124897,
        124902,
        1,
        124904,
        124907,
        1,
        124909,
        124910,
        1,
        124912,
        124926,
        1,
        124928,
        125124,
        1,
        125127,
        125142,
        1,
        125184,
        125259,
        1,
        125264,
        125273,
        1,
        125278,
        125279,
        1,
        126065,
        126132,
        1,
        126209,
        126269,
        1,
        126464,
        126467,
        1,
        126469,
        126495,
        1,
        126497,
        126498,
        1,
        126500,
        126503,
        3,
        126505,
        126514,
        1,
        126516,
        126519,
        1,
        126521,
        126523,
        2,
        126530,
        126535,
        5,
        126537,
        126541,
        2,
        126542,
        126543,
        1,
        126545,
        126546,
        1,
        126548,
        126551,
        3,
        126553,
        126561,
        2,
        126562,
        126564,
        2,
        126567,
        126570,
        1,
        126572,
        126578,
        1,
        126580,
        126583,
        1,
        126585,
        126588,
        1,
        126590,
        126592,
        2,
        126593,
        126601,
        1,
        126603,
        126619,
        1,
        126625,
        126627,
        1,
        126629,
        126633,
        1,
        126635,
        126651,
        1,
        126704,
        126705,
        1,
        126976,
        127019,
        1,
        127024,
        127123,
        1,
        127136,
        127150,
        1,
        127153,
        127167,
        1,
        127169,
        127183,
        1,
        127185,
        127221,
        1,
        127232,
        127405,
        1,
        127462,
        127490,
        1,
        127504,
        127547,
        1,
        127552,
        127560,
        1,
        127568,
        127569,
        1,
        127584,
        127589,
        1,
        127744,
        128727,
        1,
        128732,
        128748,
        1,
        128752,
        128764,
        1,
        128768,
        128886,
        1,
        128891,
        128985,
        1,
        128992,
        129003,
        1,
        129008,
        129024,
        16,
        129025,
        129035,
        1,
        129040,
        129095,
        1,
        129104,
        129113,
        1,
        129120,
        129159,
        1,
        129168,
        129197,
        1,
        129200,
        129211,
        1,
        129216,
        129217,
        1,
        129280,
        129619,
        1,
        129632,
        129645,
        1,
        129648,
        129660,
        1,
        129664,
        129673,
        1,
        129679,
        129734,
        1,
        129742,
        129756,
        1,
        129759,
        129769,
        1,
        129776,
        129784,
        1,
        129792,
        129938,
        1,
        129940,
        130041,
        1,
        131072,
        173791,
        1,
        173824,
        177977,
        1,
        177984,
        178205,
        1,
        178208,
        183969,
        1,
        183984,
        191456,
        1,
        191472,
        192093,
        1,
        194560,
        195101,
        1,
        196608,
        201546,
        1,
        201552,
        205743,
        1,
        917760,
        917999,
        1
    ]));
}
/**
 * Utilities for dealing with Unicode better than JS does.
 */ class $ff4f66a262d5170f$var$Unicode {
    // The highest legal rune value.
    static MAX_RUNE = 0x10ffff;
    // The highest legal ASCII value.
    static MAX_ASCII = 0x7f;
    // The highest legal Latin-1 value.
    static MAX_LATIN1 = 0xff;
    // The highest legal Basic Multilingual Plane (BMP) value.
    static MAX_BMP = 0xffff;
    // Minimum and maximum runes involved in folding.
    // Checked during test.
    static MIN_FOLD = 0x0041;
    static MAX_FOLD = 0x1e943;
    // is32 uses binary search to test whether rune is in the specified
    // slice of 32-bit ranges.
    static is32(ranges, r) {
        // binary search over ranges
        let lo = 0;
        let hi = ranges.length;
        while(lo < hi){
            const m = lo + Math.floor((hi - lo) / 2);
            const rlo = ranges.getLo(m);
            const rhi = ranges.getHi(m);
            if (rlo <= r && r <= rhi) {
                const stride = ranges.getStride(m);
                return (r - rlo) % stride === 0;
            }
            if (r < rlo) hi = m;
            else lo = m + 1;
        }
        return false;
    }
    // is tests whether rune is in the specified table of ranges.
    static is(ranges, r) {
        // Fast path for Latin-1 characters using linear search.
        if (r <= this.MAX_LATIN1) {
            for(let i = 0; i < ranges.length; i++){
                const rhi = ranges.getHi(i);
                if (r > rhi) continue;
                const rlo = ranges.getLo(i);
                if (r < rlo) return false;
                const stride = ranges.getStride(i);
                return (r - rlo) % stride === 0;
            }
            return false;
        }
        // Fallback to binary search for runes outside Latin-1
        return ranges.length > 0 && r >= ranges.getLo(0) && this.is32(ranges, r);
    }
    // isUpper reports whether the rune is an upper case letter.
    static isUpper(r) {
        if (r <= this.MAX_LATIN1) {
            const s = String.fromCodePoint(r);
            return s.toUpperCase() === s && s.toLowerCase() !== s;
        }
        return this.is($ff4f66a262d5170f$var$UnicodeTables.Upper, r);
    }
    // isPrint reports whether the rune is printable (Unicode L/M/N/P/S or ' ').
    static isPrint(r) {
        if (r <= this.MAX_LATIN1) return r >= 0x20 && r < this.MAX_ASCII || r >= 0xa1 && r !== 0xad;
        return this.is($ff4f66a262d5170f$var$UnicodeTables.Print, r);
    }
    // simpleFold iterates over Unicode code points equivalent under
    // the Unicode-defined simple case folding.  Among the code points
    // equivalent to rune (including rune itself), SimpleFold returns the
    // smallest r >= rune if one exists, or else the smallest r >= 0.
    //
    // For example:
    //      SimpleFold('A') = 'a'
    //      SimpleFold('a') = 'A'
    //
    //      SimpleFold('K') = 'k'
    //      SimpleFold('k') = '\u212A' (Kelvin symbol, K)
    //      SimpleFold('\u212A') = 'K'
    //
    //      SimpleFold('1') = '1'
    //
    // Derived from Go's unicode.SimpleFold.
    //
    static simpleFold(r) {
        // Consult caseOrbit table for special cases.
        if ($ff4f66a262d5170f$var$UnicodeTables.CASE_ORBIT.has(r)) return $ff4f66a262d5170f$var$UnicodeTables.CASE_ORBIT.get(r);
        // No folding specified.  This is a one- or two-element
        // equivalence class containing rune and toLower(rune)
        // and toUpper(rune) if they are different from rune.
        const l = $ff4f66a262d5170f$var$Codepoint.toLowerCase(r);
        if (l !== r) return l;
        return $ff4f66a262d5170f$var$Codepoint.toUpperCase(r);
    }
    // equalsIgnoreCase performs case-insensitive equality comparison
    // on the given runes |r1| and |r2|, with special consideration
    // for the likely scenario where both runes are ASCII characters.
    // If non-ASCII, Unicode case folding will be performed on |r1|
    // to compare it to |r2|.
    // -1 is interpreted as the end-of-file mark.
    static equalsIgnoreCase(r1, r2) {
        // Runes already match, or one of them is EOF
        if (r1 < 0 || r2 < 0 || r1 === r2) return true;
        // Fast path for the common case where both runes are ASCII characters.
        // Coerces both runes to lowercase if applicable.
        if (r1 <= this.MAX_ASCII && r2 <= this.MAX_ASCII) {
            if ($ff4f66a262d5170f$var$Codepoint.CODES.get('A') <= r1 && r1 <= $ff4f66a262d5170f$var$Codepoint.CODES.get('Z')) r1 |= 0x20;
            if ($ff4f66a262d5170f$var$Codepoint.CODES.get('A') <= r2 && r2 <= $ff4f66a262d5170f$var$Codepoint.CODES.get('Z')) r2 |= 0x20;
            return r1 === r2;
        }
        // Fall back to full Unicode case folding otherwise.
        // Invariant: r1 must be non-negative
        for(let r = this.simpleFold(r1); r !== r1; r = this.simpleFold(r)){
            if (r === r2) return true;
        }
        return false;
    }
}
/**
 * Various constants and helper utilities.
 */ class $ff4f66a262d5170f$var$Utils {
    static METACHARACTERS = '\\.+*?()|[]{}^$';
    //// EMPTY_* flags
    static EMPTY_BEGIN_LINE = 0x01;
    static EMPTY_END_LINE = 0x02;
    static EMPTY_BEGIN_TEXT = 0x04;
    static EMPTY_END_TEXT = 0x08;
    static EMPTY_WORD_BOUNDARY = 0x10;
    static EMPTY_NO_WORD_BOUNDARY = 0x20;
    static EMPTY_ALL = -1;
    static emptyInts() {
        return [];
    }
    // Returns true iff |c| is an ASCII letter or decimal digit.
    static isalnum(c) {
        return $ff4f66a262d5170f$var$Codepoint.CODES.get('0') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9') || $ff4f66a262d5170f$var$Codepoint.CODES.get('a') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('z') || $ff4f66a262d5170f$var$Codepoint.CODES.get('A') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('Z');
    }
    // If |c| is an ASCII hex digit, returns its value, otherwise -1.
    static unhex(c) {
        if ($ff4f66a262d5170f$var$Codepoint.CODES.get('0') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9')) return c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
        if ($ff4f66a262d5170f$var$Codepoint.CODES.get('a') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('f')) return c - $ff4f66a262d5170f$var$Codepoint.CODES.get('a') + 10;
        if ($ff4f66a262d5170f$var$Codepoint.CODES.get('A') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('F')) return c - $ff4f66a262d5170f$var$Codepoint.CODES.get('A') + 10;
        return -1;
    }
    // Appends a RE2 literal to |out| for rune |rune|,
    // with regexp metacharacters escaped.
    static escapeRune(rune) {
        let out = '';
        if ($ff4f66a262d5170f$var$Unicode.isPrint(rune)) {
            if (this.METACHARACTERS.indexOf(String.fromCodePoint(rune)) >= 0) out += '\\';
            out += String.fromCodePoint(rune);
        } else switch(rune){
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('"'):
                // '"'
                out += '\\"';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\\'):
                // '\\'
                out += '\\\\';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\t'):
                // '\t'
                out += '\\t';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\n'):
                // '\n'
                out += '\\n';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\r'):
                // '\r'
                out += '\\r';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\b'):
                // '\b'
                out += '\\b';
                break;
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('\f'):
                // '\f'
                out += '\\f';
                break;
            default:
                {
                    let s = rune.toString(16);
                    if (rune < 0x100) {
                        out += '\\x';
                        if (s.length === 1) out += '0';
                        out += s;
                    } else out += `\\x{${s}}`;
                    break;
                }
        }
        return out;
    }
    // Returns the array of runes in the specified Java UTF-16 string.
    static stringToRunes(str) {
        return String(str).split('').map((s)=>s.codePointAt(0));
    }
    // Returns the Java UTF-16 string containing the single rune |r|.
    static runeToString(r) {
        return String.fromCodePoint(r);
    }
    // isWordRune reports whether r is consider a ``word character''
    // during the evaluation of the \b and \B zero-width assertions.
    // These assertions are ASCII-only: the word characters are [A-Za-z0-9_].
    static isWordRune(r) {
        return $ff4f66a262d5170f$var$Codepoint.CODES.get('a') <= r && r <= $ff4f66a262d5170f$var$Codepoint.CODES.get('z') || $ff4f66a262d5170f$var$Codepoint.CODES.get('A') <= r && r <= $ff4f66a262d5170f$var$Codepoint.CODES.get('Z') || $ff4f66a262d5170f$var$Codepoint.CODES.get('0') <= r && r <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9') || r === $ff4f66a262d5170f$var$Codepoint.CODES.get('_');
    }
    // emptyOpContext returns the zero-width assertions satisfied at the position
    // between the runes r1 and r2, a bitmask of EMPTY_* flags.
    // Passing r1 == -1 indicates that the position is at the beginning of the
    // text.
    // Passing r2 == -1 indicates that the position is at the end of the text.
    // eslint-disable-next-line no-warning-comments
    // TODO(adonovan): move to Machine.
    static emptyOpContext(r1, r2) {
        let op = 0;
        if (r1 < 0) op |= this.EMPTY_BEGIN_TEXT | this.EMPTY_BEGIN_LINE;
        if (r1 === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n')) op |= this.EMPTY_BEGIN_LINE;
        if (r2 < 0) op |= this.EMPTY_END_TEXT | this.EMPTY_END_LINE;
        if (r2 === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n')) op |= this.EMPTY_END_LINE;
        if (this.isWordRune(r1) !== this.isWordRune(r2)) op |= this.EMPTY_WORD_BOUNDARY;
        else op |= this.EMPTY_NO_WORD_BOUNDARY;
        return op;
    }
    /**
   * Returns a string that quotes all regular expression metacharacters inside the argument text;
   * the returned string is a regular expression matching the literal text. For example,
   * {@code quoteMeta("[foo]").equals("\\[foo\\]")}.
   * @param {string} s
   * @returns {string}
   */ static quoteMeta(str) {
        return str.split('') // A char loop is correct because all metacharacters fit in one UTF-16 code.
        .map((s)=>{
            if (this.METACHARACTERS.indexOf(s) >= 0) return `\\${s}`;
            return s;
        }).join('');
    }
    static charCount(codePoint) {
        return codePoint > $ff4f66a262d5170f$var$Unicode.MAX_BMP ? 2 : 1;
    }
    static stringToUtf8ByteArray(str) {
        if (globalThis.TextEncoder) return Array.from(new TextEncoder().encode(str));
        else {
            // fallback, if no TextEncoder
            let out = [], p = 0;
            for(let i = 0; i < str.length; i++){
                let c = str.charCodeAt(i);
                if (c < 128) out[p++] = c;
                else if (c < 2048) {
                    out[p++] = c >> 6 | 192;
                    out[p++] = c & 63 | 128;
                } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
                    // Surrogate Pair
                    c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
                    out[p++] = c >> 18 | 240;
                    out[p++] = c >> 12 & 63 | 128;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                } else {
                    out[p++] = c >> 12 | 224;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                }
            }
            return out;
        }
    }
    static utf8ByteArrayToString(bytes) {
        if (globalThis.TextDecoder) return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
        else {
            // fallback, if no TextDecoder
            let out = [], pos = 0, c = 0;
            while(pos < bytes.length){
                let c1 = bytes[pos++];
                if (c1 < 128) out[c++] = String.fromCharCode(c1);
                else if (c1 > 191 && c1 < 224) {
                    let c2 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
                } else if (c1 > 239 && c1 < 365) {
                    // Surrogate Pair
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    let c4 = bytes[pos++];
                    let u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
                    out[c++] = String.fromCharCode(0xd800 + (u >> 10));
                    out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
                } else {
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                }
            }
            return out.join('');
        }
    }
}
// helper to create enums
// example
// Encoding[(Encoding['UTF_16'] = 0)] = 'UTF_16'
// Encoding[(Encoding['UTF_8'] = 1)] = 'UTF_8'
const $ff4f66a262d5170f$var$createEnum = (values = [], initNum = 0)=>{
    const enumObject = {};
    for(let i = 0; i < values.length; i++){
        const val = values[i];
        const keyVal = initNum + i;
        enumObject[val] = keyVal;
        enumObject[keyVal] = val;
    }
    return Object.freeze(enumObject);
};
/**
 * Abstract the representations of input text supplied to Matcher.
 */ class $ff4f66a262d5170f$var$MatcherInputBase {
    static Encoding = $ff4f66a262d5170f$var$createEnum([
        'UTF_16',
        'UTF_8'
    ]);
    getEncoding() {
        throw Error('not implemented');
    }
    /**
   *
   * @returns {boolean}
   */ isUTF8Encoding() {
        return this.getEncoding() === $ff4f66a262d5170f$var$MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {boolean}
   */ isUTF16Encoding() {
        return this.getEncoding() === $ff4f66a262d5170f$var$MatcherInputBase.Encoding.UTF_16;
    }
}
class $ff4f66a262d5170f$var$Utf8MatcherInput extends $ff4f66a262d5170f$var$MatcherInputBase {
    constructor(bytes = null){
        super();
        this.bytes = bytes;
    }
    getEncoding() {
        return $ff4f66a262d5170f$var$MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return $ff4f66a262d5170f$var$Utils.utf8ByteArrayToString(this.bytes);
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.bytes;
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.bytes.length;
    }
}
class $ff4f66a262d5170f$var$Utf16MatcherInput extends $ff4f66a262d5170f$var$MatcherInputBase {
    constructor(charSequence = null){
        super();
        this.charSequence = charSequence;
    }
    getEncoding() {
        return $ff4f66a262d5170f$var$MatcherInputBase.Encoding.UTF_16;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return this.charSequence;
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.charSequence.toString().split('').map((s)=>s.codePointAt(0));
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.charSequence.length;
    }
}
class $ff4f66a262d5170f$var$MatcherInput {
    /**
   * Return the MatcherInput for UTF_16 encoding.
   * @returns {Utf16MatcherInput}
   */ static utf16(charSequence) {
        return new $ff4f66a262d5170f$var$Utf16MatcherInput(charSequence);
    }
    /**
   * Return the MatcherInput for UTF_8 encoding.
   * @returns {Utf8MatcherInput}
   */ static utf8(input) {
        if (Array.isArray(input)) return new $ff4f66a262d5170f$var$Utf8MatcherInput(input);
        return new $ff4f66a262d5170f$var$Utf8MatcherInput($ff4f66a262d5170f$var$Utils.stringToUtf8ByteArray(input));
    }
}
/**
 * MachineInput abstracts different representations of the input text supplied to the Machine. It
 * provides one-character lookahead.
 */ class $ff4f66a262d5170f$var$MachineInputBase {
    static EOF() {
        return -8;
    }
    // can we look ahead without losing info?
    canCheckPrefix() {
        return true;
    }
    // Returns the end position in the same units as step().
    endPos() {
        return this.end;
    }
}
// An implementation of MachineInput for UTF-8 byte arrays.
// |pos| and |width| are byte indices.
class $ff4f66a262d5170f$var$MachineUTF8Input extends $ff4f66a262d5170f$var$MachineInputBase {
    constructor(bytes, start = 0, end = bytes.length){
        super();
        this.bytes = bytes;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(i) {
        i += this.start;
        if (i >= this.end) return $ff4f66a262d5170f$var$MachineInputBase.EOF();
        let x = this.bytes[i++] & 255;
        if ((x & 128) === 0) return x << 3 | 1;
        else if ((x & 224) === 192) {
            x = x & 31;
            if (i >= this.end) return $ff4f66a262d5170f$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 2;
        } else if ((x & 240) === 224) {
            x = x & 15;
            if (i + 1 >= this.end) return $ff4f66a262d5170f$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 3;
        } else {
            x = x & 7;
            if (i + 2 >= this.end) return $ff4f66a262d5170f$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 4;
        }
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.indexOf(this.bytes, re2.prefixUTF8, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        let r1 = -1;
        if (pos > this.start && pos <= this.end) {
            let start = pos - 1;
            r1 = this.bytes[start--];
            if (r1 >= 128) {
                let lim = pos - 4;
                if (lim < this.start) lim = this.start;
                while(start >= lim && (this.bytes[start] & 192) === 128)start--;
                if (start < this.start) start = this.start;
                r1 = this.step(start) >> 3;
            }
        }
        const r2 = pos < this.end ? this.step(pos) >> 3 : -1;
        return $ff4f66a262d5170f$var$Utils.emptyOpContext(r1, r2);
    }
    // Returns the index of the first occurrence of array |target| within
    // array |source| after |fromIndex|, or -1 if not found.
    indexOf(source, target, fromIndex = 0) {
        let targetLength = target.length;
        if (targetLength === 0) return -1;
        let sourceLength = source.length;
        for(let i = fromIndex; i <= sourceLength - targetLength; i++)for(let j = 0; j < targetLength; j++){
            if (source[i + j] !== target[j]) break;
            else if (j === targetLength - 1) return i;
        }
        return -1;
    }
}
// |pos| and |width| are in JS "char" units.
class $ff4f66a262d5170f$var$MachineUTF16Input extends $ff4f66a262d5170f$var$MachineInputBase {
    constructor(charSequence, start = 0, end = charSequence.length){
        super();
        this.charSequence = charSequence;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(pos) {
        pos += this.start;
        if (pos < this.end) {
            const rune = this.charSequence.codePointAt(pos);
            return rune << 3 | $ff4f66a262d5170f$var$Utils.charCount(rune);
        } else return $ff4f66a262d5170f$var$MachineInputBase.EOF();
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.charSequence.indexOf(re2.prefix, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        const r1 = pos > 0 && pos <= this.charSequence.length ? this.charSequence.codePointAt(pos - 1) : -1;
        const r2 = pos < this.charSequence.length ? this.charSequence.codePointAt(pos) : -1;
        return $ff4f66a262d5170f$var$Utils.emptyOpContext(r1, r2);
    }
}
class $ff4f66a262d5170f$var$MachineInput {
    static fromUTF8(bytes, start = 0, end = bytes.length) {
        return new $ff4f66a262d5170f$var$MachineUTF8Input(bytes, start, end);
    }
    static fromUTF16(charSequence, start = 0, end = charSequence.length) {
        return new $ff4f66a262d5170f$var$MachineUTF16Input(charSequence, start, end);
    }
}
class $ff4f66a262d5170f$export$54306bca8e0bffc2 extends Error {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = 'RE2JSException';
    }
}
/**
 * An exception thrown by the parser if the pattern was invalid.
 */ class $ff4f66a262d5170f$export$9c12d0c1e9bff151 extends $ff4f66a262d5170f$export$54306bca8e0bffc2 {
    /**
   * @param {string} error
   * @param {string|null} [input=null]
   */ constructor(error, input = null){
        let message = `error parsing regexp: ${error}`;
        if (input) message += `: \`${input}\``;
        super(message);
        this.name = 'RE2JSSyntaxException';
        this.message = message;
        /** @type {string} */ this.error = error;
        /** @type {string|null} */ this.input = input;
    }
    /**
   * Retrieves the description of the error.
   * @returns {string}
   */ getDescription() {
        return this.error;
    }
    /**
   * Retrieves the erroneous regular-expression pattern.
   * @returns {string|null}
   */ getPattern() {
        return this.input;
    }
}
/**
 * An exception thrown by the compiler
 */ class $ff4f66a262d5170f$export$457eacef9ada3821 extends $ff4f66a262d5170f$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = 'RE2JSCompileException';
    }
}
/**
 * An exception thrown by using groups
 */ class $ff4f66a262d5170f$export$eab8e70da4919c35 extends $ff4f66a262d5170f$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = 'RE2JSGroupException';
    }
}
/**
 * An exception thrown by flags
 */ class $ff4f66a262d5170f$export$fa1c64d63b2c22b1 extends $ff4f66a262d5170f$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = 'RE2JSFlagsException';
    }
}
/**
 * A stateful iterator that interprets a regex {@code RE2JS} on a specific input.
 *
 * Conceptually, a Matcher consists of four parts:
 * <ol>
 * <li>A compiled regular expression {@code RE2JS}, set at construction and fixed for the lifetime
 * of the matcher.</li>
 *
 * <li>The remainder of the input string, set at construction or {@link #reset()} and advanced by
 * each match operation such as {@link #find}, {@link #matches} or {@link #lookingAt}.</li>
 *
 * <li>The current match information, accessible via {@link #start}, {@link #end}, and
 * {@link #group}, and updated by each match operation.</li>
 *
 * <li>The append position, used and advanced by {@link #appendReplacement} and {@link #appendTail}
 * if performing a search and replace from the input to an external {@code StringBuffer}.
 *
 * </ol>
 *
 *
 * @author rsc@google.com (Russ Cox)
 */ class $ff4f66a262d5170f$export$20214574ec94167d {
    /**
   * Quotes '\' and '$' in {@code s}, so that the returned string could be used in
   * {@link #appendReplacement} as a literal replacement of {@code s}.
   *
   * @param {string} str the string to be quoted
   * @returns {string} the quoted string
   */ static quoteReplacement(str) {
        if (str.indexOf('\\') < 0 && str.indexOf('$') < 0) return str;
        return str.split('').map((s)=>{
            const c = s.codePointAt(0);
            if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('\\') || c === $ff4f66a262d5170f$var$Codepoint.CODES.get('$')) return `\\${s}`;
            return s;
        }).join('');
    }
    /**
   *
   * @param {RE2JS} pattern
   * @param {Utf8MatcherInput|Utf16MatcherInput|number[]|string} input
   */ constructor(pattern, input){
        if (pattern === null) throw new Error('pattern is null');
        // The pattern being matched.
        this.patternInput = pattern;
        const re2 = this.patternInput.re2();
        // The number of submatches (groups) in the pattern.
        /** @type {number} */ this.patternGroupCount = re2.numberOfCapturingGroups();
        // The group indexes, in [start, end) pairs.  Zeroth pair is overall match.
        /** @type {number[]} */ this.groups = [];
        /** @type {Record<string, number>} */ this.namedGroups = re2.namedGroups;
        /** @type {number} */ this.numberOfInstructions = re2.numberOfInstructions();
        if (input instanceof $ff4f66a262d5170f$var$MatcherInputBase) this.resetMatcherInput(input);
        else if (Array.isArray(input)) this.resetMatcherInput($ff4f66a262d5170f$var$MatcherInput.utf8(input));
        else this.resetMatcherInput($ff4f66a262d5170f$var$MatcherInput.utf16(input));
    }
    /**
   * Returns the {@code RE2JS} associated with this {@code Matcher}.
   * @returns {RE2JS}
   */ pattern() {
        return this.patternInput;
    }
    /**
   * Resets the {@code Matcher}, rewinding input and discarding any match information.
   *
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ reset() {
        // The input length in UTF16 codes.
        /** @type {number} */ this.matcherInputLength = this.matcherInput.length();
        // The append position: where the next append should start.
        /** @type {number} */ this.appendPos = 0;
        // Is there a current match?
        this.hasMatch = false;
        // Have we found the submatches (groups) of the current match?
        // group[0], group[1] are set regardless.
        this.hasGroups = false;
        // The anchor flag to use when repeating the match to find subgroups.
        this.anchorFlag = 0;
        return this;
    }
    /**
   * Resets the {@code Matcher} and changes the input.
   * @param {Utf8MatcherInput|Utf16MatcherInput} input
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ resetMatcherInput(input) {
        if (input === null) throw new Error('input is null');
        this.matcherInput = input;
        this.reset();
        return this;
    }
    /**
   * Returns the start of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {number}
   */ start(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group];
    }
    /**
   * Returns the end of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {number}
   */ end(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group + 1];
    }
    /**
   * Returns the program size of this pattern.
   *
   * <p>
   * Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
   * "cost". Larger numbers are more expensive than smaller numbers.
   * </p>
   *
   * @returns {number} the program size of this pattern
   */ programSize() {
        return this.numberOfInstructions;
    }
    /**
   * Returns the named group of the most recent match, or {@code null} if the group was not matched.
   * @param {string|number} [group=0]
   * @returns {?string}
   */ group(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        const start = this.start(group);
        const end = this.end(group);
        if (start < 0 && end < 0) return null;
        return this.substring(start, end);
    }
    /**
   * Returns the number of subgroups in this pattern.
   *
   * @returns {number} the number of subgroups; the overall match (group 0) does not count
   */ groupCount() {
        return this.patternGroupCount;
    }
    /**
   * Helper: finds subgroup information if needed for group.
   * @param {number} group
   * @private
   */ loadGroup(group) {
        if (group < 0 || group > this.patternGroupCount) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`Group index out of bounds: ${group}`);
        if (!this.hasMatch) throw new $ff4f66a262d5170f$export$eab8e70da4919c35('perhaps no match attempted');
        if (group === 0 || this.hasGroups) return;
        let end = this.groups[1] + 1;
        if (end > this.matcherInputLength) end = this.matcherInputLength;
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], end, this.anchorFlag, 1 + this.patternGroupCount);
        const ok = res[0];
        if (!ok) throw new $ff4f66a262d5170f$export$eab8e70da4919c35('inconsistency in matching group data');
        this.groups = res[1];
        this.hasGroups = true;
    }
    /**
   * Matches the entire input against the pattern (anchored start and end). If there is a match,
   * {@code matches} sets the match state to describe it.
   *
   * @returns {boolean} true if the entire input matches the pattern
   */ matches() {
        return this.genMatch(0, $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH);
    }
    /**
   * Matches the beginning of input against the pattern (anchored start). If there is a match,
   * {@code lookingAt} sets the match state to describe it.
   *
   * @returns {boolean} true if the beginning of the input matches the pattern
   */ lookingAt() {
        return this.genMatch(0, $ff4f66a262d5170f$var$RE2Flags.ANCHOR_START);
    }
    /**
   * Matches the input against the pattern (unanchored), starting at a specified position. If there
   * is a match, {@code find} sets the match state to describe it.
   *
   * @param {number} [start=null] the input position where the search begins
   * @returns {boolean} if it finds a match
   * @throws IndexOutOfBoundsException if start is not a valid input position
   */ find(start = null) {
        if (start !== null) {
            if (start < 0 || start > this.matcherInputLength) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`start index out of bounds: ${start}`);
            this.reset();
            return this.genMatch(start, 0);
        }
        // no start
        start = 0;
        if (this.hasMatch) {
            start = this.groups[1];
            if (this.groups[0] === this.groups[1]) start++;
        }
        return this.genMatch(start, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED);
    }
    /**
   * Helper: does match starting at start, with RE2 anchor flag.
   * @param {number} startByte
   * @param {number} anchor
   * @returns {boolean}
   * @private
   */ genMatch(startByte, anchor) {
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, startByte, this.matcherInputLength, anchor, 1);
        const ok = res[0];
        if (!ok) return false;
        this.groups = res[1];
        this.hasMatch = true;
        this.hasGroups = false;
        this.anchorFlag = anchor;
        return true;
    }
    /**
   * Helper: return substring for [start, end).
   * @param {number} start
   * @param {number} end
   * @returns {string}
   */ substring(start, end) {
        if (this.matcherInput.isUTF8Encoding()) return $ff4f66a262d5170f$var$Utils.utf8ByteArrayToString(this.matcherInput.asBytes().slice(start, end));
        return this.matcherInput.asCharSequence().substring(start, end).toString();
    }
    /**
   * Helper for Pattern: return input length.
   * @returns {number}
   */ inputLength() {
        return this.matcherInputLength;
    }
    /**
   * Appends to result two strings: the text from the append position up to the beginning of the
   * most recent match, and then the replacement with submatch groups substituted for references of
   * the form {@code $n}, where {@code n} is the group number in decimal. It advances the append
   * position to where the most recent match ended.
   *
   * To embed a literal {@code $}, use \$ (actually {@code "\\$"} with string escapes). The escape
   * is only necessary when {@code $} is followed by a digit, but it is always allowed. Only
   * {@code $} and {@code \} need escaping, but any character can be escaped.
   *
   * The group number {@code n} in {@code $n} is always at least one digit and expands to use more
   * digits as long as the resulting number is a valid group number for this pattern. To cut it off
   * earlier, escape the first digit that should not be used.
   *
   * @param {string} replacement the replacement string
   * @param {boolean} [perlMode=false] activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @throws IllegalStateException if there was no most recent match
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group
   * @private
   */ appendReplacement(replacement, perlMode = false) {
        let res = '';
        const s = this.start();
        const e = this.end();
        if (this.appendPos < s) res += this.substring(this.appendPos, s);
        this.appendPos = e;
        res += perlMode ? this.appendReplacementInternalPerl(replacement) : this.appendReplacementInternal(replacement);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternal(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++){
            if (replacement.codePointAt(i) === $ff4f66a262d5170f$var$Codepoint.CODES.get('\\')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                last = i;
                continue;
            }
            if (replacement.codePointAt(i) === $ff4f66a262d5170f$var$Codepoint.CODES.get('$')) {
                let c = replacement.codePointAt(i + 1);
                if ($ff4f66a262d5170f$var$Codepoint.CODES.get('0') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9')) {
                    let n = c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                    if (last < i) res += replacement.substring(last, i);
                    for(i += 2; i < m; i++){
                        c = replacement.codePointAt(i);
                        if (c < $ff4f66a262d5170f$var$Codepoint.CODES.get('0') || c > $ff4f66a262d5170f$var$Codepoint.CODES.get('9') || n * 10 + c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0') > this.patternGroupCount) break;
                        n = n * 10 + c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                    }
                    if (n > this.patternGroupCount) throw new $ff4f66a262d5170f$export$eab8e70da4919c35(`n > number of groups: ${n}`);
                    const group = this.group(n);
                    if (group !== null) res += group;
                    last = i;
                    i--;
                    continue;
                } else if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('{')) {
                    if (last < i) res += replacement.substring(last, i);
                    i++;
                    let j = i + 1;
                    while(j < replacement.length && replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get('}') && replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get(' '))j++;
                    if (j === replacement.length || replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get('}')) throw new $ff4f66a262d5170f$export$eab8e70da4919c35("named capture group is missing trailing '}'");
                    const groupName = replacement.substring(i + 1, j);
                    res += this.group(groupName);
                    last = j + 1;
                }
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternalPerl(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++)if (replacement.codePointAt(i) === $ff4f66a262d5170f$var$Codepoint.CODES.get('$')) {
            let c = replacement.codePointAt(i + 1);
            if ($ff4f66a262d5170f$var$Codepoint.CODES.get('$') === c) {
                if (last < i) res += replacement.substring(last, i);
                res += '$';
                i++;
                last = i + 1;
                continue;
            } else if ($ff4f66a262d5170f$var$Codepoint.CODES.get('&') === c) {
                if (last < i) res += replacement.substring(last, i);
                const group = this.group(0);
                if (group !== null) res += group;
                else res += '$&';
                i++;
                last = i + 1;
                continue;
            } else if ($ff4f66a262d5170f$var$Codepoint.CODES.get('1') <= c && c <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9')) {
                let n = c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                if (last < i) res += replacement.substring(last, i);
                for(i += 2; i < m; i++){
                    c = replacement.codePointAt(i);
                    if (c < $ff4f66a262d5170f$var$Codepoint.CODES.get('0') || c > $ff4f66a262d5170f$var$Codepoint.CODES.get('9') || n * 10 + c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0') > this.patternGroupCount) break;
                    n = n * 10 + c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                }
                if (n > this.patternGroupCount) {
                    res += `$${n}`;
                    last = i;
                    i--;
                    continue;
                }
                const group = this.group(n);
                if (group !== null) res += group;
                last = i;
                i--;
                continue;
            } else if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('<')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                let j = i + 1;
                while(j < replacement.length && replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get('>') && replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get(' '))j++;
                if (j === replacement.length || replacement.codePointAt(j) !== $ff4f66a262d5170f$var$Codepoint.CODES.get('>')) {
                    res += replacement.substring(i - 1, j + 1);
                    last = j + 1;
                    continue;
                }
                const groupName = replacement.substring(i + 1, j);
                if (Object.prototype.hasOwnProperty.call(this.namedGroups, groupName)) res += this.group(groupName);
                else res += `$<${groupName}>`;
                last = j + 1;
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * Return the substring of the input from the append position to the end of the
   * input.
   * @returns {string}
   */ appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
    }
    /**
   * Returns the input with all matches replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the matches replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceAll(replacement, perlMode = false) {
        return this.replace(replacement, true, perlMode);
    }
    /**
   * Returns the input with the first match replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the first match replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceFirst(replacement, perlMode = false) {
        return this.replace(replacement, false, perlMode);
    }
    /**
   * Helper: replaceAll/replaceFirst hybrid.
   * @param {string} replacement - the replacement string
   * @param {boolean} [all=true] - replace all matches
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @private
   */ replace(replacement, all = true, perlMode = false) {
        let res = '';
        this.reset();
        while(this.find()){
            res += this.appendReplacement(replacement, perlMode);
            if (!all) break;
        }
        res += this.appendTail();
        return res;
    }
}
/**
 * A single instruction in the regular expression virtual machine.
 *
 * @see http://swtch.com/~rsc/regexp/regexp2.html
 */ class $ff4f66a262d5170f$var$Inst {
    static ALT = 1;
    static ALT_MATCH = 2;
    static CAPTURE = 3;
    static EMPTY_WIDTH = 4;
    static FAIL = 5;
    static MATCH = 6;
    static NOP = 7;
    static RUNE = 8;
    static RUNE1 = 9;
    static RUNE_ANY = 10;
    static RUNE_ANY_NOT_NL = 11;
    static isRuneOp(op) {
        return $ff4f66a262d5170f$var$Inst.RUNE <= op && op <= $ff4f66a262d5170f$var$Inst.RUNE_ANY_NOT_NL;
    }
    // Returns an RE2 expression matching exactly |runes|.
    static escapeRunes(runes) {
        let out = '"';
        for (let rune of runes)out += $ff4f66a262d5170f$var$Utils.escapeRune(rune);
        out += '"';
        return out;
    }
    constructor(op){
        this.op = op;
        this.out = 0; // all but MATCH, FAIL
        this.arg = 0; // ALT, ALT_MATCH, CAPTURE, EMPTY_WIDTH
        // length==1 => exact match
        // otherwise a list of [lo,hi] pairs.  hi is *inclusive*.
        this.runes = [];
    }
    // MatchRune returns true if the instruction matches (and consumes) r.
    // It should only be called when op == InstRune.
    matchRune(r) {
        // Special case: single-rune slice is from literal string, not char
        // class.
        if (this.runes.length === 1) {
            const r0 = this.runes[0];
            // If this pattern is case-insensitive, apply Unicode case folding to compare the two runes.
            // Note that this may result in a case-folding loop when executed,
            // so attempt to reduce the chance of that occurring
            // by performing case folding on |r0| from the pattern rather than |r| from the input.
            if ((this.arg & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0) return $ff4f66a262d5170f$var$Unicode.equalsIgnoreCase(r0, r);
            return r === r0;
        }
        // Peek at the first few pairs.
        // Should handle ASCII well.
        for(let j = 0; j < this.runes.length && j <= 8; j += 2){
            if (r < this.runes[j]) return false;
            if (r <= this.runes[j + 1]) return true;
        }
        // Otherwise binary search.
        let lo = 0;
        let hi = this.runes.length / 2 | 0;
        while(lo < hi){
            const m = lo + ((hi - lo) / 2 | 0);
            const c = this.runes[2 * m];
            if (c <= r) {
                if (r <= this.runes[2 * m + 1]) return true;
                lo = m + 1;
            } else hi = m;
        }
        return false;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        switch(this.op){
            case $ff4f66a262d5170f$var$Inst.ALT:
                return `alt -> ${this.out}, ${this.arg}`;
            case $ff4f66a262d5170f$var$Inst.ALT_MATCH:
                return `altmatch -> ${this.out}, ${this.arg}`;
            case $ff4f66a262d5170f$var$Inst.CAPTURE:
                return `cap ${this.arg} -> ${this.out}`;
            case $ff4f66a262d5170f$var$Inst.EMPTY_WIDTH:
                return `empty ${this.arg} -> ${this.out}`;
            case $ff4f66a262d5170f$var$Inst.MATCH:
                return 'match';
            case $ff4f66a262d5170f$var$Inst.FAIL:
                return 'fail';
            case $ff4f66a262d5170f$var$Inst.NOP:
                return `nop -> ${this.out}`;
            case $ff4f66a262d5170f$var$Inst.RUNE:
                if (this.runes === null) return 'rune <null>';
                return [
                    'rune ',
                    $ff4f66a262d5170f$var$Inst.escapeRunes(this.runes),
                    (this.arg & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0 ? '/i' : '',
                    ' -> ',
                    this.out
                ].join('');
            case $ff4f66a262d5170f$var$Inst.RUNE1:
                return `rune1 ${$ff4f66a262d5170f$var$Inst.escapeRunes(this.runes)} -> ${this.out}`;
            case $ff4f66a262d5170f$var$Inst.RUNE_ANY:
                return `any -> ${this.out}`;
            case $ff4f66a262d5170f$var$Inst.RUNE_ANY_NOT_NL:
                return `anynotnl -> ${this.out}`;
            default:
                throw new Error('unhandled case in Inst.toString');
        }
    }
}
// A logical thread in the NFA.
class $ff4f66a262d5170f$var$Thread {
    constructor(){
        this.inst = null;
        this.cap = [];
    }
}
// A queue is a 'sparse array' holding pending threads of execution.  See:
// research.swtch.com/2008/03/using-uninitialized-memory-for-fun-and.html
class $ff4f66a262d5170f$var$Queue {
    constructor(){
        this.sparse = []; // may contain stale but in-bounds values.
        this.densePcs = []; // may contain stale pc in slots >= size
        this.denseThreads = []; // may contain stale Thread in slots >= size
        this.size = 0;
    }
    contains(pc) {
        const j = this.sparse[pc];
        return j < this.size && this.densePcs[j] === pc;
    }
    isEmpty() {
        return this.size === 0;
    }
    add(pc) {
        const j = this.size++;
        this.sparse[pc] = j;
        this.denseThreads[j] = null;
        this.densePcs[j] = pc;
        return j;
    }
    clear() {
        this.sparse = [];
        this.densePcs = [];
        this.denseThreads = [];
        this.size = 0;
    }
    toString() {
        let out = '{';
        for(let i = 0; i < this.size; i++){
            if (i !== 0) out += ', ';
            out += this.densePcs[i];
        }
        out += '}';
        return out;
    }
}
// A Machine matches an input string of Unicode characters against an
// RE2 instance using a simple NFA.
//
// Called by RE2.doExecute.
class $ff4f66a262d5170f$var$Machine {
    static fromRE2(re2) {
        const m = new $ff4f66a262d5170f$var$Machine();
        m.prog = re2.prog;
        m.re2 = re2;
        m.q0 = new $ff4f66a262d5170f$var$Queue(m.prog.numInst());
        m.q1 = new $ff4f66a262d5170f$var$Queue(m.prog.numInst());
        m.pool = [];
        m.poolSize = 0;
        m.matched = false;
        m.matchcap = Array(m.prog.numCap < 2 ? 2 : m.prog.numCap).fill(0);
        m.ncap = 0;
        return m;
    }
    static fromMachine(machine) {
        const m = new $ff4f66a262d5170f$var$Machine();
        m.re2 = machine.re2;
        m.prog = machine.prog;
        m.q0 = machine.q0;
        m.q1 = machine.q1;
        m.pool = machine.pool;
        m.poolSize = machine.poolSize;
        m.matched = machine.matched;
        m.matchcap = machine.matchcap;
        m.ncap = machine.ncap;
        return m;
    }
    // init() reinitializes an existing Machine for re-use on a new input.
    init(ncap) {
        this.ncap = ncap;
        if (ncap > this.matchcap.length) this.initNewCap(ncap);
        else this.resetCap(ncap);
    }
    resetCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
    }
    initNewCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
        this.matchcap = Array(ncap).fill(0);
    }
    submatches() {
        if (this.ncap === 0) return $ff4f66a262d5170f$var$Utils.emptyInts();
        return this.matchcap.slice(0, this.ncap);
    }
    // alloc() allocates a new thread with the given instruction.
    // It uses the free pool if possible.
    alloc(inst) {
        let t;
        if (this.poolSize > 0) {
            this.poolSize--;
            t = this.pool[this.poolSize];
        } else t = new $ff4f66a262d5170f$var$Thread();
        t.inst = inst;
        return t;
    }
    // Frees all threads on the thread queue, returning them to the free pool.
    freeQueue(queue, from = 0) {
        const numberOfThread = queue.size - from;
        const requiredPoolLength = this.poolSize + numberOfThread;
        if (this.pool.length < requiredPoolLength) this.pool = this.pool.slice(0, Math.max(this.pool.length * 2, requiredPoolLength));
        for(let i = from; i < queue.size; i++){
            const t = queue.denseThreads[i];
            if (t !== null) {
                this.pool[this.poolSize] = t;
                this.poolSize++;
            }
        }
        queue.clear();
    }
    // freeThread() returns t to the free pool.
    freeThread(t) {
        if (this.pool.length <= this.poolSize) this.pool = this.pool.slice(0, this.pool.length * 2);
        this.pool[this.poolSize] = t;
        this.poolSize++;
    }
    match(input, pos, anchor) {
        const startCond = this.re2.cond;
        if (startCond === $ff4f66a262d5170f$var$Utils.EMPTY_ALL) return false;
        if ((anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_START || anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        this.matched = false;
        this.matchcap = Array(this.prog.numCap).fill(-1);
        let runq = this.q0;
        let nextq = this.q1;
        let r = input.step(pos);
        let rune = r >> 3;
        let width = r & 7;
        let rune1 = -1;
        let width1 = 0;
        if (r !== $ff4f66a262d5170f$var$MachineInputBase.EOF()) {
            r = input.step(pos + width);
            rune1 = r >> 3;
            width1 = r & 7;
        }
        let flag;
        if (pos === 0) flag = $ff4f66a262d5170f$var$Utils.emptyOpContext(-1, rune);
        else flag = input.context(pos);
        while(true){
            if (runq.isEmpty()) {
                if ((startCond & $ff4f66a262d5170f$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && pos !== 0) break;
                if (this.matched) break;
                if (!(this.re2.prefix.length === 0) && rune1 !== this.re2.prefixRune && input.canCheckPrefix()) {
                    const advance = input.index(this.re2, pos);
                    if (advance < 0) break;
                    pos += advance;
                    r = input.step(pos);
                    rune = r >> 3;
                    width = r & 7;
                    r = input.step(pos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                }
            }
            if (!this.matched && (pos === 0 || anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED)) {
                if (this.ncap > 0) this.matchcap[0] = pos;
                this.add(runq, this.prog.start, pos, this.matchcap, flag, null);
            }
            const nextPos = pos + width;
            flag = input.context(nextPos);
            this.step(runq, nextq, pos, nextPos, rune, flag, anchor, pos === input.endPos());
            if (width === 0) break;
            if (this.ncap === 0 && this.matched) break;
            pos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r = input.step(pos + width);
                rune1 = r >> 3;
                width1 = r & 7;
            }
            const tmpq = runq;
            runq = nextq;
            nextq = tmpq;
        }
        this.freeQueue(nextq);
        return this.matched;
    }
    step(runq, nextq, pos, nextPos, c, nextCond, anchor, atEnd) {
        const longest = this.re2.longest;
        for(let j = 0; j < runq.size; j++){
            let t = runq.denseThreads[j];
            if (t === null) continue;
            if (longest && this.matched && this.ncap > 0 && this.matchcap[0] < t.cap[0]) {
                this.freeThread(t);
                continue;
            }
            const i = t.inst;
            let add = false;
            switch(i.op){
                case $ff4f66a262d5170f$var$Inst.MATCH:
                    if (anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH && !atEnd) break;
                    if (this.ncap > 0 && (!longest || !this.matched || this.matchcap[1] < pos)) {
                        t.cap[1] = pos;
                        this.matchcap = t.cap.slice(0, this.ncap);
                    }
                    if (!longest) this.freeQueue(runq, j + 1);
                    this.matched = true;
                    break;
                case $ff4f66a262d5170f$var$Inst.RUNE:
                    add = i.matchRune(c);
                    break;
                case $ff4f66a262d5170f$var$Inst.RUNE1:
                    add = c === i.runes[0];
                    break;
                case $ff4f66a262d5170f$var$Inst.RUNE_ANY:
                    add = true;
                    break;
                case $ff4f66a262d5170f$var$Inst.RUNE_ANY_NOT_NL:
                    add = c !== $ff4f66a262d5170f$var$Codepoint.CODES.get('\n');
                    break;
                default:
                    throw new Error('bad inst');
            }
            if (add) t = this.add(nextq, i.out, nextPos, t.cap, nextCond, t);
            if (t !== null) {
                this.freeThread(t);
                runq.denseThreads[j] = null;
            }
        }
        runq.clear();
    }
    add(q, pc, pos, cap, cond, t) {
        if (pc === 0) return t;
        if (q.contains(pc)) return t;
        const d = q.add(pc);
        const inst = this.prog.inst[pc];
        switch(inst.op){
            case $ff4f66a262d5170f$var$Inst.FAIL:
                break;
            case $ff4f66a262d5170f$var$Inst.ALT:
            case $ff4f66a262d5170f$var$Inst.ALT_MATCH:
                t = this.add(q, inst.out, pos, cap, cond, t);
                t = this.add(q, inst.arg, pos, cap, cond, t);
                break;
            case $ff4f66a262d5170f$var$Inst.EMPTY_WIDTH:
                if ((inst.arg & ~cond) === 0) t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $ff4f66a262d5170f$var$Inst.NOP:
                t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $ff4f66a262d5170f$var$Inst.CAPTURE:
                if (inst.arg < this.ncap) {
                    const opos = cap[inst.arg];
                    cap[inst.arg] = pos;
                    this.add(q, inst.out, pos, cap, cond, null);
                    cap[inst.arg] = opos;
                } else t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $ff4f66a262d5170f$var$Inst.MATCH:
            case $ff4f66a262d5170f$var$Inst.RUNE:
            case $ff4f66a262d5170f$var$Inst.RUNE1:
            case $ff4f66a262d5170f$var$Inst.RUNE_ANY:
            case $ff4f66a262d5170f$var$Inst.RUNE_ANY_NOT_NL:
                if (t === null) t = this.alloc(inst);
                else t.inst = inst;
                if (this.ncap > 0 && t.cap !== cap) t.cap = cap.slice(0, this.ncap);
                q.denseThreads[d] = t;
                t = null;
                break;
            default:
                throw new Error('unhandled');
        }
        return t;
    }
}
// FNV-1a 32-bit hash for an array of integers.
// Extremely fast, allocates no memory, and produces good distribution.
const $ff4f66a262d5170f$var$hashPCs = (pcs)=>{
    let h = -2128831035; // 0x811c9dc5 (32-bit signed offset basis)
    for(let i = 0; i < pcs.length; i++){
        h ^= pcs[i];
        h = Math.imul(h, 16777619); // 0x01000193 (FNV prime)
    }
    return h;
};
// Zero-allocation array comparison for hash collision resolution
const $ff4f66a262d5170f$var$arraysEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
};
class $ff4f66a262d5170f$var$DFAState {
    constructor(nfaStates, isMatch){
        this.nfaStates = nfaStates; // Int32Array of Instruction PCs
        this.isMatch = isMatch; // Boolean
        this.nextAscii = new Array($ff4f66a262d5170f$var$Unicode.MAX_ASCII + 1).fill(null); // Flat array for blisteringly fast ASCII lookups
        this.nextMap = new Map(); // Cache of Char -> DFAState
    }
}
class $ff4f66a262d5170f$var$DFA {
    constructor(prog){
        this.prog = prog;
        this.stateCache = new Map(); // hash(number) -> DFAState[]
        this.stateCount = 0; // Tracks total states for memory limits
        this.startState = null;
        this.stateLimit = 10000; // Prevent memory explosion (ReDoS protection)
    }
    // Follows epsilon (empty) transitions to find all reachable states without consuming a char
    computeClosure(pcs) {
        const closure = new Set();
        const stack = [
            ...pcs
        ];
        let isMatch = false;
        while(stack.length > 0){
            const pc = stack.pop();
            if (closure.has(pc)) continue;
            closure.add(pc);
            const inst = this.prog.getInst(pc);
            switch(inst.op){
                case $ff4f66a262d5170f$var$Inst.MATCH:
                    isMatch = true;
                    break;
                case $ff4f66a262d5170f$var$Inst.ALT:
                case $ff4f66a262d5170f$var$Inst.ALT_MATCH:
                    stack.push(inst.out);
                    stack.push(inst.arg);
                    break;
                case $ff4f66a262d5170f$var$Inst.NOP:
                case $ff4f66a262d5170f$var$Inst.CAPTURE:
                    stack.push(inst.out);
                    break;
                // Bailing out on complex empty-width assertions to keep DFA fast.
                // Engine will seamlessly fall back to the NFA.
                case $ff4f66a262d5170f$var$Inst.EMPTY_WIDTH:
                    return null;
            }
        }
        const sortedPCs = Int32Array.from(closure).sort();
        return {
            pcs: sortedPCs,
            isMatch: isMatch
        };
    }
    // Get or create a DFA state from a list of NFA PCs
    getState(pcs) {
        const closureResult = this.computeClosure(pcs);
        if (!closureResult) return null; // Bailout to NFA required
        const sortedPCs = closureResult.pcs;
        const hash = $ff4f66a262d5170f$var$hashPCs(sortedPCs);
        // Lookup hash bucket
        let bucket = this.stateCache.get(hash);
        if (bucket) // Resolve potential hash collisions
        for(let i = 0; i < bucket.length; i++){
            const state = bucket[i];
            if ($ff4f66a262d5170f$var$arraysEqual(state.nfaStates, sortedPCs)) return state;
        }
        else {
            bucket = [];
            this.stateCache.set(hash, bucket);
        }
        // Safety: prevent memory exhaustion from state explosion
        // We flush the cache and return null, which seamlessly routes execution to the NFA
        if (this.stateCount >= this.stateLimit) {
            this.stateCache.clear();
            this.stateCount = 0;
            this.startState = null;
            return null;
        }
        // State not found, create it and add to bucket
        const state = new $ff4f66a262d5170f$var$DFAState(sortedPCs, closureResult.isMatch);
        bucket.push(state);
        this.stateCount++;
        return state;
    }
    // Compute the next DFA state given a current state and a character
    step(state, charCode, anchor) {
        // OPTIMIZATION: ASCII Fast-Path
        if (anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED && charCode <= $ff4f66a262d5170f$var$Unicode.MAX_ASCII) {
            const next = state.nextAscii[charCode];
            if (next !== null) return next;
        } else {
            const key = charCode + (anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED ? 0 : $ff4f66a262d5170f$var$Unicode.MAX_RUNE + 1);
            if (state.nextMap.has(key)) return state.nextMap.get(key);
        }
        const nextPCs = [];
        for(let i = 0; i < state.nfaStates.length; i++){
            const pc = state.nfaStates[i];
            const inst = this.prog.getInst(pc);
            if ($ff4f66a262d5170f$var$Inst.isRuneOp(inst.op) && inst.matchRune(charCode)) nextPCs.push(inst.out);
        }
        if (anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED) nextPCs.push(this.prog.start);
        const nextState = this.getState(nextPCs);
        // Cache the result
        if (anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED && charCode <= $ff4f66a262d5170f$var$Unicode.MAX_ASCII) state.nextAscii[charCode] = nextState;
        else {
            const key = charCode + (anchor === $ff4f66a262d5170f$var$RE2Flags.UNANCHORED ? 0 : $ff4f66a262d5170f$var$Unicode.MAX_RUNE + 1);
            state.nextMap.set(key, nextState);
        }
        return nextState;
    }
    // The hot loop: Execute the Lazy DFA
    match(input, pos, anchor) {
        if ((anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_START || anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        if (!this.startState) {
            this.startState = this.getState([
                this.prog.start
            ]);
            if (!this.startState) return null; // Fallback to NFA
        }
        let endPos = input.endPos();
        let currentState = this.startState;
        if (currentState.isMatch) {
            if (anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH) {
                if (pos === endPos) return true;
            } else return true;
        }
        let i = pos;
        while(i < endPos){
            const r = input.step(i);
            const rune = r >> 3;
            const width = r & 7;
            // prevent infinite loop on EOF
            if (width === 0) break;
            currentState = this.step(currentState, rune, anchor);
            // If we hit an unrecoverable DFA error or bailout, signal fallback
            if (currentState === null) return null;
            if (currentState.isMatch) {
                if (anchor === $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH) {
                    if (i + width === endPos) return true;
                } else return true;
            }
            // If we hit a dead end, and anchored, fail early
            if (currentState.nfaStates.length === 0) {
                if (anchor !== $ff4f66a262d5170f$var$RE2Flags.UNANCHORED) return false;
            }
            i += width;
        }
        return false;
    }
}
/**
 * Regular expression abstract syntax tree. Produced by parser, used by compiler. NB, this
 * corresponds to {@code syntax.regexp} in the Go implementation; Go's {@code regexp} is called
 * {@code RE2} in Java.
 */ class $ff4f66a262d5170f$var$Regexp {
    static Op = $ff4f66a262d5170f$var$createEnum([
        'NO_MATCH',
        // Matches no strings.
        'EMPTY_MATCH',
        // Matches empty string.
        'LITERAL',
        // Matches runes[] sequence
        'CHAR_CLASS',
        // Matches Runes interpreted as range pair list
        'ANY_CHAR_NOT_NL',
        // Matches any character except '\n'
        'ANY_CHAR',
        // Matches any character
        'BEGIN_LINE',
        // Matches empty string at end of line
        'END_LINE',
        // Matches empty string at end of line
        'BEGIN_TEXT',
        // Matches empty string at beginning of text
        'END_TEXT',
        // Matches empty string at end of text
        'WORD_BOUNDARY',
        // Matches word boundary `\b`
        'NO_WORD_BOUNDARY',
        // Matches word non-boundary `\B`
        'CAPTURE',
        // Capturing subexpr with index cap, optional name name
        'STAR',
        // Matches subs[0] zero or more times.
        'PLUS',
        // Matches subs[0] one or more times.
        'QUEST',
        // Matches subs[0] zero or one times.
        'REPEAT',
        // Matches subs[0] [min, max] times; max=-1 => no limit.
        'CONCAT',
        // Matches concatenation of subs[]
        'ALTERNATE',
        // Matches union of subs[]
        // Pseudo ops, used internally by Parser for parsing stack:
        'LEFT_PAREN',
        'VERTICAL_BAR'
    ]);
    static isPseudoOp(op) {
        return op >= $ff4f66a262d5170f$var$Regexp.Op.LEFT_PAREN;
    }
    static emptySubs() {
        return [];
    }
    static quoteIfHyphen(rune) {
        if (rune === $ff4f66a262d5170f$var$Codepoint.CODES.get('-')) return '\\';
        return '';
    }
    static fromRegexp(re) {
        const regex = new $ff4f66a262d5170f$var$Regexp(re.op);
        regex.flags = re.flags;
        regex.subs = re.subs;
        regex.runes = re.runes;
        regex.cap = re.cap;
        regex.min = re.min;
        regex.max = re.max;
        regex.name = re.name;
        regex.namedGroups = re.namedGroups;
        return regex;
    }
    constructor(op){
        this.op = op; // operator
        this.flags = 0; // bitmap of parse flags
        // subexpressions, if any.  Never null.
        // subs[0] is used as the freelist.
        this.subs = $ff4f66a262d5170f$var$Regexp.emptySubs();
        this.runes = []; // matched runes, for LITERAL, CHAR_CLASS
        this.min = 0; // min for REPEAT
        this.max = 0; // max for REPEAT
        this.cap = 0; // capturing index, for CAPTURE
        this.name = null; // capturing name, for CAPTURE
        this.namedGroups = {}; // map of group name -> capturing index
    }
    reinit() {
        this.flags = 0;
        this.subs = $ff4f66a262d5170f$var$Regexp.emptySubs();
        this.runes = [];
        this.cap = 0;
        this.min = 0;
        this.max = 0;
        this.name = null;
        this.namedGroups = {};
    }
    toString() {
        return this.appendTo();
    }
    // appendTo() appends the Perl syntax for |this| regular expression to out
    appendTo() {
        let out = '';
        switch(this.op){
            case $ff4f66a262d5170f$var$Regexp.Op.NO_MATCH:
                out += '[^\\x00-\\x{10FFFF}]';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH:
                out += '(?:)';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.STAR:
            case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
            case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
            case $ff4f66a262d5170f$var$Regexp.Op.REPEAT:
                {
                    const sub = this.subs[0];
                    if (sub.op > $ff4f66a262d5170f$var$Regexp.Op.CAPTURE || sub.op === $ff4f66a262d5170f$var$Regexp.Op.LITERAL && sub.runes.length > 1) out += `(?:${sub.appendTo()})`;
                    else out += sub.appendTo();
                    switch(this.op){
                        case $ff4f66a262d5170f$var$Regexp.Op.STAR:
                            out += '*';
                            break;
                        case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
                            out += '+';
                            break;
                        case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
                            out += '?';
                            break;
                        case $ff4f66a262d5170f$var$Regexp.Op.REPEAT:
                            out += `{${this.min}`;
                            if (this.min !== this.max) {
                                out += ',';
                                if (this.max >= 0) out += this.max;
                            }
                            out += '}';
                            break;
                    }
                    if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== 0) out += '?';
                    break;
                }
            case $ff4f66a262d5170f$var$Regexp.Op.CONCAT:
                for (let sub of this.subs)if (sub.op === $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE) out += `(?:${sub.appendTo()})`;
                else out += sub.appendTo();
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE:
                {
                    let sep = '';
                    for (let sub of this.subs){
                        out += sep;
                        sep = '|';
                        out += sub.appendTo();
                    }
                    break;
                }
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0) out += '(?i:';
                for (let rune of this.runes)out += $ff4f66a262d5170f$var$Utils.escapeRune(rune);
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0) out += ')';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL:
                out += '(?-s:.)';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR:
                out += '(?s:.)';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CAPTURE:
                if (this.name === null || this.name.length === 0) out += '(';
                else out += `(?P<${this.name}>`;
                if (this.subs[0].op !== $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) out += this.subs[0].appendTo();
                out += ')';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.BEGIN_TEXT:
                out += '\\A';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.END_TEXT:
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.WAS_DOLLAR) !== 0) out += '(?-m:$)';
                else out += '\\z';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.BEGIN_LINE:
                out += '^';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.END_LINE:
                out += '$';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.WORD_BOUNDARY:
                out += '\\b';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.NO_WORD_BOUNDARY:
                out += '\\B';
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS:
                if (this.runes.length % 2 !== 0) {
                    out += '[invalid char class]';
                    break;
                }
                out += '[';
                if (this.runes.length === 0) out += '^\\x00-\\x{10FFFF}';
                else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === $ff4f66a262d5170f$var$Unicode.MAX_RUNE) {
                    out += '^';
                    for(let i = 1; i < this.runes.length - 1; i += 2){
                        const lo = this.runes[i] + 1;
                        const hi = this.runes[i + 1] - 1;
                        out += $ff4f66a262d5170f$var$Regexp.quoteIfHyphen(lo);
                        out += $ff4f66a262d5170f$var$Utils.escapeRune(lo);
                        if (lo !== hi) {
                            out += '-';
                            out += $ff4f66a262d5170f$var$Regexp.quoteIfHyphen(hi);
                            out += $ff4f66a262d5170f$var$Utils.escapeRune(hi);
                        }
                    }
                } else for(let i = 0; i < this.runes.length; i += 2){
                    const lo = this.runes[i];
                    const hi = this.runes[i + 1];
                    out += $ff4f66a262d5170f$var$Regexp.quoteIfHyphen(lo);
                    out += $ff4f66a262d5170f$var$Utils.escapeRune(lo);
                    if (lo !== hi) {
                        out += '-';
                        out += $ff4f66a262d5170f$var$Regexp.quoteIfHyphen(hi);
                        out += $ff4f66a262d5170f$var$Utils.escapeRune(hi);
                    }
                }
                out += ']';
                break;
            default:
                out += this.op;
                break;
        }
        return out;
    }
    // maxCap() walks the regexp to find the maximum capture index.
    maxCap() {
        let m = 0;
        if (this.op === $ff4f66a262d5170f$var$Regexp.Op.CAPTURE) m = this.cap;
        if (this.subs !== null) for (let sub of this.subs){
            const n = sub.maxCap();
            if (m < n) m = n;
        }
        return m;
    }
    // equals() returns true if this and that have identical structure.
    equals(that) {
        if (!(that !== null && that instanceof $ff4f66a262d5170f$var$Regexp)) return false;
        if (this.op !== that.op) return false;
        switch(this.op){
            case $ff4f66a262d5170f$var$Regexp.Op.END_TEXT:
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.WAS_DOLLAR) !== (that.flags & $ff4f66a262d5170f$var$RE2Flags.WAS_DOLLAR)) return false;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
            case $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS:
                if (this.runes === null && that.runes === null) break;
                if (this.runes === null || that.runes === null) return false;
                if (this.runes.length !== that.runes.length) return false;
                for(let i = 0; i < this.runes.length; i++){
                    if (this.runes[i] !== that.runes[i]) return false;
                }
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE:
            case $ff4f66a262d5170f$var$Regexp.Op.CONCAT:
                if (this.subs.length !== that.subs.length) return false;
                for(let i = 0; i < this.subs.length; ++i){
                    if (!this.subs[i].equals(that.subs[i])) return false;
                }
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.STAR:
            case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
            case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== (that.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.REPEAT:
                if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== (that.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) || this.min !== that.min || this.max !== that.max || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CAPTURE:
                if (this.cap !== that.cap || (this.name === null ? that.name !== null : this.name !== that.name) || !this.subs[0].equals(that.subs[0])) return false;
                break;
        }
        return true;
    }
}
/**
 * A Prog is a compiled regular expression program.
 */ class $ff4f66a262d5170f$var$Prog {
    constructor(){
        this.inst = [];
        this.start = 0; // index of start instruction
        // number of CAPTURE insts in re
        // 2 => implicit ( and ) for whole match $0
        this.numCap = 2;
    }
    // Returns the instruction at the specified pc.
    // Precondition: pc > 0 && pc < numInst().
    getInst(pc) {
        return this.inst[pc];
    }
    // Returns the number of instructions in this program.
    numInst() {
        return this.inst.length;
    }
    // Adds a new instruction to this program, with operator |op| and |pc| equal
    // to |numInst()|.
    addInst(op) {
        this.inst.push(new $ff4f66a262d5170f$var$Inst(op));
    }
    // skipNop() follows any no-op or capturing instructions and returns the
    // resulting instruction.
    skipNop(pc) {
        let i = this.inst[pc];
        while(i.op === $ff4f66a262d5170f$var$Inst.NOP || i.op === $ff4f66a262d5170f$var$Inst.CAPTURE){
            i = this.inst[pc];
            pc = i.out;
        }
        return i;
    }
    // prefix() returns a pair of a literal string that all matches for the
    // regexp must start with, and a boolean which is true if the prefix is the
    // entire match.  The string is returned by appending to |prefix|.
    prefix() {
        let prefix = '';
        let i = this.skipNop(this.start);
        if (!$ff4f66a262d5170f$var$Inst.isRuneOp(i.op) || i.runes.length !== 1) return [
            i.op === $ff4f66a262d5170f$var$Inst.MATCH,
            prefix
        ];
        while($ff4f66a262d5170f$var$Inst.isRuneOp(i.op) && i.runes.length === 1 && (i.arg & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) === 0){
            prefix += String.fromCodePoint(i.runes[0]);
            i = this.skipNop(i.out);
        }
        return [
            i.op === $ff4f66a262d5170f$var$Inst.MATCH,
            prefix
        ];
    }
    // startCond() returns the leading empty-width conditions that must be true
    // in any match.  It returns -1 (all bits set) if no matches are possible.
    startCond() {
        let flag = 0;
        let pc = this.start;
        loop: for(;;){
            const i = this.inst[pc];
            switch(i.op){
                case $ff4f66a262d5170f$var$Inst.EMPTY_WIDTH:
                    flag |= i.arg;
                    break;
                case $ff4f66a262d5170f$var$Inst.FAIL:
                    return -1;
                case $ff4f66a262d5170f$var$Inst.CAPTURE:
                case $ff4f66a262d5170f$var$Inst.NOP:
                    break;
                default:
                    break loop;
            }
            pc = i.out;
        }
        return flag;
    }
    // --- Patch list ---
    // A patchlist is a list of instruction pointers that need to be filled in
    // (patched).  Because the pointers haven't been filled in yet, we can reuse
    // their storage to hold the list.  It's kind of sleazy, but works well in
    // practice.  See http://swtch.com/~rsc/regexp/regexp1.html for inspiration.
    // These aren't really pointers: they're integers, so we can reinterpret them
    // this way without using package unsafe.  A value l denotes p.inst[l>>1].out
    // (l&1==0) or .arg (l&1==1).  l == 0 denotes the empty list, okay because we
    // start every program with a fail instruction, so we'll never want to point
    // at its output link.
    next(l) {
        const i = this.inst[l >> 1];
        if ((l & 1) === 0) return i.out;
        return i.arg;
    }
    patch(l, val) {
        while(l !== 0){
            const i = this.inst[l >> 1];
            if ((l & 1) === 0) {
                l = i.out;
                i.out = val;
            } else {
                l = i.arg;
                i.arg = val;
            }
        }
    }
    append(l1, l2) {
        if (l1 === 0) return l2;
        if (l2 === 0) return l1;
        let last = l1;
        for(;;){
            const next = this.next(last);
            if (next === 0) break;
            last = next;
        }
        const i = this.inst[last >> 1];
        if ((last & 1) === 0) i.out = l2;
        else i.arg = l2;
        return l1;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        let out = '';
        for(let pc = 0; pc < this.inst.length; pc++){
            const len = out.length;
            out += pc;
            if (pc === this.start) out += '*';
            out += '        '.substring(out.length - len);
            out += this.inst[pc];
            out += '\n';
        }
        return out;
    }
}
/**
 * A fragment of a compiled regular expression program.
 *
 * @see http://swtch.com/~rsc/regexp/regexp1.html
 * @class
 */ class $ff4f66a262d5170f$var$Frag {
    constructor(i = 0, out = 0, nullable = false){
        this.i = i; // an instruction address (pc).
        this.out = out; // a patch list; see explanation in Prog.js
        this.nullable = nullable; // whether the fragment can match the empty string
    }
}
/**
 * Compiler from {@code Regexp} (RE2 abstract syntax) to {@code RE2} (compiled regular expression).
 *
 * The only entry point is {@link #compileRegexp}.
 */ class $ff4f66a262d5170f$var$Compiler {
    static ANY_RUNE_NOT_NL() {
        return [
            0,
            $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') - 1,
            $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') + 1,
            $ff4f66a262d5170f$var$Unicode.MAX_RUNE
        ];
    }
    static ANY_RUNE() {
        return [
            0,
            $ff4f66a262d5170f$var$Unicode.MAX_RUNE
        ];
    }
    static compileRegexp(re) {
        const c = new $ff4f66a262d5170f$var$Compiler();
        const f = c.compile(re);
        c.prog.patch(f.out, c.newInst($ff4f66a262d5170f$var$Inst.MATCH).i);
        c.prog.start = f.i;
        return c.prog;
    }
    constructor(){
        this.prog = new $ff4f66a262d5170f$var$Prog();
        this.newInst($ff4f66a262d5170f$var$Inst.FAIL);
    }
    newInst(op) {
        this.prog.addInst(op);
        return new $ff4f66a262d5170f$var$Frag(this.prog.numInst() - 1, 0, true);
    }
    // Returns a no-op fragment.  Sometimes unavoidable.
    nop() {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.NOP);
        f.out = f.i << 1;
        return f;
    }
    fail() {
        return new $ff4f66a262d5170f$var$Frag();
    }
    // Given fragment a, returns (a) capturing as \n.
    // Given a fragment a, returns a fragment with capturing parens around a.
    cap(arg) {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.CAPTURE);
        f.out = f.i << 1;
        this.prog.getInst(f.i).arg = arg;
        if (this.prog.numCap < arg + 1) this.prog.numCap = arg + 1;
        return f;
    }
    // Given fragments a and b, returns ab; a|b
    cat(f1, f2) {
        // concat of failure is failure
        if (f1.i === 0 || f2.i === 0) return this.fail();
        // eslint-disable-next-line no-warning-comments
        // TODO(rsc): elide nop
        this.prog.patch(f1.out, f2.i);
        return new $ff4f66a262d5170f$var$Frag(f1.i, f2.out, f1.nullable && f2.nullable);
    }
    // Given fragments for a and b, returns fragment for a|b.
    alt(f1, f2) {
        // alt of failure is other
        if (f1.i === 0) return f2;
        if (f2.i === 0) return f1;
        const f = this.newInst($ff4f66a262d5170f$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        i.out = f1.i;
        i.arg = f2.i;
        f.out = this.prog.append(f1.out, f2.out);
        f.nullable = f1.nullable || f2.nullable;
        return f;
    }
    // loop returns the fragment for the main loop of a plus or star.
    // For plus, it can be used directly. with f1.i as the entry.
    // For star, it can be used directly when f1 can't match an empty string.
    // (When f1 can match an empty string, f1* must be implemented as (f1+)?
    // to get the priority match order correct.)
    loop(f1, nongreedy) {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        this.prog.patch(f1.out, f.i);
        return f;
    }
    // Given a fragment for a, returns a fragment for a? or a?? (if nongreedy)
    quest(f1, nongreedy) {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        f.out = this.prog.append(f.out, f1.out);
        return f;
    }
    // Given a fragment a, returns a fragment for a* or a*? (if nongreedy)
    star(f1, nongreedy) {
        if (f1.nullable) return this.quest(this.plus(f1, nongreedy), nongreedy);
        return this.loop(f1, nongreedy);
    }
    // Given a fragment for a, returns a fragment for a+ or a+? (if nongreedy)
    plus(f1, nongreedy) {
        return new $ff4f66a262d5170f$var$Frag(f1.i, this.loop(f1, nongreedy).out, f1.nullable);
    }
    // op is a bitmask of EMPTY_* flags.
    empty(op) {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.EMPTY_WIDTH);
        this.prog.getInst(f.i).arg = op;
        f.out = f.i << 1;
        return f;
    }
    // flags : parser flags
    rune(runes, flags) {
        const f = this.newInst($ff4f66a262d5170f$var$Inst.RUNE);
        f.nullable = false;
        const i = this.prog.getInst(f.i);
        i.runes = runes;
        flags &= $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE;
        if (runes.length !== 1 || $ff4f66a262d5170f$var$Unicode.simpleFold(runes[0]) === runes[0]) flags &= -2;
        i.arg = flags;
        f.out = f.i << 1;
        if ((flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) === 0 && runes.length === 1 || runes.length === 2 && runes[0] === runes[1]) i.op = $ff4f66a262d5170f$var$Inst.RUNE1;
        else if (runes.length === 2 && runes[0] === 0 && runes[1] === $ff4f66a262d5170f$var$Unicode.MAX_RUNE) i.op = $ff4f66a262d5170f$var$Inst.RUNE_ANY;
        else if (runes.length === 4 && runes[0] === 0 && runes[1] === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') - 1 && runes[2] === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') + 1 && runes[3] === $ff4f66a262d5170f$var$Unicode.MAX_RUNE) i.op = $ff4f66a262d5170f$var$Inst.RUNE_ANY_NOT_NL;
        return f;
    }
    compile(re) {
        switch(re.op){
            case $ff4f66a262d5170f$var$Regexp.Op.NO_MATCH:
                return this.fail();
            case $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH:
                return this.nop();
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
                if (re.runes.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let r of re.runes){
                        const f1 = this.rune([
                            r
                        ], re.flags);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS:
                return this.rune(re.runes, re.flags);
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return this.rune($ff4f66a262d5170f$var$Compiler.ANY_RUNE_NOT_NL(), 0);
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR:
                return this.rune($ff4f66a262d5170f$var$Compiler.ANY_RUNE(), 0);
            case $ff4f66a262d5170f$var$Regexp.Op.BEGIN_LINE:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_BEGIN_LINE);
            case $ff4f66a262d5170f$var$Regexp.Op.END_LINE:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_END_LINE);
            case $ff4f66a262d5170f$var$Regexp.Op.BEGIN_TEXT:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_BEGIN_TEXT);
            case $ff4f66a262d5170f$var$Regexp.Op.END_TEXT:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_END_TEXT);
            case $ff4f66a262d5170f$var$Regexp.Op.WORD_BOUNDARY:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_WORD_BOUNDARY);
            case $ff4f66a262d5170f$var$Regexp.Op.NO_WORD_BOUNDARY:
                return this.empty($ff4f66a262d5170f$var$Utils.EMPTY_NO_WORD_BOUNDARY);
            case $ff4f66a262d5170f$var$Regexp.Op.CAPTURE:
                {
                    const bra = this.cap(re.cap << 1);
                    const sub = this.compile(re.subs[0]);
                    const ket = this.cap(re.cap << 1 | 1);
                    return this.cat(this.cat(bra, sub), ket);
                }
            case $ff4f66a262d5170f$var$Regexp.Op.STAR:
                return this.star(this.compile(re.subs[0]), (re.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== 0);
            case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
                return this.plus(this.compile(re.subs[0]), (re.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== 0);
            case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
                return this.quest(this.compile(re.subs[0]), (re.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) !== 0);
            case $ff4f66a262d5170f$var$Regexp.Op.CONCAT:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.alt(f, f1);
                    }
                    return f;
                }
            default:
                throw new $ff4f66a262d5170f$export$457eacef9ada3821('regexp: unhandled case in compile');
        }
    }
}
class $ff4f66a262d5170f$var$Simplify {
    // Simplify returns a regexp equivalent to re but without counted
    // repetitions and with various other simplifications, such as
    // rewriting /(?:a+)+/ to /a+/.  The resulting regexp will execute
    // correctly but its string representation will not produce the same
    // parse tree, because capturing parentheses may have been duplicated
    // or removed.  For example, the simplified form for /(x){1,2}/ is
    // /(x)(x)?/ but both parentheses capture as $1.  The returned regexp
    // may share structure with or be the original.
    static simplify(re) {
        if (re === null) return null;
        switch(re.op){
            case $ff4f66a262d5170f$var$Regexp.Op.CAPTURE:
            case $ff4f66a262d5170f$var$Regexp.Op.CONCAT:
            case $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE:
                {
                    let nre = re;
                    for(let i = 0; i < re.subs.length; i++){
                        const sub = re.subs[i];
                        const nsub = $ff4f66a262d5170f$var$Simplify.simplify(sub);
                        if (nre === re && nsub !== sub) {
                            nre = $ff4f66a262d5170f$var$Regexp.fromRegexp(re);
                            nre.runes = [];
                            nre.subs = re.subs.slice(0, re.subs.length);
                        }
                        if (nre !== re) nre.subs[i] = nsub;
                    }
                    return nre;
                }
            case $ff4f66a262d5170f$var$Regexp.Op.STAR:
            case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
            case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
                {
                    const sub = $ff4f66a262d5170f$var$Simplify.simplify(re.subs[0]);
                    return $ff4f66a262d5170f$var$Simplify.simplify1(re.op, re.flags, sub, re);
                }
            case $ff4f66a262d5170f$var$Regexp.Op.REPEAT:
                {
                    // Special special case: x{0} matches the empty string
                    // and doesn't even need to consider x.
                    if (re.min === 0 && re.max === 0) return new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH);
                    // The fun begins.
                    const sub = $ff4f66a262d5170f$var$Simplify.simplify(re.subs[0]);
                    // x{n,} means at least n matches of x.
                    if (re.max === -1) {
                        // Special case: x{0,} is x*.
                        if (re.min === 0) return $ff4f66a262d5170f$var$Simplify.simplify1($ff4f66a262d5170f$var$Regexp.Op.STAR, re.flags, sub, null);
                        // Special case: x{1,} is x+.
                        if (re.min === 1) return $ff4f66a262d5170f$var$Simplify.simplify1($ff4f66a262d5170f$var$Regexp.Op.PLUS, re.flags, sub, null);
                        // General case: x{4,} is xxxx+.
                        const nre = new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.CONCAT);
                        const subs = [];
                        for(let i = 0; i < re.min - 1; i++)subs.push(sub);
                        subs.push($ff4f66a262d5170f$var$Simplify.simplify1($ff4f66a262d5170f$var$Regexp.Op.PLUS, re.flags, sub, null));
                        nre.subs = subs.slice(0);
                        return nre;
                    }
                    // Special case x{0} handled above.
                    // Special case: x{1} is just x.
                    if (re.min === 1 && re.max === 1) return sub;
                    // General case: x{n,m} means n copies of x and m copies of x?
                    // The machine will do less work if we nest the final m copies,
                    // so that x{2,5} = xx(x(x(x)?)?)?
                    // Build leading prefix: xx.
                    let prefixSubs = null;
                    if (re.min > 0) {
                        prefixSubs = [];
                        for(let i = 0; i < re.min; i++)prefixSubs.push(sub);
                    }
                    // Build and attach suffix: (x(x(x)?)?)?
                    if (re.max > re.min) {
                        let suffix = $ff4f66a262d5170f$var$Simplify.simplify1($ff4f66a262d5170f$var$Regexp.Op.QUEST, re.flags, sub, null);
                        for(let i = re.min + 1; i < re.max; i++){
                            const nre2 = new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.CONCAT);
                            nre2.subs = [
                                sub,
                                suffix
                            ];
                            suffix = $ff4f66a262d5170f$var$Simplify.simplify1($ff4f66a262d5170f$var$Regexp.Op.QUEST, re.flags, nre2, null);
                        }
                        if (prefixSubs === null) return suffix;
                        prefixSubs.push(suffix);
                    }
                    if (prefixSubs !== null) {
                        const prefix = new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.CONCAT);
                        prefix.subs = prefixSubs.slice(0);
                        return prefix;
                    }
                    // Some degenerate case like min > max or min < max < 0.
                    // Handle as impossible match.
                    return new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.NO_MATCH);
                }
        }
        return re;
    }
    // simplify1 implements Simplify for the unary OpStar,
    // OpPlus, and OpQuest operators.  It returns the simple regexp
    // equivalent to
    //
    //      Regexp{Op: op, Flags: flags, Sub: {sub}}
    //
    // under the assumption that sub is already simple, and
    // without first allocating that structure.  If the regexp
    // to be returned turns out to be equivalent to re, simplify1
    // returns re instead.
    //
    // simplify1 is factored out of Simplify because the implementation
    // for other operators generates these unary expressions.
    // Letting them call simplify1 makes sure the expressions they
    // generate are simple.
    static simplify1(op, flags, sub, re) {
        // Special case: repeat the empty string as much as
        // you want, but it's still the empty string.
        if (sub.op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) return sub;
        // The operators are idempotent if the flags match.
        if (op === sub.op && (flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) === (sub.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY)) return sub;
        if (re !== null && re.op === op && (re.flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) === (flags & $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY) && sub === re.subs[0]) return re;
        re = new $ff4f66a262d5170f$var$Regexp(op);
        re.flags = flags;
        re.subs = [
            sub
        ];
        return re;
    }
}
// GENERATED BY tools/scripts/make_perl_groups.pl; DO NOT EDIT.
// ./tools/scripts/make_perl_groups.pl  > src/CharGroup.js
class $ff4f66a262d5170f$var$CharGroup {
    constructor(sign, cls){
        this.sign = sign;
        this.cls = cls;
    }
}
const $ff4f66a262d5170f$var$code1 = [
    0x30,
    0x39
];
const $ff4f66a262d5170f$var$code2 = [
    0x9,
    0xa,
    0xc,
    0xd,
    0x20,
    0x20
];
const $ff4f66a262d5170f$var$code3 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const $ff4f66a262d5170f$var$PERL_GROUPS = new Map([
    [
        '\\d',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code1)
    ],
    [
        '\\D',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code1)
    ],
    [
        '\\s',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code2)
    ],
    [
        '\\S',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code2)
    ],
    [
        '\\w',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code3)
    ],
    [
        '\\W',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code3)
    ]
]);
const $ff4f66a262d5170f$var$code4 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x61,
    0x7a
];
const $ff4f66a262d5170f$var$code5 = [
    0x41,
    0x5a,
    0x61,
    0x7a
];
const $ff4f66a262d5170f$var$code6 = [
    0x0,
    0x7f
];
const $ff4f66a262d5170f$var$code7 = [
    0x9,
    0x9,
    0x20,
    0x20
];
const $ff4f66a262d5170f$var$code8 = [
    0x0,
    0x1f,
    0x7f,
    0x7f
];
const $ff4f66a262d5170f$var$code9 = [
    0x30,
    0x39
];
const $ff4f66a262d5170f$var$code10 = [
    0x21,
    0x7e
];
const $ff4f66a262d5170f$var$code11 = [
    0x61,
    0x7a
];
const $ff4f66a262d5170f$var$code12 = [
    0x20,
    0x7e
];
const $ff4f66a262d5170f$var$code13 = [
    0x21,
    0x2f,
    0x3a,
    0x40,
    0x5b,
    0x60,
    0x7b,
    0x7e
];
const $ff4f66a262d5170f$var$code14 = [
    0x9,
    0xd,
    0x20,
    0x20
];
const $ff4f66a262d5170f$var$code15 = [
    0x41,
    0x5a
];
const $ff4f66a262d5170f$var$code16 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const $ff4f66a262d5170f$var$code17 = [
    0x30,
    0x39,
    0x41,
    0x46,
    0x61,
    0x66
];
const $ff4f66a262d5170f$var$POSIX_GROUPS = new Map([
    [
        '[:alnum:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code4)
    ],
    [
        '[:^alnum:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code4)
    ],
    [
        '[:alpha:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code5)
    ],
    [
        '[:^alpha:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code5)
    ],
    [
        '[:ascii:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code6)
    ],
    [
        '[:^ascii:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code6)
    ],
    [
        '[:blank:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code7)
    ],
    [
        '[:^blank:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code7)
    ],
    [
        '[:cntrl:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code8)
    ],
    [
        '[:^cntrl:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code8)
    ],
    [
        '[:digit:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code9)
    ],
    [
        '[:^digit:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code9)
    ],
    [
        '[:graph:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code10)
    ],
    [
        '[:^graph:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code10)
    ],
    [
        '[:lower:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code11)
    ],
    [
        '[:^lower:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code11)
    ],
    [
        '[:print:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code12)
    ],
    [
        '[:^print:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code12)
    ],
    [
        '[:punct:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code13)
    ],
    [
        '[:^punct:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code13)
    ],
    [
        '[:space:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code14)
    ],
    [
        '[:^space:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code14)
    ],
    [
        '[:upper:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code15)
    ],
    [
        '[:^upper:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code15)
    ],
    [
        '[:word:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code16)
    ],
    [
        '[:^word:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code16)
    ],
    [
        '[:xdigit:]',
        new $ff4f66a262d5170f$var$CharGroup(1, $ff4f66a262d5170f$var$code17)
    ],
    [
        '[:^xdigit:]',
        new $ff4f66a262d5170f$var$CharGroup(-1, $ff4f66a262d5170f$var$code17)
    ]
]);
/**
 * A "builder"-style helper class for manipulating character classes represented as an array of
 * pairs of runes [lo, hi], each denoting an inclusive interval.
 *
 * All methods mutate the internal state and return {@code this}, allowing operations to be chained.
 */ class $ff4f66a262d5170f$var$CharClass {
    // Exposed, since useful for debugging CharGroups too.
    static charClassToString(r, len) {
        let result = '[';
        for(let i = 0; i < len; i += 2){
            if (i > 0) result += ' ';
            const lo = r[i];
            const hi = r[i + 1];
            if (lo === hi) result += `0x${lo.toString(16)}`;
            else result += `0x${lo.toString(16)}-0x${hi.toString(16)}`;
        }
        result += ']';
        return result;
    }
    // cmp() returns the ordering of the pair (a[i], a[i+1]) relative to
    // (pivotFrom, pivotTo), where the first component of the pair (lo) is
    // ordered naturally and the second component (hi) is in reverse order.
    static cmp(array, i, pivotFrom, pivotTo) {
        const cmp = array[i] - pivotFrom;
        return cmp !== 0 ? cmp : pivotTo - array[i + 1];
    }
    // qsortIntPair() quicksorts pairs of ints in |array| according to lt().
    // Precondition: |left|, |right|, |this.len| must all be even; |this.len > 1|.
    static qsortIntPair(array, left, right) {
        const pivotIndex = ((left + right) / 2 | 0) & -2;
        const pivotFrom = array[pivotIndex];
        const pivotTo = array[pivotIndex + 1];
        let i = left;
        let j = right;
        while(i <= j){
            while(i < right && $ff4f66a262d5170f$var$CharClass.cmp(array, i, pivotFrom, pivotTo) < 0)i += 2;
            while(j > left && $ff4f66a262d5170f$var$CharClass.cmp(array, j, pivotFrom, pivotTo) > 0)j -= 2;
            if (i <= j) {
                if (i !== j) {
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                    temp = array[i + 1];
                    array[i + 1] = array[j + 1];
                    array[j + 1] = temp;
                }
                i += 2;
                j -= 2;
            }
        }
        if (left < j) $ff4f66a262d5170f$var$CharClass.qsortIntPair(array, left, j);
        if (i < right) $ff4f66a262d5170f$var$CharClass.qsortIntPair(array, i, right);
    }
    constructor(r = $ff4f66a262d5170f$var$Utils.emptyInts()){
        this.r = r; // inclusive ranges, pairs of [lo,hi].  r.length is even.
        this.len = r.length; // prefix of |r| that is defined.  Even.
    }
    // Returns the character class as an int array.  Subsequent CharClass
    // operations may mutate this array, so typically this is the last operation
    // performed on a given CharClass instance.
    toArray() {
        if (this.len === this.r.length) return this.r;
        else return this.r.slice(0, this.len);
    }
    // cleanClass() sorts the ranges (pairs of elements) of this CharClass,
    // merges them, and eliminates duplicates.
    cleanClass() {
        if (this.len < 4) return this;
        // Sort by lo increasing, hi decreasing to break ties.
        $ff4f66a262d5170f$var$CharClass.qsortIntPair(this.r, 0, this.len - 2);
        // Merge abutting, overlapping.
        let w = 2; // write index
        for(let i = 2; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (lo <= this.r[w - 1] + 1) {
                // merge with previous range
                if (hi > this.r[w - 1]) this.r[w - 1] = hi;
                continue;
            }
            // new disjoint range
            this.r[w] = lo;
            this.r[w + 1] = hi;
            w += 2;
        }
        this.len = w;
        return this;
    }
    // appendLiteral() appends the literal |x| to this CharClass.
    appendLiteral(x, flags) {
        return (flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0 ? this.appendFoldedRange(x, x) : this.appendRange(x, x);
    }
    // appendRange() appends the range [lo-hi] (inclusive) to this CharClass.
    appendRange(lo, hi) {
        // Expand last range or next to last range if it overlaps or abuts.
        // Checking two ranges helps when appending case-folded
        // alphabets, so that one range can be expanding A-Z and the
        // other expanding a-z.
        if (this.len > 0) {
            for(let i = 2; i <= 4; i += 2)// twice, using i=2, i=4
            if (this.len >= i) {
                const rlo = this.r[this.len - i];
                const rhi = this.r[this.len - i + 1];
                if (lo <= rhi + 1 && rlo <= hi + 1) {
                    if (lo < rlo) this.r[this.len - i] = lo;
                    if (hi > rhi) this.r[this.len - i + 1] = hi;
                    return this;
                }
            }
        }
        this.r[this.len++] = lo;
        this.r[this.len++] = hi;
        return this;
    }
    // appendFoldedRange() appends the range [lo-hi] and its case
    // folding-equivalent runes to this CharClass.
    appendFoldedRange(lo, hi) {
        // Optimizations.
        if (lo <= $ff4f66a262d5170f$var$Unicode.MIN_FOLD && hi >= $ff4f66a262d5170f$var$Unicode.MAX_FOLD) // Range is full: folding can't add more.
        return this.appendRange(lo, hi);
        if (hi < $ff4f66a262d5170f$var$Unicode.MIN_FOLD || lo > $ff4f66a262d5170f$var$Unicode.MAX_FOLD) // Range is outside folding possibilities.
        return this.appendRange(lo, hi);
        if (lo < $ff4f66a262d5170f$var$Unicode.MIN_FOLD) {
            // [lo, minFold-1] needs no folding.
            this.appendRange(lo, $ff4f66a262d5170f$var$Unicode.MIN_FOLD - 1);
            lo = $ff4f66a262d5170f$var$Unicode.MIN_FOLD;
        }
        if (hi > $ff4f66a262d5170f$var$Unicode.MAX_FOLD) {
            // [maxFold+1, hi] needs no folding.
            this.appendRange($ff4f66a262d5170f$var$Unicode.MAX_FOLD + 1, hi);
            hi = $ff4f66a262d5170f$var$Unicode.MAX_FOLD;
        }
        // Brute force.  Depend on appendRange to coalesce ranges on the fly.
        for(let c = lo; c <= hi; c++){
            this.appendRange(c, c);
            for(let f = $ff4f66a262d5170f$var$Unicode.simpleFold(c); f !== c; f = $ff4f66a262d5170f$var$Unicode.simpleFold(f))this.appendRange(f, f);
        }
        return this;
    }
    // appendClass() appends the class |x| to this CharClass.
    // It assumes |x| is clean.  Does not mutate |x|.
    appendClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendRange(x[i], x[i + 1]);
        return this;
    }
    // appendFoldedClass() appends the case folding of the class |x| to this
    // CharClass.  Does not mutate |x|.
    appendFoldedClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendFoldedRange(x[i], x[i + 1]);
        return this;
    }
    // appendNegatedClass() append the negation of the class |x| to this
    // CharClass.  It assumes |x| is clean.  Does not mutate |x|.
    appendNegatedClass(x) {
        let nextLo = 0;
        for(let i = 0; i < x.length; i += 2){
            const lo = x[i];
            const hi = x[i + 1];
            if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
            nextLo = hi + 1;
        }
        if (nextLo <= $ff4f66a262d5170f$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $ff4f66a262d5170f$var$Unicode.MAX_RUNE);
        return this;
    }
    // appendTable() appends the Unicode range table |table| to this CharClass.
    // Does not mutate |table|.
    appendTable(table) {
        for(let i = 0; i < table.length; ++i){
            const lo = table.getLo(i);
            const hi = table.getHi(i);
            const stride = table.getStride(i);
            if (stride === 1) {
                this.appendRange(lo, hi);
                continue;
            }
            for(let c = lo; c <= hi; c += stride)this.appendRange(c, c);
        }
        return this;
    }
    // appendNegatedTable() returns the result of appending the negation of range
    // table |table| to this CharClass.  Does not mutate |table|.
    appendNegatedTable(table) {
        let nextLo = 0;
        for(let i = 0; i < table.length; ++i){
            const lo = table.getLo(i);
            const hi = table.getHi(i);
            const stride = table.getStride(i);
            if (stride === 1) {
                if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                nextLo = hi + 1;
                continue;
            }
            for(let c = lo; c <= hi; c += stride){
                if (nextLo <= c - 1) this.appendRange(nextLo, c - 1);
                nextLo = c + 1;
            }
        }
        if (nextLo <= $ff4f66a262d5170f$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $ff4f66a262d5170f$var$Unicode.MAX_RUNE);
        return this;
    }
    // appendTableWithSign() calls append{,Negated}Table depending on sign.
    // Does not mutate |table|.
    appendTableWithSign(table, sign) {
        return sign < 0 ? this.appendNegatedTable(table) : this.appendTable(table);
    }
    // negateClass() negates this CharClass, which must already be clean.
    negateClass() {
        let nextLo = 0; // lo end of next class to add
        let w = 0; // write index
        for(let i = 0; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (nextLo <= lo - 1) {
                this.r[w] = nextLo;
                this.r[w + 1] = lo - 1;
                w += 2;
            }
            nextLo = hi + 1;
        }
        this.len = w;
        if (nextLo <= $ff4f66a262d5170f$var$Unicode.MAX_RUNE) {
            this.r[this.len++] = nextLo;
            this.r[this.len++] = $ff4f66a262d5170f$var$Unicode.MAX_RUNE;
        }
        return this;
    }
    // appendClassWithSign() calls appendClass() if sign is +1 or
    // appendNegatedClass if sign is -1.  Does not mutate |x|.
    appendClassWithSign(x, sign) {
        return sign < 0 ? this.appendNegatedClass(x) : this.appendClass(x);
    }
    // appendGroup() appends CharGroup |g| to this CharClass, folding iff
    // |foldCase|.  Does not mutate |g|.
    appendGroup(g, foldCase) {
        let cls = g.cls;
        if (foldCase) cls = new $ff4f66a262d5170f$var$CharClass().appendFoldedClass(cls).cleanClass().toArray();
        return this.appendClassWithSign(cls, g.sign);
    }
    toString() {
        return $ff4f66a262d5170f$var$CharClass.charClassToString(this.r, this.len);
    }
}
class $ff4f66a262d5170f$var$Pair {
    static of(first, second) {
        return new $ff4f66a262d5170f$var$Pair(first, second);
    }
    constructor(first, second){
        this.first = first;
        this.second = second;
    }
}
// StringIterator: a stream of runes with an opaque cursor, permitting
// rewinding.  The units of the cursor are not specified beyond the
// fact that ASCII characters are single width.  (Cursor positions
// could be UTF-8 byte indices, UTF-16 code indices or rune indices.)
//
// In particular, be careful with:
// - skip: only use this to advance over ASCII characters
//   since these always have a width of 1.
// - skipString: only use this to advance over strings which are
//   known to be at the current position, e.g. due to prior call to
//   lookingAt().
// Only use pop() to advance over possibly non-ASCII runes.
class $ff4f66a262d5170f$var$StringIterator {
    constructor(str){
        this.str = str;
        this.position = 0;
    }
    // Returns the cursor position.  Do not interpret the result!
    pos() {
        return this.position;
    }
    // Resets the cursor position to a previous value returned by pos().
    rewindTo(pos) {
        this.position = pos;
    }
    // Returns true unless the stream is exhausted.
    more() {
        return this.position < this.str.length;
    }
    // Returns the rune at the cursor position.
    // Precondition: |more()|.
    peek() {
        return this.str.codePointAt(this.position);
    }
    // Advances the cursor by |n| positions, which must be ASCII runes.
    //
    // (In practise, this is only ever used to skip over regexp
    // metacharacters that are ASCII, so there is no numeric difference
    // between indices into  UTF-8 bytes, UTF-16 codes and runes.)
    skip(n) {
        this.position += n;
    }
    // Advances the cursor by the number of cursor positions in |s|.
    skipString(s) {
        this.position += s.length;
    }
    // Returns the rune at the cursor position, and advances the cursor
    // past it.  Precondition: |more()|.
    pop() {
        const r = this.str.codePointAt(this.position);
        this.position += $ff4f66a262d5170f$var$Utils.charCount(r);
        return r;
    }
    lookingAt(s) {
        return this.rest().startsWith(s);
    }
    // Returns the rest of the pattern as a Java UTF-16 string.
    rest() {
        return this.str.substring(this.position);
    }
    // Returns the substring from |beforePos| to the current position.
    // |beforePos| must have been previously returned by |pos()|.
    from(beforePos) {
        return this.str.substring(beforePos, this.position);
    }
    toString() {
        return this.rest();
    }
}
/**
 * A parser of regular expression patterns.
 *
 * The only public entry point is {@link #parse(String pattern, int flags)}.
 */ class $ff4f66a262d5170f$var$Parser {
    // Unexpected error
    static ERR_INTERNAL_ERROR = 'regexp/syntax: internal error';
    // Parse errors
    static ERR_INVALID_CHAR_RANGE = 'invalid character class range';
    static ERR_INVALID_ESCAPE = 'invalid escape sequence';
    static ERR_INVALID_NAMED_CAPTURE = 'invalid named capture';
    static ERR_INVALID_PERL_OP = 'invalid or unsupported Perl syntax';
    static ERR_INVALID_REPEAT_OP = 'invalid nested repetition operator';
    static ERR_INVALID_REPEAT_SIZE = 'invalid repeat count';
    static ERR_MISSING_BRACKET = 'missing closing ]';
    static ERR_MISSING_PAREN = 'missing closing )';
    static ERR_MISSING_REPEAT_ARGUMENT = 'missing argument to repetition operator';
    static ERR_TRAILING_BACKSLASH = 'trailing backslash at end of expression';
    static ERR_DUPLICATE_NAMED_CAPTURE = 'duplicate capture group name';
    static ERR_UNEXPECTED_PAREN = 'unexpected )';
    static ERR_NESTING_DEPTH = 'expression nests too deeply';
    static ERR_LARGE = 'expression too large';
    // maxHeight is the maximum height of a regexp parse tree.
    // It is somewhat arbitrarily chosen, but the idea is to be large enough
    // that no one will actually hit in real use but at the same time small enough
    // that recursion on the Regexp tree will not hit the 1GB Go stack limit.
    // The maximum amount of stack for a single recursive frame is probably
    // closer to 1kB, so this could potentially be raised, but it seems unlikely
    // that people have regexps nested even this deeply.
    // We ran a test on Google's C++ code base and turned up only
    // a single use case with depth > 100; it had depth 128.
    // Using depth 1000 should be plenty of margin.
    // As an optimization, we don't even bother calculating heights
    // until we've allocated at least maxHeight Regexp structures.
    static MAX_HEIGHT = 1000;
    // maxSize is the maximum size of a compiled regexp in Insts.
    // It too is somewhat arbitrarily chosen, but the idea is to be large enough
    // to allow significant regexps while at the same time small enough that
    // the compiled form will not take up too much memory.
    // 128 MB is enough for a 3.3 million Inst structures, which roughly
    // corresponds to a 3.3 MB regexp.
    static MAX_SIZE = 3355443;
    // maxRunes is the maximum number of runes allowed in a regexp tree
    // counting the runes in all the nodes.
    // Ignoring character classes p.numRunes is always less than the length of the regexp.
    // Character classes can make it much larger: each \pL adds 1292 runes.
    // 128 MB is enough for 32M runes, which is over 26k \pL instances.
    // Note that repetitions do not make copies of the rune slices,
    // so \pL{1000} is only one rune slice, not 1000.
    // We could keep a cache of character classes we've seen,
    // so that all the \pL we see use the same rune list,
    // but that doesn't remove the problem entirely:
    // consider something like [\pL01234][\pL01235][\pL01236]...[\pL^&*()].
    // And because the Rune slice is exposed directly in the Regexp,
    // there is not an opportunity to change the representation to allow
    // partial sharing between different character classes.
    // So the limit is the best we can do.
    static MAX_RUNES = 33554432;
    // RangeTables are represented as int[][], a list of triples (start, end,
    // stride).
    static ANY_TABLE = new $ff4f66a262d5170f$var$UnicodeRangeTable(new Uint32Array([
        0,
        $ff4f66a262d5170f$var$Unicode.MAX_RUNE,
        1
    ]));
    // unicodeTable() returns the Unicode RangeTable identified by name
    // and the table of additional fold-equivalent code points.
    // Returns null if |name| does not identify a Unicode character range.
    static unicodeTable(name) {
        if (name === 'Any') return $ff4f66a262d5170f$var$Pair.of($ff4f66a262d5170f$var$Parser.ANY_TABLE, $ff4f66a262d5170f$var$Parser.ANY_TABLE);
        if ($ff4f66a262d5170f$var$UnicodeTables.CATEGORIES.has(name)) return $ff4f66a262d5170f$var$Pair.of($ff4f66a262d5170f$var$UnicodeTables.CATEGORIES.get(name), $ff4f66a262d5170f$var$UnicodeTables.FOLD_CATEGORIES.get(name));
        if ($ff4f66a262d5170f$var$UnicodeTables.SCRIPTS.has(name)) return $ff4f66a262d5170f$var$Pair.of($ff4f66a262d5170f$var$UnicodeTables.SCRIPTS.get(name), $ff4f66a262d5170f$var$UnicodeTables.FOLD_SCRIPT.get(name));
        return null;
    }
    // minFoldRune returns the minimum rune fold-equivalent to r.
    static minFoldRune(r) {
        if (r < $ff4f66a262d5170f$var$Unicode.MIN_FOLD || r > $ff4f66a262d5170f$var$Unicode.MAX_FOLD) return r;
        let min = r;
        const r0 = r;
        for(r = $ff4f66a262d5170f$var$Unicode.simpleFold(r); r !== r0; r = $ff4f66a262d5170f$var$Unicode.simpleFold(r))if (min > r) min = r;
        return min;
    }
    // leadingRegexp returns the leading regexp that re begins with.
    // The regexp refers to storage in re or its children.
    static leadingRegexp(re) {
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) return null;
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            const sub = re.subs[0];
            if (sub.op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) return null;
            return sub;
        }
        return re;
    }
    static literalRegexp(s, flags) {
        const re = new $ff4f66a262d5170f$var$Regexp($ff4f66a262d5170f$var$Regexp.Op.LITERAL);
        re.flags = flags;
        re.runes = $ff4f66a262d5170f$var$Utils.stringToRunes(s);
        return re;
    }
    /**
   * Parse regular expression pattern {@code pattern} with mode flags {@code flags}.
   * @param {string} pattern
   * @param {number} flags
   */ static parse(pattern, flags) {
        return new $ff4f66a262d5170f$var$Parser(pattern, flags).parseInternal();
    }
    // parseRepeat parses {min} (max=min) or {min,} (max=-1) or {min,max}.
    // If |t| is not of that form, it returns -1.
    // If |t| has the right form but the values are negative or too big,
    // it returns -2.
    // On success, returns a nonnegative number encoding min/max in the
    // high/low signed halfwords of the result.  (Note: min >= 0; max may
    // be -1.)
    //
    // On success, advances |t| beyond the repeat; otherwise |t.pos()| is
    // undefined.
    static parseRepeat(t) {
        const start = t.pos();
        if (!t.more() || !t.lookingAt('{')) return -1;
        t.skip(1);
        const min = $ff4f66a262d5170f$var$Parser.parseInt(t);
        if (min === -1) return -1;
        if (!t.more()) return -1;
        let max;
        if (!t.lookingAt(',')) max = min;
        else {
            t.skip(1);
            if (!t.more()) return -1;
            if (t.lookingAt('}')) max = -1;
            else if ((max = $ff4f66a262d5170f$var$Parser.parseInt(t)) === -1) return -1;
        }
        if (!t.more() || !t.lookingAt('}')) return -1;
        t.skip(1);
        if (min < 0 || min > 1000 || max === -2 || max > 1000 || max >= 0 && min > max) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_REPEAT_SIZE, t.from(start));
        return min << 16 | max & $ff4f66a262d5170f$var$Unicode.MAX_BMP;
    }
    // isValidCaptureName reports whether name
    // is a valid capture name: [A-Za-z0-9_]+.
    // PCRE limits names to 32 bytes.
    // Python rejects names starting with digits.
    // We don't enforce either of those.
    static isValidCaptureName(name) {
        if (name.length === 0) return false;
        for(let i = 0; i < name.length; i++){
            const c = name.codePointAt(i);
            if (c !== $ff4f66a262d5170f$var$Codepoint.CODES.get('_') && !$ff4f66a262d5170f$var$Utils.isalnum(c)) return false;
        }
        return true;
    }
    // parseInt parses a nonnegative decimal integer.
    // -1 => bad format.  -2 => format ok, but integer overflow.
    static parseInt(t) {
        const start = t.pos();
        while(t.more() && t.peek() >= $ff4f66a262d5170f$var$Codepoint.CODES.get('0') && t.peek() <= $ff4f66a262d5170f$var$Codepoint.CODES.get('9'))t.skip(1);
        const n = t.from(start);
        if (n.length === 0 || n.length > 1 && n.codePointAt(0) === $ff4f66a262d5170f$var$Codepoint.CODES.get('0')) return -1;
        if (n.length > 8) return -2;
        return parseFloat(n, 10);
    }
    // can this be represented as a character class?
    // single-rune literal string, char class, ., and .|\n.
    static isCharClass(re) {
        return re.op === $ff4f66a262d5170f$var$Regexp.Op.LITERAL && re.runes.length === 1 || re.op === $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS || re.op === $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL || re.op === $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR;
    }
    // does re match r?
    static matchRune(re, r) {
        switch(re.op){
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
                return re.runes.length === 1 && re.runes[0] === r;
            case $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS:
                for(let i = 0; i < re.runes.length; i += 2){
                    if (re.runes[i] <= r && r <= re.runes[i + 1]) return true;
                }
                return false;
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return r !== $ff4f66a262d5170f$var$Codepoint.CODES.get('\n');
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR:
                return true;
        }
        return false;
    }
    // mergeCharClass makes dst = dst|src.
    // The caller must ensure that dst.Op >= src.Op,
    // to reduce the amount of copying.
    static mergeCharClass(dst, src) {
        switch(dst.op){
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR:
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL:
                if ($ff4f66a262d5170f$var$Parser.matchRune(src, $ff4f66a262d5170f$var$Codepoint.CODES.get('\n'))) dst.op = $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS:
                if (src.op === $ff4f66a262d5170f$var$Regexp.Op.LITERAL) dst.runes = new $ff4f66a262d5170f$var$CharClass(dst.runes).appendLiteral(src.runes[0], src.flags).toArray();
                else dst.runes = new $ff4f66a262d5170f$var$CharClass(dst.runes).appendClass(src.runes).toArray();
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
                if (src.runes[0] === dst.runes[0] && src.flags === dst.flags) break;
                dst.op = $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS;
                dst.runes = new $ff4f66a262d5170f$var$CharClass().appendLiteral(dst.runes[0], dst.flags).appendLiteral(src.runes[0], src.flags).toArray();
                break;
        }
    }
    // parseEscape parses an escape sequence at the beginning of s
    // and returns the rune.
    // Pre: t at '\\'.  Post: after escape.
    static parseEscape(t) {
        const startPos = t.pos();
        t.skip(1); // '\\'
        if (!t.more()) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_TRAILING_BACKSLASH);
        let c = t.pop();
        bigswitch: switch(c){
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('1'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('2'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('3'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('4'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('5'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('6'):
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('7'):
                if (!t.more() || t.peek() < $ff4f66a262d5170f$var$Codepoint.CODES.get('0') || t.peek() > $ff4f66a262d5170f$var$Codepoint.CODES.get('7')) break;
            // eslint-disable-next-line no-fallthrough
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('0'):
                {
                    let r = c - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                    for(let i = 1; i < 3; i++){
                        if (!t.more() || t.peek() < $ff4f66a262d5170f$var$Codepoint.CODES.get('0') || t.peek() > $ff4f66a262d5170f$var$Codepoint.CODES.get('7')) break;
                        r = r * 8 + t.peek() - $ff4f66a262d5170f$var$Codepoint.CODES.get('0');
                        t.skip(1);
                    }
                    return r;
                }
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('x'):
                {
                    if (!t.more()) break;
                    c = t.pop();
                    if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('{')) {
                        let nhex = 0;
                        let r = 0;
                        while(true){
                            if (!t.more()) break bigswitch;
                            c = t.pop();
                            if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('}')) break;
                            const v = $ff4f66a262d5170f$var$Utils.unhex(c);
                            if (v < 0) break bigswitch;
                            r = r * 16 + v;
                            if (r > $ff4f66a262d5170f$var$Unicode.MAX_RUNE) break bigswitch;
                            nhex++;
                        }
                        if (nhex === 0) break bigswitch;
                        return r;
                    }
                    const x = $ff4f66a262d5170f$var$Utils.unhex(c);
                    if (!t.more()) break;
                    c = t.pop();
                    const y = $ff4f66a262d5170f$var$Utils.unhex(c);
                    if (x < 0 || y < 0) break;
                    return x * 16 + y;
                }
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('a'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\x07');
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('f'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\f');
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('n'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\n');
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('r'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\r');
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('t'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\t');
            case $ff4f66a262d5170f$var$Codepoint.CODES.get('v'):
                return $ff4f66a262d5170f$var$Codepoint.CODES.get('\v');
            default:
                if (c <= $ff4f66a262d5170f$var$Unicode.MAX_ASCII && !$ff4f66a262d5170f$var$Utils.isalnum(c)) return c;
                break;
        }
        throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_ESCAPE, t.from(startPos));
    }
    // parseClassChar parses a character class character and returns it.
    // wholeClassPos is the position of the start of the entire class "[...".
    // Pre: t at class char; Post: t after it.
    static parseClassChar(t, wholeClassPos) {
        if (!t.more()) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_MISSING_BRACKET, t.from(wholeClassPos));
        if (t.lookingAt('\\')) return $ff4f66a262d5170f$var$Parser.parseEscape(t);
        return t.pop();
    }
    static concatRunes(x, y) {
        return [
            ...x,
            ...y
        ];
    }
    constructor(wholeRegexp, flags = 0){
        this.wholeRegexp = wholeRegexp;
        // Flags control the behavior of the parser and record information about
        // regexp context.
        this.flags = flags;
        // number of capturing groups seen
        this.numCap = 0;
        this.namedGroups = {};
        // Stack of parsed expressions.
        this.stack = [];
        this.free = null;
        // checks
        this.numRegexp = 0; // number of regexps allocated
        this.numRunes = 0; // number of runes in char classes
        this.repeats = 0; // product of all repetitions seen
        this.height = null; // regexp height, for height limit check
        this.size = null; // regexp compiled size, for size limit check
    }
    // Allocate a Regexp, from the free list if possible.
    newRegexp(op) {
        let re = this.free;
        if (re !== null && re.subs !== null && re.subs.length > 0) {
            this.free = re.subs[0];
            re.reinit();
            re.op = op;
        } else {
            re = new $ff4f66a262d5170f$var$Regexp(op);
            this.numRegexp += 1;
        }
        return re;
    }
    reuse(re) {
        if (this.height !== null && Object.prototype.hasOwnProperty.call(this.height, re)) delete this.height[re];
        if (re.subs !== null && re.subs.length > 0) re.subs[0] = this.free;
        this.free = re;
    }
    checkLimits(re) {
        if (this.numRunes > $ff4f66a262d5170f$var$Parser.MAX_RUNES) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_LARGE);
        this.checkSize(re);
        this.checkHeight(re);
    }
    checkSize(re) {
        if (this.size === null) {
            // We haven't started tracking size yet.
            // Do a relatively cheap check to see if we need to start.
            // Maintain the product of all the repeats we've seen
            // and don't track if the total number of regexp nodes
            // we've seen times the repeat product is in budget.
            if (this.repeats === 0) this.repeats = 1;
            if (re.op === $ff4f66a262d5170f$var$Regexp.Op.REPEAT) {
                let n = re.max;
                if (n === -1) n = re.min;
                if (n <= 0) n = 1;
                if (n > $ff4f66a262d5170f$var$Parser.MAX_SIZE / this.repeats) this.repeats = $ff4f66a262d5170f$var$Parser.MAX_SIZE;
                else this.repeats *= n;
            }
            if (this.numRegexp < $ff4f66a262d5170f$var$Parser.MAX_SIZE / this.repeats) return;
            // We need to start tracking size.
            // Make the map and belatedly populate it
            // with info about everything we've constructed so far.
            this.size = {};
            for (let reEx of this.stack)this.checkSize(reEx);
        }
        if (this.calcSize(re, true) > $ff4f66a262d5170f$var$Parser.MAX_SIZE) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_LARGE);
    }
    calcSize(re, force = false) {
        if (!force) {
            if (Object.prototype.hasOwnProperty.call(this.size, re)) return this.size[re];
        }
        let size = 0;
        switch(re.op){
            case $ff4f66a262d5170f$var$Regexp.Op.LITERAL:
                size = re.runes.length;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CAPTURE:
            case $ff4f66a262d5170f$var$Regexp.Op.STAR:
                // star can be 1+ or 2+; assume 2 pessimistically
                size = 2 + this.calcSize(re.subs[0]);
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.PLUS:
            case $ff4f66a262d5170f$var$Regexp.Op.QUEST:
                size = 1 + this.calcSize(re.subs[0]);
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.CONCAT:
                for (let sub of re.subs)size = size + this.calcSize(sub);
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE:
                for (let sub of re.subs)size = size + this.calcSize(sub);
                if (re.subs.length > 1) size = size + re.subs.length - 1;
                break;
            case $ff4f66a262d5170f$var$Regexp.Op.REPEAT:
                {
                    let sub = this.calcSize(re.subs[0]);
                    if (re.max === -1) {
                        if (re.min === 0) size = 2 + sub; // x*
                        else size = 1 + re.min * sub; // xxx+
                        break;
                    }
                    // x{2,5} = xx(x(x(x)?)?)?
                    size = re.max * sub + (re.max - re.min);
                    break;
                }
        }
        size = Math.max(1, size);
        this.size[re] = size;
        return size;
    }
    checkHeight(re) {
        if (this.numRegexp < $ff4f66a262d5170f$var$Parser.MAX_HEIGHT) return;
        if (this.height === null) {
            this.height = {};
            for (let reEx of this.stack)this.checkHeight(reEx);
        }
        if (this.calcHeight(re, true) > $ff4f66a262d5170f$var$Parser.MAX_HEIGHT) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_NESTING_DEPTH);
    }
    calcHeight(re, force = false) {
        if (!force) {
            if (Object.prototype.hasOwnProperty.call(this.height, re)) return this.height[re];
        }
        let h = 1;
        for (let sub of re.subs){
            const hsub = this.calcHeight(sub);
            if (h < 1 + hsub) h = 1 + hsub;
        }
        this.height[re] = h;
        return h;
    }
    // Parse stack manipulation.
    pop() {
        return this.stack.pop();
    }
    popToPseudo() {
        const n = this.stack.length;
        let i = n;
        while(i > 0 && !$ff4f66a262d5170f$var$Regexp.isPseudoOp(this.stack[i - 1].op))i--;
        const r = this.stack.slice(i, n);
        this.stack = this.stack.slice(0, i);
        return r;
    }
    // push pushes the regexp re onto the parse stack and returns the regexp.
    // Returns null for a CHAR_CLASS that can be merged with the top-of-stack.
    push(re) {
        this.numRunes += re.runes.length;
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] === re.runes[1]) {
            if (this.maybeConcat(re.runes[0], this.flags & -2)) return null;
            re.op = $ff4f66a262d5170f$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags & -2;
        } else if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS && re.runes.length === 4 && re.runes[0] === re.runes[1] && re.runes[2] === re.runes[3] && $ff4f66a262d5170f$var$Unicode.simpleFold(re.runes[0]) === re.runes[2] && $ff4f66a262d5170f$var$Unicode.simpleFold(re.runes[2]) === re.runes[0] || re.op === $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] + 1 === re.runes[1] && $ff4f66a262d5170f$var$Unicode.simpleFold(re.runes[0]) === re.runes[1] && $ff4f66a262d5170f$var$Unicode.simpleFold(re.runes[1]) === re.runes[0]) {
            // Case-insensitive rune like [Aa] or [Δδ].
            if (this.maybeConcat(re.runes[0], this.flags | $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE)) return null;
            // Rewrite as (case-insensitive) literal.
            re.op = $ff4f66a262d5170f$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags | $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE;
        } else // Incremental concatenation.
        this.maybeConcat(-1, 0);
        this.stack.push(re);
        this.checkLimits(re);
        return re;
    }
    // maybeConcat implements incremental concatenation
    // of literal runes into string nodes.  The parser calls this
    // before each push, so only the top fragment of the stack
    // might need processing.  Since this is called before a push,
    // the topmost literal is no longer subject to operators like *
    // (Otherwise ab* would turn into (ab)*.)
    // If (r >= 0 and there's a node left over, maybeConcat uses it
    // to push r with the given flags.
    // maybeConcat reports whether r was pushed.
    maybeConcat(r, flags) {
        const n = this.stack.length;
        if (n < 2) return false;
        const re1 = this.stack[n - 1];
        const re2 = this.stack[n - 2];
        if (re1.op !== $ff4f66a262d5170f$var$Regexp.Op.LITERAL || re2.op !== $ff4f66a262d5170f$var$Regexp.Op.LITERAL || (re1.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== (re2.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE)) return false;
        // Push re1 into re2.
        re2.runes = $ff4f66a262d5170f$var$Parser.concatRunes(re2.runes, re1.runes);
        // Reuse re1 if possible.
        if (r >= 0) {
            re1.runes = [
                r
            ];
            re1.flags = flags;
            return true;
        }
        this.pop();
        this.reuse(re1);
        return false; // did not push r
    }
    // newLiteral returns a new LITERAL Regexp with the given flags
    newLiteral(r, flags) {
        const re = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.LITERAL);
        re.flags = flags;
        if ((flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0) r = $ff4f66a262d5170f$var$Parser.minFoldRune(r);
        re.runes = [
            r
        ];
        return re;
    }
    // literal pushes a literal regexp for the rune r on the stack
    // and returns that regexp.
    literal(r) {
        this.push(this.newLiteral(r, this.flags));
    }
    // op pushes a regexp with the given op onto the stack
    // and returns that regexp.
    op(op) {
        const re = this.newRegexp(op);
        re.flags = this.flags;
        return this.push(re);
    }
    // repeat replaces the top stack element with itself repeated according to
    // op, min, max.  beforePos is the start position of the repetition operator.
    // Pre: t is positioned after the initial repetition operator.
    // Post: t advances past an optional perl-mode '?', or stays put.
    //       Or, it fails with RE2JSSyntaxException.
    repeat(op, min, max, beforePos, t, lastRepeatPos) {
        let flags = this.flags;
        if ((flags & $ff4f66a262d5170f$var$RE2Flags.PERL_X) !== 0) {
            if (t.more() && t.lookingAt('?')) {
                t.skip(1);
                flags ^= $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY;
            }
            if (lastRepeatPos !== -1) // In Perl it is not allowed to stack repetition operators:
            // a** is a syntax error, not a doubled star, and a++ means
            // something else entirely, which we don't support!
            throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_REPEAT_OP, t.from(lastRepeatPos));
        }
        const n = this.stack.length;
        if (n === 0) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const sub = this.stack[n - 1];
        if ($ff4f66a262d5170f$var$Regexp.isPseudoOp(sub.op)) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const re = this.newRegexp(op);
        re.min = min;
        re.max = max;
        re.flags = flags;
        re.subs = [
            sub
        ];
        this.stack[n - 1] = re;
        this.checkLimits(re);
        if (op === $ff4f66a262d5170f$var$Regexp.Op.REPEAT && (min >= 2 || max >= 2) && !this.repeatIsValid(re, 1000)) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_REPEAT_SIZE, t.from(beforePos));
    }
    // repeatIsValid reports whether the repetition re is valid.
    // Valid means that the combination of the top-level repetition
    // and any inner repetitions does not exceed n copies of the
    // innermost thing.
    // This function rewalks the regexp tree and is called for every repetition,
    // so we have to worry about inducing quadratic behavior in the parser.
    // We avoid this by only calling repeatIsValid when min or max >= 2.
    // In that case the depth of any >= 2 nesting can only get to 9 without
    // triggering a parse error, so each subtree can only be rewalked 9 times.
    repeatIsValid(re, n) {
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.REPEAT) {
            let m = re.max;
            if (m === 0) return true;
            if (m < 0) m = re.min;
            if (m > n) return false;
            if (m > 0) n = Math.trunc(n / m);
        }
        for (let sub of re.subs){
            if (!this.repeatIsValid(sub, n)) return false;
        }
        return true;
    }
    // concat replaces the top of the stack (above the topmost '|' or '(') with
    // its concatenation.
    concat() {
        this.maybeConcat(-1, 0);
        const subs = this.popToPseudo();
        if (subs.length === 0) return this.push(this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH));
        return this.push(this.collapse(subs, $ff4f66a262d5170f$var$Regexp.Op.CONCAT));
    }
    // alternate replaces the top of the stack (above the topmost '(') with its
    // alternation.
    alternate() {
        // Scan down to find pseudo-operator (.
        // There are no | above (.
        const subs = this.popToPseudo();
        // Make sure top class is clean.
        // All the others already are (see swapVerticalBar).
        if (subs.length > 0) this.cleanAlt(subs[subs.length - 1]);
        // Empty alternate is special case
        // (shouldn't happen but easy to handle).
        if (subs.length === 0) return this.push(this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.NO_MATCH));
        return this.push(this.collapse(subs, $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE));
    }
    // cleanAlt cleans re for eventual inclusion in an alternation.
    cleanAlt(re) {
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS) {
            re.runes = new $ff4f66a262d5170f$var$CharClass(re.runes).cleanClass().toArray();
            if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $ff4f66a262d5170f$var$Unicode.MAX_RUNE) {
                re.runes = [];
                re.op = $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR;
            } else if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') - 1 && re.runes[2] === $ff4f66a262d5170f$var$Codepoint.CODES.get('\n') + 1 && re.runes[3] === $ff4f66a262d5170f$var$Unicode.MAX_RUNE) {
                re.runes = [];
                re.op = $ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL;
            }
        }
    }
    // collapse returns the result of applying op to subs[start:end].
    // If (sub contains op nodes, they all get hoisted up
    // so that there is never a concat of a concat or an
    // alternate of an alternate.
    collapse(subs, op) {
        if (subs.length === 1) return subs[0];
        // Concatenate subs iff op is same.
        // Compute length in first pass.
        let len = 0;
        for (let sub of subs)len += sub.op === op ? sub.subs.length : 1;
        let newsubs = new Array(len).fill(null);
        let i = 0;
        for (let sub of subs)if (sub.op === op) {
            newsubs.splice(i, sub.subs.length, ...sub.subs);
            i += sub.subs.length;
            this.reuse(sub);
        } else newsubs[i++] = sub;
        let re = this.newRegexp(op);
        re.subs = newsubs;
        if (op === $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE) {
            // re.subs = this.factor(re.subs, re.flags)
            re.subs = this.factor(re.subs);
            if (re.subs.length === 1) {
                const old = re;
                re = re.subs[0];
                this.reuse(old);
            }
        }
        return re;
    }
    // factor factors common prefixes from the alternation list sub.  It
    // returns a replacement list that reuses the same storage and frees
    // (passes to p.reuse) any removed *Regexps.
    //
    // For example,
    //     ABC|ABD|AEF|BCX|BCY
    // simplifies by literal prefix extraction to
    //     A(B(C|D)|EF)|BC(X|Y)
    // which simplifies by character class introduction to
    //     A(B[CD]|EF)|BC[XY]
    //
    factor(array) {
        if (array.length < 2) return array;
        // The following code is subtle, because it's a literal JS
        // translation of code that makes clever use of Go "slices".
        // A slice is a triple (array, offset, length), and the Go
        // implementation uses two slices, |sub| and |out| backed by the
        // same array.  In JS, we have to be explicit about all of these
        // variables, so:
        //
        // Go    JS
        // sub   (array, s, lensub)
        // out   (array, 0, lenout)   // (always a prefix of |array|)
        //
        // In the comments we'll use the logical notation of go slices, e.g. sub[i]
        // even though the JS code will read array[s + i].
        let s = 0; // offset of first |sub| within array.
        let lensub = array.length; // = len(sub)
        let lenout = 0; // = len(out)
        // Round 1: Factor out common literal prefixes.
        // Note: (str, strlen) and (istr, istrlen) are like Go slices
        // onto a prefix of some Regexp's runes array (hence offset=0).
        let str = null;
        let strlen = 0;
        let strflags = 0;
        let start = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (len <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin
            // with str as modified by strflags.
            let istr = null;
            let istrlen = 0;
            let iflags = 0;
            if (i < lensub) {
                // NB, we inlined Go's leadingString() since Java has no pair return.
                let re = array[s + i];
                if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CONCAT && re.subs.length > 0) re = re.subs[0];
                if (re.op === $ff4f66a262d5170f$var$Regexp.Op.LITERAL) {
                    istr = re.runes;
                    istrlen = re.runes.length;
                    iflags = re.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE;
                }
                // istr is the leading literal string that re begins with.
                // The string refers to storage in re or its children.
                if (iflags === strflags) {
                    let same = 0;
                    while(same < strlen && same < istrlen && str[same] === istr[same])same++;
                    if (same > 0) {
                        // Matches at least one rune in current range.
                        // Keep going around.
                        strlen = same;
                        continue;
                    }
                }
            }
            // Found end of a run with common leading literal string:
            // sub[start:i] all begin with str[0:strlen], but sub[i]
            // does not even begin with str[0].
            //
            // Factor out common string and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.LITERAL);
                prefix.flags = strflags;
                prefix.runes = str.slice(0, strlen);
                for(let j = start; j < i; j++){
                    array[s + j] = this.removeLeadingString(array[s + j], strlen);
                    this.checkLimits(array[s + j]);
                }
                // Recurse.
                const suffix = this.collapse(array.slice(s + start, s + i), $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            str = istr;
            strlen = istrlen;
            strflags = iflags;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 2: Factor out common complex prefixes,
        // just the first piece of each concatenation,
        // whatever it is.  This is good enough a lot of the time.
        start = 0;
        lenout = 0;
        let first = null;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin with
            // ifirst.
            let ifirst = null;
            if (i < lensub) {
                ifirst = $ff4f66a262d5170f$var$Parser.leadingRegexp(array[s + i]);
                if (first !== null && first.equals(ifirst) && ($ff4f66a262d5170f$var$Parser.isCharClass(first) || first.op === $ff4f66a262d5170f$var$Regexp.Op.REPEAT && first.min === first.max && $ff4f66a262d5170f$var$Parser.isCharClass(first.subs[0]))) continue;
            }
            // Found end of a run with common leading regexp:
            // sub[start:i] all begin with first but sub[i] does not.
            //
            // Factor out common regexp and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = first;
                for(let j = start; j < i; j++){
                    const reuse = j !== start; // prefix came from sub[start]
                    array[s + j] = this.removeLeadingRegexp(array[s + j], reuse);
                    this.checkLimits(array[s + j]);
                }
                // recurse
                const suffix = this.collapse(array.slice(s + start, s + i), $ff4f66a262d5170f$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            first = ifirst;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 3: Collapse runs of single literals into character classes.
        start = 0;
        lenout = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that are either
            // literal runes or character classes.
            if (i < lensub && $ff4f66a262d5170f$var$Parser.isCharClass(array[s + i])) continue;
            // sub[i] is not a char or char class;
            // emit char class for sub[start:i]...
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Make new char class.
                // Start with most complex regexp in sub[start].
                let max = start;
                for(let j = start + 1; j < i; j++){
                    const subMax = array[s + max];
                    const subJ = array[s + j];
                    if (subMax.op < subJ.op || subMax.op === subJ.op && (subMax.runes !== null ? subMax.runes.length : 0) < (subJ.runes !== null ? subJ.runes.length : 0)) max = j;
                }
                // swap sub[start], sub[max].
                const tmp = array[s + start];
                array[s + start] = array[s + max];
                array[s + max] = tmp;
                for(let j = start + 1; j < i; j++){
                    $ff4f66a262d5170f$var$Parser.mergeCharClass(array[s + start], array[s + j]);
                    this.reuse(array[s + j]);
                }
                this.cleanAlt(array[s + start]);
                array[lenout++] = array[s + start];
            }
            // ... and then emit sub[i].
            if (i < lensub) array[lenout++] = array[s + i];
            start = i + 1;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 4: Collapse runs of empty matches into a single empty match.
        start = 0;
        lenout = 0;
        for(let i = 0; i < lensub; ++i){
            if (i + 1 < lensub && array[s + i].op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH && array[s + i + 1].op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) continue;
            array[lenout++] = array[s + i];
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        return array.slice(s, lensub);
    }
    // removeLeadingString removes the first n leading runes
    // from the beginning of re.  It returns the replacement for re.
    removeLeadingString(re, n) {
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            // Removing a leading string in a concatenation
            // might simplify the concatenation.
            const sub = this.removeLeadingString(re.subs[0], n);
            re.subs[0] = sub;
            if (sub.op === $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH) {
                this.reuse(sub);
                switch(re.subs.length){
                    case 0:
                    case 1:
                        // Impossible but handle.
                        re.op = $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH;
                        re.subs = null;
                        break;
                    case 2:
                        {
                            const old = re;
                            re = re.subs[1];
                            this.reuse(old);
                            break;
                        }
                    default:
                        re.subs = re.subs.slice(1, re.subs.length);
                        break;
                }
            }
            return re;
        }
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.LITERAL) {
            re.runes = re.runes.slice(n, re.runes.length);
            if (re.runes.length === 0) re.op = $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH;
        }
        return re;
    }
    // removeLeadingRegexp removes the leading regexp in re.
    // It returns the replacement for re.
    // If reuse is true, it passes the removed regexp (if no longer needed) to
    // reuse.
    removeLeadingRegexp(re, reuse) {
        if (re.op === $ff4f66a262d5170f$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            if (reuse) this.reuse(re.subs[0]);
            re.subs = re.subs.slice(1, re.subs.length);
            switch(re.subs.length){
                case 0:
                    re.op = $ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH;
                    re.subs = $ff4f66a262d5170f$var$Regexp.emptySubs();
                    break;
                case 1:
                    {
                        const old = re;
                        re = re.subs[0];
                        this.reuse(old);
                        break;
                    }
            }
            return re;
        }
        if (reuse) this.reuse(re);
        return this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.EMPTY_MATCH);
    }
    parseInternal() {
        if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.LITERAL) !== 0) // Trivial parser for literal string.
        return $ff4f66a262d5170f$var$Parser.literalRegexp(this.wholeRegexp, this.flags);
        // Otherwise, must do real work.
        let lastRepeatPos = -1;
        let min = -1;
        let max = -1;
        const t = new $ff4f66a262d5170f$var$StringIterator(this.wholeRegexp);
        while(t.more()){
            let repeatPos = -1;
            bigswitch: switch(t.peek()){
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('('):
                    if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.PERL_X) !== 0 && t.lookingAt('(?')) {
                        // Flag changes and non-capturing groups.
                        this.parsePerlFlags(t);
                        break;
                    }
                    this.op($ff4f66a262d5170f$var$Regexp.Op.LEFT_PAREN).cap = ++this.numCap;
                    t.skip(1); // '('
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('|'):
                    this.parseVerticalBar(); // '|'
                    t.skip(1); // '|'
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get(')'):
                    this.parseRightParen();
                    t.skip(1); // ')'
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('^'):
                    if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.ONE_LINE) !== 0) this.op($ff4f66a262d5170f$var$Regexp.Op.BEGIN_TEXT);
                    else this.op($ff4f66a262d5170f$var$Regexp.Op.BEGIN_LINE);
                    t.skip(1); // '^'
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('$'):
                    if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.ONE_LINE) !== 0) this.op($ff4f66a262d5170f$var$Regexp.Op.END_TEXT).flags |= $ff4f66a262d5170f$var$RE2Flags.WAS_DOLLAR;
                    else this.op($ff4f66a262d5170f$var$Regexp.Op.END_LINE);
                    t.skip(1); // '$'
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('.'):
                    if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.DOT_NL) !== 0) this.op($ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR);
                    else this.op($ff4f66a262d5170f$var$Regexp.Op.ANY_CHAR_NOT_NL);
                    t.skip(1); // '.'
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('['):
                    this.parseClass(t);
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('*'):
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('+'):
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('?'):
                    {
                        repeatPos = t.pos();
                        let op = null;
                        switch(t.pop()){
                            case $ff4f66a262d5170f$var$Codepoint.CODES.get('*'):
                                op = $ff4f66a262d5170f$var$Regexp.Op.STAR;
                                break;
                            case $ff4f66a262d5170f$var$Codepoint.CODES.get('+'):
                                op = $ff4f66a262d5170f$var$Regexp.Op.PLUS;
                                break;
                            case $ff4f66a262d5170f$var$Codepoint.CODES.get('?'):
                                op = $ff4f66a262d5170f$var$Regexp.Op.QUEST;
                                break;
                        }
                        this.repeat(op, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('{'):
                    {
                        repeatPos = t.pos();
                        const minMax = $ff4f66a262d5170f$var$Parser.parseRepeat(t);
                        if (minMax < 0) {
                            // If the repeat cannot be parsed, { is a literal.
                            t.rewindTo(repeatPos);
                            this.literal(t.pop()); // '{'
                            break;
                        }
                        min = minMax >> 16;
                        max = (minMax & $ff4f66a262d5170f$var$Unicode.MAX_BMP) << 16 >> 16;
                        this.repeat($ff4f66a262d5170f$var$Regexp.Op.REPEAT, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('\\'):
                    {
                        const savedPos = t.pos();
                        t.skip(1); // '\\'
                        if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.PERL_X) !== 0 && t.more()) {
                            const c = t.pop();
                            switch(c){
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('A'):
                                    this.op($ff4f66a262d5170f$var$Regexp.Op.BEGIN_TEXT);
                                    break bigswitch;
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('b'):
                                    this.op($ff4f66a262d5170f$var$Regexp.Op.WORD_BOUNDARY);
                                    break bigswitch;
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('B'):
                                    this.op($ff4f66a262d5170f$var$Regexp.Op.NO_WORD_BOUNDARY);
                                    break bigswitch;
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('C'):
                                    // any byte; not supported
                                    throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_ESCAPE, '\\C');
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('Q'):
                                    {
                                        // \Q ... \E: the ... is always literals
                                        let lit = t.rest();
                                        const i = lit.indexOf('\\E');
                                        if (i >= 0) lit = lit.substring(0, i);
                                        t.skipString(lit);
                                        t.skipString('\\E');
                                        let j = 0;
                                        while(j < lit.length){
                                            const codepoint = lit.codePointAt(j);
                                            this.literal(codepoint);
                                            j += $ff4f66a262d5170f$var$Utils.charCount(codepoint);
                                        }
                                        break bigswitch;
                                    }
                                case $ff4f66a262d5170f$var$Codepoint.CODES.get('z'):
                                    this.op($ff4f66a262d5170f$var$Regexp.Op.END_TEXT);
                                    break bigswitch;
                                default:
                                    t.rewindTo(savedPos);
                                    break;
                            }
                        }
                        const re = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS);
                        re.flags = this.flags;
                        // Look for Unicode character group like \p{Han}
                        if (t.lookingAt('\\p') || t.lookingAt('\\P')) {
                            const cc = new $ff4f66a262d5170f$var$CharClass();
                            if (this.parseUnicodeClass(t, cc)) {
                                re.runes = cc.toArray();
                                this.push(re);
                                break bigswitch;
                            }
                        }
                        // Perl character class escape.
                        const cc = new $ff4f66a262d5170f$var$CharClass();
                        if (this.parsePerlClassEscape(t, cc)) {
                            re.runes = cc.toArray();
                            this.push(re);
                            break bigswitch;
                        }
                        t.rewindTo(savedPos);
                        this.reuse(re);
                        // Ordinary single-character escape.
                        this.literal($ff4f66a262d5170f$var$Parser.parseEscape(t));
                        break;
                    }
                default:
                    this.literal(t.pop());
                    break;
            }
            lastRepeatPos = repeatPos;
        }
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n !== 1) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        this.stack[0].namedGroups = this.namedGroups;
        return this.stack[0];
    }
    // parsePerlFlags parses a Perl flag setting or non-capturing group or both,
    // like (?i) or (?: or (?i:.
    // Pre: t at "(?".  Post: t after ")".
    // Sets numCap.
    parsePerlFlags(t) {
        const startPos = t.pos();
        // Check for named captures, first introduced in Python's regexp library.
        // As usual, there are three slightly different syntaxes:
        //
        //   (?P<name>expr)   the original, introduced by Python
        //   (?<name>expr)    the .NET alteration, adopted by Perl 5.10
        //   (?'name'expr)    another .NET alteration, adopted by Perl 5.10
        //
        // Perl 5.10 gave in and implemented the Python version too,
        // but they claim that the last two are the preferred forms.
        // PCRE and languages based on it (specifically, PHP and Ruby)
        // support all three as well.  EcmaScript 4 uses only the Python form.
        //
        // In both the open source world (via Code Search) and the
        // Google source tree, (?P<name>expr) and (?<name>expr) are the
        // dominant forms of named captures and both are supported.
        const s = t.rest();
        if (s.startsWith('(?P<') || s.startsWith('(?<')) {
            // Pull out name.
            const begin = s.charAt(2) === 'P' ? 4 : 3;
            const end = s.indexOf('>');
            if (end < 0) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_NAMED_CAPTURE, s);
            const name = s.substring(begin, end); // "name"
            t.skipString(name);
            t.skip(begin + 1); // "(?P<>" or "(?<>"
            if (!$ff4f66a262d5170f$var$Parser.isValidCaptureName(name)) // "(?P<name>"
            throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_NAMED_CAPTURE, s.substring(0, end + 1)); // "(?P<name>" or "(?<name>"
            // Like ordinary capture, but named.
            const re = this.op($ff4f66a262d5170f$var$Regexp.Op.LEFT_PAREN);
            re.cap = ++this.numCap;
            if (this.namedGroups[name]) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_DUPLICATE_NAMED_CAPTURE, name);
            this.namedGroups[name] = this.numCap;
            re.name = name;
            return;
        }
        // Non-capturing group.  Might also twiddle Perl flags.
        t.skip(2); // "(?"
        let flags = this.flags;
        let sign = 1;
        let sawFlag = false;
        loop: while(t.more()){
            const c = t.pop();
            switch(c){
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('i'):
                    flags |= $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE;
                    sawFlag = true;
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('m'):
                    flags &= -17;
                    sawFlag = true;
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('s'):
                    flags |= $ff4f66a262d5170f$var$RE2Flags.DOT_NL;
                    sawFlag = true;
                    break;
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('U'):
                    flags |= $ff4f66a262d5170f$var$RE2Flags.NON_GREEDY;
                    sawFlag = true;
                    break;
                // Switch to negation.
                case $ff4f66a262d5170f$var$Codepoint.CODES.get('-'):
                    if (sign < 0) break loop;
                    sign = -1;
                    // Invert flags so that | above turn into &~ and vice versa.
                    // We'll invert flags again before using it below.
                    flags = ~flags;
                    sawFlag = false;
                    break;
                // End of flags, starting group or not.
                case $ff4f66a262d5170f$var$Codepoint.CODES.get(':'):
                case $ff4f66a262d5170f$var$Codepoint.CODES.get(')'):
                    if (sign < 0) {
                        if (!sawFlag) break loop;
                        flags = ~flags;
                    }
                    if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get(':')) // Open new group
                    this.op($ff4f66a262d5170f$var$Regexp.Op.LEFT_PAREN);
                    this.flags = flags;
                    return;
                default:
                    break loop;
            }
        }
        throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_PERL_OP, t.from(startPos));
    }
    // parseVerticalBar handles a | in the input.
    parseVerticalBar() {
        this.concat();
        // The concatenation we just parsed is on top of the stack.
        // If it sits above an opVerticalBar, swap it below
        // (things below an opVerticalBar become an alternation).
        // Otherwise, push a new vertical bar.
        if (!this.swapVerticalBar()) this.op($ff4f66a262d5170f$var$Regexp.Op.VERTICAL_BAR);
    }
    // If the top of the stack is an element followed by an opVerticalBar
    // swapVerticalBar swaps the two and returns true.
    // Otherwise it returns false.
    swapVerticalBar() {
        const n = this.stack.length;
        // If above and below vertical bar are literal or char class,
        // can merge into a single char class.
        if (n >= 3 && this.stack[n - 2].op === $ff4f66a262d5170f$var$Regexp.Op.VERTICAL_BAR && $ff4f66a262d5170f$var$Parser.isCharClass(this.stack[n - 1]) && $ff4f66a262d5170f$var$Parser.isCharClass(this.stack[n - 3])) {
            let re1 = this.stack[n - 1];
            let re3 = this.stack[n - 3];
            // Make re3 the more complex of the two.
            if (re1.op > re3.op) {
                const tmp = re3;
                re3 = re1;
                re1 = tmp;
                this.stack[n - 3] = re3;
            }
            $ff4f66a262d5170f$var$Parser.mergeCharClass(re3, re1);
            this.reuse(re1);
            this.pop();
            return true;
        }
        if (n >= 2) {
            const re1 = this.stack[n - 1];
            const re2 = this.stack[n - 2];
            if (re2.op === $ff4f66a262d5170f$var$Regexp.Op.VERTICAL_BAR) {
                if (n >= 3) // Now out of reach.
                // Clean opportunistically.
                this.cleanAlt(this.stack[n - 3]);
                this.stack[n - 2] = re1;
                this.stack[n - 1] = re2;
                return true;
            }
        }
        return false;
    }
    // parseRightParen handles a ')' in the input.
    parseRightParen() {
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n < 2) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        const re1 = this.pop();
        const re2 = this.pop();
        if (re2.op !== $ff4f66a262d5170f$var$Regexp.Op.LEFT_PAREN) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        // Restore flags at time of paren.
        this.flags = re2.flags;
        if (re2.cap === 0) // Just for grouping.
        this.push(re1);
        else {
            re2.op = $ff4f66a262d5170f$var$Regexp.Op.CAPTURE;
            re2.subs = [
                re1
            ];
            this.push(re2);
        }
    }
    // parsePerlClassEscape parses a leading Perl character class escape like \d
    // from the beginning of |t|.  If one is present, it appends the characters
    // to cc and returns true.  The iterator is advanced past the escape
    // on success, undefined on failure, in which case false is returned.
    parsePerlClassEscape(t, cc) {
        const beforePos = t.pos();
        if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.PERL_X) === 0 || !t.more() || t.pop() !== $ff4f66a262d5170f$var$Codepoint.CODES.get('\\') || !t.more()) return false;
        t.pop(); // e.g. advance past 'd' in "\\d"
        const p = t.from(beforePos);
        const g = $ff4f66a262d5170f$var$PERL_GROUPS.has(p) ? $ff4f66a262d5170f$var$PERL_GROUPS.get(p) : null;
        if (g === null) return false;
        cc.appendGroup(g, (this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseNamedClass parses a leading POSIX named character class like
    // [:alnum:] from the beginning of t.  If one is present, it appends the
    // characters to cc, advances the iterator, and returns true.
    // Pre: t at "[:".  Post: t after ":]".
    // On failure (no class of than name), throws RE2JSSyntaxException.
    // On misparse, returns false; t.pos() is undefined.
    parseNamedClass(t, cc) {
        // (Go precondition check deleted.)
        const cls = t.rest();
        const i = cls.indexOf(':]');
        if (i < 0) return false;
        const name = cls.substring(0, i + 2); // "[:alnum:]"
        t.skipString(name);
        const g = $ff4f66a262d5170f$var$POSIX_GROUPS.has(name) ? $ff4f66a262d5170f$var$POSIX_GROUPS.get(name) : null;
        if (g === null) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, name);
        cc.appendGroup(g, (this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseUnicodeClass() parses a leading Unicode character class like \p{Han}
    // from the beginning of t.  If one is present, it appends the characters to
    // to |cc|, advances |t| and returns true.
    //
    // Returns false if such a pattern is not present or UNICODE_GROUPS
    // flag is not enabled; |t.pos()| is not advanced in this case.
    // Indicates error by throwing RE2JSSyntaxException.
    parseUnicodeClass(t, cc) {
        const startPos = t.pos();
        if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.UNICODE_GROUPS) === 0 || !t.lookingAt('\\p') && !t.lookingAt('\\P')) return false;
        t.skip(1); // '\\'
        // Committed to parse or throw exception.
        let sign = 1;
        let c = t.pop(); // 'p' or 'P'
        if (c === $ff4f66a262d5170f$var$Codepoint.CODES.get('P')) sign = -1;
        if (!t.more()) {
            t.rewindTo(startPos);
            throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
        }
        c = t.pop();
        let name;
        if (c !== $ff4f66a262d5170f$var$Codepoint.CODES.get('{')) // Single-letter name.
        name = $ff4f66a262d5170f$var$Utils.runeToString(c);
        else {
            // Name is in braces.
            const rest = t.rest();
            const end = rest.indexOf('}');
            if (end < 0) {
                t.rewindTo(startPos);
                throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
            }
            name = rest.substring(0, end); // e.g. "Han"
            t.skipString(name);
            t.skip(1);
        // Don't use skip(end) because it assumes UTF-16 coding, and
        // StringIterator doesn't guarantee that.
        }
        // Group can have leading negation too.
        //  \p{^Han} == \P{Han}, \P{^Han} == \p{Han}.
        if (!(name.length === 0) && name.codePointAt(0) === $ff4f66a262d5170f$var$Codepoint.CODES.get('^')) {
            sign = 0 - sign; // -sign
            name = name.substring(1);
        }
        const pair = $ff4f66a262d5170f$var$Parser.unicodeTable(name);
        if (pair === null) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, t.from(startPos));
        const tab = pair.first;
        const fold = pair.second; // fold-equivalent table
        // Variation of CharClass.appendGroup() for tables.
        if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) === 0 || fold === null) cc.appendTableWithSign(tab, sign);
        else {
            // Merge and clean tab and fold in a temporary buffer.
            // This is necessary for the negative case and just tidy
            // for the positive case.
            const tmp = new $ff4f66a262d5170f$var$CharClass().appendTable(tab).appendTable(fold).cleanClass().toArray();
            cc.appendClassWithSign(tmp, sign);
        }
        return true;
    }
    // parseClass parses a character class and pushes it onto the parse stack.
    //
    // NOTES:
    // Pre: at '['; Post: after ']'.
    // Mutates stack.  Advances iterator.  May throw.
    parseClass(t) {
        const startPos = t.pos();
        t.skip(1); // '['
        const re = this.newRegexp($ff4f66a262d5170f$var$Regexp.Op.CHAR_CLASS);
        re.flags = this.flags;
        const cc = new $ff4f66a262d5170f$var$CharClass();
        let sign = 1;
        if (t.more() && t.lookingAt('^')) {
            sign = -1;
            t.skip(1); // '^'
            // If character class does not match \n, add it here,
            // so that negation later will do the right thing.
            if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.CLASS_NL) === 0) cc.appendRange($ff4f66a262d5170f$var$Codepoint.CODES.get('\n'), $ff4f66a262d5170f$var$Codepoint.CODES.get('\n'));
        }
        let first = true; // ']' and '-' are okay as first char in class
        while(!t.more() || t.peek() !== $ff4f66a262d5170f$var$Codepoint.CODES.get(']') || first){
            // POSIX: - is only okay unescaped as first or last in class.
            // Perl: - is okay anywhere.
            if (t.more() && t.lookingAt('-') && (this.flags & $ff4f66a262d5170f$var$RE2Flags.PERL_X) === 0 && !first) {
                const s = t.rest();
                if (s === '-' || !s.startsWith('-]')) {
                    t.rewindTo(startPos);
                    throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                }
            }
            first = false;
            const beforePos = t.pos();
            // Look for POSIX [:alnum:] etc.
            if (t.lookingAt('[:')) {
                if (this.parseNamedClass(t, cc)) continue;
                t.rewindTo(beforePos);
            }
            // Look for Unicode character group like \p{Han}.
            if (this.parseUnicodeClass(t, cc)) continue;
            // Look for Perl character class symbols (extension).
            if (this.parsePerlClassEscape(t, cc)) continue;
            t.rewindTo(beforePos);
            // Single character or simple range.
            const lo = $ff4f66a262d5170f$var$Parser.parseClassChar(t, startPos);
            let hi = lo;
            if (t.more() && t.lookingAt('-')) {
                t.skip(1);
                if (t.more() && t.lookingAt(']')) // [a-] means (a|-) so check for final ].
                t.skip(-1);
                else {
                    hi = $ff4f66a262d5170f$var$Parser.parseClassChar(t, startPos);
                    if (hi < lo) throw new $ff4f66a262d5170f$export$9c12d0c1e9bff151($ff4f66a262d5170f$var$Parser.ERR_INVALID_CHAR_RANGE, t.from(beforePos));
                }
            }
            if ((this.flags & $ff4f66a262d5170f$var$RE2Flags.FOLD_CASE) === 0) cc.appendRange(lo, hi);
            else cc.appendFoldedRange(lo, hi);
        }
        t.skip(1); // ']'
        cc.cleanClass();
        if (sign < 0) cc.negateClass();
        re.runes = cc.toArray();
        this.push(re);
    }
}
class $ff4f66a262d5170f$var$AtomicReference {
    constructor(initialValue){
        this.value = initialValue;
    }
    // Returns the current value
    get() {
        return this.value;
    }
    // Sets to the given value
    set(newValue) {
        this.value = newValue;
    }
    // Atomically sets to the given value and returns true if the current value == the expected value
    compareAndSet(expect, update) {
        if (this.value === expect) {
            this.value = update;
            return true;
        }
        return false;
    }
}
/**
 * An RE2 class instance is a compiled representation of an RE2 regular expression, independent of
 * the public Java-like Pattern/Matcher API.
 *
 * This class also contains various implementation helpers for RE2 regular expressions.
 *
 * Use the {@link #quoteMeta(String)} utility function to quote all regular expression
 * metacharacters in an arbitrary string.
 *
 */ class $ff4f66a262d5170f$var$RE2 {
    // This is visible for testing.
    static initTest(expr) {
        const re2 = $ff4f66a262d5170f$var$RE2.compile(expr);
        const res = new $ff4f66a262d5170f$var$RE2(re2.expr, re2.prog, re2.numSubexp, re2.longest);
        res.cond = re2.cond;
        res.prefix = re2.prefix;
        res.prefixUTF8 = re2.prefixUTF8;
        res.prefixComplete = re2.prefixComplete;
        res.prefixRune = re2.prefixRune;
        return res;
    }
    /**
   * Parses a regular expression and returns, if successful, an {@code RE2} instance that can be
   * used to match against text.
   *
   * When matching against text, the regexp returns a match that begins as early as possible in the
   * input (leftmost), and among those it chooses the one that a backtracking search would have
   * found first. This so-called leftmost-first matching is the same semantics that Perl, Python,
   * and other implementations use, although this package implements it without the expense of
   * backtracking. For POSIX leftmost-longest matching, see {@link #compilePOSIX}.
   */ static compile(expr) {
        return $ff4f66a262d5170f$var$RE2.compileImpl(expr, $ff4f66a262d5170f$var$RE2Flags.PERL, false);
    }
    /**
   * {@code compilePOSIX} is like {@link #compile} but restricts the regular expression to POSIX ERE
   * (egrep) syntax and changes the match semantics to leftmost-longest.
   *
   * That is, when matching against text, the regexp returns a match that begins as early as
   * possible in the input (leftmost), and among those it chooses a match that is as long as
   * possible. This so-called leftmost-longest matching is the same semantics that early regular
   * expression implementations used and that POSIX specifies.
   *
   * However, there can be multiple leftmost-longest matches, with different submatch choices, and
   * here this package diverges from POSIX. Among the possible leftmost-longest matches, this
   * package chooses the one that a backtracking search would have found first, while POSIX
   * specifies that the match be chosen to maximize the length of the first subexpression, then the
   * second, and so on from left to right. The POSIX rule is computationally prohibitive and not
   * even well-defined. See http://swtch.com/~rsc/regexp/regexp2.html#posix
   */ static compilePOSIX(expr) {
        return $ff4f66a262d5170f$var$RE2.compileImpl(expr, $ff4f66a262d5170f$var$RE2Flags.POSIX, true);
    }
    // Exposed to ExecTests.
    static compileImpl(expr, mode, longest) {
        let re = $ff4f66a262d5170f$var$Parser.parse(expr, mode);
        const maxCap = re.maxCap();
        re = $ff4f66a262d5170f$var$Simplify.simplify(re);
        const prog = $ff4f66a262d5170f$var$Compiler.compileRegexp(re);
        const re2 = new $ff4f66a262d5170f$var$RE2(expr, prog, maxCap, longest);
        const [prefixCompl, prefixStr] = prog.prefix();
        re2.prefixComplete = prefixCompl;
        re2.prefix = prefixStr;
        re2.prefixUTF8 = $ff4f66a262d5170f$var$Utils.stringToUtf8ByteArray(re2.prefix);
        if (re2.prefix.length > 0) re2.prefixRune = re2.prefix.codePointAt(0);
        re2.namedGroups = re.namedGroups;
        return re2;
    }
    /**
   * Returns true iff textual regular expression {@code pattern} matches string {@code s}.
   *
   * More complicated queries need to use {@link #compile} and the full {@code RE2} interface.
   */ // This is visible for testing.
    static match(pattern, s) {
        return $ff4f66a262d5170f$var$RE2.compile(pattern).match(s);
    }
    constructor(expr, prog, numSubexp = 0, longest = 0){
        this.expr = expr; // as passed to Compile
        this.prog = prog; // compiled program
        this.numSubexp = numSubexp;
        this.longest = longest;
        this.cond = prog.startCond(); // EMPTY_* bitmask: empty-width conditions
        this.prefix = null; // required UTF-16 prefix in unanchored matches
        this.prefixUTF8 = null; // required UTF-8 prefix in unanchored matches
        this.prefixComplete = false; // true if prefix is the entire regexp
        this.prefixRune = 0; // first rune in prefix
        this.pooled = new $ff4f66a262d5170f$var$AtomicReference(); // Cache of machines for running regexp. Forms a Treiber stack.
        this.dfa = new $ff4f66a262d5170f$var$DFA(prog); // Initialize the Lazy DFA
    }
    executeEngine(input, pos, anchor, ncap) {
        // If the user wants capturing groups (ncap > 0), the DFA mathematically CANNOT do it.
        // We must use the NFA.
        if (ncap > 0) return this.doExecuteNFA(input, pos, anchor, ncap);
        const dfaResult = this.dfa.match(input, pos, anchor);
        if (dfaResult !== null) // DFA succeeded (returned true or false)
        return dfaResult ? [] : null; // Return empty array to signify "matched but no captures"
        // Fallback to NFA
        return this.doExecuteNFA(input, pos, anchor, ncap);
    }
    /**
   * Returns the number of parenthesized subexpressions in this regular expression.
   */ numberOfCapturingGroups() {
        return this.numSubexp;
    }
    /**
   * Returns the number of instructions in this compiled regular expression program.
   */ numberOfInstructions() {
        return this.prog.numInst();
    }
    // get() returns a machine to use for matching |this|.  It uses |this|'s
    // machine cache if possible, to avoid unnecessary allocation.
    get() {
        // Pop a machine off the stack if available.
        let head;
        do head = this.pooled.get();
        while (head && !this.pooled.compareAndSet(head, head.next));
        return head;
    }
    // Clears the memory associated with this machine.
    reset() {
        this.pooled.set(null);
    }
    // put() returns a machine to |this|'s machine cache.  There is no attempt to
    // limit the size of the cache, so it will grow to the maximum number of
    // simultaneous matches run using |this|.  (The cache empties when |this|
    // gets garbage collected or reset is called.)
    put(m, isNew) {
        // To avoid allocation in the single-thread or uncontended case, reuse a node only if
        // it was the only element in the stack when it was popped, and it's the only element
        // in the stack when it's pushed back after use.
        let head = this.pooled.get();
        do {
            head = this.pooled.get();
            if (!isNew && head) {
                // If an element had a null next pointer and it was previously in the stack, another thread
                // might be trying to pop it out right now, and if it sees the same node now in the
                // stack the pop will succeed, but the new top of the stack will be the stale (null) value
                // of next. Allocate a new Machine so that the CAS will not succeed if this node has been
                // popped and re-pushed.
                m = $ff4f66a262d5170f$var$Machine.fromMachine(m);
                isNew = true;
            }
            // Without this comparison, TSAN will complain about a race condition:
            // Thread A, B, and C all attempt to do a match on the same pattern.
            //
            // A: Allocates Machine 1; executes match; put machine 1. State is now:
            //
            // pooled -> machine 1 -> null
            //
            // B reads pooled, sees machine 1
            //
            // C reads pooled, sees machine 1
            //
            // B successfully CASes pooled to null
            //
            // B executes match; put machine 1, which involves setting machine1.next to
            // null (even though it's already null); preempted before CAS
            //
            // C resumes, and reads machine1.next in order to execute cas(head, head.next)
            //
            // There is no happens-before relationship between B's redundant null write
            // and C's read, thus triggering TSAN.
            //
            // Not needed for JS code
            if (m.next !== head) m.next = head;
        }while (!this.pooled.compareAndSet(head, m));
    }
    toString() {
        return this.expr;
    }
    // doExecuteNFA() finds the leftmost match in the input and returns
    // the position of its subexpressions.
    // Derived from exec.go.
    doExecuteNFA(input, pos, anchor, ncap) {
        let m = this.get();
        // The Treiber stack cannot reuse nodes, unless the node to be reused has only ever been at
        // the bottom of the stack (i.e., next == null).
        let isNew = false;
        if (!m) {
            m = $ff4f66a262d5170f$var$Machine.fromRE2(this);
            isNew = true;
        } else if (m.next !== null) {
            m = $ff4f66a262d5170f$var$Machine.fromMachine(m);
            isNew = true;
        }
        m.init(ncap);
        const cap = m.match(input, pos, anchor) ? m.submatches() : null;
        this.put(m, isNew);
        return cap;
    }
    match(s) {
        return this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Matches the regular expression against input starting at position start and ending at position
   * end, with the given anchoring. Records the submatch boundaries in group, which is [start, end)
   * pairs of byte offsets. The number of boundaries needed is inferred from the size of the group
   * array. It is most efficient not to ask for submatch boundaries.
   *
   * @param input the input byte array
   * @param start the beginning position in the input
   * @param end the end position in the input
   * @param anchor the anchoring flag (UNANCHORED, ANCHOR_START, ANCHOR_BOTH)
   * @param group the array to fill with submatch positions
   * @param ngroup the number of array pairs to fill in
   * @returns true if a match was found
   */ matchWithGroup(input, start, end, anchor, ngroup) {
        if (!(input instanceof $ff4f66a262d5170f$var$MatcherInputBase)) input = $ff4f66a262d5170f$var$MatcherInput.utf16(input);
        return this.matchMachineInput(input, start, end, anchor, ngroup);
    }
    matchMachineInput(input, start, end, anchor, ngroup) {
        if (start > end) return [
            false,
            null
        ];
        const machineInput = input.isUTF16Encoding() ? $ff4f66a262d5170f$var$MachineInput.fromUTF16(input.asCharSequence(), 0, end) : $ff4f66a262d5170f$var$MachineInput.fromUTF8(input.asBytes(), 0, end);
        const groupMatch = this.executeEngine(machineInput, start, anchor, 2 * ngroup);
        if (groupMatch === null) return [
            false,
            null
        ];
        return [
            true,
            groupMatch
        ];
    }
    /**
   * Returns true iff this regexp matches the UTF-8 byte array {@code b}.
   */ // This is visible for testing.
    matchUTF8(b) {
        return this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Returns a copy of {@code src} in which all matches for this regexp have been replaced by
   * {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAll(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 2 * src.length + 1);
    }
    /**
   * Returns a copy of {@code src} in which only the first match for this regexp has been replaced
   * by {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceFirst(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 1);
    }
    /**
   * Returns a copy of {@code src} in which at most {@code maxReplaces} matches for this regexp have
   * been replaced by the return value of of function {@code repl} (whose first argument is the
   * matched string). No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAllFunc(src, replFunc, maxReplaces) {
        let lastMatchEnd = 0;
        let searchPos = 0;
        let out = '';
        const input = $ff4f66a262d5170f$var$MachineInput.fromUTF16(src);
        let numReplaces = 0;
        while(searchPos <= src.length){
            const a = this.executeEngine(input, searchPos, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 2);
            if (a === null || a.length === 0) break;
            out += src.substring(lastMatchEnd, a[0]);
            if (a[1] > lastMatchEnd || a[0] === 0) {
                out += replFunc(src.substring(a[0], a[1]));
                numReplaces++;
            }
            lastMatchEnd = a[1];
            const width = input.step(searchPos) & 7;
            if (searchPos + width > a[1]) searchPos += width;
            else if (searchPos + 1 > a[1]) searchPos++;
            else searchPos = a[1];
            if (numReplaces >= maxReplaces) break;
        }
        out += src.substring(lastMatchEnd);
        return out;
    }
    // The number of capture values in the program may correspond
    // to fewer capturing expressions than are in the regexp.
    // For example, "(a){0}" turns into an empty program, so the
    // maximum capture in the program is 0 but we need to return
    // an expression for \1.  Pad returns a with -1s appended as needed;
    // the result may alias a.
    pad(a) {
        if (a === null) return null;
        let n = (1 + this.numSubexp) * 2;
        if (a.length < n) {
            let a2 = new Array(n).fill(-1);
            for(let i = 0; i < a.length; i++)a2[i] = a[i];
            a = a2;
        }
        return a;
    }
    // Find matches in input.
    allMatches(input, n, deliverFun = (v)=>v) {
        let result = [];
        const end = input.endPos();
        if (n < 0) n = end + 1;
        let pos = 0;
        let i = 0;
        let prevMatchEnd = -1;
        while(i < n && pos <= end){
            const matches = this.executeEngine(input, pos, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, this.prog.numCap);
            if (matches === null || matches.length === 0) break;
            let accept = true;
            if (matches[1] === pos) {
                if (matches[0] === prevMatchEnd) accept = false;
                const r = input.step(pos);
                if (r < 0) pos = end + 1;
                else pos += r & 7;
            } else pos = matches[1];
            prevMatchEnd = matches[1];
            if (accept) {
                result.push(deliverFun(this.pad(matches)));
                i++;
            }
        }
        return result;
    }
    // Legacy Go-style interface; preserved (package-private) for better
    // test coverage.
    //
    // There are 16 methods of RE2 that match a regular expression and
    // identify the matched text.  Their names are matched by this regular
    // expression:
    //
    //    find(All)?(UTF8)?(Submatch)?(Index)?
    //
    // If 'All' is present, the routine matches successive non-overlapping
    // matches of the entire expression.  Empty matches abutting a
    // preceding match are ignored.  The return value is an array
    // containing the successive return values of the corresponding
    // non-All routine.  These routines take an extra integer argument, n;
    // if n >= 0, the function returns at most n matches/submatches.
    //
    // If 'UTF8' is present, the argument is a UTF-8 encoded byte[] array;
    // otherwise it is a UTF-16 encoded js string; return values
    // are adjusted as appropriate.
    //
    // If 'Submatch' is present, the return value is an list identifying
    // the successive submatches of the expression.  Submatches are
    // matches of parenthesized subexpressions within the regular
    // expression, numbered from left to right in order of opening
    // parenthesis.  Submatch 0 is the match of the entire expression,
    // submatch 1 the match of the first parenthesized subexpression, and
    // so on.
    //
    // If 'Index' is present, matches and submatches are identified by
    // byte index pairs within the input string: result[2*n:2*n+1]
    // identifies the indexes of the nth submatch.  The pair for n==0
    // identifies the match of the entire expression.  If 'Index' is not
    // present, the match is identified by the text of the match/submatch.
    // If an index is negative, it means that subexpression did not match
    // any string in the input.
    /**
   * Returns an array holding the text of the leftmost match in {@code b} of this regular
   * expression.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8(b) {
        const a = this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return b.slice(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code b} of this regular expression. The match itself is at {@code b[loc[0]...loc[1]]}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Index(b) {
        const a = this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return a.slice(0, 2);
    }
    /**
   * Returns a string holding the text of the leftmost match in {@code s} of this regular
   * expression.
   *
   * If there is no match, the return value is an empty string, but it will also be empty if the
   * regular expression successfully matches an empty string. Use {@link #findIndex} or
   * {@link #findSubmatch} if it is necessary to distinguish these cases.
   */ // This is visible for testing.
    find(s) {
        const a = this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return '';
        return s.substring(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code s} of this regular expression. The match itself is at
   * {@code s.substring(loc[0], loc[1])}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findIndex(s) {
        return this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, 2);
    }
    /**
   * Returns an array of arrays the text of the leftmost match of the regular expression in
   * {@code b} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Submatch(b) {
        const a = this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = b.slice(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code b} and the matches, if any, of its subexpressions, as defined by the the
   * <a href='#submatch'>Submatch</a> and <a href='#index'>Index</a> descriptions above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8SubmatchIndex(b) {
        return this.pad(this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * Returns an array of strings holding the text of the leftmost match of the regular expression in
   * {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatch(s) {
        const a = this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = s.substring(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatchIndex(s) {
        return this.pad(this.executeEngine($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), 0, $ff4f66a262d5170f$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * {@code findAllUTF8()} is the <a href='#all'>All</a> version of {@link #findUTF8}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   *
   * TODO(adonovan): think about defining a byte slice view class, like a read-only Go slice backed
   * by |b|.
   */ // This is visible for testing.
    findAllUTF8(b, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), n, (match)=>b.slice(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Index} is the <a href='#all'>All</a> version of {@link #findUTF8Index}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Index(b, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAll} is the <a href='#all'>All</a> version of {@link #find}; it returns a list of up
   * to {@code n} successive matches of the expression, as defined by the <a href='#all'>All</a>
   * description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAll(s, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), n, (match)=>s.substring(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllIndex} is the <a href='#all'>All</a> version of {@link #findIndex}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllIndex(s, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Submatch} is the <a href='#all'>All</a> version of {@link #findUTF8Submatch};
   * it returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Submatch(b, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = b.slice(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8SubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findUTF8SubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8SubmatchIndex(b, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF8(b), n);
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatch} is the <a href='#all'>All</a> version of {@link #findSubmatch}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatch(s, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = s.substring(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findSubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatchIndex(s, n) {
        const result = this.allMatches($ff4f66a262d5170f$var$MachineInput.fromUTF16(s), n);
        if (result.length === 0) return null;
        return result;
    }
}
/**
 * Transform JS regex string to RE2 regex string
 */ class $ff4f66a262d5170f$var$TranslateRegExpString {
    static isUpperCaseAlpha(ch) {
        return 'A' <= ch && ch <= 'Z';
    }
    static isHexadecimal(ch) {
        return '0' <= ch && ch <= '9' || 'A' <= ch && ch <= 'F' || 'a' <= ch && ch <= 'f';
    }
    static getUtf8CharSize(ch) {
        const code = ch.charCodeAt(0);
        if (code < 0x80) return 1; // 1-byte (ASCII)
        if (code < 0x800) return 2; // 2-byte
        if (code < 0x10000) return 3; // 3-byte
        return 4; // 4-byte (surrogate pairs, rare characters)
    }
    static translate(data) {
        if (typeof data !== 'string') return data;
        let result = '';
        let changed = false;
        let size = data.length;
        if (size === 0) {
            result = '(?:)';
            changed = true;
        }
        let i = 0;
        while(i < size){
            let ch = data[i];
            if (ch === '\\') {
                if (i + 1 < size) {
                    ch = data[i + 1];
                    switch(ch){
                        case '\\':
                            result += '\\\\';
                            i += 2;
                            continue;
                        case 'c':
                            if (i + 2 < size) {
                                let nextCh = data[i + 2];
                                if ($ff4f66a262d5170f$var$TranslateRegExpString.isUpperCaseAlpha(nextCh)) {
                                    result += '\\x';
                                    result += (nextCh.charCodeAt(0) - 64 >> 4).toString(16).toUpperCase();
                                    result += (nextCh.charCodeAt(0) - 64 & 15).toString(16).toUpperCase();
                                    i += 3;
                                    changed = true;
                                    continue;
                                }
                            }
                            result += '\\c';
                            i += 2;
                            continue;
                        case 'u':
                            if (i + 2 < size) {
                                let nextCh = data[i + 2];
                                if ($ff4f66a262d5170f$var$TranslateRegExpString.isHexadecimal(nextCh)) {
                                    result += '\\x{' + nextCh;
                                    i += 3;
                                    for(let j = 0; j < 3 && i < size; ++i, ++j){
                                        nextCh = data[i];
                                        if (!$ff4f66a262d5170f$var$TranslateRegExpString.isHexadecimal(nextCh)) break;
                                        result += nextCh;
                                    }
                                    result += '}';
                                    changed = true;
                                    continue;
                                } else if (nextCh === '{') {
                                    result += '\\x';
                                    i += 2;
                                    changed = true;
                                    continue;
                                }
                            }
                            result += '\\u';
                            i += 2;
                            continue;
                        default:
                            {
                                result += '\\';
                                let symSize = $ff4f66a262d5170f$var$TranslateRegExpString.getUtf8CharSize(ch);
                                result += data.substring(i + 1, i + 1 + symSize);
                                i += symSize + 1;
                                continue;
                            }
                    }
                }
            } else if (ch === '/') {
                result += '\\/';
                i += 1;
                changed = true;
                continue;
            } else if (ch === '(' && i + 2 < size && data[i + 1] === '?' && data[i + 2] === '<') {
                if (i + 3 >= size || data[i + 3] !== '=' && data[i + 3] !== '!') {
                    result += '(?P<';
                    i += 3;
                    changed = true;
                    continue;
                }
            }
            let symSize = $ff4f66a262d5170f$var$TranslateRegExpString.getUtf8CharSize(ch);
            result += data.substring(i, i + symSize);
            i += symSize;
        }
        return changed ? result : data;
    }
}
/**
 * A compiled representation of an RE2 regular expression
 *
 * The matching functions take {@code String} arguments instead of the more general Java
 * {@code CharSequence} since the latter doesn't provide UTF-16 decoding.
 *
 *
 * @author rsc@google.com (Russ Cox)
 * @class
 */ class $ff4f66a262d5170f$export$e46efc5f33420715 {
    /**
   * Flag: case insensitive matching.
   */ static CASE_INSENSITIVE = 1;
    /**
   * Flag: dot ({@code .}) matches all characters, including newline.
   */ static DOTALL = 2;
    /**
   * Flag: multiline matching: {@code ^} and {@code $} match at beginning and end of line, not just
   * beginning and end of input.
   */ static MULTILINE = 4;
    /**
   * Flag: Unicode groups (e.g. {@code \p\ Greek\} ) will be syntax errors.
   */ static DISABLE_UNICODE_GROUPS = 8;
    /**
   * Flag: matches longest possible string.
   */ static LONGEST_MATCH = 16;
    /**
   * Returns a literal pattern string for the specified string.
   *
   * This method produces a string that can be used to create a <code>RE2JS</code> that would
   * match the string <code>s</code> as if it were a literal pattern.
   *
   * Metacharacters or escape sequences in the input sequence will be given no special meaning.
   *
   * @param {string} str The string to be literalized
   * @returns {string} A literal string replacement
   */ static quote(str) {
        return $ff4f66a262d5170f$var$Utils.quoteMeta(str);
    }
    /**
   * Translates a given regular expression string to ensure compatibility with RE2JS.
   *
   * This function preprocesses the input regex string by applying necessary transformations,
   * such as escaping special characters (e.g., `/`), converting named capture groups to
   * RE2JS-compatible syntax, and handling Unicode sequences properly. It ensures that the
   * resulting regex is safe and properly formatted before compilation.
   *
   * @param {string} expr - The regular expression string to be translated.
   * @returns {string} - The transformed regular expression string, ready for compilation.
   */ static translateRegExp(expr) {
        return $ff4f66a262d5170f$var$TranslateRegExpString.translate(expr);
    }
    /**
   * Helper: create new RE2JS with given regex and flags. Flregex is the regex with flags applied.
   * @param {string} regex
   * @param {number} [flags=0]
   * @returns {RE2JS}
   */ static compile(regex, flags = 0) {
        let fregex = regex;
        if ((flags & $ff4f66a262d5170f$export$e46efc5f33420715.CASE_INSENSITIVE) !== 0) fregex = `(?i)${fregex}`;
        if ((flags & $ff4f66a262d5170f$export$e46efc5f33420715.DOTALL) !== 0) fregex = `(?s)${fregex}`;
        if ((flags & $ff4f66a262d5170f$export$e46efc5f33420715.MULTILINE) !== 0) fregex = `(?m)${fregex}`;
        if ((flags & ~($ff4f66a262d5170f$export$e46efc5f33420715.MULTILINE | $ff4f66a262d5170f$export$e46efc5f33420715.DOTALL | $ff4f66a262d5170f$export$e46efc5f33420715.CASE_INSENSITIVE | $ff4f66a262d5170f$export$e46efc5f33420715.DISABLE_UNICODE_GROUPS | $ff4f66a262d5170f$export$e46efc5f33420715.LONGEST_MATCH)) !== 0) throw new $ff4f66a262d5170f$export$fa1c64d63b2c22b1('Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH');
        let re2Flags = $ff4f66a262d5170f$var$RE2Flags.PERL;
        if ((flags & $ff4f66a262d5170f$export$e46efc5f33420715.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= -129;
        const p = new $ff4f66a262d5170f$export$e46efc5f33420715(regex, flags);
        // The compiled RE2 regexp.
        p.re2Input = $ff4f66a262d5170f$var$RE2.compileImpl(fregex, re2Flags, (flags & $ff4f66a262d5170f$export$e46efc5f33420715.LONGEST_MATCH) !== 0);
        return p;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string} regex the regular expression
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   * @throws RE2JSSyntaxException if the regular expression is malformed
   */ static matches(regex, input) {
        return $ff4f66a262d5170f$export$e46efc5f33420715.compile(regex).testExact(input);
    }
    /**
   * This is visible for testing.
   * @private
   */ static initTest(pattern, flags, re2) {
        if (pattern == null) throw new Error('pattern is null');
        if (re2 == null) throw new Error('re2 is null');
        const p = new $ff4f66a262d5170f$export$e46efc5f33420715(pattern, flags);
        // The compiled RE2 regexp.
        p.re2Input = re2;
        return p;
    }
    /**
   *
   * @param {string} pattern
   * @param {number} flags
   */ constructor(pattern, flags){
        // The pattern string at construction time.
        this.patternInput = pattern;
        // The flags at construction time.
        this.flagsInput = flags;
    }
    /**
   * Releases memory used by internal caches associated with this pattern. Does not change the
   * observable behaviour. Useful for tests that detect memory leaks via allocation tracking.
   */ reset() {
        this.re2Input.reset();
    }
    /**
   * Returns the flags used in the constructor.
   * @returns {number}
   */ flags() {
        return this.flagsInput;
    }
    /**
   * Returns the pattern used in the constructor.
   * @returns {string}
   */ pattern() {
        return this.patternInput;
    }
    re2() {
        return this.re2Input;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   */ matches(input) {
        return this.testExact(input);
    }
    /**
   * Creates a new {@code Matcher} matching the pattern against the input.
   *
   * @param {string|number[]} input the input string
   * @returns {Matcher}
   */ matcher(input) {
        if (Array.isArray(input)) input = $ff4f66a262d5170f$var$MatcherInput.utf8(input);
        return new $ff4f66a262d5170f$export$20214574ec94167d(this, input);
    }
    /**
   * Tests whether the regular expression matches any part of the input string.
   * Performance Note: This method is highly optimized. Because it only returns
   * a boolean and does not extract capture groups, it bypasses the `Matcher` overhead
   * and guarantees execution on the high-speed DFA engine whenever possible.
   *
   * @param {string|number[]} input - The input string or UTF-8 byte array to test against.
   * @returns {boolean} `true` if the pattern is found anywhere in the input, `false` otherwise.
   */ test(input) {
        if (Array.isArray(input)) // Reuse the existing UTF-8 fast-path method
        return this.re2Input.matchUTF8(input);
        // Reuse the existing UTF-16 fast-path method
        return this.re2Input.match(input);
    }
    /**
   * Tests whether the regular expression matches the ENTIRE input string.
   * * **Performance Note:** This operates identically to `.matches()`, but is significantly
   * faster because it does not request capture group data. By requesting 0 capture groups,
   * it securely routes execution through the DFA fast-path.
   *
   * @param {string|number[]} input - The input string or UTF-8 byte array to test against.
   * @returns {boolean} `true` if the exact input string fully matches the pattern, `false` otherwise.
   */ testExact(input) {
        const machineInput = Array.isArray(input) ? $ff4f66a262d5170f$var$MachineInput.fromUTF8(input) : $ff4f66a262d5170f$var$MachineInput.fromUTF16(input);
        return this.re2Input.executeEngine(machineInput, 0, $ff4f66a262d5170f$var$RE2Flags.ANCHOR_BOTH, 0) !== null;
    }
    /**
   * Splits input around instances of the regular expression. It returns an array giving the strings
   * that occur before, between, and after instances of the regular expression.
   *
   * If {@code limit <= 0}, there is no limit on the size of the returned array. If
   * {@code limit == 0}, empty strings that would occur at the end of the array are omitted. If
   * {@code limit > 0}, at most limit strings are returned. The final string contains the remainder
   * of the input, possibly including additional matches of the pattern.
   *
   * @param {string} input the input string to be split
   * @param {number} [limit=0] the limit
   * @returns {string[]} the split strings
   */ split(input, limit = 0) {
        const m = this.matcher(input);
        const result = [];
        let emptiesSkipped = 0;
        let last = 0;
        while(m.find()){
            if (last === 0 && m.end() === 0) {
                // Zero-width match at the beginning, skip
                last = m.end();
                continue;
            }
            if (limit > 0 && result.length === limit - 1) break;
            if (last === m.start()) // Empty match, may or may not be trailing.
            {
                if (limit === 0) {
                    emptiesSkipped += 1;
                    last = m.end();
                    continue;
                }
            } else // If emptiesSkipped > 0 then limit == 0 and we have non-trailing empty matches to add before
            // this non-empty match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.start()));
            last = m.end();
        }
        if (limit === 0 && last !== m.inputLength()) {
            // Unlimited match, no more delimiters but we have a non-empty input at the end. Catch up any skipped empty
            // matches, then emit the final match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.inputLength()));
        }
        if (limit !== 0 || result.length === 0) result.push(m.substring(last, m.inputLength()));
        return result;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        return this.patternInput;
    }
    /**
   * Returns the program size of this pattern.
   *
   * <p>
   * Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
   * "cost". Larger numbers are more expensive than smaller numbers.
   * </p>
   *
   * @returns {number} the program size of this pattern
   */ programSize() {
        return this.re2Input.numberOfInstructions();
    }
    /**
   * Returns the number of capturing groups in this matcher's pattern. Group zero denotes the entire
   * pattern and is excluded from this count.
   *
   * @returns {number} the number of capturing groups in this pattern
   */ groupCount() {
        return this.re2Input.numberOfCapturingGroups();
    }
    /**
   * Return a map of the capturing groups in this matcher's pattern, where key is the name and value
   * is the index of the group in the pattern.
   * @returns {Record<string, number>}
   */ namedGroups() {
        return this.re2Input.namedGroups;
    }
    /**
   *
   * @param {*} other
   * @returns {boolean}
   */ equals(other) {
        if (this === other) return true;
        if (other === null || this.constructor !== other.constructor) return false;
        return this.flagsInput === other.flagsInput && this.patternInput === other.patternInput;
    }
}

});

parcelRegister("82gbm", function(module, exports) {
$parcel$export(module.exports, "ValidationFieldSet", () => $5658df915d376af2$export$1050042c8e014605);
$parcel$export(module.exports, "ErrorKeySet", () => $5658df915d376af2$export$1a23c12903aac701);
const $5658df915d376af2$export$1050042c8e014605 = {
    ALL_FIELDS: 'allFields',
    MODIFIED_FIELDS: 'modifiedFields',
    NONE: 'none',
    SECURITY_CRITICAL: 'securityCritical'
};
const $5658df915d376af2$export$1a23c12903aac701 = {
    REQUIRED: 'required',
    INVALID: 'invalid',
    INVALID_REGEX: 'invalidRegex'
};

});

parcelRegister("j15pg", function(module, exports) {
$parcel$export(module.exports, "getFailedRequiredValidationError", () => $a220277a7b9b2b7a$export$d910c698504f3659);
$parcel$export(module.exports, "getFailedValidationError", () => $a220277a7b9b2b7a$export$f680e8766c27c01e);

var $82gbm = parcelRequire("82gbm");

var $h2kMT = parcelRequire("h2kMT");
const $a220277a7b9b2b7a$export$d910c698504f3659 = (fieldLabel, intl)=>$a220277a7b9b2b7a$export$f680e8766c27c01e((0, $82gbm.ErrorKeySet).REQUIRED, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $h2kMT.messages).required, {
        fieldLabel: fieldLabel
    }));
const $a220277a7b9b2b7a$export$f680e8766c27c01e = (errorKey, errorMessage)=>({
        errorKey: errorKey,
        errorMessage: errorMessage
    });

});
parcelRegister("h2kMT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $858078f8b0402769$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $858078f8b0402769$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    required: {
        id: 'proforma-form-renderer.common.utils.validators.required',
        defaultMessage: '{fieldLabel} is required.',
        description: 'Validation message for required field with given label.'
    }
});

});


parcelRegister("gCFqc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a9eeb0ba86f54b2d$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a9eeb0ba86f54b2d$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenCharacters: {
        id: 'proforma-form-renderer.common.utils.validators.text.between-characters',
        defaultMessage: 'Must be between {minimum} and {maximum, plural, one {# character} other {# characters}}.',
        description: 'Validation message for field with character length between a range.'
    },
    betweenWords: {
        id: 'proforma-form-renderer.common.utils.validators.text.between-words',
        defaultMessage: 'Must be between {minimum} and {maximum, plural, one {# word} other {# words}}.',
        description: 'Validation message for field with word length between a range.'
    },
    exactCharacters: {
        id: 'proforma-form-renderer.common.utils.validators.text.exact-characters',
        defaultMessage: 'Must be exactly {minimum, plural, one {# character} other {# characters}}.',
        description: 'Validation message for field with exact character length.'
    },
    exactWords: {
        id: 'proforma-form-renderer.common.utils.validators.text.exact-words',
        defaultMessage: 'Must be exactly {minimum, plural, one {# word} other {# words}}.',
        description: 'Validation message for field with exact word length.'
    },
    maximumCharacters: {
        id: 'proforma-form-renderer.common.utils.validators.text.maximum-characters',
        defaultMessage: 'Must be less than {maximum, plural, one {# character} other {# characters}}.',
        description: 'Validation message for field with maximum character length.'
    },
    maximumWords: {
        id: 'proforma-form-renderer.common.utils.validators.text.maximum-words',
        defaultMessage: 'Must be less than {maximum, plural, one {# word} other {# words}}.',
        description: 'Validation message for field with maximum word length.'
    },
    minimumCharacters: {
        id: 'proforma-form-renderer.common.utils.validators.text.minimum-characters',
        defaultMessage: 'Must be more than {minimum, plural, one {# character} other {# characters}}.',
        description: 'Validation message for field with minimum character length.'
    },
    minimumWords: {
        id: 'proforma-form-renderer.common.utils.validators.text.minimum-words',
        defaultMessage: 'Must be more than {minimum, plural, one {# word} other {# words}}.',
        description: 'Validation message for field with minimum word length.'
    },
    regexCustomMessage: {
        id: 'proforma-form-renderer.common.utils.validators.text.regex-custom-message',
        defaultMessage: '{message}',
        description: 'Custom validation message for field with regex pattern.'
    },
    regexDefaultMessage: {
        id: 'proforma-form-renderer.common.utils.validators.text.regex-default-message',
        defaultMessage: 'Response does not match required pattern.',
        description: 'Default validation message for field with regex pattern.'
    },
    regexInvalidMessage: {
        id: 'proforma-form-renderer.common.utils.validators.text.regex-invalid-message',
        defaultMessage: 'The regex pattern on this field is invalid. Answer unable to be validated.',
        description: 'Validation message for field with invalid regex pattern.'
    }
});

});



parcelRegister("eqLbu", function(module, exports) {
$parcel$export(module.exports, "getAttachmentValidationErrors", () => $4331eed434bf2af2$export$4376befe05e3f12f);

var $j15pg = parcelRequire("j15pg");
const $4331eed434bf2af2$export$4376befe05e3f12f = (validation, fieldLabel, intl, filesValue)=>{
    if (Object.keys(validation).length === 0) return [];
    if (validation.required) return !filesValue || !filesValue.files.length ? [
        (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
    ] : [];
    return [];
};

});

parcelRegister("e0sS2", function(module, exports) {
$parcel$export(module.exports, "getDateValidationErrors", () => $9f92d22eddf42217$export$dca24ca2e110c17);

var $82gbm = parcelRequire("82gbm");

var $j15pg = parcelRequire("j15pg");

var $KuZ3l = parcelRequire("KuZ3l");
const $9f92d22eddf42217$export$dca24ca2e110c17 = (validation, fieldLabel, intl, date)=>{
    if (!date) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    // Date values to be reused throughout the validation logic
    const minDate = validation.minimumDate ? new Date(validation.minimumDate) : undefined;
    const maxDate = validation.maximumDate ? new Date(validation.maximumDate) : undefined;
    const enteredDate = new Date(date);
    // Boolean values for validation logic
    const hasExactDateRequirements = validation.minimumDate && validation.minimumDate === validation.maximumDate;
    const hasBetweenDateRequirements = !!validation.minimumDate && !!validation.maximumDate;
    const validationErrors = [];
    if (hasExactDateRequirements && minDate) {
        if (enteredDate.valueOf() !== minDate.valueOf()) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $KuZ3l.messages).exactDate, {
            date: minDate
        })));
         // No need to compare with both max and min again
    } else if (hasBetweenDateRequirements && minDate && maxDate) // Between dates scenario
    {
        if (enteredDate < minDate || enteredDate > maxDate) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $KuZ3l.messages).betweenDate, {
            minimum: minDate,
            maximum: maxDate
        })));
    } else {
        if (validation.minimumDate && minDate) {
            if (enteredDate < minDate) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $KuZ3l.messages).minimumDate, {
                minimum: minDate
            })));
        }
        if (validation.maximumDate && maxDate) {
            if (enteredDate > maxDate) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $KuZ3l.messages).maximumDate, {
                maximum: maxDate
            })));
        }
    }
    return validationErrors;
};

});
parcelRegister("KuZ3l", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d1a926ecc7579162$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $d1a926ecc7579162$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenDate: {
        id: 'proforma-form-renderer.common.utils.validators.date.between-date',
        defaultMessage: 'The date must be between {minimum, date, medium} and {maximum, date, medium}.',
        description: 'Validation message for field with date between a range.'
    },
    exactDate: {
        id: 'proforma-form-renderer.common.utils.validators.date.exact-date',
        defaultMessage: 'The date must be exactly {date, date, medium}.',
        description: 'Validation message for field with exact date.'
    },
    maximumDate: {
        id: 'proforma-form-renderer.common.utils.validators.date.maximum-date',
        defaultMessage: 'The date must be on or before {maximum, date, medium}.',
        description: 'Validation message for field with maximum date.'
    },
    minimumDate: {
        id: 'proforma-form-renderer.common.utils.validators.date.minimum-date',
        defaultMessage: 'The date must be on or after {minimum, date, medium}.',
        description: 'Validation message for field with minimum date.'
    }
});

});


parcelRegister("5U9IG", function(module, exports) {
$parcel$export(module.exports, "getDateTimeValidationErrors", () => $a3497f66a6deb9d0$export$dfe2acc65eb9303a);

var $82gbm = parcelRequire("82gbm");

var $e0sS2 = parcelRequire("e0sS2");

var $9y0Zb = parcelRequire("9y0Zb");

var $j15pg = parcelRequire("j15pg");

var $g7xve = parcelRequire("g7xve");
const $a3497f66a6deb9d0$export$dfe2acc65eb9303a = (validation, fieldLabel, intl, dateTime)=>{
    if (Object.keys(validation).length === 0) return [];
    // we don't check for min/max date and time here, because in the frontend it is possible to have a Date field with Time validation and vice versa
    if (!dateTime) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    // DateTime values to be reused throughout the validation logic
    const minDateTime = validation.minimumDate && validation.minimumTime ? new Date(`${validation.minimumDate}T${validation.minimumTime}`) : undefined;
    const maxDateTime = validation.maximumDate && validation.maximumTime ? new Date(`${validation.maximumDate}T${validation.maximumTime}`) : undefined;
    const enteredDateTime = dateTime.date && dateTime.localTime ? new Date(`${dateTime.date}T${dateTime.localTime}`) : dateTime.date ? new Date(dateTime.date) : undefined;
    // Boolean values for validation logic
    const hasMinDateTimeRequirements = !!validation.minimumDate && !!validation.minimumTime;
    const hasMaxDateTimeRequirements = !!validation.maximumDate && !!validation.maximumTime;
    const hasExactDateTimeRequirements = hasMinDateTimeRequirements && validation.minimumDate === validation.maximumDate && validation.minimumTime === validation.maximumTime;
    const hasBetweenDateTimeRequirements = hasMinDateTimeRequirements && hasMaxDateTimeRequirements;
    // Date or time required
    if (validation.required && (!dateTime.date || !dateTime.localTime)) return [
        {
            errorKey: (0, $82gbm.ErrorKeySet).REQUIRED,
            errorMessage: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $g7xve.messages).requiredDateTime, {
                fieldLabel: fieldLabel
            })
        }
    ];
    if (hasExactDateTimeRequirements && minDateTime && enteredDateTime) {
        if (enteredDateTime.valueOf() !== minDateTime.valueOf()) return [
            {
                errorKey: (0, $82gbm.ErrorKeySet).INVALID,
                errorMessage: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $g7xve.messages).exactDateTime, {
                    date: minDateTime,
                    time: minDateTime
                })
            }
        ];
    } else if (hasBetweenDateTimeRequirements && minDateTime && maxDateTime && enteredDateTime) {
        if (enteredDateTime < minDateTime || enteredDateTime > maxDateTime) return [
            {
                errorKey: (0, $82gbm.ErrorKeySet).INVALID,
                errorMessage: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $g7xve.messages).betweenDateTime, {
                    minimumDate: minDateTime,
                    minimumTime: minDateTime,
                    maximumDate: maxDateTime,
                    maximumTime: maxDateTime
                })
            }
        ];
    } else if (hasMinDateTimeRequirements || hasMaxDateTimeRequirements) {
        if (hasMinDateTimeRequirements && minDateTime && enteredDateTime) {
            if (enteredDateTime < minDateTime) return [
                {
                    errorKey: (0, $82gbm.ErrorKeySet).INVALID,
                    errorMessage: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $g7xve.messages).minimumDateTime, {
                        minimumDate: minDateTime,
                        minimumTime: minDateTime
                    })
                }
            ];
        }
        // Max Date and time
        if (hasMaxDateTimeRequirements && enteredDateTime && maxDateTime) {
            if (enteredDateTime > maxDateTime) return [
                {
                    errorKey: (0, $82gbm.ErrorKeySet).INVALID,
                    errorMessage: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $g7xve.messages).maximumDateTime, {
                        maximumDate: maxDateTime,
                        maximumTime: maxDateTime
                    })
                }
            ];
        }
    } else {
        // Individual date and time validations
        const validationErrors = [];
        // Validate Date
        if (dateTime.date) {
            const dateValidationErrors = (0, $e0sS2.getDateValidationErrors)(validation, fieldLabel, intl, dateTime.date);
            validationErrors.push(...dateValidationErrors);
        }
        if (dateTime.localTime) {
            // Validate Time
            const timeValidationErrors = (0, $9y0Zb.getTimeValidationErrors)(validation, fieldLabel, intl, dateTime.localTime);
            validationErrors.push(...timeValidationErrors);
        }
        return validationErrors;
    }
    return [];
};

});
parcelRegister("9y0Zb", function(module, exports) {
$parcel$export(module.exports, "getTimeValidationErrors", () => $0987c7edfd4e534e$export$f045ab6f6b0ff8b0);

var $82gbm = parcelRequire("82gbm");

var $j15pg = parcelRequire("j15pg");

var $4qMJv = parcelRequire("4qMJv");
const $0987c7edfd4e534e$var$datePrefix = '1999-01-01';
const $0987c7edfd4e534e$export$f045ab6f6b0ff8b0 = (validation, fieldLabel, intl, localTime)=>{
    if (Object.keys(validation).length === 0) return [];
    if (!localTime) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    const time = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${localTime}`);
    const validationErrors = [];
    if (Number.isNaN(time.getTime())) // Check time is valid
    validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $4qMJv.messages).invalidTime)));
    else if (validation.minimumTime && validation.minimumTime === validation.maximumTime) {
        // Exact time scenario
        const minTime = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${validation.minimumTime}`);
        if (time.getTime() !== minTime.getTime()) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $4qMJv.messages).exactTime, {
            time: minTime
        })));
    } else if (validation.minimumTime && validation.maximumTime) {
        // Between times scenario
        const minTime = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${validation.minimumTime}`);
        const maxTime = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${validation.maximumTime}`);
        if (time < minTime || time > maxTime) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $4qMJv.messages).betweenTime, {
            minimum: minTime,
            maximum: maxTime
        })));
    } else {
        if (validation.minimumTime) {
            const minTime = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${validation.minimumTime}`);
            if (time < minTime) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $4qMJv.messages).minimumTime, {
                minimum: minTime
            })));
        }
        if (validation.maximumTime) {
            const maxTime = new Date(`${$0987c7edfd4e534e$var$datePrefix}T${validation.maximumTime}`);
            if (time > maxTime) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $4qMJv.messages).maximumTime, {
                maximum: maxTime
            })));
        }
    }
    return validationErrors;
};

});
parcelRegister("4qMJv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $600bf0132aee2b6a$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $600bf0132aee2b6a$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenTime: {
        id: 'proforma-form-renderer.common.utils.validators.time.between-time',
        defaultMessage: 'The time must be between {minimum, time, short} and {maximum, time, short}.',
        description: 'Validation message for field with time between a range.'
    },
    exactTime: {
        id: 'proforma-form-renderer.common.utils.validators.time.exact-time',
        defaultMessage: 'The time must be exactly {time, time, short}.',
        description: 'Validation message for field with exact time.'
    },
    invalidTime: {
        id: 'proforma-form-renderer.common.utils.validators.time.invalid-time',
        defaultMessage: 'The time is invalid.',
        description: 'Validation message for field with invalid time.'
    },
    maximumTime: {
        id: 'proforma-form-renderer.common.utils.validators.time.maximum-time',
        defaultMessage: 'The time must be at or before {maximum, time, short}.',
        description: 'Validation message for field with maximum time.'
    },
    minimumTime: {
        id: 'proforma-form-renderer.common.utils.validators.time.minimum-time',
        defaultMessage: 'The time must be at or after {minimum, time, short}.',
        description: 'Validation message for field with minimum time.'
    }
});

});


parcelRegister("g7xve", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2dc9324ed079d7c5$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2dc9324ed079d7c5$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenDateTime: {
        id: 'proforma-form-renderer.common.utils.validators.date-time.between-date-time',
        defaultMessage: 'The date and time must be between the {minimumDate, date, medium} at {minimumTime, time, short} and the {maximumDate, date, medium} at {maximumTime, time, short}.',
        description: 'Validation message for field with date and time between a range.'
    },
    exactDateTime: {
        id: 'proforma-form-renderer.common.utils.validators.date-time.exact-date-time',
        defaultMessage: 'The date and time must be exactly the {date, date, medium} at {time, time, short}.',
        description: 'Validation message for field with exact date and time.'
    },
    maximumDateTime: {
        id: 'proforma-form-renderer.common.utils.validators.date-time.maximum-date-time',
        defaultMessage: 'The date and time must be on or before the {maximumDate, date, medium} at {maximumTime, time, short}.',
        description: 'Validation message for field with maximum date and time.'
    },
    minimumDateTime: {
        id: 'proforma-form-renderer.common.utils.validators.date-time.minimum-date-time',
        defaultMessage: 'The date and time must be at or after the {minimumDate, date, medium} at {minimumTime, time, short}.',
        description: 'Validation message for field with minimum date and time.'
    },
    requiredDateTime: {
        id: 'proforma-form-renderer.common.utils.validators.date-time.required-date-time',
        defaultMessage: '{fieldLabel} is required. Please specify a date and time.',
        description: 'Validation message for required date time field with given label.'
    }
});

});


parcelRegister("6mKvs", function(module, exports) {
$parcel$export(module.exports, "getEmailFormatErrors", () => $4304eff262ec3dc0$export$5f1f98008550a262);
$parcel$export(module.exports, "getEmailValidationErrors", () => $4304eff262ec3dc0$export$728aada1e1a517cf);

var $82gbm = parcelRequire("82gbm");

var $jg5hp = parcelRequire("jg5hp");

var $j15pg = parcelRequire("j15pg");

var $2eK6f = parcelRequire("2eK6f");
const $4304eff262ec3dc0$var$emailRegex = /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/;
const $4304eff262ec3dc0$export$5f1f98008550a262 = (intl, textValue)=>{
    var _textValue$text;
    const text = textValue === null || textValue === void 0 || (_textValue$text = textValue.text) === null || _textValue$text === void 0 ? void 0 : _textValue$text.trim();
    if (text && !$4304eff262ec3dc0$var$emailRegex.test(text)) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $2eK6f.messages).invalidEmail))
    ];
    return [];
};
const $4304eff262ec3dc0$export$728aada1e1a517cf = (validation, fieldLabel, intl, textValue)=>{
    if (textValue) {
        const { text: text } = textValue;
        const trimmedText = text.trim();
        if (!$4304eff262ec3dc0$var$emailRegex.test(trimmedText)) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $2eK6f.messages).invalidEmail))
        ];
    }
    return (0, $jg5hp.getTextValidationErrors)(validation, fieldLabel, intl, textValue);
};

});
parcelRegister("2eK6f", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2a2689d3683363e3$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2a2689d3683363e3$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    invalidEmail: {
        id: 'proforma-form-renderer.common.utils.validators.email.invalid-email',
        defaultMessage: 'Must be an email address',
        description: 'Validation message for field with invalid email.'
    }
});

});


parcelRegister("k6x2A", function(module, exports) {
$parcel$export(module.exports, "getNumberValidationErrors", () => $9e0dba7cf2cd78f3$export$ea5afb805e0643ce);

var $82gbm = parcelRequire("82gbm");

var $j15pg = parcelRequire("j15pg");

var $72hSd = parcelRequire("72hSd");
const $9e0dba7cf2cd78f3$export$ea5afb805e0643ce = (validation, fieldLabel, intl, numberValue)=>{
    if (Object.keys(validation).length === 0) return [];
    if (!numberValue) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    const { number: number } = numberValue;
    if (validation.wholeNumbersOnly && !Number.isInteger(number)) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $72hSd.messages).wholeNumbersOnly))
    ];
    // Check equal
    if (validation.minimumNumber && validation.minimumNumber === validation.maximumNumber && number !== validation.minimumNumber) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $72hSd.messages).exactNumber, {
            number: validation.minimumNumber
        }))
    ];
    // check between
    if (validation.minimumNumber && validation.maximumNumber && (number < validation.minimumNumber || number > validation.maximumNumber)) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $72hSd.messages).betweenNumber, {
            minimum: validation.minimumNumber,
            maximum: validation.maximumNumber
        }))
    ];
    if (validation.minimumNumber && number < validation.minimumNumber) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $72hSd.messages).minimumNumber, {
            minimum: validation.minimumNumber
        }))
    ];
    if (validation.maximumNumber && number > validation.maximumNumber) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $72hSd.messages).maximumNumber, {
            maximum: validation.maximumNumber
        }))
    ];
    return [];
};

});
parcelRegister("72hSd", function(module, exports) {
$parcel$export(module.exports, "messages", () => $db029940a4e174c2$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $db029940a4e174c2$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenNumber: {
        id: 'proforma-form-renderer.common.utils.validators.number.between-number',
        defaultMessage: 'Must be between {minimum} and {maximum}.',
        description: 'Validation message for field with number between a range.'
    },
    exactNumber: {
        id: 'proforma-form-renderer.common.utils.validators.number.exact-number',
        defaultMessage: 'Must be exactly {number}.',
        description: 'Validation message for field with exact number.'
    },
    maximumNumber: {
        id: 'proforma-form-renderer.common.utils.validators.number.maximum-number',
        defaultMessage: 'Must be less than or equal to {maximum}.',
        description: 'Validation message for field with maximum number.'
    },
    minimumNumber: {
        id: 'proforma-form-renderer.common.utils.validators.number.minimum-number',
        defaultMessage: 'Must be more than or equal to {minimum}.',
        description: 'Validation message for field with minimum number.'
    },
    wholeNumbersOnly: {
        id: 'proforma-form-renderer.common.utils.validators.number.whole-numbers-only',
        defaultMessage: 'Must be a whole number.',
        description: 'Validation message for field with whole numbers only.'
    }
});

});


parcelRegister("euTuW", function(module, exports) {
$parcel$export(module.exports, "getOptionValidationErrors", () => $69f8c7affa855be3$export$b5701d6645b2e875);

var $82gbm = parcelRequire("82gbm");

var $j15pg = parcelRequire("j15pg");

var $3vIul = parcelRequire("3vIul");
const $69f8c7affa855be3$var$optionIsSelected = (selectedOptionIds, optionId)=>selectedOptionIds.includes(optionId) || selectedOptionIds.map((id)=>id.split(':')[0]).includes(optionId.toString());
const $69f8c7affa855be3$export$b5701d6645b2e875 = (options, validation, fieldLabel, intl, option)=>{
    var _option$options, _validation$requiredO;
    if (Object.keys(validation).length === 0) return [];
    if (!option) {
        if (validation.required) return [
            (0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl)
        ];
        return [];
    }
    const numOptionsSelected = (((_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.length) ?? 0) + (option.otherOptionText !== undefined ? 1 : 0);
    const validationErrors = [];
    // Validate required
    if (validation.required) {
        if (numOptionsSelected === 0) validationErrors.push((0, $j15pg.getFailedRequiredValidationError)(fieldLabel, intl));
    }
    if (!validation.required && numOptionsSelected === 0) return [];
    if (validation.minimumOptionSelections && validation.minimumOptionSelections === validation.maximumOptionSelections) // Check for exact num of options
    {
        if (numOptionsSelected !== validation.minimumOptionSelections) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $3vIul.messages).exactOptions, {
            minimum: validation.minimumOptionSelections
        })));
    } else if (validation.minimumOptionSelections && validation.maximumOptionSelections) // check for in between num of options
    {
        if (numOptionsSelected < validation.minimumOptionSelections || numOptionsSelected > validation.maximumOptionSelections) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $3vIul.messages).betweenOptions, {
            minimum: validation.minimumOptionSelections,
            maximum: validation.maximumOptionSelections
        })));
    } else {
        // min or max num of options
        if (validation.minimumOptionSelections && numOptionsSelected < validation.minimumOptionSelections) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $3vIul.messages).minimumOptions, {
            minimum: validation.minimumOptionSelections
        })));
        if (validation.maximumOptionSelections && numOptionsSelected > validation.maximumOptionSelections) validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $3vIul.messages).maximumOptions, {
            maximum: validation.maximumOptionSelections
        })));
    }
    const requiredOptionId = (_validation$requiredO = validation.requiredOption) === null || _validation$requiredO === void 0 ? void 0 : _validation$requiredO.id;
    if (requiredOptionId) {
        if (!$69f8c7affa855be3$var$optionIsSelected(option.options.map((c)=>c.id), requiredOptionId)) {
            var _validation$requiredO2;
            validationErrors.push((0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).REQUIRED, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $3vIul.messages).requiredOption, {
                label: ((_validation$requiredO2 = validation.requiredOption) === null || _validation$requiredO2 === void 0 ? void 0 : _validation$requiredO2.label) ?? requiredOptionId
            })));
        }
    }
    return validationErrors;
};

});
parcelRegister("3vIul", function(module, exports) {
$parcel$export(module.exports, "messages", () => $40105a36b1337b15$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $40105a36b1337b15$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    betweenOptions: {
        id: 'proforma-form-renderer.common.utils.validators.option.between-options',
        defaultMessage: 'Must select between {minimum} and {maximum, plural, one {# choice} other {# choices}}.',
        description: 'Validation message for field with number of choices between a range.'
    },
    exactOptions: {
        id: 'proforma-form-renderer.common.utils.validators.option.exact-options',
        defaultMessage: 'Must select exactly {minimum, plural, one {# choice} other {# choices}}.',
        description: 'Validation message for field with exact number of choices.'
    },
    maximumOptions: {
        id: 'proforma-form-renderer.common.utils.validators.option.maximum-options',
        defaultMessage: 'Must select less than or equal to {maximum, plural, one {# choice} other {# choices}}.',
        description: 'Validation message for field with maximum number of choices.'
    },
    minimumOptions: {
        id: 'proforma-form-renderer.common.utils.validators.option.minimum-options',
        defaultMessage: 'Must select more than or equal to {minimum, plural, one {# choice} other {# choices}}.',
        description: 'Validation message for field with minimum number of choices.'
    },
    requiredOption: {
        id: 'proforma-form-renderer.common.utils.validators.option.required-option',
        defaultMessage: "The \u2018{label}\u2019 choice is required.",
        description: 'Validation message for required choice field with given label.'
    }
});

});


parcelRegister("g4L6R", function(module, exports) {
$parcel$export(module.exports, "getUrlFormatErrors", () => $2d617345cdcec5a9$export$1112ac8046343d94);
$parcel$export(module.exports, "getUrlValidationErrors", () => $2d617345cdcec5a9$export$7476af1bd4b3d7e4);

var $82gbm = parcelRequire("82gbm");

var $jg5hp = parcelRequire("jg5hp");

var $j15pg = parcelRequire("j15pg");

var $kpE4p = parcelRequire("kpE4p");
const $2d617345cdcec5a9$var$urlRegex = /((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))/;
const $2d617345cdcec5a9$export$1112ac8046343d94 = (intl, textValue)=>{
    var _textValue$text;
    const text = textValue === null || textValue === void 0 || (_textValue$text = textValue.text) === null || _textValue$text === void 0 ? void 0 : _textValue$text.trim();
    if (text && !$2d617345cdcec5a9$var$urlRegex.test(text)) return [
        (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $kpE4p.messages).invalidUrl))
    ];
    return [];
};
const $2d617345cdcec5a9$export$7476af1bd4b3d7e4 = (validation, fieldLabel, intl, textValue)=>{
    if (textValue) {
        const { text: text } = textValue;
        const trimmedText = text.trim();
        if (!$2d617345cdcec5a9$var$urlRegex.test(trimmedText)) return [
            (0, $j15pg.getFailedValidationError)((0, $82gbm.ErrorKeySet).INVALID, intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $kpE4p.messages).invalidUrl))
        ];
    }
    return (0, $jg5hp.getTextValidationErrors)(validation, fieldLabel, intl, textValue);
};

});
parcelRegister("kpE4p", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1546ca61b8159ae6$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $1546ca61b8159ae6$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    invalidUrl: {
        id: 'proforma-form-renderer.common.utils.validators.url.invalid-url',
        defaultMessage: 'Must be a valid URL e.g. https://www.google.com/images',
        description: 'Validation message for field with invalid URL.'
    }
});

});



parcelRegister("i0Lo9", function(module, exports) {
$parcel$export(module.exports, "actions", () => $9d1ae6a1e7fdf5df$export$e324594224ef24da);

var $ax6EE = parcelRequire("ax6EE");

var $5ZONa = parcelRequire("5ZONa");

var $4yFkY = parcelRequire("4yFkY");

var $8kFFN = parcelRequire("8kFFN");

var $bN6Ub = parcelRequire("bN6Ub");

var $ksVZU = parcelRequire("ksVZU");

var $3VxG4 = parcelRequire("3VxG4");
const $9d1ae6a1e7fdf5df$export$e324594224ef24da = {
    clearModifiedValues: $ax6EE.clearModifiedValues,
    getFieldIdsFailingValidation: $5ZONa.getFieldIdsFailingValidation,
    getVisibleFieldValues: $8kFFN.getVisibleFieldValues,
    getFieldValues: $4yFkY.getFieldValues,
    setFieldCustomErrors: $bN6Ub.setFieldCustomErrors,
    setFormRendererProps: $ksVZU.setFormRendererProps,
    updateModifiedValue: $3VxG4.updateModifiedValue
};

});
parcelRegister("ax6EE", function(module, exports) {
$parcel$export(module.exports, "clearModifiedValues", () => $aa2fc47071ca86dd$export$bfa216bccb0b16d7);
const $aa2fc47071ca86dd$export$bfa216bccb0b16d7 = ()=>({ setState: setState })=>{
        setState({
            modifiedValues: {}
        });
    };

});

parcelRegister("5ZONa", function(module, exports) {
$parcel$export(module.exports, "getFieldIdsFailingValidation", () => $e041bdae1732ec4a$export$369ae63f53afbb7c);

var $gvi18 = parcelRequire("gvi18");

var $j0o1C = parcelRequire("j0o1C");
const $e041bdae1732ec4a$export$369ae63f53afbb7c = (validationTargets, formFields)=>({ getState: getState })=>{
        const state = getState();
        const effectiveStateForSelector = validationTargets ? {
            ...formFields ? {
                ...state,
                formFields: formFields
            } : state,
            fieldValidation: {
                ...state.fieldValidation,
                validationTargets: validationTargets
            }
        } : {
            ...formFields ? {
                ...state,
                formFields: formFields
            } : state
        };
        const visibleFieldIds = (0, $j0o1C.getAllVisibleFieldIdsSelector)(effectiveStateForSelector);
        const failingFieldIds = visibleFieldIds.reduce((accFailingFieldIds, fieldId)=>{
            if ((0, $gvi18.fieldInvalidSelector)(effectiveStateForSelector, {
                fieldId: fieldId
            })) accFailingFieldIds.push(fieldId);
            return accFailingFieldIds;
        }, []);
        return failingFieldIds;
    };

});
parcelRegister("gvi18", function(module, exports) {
$parcel$export(module.exports, "fieldInvalidSelector", () => $05960b7749569e07$export$e35f4d21d9739426);

var $bBhJi = parcelRequire("bBhJi");

var $eyjhg = parcelRequire("eyjhg");

var $izEf6 = parcelRequire("izEf6");
const $05960b7749569e07$export$e35f4d21d9739426 = (0, $bBhJi.createSelector)((state)=>state, (_, props)=>props.fieldId, (0, $eyjhg.fieldCustomErrorSelector), (0, $izEf6.fieldValidationErrorsSelector), (_, __, customError, validationErrors)=>customError !== undefined || validationErrors.length > 0);

});
parcelRegister("eyjhg", function(module, exports) {
$parcel$export(module.exports, "fieldCustomErrorSelector", () => $fc039af4ad9cdc8f$export$f1a51f19283f0602);

var $bBhJi = parcelRequire("bBhJi");
const $fc039af4ad9cdc8f$export$f1a51f19283f0602 = (0, $bBhJi.createSelector)((state)=>state.fieldCustomErrors, (_, props)=>props.fieldId, (fieldCustomErrors, fieldId)=>fieldCustomErrors[fieldId]);

});

parcelRegister("izEf6", function(module, exports) {
$parcel$export(module.exports, "fieldValidationErrorsSelector", () => $9563c0b5869f6eaa$export$74cdb3311f59e375);

var $bBhJi = parcelRequire("bBhJi");

var $82gbm = parcelRequire("82gbm");

var $4HPol = parcelRequire("4HPol");

var $bPSmO = parcelRequire("bPSmO");
const $9563c0b5869f6eaa$var$getValidationErrorsForField = (field, defaultValidators, currentValue, validators)=>{
    const fieldType = field.type;
    const validator = (validators === null || validators === void 0 ? void 0 : validators[fieldType]) ?? defaultValidators[fieldType];
    if (validator) return validator(field, defaultValidators, currentValue);
    return [];
};
const $9563c0b5869f6eaa$export$74cdb3311f59e375 = (0, $bBhJi.createSelector)((state)=>({
        formFields: state.formFields,
        fieldValidation: state.fieldValidation,
        defaultValidators: state.defaultValidators,
        securityCriticalValidators: state.securityCriticalValidators
    }), (_, props)=>props.fieldId, (0, $4HPol.currentValueSelector), (0, $bPSmO.fieldValidationEnabledSelector), ({ formFields: formFields, fieldValidation: fieldValidation, defaultValidators: defaultValidators, securityCriticalValidators: securityCriticalValidators }, fieldId, currentValue, validationEnabled)=>{
    var _fieldValidation$vali;
    if (!validationEnabled) return [];
    const field = formFields[fieldId];
    if (field === undefined) return [];
    const isSecurityCritical = ((_fieldValidation$vali = fieldValidation.validationTargets) === null || _fieldValidation$vali === void 0 ? void 0 : _fieldValidation$vali.fieldSet) === (0, $82gbm.ValidationFieldSet).SECURITY_CRITICAL;
    return $9563c0b5869f6eaa$var$getValidationErrorsForField(field, defaultValidators, currentValue, isSecurityCritical ? securityCriticalValidators : fieldValidation.validators);
});

});
parcelRegister("4HPol", function(module, exports) {
$parcel$export(module.exports, "currentValueSelector", () => $46b081d3461095bd$export$35b57de650ca1ef5);

var $bBhJi = parcelRequire("bBhJi");
const $46b081d3461095bd$export$35b57de650ca1ef5 = (0, $bBhJi.createSelector)((state)=>state.formFields, (state)=>state.modifiedValues, (_, props)=>props.fieldId, (formFields, modifiedValues, fieldId)=>{
    var _formFields$fieldId;
    return fieldId in modifiedValues ? modifiedValues[fieldId] ?? undefined : (_formFields$fieldId = formFields[fieldId]) === null || _formFields$fieldId === void 0 ? void 0 : _formFields$fieldId.value;
});

});

parcelRegister("bPSmO", function(module, exports) {
$parcel$export(module.exports, "fieldValidationEnabledSelector", () => $3c04f2da4f4ed6fc$export$1b62bbbfa6169d62);

var $bBhJi = parcelRequire("bBhJi");

var $82gbm = parcelRequire("82gbm");

var $2nfpZ = parcelRequire("2nfpZ");
const $3c04f2da4f4ed6fc$var$SECURITY_CRITICAL_FIELD_TYPES = new Set([
    (0, $2nfpZ.FormFieldType).URL,
    (0, $2nfpZ.FormFieldType).EMAIL
]);
const $3c04f2da4f4ed6fc$export$1b62bbbfa6169d62 = (0, $bBhJi.createSelector)((state)=>state.fieldValidation, (state)=>state.modifiedValues, (state)=>state.formFields, (_, props)=>props.fieldId, (fieldValidation, modifiedValues, formFields, fieldId)=>{
    var _fieldValidation$vali, _fieldValidation$vali2, _fieldValidation$vali3, _fieldValidation$vali4;
    if ((_fieldValidation$vali = fieldValidation.validationTargets) !== null && _fieldValidation$vali !== void 0 && (_fieldValidation$vali = _fieldValidation$vali.fieldIds) !== null && _fieldValidation$vali !== void 0 && _fieldValidation$vali.includes(fieldId)) return true;
    if (((_fieldValidation$vali2 = fieldValidation.validationTargets) === null || _fieldValidation$vali2 === void 0 ? void 0 : _fieldValidation$vali2.fieldSet) === (0, $82gbm.ValidationFieldSet).ALL_FIELDS) return true;
    if (((_fieldValidation$vali3 = fieldValidation.validationTargets) === null || _fieldValidation$vali3 === void 0 ? void 0 : _fieldValidation$vali3.fieldSet) === (0, $82gbm.ValidationFieldSet).MODIFIED_FIELDS && modifiedValues[fieldId] !== undefined) return true;
    if (((_fieldValidation$vali4 = fieldValidation.validationTargets) === null || _fieldValidation$vali4 === void 0 ? void 0 : _fieldValidation$vali4.fieldSet) === (0, $82gbm.ValidationFieldSet).SECURITY_CRITICAL) {
        const field = formFields[fieldId];
        return field !== undefined && $3c04f2da4f4ed6fc$var$SECURITY_CRITICAL_FIELD_TYPES.has(field.type);
    }
    return false;
});

});



parcelRegister("j0o1C", function(module, exports) {
$parcel$export(module.exports, "getAllVisibleFieldIdsSelector", () => $ac69ecf073c58585$export$50f298d773107bd2);

var $bBhJi = parcelRequire("bBhJi");

var $dmeMl = parcelRequire("dmeMl");

var $cl2bG = parcelRequire("cl2bG");

var $9Mnjx = parcelRequire("9Mnjx");
const $ac69ecf073c58585$export$50f298d773107bd2 = (0, $bBhJi.createSelector)((state)=>state.formSections, (state)=>state.formFields, (state)=>(0, $9Mnjx.currentValuesSelector)(state), (formSections, formFields, currentValues)=>{
    const visibleSections = (0, $dmeMl.filterVisibleSections)(formSections, formFields, currentValues);
    return visibleSections.flatMap((0, $cl2bG.getFieldIdsUnderSection));
});

});
parcelRegister("dmeMl", function(module, exports) {
$parcel$export(module.exports, "filterVisibleSections", () => $17dfe3ba32d710bc$export$bf5a12d217ccfe88);
$parcel$export(module.exports, "getSectionVisibilityMap", () => $17dfe3ba32d710bc$export$237a3a44cb4988a5);

var $9oPk5 = parcelRequire("9oPk5");

var $gw4Ft = parcelRequire("gw4Ft");

var $8WHj4 = parcelRequire("8WHj4");
const $17dfe3ba32d710bc$export$bf5a12d217ccfe88 = (formSections, formFields, currentValues)=>{
    const sectionVisibleStore = $17dfe3ba32d710bc$var$createSectionVisibleStore(formSections, formFields, currentValues);
    return formSections.filter((_, index)=>$17dfe3ba32d710bc$export$c3dbce4ddac238c9(index, sectionVisibleStore));
};
const $17dfe3ba32d710bc$export$237a3a44cb4988a5 = (formSections, formFields, currentValues)=>{
    const sectionVisibleStore = $17dfe3ba32d710bc$var$createSectionVisibleStore(formSections, formFields, currentValues);
    return new Map(formSections.map((_, index)=>[
            index,
            $17dfe3ba32d710bc$export$c3dbce4ddac238c9(index, sectionVisibleStore)
        ]));
};
const $17dfe3ba32d710bc$var$createSectionVisibleStore = (formSections, formFields, currentValues)=>({
        // this does not need to be created every render, if doing performance improvements, then pass question to section index map in
        questionToSectionIndexMap: $17dfe3ba32d710bc$var$createQuestionToSectionIndexMap(formSections),
        sectionVisibleCache: new Map(),
        sections: formSections,
        formFields: formFields,
        currentValues: currentValues
    });
const $17dfe3ba32d710bc$export$c3dbce4ddac238c9 = (sectionIndex, sectionVisibleStore)=>{
    const cached = sectionVisibleStore.sectionVisibleCache.get(sectionIndex);
    if (cached) return cached;
    const section = sectionVisibleStore.sections[sectionIndex];
    const value = !section.condition || $17dfe3ba32d710bc$var$isVisible(section.condition, $17dfe3ba32d710bc$export$d97f2b390b3a34a7(section.condition, sectionVisibleStore));
    sectionVisibleStore.sectionVisibleCache.set(sectionIndex, value);
    return value;
};
const $17dfe3ba32d710bc$var$isVisible = (condition, data)=>{
    if (data.hasError) // a condition either shows or hides a section. By default the condition is essentially 'off'
    // When the condition is set to 'hide' then the 'off' setting is to show the section.
    return condition.visibility === (0, $gw4Ft.Visibility).HIDE;
    return condition.visibility === (0, $gw4Ft.Visibility).SHOW && data.value || condition.visibility === (0, $gw4Ft.Visibility).HIDE && !data.value;
};
const $17dfe3ba32d710bc$export$d97f2b390b3a34a7 = (condition, sectionVisibleStore)=>{
    let accumulatedResult = {
        value: $17dfe3ba32d710bc$var$getInitialValue(condition.operator),
        hasError: false
    };
    for(let i = 0; i < condition.checkGroups.length; i += 1){
        const checkGroup = condition.checkGroups[i];
        const groupResult = $17dfe3ba32d710bc$var$evaluateCheckGroup(checkGroup, sectionVisibleStore);
        // Propagate errors immediately
        if (groupResult.hasError) return groupResult;
        // short circuit for OR operator
        if (condition.operator === (0, $gw4Ft.FormSectionConditionOperator).OR && groupResult.value === true) return groupResult;
        accumulatedResult = {
            value: $17dfe3ba32d710bc$var$applyLogicalOperator(accumulatedResult.value, groupResult.value, condition.operator),
            hasError: false
        };
    }
    return accumulatedResult;
};
const $17dfe3ba32d710bc$var$evaluateCheckGroup = (checkGroup, sectionVisibleStore)=>{
    let result = {
        value: $17dfe3ba32d710bc$var$getInitialValue(checkGroup.operator),
        hasError: false
    };
    for(let j = 0; j < checkGroup.checks.length; j += 1){
        const check = checkGroup.checks[j];
        const checkResult = $17dfe3ba32d710bc$var$calculateCheck(check, sectionVisibleStore);
        // Short-circuit on error to bubble up
        if (checkResult.hasError) return checkResult;
        result = {
            value: $17dfe3ba32d710bc$var$applyLogicalOperator(result.value, checkResult.value, checkGroup.operator),
            hasError: false
        };
    }
    return result;
};
// Identity elements for logical operators so we can start with a value that won't influence the result
const $17dfe3ba32d710bc$var$getInitialValue = (operator)=>{
    switch(operator){
        case (0, $gw4Ft.FormSectionConditionOperator).AND:
            return true;
        // true AND condition = condition
        case (0, $gw4Ft.FormSectionConditionOperator).OR:
            return false;
        // false OR condition = condition
        default:
            return true;
    }
};
const $17dfe3ba32d710bc$var$applyLogicalOperator = (previousValue, currentValue, operator)=>{
    switch(operator){
        case (0, $gw4Ft.FormSectionConditionOperator).AND:
            return previousValue && currentValue;
        case (0, $gw4Ft.FormSectionConditionOperator).OR:
            return previousValue || currentValue;
        default:
            return currentValue;
    }
};
const $17dfe3ba32d710bc$var$calculateCheck = (conditionCheck, sectionVisibleStore)=>{
    var _config$constraintChe;
    const formField = sectionVisibleStore.formFields[conditionCheck.fieldId];
    if (formField === undefined) return {
        value: false,
        hasError: true
    };
    const fieldType = formField.type;
    const fieldValue = sectionVisibleStore.currentValues[conditionCheck.fieldId];
    const config = (0, $8WHj4.fieldTypeToCheckConfigs)[fieldType] ?? undefined;
    if (config === undefined) return {
        value: false,
        hasError: true
    };
    const constraintCheck = ((_config$constraintChe = config.constraintChecks) === null || _config$constraintChe === void 0 ? void 0 : _config$constraintChe[conditionCheck.type]) ?? undefined;
    if (constraintCheck === undefined) return {
        value: false,
        hasError: true
    };
    const { constraint: constraint } = conditionCheck;
    if (fieldValue !== undefined && !config.typeGuard(fieldValue)) return {
        value: false,
        hasError: true
    };
    const parentSectionIndex = sectionVisibleStore.questionToSectionIndexMap.get(conditionCheck.fieldId);
    let value = constraintCheck(fieldValue, constraint);
    if (value && parentSectionIndex !== undefined) {
        const isParentVisible = $17dfe3ba32d710bc$export$c3dbce4ddac238c9(parentSectionIndex, sectionVisibleStore);
        value = isParentVisible;
    }
    return {
        value: value,
        hasError: false
    };
};
const $17dfe3ba32d710bc$var$createQuestionToSectionIndexMap = (formSections)=>{
    const questionToSectionIndexMap = new Map();
    formSections.forEach((section, index)=>section.layout.content.forEach((contentNode)=>// this handles recursive sections
            (0, $9oPk5.filter)(contentNode, (node)=>{
                if (!node.attrs || !node.attrs.parameters || !node.attrs.parameters.id) return false;
                return node.attrs.extensionKey === 'question';
            }).forEach((node)=>{
                var _node$attrs;
                const id = (_node$attrs = node.attrs) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.parameters) === null || _node$attrs === void 0 ? void 0 : _node$attrs.id;
                if (id) questionToSectionIndexMap.set(id.toString(), index);
            })));
    return questionToSectionIndexMap;
};

});
parcelRegister("gw4Ft", function(module, exports) {
$parcel$export(module.exports, "FormSectionConditionCheckType", () => $2c3fbdfa35700b7b$export$ef872f3e837d1dfa);
$parcel$export(module.exports, "FormSectionConditionOperator", () => $2c3fbdfa35700b7b$export$f74f3c9a79c3320f);
$parcel$export(module.exports, "Visibility", () => $2c3fbdfa35700b7b$export$5afe92775e3e701d);
const $2c3fbdfa35700b7b$export$ef872f3e837d1dfa = {
    // Option checks:
    ALL_OF: 'ALL_OF',
    BETWEEN: 'BETWEEN',
    // Exclusive of `minimum` and `maximum`.
    CONTAINS: 'CONTAINS',
    DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
    NONE_OF: 'NONE_OF',
    SOME_OF: 'SOME_OF',
    // String contents checks - e.g. option label; file name; text; etc.
    // Relativity checks - field types: date and/or time; number; text; etc.
    DOES_NOT_EQUAL: 'DOES_NOT_EQUAL',
    EQUAL_TO: 'EQUAL_TO',
    GREATER_THAN: 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
    LESS_THAN: 'LESS_THAN',
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    EMPTY: 'EMPTY',
    NOT_EMPTY: 'NOT_EMPTY'
};
const $2c3fbdfa35700b7b$export$f74f3c9a79c3320f = {
    AND: 'AND',
    OR: 'OR'
};
const $2c3fbdfa35700b7b$export$5afe92775e3e701d = {
    SHOW: 'show',
    HIDE: 'hide'
};

});

parcelRegister("8WHj4", function(module, exports) {
$parcel$export(module.exports, "fieldTypeToCheckConfigs", () => $3ce606a3e7b013bb$export$c1328af6260de467);

var $2nfpZ = parcelRequire("2nfpZ");

var $i86qj = parcelRequire("i86qj");

var $gw4Ft = parcelRequire("gw4Ft");

var $8eAbk = parcelRequire("8eAbk");

var $fLxLh = parcelRequire("fLxLh");

var $b3Dkb = parcelRequire("b3Dkb");

var $iLvlA = parcelRequire("iLvlA");

var $jzY2X = parcelRequire("jzY2X");

var $9Ryur = parcelRequire("9Ryur");
const $3ce606a3e7b013bb$var$basicOptionsConfig = {
    typeGuard: (0, $i86qj.isOptionsValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).NONE_OF]: (0, $iLvlA.optionsValueNoneOfCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).SOME_OF]: (0, $iLvlA.optionsValueSomeOfCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $iLvlA.optionsValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $iLvlA.optionsValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$extendedOptionsConfig = {
    typeGuard: (0, $i86qj.isOptionsValue),
    constraintChecks: {
        ...$3ce606a3e7b013bb$var$basicOptionsConfig.constraintChecks,
        [(0, $gw4Ft.FormSectionConditionCheckType).ALL_OF]: (0, $iLvlA.optionsValueEqualsCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $iLvlA.optionsValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $iLvlA.optionsValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$textConfig = {
    typeGuard: (0, $i86qj.isTextValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).CONTAINS]: (0, $jzY2X.textValueContainsCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_CONTAIN]: (0, $jzY2X.textValueDoesNotContainCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_EQUAL]: (0, $jzY2X.textValueDoesNotEqualCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EQUAL_TO]: (0, $jzY2X.textValueEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $jzY2X.textValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $jzY2X.textValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$dateConfig = {
    typeGuard: (0, $i86qj.isDateValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).EQUAL_TO]: (0, $8eAbk.dateValueEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_EQUAL]: (0, $8eAbk.dateValueDoesNotEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN]: (0, $8eAbk.dateValueGreaterThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN_OR_EQUAL_TO]: (0, $8eAbk.dateValueGreaterThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN]: (0, $8eAbk.dateValueLessThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN_OR_EQUAL_TO]: (0, $8eAbk.dateValueLessThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).BETWEEN]: (0, $8eAbk.dateValueBetweenCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $8eAbk.dateValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $8eAbk.dateValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$dateTimeConfig = {
    typeGuard: (0, $i86qj.isDateTimeValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).EQUAL_TO]: (0, $fLxLh.dateTimeValueEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_EQUAL]: (0, $fLxLh.dateTimeValueDoesNotEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN]: (0, $fLxLh.dateTimeValueGreaterThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN_OR_EQUAL_TO]: (0, $fLxLh.dateTimeValueGreaterThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN]: (0, $fLxLh.dateTimeValueLessThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN_OR_EQUAL_TO]: (0, $fLxLh.dateTimeValueLessThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).BETWEEN]: (0, $fLxLh.dateTimeValueBetweenCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $fLxLh.dateTimeValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $fLxLh.dateTimeValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$timeConfig = {
    typeGuard: (0, $i86qj.isLocalTimeValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).EQUAL_TO]: (0, $9Ryur.timeValueEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_EQUAL]: (0, $9Ryur.timeValueDoesNotEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN]: (0, $9Ryur.timeValueGreaterThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN_OR_EQUAL_TO]: (0, $9Ryur.timeValueGreaterThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN]: (0, $9Ryur.timeValueLessThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN_OR_EQUAL_TO]: (0, $9Ryur.timeValueLessThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).BETWEEN]: (0, $9Ryur.timeValueBetweenCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $9Ryur.timeValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $9Ryur.timeValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$var$numberConfig = {
    typeGuard: (0, $i86qj.isNumberValue),
    constraintChecks: {
        [(0, $gw4Ft.FormSectionConditionCheckType).EQUAL_TO]: (0, $b3Dkb.numberValueEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).DOES_NOT_EQUAL]: (0, $b3Dkb.numberValueDoesNotEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN]: (0, $b3Dkb.numberValueGreaterThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).GREATER_THAN_OR_EQUAL_TO]: (0, $b3Dkb.numberValueGreaterThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN]: (0, $b3Dkb.numberValueLessThanCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).LESS_THAN_OR_EQUAL_TO]: (0, $b3Dkb.numberValueLessThanOrEqualToCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).BETWEEN]: (0, $b3Dkb.numberValueBetweenCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $b3Dkb.numberValueEmptyCheck),
        [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $b3Dkb.numberValueNotEmptyCheck)
    }
};
const $3ce606a3e7b013bb$export$c1328af6260de467 = {
    [(0, $2nfpZ.FormFieldType).CASCADING_SELECT]: {
        typeGuard: (0, $i86qj.isOptionsValue),
        constraintChecks: {
            [(0, $gw4Ft.FormSectionConditionCheckType).NONE_OF]: (0, $iLvlA.cascadingValueNoneOfCheck),
            [(0, $gw4Ft.FormSectionConditionCheckType).SOME_OF]: (0, $iLvlA.cascadingValueSomeOfCheck),
            [(0, $gw4Ft.FormSectionConditionCheckType).EMPTY]: (0, $iLvlA.optionsValueEmptyCheck),
            [(0, $gw4Ft.FormSectionConditionCheckType).NOT_EMPTY]: (0, $iLvlA.optionsValueNotEmptyCheck)
        }
    },
    [(0, $2nfpZ.FormFieldType).RADIO]: $3ce606a3e7b013bb$var$basicOptionsConfig,
    [(0, $2nfpZ.FormFieldType).SINGLE_SELECT]: $3ce606a3e7b013bb$var$basicOptionsConfig,
    [(0, $2nfpZ.FormFieldType).MULTIPLE_SELECT]: $3ce606a3e7b013bb$var$extendedOptionsConfig,
    [(0, $2nfpZ.FormFieldType).CHECKBOX]: $3ce606a3e7b013bb$var$extendedOptionsConfig,
    [(0, $2nfpZ.FormFieldType).RATING]: $3ce606a3e7b013bb$var$numberConfig,
    [(0, $2nfpZ.FormFieldType).SCALE]: $3ce606a3e7b013bb$var$numberConfig,
    [(0, $2nfpZ.FormFieldType).DATE]: $3ce606a3e7b013bb$var$dateConfig,
    [(0, $2nfpZ.FormFieldType).DATE_TIME]: $3ce606a3e7b013bb$var$dateTimeConfig,
    [(0, $2nfpZ.FormFieldType).LOCAL_TIME]: $3ce606a3e7b013bb$var$timeConfig,
    [(0, $2nfpZ.FormFieldType).NUMBER]: $3ce606a3e7b013bb$var$numberConfig,
    [(0, $2nfpZ.FormFieldType).LONG_TEXT]: $3ce606a3e7b013bb$var$textConfig,
    [(0, $2nfpZ.FormFieldType).EMAIL]: $3ce606a3e7b013bb$var$textConfig,
    [(0, $2nfpZ.FormFieldType).PARAGRAPH]: $3ce606a3e7b013bb$var$textConfig,
    [(0, $2nfpZ.FormFieldType).SHORT_TEXT]: $3ce606a3e7b013bb$var$textConfig,
    [(0, $2nfpZ.FormFieldType).URL]: $3ce606a3e7b013bb$var$textConfig
};

});
parcelRegister("8eAbk", function(module, exports) {
$parcel$export(module.exports, "dateValueEqualToCheck", () => $9b4acd2bb9f7c8b9$export$662b8358fd18efc8);
$parcel$export(module.exports, "dateValueDoesNotEqualToCheck", () => $9b4acd2bb9f7c8b9$export$c6bcf64f8206faf8);
$parcel$export(module.exports, "dateValueGreaterThanCheck", () => $9b4acd2bb9f7c8b9$export$9c615065c19840af);
$parcel$export(module.exports, "dateValueGreaterThanOrEqualToCheck", () => $9b4acd2bb9f7c8b9$export$5146a4d33c391668);
$parcel$export(module.exports, "dateValueLessThanCheck", () => $9b4acd2bb9f7c8b9$export$bd5d466d3d5c654);
$parcel$export(module.exports, "dateValueLessThanOrEqualToCheck", () => $9b4acd2bb9f7c8b9$export$79b37f4ca1a7d336);
$parcel$export(module.exports, "dateValueBetweenCheck", () => $9b4acd2bb9f7c8b9$export$377c22ca2d67bc6c);
$parcel$export(module.exports, "dateValueEmptyCheck", () => $9b4acd2bb9f7c8b9$export$77af15fd01a62b55);
$parcel$export(module.exports, "dateValueNotEmptyCheck", () => $9b4acd2bb9f7c8b9$export$8a306506421ebd2d);
var $9b4acd2bb9f7c8b9$export$b3f55ef7f087e744 = /*#__PURE__*/ function(DateUnit) {
    DateUnit["DAYS"] = "days";
    DateUnit["WEEKS"] = "weeks";
    DateUnit["MONTHS"] = "months";
    return DateUnit;
}({});
const $9b4acd2bb9f7c8b9$export$662b8358fd18efc8 = (value, constraint)=>value !== undefined && value.date === constraint[0];
const $9b4acd2bb9f7c8b9$export$c6bcf64f8206faf8 = (value, constraint)=>value === undefined || value.date !== constraint[0];
const $9b4acd2bb9f7c8b9$export$9c615065c19840af = (value, constraint)=>value !== undefined && value.date > constraint[0];
const $9b4acd2bb9f7c8b9$export$5146a4d33c391668 = (value, constraint)=>value !== undefined && value.date >= constraint[0];
const $9b4acd2bb9f7c8b9$export$bd5d466d3d5c654 = (value, constraint)=>value !== undefined && value.date < constraint[0];
const $9b4acd2bb9f7c8b9$export$79b37f4ca1a7d336 = (value, constraint)=>value !== undefined && value.date <= constraint[0];
const $9b4acd2bb9f7c8b9$export$377c22ca2d67bc6c = (value, constraint)=>{
    if (value === undefined) return false;
    const min = constraint[0];
    const max = constraint[1];
    return value.date >= min && value.date <= max;
};
const $9b4acd2bb9f7c8b9$export$77af15fd01a62b55 = (value)=>value === undefined || !value.date;
const $9b4acd2bb9f7c8b9$export$8a306506421ebd2d = (value)=>value !== undefined && !!value.date;

});

parcelRegister("fLxLh", function(module, exports) {
$parcel$export(module.exports, "dateTimeValueEqualToCheck", () => $906907dfba756140$export$2a5cb0d238f3c3ba);
$parcel$export(module.exports, "dateTimeValueDoesNotEqualToCheck", () => $906907dfba756140$export$f10f23fac5e65307);
$parcel$export(module.exports, "dateTimeValueGreaterThanCheck", () => $906907dfba756140$export$951286cde9156c23);
$parcel$export(module.exports, "dateTimeValueGreaterThanOrEqualToCheck", () => $906907dfba756140$export$750544e49e830b45);
$parcel$export(module.exports, "dateTimeValueLessThanCheck", () => $906907dfba756140$export$3950488be8491438);
$parcel$export(module.exports, "dateTimeValueLessThanOrEqualToCheck", () => $906907dfba756140$export$dfe87d0bc4cf0d99);
$parcel$export(module.exports, "dateTimeValueBetweenCheck", () => $906907dfba756140$export$67b4b77b959cc4da);
$parcel$export(module.exports, "dateTimeValueEmptyCheck", () => $906907dfba756140$export$4dd76d6f398a1295);
$parcel$export(module.exports, "dateTimeValueNotEmptyCheck", () => $906907dfba756140$export$e5b60994d9d83ee9);
var $906907dfba756140$export$d1ae7f29709f9edc = /*#__PURE__*/ function(DateTimeUnit) {
    DateTimeUnit["HOURS"] = "hours";
    DateTimeUnit["DAYS"] = "days";
    DateTimeUnit["WEEKS"] = "weeks";
    DateTimeUnit["MONTHS"] = "months";
    return DateTimeUnit;
}({});
// Converts DateTime to ISO string for comparison (YYYY-MM-DDTHH:mm:ss format)
// Returns empty string if either date or time is missing
const $906907dfba756140$var$getDateTimeString = (value)=>{
    if (!value.date || !value.localTime) return '';
    return `${value.date}T${value.localTime}`;
};
const $906907dfba756140$export$2a5cb0d238f3c3ba = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== '' && valueStr === constraint[0];
};
const $906907dfba756140$export$f10f23fac5e65307 = (value, constraint)=>{
    if (value === undefined) return true;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== constraint[0];
};
const $906907dfba756140$export$951286cde9156c23 = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== '' && valueStr > constraint[0];
};
const $906907dfba756140$export$750544e49e830b45 = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== '' && valueStr >= constraint[0];
};
const $906907dfba756140$export$3950488be8491438 = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== '' && valueStr < constraint[0];
};
const $906907dfba756140$export$dfe87d0bc4cf0d99 = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    return valueStr !== '' && valueStr <= constraint[0];
};
const $906907dfba756140$export$67b4b77b959cc4da = (value, constraint)=>{
    if (value === undefined) return false;
    const valueStr = $906907dfba756140$var$getDateTimeString(value);
    if (valueStr === '') return false;
    const min = constraint[0];
    const max = constraint[1];
    return valueStr >= min && valueStr <= max;
};
const $906907dfba756140$export$4dd76d6f398a1295 = (value)=>value === undefined || !value.date && !value.localTime;
const $906907dfba756140$export$e5b60994d9d83ee9 = (value)=>value !== undefined && (!!value.date || !!value.localTime);

});

parcelRegister("b3Dkb", function(module, exports) {
$parcel$export(module.exports, "numberValueEqualToCheck", () => $1e9c6d8055755a15$export$ed6875f468a5fdc1);
$parcel$export(module.exports, "numberValueDoesNotEqualToCheck", () => $1e9c6d8055755a15$export$f3fb2d47397909be);
$parcel$export(module.exports, "numberValueGreaterThanCheck", () => $1e9c6d8055755a15$export$d7af1af1367638ba);
$parcel$export(module.exports, "numberValueGreaterThanOrEqualToCheck", () => $1e9c6d8055755a15$export$7f761408ab4839e);
$parcel$export(module.exports, "numberValueLessThanCheck", () => $1e9c6d8055755a15$export$40322f3397aea334);
$parcel$export(module.exports, "numberValueLessThanOrEqualToCheck", () => $1e9c6d8055755a15$export$d3aa289d3fa1df88);
$parcel$export(module.exports, "numberValueBetweenCheck", () => $1e9c6d8055755a15$export$ca3cfde65e9baa00);
$parcel$export(module.exports, "numberValueEmptyCheck", () => $1e9c6d8055755a15$export$651091382bf1b634);
$parcel$export(module.exports, "numberValueNotEmptyCheck", () => $1e9c6d8055755a15$export$c427ffc3a8029bcb);
const $1e9c6d8055755a15$export$ed6875f468a5fdc1 = (value, constraint)=>value !== undefined && value.number === Number(constraint[0]);
const $1e9c6d8055755a15$export$f3fb2d47397909be = (value, constraint)=>value === undefined || value.number !== Number(constraint[0]);
const $1e9c6d8055755a15$export$d7af1af1367638ba = (value, constraint)=>value !== undefined && value.number > Number(constraint[0]);
const $1e9c6d8055755a15$export$7f761408ab4839e = (value, constraint)=>value !== undefined && value.number >= Number(constraint[0]);
const $1e9c6d8055755a15$export$40322f3397aea334 = (value, constraint)=>value !== undefined && value.number < Number(constraint[0]);
const $1e9c6d8055755a15$export$d3aa289d3fa1df88 = (value, constraint)=>value !== undefined && value.number <= Number(constraint[0]);
const $1e9c6d8055755a15$export$ca3cfde65e9baa00 = (value, constraint)=>{
    if (value === undefined) return false;
    const min = Number(constraint[0]);
    const max = Number(constraint[1]);
    return value.number >= min && value.number <= max;
};
const $1e9c6d8055755a15$export$651091382bf1b634 = (value)=>value === undefined || typeof value.number !== 'number';
const $1e9c6d8055755a15$export$c427ffc3a8029bcb = (value)=>value !== undefined && typeof value.number === 'number';

});

parcelRegister("iLvlA", function(module, exports) {
$parcel$export(module.exports, "optionsValueEqualsCheck", () => $abf096f145084bc9$export$2fc6ac51c44227d6);
$parcel$export(module.exports, "optionsValueSomeOfCheck", () => $abf096f145084bc9$export$eb6f39def97e9c2b);
$parcel$export(module.exports, "optionsValueNoneOfCheck", () => $abf096f145084bc9$export$a87c94b38d842e70);
$parcel$export(module.exports, "cascadingValueNoneOfCheck", () => $abf096f145084bc9$export$8c284222b72d0ccb);
$parcel$export(module.exports, "cascadingValueSomeOfCheck", () => $abf096f145084bc9$export$b15589de72371ebc);
$parcel$export(module.exports, "optionsValueEmptyCheck", () => $abf096f145084bc9$export$a3ea307a731e7241);
$parcel$export(module.exports, "optionsValueNotEmptyCheck", () => $abf096f145084bc9$export$7ee89f338197d9b2);

var $gjxgd = parcelRequire("gjxgd");
const $abf096f145084bc9$export$2fc6ac51c44227d6 = (value, constraint)=>{
    if (value === undefined) return false;
    const idSet = new Set([
        ...value.options.map((item)=>item.id) || [],
        ...value.otherOptionText !== undefined ? [
            (0, $gjxgd.OTHER_ID)
        ] : []
    ]);
    if (idSet.size !== constraint.length) return false;
    return constraint.every((option)=>idSet.has(option));
};
const $abf096f145084bc9$export$eb6f39def97e9c2b = (value, constraint)=>{
    if (value === undefined) return false;
    const idSet = new Set([
        ...value.options.map((item)=>item.id) || [],
        ...value.otherOptionText !== undefined ? [
            (0, $gjxgd.OTHER_ID)
        ] : []
    ]);
    return constraint.some((option)=>idSet.has(option));
};
const $abf096f145084bc9$export$a87c94b38d842e70 = (value, constraint)=>{
    if (value === undefined) return true;
    const idSet = new Set([
        ...value.options.map((item)=>item.id) || [],
        ...value.otherOptionText !== undefined ? [
            (0, $gjxgd.OTHER_ID)
        ] : []
    ]);
    return !constraint.some((option)=>idSet.has(option));
};
const $abf096f145084bc9$export$8c284222b72d0ccb = (value, constraint)=>!$abf096f145084bc9$export$b15589de72371ebc(value, constraint);
const $abf096f145084bc9$export$b15589de72371ebc = (value, constraint)=>{
    if (value === undefined) return false;
    const idSet = new Set(value.options.flatMap((item)=>[
            item.id,
            item.id.split(':')[0]
        ]));
    return constraint.some((option)=>idSet.has(option));
};
const $abf096f145084bc9$export$a3ea307a731e7241 = (value)=>value === undefined || value.options.length === 0 && !value.otherOptionText;
const $abf096f145084bc9$export$7ee89f338197d9b2 = (value)=>value !== undefined && (value.options.length > 0 || !!value.otherOptionText);

});
parcelRegister("gjxgd", function(module, exports) {
$parcel$export(module.exports, "FileStatus", () => $e7f37e6c6e29e806$export$c0d3d383dd22c384);
$parcel$export(module.exports, "OTHER_ID", () => $e7f37e6c6e29e806$export$10886ddc73d032c7);
$parcel$export(module.exports, "EMPTY_ADF", () => $e7f37e6c6e29e806$export$d001b008aa23412d);
const $e7f37e6c6e29e806$export$c0d3d383dd22c384 = {
    UPLOADING: 'uploading',
    UPLOADED: 'uploaded'
};
const $e7f37e6c6e29e806$export$10886ddc73d032c7 = '0';
const $e7f37e6c6e29e806$export$d001b008aa23412d = {
    version: 1,
    type: 'doc',
    content: []
};

});


parcelRegister("jzY2X", function(module, exports) {
$parcel$export(module.exports, "textValueContainsCheck", () => $c548c20cb9c3bd81$export$bb0cd207bfbeb9b0);
$parcel$export(module.exports, "textValueDoesNotContainCheck", () => $c548c20cb9c3bd81$export$e9a378788295b9a7);
$parcel$export(module.exports, "textValueEqualToCheck", () => $c548c20cb9c3bd81$export$3ff40d2526248726);
$parcel$export(module.exports, "textValueDoesNotEqualCheck", () => $c548c20cb9c3bd81$export$d33502108d59adca);
$parcel$export(module.exports, "textValueEmptyCheck", () => $c548c20cb9c3bd81$export$8bebd99a04b8361d);
$parcel$export(module.exports, "textValueNotEmptyCheck", () => $c548c20cb9c3bd81$export$579f4957eaaad914);
const $c548c20cb9c3bd81$export$bb0cd207bfbeb9b0 = (value, constraint)=>{
    var _constraint$;
    return value !== undefined && value.text.toLowerCase().includes((_constraint$ = constraint[0]) === null || _constraint$ === void 0 ? void 0 : _constraint$.toLowerCase());
};
const $c548c20cb9c3bd81$export$e9a378788295b9a7 = (value, constraint)=>{
    var _constraint$2;
    return value === undefined || !value.text.toLowerCase().includes((_constraint$2 = constraint[0]) === null || _constraint$2 === void 0 ? void 0 : _constraint$2.toLowerCase());
};
const $c548c20cb9c3bd81$export$3ff40d2526248726 = (value, constraint)=>value !== undefined && value.text === constraint[0];
const $c548c20cb9c3bd81$export$d33502108d59adca = (value, constraint)=>value === undefined || value.text !== constraint[0];
const $c548c20cb9c3bd81$export$8bebd99a04b8361d = (value)=>value === undefined || value.text.trim().length === 0;
const $c548c20cb9c3bd81$export$579f4957eaaad914 = (value)=>value !== undefined && value.text.trim().length > 0;

});

parcelRegister("9Ryur", function(module, exports) {
$parcel$export(module.exports, "timeValueEqualToCheck", () => $e0f5b3357ec94a8b$export$f2661f839348c9a4);
$parcel$export(module.exports, "timeValueDoesNotEqualToCheck", () => $e0f5b3357ec94a8b$export$b4c9b3fb8b8d9144);
$parcel$export(module.exports, "timeValueGreaterThanCheck", () => $e0f5b3357ec94a8b$export$8ac7f6d7d8cad72);
$parcel$export(module.exports, "timeValueGreaterThanOrEqualToCheck", () => $e0f5b3357ec94a8b$export$c92d83e1ee6da9c8);
$parcel$export(module.exports, "timeValueLessThanCheck", () => $e0f5b3357ec94a8b$export$855db020b10c8ba9);
$parcel$export(module.exports, "timeValueLessThanOrEqualToCheck", () => $e0f5b3357ec94a8b$export$1a29db20be0e4fbc);
$parcel$export(module.exports, "timeValueBetweenCheck", () => $e0f5b3357ec94a8b$export$a60968ef35d47fdd);
$parcel$export(module.exports, "timeValueEmptyCheck", () => $e0f5b3357ec94a8b$export$82fb7cfd09d8eb8e);
$parcel$export(module.exports, "timeValueNotEmptyCheck", () => $e0f5b3357ec94a8b$export$c8d3dffbe98e53f3);
var $e0f5b3357ec94a8b$export$d9e59215631231e3 = /*#__PURE__*/ function(TimeUnit) {
    TimeUnit["MINUTES"] = "minutes";
    TimeUnit["HOURS"] = "hours";
    return TimeUnit;
}({});
const $e0f5b3357ec94a8b$export$f2661f839348c9a4 = (value, constraint)=>value !== undefined && value.localTime === constraint[0];
const $e0f5b3357ec94a8b$export$b4c9b3fb8b8d9144 = (value, constraint)=>value === undefined || value.localTime !== constraint[0];
const $e0f5b3357ec94a8b$export$8ac7f6d7d8cad72 = (value, constraint)=>value !== undefined && value.localTime > constraint[0];
const $e0f5b3357ec94a8b$export$c92d83e1ee6da9c8 = (value, constraint)=>value !== undefined && value.localTime >= constraint[0];
const $e0f5b3357ec94a8b$export$855db020b10c8ba9 = (value, constraint)=>value !== undefined && value.localTime < constraint[0];
const $e0f5b3357ec94a8b$export$1a29db20be0e4fbc = (value, constraint)=>value !== undefined && value.localTime <= constraint[0];
const $e0f5b3357ec94a8b$export$a60968ef35d47fdd = (value, constraint)=>{
    if (value === undefined) return false;
    const min = constraint[0];
    const max = constraint[1];
    return value.localTime >= min && value.localTime <= max;
};
const $e0f5b3357ec94a8b$export$82fb7cfd09d8eb8e = (value)=>value === undefined || !value.localTime;
const $e0f5b3357ec94a8b$export$c8d3dffbe98e53f3 = (value)=>value !== undefined && !!value.localTime;

});



parcelRegister("cl2bG", function(module, exports) {
$parcel$export(module.exports, "getFieldIdsUnderSection", () => $ded43d53cd6d120d$export$848bd08473c8d2e7);
$parcel$export(module.exports, "isSectionLayoutEmpty", () => $ded43d53cd6d120d$export$7a06b531993d779e);

var $9oPk5 = parcelRequire("9oPk5");
const $ded43d53cd6d120d$export$848bd08473c8d2e7 = (section)=>(section.layout.content ?? []).flatMap((contentNode)=>(0, $9oPk5.filter)(contentNode, (node)=>{
            if (!node.attrs || !node.attrs.parameters) return false;
            const { id: id } = node.attrs.parameters;
            if (!(typeof id === 'string' && id.length > 0 || typeof id === 'number')) return false;
            return node.attrs.extensionKey === 'question';
        }).flatMap((node)=>node.attrs ? [
                String(node.attrs.parameters.id)
            ] : []));
const $ded43d53cd6d120d$export$7a06b531993d779e = (layout)=>{
    var _layout$content;
    return ((layout === null || layout === void 0 || (_layout$content = layout.content) === null || _layout$content === void 0 ? void 0 : _layout$content.length) ?? 0) === 0;
};

});

parcelRegister("9Mnjx", function(module, exports) {
$parcel$export(module.exports, "currentValuesSelector", () => $e8e3c47dbded8d92$export$666b1b139ffc424e);

var $bBhJi = parcelRequire("bBhJi");

var $i86qj = parcelRequire("i86qj");
const $e8e3c47dbded8d92$export$666b1b139ffc424e = (0, $bBhJi.createSelector)((state)=>state.formFields, (state)=>state.modifiedValues, (formFields, modifiedValues)=>Object.keys(formFields).reduce((currentValues, fieldId)=>{
        var _formFields$fieldId;
        const modifiedFieldValue = modifiedValues[fieldId];
        const modifiedFilesValue = (0, $i86qj.asModifiedFilesValue)(modifiedFieldValue);
        const sanitisedModifiedValue = modifiedFilesValue === undefined ? modifiedFieldValue : modifiedFilesValue === null ? null : {
            files: modifiedFilesValue.files
        };
        const currentValue = sanitisedModifiedValue || (sanitisedModifiedValue === null ? undefined : (_formFields$fieldId = formFields[fieldId]) === null || _formFields$fieldId === void 0 ? void 0 : _formFields$fieldId.value);
        return currentValue ? {
            ...currentValues,
            [fieldId]: currentValue
        } : currentValues;
    }, {}));

});



parcelRegister("4yFkY", function(module, exports) {
$parcel$export(module.exports, "getFieldValues", () => $370733ac2cbdc9f5$export$54119e4fbb06537c);

var $9Mnjx = parcelRequire("9Mnjx");
const $370733ac2cbdc9f5$export$54119e4fbb06537c = ()=>({ getState: getState })=>{
        const state = getState();
        const currentValues = (0, $9Mnjx.currentValuesSelector)(state);
        return currentValues;
    };

});

parcelRegister("8kFFN", function(module, exports) {
$parcel$export(module.exports, "getVisibleFieldValues", () => $e107c9e13d0544da$export$2bb0073e64016de1);

var $9Mnjx = parcelRequire("9Mnjx");

var $j0o1C = parcelRequire("j0o1C");
const $e107c9e13d0544da$export$2bb0073e64016de1 = ()=>({ getState: getState })=>{
        const state = getState();
        const currentValues = (0, $9Mnjx.currentValuesSelector)(state);
        const visibleFieldIds = (0, $j0o1C.getAllVisibleFieldIdsSelector)(state);
        return visibleFieldIds.reduce((accum, fieldId)=>({
                ...accum,
                [fieldId]: currentValues[fieldId]
            }), {});
    };

});

parcelRegister("bN6Ub", function(module, exports) {
$parcel$export(module.exports, "setFieldCustomErrors", () => $ce29d4e62b4f1bbe$export$5a3c327d34d67667);
const $ce29d4e62b4f1bbe$export$5a3c327d34d67667 = (fieldCustomErrors)=>({ setState: setState })=>setState({
            fieldCustomErrors: fieldCustomErrors
        });

});

parcelRegister("ksVZU", function(module, exports) {
$parcel$export(module.exports, "setFormRendererProps", () => $10470b31e8d95efd$export$6f06e0875c2d64fa);
const $10470b31e8d95efd$export$6f06e0875c2d64fa = (asyncFields, form, lifecycleHandlers, renderers, renderMode, fieldVisibility, fieldValidation, defaultValidators, attachmentConfiguration, securityCriticalValidators)=>({ setState: setState, getState: getState })=>{
        setState({
            asyncFields: asyncFields,
            formFields: form.fields,
            formSections: form.sections,
            lifecycleHandlers: lifecycleHandlers,
            renderers: renderers,
            renderMode: renderMode,
            fieldVisibility: fieldVisibility,
            fieldValidation: fieldValidation,
            defaultValidators: defaultValidators,
            securityCriticalValidators: securityCriticalValidators ?? getState().securityCriticalValidators,
            formId: form.id,
            attachmentConfiguration: attachmentConfiguration
        });
    };

});

parcelRegister("3VxG4", function(module, exports) {
$parcel$export(module.exports, "updateModifiedValue", () => $a694006153663a5b$export$35b4e256ae7bf1f8);

var $i86qj = parcelRequire("i86qj");

var $azuRz = parcelRequire("azuRz");
const $a694006153663a5b$export$35b4e256ae7bf1f8 = (fieldId, modifiedFieldValue)=>({ setState: setState, getState: getState })=>{
        var _lifecycleHandlers$Fo;
        const { lifecycleHandlers: lifecycleHandlers, modifiedValues: modifiedValues } = getState();
        setState({
            modifiedValues: {
                ...modifiedValues,
                [fieldId]: modifiedFieldValue
            }
        });
        // Sanitise the modifiedValue so we don't leak internal state, e.g. `fileStatus`
        const modifiedFilesValue = (0, $i86qj.asModifiedFilesValue)(modifiedFieldValue);
        const fieldValue = modifiedFilesValue === undefined ? modifiedFieldValue : modifiedFilesValue === null ? null : {
            files: modifiedFilesValue.files
        };
        (_lifecycleHandlers$Fo = lifecycleHandlers[(0, $azuRz.FormRendererLifecycleStage).FIELD_CHANGED]) === null || _lifecycleHandlers$Fo === void 0 || _lifecycleHandlers$Fo.call(lifecycleHandlers, {
            fieldId: fieldId,
            fieldValue: fieldValue,
            stage: (0, $azuRz.FormRendererLifecycleStage).FIELD_CHANGED
        });
    };

});
parcelRegister("azuRz", function(module, exports) {
$parcel$export(module.exports, "FormRendererLifecycleStage", () => $2125406a0361947e$export$d662c5383f50f6f9);
const $2125406a0361947e$export$d662c5383f50f6f9 = {
    ATTACHMENT_UPLOAD_END: 'attachmentUploadEnd',
    FIELD_CHANGED: 'fieldChanged',
    RENDER_COMPLETE: 'renderComplete'
};

});



parcelRegister("ZC397", function(module, exports) {
$parcel$export(module.exports, "formFieldSelector", () => $35908b25bd10569f$export$d21314b9f6c372ed);

var $bBhJi = parcelRequire("bBhJi");
const $35908b25bd10569f$export$d21314b9f6c372ed = (0, $bBhJi.createSelector)((state)=>state.formFields, (_, props)=>props.fieldId, (formFields, fieldId)=>formFields[fieldId]);

});

parcelRegister("40O90", function(module, exports) {
$parcel$export(module.exports, "attachmentConfigurationSelector", () => $9d529711e25d6cb6$export$7005497295933b59);

var $bBhJi = parcelRequire("bBhJi");
const $9d529711e25d6cb6$export$7005497295933b59 = (0, $bBhJi.createSelector)((state)=>state.attachmentConfiguration, (configuration)=>configuration);

});

parcelRegister("6Caju", function(module, exports) {
$parcel$export(module.exports, "fieldRequiredSelector", () => $13cb65497684c5f1$export$8a4bde0e734ccb0b);

var $bBhJi = parcelRequire("bBhJi");
const $13cb65497684c5f1$export$8a4bde0e734ccb0b = (0, $bBhJi.createSelector)((state)=>state.formFields, (_, props)=>props.fieldId, (formFields, fieldId)=>{
    var _formFields$fieldId;
    return ((_formFields$fieldId = formFields[fieldId]) === null || _formFields$fieldId === void 0 || (_formFields$fieldId = _formFields$fieldId.validation) === null || _formFields$fieldId === void 0 ? void 0 : _formFields$fieldId.required) ?? false;
});

});

parcelRegister("air4B", function(module, exports) {
$parcel$export(module.exports, "fileUploadProgressSelector", () => $57d5a17326a40362$export$d07947937ba9abd7);

var $bBhJi = parcelRequire("bBhJi");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");
const $57d5a17326a40362$export$d07947937ba9abd7 = (0, $bBhJi.createSelector)((state)=>state.modifiedValues, (modifiedValues)=>Object.values(modifiedValues).some((fieldValue)=>{
        var _asModifiedFilesValue;
        return ((_asModifiedFilesValue = (0, $i86qj.asModifiedFilesValue)(fieldValue)) === null || _asModifiedFilesValue === void 0 ? void 0 : _asModifiedFilesValue.fileStatus) === (0, $gjxgd.FileStatus).UPLOADING;
    }));

});

parcelRegister("aCDyQ", function(module, exports) {
$parcel$export(module.exports, "hasModifiedValuesSelector", () => $a7d5b05e05eecfd7$export$4fd4cafe1408720f);

var $bBhJi = parcelRequire("bBhJi");
const $a7d5b05e05eecfd7$export$4fd4cafe1408720f = (0, $bBhJi.createSelector)((state)=>state.modifiedValues, (modifiedValues)=>Object.keys(modifiedValues).length > 0);

});

parcelRegister("HuWcQ", function(module, exports) {
$parcel$export(module.exports, "lifecycleHandlersSelector", () => $b85aaacf0b2b20c1$export$bb79a9f71c20dd8e);

var $bBhJi = parcelRequire("bBhJi");
const $b85aaacf0b2b20c1$export$bb79a9f71c20dd8e = (0, $bBhJi.createSelector)((state)=>state.lifecycleHandlers, (lifecycleHandlers)=>lifecycleHandlers);

});

parcelRegister("jutXJ", function(module, exports) {
$parcel$export(module.exports, "renderModeSelector", () => $17c59a8efbb1af90$export$85a35ba46d7d4a7a);

var $bBhJi = parcelRequire("bBhJi");
const $17c59a8efbb1af90$export$85a35ba46d7d4a7a = (0, $bBhJi.createSelector)((state)=>state.renderMode, (renderMode)=>renderMode);

});

parcelRegister("5sdW4", function(module, exports) {
$parcel$export(module.exports, "renderersSelector", () => $c3c03e9707adde4c$export$8dd35f93e7301aa2);

var $bBhJi = parcelRequire("bBhJi");
const $c3c03e9707adde4c$export$8dd35f93e7301aa2 = (0, $bBhJi.createSelector)((state)=>state.renderers, (renderers)=>renderers);

});

parcelRegister("a5VDB", function(module, exports) {
$parcel$export(module.exports, "totalFormAttachmentsSelector", () => $66c4330fadb197b4$export$94d8c91ca595ffb9);

var $bBhJi = parcelRequire("bBhJi");

var $i86qj = parcelRequire("i86qj");

var $9Mnjx = parcelRequire("9Mnjx");
const $66c4330fadb197b4$export$94d8c91ca595ffb9 = (0, $bBhJi.createSelector)((0, $9Mnjx.currentValuesSelector), (currentValues)=>Object.values(currentValues).map((0, $i86qj.asFilesValue)).reduce((totalFiles, currentFilesValue)=>totalFiles + ((currentFilesValue === null || currentFilesValue === void 0 ? void 0 : currentFilesValue.files.length) ?? 0), 0));

});


parcelRegister("UUFWv", function(module, exports) {
$parcel$export(module.exports, "FormRenderer", () => $c5a8b35308b49a27$export$264ccba4570be827);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $tLWYq = parcelRequire("tLWYq");

var $64ZSD = parcelRequire("64ZSD");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $2OYZx = parcelRequire("2OYZx");

var $4ve8e = parcelRequire("4ve8e");

var $5JwFL = parcelRequire("5JwFL");

var $8GL6u = parcelRequire("8GL6u");

var $dU4Mb = parcelRequire("dU4Mb");

var $fw22C = parcelRequire("fw22C");
const $c5a8b35308b49a27$var$formContainerStyles = (0, $9BVpB.xcss)({
    height: 'auto',
    overflow: 'visible',
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.subtle'
});
const $c5a8b35308b49a27$var$environment = window.location.hostname === 'localhost' ? 'staging' : undefined; // Make smart links connect to staging when developing locally.
const $c5a8b35308b49a27$var$smartCardClient = new (0, $tLWYq.default)($c5a8b35308b49a27$var$environment);
const $c5a8b35308b49a27$var$FormRendererInner = ({ asyncFields: asyncFields = {}, form: form, lifecycleHandlers: lifecycleHandlers = {}, renderers: renderers = {}, renderMode: renderMode, fieldVisibility: fieldVisibility, fieldValidation: fieldValidation, attachmentConfiguration: attachmentConfiguration })=>{
    const intl = (0, $4vLTk.default)();
    const { setFormRendererProps: setFormRendererProps } = (0, $5JwFL.useFormRendererActions)();
    const defaultFormFieldValidators = (0, $bSJIT.useMemo)(()=>(0, $4ve8e.buildDefaultFormFieldValidators)(intl), [
        intl
    ]);
    const securityCriticalFormFieldValidators = (0, $bSJIT.useMemo)(()=>(0, $4ve8e.buildSecurityCriticalValidators)(intl), [
        intl
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setFormRendererProps(asyncFields, form, lifecycleHandlers, renderers, renderMode, fieldVisibility, fieldValidation, defaultFormFieldValidators, attachmentConfiguration, securityCriticalFormFieldValidators);
    }, [
        asyncFields,
        defaultFormFieldValidators,
        securityCriticalFormFieldValidators,
        form,
        setFormRendererProps,
        lifecycleHandlers,
        renderers,
        renderMode,
        fieldVisibility,
        fieldValidation,
        attachmentConfiguration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $c5a8b35308b49a27$var$formContainerStyles,
        testId: "proforma-form-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fw22C.FormSections), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dU4Mb.FormRenderSuccess), {
        lifecycleHandlers: lifecycleHandlers
    }));
};
const $c5a8b35308b49a27$export$264ccba4570be827 = ({ asyncFields: asyncFields = {}, form: form, lifecycleHandlers: lifecycleHandlers = {}, renderers: renderers = {}, locale: locale, renderMode: renderMode, fieldVisibility: fieldVisibility, fieldValidation: fieldValidation, attachmentConfiguration: attachmentConfiguration })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2OYZx.ProformaIntlProvider), {
        messages: (0, $8GL6u.default),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $64ZSD.SmartCardProvider), {
        client: $c5a8b35308b49a27$var$smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c5a8b35308b49a27$var$FormRendererInner, {
        asyncFields: asyncFields,
        form: form,
        lifecycleHandlers: lifecycleHandlers,
        renderers: renderers,
        locale: locale,
        renderMode: renderMode,
        fieldVisibility: fieldVisibility,
        fieldValidation: fieldValidation,
        attachmentConfiguration: attachmentConfiguration
    })));
};

});
parcelRegister("8GL6u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6efc1e70e5f24be$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utilities.
 */ 
























const $b6efc1e70e5f24be$var$lazyMessages = {
    cs: ()=>(parcelRequire("ji7gU")),
    da: ()=>(parcelRequire("gFpId")),
    de: ()=>(parcelRequire("8nXCg")),
    en: ()=>(parcelRequire("84bLQ")),
    en_GB: ()=>(parcelRequire("81Lo5")),
    en_ZZ: ()=>(parcelRequire("h39Ae")),
    es: ()=>(parcelRequire("fDF8i")),
    fi: ()=>(parcelRequire("5RmoW")),
    fr: ()=>(parcelRequire("9QxTG")),
    hu: ()=>(parcelRequire("i5tYN")),
    it: ()=>(parcelRequire("keQUs")),
    ja: ()=>(parcelRequire("isDkz")),
    ko: ()=>(parcelRequire("8ehF1")),
    nb: ()=>(parcelRequire("lTA0x")),
    nl: ()=>(parcelRequire("f5OSi")),
    pl: ()=>(parcelRequire("basfP")),
    pt_BR: ()=>(parcelRequire("S1xbJ")),
    ru: ()=>(parcelRequire("iywv1")),
    sv: ()=>(parcelRequire("bMZUg")),
    th: ()=>(parcelRequire("ayb5d")),
    tr: ()=>(parcelRequire("8ZrYu")),
    uk: ()=>(parcelRequire("1O8sc")),
    vi: ()=>(parcelRequire("fvNEF")),
    zh: ()=>(parcelRequire("aeLSE")),
    zh_TW: ()=>(parcelRequire("8cBaf"))
};
var $b6efc1e70e5f24be$export$2e2bcd8739ae039 = $b6efc1e70e5f24be$var$lazyMessages;

});
parcelRegister("ji7gU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fgeoO").then(()=>parcelRequire('iqU51'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("gFpId", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lHy5t").then(()=>parcelRequire('drv4P'));

});

parcelRegister("8nXCg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("96TXW").then(()=>parcelRequire('b841n'));

});

parcelRegister("84bLQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3Y42l").then(()=>parcelRequire('dSPP1'));

});

parcelRegister("81Lo5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9WlO9").then(()=>parcelRequire('5w7xj'));

});

parcelRegister("h39Ae", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aTBge").then(()=>parcelRequire('geNLj'));

});

parcelRegister("fDF8i", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ahcgP").then(()=>parcelRequire('8em61'));

});

parcelRegister("5RmoW", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8vh7N").then(()=>parcelRequire('bDqvf'));

});

parcelRegister("9QxTG", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6rlW9").then(()=>parcelRequire('lJX8u'));

});

parcelRegister("i5tYN", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("83V1h").then(()=>parcelRequire('8n35i'));

});

parcelRegister("keQUs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3Hike").then(()=>parcelRequire('4w4SN'));

});

parcelRegister("isDkz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6VAtr").then(()=>parcelRequire('eC2mv'));

});

parcelRegister("8ehF1", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("f9kF6").then(()=>parcelRequire('aGU1M'));

});

parcelRegister("lTA0x", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6X3Cy").then(()=>parcelRequire('9adoG'));

});

parcelRegister("f5OSi", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iPStz").then(()=>parcelRequire('2Fthw'));

});

parcelRegister("basfP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("av9pK").then(()=>parcelRequire('a6hJ7'));

});

parcelRegister("S1xbJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dX8pJ").then(()=>parcelRequire('cRS1p'));

});

parcelRegister("iywv1", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dxg7Z").then(()=>parcelRequire('75qvb'));

});

parcelRegister("bMZUg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fQRB8").then(()=>parcelRequire('lfUkW'));

});

parcelRegister("ayb5d", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fH9fw").then(()=>parcelRequire('aW4yl'));

});

parcelRegister("8ZrYu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4gG3r").then(()=>parcelRequire('gG0uf'));

});

parcelRegister("1O8sc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gREpF").then(()=>parcelRequire('a5mrx'));

});

parcelRegister("fvNEF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eKgW3").then(()=>parcelRequire('hOEUg'));

});

parcelRegister("aeLSE", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("f8HwN").then(()=>parcelRequire('02eSF'));

});

parcelRegister("8cBaf", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gfC1Z").then(()=>parcelRequire('73QvY'));

});


parcelRegister("dU4Mb", function(module, exports) {
$parcel$export(module.exports, "FormRenderSuccess", () => $defc090d97ade7af$export$6fd31877a2e49b1b);

var $bSJIT = parcelRequire("bSJIT");

var $azuRz = parcelRequire("azuRz");
const $defc090d97ade7af$export$6fd31877a2e49b1b = ({ lifecycleHandlers: lifecycleHandlers })=>{
    const formRenderSuccessCallback = lifecycleHandlers[(0, $azuRz.FormRendererLifecycleStage).RENDER_COMPLETE];
    (0, $bSJIT.useLayoutEffect)(()=>formRenderSuccessCallback && formRenderSuccessCallback({
            stage: (0, $azuRz.FormRendererLifecycleStage).RENDER_COMPLETE
        }), [
        formRenderSuccessCallback
    ]);
    return null;
};

});

parcelRegister("fw22C", function(module, exports) {
$parcel$export(module.exports, "FormSections", () => $6dbadcc692492f47$export$276f2aa4ba2a046b);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $7WQx2 = parcelRequire("7WQx2");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $8wHrE = parcelRequire("8wHrE");

var $dmeMl = parcelRequire("dmeMl");

var $5JwFL = parcelRequire("5JwFL");

var $f0QJc = parcelRequire("f0QJc");

var $j8FrW = parcelRequire("j8FrW");
const $6dbadcc692492f47$var$hiddenSectionContainerStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    padding: 'space.050'
});
const $6dbadcc692492f47$var$hiddenSectionWrapperStyles = (0, $9BVpB.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.disabled',
    top: 'space.0',
    left: 'space.0',
    position: 'absolute',
    borderRadius: 'radius.small',
    textAlign: 'center',
    pointerEvents: 'none'
});
const $6dbadcc692492f47$var$hiddenSectionOverlayStyles = (0, $9BVpB.xcss)({
    padding: 'space.100',
    color: 'color.text',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
    backgroundColor: 'color.background.accent.gray.subtler',
    display: 'inline-block',
    position: 'relative',
    top: 'space.100',
    borderRadius: 'radius.large'
});
const $6dbadcc692492f47$export$276f2aa4ba2a046b = ()=>{
    const { fieldVisibility: fieldVisibility, formFields: formFields, formId: formId, formSections: allFormSections } = (0, $5JwFL.useFormRendererState)();
    const currentValues = (0, $5JwFL.useCurrentValues)();
    const sectionVisibilityMap = (0, $dmeMl.getSectionVisibilityMap)(allFormSections, formFields, currentValues);
    const formSections = allFormSections;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, formSections.map((section, index)=>{
        var _fieldVisibility$fiel;
        const sectionIsVisible = (sectionVisibilityMap === null || sectionVisibilityMap === void 0 ? void 0 : sectionVisibilityMap.get(index)) ?? false;
        if (((_fieldVisibility$fiel = fieldVisibility.fieldSet) === null || _fieldVisibility$fiel === void 0 ? void 0 : _fieldVisibility$fiel.length) === 0 || !sectionIsVisible && !fieldVisibility.fieldSet.includes((0, $8wHrE.VisibilityFieldSet).ALL_FIELDS)) return null;
        if (!sectionIsVisible && fieldVisibility.fieldSet.includes((0, $8wHrE.VisibilityFieldSet).ALL_FIELDS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            key: `pf-${formId}-form-section-${index.toString()}`,
            xcss: $6dbadcc692492f47$var$hiddenSectionContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f0QJc.FormSection), {
            key: `pf-${formId}-form-section-${index.toString()}`,
            sectionKey: index.toString(),
            sectionLayout: section.layout
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $6dbadcc692492f47$var$hiddenSectionWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $6dbadcc692492f47$var$hiddenSectionOverlayStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $j8FrW.messages).hiddenSectionTitle)))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f0QJc.FormSection), {
            key: `pf-${formId}-form-section-${index.toString()}`,
            sectionKey: index.toString(),
            sectionLayout: section.layout
        });
    }));
};

});
parcelRegister("8wHrE", function(module, exports) {
$parcel$export(module.exports, "VisibilityFieldSet", () => $5fd609839fc855aa$export$e2ed227a375a5e0e);
const $5fd609839fc855aa$export$e2ed227a375a5e0e = {
    ALL_FIELDS: 'allFields',
    VISIBLE_SECTION_FIELDS: 'visibleSectionFields'
};

});

parcelRegister("f0QJc", function(module, exports) {
$parcel$export(module.exports, "FormSection", () => $8575bd95cee6a0d5$export$b5ff61ac8b0a660f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9PwDt = parcelRequire("9PwDt");

var $7uUp4 = parcelRequire("7uUp4");

var $5JwFL = parcelRequire("5JwFL");

var $8uNfm = parcelRequire("8uNfm");

var $mA3R1 = parcelRequire("mA3R1");
const $8575bd95cee6a0d5$export$b5ff61ac8b0a660f = ({ sectionLayout: sectionLayout, sectionKey: sectionKey })=>{
    const renderers = (0, $5JwFL.useRenderers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $8575bd95cee6a0d5$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8575bd95cee6a0d5$var$ReactRendererStyleOverridesWithZIndex, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.default), {
        key: sectionKey,
        document: sectionLayout,
        extensionHandlers: {
            'com.thinktilt.proforma': (0, $8uNfm.FormExtensionRenderer)
        },
        eventHandlers: (0, $mA3R1.rendererEventHandlers),
        adfStage: "stage0",
        nodeComponents: renderers.adfNodeRenderers
    })));
};
const $8575bd95cee6a0d5$var$styles = {
    sectionContainer: "_otyrpxbi"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $8575bd95cee6a0d5$var$ReactRendererStyleOverridesWithZIndex = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_e4fq261p _1jvk261p _nsrr1h90",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8uNfm", function(module, exports) {
$parcel$export(module.exports, "FormExtensionRenderer", () => $773f94d8dbaa61db$export$920a3c316d9ff408);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $dsw4B = parcelRequire("dsw4B");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $jexpN = parcelRequire("jexpN");

var $5Z1z9 = parcelRequire("5Z1z9");

var $bN32a = parcelRequire("bN32a");
const $773f94d8dbaa61db$export$920a3c316d9ff408 = ({ extensionKey: extensionKey, parameters: parameters })=>{
    const extensionId = parameters === null || parameters === void 0 ? void 0 : parameters.id;
    if (extensionId === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger)",
        label: "Warning"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        color: "color.text.danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $bN32a.messages).extensionError)));
    switch(extensionKey){
        case 'html':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5Z1z9.HtmlRenderer), {
                fieldId: extensionId,
                htmlContent: (parameters === null || parameters === void 0 ? void 0 : parameters.htmlContent) ?? ''
            });
        case 'question':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jexpN.FormFieldRenderer), {
                fieldId: extensionId
            });
        default:
            // TODO: REQIN-1562 - Add error handling / logging
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    }
};

});
parcelRegister("jexpN", function(module, exports) {
$parcel$export(module.exports, "FormFieldRenderer", () => $2ca5e173d35e1684$export$d3fd267c87f1947c);

var $bSJIT = parcelRequire("bSJIT");

var $dDEhr = parcelRequire("dDEhr");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $hLmNI = parcelRequire("hLmNI");

var $1BKyJ = parcelRequire("1BKyJ");

var $eXSFU = parcelRequire("eXSFU");

var $24rCT = parcelRequire("24rCT");
const $2ca5e173d35e1684$export$d3fd267c87f1947c = ({ fieldId: fieldId })=>{
    const { formId: formId, renderers: renderers } = (0, $5JwFL.useFormRendererState)();
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const customFormFieldComponentRenderers = renderers.formFieldComponentRenderers || {};
    if (formField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eXSFU.UnknownField), {
        fieldId: fieldId,
        fieldInputId: "pf-unknown-fieldId",
        fieldLabelId: "pf-unknown-fieldId-label",
        fieldErrorId: "pf-unknown-fieldId-error"
    });
    const fieldInputId = `pf-${formId}-${formField.type}-${fieldId}`;
    const fieldLabelId = `${fieldInputId}-label`;
    const fieldErrorId = `${fieldInputId}-error`;
    const FormFieldContainerRenderer = (0, $24rCT.getFormFieldComponentRenderer)(formField.type, customFormFieldComponentRenderers.Container, (0, $hLmNI.defaultFormFieldComponentRenderers).Container);
    const FormFieldHelperMessageRenderer = (0, $24rCT.getFormFieldComponentRenderer)(formField.type, customFormFieldComponentRenderers.HelperMessage, (0, $hLmNI.defaultFormFieldComponentRenderers).HelperMessage);
    const FormFieldLabelRenderer = (0, $24rCT.getFormFieldComponentRenderer)(formField.type, customFormFieldComponentRenderers.Label, (0, $hLmNI.defaultFormFieldComponentRenderers).Label);
    const FormFieldInputRenderer = (0, $24rCT.getFormFieldComponentRenderer)(formField.type, customFormFieldComponentRenderers.Input, (0, $hLmNI.defaultFormFieldComponentRenderers).Input);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FormFieldContainerRenderer, {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FormFieldLabelRenderer, {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FormFieldHelperMessageRenderer, {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FormFieldInputRenderer, {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    }), renderMode === (0, $gkoaJ.FormRenderMode).EDIT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1BKyJ.FormFieldErrorRenderer), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    })));
};

});
parcelRegister("hLmNI", function(module, exports) {
$parcel$export(module.exports, "defaultFormFieldComponentRenderers", () => $27e609c411f57548$export$ab3d757d62ae0201);

var $2nfpZ = parcelRequire("2nfpZ");

var $91jiE = parcelRequire("91jiE");

var $cPSa2 = parcelRequire("cPSa2");

var $63hKy = parcelRequire("63hKy");

var $kx4l2 = parcelRequire("kx4l2");

var $lu8vG = parcelRequire("lu8vG");

var $aqzIR = parcelRequire("aqzIR");

var $hhmU3 = parcelRequire("hhmU3");

var $e1NVz = parcelRequire("e1NVz");

var $9eIAL = parcelRequire("9eIAL");

var $7XK7W = parcelRequire("7XK7W");

var $kyX62 = parcelRequire("kyX62");

var $36X5q = parcelRequire("36X5q");

var $dRVn5 = parcelRequire("dRVn5");

var $cEvwV = parcelRequire("cEvwV");

var $6qOtx = parcelRequire("6qOtx");

var $a2eVO = parcelRequire("a2eVO");

var $kOL4b = parcelRequire("kOL4b");

var $lseR1 = parcelRequire("lseR1");

var $bsKrV = parcelRequire("bsKrV");

var $h97p6 = parcelRequire("h97p6");

var $2K4mp = parcelRequire("2K4mp");
const $27e609c411f57548$export$ab3d757d62ae0201 = {
    Container: (0, $hhmU3.FieldContainer),
    HelperMessage: (0, $e1NVz.FieldHelperMessage),
    Label: (0, $9eIAL.FieldLabel),
    Input: {
        [(0, $2nfpZ.FormFieldType).ATTACHMENT]: (0, $91jiE.AttachmentField),
        [(0, $2nfpZ.FormFieldType).CASCADING_SELECT]: (0, $cPSa2.CascadingSelectInput),
        [(0, $2nfpZ.FormFieldType).CHECKBOX]: (0, $63hKy.CheckboxInput),
        [(0, $2nfpZ.FormFieldType).DATE]: (0, $kx4l2.DateInput),
        [(0, $2nfpZ.FormFieldType).DATE_TIME]: (0, $lu8vG.DateTimeInput),
        [(0, $2nfpZ.FormFieldType).EMAIL]: (0, $aqzIR.EmailInput),
        [(0, $2nfpZ.FormFieldType).LOCAL_TIME]: (0, $7XK7W.LocalTimeInput),
        [(0, $2nfpZ.FormFieldType).LONG_TEXT]: (0, $bsKrV.TextLongInput),
        [(0, $2nfpZ.FormFieldType).MULTIPLE_SELECT]: (0, $kyX62.MultipleSelectInput),
        [(0, $2nfpZ.FormFieldType).NUMBER]: (0, $36X5q.NumberInput),
        [(0, $2nfpZ.FormFieldType).PARAGRAPH]: (0, $dRVn5.PlainTextParagraphInput),
        [(0, $2nfpZ.FormFieldType).RADIO]: (0, $6qOtx.RadioInput),
        [(0, $2nfpZ.FormFieldType).RATING]: (0, $a2eVO.RatingInput),
        [(0, $2nfpZ.FormFieldType).SCALE]: (0, $kOL4b.ScaleInput),
        [(0, $2nfpZ.FormFieldType).RICH_TEXT_PARAGRAPH]: (0, $cEvwV.RichTextParagraphInput),
        [(0, $2nfpZ.FormFieldType).SHORT_TEXT]: (0, $h97p6.TextShortInput),
        [(0, $2nfpZ.FormFieldType).SINGLE_SELECT]: (0, $lseR1.SingleSelectInput),
        [(0, $2nfpZ.FormFieldType).URL]: (0, $2K4mp.UrlInput)
    }
};

});
parcelRegister("91jiE", function(module, exports) {
$parcel$export(module.exports, "AttachmentField", () => $3d8891cefb800e1e$export$37776e18d1f2630f);

var $bSJIT = parcelRequire("bSJIT");

var $bf1Bt = parcelRequire("bf1Bt");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $iKzME = parcelRequire("iKzME");

var $gpGs4 = parcelRequire("gpGs4");
const $3d8891cefb800e1e$export$37776e18d1f2630f = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    switch(renderMode){
        case (0, $gkoaJ.FormRenderMode).EDIT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bf1Bt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iKzME.EditAttachmentField), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gpGs4.ViewAttachmentField), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
    }
};

});
parcelRegister("iKzME", function(module, exports) {
$parcel$export(module.exports, "EditAttachmentField", () => $53be16d1a6262e0d$export$c11ebbe3626ea977);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $iHNht = parcelRequire("iHNht");

var $gV64P = parcelRequire("gV64P");

var $9Rfip = parcelRequire("9Rfip");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $i86qj = parcelRequire("i86qj");

var $hrKkD = parcelRequire("hrKkD");

var $27zro = parcelRequire("27zro");

var $5JwFL = parcelRequire("5JwFL");

var $kS0G5 = parcelRequire("kS0G5");

var $bD68n = parcelRequire("bD68n");

var $aXz0E = parcelRequire("aXz0E");

var $9R3Q2 = parcelRequire("9R3Q2");

var $6kxFc = parcelRequire("6kxFc");

var $9C7EN = parcelRequire("9C7EN");

var $2a821 = parcelRequire("2a821");

var $8vBWv = parcelRequire("8vBWv");
const $53be16d1a6262e0d$var$styles = {
    container: "_189ee4h9 _1dqogq9o _1e0c1txw _2lx21bp4 _1bah1h6o _ca0q1ejb _n3td1ejb _syaz1rpy",
    dropzoneContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $53be16d1a6262e0d$var$EMPTY_FILES_VALUE = {
    files: []
};
const $53be16d1a6262e0d$export$c11ebbe3626ea977 = ({ fieldId: fieldId, fieldErrorId: fieldErrorId })=>{
    const [isDragActive, setIsDragActive] = (0, $9R3Q2.useIsDragActive)();
    const intl = (0, $4vLTk.default)();
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const filesValue = (0, $i86qj.asFilesValue)(currentValue) ?? $53be16d1a6262e0d$var$EMPTY_FILES_VALUE;
    const field = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const attachmentConfiguration = (0, $5JwFL.useAttachmentConfiguration)();
    const onRemoveFile = (0, $6kxFc.useOnRemoveFile)(filesValue, fieldId);
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const { mediaBrowserConfig: mediaBrowserConfig, mediaClientConfig: mediaClientUploadConfig, mediaDropzoneConfig: mediaDropzoneConfig } = (attachmentConfiguration === null || attachmentConfiguration === void 0 ? void 0 : attachmentConfiguration.upload) ?? {};
    const { mediaClientConfig: mediaClientReadConfig } = (attachmentConfiguration === null || attachmentConfiguration === void 0 ? void 0 : attachmentConfiguration.read) ?? {};
    const fileCollectionName = mediaBrowserConfig === null || mediaBrowserConfig === void 0 ? void 0 : mediaBrowserConfig.uploadParams.collection;
    const onUploadEnd = (0, $9C7EN.useOnUploadEnd)(filesValue, fieldId, fileCollectionName);
    const onUploadError = (0, $2a821.useOnUploadError)(filesValue, fieldId);
    const onUploadStart = (0, $8vBWv.useOnUploadStart)(filesValue, fieldId, fileCollectionName);
    const onDragEnter = (0, $bSJIT.useCallback)(()=>{
        setIsDragActive(true);
    }, [
        setIsDragActive
    ]);
    const onDragLeave = (0, $bSJIT.useCallback)(()=>{
        setIsDragActive(false);
    }, [
        setIsDragActive
    ]);
    const onAttachmentUploadStart = (0, $bSJIT.useCallback)((payload)=>{
        onUploadStart(payload);
        setIsDragActive(false);
    }, [
        onUploadStart,
        setIsDragActive
    ]);
    const dropZoneContainer = (0, $aXz0E.getDropzone)(fieldId);
    const cardActions = (0, $bSJIT.useMemo)(()=>[
            {
                handler: onRemoveFile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                label: intl.formatMessage((0, $bD68n.messages).deleteIconLabel)
            }
        ], [
        intl,
        onRemoveFile
    ]);
    if (mediaClientReadConfig === undefined || mediaClientUploadConfig === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hrKkD.AttachmentErrorState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $53be16d1a6262e0d$var$styles.container,
        testId: "field-input-attachment-edit-dropzone",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        title: field === null || field === void 0 ? void 0 : field.label,
        id: `${fieldId}-dropzone-container`,
        "aria-invalid": isInvalid,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $53be16d1a6262e0d$var$styles.dropzoneContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHNht))), {
        color: "currentColor",
        spacing: "spacious",
        label: intl.formatMessage((0, $bD68n.messages).uploadIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kS0G5.AttachmentPicker), {
        mediaClientConfig: mediaClientUploadConfig,
        mediaBrowserConfig: mediaBrowserConfig,
        mediaDropzoneConfig: mediaDropzoneConfig,
        dropzoneContainer: dropZoneContainer,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...(0, $bD68n.messages).browseWithDropzone,
            values: {
                a: (content)=>// TODO: REQIN-2301 Atlaskit buttons don't have a type that is visually similar to current browse link. Will investigate in follow-up PR.
                    // eslint-disable-next-line @atlassian/a11y/anchor-is-valid
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Rfip.default), {
                        href: "#",
                        onClick: (e)=>{
                            e.preventDefault();
                            setIsBrowserOpen(true);
                        }
                    }, content)
            }
        }))), (filesValue.files.length > 0 || isDragActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $27zro.AttachmentSharedFilmstrip), {
        actions: cardActions,
        files: filesValue.files,
        mediaClientConfig: mediaClientReadConfig,
        isDragActive: isDragActive
    }));
};

});
parcelRegister("hrKkD", function(module, exports) {
$parcel$export(module.exports, "AttachmentErrorState", () => $bb3029cb4b647aa1$export$c887ece75d5757fc);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $dsw4B = parcelRequire("dsw4B");

var $9PwDt = parcelRequire("9PwDt");

var $9AAb2 = parcelRequire("9AAb2");
const $bb3029cb4b647aa1$var$styles = {
    error: "_189ee4h9 _1dqogq9o _1h6d1l7x _4t3i53f4 _1e0c1txw _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _1bah1h6o _4cvr1h6o _y3gn1h6o"
};
const $bb3029cb4b647aa1$export$c887ece75d5757fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $bb3029cb4b647aa1$var$styles.error,
        testId: "field-input-attachment-view-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        spacing: "spacious",
        color: "var(--ds-icon-warning, #E06C00)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $9AAb2.messages).defaultRenderError));

});
parcelRegister("9AAb2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $878a4f3b87f7ed91$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $878a4f3b87f7ed91$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    defaultRenderError: {
        id: 'proforma-form-renderer.common.ui.attachment-error-state.default-render-error',
        defaultMessage: 'Unable to show attachments in this field. Refresh this page to try again.',
        description: 'Error message when attachment field fails to render'
    }
});

});


parcelRegister("27zro", function(module, exports) {
$parcel$export(module.exports, "AttachmentSharedFilmstrip", () => $5741c5d427413a26$export$5f96bbcaad77b904);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $lwuFt = parcelRequire("lwuFt");

var $fyJNx = parcelRequire("fyJNx");

var $bu3n5 = parcelRequire("bu3n5");

var $fzoUl = parcelRequire("fzoUl");

var $9PwDt = parcelRequire("9PwDt");

var $l8AKU = parcelRequire("l8AKU");

var $7xyjG = parcelRequire("7xyjG");
const $5741c5d427413a26$var$styles = {
    dragPlaceholder: "_2rkofajl _syaz16jw _1bsb1w81 _1tke53f4 _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $5741c5d427413a26$var$DragPlaceholder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $5741c5d427413a26$var$styles.dragPlaceholder,
        backgroundColor: "color.background.accent.blue.subtle",
        testId: "field-input-attachment-view-filmstrip-drag-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), {
        color: "currentColor",
        label: "Document",
        spacing: "spacious"
    }));
const $5741c5d427413a26$export$5f96bbcaad77b904 = ({ actions: actions, files: files, mediaClientConfig: mediaClientConfig, isDragActive: isDragActive })=>{
    const [animateAndOffset, setAnimateAndOffset] = (0, $bSJIT.useState)({
        animate: false,
        offset: 0
    });
    const { animate: animate, offset: offset } = animateAndOffset;
    const onScroll = (e)=>{
        setAnimateAndOffset({
            animate: e.animate,
            offset: e.offset
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bu3n5.MediaProvider), {
        mediaClientConfig: mediaClientConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fzoUl.FilmstripView), {
        onScroll: onScroll,
        animate: animate,
        offset: offset
    }, files.sort((a, b)=>(0, $l8AKU.sortFilesByCreationDate)(a, b)).map((file)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            testId: "field-input-attachment-view-filmstrip-card",
            key: file.identifier.id.toString()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fyJNx.default), {
            key: file.identifier.id.toString(),
            mediaClientConfig: mediaClientConfig,
            identifier: file.identifier,
            actions: actions || [],
            shouldOpenMediaViewer: true,
            shouldEnableDownloadButton: true,
            dimensions: (0, $7xyjG.defaultImageCardDimensions)
        })))), isDragActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fzoUl.FilmstripView), {
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5741c5d427413a26$var$DragPlaceholder, null)));
};

});
parcelRegister("l8AKU", function(module, exports) {
$parcel$export(module.exports, "sortFilesByCreationDate", () => $13f65de27d18b0be$export$1af729506cd08f9b);
const $13f65de27d18b0be$export$1af729506cd08f9b = (a, b)=>b.creationDate && a.creationDate ? b.creationDate - a.creationDate : 0;

});

parcelRegister("7xyjG", function(module, exports) {
$parcel$export(module.exports, "defaultImageCardDimensions", () => $8e50bb7b0eb50000$export$d87a47989c00f322);
const $8e50bb7b0eb50000$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};

});


parcelRegister("kS0G5", function(module, exports) {
$parcel$export(module.exports, "AttachmentPicker", () => $9f42eb5506233068$export$540eacb3f0344e48);

var $bSJIT = parcelRequire("bSJIT");

var $bu3n5 = parcelRequire("bu3n5");

var $8AI2A = parcelRequire("8AI2A");

var $7tc9a = parcelRequire("7tc9a");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");
const $9f42eb5506233068$export$540eacb3f0344e48 = ({ dropzoneContainer: dropzoneContainer, onUploadEnd: onUploadEnd, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, mediaBrowserConfig: mediaBrowserConfig, mediaDropzoneConfig: mediaDropzoneConfig, onDragEnter: onDragEnter, onDragLeave: onDragLeave, children: renderBrowserControl })=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $bSJIT.useState)(false);
    const browserConfig = {
        multiple: true,
        uploadParams: {},
        ...mediaBrowserConfig ?? {}
    };
    const dropzoneConfig = {
        uploadParams: {},
        ...mediaDropzoneConfig ?? {},
        container: dropzoneContainer
    };
    // this is incremented whenever the mediaClientConfig and onUploadStart changes which in turn changes the key of the Browser component to trigger a remount
    // this is because the Browser component does not update its mediaClient on re-render, only remounts
    // TODO: REQIN-1937 try to fix the underlying issue in authProvider to remove this useEffect
    const [mediaConfigRefreshCount, setMediaConfigRefreshCount] = (0, $bSJIT.useState)(0);
    (0, $bSJIT.useEffect)(()=>{
        setMediaConfigRefreshCount(mediaConfigRefreshCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mediaClientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bu3n5.MediaProvider), {
        mediaClientConfig: mediaClientConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        translate: "no"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8AI2A.BrowserLoader), {
        key: String(mediaConfigRefreshCount),
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onClose: ()=>setIsBrowserOpen(false),
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7tc9a.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        // Without onError, a failed drag-and-drop upload is never removed and the field stays
        // in the UPLOADING state, blocking form submission. Browser already handles this.
        onError: (0, $gdUUy.fg)('proforma-jsdcloud-19007-media-token-sync') ? onUploadError : undefined,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onEnd: onUploadEnd
    })), renderBrowserControl({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};

});

parcelRegister("bD68n", function(module, exports) {
$parcel$export(module.exports, "messages", () => $506fc931c2166107$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $506fc931c2166107$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    browseWithDropzone: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.browse-with-dropzone',
        defaultMessage: 'Drop files to attach or <a>browse</a>',
        description: 'File upload prompt with drag-and-drop or browse options'
    },
    uploadIconLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.upload-icon-label',
        defaultMessage: 'Upload',
        description: 'The accessible label for the upload icon button in the attachment field edit area of the form renderer, indicating the action to upload a file.'
    },
    deleteIconLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.delete-icon-label',
        defaultMessage: 'Delete',
        description: 'The accessible label for the delete icon button in the attachment field edit area of the form renderer, indicating the action to remove an attached file.'
    }
});

});

parcelRegister("aXz0E", function(module, exports) {
$parcel$export(module.exports, "getDropzone", () => $725e0498125316c7$export$f7bd45c6298822d9);
const $725e0498125316c7$export$f7bd45c6298822d9 = (fieldId)=>{
    if (!fieldId) return undefined;
    const id = `${fieldId}-dropzone-container`;
    return document.getElementById(id) ?? undefined;
};

});

parcelRegister("9R3Q2", function(module, exports) {
$parcel$export(module.exports, "useIsDragActive", () => $33ec580014fda424$export$c88b7c203d029251);

var $bSJIT = parcelRequire("bSJIT");
const $33ec580014fda424$export$c88b7c203d029251 = ()=>(0, $bSJIT.useState)(false);

});

parcelRegister("6kxFc", function(module, exports) {
$parcel$export(module.exports, "useOnRemoveFile", () => $148ca1d668ddacc5$export$be9db9a7fba175a1);

var $bSJIT = parcelRequire("bSJIT");

var $gjxgd = parcelRequire("gjxgd");

var $5JwFL = parcelRequire("5JwFL");
const $148ca1d668ddacc5$export$be9db9a7fba175a1 = (currentFilesValue, fieldId)=>{
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const onRemoveFile = (0, $bSJIT.useCallback)((fileToRemove)=>{
        if (!fileToRemove) return;
        const updatedFiles = currentFilesValue.files.filter((formfile)=>formfile.identifier.id !== fileToRemove.details.id);
        if (updatedFiles.length === 0) updateModifiedValue(fieldId, null);
        else updateModifiedValue(fieldId, {
            files: updatedFiles,
            fileStatus: (0, $gjxgd.FileStatus).UPLOADED
        });
    }, [
        currentFilesValue,
        fieldId,
        updateModifiedValue
    ]);
    return onRemoveFile;
};

});

parcelRegister("9C7EN", function(module, exports) {
$parcel$export(module.exports, "useOnUploadEnd", () => $558d27b95f7dbc51$export$86e8c5a1930115c3);

var $bSJIT = parcelRequire("bSJIT");

var $gjxgd = parcelRequire("gjxgd");

var $azuRz = parcelRequire("azuRz");

var $5JwFL = parcelRequire("5JwFL");
const $558d27b95f7dbc51$export$86e8c5a1930115c3 = (currentFilesValue, fieldId, collectionName)=>{
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const lifecycleHandlers = (0, $5JwFL.useLifecycleHandlers)();
    // Dynamic state that needs to be accessed from onUploadEnd need to be stored in a ref.
    // This is due to how the Media components work. The callbacks are cached, so passing
    // in a new onUploadEnd callback into Media components will not register the
    // updated callback.
    const currentFilesValueRef = (0, $bSJIT.useRef)(currentFilesValue);
    currentFilesValueRef.current = currentFilesValue;
    const onUploadEnd = (0, $bSJIT.useCallback)((payload)=>{
        var _lifecycleHandlers$Fo;
        updateModifiedValue(fieldId, {
            files: currentFilesValueRef.current.files,
            fileStatus: (0, $gjxgd.FileStatus).UPLOADED
        });
        (_lifecycleHandlers$Fo = lifecycleHandlers[(0, $azuRz.FormRendererLifecycleStage).ATTACHMENT_UPLOAD_END]) === null || _lifecycleHandlers$Fo === void 0 || _lifecycleHandlers$Fo.call(lifecycleHandlers, {
            fieldId: fieldId,
            file: {
                creationDate: payload.file.creationDate,
                identifier: {
                    collectionName: collectionName,
                    id: payload.file.id,
                    mediaItemType: 'file',
                    occurrenceKey: payload.file.occurrenceKey
                },
                name: payload.file.name,
                size: payload.file.size,
                type: payload.file.type
            },
            stage: (0, $azuRz.FormRendererLifecycleStage).ATTACHMENT_UPLOAD_END
        });
    }, [
        collectionName,
        currentFilesValueRef,
        fieldId,
        lifecycleHandlers,
        updateModifiedValue
    ]);
    return onUploadEnd;
};

});

parcelRegister("2a821", function(module, exports) {
$parcel$export(module.exports, "useOnUploadError", () => $a3d1fec27a210ac7$export$39ab63477493119a);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $VnB4y = parcelRequire("VnB4y");

var $hkLEY = parcelRequire("hkLEY");

var $gjxgd = parcelRequire("gjxgd");

var $5JwFL = parcelRequire("5JwFL");

var $9qlFH = parcelRequire("9qlFH");
const $a3d1fec27a210ac7$export$39ab63477493119a = (currentFilesValue, fieldId)=>{
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    // Dynamic state that needs to be accessed from onUploadStart need to be stored in a ref.
    // This is due to how the Media components work. The callbacks are cached, so passing
    // in a new onUploadStart callback into Media components will not register the
    // updated callback.
    const currentFilesValueRef = (0, $bSJIT.useRef)(currentFilesValue);
    currentFilesValueRef.current = currentFilesValue;
    const onUploadError = (0, $bSJIT.useCallback)((payload)=>{
        showFlag({
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-accent-red, #C9372C)"
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $9qlFH.messages).uploadErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $9qlFH.messages).uploadErrorDescription)
        });
        const updatedFiles = currentFilesValueRef.current.files.filter((formfile)=>formfile.identifier.id !== payload.fileId);
        if (updatedFiles.length === 0) updateModifiedValue(fieldId, null);
        else updateModifiedValue(fieldId, {
            files: updatedFiles,
            fileStatus: (0, $gjxgd.FileStatus).UPLOADED
        });
    }, [
        currentFilesValueRef,
        fieldId,
        showFlag,
        updateModifiedValue
    ]);
    return onUploadError;
};

});
parcelRegister("9qlFH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f60969e9cbc6801c$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f60969e9cbc6801c$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    uploadErrorTitle: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-error.upload-error-title',
        defaultMessage: 'Error uploading attachment',
        description: 'Title displayed in the error flag when an attachment upload error has occurred.'
    },
    uploadErrorDescription: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-error.upload-error-description',
        defaultMessage: 'An error occurred when uploading an attachment',
        description: 'Description displayed in the error flag when a generic error occurs during an attachment upload.'
    }
});

});


parcelRegister("8vBWv", function(module, exports) {
$parcel$export(module.exports, "useOnUploadStart", () => $c05cdc331085da94$export$86d3210897d66c59);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $VnB4y = parcelRequire("VnB4y");

var $hkLEY = parcelRequire("hkLEY");

var $gjxgd = parcelRequire("gjxgd");

var $5JwFL = parcelRequire("5JwFL");

var $a6Twe = parcelRequire("a6Twe");
const $c05cdc331085da94$var$DEFAULT_ATTACHMENTS_LIMIT = 50;
const $c05cdc331085da94$export$86d3210897d66c59 = (currentFilesValue, fieldId, collectionName)=>{
    const attachmentConfiguration = (0, $5JwFL.useAttachmentConfiguration)();
    const totalFormAttachments = (0, $5JwFL.useTotalFormAttachments)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    // Dynamic state that needs to be accessed from onUploadStart need to be stored in a ref.
    // This is due to how the Media components work. The callbacks are cached, so passing
    // in a new onUploadStart callback into Media components will not register the
    // updated callback.
    const currentFilesValueRef = (0, $bSJIT.useRef)(currentFilesValue);
    currentFilesValueRef.current = currentFilesValue;
    const totalFormAttachmentsRef = (0, $bSJIT.useRef)(totalFormAttachments);
    totalFormAttachmentsRef.current = totalFormAttachments;
    const onUploadStart = (0, $bSJIT.useCallback)((payload)=>{
        var _attachmentConfigurat;
        const filesValue = currentFilesValueRef.current;
        const attachmentLimit = (attachmentConfiguration === null || attachmentConfiguration === void 0 || (_attachmentConfigurat = attachmentConfiguration.upload) === null || _attachmentConfigurat === void 0 ? void 0 : _attachmentConfigurat.totalAttachmentsNumberLimit) ?? $c05cdc331085da94$var$DEFAULT_ATTACHMENTS_LIMIT;
        const newTotalFormAttachments = totalFormAttachmentsRef.current + payload.files.length;
        if (newTotalFormAttachments > attachmentLimit) {
            showFlag({
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $a6Twe.messages).uploadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $a6Twe.messages).uploadErrorAttachmentLimitExceeded)
            });
            return;
        }
        const updatedFiles = filesValue.files.concat(payload.files.map((mediaFile)=>({
                creationDate: mediaFile.creationDate,
                identifier: {
                    mediaItemType: 'file',
                    id: mediaFile.id,
                    occurrenceKey: mediaFile.occurrenceKey,
                    ...collectionName ? {
                        collectionName: collectionName
                    } : {}
                },
                name: mediaFile.name,
                size: mediaFile.size,
                type: mediaFile.type
            })));
        updateModifiedValue(fieldId, {
            files: updatedFiles,
            fileStatus: (0, $gjxgd.FileStatus).UPLOADING
        });
    }, [
        attachmentConfiguration,
        collectionName,
        currentFilesValueRef,
        fieldId,
        showFlag,
        totalFormAttachmentsRef,
        updateModifiedValue
    ]);
    return onUploadStart;
};

});
parcelRegister("a6Twe", function(module, exports) {
$parcel$export(module.exports, "messages", () => $65c489ad11daf78e$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $65c489ad11daf78e$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    uploadErrorTitle: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-start.upload-error-title',
        defaultMessage: 'Error uploading attachment',
        description: 'Title displayed in the error flag when an attachment upload error has occurred.'
    },
    uploadErrorAttachmentLimitExceeded: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-start.upload-error-attachment-limit-exceeded',
        defaultMessage: `There can't be more than 50 attachments on a form at any given time.`,
        description: 'Description displayed in the error flag when uploading an attachment would exceed the maximum number of attachments on a form (50).'
    }
});

});



parcelRegister("gpGs4", function(module, exports) {
$parcel$export(module.exports, "ViewAttachmentField", () => $47365608bcb32402$export$c00ca54825fe5ddc);

var $bSJIT = parcelRequire("bSJIT");

var $8LptA = parcelRequire("8LptA");

var $6otUE = parcelRequire("6otUE");

var $i86qj = parcelRequire("i86qj");

var $hrKkD = parcelRequire("hrKkD");

var $27zro = parcelRequire("27zro");

var $5JwFL = parcelRequire("5JwFL");

var $jcNBY = parcelRequire("jcNBY");
const $47365608bcb32402$export$c00ca54825fe5ddc = ({ fieldId: fieldId })=>{
    var _attachmentConfigurat;
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const filesValue = (0, $i86qj.asFilesValue)(currentValue) ?? {
        files: []
    };
    const attachmentConfiguration = (0, $5JwFL.useAttachmentConfiguration)();
    const mediaClientConfig = attachmentConfiguration === null || attachmentConfiguration === void 0 || (_attachmentConfigurat = attachmentConfiguration.read) === null || _attachmentConfigurat === void 0 ? void 0 : _attachmentConfigurat.mediaClientConfig;
    if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hrKkD.AttachmentErrorState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, filesValue.files.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $27zro.AttachmentSharedFilmstrip), {
        files: filesValue.files,
        mediaClientConfig: mediaClientConfig
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jcNBY.EmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireUIAnalytics), {
        actionSubject: (0, $6otUE.ActionSubject).ATTACHMENT_VIEWER,
        action: (0, $6otUE.Action).VIEWED,
        actionSubjectId: "proformaAttachmentViewerField"
    }));
};

});
parcelRegister("6otUE", function(module, exports) {
$parcel$export(module.exports, "ActionSubject", () => $3a106540d26dcafc$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $3a106540d26dcafc$export$e19cd5f9376f8cee);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in Proforma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
var $3a106540d26dcafc$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    // Objects
    ActionSubject["FORM"] = "form";
    // An actual form on an issue.
    ActionSubject["FORM_FIELD"] = "formField";
    // A field in a form.
    ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
    // A data connection's choices in a form.
    ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
    // A Jira field's choices in a form.
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    // Language dropdown of a form in form settings.
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    // Lock and PDF of a form on submit toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    // Submit and validate on create toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    // Issue forms types dropdown in form settings, enabled through issue forms toggle.
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    // Answer of a Question in a form.
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    // A form in a project created by form builder than can be then instantiated on an issue.
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    // Predefined templates available in the form builder that can be inserted into a template form.
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
    // Processes
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    // TODO: This is duplicated!!!
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
var $3a106540d26dcafc$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    // Objects
    Action["ADDED"] = "added";
    // When an entity is added/inserted into another.
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["COPIED"] = "copied";
    // Processes
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
var $3a106540d26dcafc$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE";
    return FormUpdateType;
}({});

});

parcelRegister("jcNBY", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $9a8f90e36cf3d8bf$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $lJuXR = parcelRequire("lJuXR");
const $9a8f90e36cf3d8bf$var$styles = {
    emptyState: "_189ee4h9 _1dqogq9o _1h6d1l7x _1e0c1txw _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    textBox: "_19pkze3t"
};
const $9a8f90e36cf3d8bf$export$fddf379e22a74b00 = ()=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $9a8f90e36cf3d8bf$var$styles.emptyState,
        testId: "field-input-attachment-view-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $9a8f90e36cf3d8bf$var$styles.textBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "p",
        color: "color.text.subtlest",
        weight: "semibold",
        align: "center"
    }, intl.formatMessage((0, $lJuXR.messages).emptyStateMessage))));
};

});
parcelRegister("lJuXR", function(module, exports) {
$parcel$export(module.exports, "messages", () => $35723cd917407980$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $35723cd917407980$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emptyStateMessage: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.view.empty-state.empty-state-message',
        defaultMessage: 'No attachments uploaded',
        description: 'Empty state message when no attachments uploaded'
    }
});

});




parcelRegister("cPSa2", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectInput", () => $410a1054e65cd06e$export$3dada0673e81e28a);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $iMehJ = parcelRequire("iMehJ");

var $gqMCH = parcelRequire("gqMCH");

var $6qRzJ = parcelRequire("6qRzJ");
const $410a1054e65cd06e$export$3dada0673e81e28a = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iMehJ.EditCascadingSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gqMCH.PreviewCascadingSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6qRzJ.ViewCascadingSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("iMehJ", function(module, exports) {
$parcel$export(module.exports, "EditCascadingSelectInput", () => $b1f910824c1361e4$export$dff0f0e1cf351192);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $eOzrv = parcelRequire("eOzrv");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $lP1BQ = parcelRequire("lP1BQ");

var $ks8Kp = parcelRequire("ks8Kp");

var $5JwFL = parcelRequire("5JwFL");

var $7tx17 = parcelRequire("7tx17");
const $b1f910824c1361e4$export$dff0f0e1cf351192 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _findParent;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const [selectedParentOption, setSelectedParentOption] = (0, $bSJIT.useState)(()=>{
        if (formOptionField === undefined) return undefined;
        return (0, $ks8Kp.findParentValue)(formOptionField, currentValue) ?? undefined;
    });
    const onChange = (0, $bSJIT.useCallback)((value)=>{
        if (value === null) {
            setSelectedParentOption(undefined);
            updateModifiedValue(fieldId, null);
        } else {
            setSelectedParentOption(value);
            updateModifiedValue(fieldId, {
                options: [
                    {
                        id: value.value.toString(),
                        label: value.label
                    }
                ]
            });
        }
    }, [
        fieldId,
        updateModifiedValue
    ]);
    const onChangeChild = (0, $bSJIT.useCallback)((value)=>{
        // it is not possible for the child to have no value because it is not clearable.
        if (value !== null && formOptionField !== undefined && selectedParentOption !== undefined) updateModifiedValue(fieldId, {
            options: [
                {
                    id: `${selectedParentOption.value.toString().split(':')[0]}:${value.value.toString()}`,
                    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                    label: `${selectedParentOption.label} - ${value.label}`
                }
            ]
        });
    }, [
        selectedParentOption,
        fieldId,
        formOptionField,
        updateModifiedValue
    ]);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        testId: `field-input-cascading-select-edit-${fieldId}`,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: fieldInputId,
        inputId: fieldInputId,
        value: selectedParentOption,
        options: (0, $kVXLM.toOptions)(formOptionField.options),
        isSearchable: true,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7tx17.messages).optionDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7tx17.messages).optionDropdownSelect),
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        isInvalid: isInvalid,
        onChange: onChange,
        isClearable: true,
        isRequired: isRequired,
        testId: `field-input-cascading-select-parent-edit-${fieldId}`,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: `${fieldInputId}-child`,
        label: formatMessage((0, $7tx17.messages).childLabel, {
            label: formField.label
        }),
        value: (0, $ks8Kp.findChildValue)(formOptionField, currentValue),
        // find the current parent option (if any) and then find its children
        options: (0, $kVXLM.toOptions)((_findParent = (0, $ks8Kp.findParent)(formOptionField, currentValue)) === null || _findParent === void 0 ? void 0 : _findParent.children),
        isSearchable: true,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7tx17.messages).optionDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7tx17.messages).optionDropdownSelect),
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        isInvalid: isInvalid,
        onChange: onChangeChild,
        isRequired: isRequired,
        testId: `field-input-cascading-select-child-edit-${fieldId}`,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }))));
};

});
parcelRegister("lP1BQ", function(module, exports) {
$parcel$export(module.exports, "haveOtherFieldValuesChanged", () => $aca2c564c58fc786$export$fa33ad5835246a48);
$parcel$export(module.exports, "formatLocalTimeValueForView", () => $aca2c564c58fc786$export$7d6f04502d2a16ba);
$parcel$export(module.exports, "formatDateValueForView", () => $aca2c564c58fc786$export$69b33eca51ff4481);
$parcel$export(module.exports, "getDropDownMenuPosition", () => $aca2c564c58fc786$export$cc1c1d9e6b32e7b2);
$parcel$export(module.exports, "parseDateTimeValueForView", () => $aca2c564c58fc786$export$f8913d90873e6918);
$parcel$export(module.exports, "startOfWeekDay", () => $aca2c564c58fc786$export$96be4a17474cfebf);

var $2BKOF = parcelRequire("2BKOF");

var $c9wRy = parcelRequire("c9wRy");

var $gdUUy = parcelRequire("gdUUy");

var $84Typ = parcelRequire("84Typ");
const $aca2c564c58fc786$export$fa33ad5835246a48 = (previousValues, nextValues, excludedFieldId)=>{
    if (previousValues === nextValues) return false;
    const previousKeys = Object.keys(previousValues).filter((id)=>id !== excludedFieldId);
    const nextKeys = Object.keys(nextValues).filter((id)=>id !== excludedFieldId);
    if (previousKeys.length !== nextKeys.length) return true;
    return nextKeys.some((id)=>previousValues[id] !== nextValues[id]);
};
const $aca2c564c58fc786$var$IPAD_USER_AGENT = /iPad;/;
const $aca2c564c58fc786$var$IPHONE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPod;|iPod touch;)/;
const $aca2c564c58fc786$export$7d6f04502d2a16ba = (value, locale)=>{
    if (!value || value.length === 0) return '';
    const timeSplit = value.split(':');
    const hours = parseInt(timeSplit[0], 10);
    const minutes = parseInt(timeSplit[1], 10);
    return new Intl.DateTimeFormat(locale, {
        ...(0, $84Typ.longTimeOnlyFormat),
        timeZone: 'UTC'
    }).format(Date.UTC(0, 0, 1, hours, minutes));
};
const $aca2c564c58fc786$export$69b33eca51ff4481 = (currentAnswer, locale)=>{
    if (!currentAnswer || currentAnswer.length === 0) return '';
    return new Intl.DateTimeFormat(locale, {
        ...(0, $84Typ.longDateOnlyFormat),
        timeZone: 'UTC'
    }).format(Date.parse(currentAnswer));
};
// Matches the ADS modal layer so a portalled menu still shows when the form is rendered in a modal.
const $aca2c564c58fc786$var$MENU_PORTAL_Z_INDEX = 510;
const $aca2c564c58fc786$export$cc1c1d9e6b32e7b2 = ()=>{
    var _getDocument;
    const menuPosition = $aca2c564c58fc786$export$530b8c437b4f1023() || $aca2c564c58fc786$export$509c2fa871ee4b40() ? // This is to prevent menu floating away due to virtual keyboard in iPad and iPhone
    'absolute' : 'fixed';
    const body = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
    if (!(0, $gdUUy.fg)('proforma_select_menu_portal_to_body') || !body) return {
        menuPosition: menuPosition
    };
    return {
        menuPosition: menuPosition,
        // Each field is rendered inside an extension wrapper with `container-type: inline-size`, which
        // creates a stacking context on Safari <= 18.4 (e.g. iOS 17) and Chrome <= 128. Portalling the menu to
        // the body stops it painting behind the fields that follow it.
        menuPortalTarget: body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: $aca2c564c58fc786$var$MENU_PORTAL_Z_INDEX
                })
        }
    };
};
const $aca2c564c58fc786$var$getLocale = (localeString)=>{
    const key = localeString;
    return (0, $84Typ.locales)[key] || (0, $84Typ.locales)[0, $84Typ.DEFAULT_LOCALE];
};
const $aca2c564c58fc786$export$509c2fa871ee4b40 = ()=>{
    var _navigator, _navigator2;
    if (!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.length) || !((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.platform) !== null && _navigator2 !== void 0 && _navigator2.length)) return false;
    const { userAgent: userAgent, platform: platform, maxTouchPoints: maxTouchPoints } = navigator;
    // Check for iPad using user agent
    const isIpadUserAgent = $aca2c564c58fc786$var$IPAD_USER_AGENT.test(userAgent);
    // Check for iPad in desktop mode (iOS 13+)
    const isIpadDesktop = platform === 'MacIntel' && maxTouchPoints > 1;
    return isIpadUserAgent || isIpadDesktop;
};
const $aca2c564c58fc786$export$530b8c437b4f1023 = ()=>{
    var _navigator3;
    if (!((_navigator3 = navigator) !== null && _navigator3 !== void 0 && (_navigator3 = _navigator3.userAgent) !== null && _navigator3 !== void 0 && _navigator3.length)) return false;
    return $aca2c564c58fc786$var$IPHONE_USER_AGENT.test(navigator.userAgent);
};
const $aca2c564c58fc786$export$f8913d90873e6918 = (dateAnswer, timeAnswer, locale)=>{
    const formattedDateValue = $aca2c564c58fc786$export$69b33eca51ff4481(dateAnswer, locale);
    const formattedTimeValue = $aca2c564c58fc786$export$7d6f04502d2a16ba(timeAnswer, locale);
    return {
        formattedDateValue: formattedDateValue,
        formattedTimeValue: formattedTimeValue
    };
};
const $aca2c564c58fc786$export$96be4a17474cfebf = (localeString)=>{
    const startWeekDay = (0, (/*@__PURE__*/$parcel$interopDefault($2BKOF)))($aca2c564c58fc786$var$getLocale(localeString), 'options.weekStartsOn', (0, $84Typ.DEFAULT_WEEK_START_DAY));
    return startWeekDay;
};

});
parcelRegister("84Typ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $b3820507df2b33b4$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $b3820507df2b33b4$export$845e1054649a85c2);
$parcel$export(module.exports, "locales", () => $b3820507df2b33b4$export$df1c34db1371eeed);
$parcel$export(module.exports, "longDateOnlyFormat", () => $b3820507df2b33b4$export$51f819d50bcd4ae1);
$parcel$export(module.exports, "longTimeOnlyFormat", () => $b3820507df2b33b4$export$a3aff10871f7171c);
$parcel$export(module.exports, "times", () => $b3820507df2b33b4$export$b5bc26e198ce73d0);

var $15G8h = parcelRequire("15G8h");
var $1n4Db = parcelRequire("1n4Db");
var $2DxUP = parcelRequire("2DxUP");
var $kaCoo = parcelRequire("kaCoo");
var $eOqlH = parcelRequire("eOqlH");
var $xGSoN = parcelRequire("xGSoN");
var $frtSF = parcelRequire("frtSF");
var $7fOw9 = parcelRequire("7fOw9");
var $h7XqT = parcelRequire("h7XqT");
var $6bIV0 = parcelRequire("6bIV0");
var $kuSiQ = parcelRequire("kuSiQ");
var $6O8Kn = parcelRequire("6O8Kn");
var $7alMJ = parcelRequire("7alMJ");
var $fA0le = parcelRequire("fA0le");
var $8iOHU = parcelRequire("8iOHU");
var $5zE4Q = parcelRequire("5zE4Q");
var $8G5A9 = parcelRequire("8G5A9");
var $GYAxJ = parcelRequire("GYAxJ");
var $eHyQt = parcelRequire("eHyQt");
var $fwP8D = parcelRequire("fwP8D");
var $5XslL = parcelRequire("5XslL");
var $c1aBp = parcelRequire("c1aBp");
var $6cm9c = parcelRequire("6cm9c");
var $exjZ8 = parcelRequire("exjZ8");
var $dvrov = parcelRequire("dvrov");
var $cRvk8 = parcelRequire("cRvk8");
var $93fiQ = parcelRequire("93fiQ");
var $eyi7k = parcelRequire("eyi7k");
const $b3820507df2b33b4$export$1af4c7e47ad72f44 = 'en-US';
const $b3820507df2b33b4$export$845e1054649a85c2 = 0; // Sunday
const $b3820507df2b33b4$export$df1c34db1371eeed = {
    arDZ: $15G8h.default,
    ar: (0, $15G8h.default),
    ar_DZ: (0, $15G8h.default),
    cs: $1n4Db.default,
    cs_CZ: (0, $1n4Db.default),
    'cs-CZ': (0, $1n4Db.default),
    da: $2DxUP.default,
    da_DK: (0, $2DxUP.default),
    'da-DK': (0, $2DxUP.default),
    de: $kaCoo.default,
    de_DE: (0, $kaCoo.default),
    'de-DE': (0, $kaCoo.default),
    enUS: $frtSF.default,
    en_US: (0, $frtSF.default),
    'en-US': (0, $frtSF.default),
    enGB: $xGSoN.default,
    en_UK: (0, $xGSoN.default),
    'en-UK': (0, $xGSoN.default),
    'en-GB': (0, $xGSoN.default),
    en_GB: (0, $xGSoN.default),
    enAU: $eOqlH.default,
    en_AU: (0, $eOqlH.default),
    'en-AU': (0, $eOqlH.default),
    es: $7fOw9.default,
    es_ES: (0, $7fOw9.default),
    'es-ES': (0, $7fOw9.default),
    et: $h7XqT.default,
    et_EE: (0, $h7XqT.default),
    'et-EE': (0, $h7XqT.default),
    fi: $6bIV0.default,
    fi_FI: (0, $6bIV0.default),
    'fi-FI': (0, $6bIV0.default),
    fr: $kuSiQ.default,
    fr_FR: (0, $kuSiQ.default),
    'fr-FR': (0, $kuSiQ.default),
    hu: $6O8Kn.default,
    hu_HU: (0, $6O8Kn.default),
    'hu-HU': (0, $6O8Kn.default),
    is: $7alMJ.default,
    is_IS: (0, $7alMJ.default),
    'is-IS': (0, $7alMJ.default),
    it: $fA0le.default,
    it_IT: (0, $fA0le.default),
    'it-IT': (0, $fA0le.default),
    ja: $8iOHU.default,
    ja_JP: (0, $8iOHU.default),
    'ja-JP': (0, $8iOHU.default),
    ko: $5zE4Q.default,
    ko_KR: (0, $5zE4Q.default),
    'ko-KR': (0, $5zE4Q.default),
    nb: $8G5A9.default,
    nb_NO: (0, $8G5A9.default),
    'nb-NO': (0, $8G5A9.default),
    nl: $GYAxJ.default,
    nl_NL: (0, $GYAxJ.default),
    'nl-NL': (0, $GYAxJ.default),
    pl: $eHyQt.default,
    pl_PL: (0, $eHyQt.default),
    'pl-PL': (0, $eHyQt.default),
    pt: $fwP8D.default,
    'pt-PT': (0, $fwP8D.default),
    pt_PT: (0, $fwP8D.default),
    ptBR: $5XslL.default,
    'pt-BR': (0, $5XslL.default),
    pt_BR: (0, $5XslL.default),
    ro: $c1aBp.default,
    ro_RO: (0, $c1aBp.default),
    'ro-RO': (0, $c1aBp.default),
    ru: $6cm9c.default,
    ru_RU: (0, $6cm9c.default),
    'ru-RU': (0, $6cm9c.default),
    sk: $exjZ8.default,
    sk_SK: (0, $exjZ8.default),
    'sk-SK': (0, $exjZ8.default),
    sv: $dvrov.default,
    sv_SE: (0, $dvrov.default),
    'sv-SE': (0, $dvrov.default),
    tr: $cRvk8.default,
    'tr-TR': (0, $cRvk8.default),
    tr_TR: (0, $cRvk8.default),
    zhCN: $93fiQ.default,
    'zh-CN': (0, $93fiQ.default),
    zh_CN: (0, $93fiQ.default),
    zhTW: $eyi7k.default,
    'zh-TW': (0, $eyi7k.default),
    zh_TW: (0, $eyi7k.default)
};
const $b3820507df2b33b4$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};
const $b3820507df2b33b4$export$a3aff10871f7171c = {
    hour: 'numeric',
    minute: 'numeric'
};
const $b3820507df2b33b4$export$b5bc26e198ce73d0 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});


parcelRegister("ks8Kp", function(module, exports) {
$parcel$export(module.exports, "findParent", () => $7e08e64feb2a66ae$export$25245567f53f158f);
$parcel$export(module.exports, "findParentValue", () => $7e08e64feb2a66ae$export$a2df38e067c4835d);
$parcel$export(module.exports, "findChildValue", () => $7e08e64feb2a66ae$export$d05af7ce39b8e394);
const $7e08e64feb2a66ae$export$25245567f53f158f = (formOptionField, currentValue)=>currentValue !== null && currentValue !== void 0 && currentValue.options.length ? formOptionField.options.find((option)=>option.id === currentValue.options[0].id.split(':')[0]) : undefined;
const $7e08e64feb2a66ae$export$a2df38e067c4835d = (formOptionField, currentValue)=>{
    const parent = $7e08e64feb2a66ae$export$25245567f53f158f(formOptionField, currentValue);
    return parent ? {
        value: parent.id,
        label: parent.label
    } : null;
};
const $7e08e64feb2a66ae$export$d05af7ce39b8e394 = (formOptionField, currentValue)=>{
    const parent = $7e08e64feb2a66ae$export$25245567f53f158f(formOptionField, currentValue);
    if (parent && currentValue) {
        var _parent$children;
        const child = currentValue.options[0].id.includes(':') ? (_parent$children = parent.children) === null || _parent$children === void 0 ? void 0 : _parent$children.find((option)=>option.id === currentValue.options[0].id.split(':')[1]) : null;
        return child ? {
            value: child.id,
            label: child.label
        } : null;
    }
    return null;
};

});

parcelRegister("7tx17", function(module, exports) {
$parcel$export(module.exports, "messages", () => $980dd942bd2fc828$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $980dd942bd2fc828$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    childLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.child-label',
        description: 'Label for the cascading select input child field, for accessibility',
        defaultMessage: '{label} child'
    },
    optionDropdownNoOptions: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.option-dropdown-no-options',
        defaultMessage: 'No options',
        description: 'Placeholder text in dropdown when there are no options.'
    },
    optionDropdownSelect: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.option-dropdown-select',
        defaultMessage: 'Select...',
        description: 'Placeholder text in dropdown waiting for the user to select something.'
    }
});

});


parcelRegister("gqMCH", function(module, exports) {
$parcel$export(module.exports, "PreviewCascadingSelectInput", () => $7392668d1fa20d32$export$12f2c298fb634c88);

var $bSJIT = parcelRequire("bSJIT");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $eOzrv = parcelRequire("eOzrv");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $ks8Kp = parcelRequire("ks8Kp");

var $5JwFL = parcelRequire("5JwFL");
const $7392668d1fa20d32$export$12f2c298fb634c88 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        testId: `field-input-cascading-select-preview-${fieldId}`,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: fieldInputId,
        inputId: fieldInputId,
        value: (0, $ks8Kp.findParentValue)(formOptionField, currentValue),
        isDisabled: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: `${fieldInputId}-child`,
        value: (0, $ks8Kp.findChildValue)(formOptionField, currentValue),
        isDisabled: true
    })));
};

});

parcelRegister("6qRzJ", function(module, exports) {
$parcel$export(module.exports, "ViewCascadingSelectInput", () => $9a5c3c9c546773a0$export$9c4bed0bc326a9b);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $9a5c3c9c546773a0$export$9c4bed0bc326a9b = ({ fieldId: fieldId })=>{
    var _formOptionField$valu;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-cascading-select-view-${fieldId}`
    }, (_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 || (_formOptionField$valu = _formOptionField$valu.options[0]) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.label));
};

});


parcelRegister("63hKy", function(module, exports) {
$parcel$export(module.exports, "CheckboxInput", () => $365374d6fef1f247$export$d4e232ca161ccdd3);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $sf8OG = parcelRequire("sf8OG");

var $dkfmQ = parcelRequire("dkfmQ");

var $dGJzm = parcelRequire("dGJzm");
const $365374d6fef1f247$export$d4e232ca161ccdd3 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $sf8OG.EditCheckboxInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dkfmQ.PreviewCheckboxInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dGJzm.ViewCheckboxInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("sf8OG", function(module, exports) {
$parcel$export(module.exports, "EditCheckboxInput", () => $5a22ef1828f67862$export$5c186521a9c9411a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $4vLTk = parcelRequire("4vLTk");

var $8HhhR = parcelRequire("8HhhR");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $eLTGD = parcelRequire("eLTGD");
const $5a22ef1828f67862$var$styles = {
    placeholder: "_19pk1jfw _2hwx1jfw _otyr1jfw _18u01jfw",
    option: "_19pk1b66"
};
const $5a22ef1828f67862$export$5c186521a9c9411a = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    const intl = (0, $4vLTk.default)();
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const [otherTextInputValue, setOtherTextInputValue] = (0, $bSJIT.useState)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    (0, $bSJIT.useEffect)(()=>{
        setOtherTextInputValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        setOtherTextInputValue
    ]);
    const onChange = (0, $bSJIT.useCallback)((event)=>{
        const selectedOptionId = event.target.value;
        let options = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? [];
        if (options.some((option)=>option.id === selectedOptionId)) // "Unchecking" a checked option
        options = options.filter((option)=>option.id !== selectedOptionId);
        else if (selectedOptionId !== (0, $gjxgd.OTHER_ID)) {
            var _formOptionField$opti;
            const selectedOption = formOptionField === null || formOptionField === void 0 || (_formOptionField$opti = formOptionField.options) === null || _formOptionField$opti === void 0 ? void 0 : _formOptionField$opti.find((option)=>option.id === selectedOptionId);
            if (selectedOption !== undefined) options = [
                ...options,
                selectedOption
            ];
        }
        const otherOptionText = selectedOptionId !== (0, $gjxgd.OTHER_ID) ? currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText : (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) === undefined ? '' : undefined;
        if (options.length === 0 && otherOptionText === undefined) updateModifiedValue(fieldId, null);
        else updateModifiedValue(fieldId, {
            otherOptionText: otherOptionText,
            options: options
        });
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.options,
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        fieldId,
        formOptionField === null || formOptionField === void 0 ? void 0 : formOptionField.options,
        updateModifiedValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const onOtherOptionTextChange = (0, $bSJIT.useCallback)((event)=>{
        setOtherTextInputValue(event.target.value);
        debouncedUpdateModifiedValue(fieldId, {
            otherOptionText: event.target.value,
            options: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? []
        });
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.options,
        debouncedUpdateModifiedValue,
        fieldId,
        setOtherTextInputValue
    ]);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const otherOption = {
        id: (0, $gjxgd.OTHER_ID),
        label: intl.formatMessage((0, $eLTGD.messages).otherOption)
    };
    const getCheckboxId = (optionId, index)=>{
        if ((0, $gdUUy.fg)('jsm-reqin-fieldset-update')) return `${fieldInputId}-option-${optionId}`;
        return index === 0 ? fieldInputId : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-checkbox-edit-${fieldId}`,
        "aria-invalid": isInvalid,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        title: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? undefined : formField === null || formField === void 0 ? void 0 : formField.label,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }, formOptionField.hasOtherOption || formOptionField.options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, (formOptionField.hasOtherOption ? [
        ...formOptionField.options,
        otherOption
    ] : formOptionField.options).map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
            key: `${fieldInputId}-${option.id}-${option.label}`,
            id: getCheckboxId(option.id, index),
            name: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? fieldInputId : `${fieldInputId}-${option.id}-${option.label}`,
            testId: `field-input-checkbox-edit-${fieldId}-option-${option.id}`,
            value: option.id,
            label: option.label,
            isChecked: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.options.some((currentOption)=>currentOption.id === option.id)) || option.id === (0, $gjxgd.OTHER_ID) && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) !== undefined,
            onChange: onChange,
            "aria-required": isRequired
        })), otherTextInputValue !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $5a22ef1828f67862$var$styles.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        appearance: "standard",
        placeholder: intl.formatMessage((0, $eLTGD.messages).otherOption),
        minimumRows: 2,
        isMonospaced: false,
        value: otherTextInputValue,
        resize: "smart",
        spellCheck: false,
        onChange: onOtherOptionTextChange,
        testId: `field-input-checkbox-edit-other-${fieldId}`,
        "aria-label": intl.formatMessage((0, $eLTGD.messages).otherOptionTextLabel, {
            label: formField.label
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $5a22ef1828f67862$var$styles.placeholder
    }));
};

});
parcelRegister("eLTGD", function(module, exports) {
$parcel$export(module.exports, "messages", () => $869568bc91f4f1dd$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $869568bc91f4f1dd$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.edit.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.edit.other-option-text-label',
        description: 'Label for the checkbox choice field other text box in edit mode, for accessibility',
        defaultMessage: '{label} checkbox choice field other option text area'
    }
});

});


parcelRegister("dkfmQ", function(module, exports) {
$parcel$export(module.exports, "PreviewCheckboxInput", () => $3e41a425575eca31$export$eb0a985fc0c4d7ab);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8HhhR = parcelRequire("8HhhR");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $fbFQI = parcelRequire("fbFQI");
const $3e41a425575eca31$export$eb0a985fc0c4d7ab = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formOptionField$valu2, _formOptionField$valu3, _formOptionField$valu4, _formOptionField$valu5;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const getCheckboxId = (optionId, index)=>{
        if ((0, $gdUUy.fg)('jsm-reqin-fieldset-update')) return `${fieldInputId}-option-${optionId}`;
        return index === 0 ? fieldInputId : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-checkbox-preview-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), null, formOptionField.options.map((option, index)=>{
        var _formOptionField$valu;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
            key: `${fieldInputId}-${option.id}-${option.label}`,
            id: getCheckboxId(option.id, index),
            name: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? fieldInputId : `${fieldInputId}-${option.id}-${option.label}`,
            isChecked: (_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.options.some((c)=>c.id === option.id),
            testId: `field-input-checkbox-preview-${fieldId}-option-${option.id}`,
            isDisabled: true,
            label: option.label
        });
    }), formOptionField.hasOtherOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
        key: `${fieldInputId}-${(0, $gjxgd.OTHER_ID)}-${((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.otherOptionText) ?? intl.formatMessage((0, $fbFQI.messages).otherOption)}`,
        id: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? `${fieldInputId}-option-other` : undefined,
        name: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? fieldInputId : `${fieldInputId}-${0, $gjxgd.OTHER_ID}-${((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) ?? intl.formatMessage((0, $fbFQI.messages).otherOption)}`,
        isChecked: ((_formOptionField$valu4 = formOptionField.value) === null || _formOptionField$valu4 === void 0 ? void 0 : _formOptionField$valu4.otherOptionText) !== undefined,
        isDisabled: true,
        label: intl.formatMessage((0, $fbFQI.messages).otherOption)
    }), ((_formOptionField$valu5 = formOptionField.value) === null || _formOptionField$valu5 === void 0 ? void 0 : _formOptionField$valu5.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $fbFQI.messages).otherOptionTextLabel, {
            label: formField.label
        })
    })));
};

});
parcelRegister("fbFQI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5cdf7cfdbb293a53$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $5cdf7cfdbb293a53$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.preview.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.preview.other-option-text-label',
        description: 'Label for the checkbox choice field other text box in preview mode, for accessibility',
        defaultMessage: '{label} checkbox choice field other option text area preview'
    }
});

});


parcelRegister("dGJzm", function(module, exports) {
$parcel$export(module.exports, "ViewCheckboxInput", () => $5eeb8874988f8d20$export$54ed257ffa293e07);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8HhhR = parcelRequire("8HhhR");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $dDEhr = parcelRequire("dDEhr");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $euum6 = parcelRequire("euum6");
const $5eeb8874988f8d20$export$54ed257ffa293e07 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formOptionField$valu2, _formOptionField$valu3, _formOptionField$valu4, _formOptionField$valu5;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const getCheckboxId = (optionId, index)=>{
        if ((0, $gdUUy.fg)('jsm-reqin-fieldset-update')) return `${fieldInputId}-option-${optionId}`;
        return index === 0 ? fieldInputId : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-checkbox-view-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), null, formOptionField.options.map((option, index)=>{
        var _formOptionField$valu;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
            key: `${fieldInputId}-${option.id}-${option.label}`,
            id: getCheckboxId(option.id, index),
            name: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? fieldInputId : `${fieldInputId}-${option.id}-${option.label}`,
            isChecked: (_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.options.some((c)=>c.id === option.id),
            testId: `field-input-checkbox-view-${fieldId}-option-${option.id}`,
            isDisabled: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
                xcss: $5eeb8874988f8d20$var$styles.checkboxLabel
            }, option.label)
        });
    }), formOptionField.hasOtherOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
        key: `${fieldInputId}-${(0, $gjxgd.OTHER_ID)}-${((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.otherOptionText) ?? intl.formatMessage((0, $euum6.messages).otherOption)}`,
        id: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? `${fieldInputId}-option-other` : undefined,
        name: (0, $gdUUy.fg)('jsm-reqin-fieldset-update') ? fieldInputId : `${fieldInputId}-${0, $gjxgd.OTHER_ID}-${((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) ?? intl.formatMessage((0, $euum6.messages).otherOption)}`,
        isChecked: ((_formOptionField$valu4 = formOptionField.value) === null || _formOptionField$valu4 === void 0 ? void 0 : _formOptionField$valu4.otherOptionText) !== undefined,
        isDisabled: true,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: $5eeb8874988f8d20$var$styles.checkboxLabel
        }, intl.formatMessage((0, $euum6.messages).otherOption))
    }), ((_formOptionField$valu5 = formOptionField.value) === null || _formOptionField$valu5 === void 0 ? void 0 : _formOptionField$valu5.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $euum6.messages).otherOptionTextLabel, {
            label: formField.label
        })
    })));
};
const $5eeb8874988f8d20$var$styles = {
    checkboxLabel: "_syazi7uo"
};

});
parcelRegister("euum6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $573e01ea116a2331$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $573e01ea116a2331$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.view.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.checkbox-input.view.other-option-text-label',
        description: 'Label for the checkbox choice field other text box in view mode, for accessibility',
        defaultMessage: '{label} checkbox choice field other option text area view'
    }
});

});



parcelRegister("kx4l2", function(module, exports) {
$parcel$export(module.exports, "DateInput", () => $47c8e2dba9a60cb8$export$7edc06cf1783b30f);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $gcjOe = parcelRequire("gcjOe");

var $h2raB = parcelRequire("h2raB");

var $3qzW3 = parcelRequire("3qzW3");
const $47c8e2dba9a60cb8$export$7edc06cf1783b30f = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    switch(renderMode){
        case (0, $gkoaJ.FormRenderMode).EDIT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gcjOe.EditDateInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        case (0, $gkoaJ.FormRenderMode).PREVIEW:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $h2raB.PreviewDateInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3qzW3.ViewDateInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
    }
};

});
parcelRegister("gcjOe", function(module, exports) {
$parcel$export(module.exports, "EditDateInput", () => $40f953ff8b4ebc3d$export$2ab632a8951d8cb3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $aM9QT = parcelRequire("aM9QT");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $i86qj = parcelRequire("i86qj");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");

var $4MyMf = parcelRequire("4MyMf");
const $40f953ff8b4ebc3d$var$styles = {
    container: "_p12f1lit"
};
const $40f953ff8b4ebc3d$export$2ab632a8951d8cb3 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asDateValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const intl = (0, $4vLTk.default)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const onChange = (0, $bSJIT.useCallback)((value)=>{
        if (value.length === 0) updateModifiedValue(fieldId, null);
        else updateModifiedValue(fieldId, {
            date: value
        });
    }, [
        fieldId,
        updateModifiedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $40f953ff8b4ebc3d$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aM9QT.default), {
        id: fieldInputId,
        value: ((_asDateValue = (0, $i86qj.asDateValue)(currentValue)) === null || _asDateValue === void 0 ? void 0 : _asDateValue.date) ?? '',
        isInvalid: isInvalid,
        onChange: onChange,
        locale: intl.locale,
        placeholder: intl.formatMessage((0, $4MyMf.messages).datePlaceholder, {
            date: intl.formatDate(new Date(), {})
        }),
        weekStartDay: (0, $lP1BQ.startOfWeekDay)(intl.locale),
        testId: `field-input-date-edit-${fieldId}`,
        shouldShowCalendarButton: !currentValue,
        isRequired: isRequired,
        "aria-label": (formField === null || formField === void 0 ? void 0 : formField.label) || intl.formatMessage((0, $4MyMf.messages).datePlaceholder, {
            date: intl.formatDate(new Date(), {})
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});
parcelRegister("4MyMf", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c0c897cbda58f50a$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c0c897cbda58f50a$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    datePlaceholder: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-input.edit.date-placeholder',
        description: 'Placeholder for the date input field when no date is selected',
        defaultMessage: 'e.g. {date}'
    }
});

});


parcelRegister("h2raB", function(module, exports) {
$parcel$export(module.exports, "PreviewDateInput", () => $30c624def38371d9$export$f9cee105788cb830);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $aM9QT = parcelRequire("aM9QT");

var $9PwDt = parcelRequire("9PwDt");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $iNuXB = parcelRequire("iNuXB");
const $30c624def38371d9$var$styles = {
    container: "_p12f1lit"
};
const $30c624def38371d9$export$f9cee105788cb830 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formDateField$value;
    const intl = (0, $4vLTk.default)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formDateField = (0, $kVXLM.asFormDateField)(formField);
    if (formDateField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $30c624def38371d9$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aM9QT.default), {
        id: fieldInputId,
        value: (_formDateField$value = formDateField.value) === null || _formDateField$value === void 0 ? void 0 : _formDateField$value.date,
        locale: intl.locale,
        testId: `field-input-date-preview-${fieldId}`,
        isDisabled: true,
        shouldShowCalendarButton: true,
        label: (formField === null || formField === void 0 ? void 0 : formField.label) || intl.formatMessage((0, $iNuXB.messages).dateLabel)
    }));
};

});
parcelRegister("iNuXB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c7e06c08741df265$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c7e06c08741df265$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    dateLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-input.preview.date-label',
        defaultMessage: 'Date',
        description: 'Fallback label for the date input field in preview mode'
    }
});

});


parcelRegister("3qzW3", function(module, exports) {
$parcel$export(module.exports, "ViewDateInput", () => $bdce750d14d2a931$export$38169582799b6d3f);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");
const $bdce750d14d2a931$export$38169582799b6d3f = ({ fieldId: fieldId })=>{
    var _formDateField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formDateField = (0, $kVXLM.asFormDateField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formDateField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-date-view-${fieldId}`
    }, (0, $lP1BQ.formatDateValueForView)((_formDateField$value = formDateField.value) === null || _formDateField$value === void 0 ? void 0 : _formDateField$value.date, intl.locale));
};

});


parcelRegister("lu8vG", function(module, exports) {
$parcel$export(module.exports, "DateTimeInput", () => $3d619c0c295915be$export$183478aa40b5df1);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $cEV3t = parcelRequire("cEV3t");

var $4S0hh = parcelRequire("4S0hh");

var $kUW5g = parcelRequire("kUW5g");
const $3d619c0c295915be$export$183478aa40b5df1 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    switch(renderMode){
        case (0, $gkoaJ.FormRenderMode).EDIT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cEV3t.EditDateTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        case (0, $gkoaJ.FormRenderMode).PREVIEW:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4S0hh.PreviewDateTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kUW5g.ViewDateTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
    }
};

});
parcelRegister("cEV3t", function(module, exports) {
$parcel$export(module.exports, "EditDateTimeInput", () => $bf67446f50acfeed$export$8a9bc940b8c911ab);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $aM9QT = parcelRequire("aM9QT");

var $iSkY9 = parcelRequire("iSkY9");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $84Typ = parcelRequire("84Typ");

var $i86qj = parcelRequire("i86qj");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");

var $gr0Hu = parcelRequire("gr0Hu");
const $bf67446f50acfeed$var$styles = {
    container: "_p12fnklw",
    pickerContainer: "_1bsb1ssb"
};
const $bf67446f50acfeed$export$8a9bc940b8c911ab = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const intl = (0, $4vLTk.default)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const dateTimeCurrentValue = (0, $i86qj.asDateTimeValue)(currentValue);
    const onChangeDate = (0, $bSJIT.useCallback)((value)=>{
        if (value.length === 0) {
            if ((dateTimeCurrentValue === null || dateTimeCurrentValue === void 0 ? void 0 : dateTimeCurrentValue.localTime) === undefined) updateModifiedValue(fieldId, null);
            else updateModifiedValue(fieldId, {
                ...dateTimeCurrentValue,
                date: undefined
            });
        } else updateModifiedValue(fieldId, {
            ...dateTimeCurrentValue,
            date: value
        });
    }, [
        dateTimeCurrentValue,
        fieldId,
        updateModifiedValue
    ]);
    const onChangeLocalTime = (0, $bSJIT.useCallback)((value)=>{
        if (value.length === 0) {
            if ((dateTimeCurrentValue === null || dateTimeCurrentValue === void 0 ? void 0 : dateTimeCurrentValue.date) === undefined) updateModifiedValue(fieldId, null);
            else updateModifiedValue(fieldId, {
                ...dateTimeCurrentValue,
                localTime: undefined
            });
        } else updateModifiedValue(fieldId, {
            ...dateTimeCurrentValue,
            localTime: value
        });
    }, [
        dateTimeCurrentValue,
        fieldId,
        updateModifiedValue
    ]);
    // NOTE: We are using the individual `DatePicker` and `TimePicker` because there is a problem
    //       when using the `DateTimePicker` and `onChange` updating multiple properties
    //       (e.g. `date` and `localTime`) where the `onChange` for the date picker and time picker
    //       being fired immediately one after the other, not leaving time for the rerender to update
    //       the `currentValue`  which means that the clear button can only clear the time, and users
    //       would have to enter the date picker and press the delete key to clear it. This could be
    //       solved by local state, but that seems rather messy storing the value 3 times.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        xcss: $bf67446f50acfeed$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $bf67446f50acfeed$var$styles.pickerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aM9QT.default), {
        id: fieldInputId,
        value: (dateTimeCurrentValue === null || dateTimeCurrentValue === void 0 ? void 0 : dateTimeCurrentValue.date) ?? '',
        isInvalid: isInvalid,
        locale: intl.locale,
        onChange: onChangeDate,
        placeholder: intl.formatMessage((0, $gr0Hu.messages).datePlaceholder, {
            date: intl.formatDate(new Date(), {})
        }),
        shouldShowCalendarButton: !(dateTimeCurrentValue !== null && dateTimeCurrentValue !== void 0 && dateTimeCurrentValue.date),
        weekStartDay: (0, $lP1BQ.startOfWeekDay)(intl.locale),
        testId: `field-input-date-time-date-picker-edit-${fieldId}`,
        isRequired: isRequired,
        label: intl.formatMessage((0, $gr0Hu.messages).dateLabel, {
            label: formField === null || formField === void 0 ? void 0 : formField.label
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $bf67446f50acfeed$var$styles.pickerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iSkY9.default), {
        value: (dateTimeCurrentValue === null || dateTimeCurrentValue === void 0 ? void 0 : dateTimeCurrentValue.localTime) ?? '',
        isInvalid: isInvalid,
        locale: intl.locale,
        onChange: onChangeLocalTime,
        placeholder: intl.formatMessage((0, $gr0Hu.messages).timePlaceholder, {
            time: intl.formatTime(new Date(), {})
        }),
        testId: `field-input-date-time-time-picker-edit-${fieldId}`,
        times: (0, $84Typ.times),
        isRequired: isRequired,
        timeIsEditable: true,
        label: intl.formatMessage((0, $gr0Hu.messages).timeLabel, {
            label: formField === null || formField === void 0 ? void 0 : formField.label
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })));
};

});
parcelRegister("gr0Hu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7a7e1801ac56a003$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $7a7e1801ac56a003$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    dateLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.date-label',
        defaultMessage: 'Date : {label}',
        description: "The label displayed above the date input field in the date-time form field editor. The placeholder {label} is substituted with the field's configured label text."
    },
    datePlaceholder: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.date-placeholder',
        description: 'Placeholder for the date input field when no date is selected',
        defaultMessage: 'e.g. {date}'
    },
    timeLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.time-label',
        defaultMessage: 'Time : {label}',
        description: "The label displayed above the time input field in the date-time form field editor. The placeholder {label} is substituted with the field's configured label text."
    },
    timePlaceholder: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.edit.time-placeholder',
        description: 'Placeholder for the time input field when no time is selected',
        defaultMessage: 'e.g. {time}'
    }
});

});


parcelRegister("4S0hh", function(module, exports) {
$parcel$export(module.exports, "PreviewDateTimeInput", () => $bde95d5b43945047$export$7cd4dad5cbe89dba);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $aM9QT = parcelRequire("aM9QT");

var $iSkY9 = parcelRequire("iSkY9");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $iQcfy = parcelRequire("iQcfy");
const $bde95d5b43945047$var$styles = {
    container: "_p12fnklw",
    pickerContainer: "_1bsb1ssb"
};
const $bde95d5b43945047$export$7cd4dad5cbe89dba = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formDateTimeField$va, _formDateTimeField$va2;
    const intl = (0, $4vLTk.default)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formDateTimeField = (0, $kVXLM.asFormDateTimeField)(formField);
    if (formDateTimeField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    // NOTE: See edit component for why we are using the individual `DatePicker` and `TimePicker`.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        xcss: $bde95d5b43945047$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $bde95d5b43945047$var$styles.pickerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aM9QT.default), {
        id: fieldInputId,
        value: (_formDateTimeField$va = formDateTimeField.value) === null || _formDateTimeField$va === void 0 ? void 0 : _formDateTimeField$va.date,
        locale: intl.locale,
        shouldShowCalendarButton: true,
        testId: `field-input-date-time-date-picker-edit-${fieldId}`,
        isDisabled: true,
        label: formField !== null && formField !== void 0 && formField.label ? `${formField.label} ${intl.formatMessage((0, $iQcfy.messages).timeLabelSuffix)}` : intl.formatMessage((0, $iQcfy.messages).dateLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $bde95d5b43945047$var$styles.pickerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iSkY9.default), {
        id: fieldInputId,
        value: (_formDateTimeField$va2 = formDateTimeField.value) === null || _formDateTimeField$va2 === void 0 ? void 0 : _formDateTimeField$va2.localTime,
        locale: intl.locale,
        testId: `field-input-date-time-time-picker-edit-${fieldId}`,
        isDisabled: true,
        label: formField !== null && formField !== void 0 && formField.label ? `${formField.label} ${intl.formatMessage((0, $iQcfy.messages).dateTimeLabelSuffix)}` : intl.formatMessage((0, $iQcfy.messages).timeLabel)
    })));
};

});
parcelRegister("iQcfy", function(module, exports) {
$parcel$export(module.exports, "messages", () => $35fcc3ceaefbbe34$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $35fcc3ceaefbbe34$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    dateLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.date-label',
        defaultMessage: 'Date',
        description: 'Fallback label for the date picker in the date-time input field in preview mode'
    },
    timeLabelSuffix: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.time-label-suffix',
        defaultMessage: '(Date)',
        description: 'Suffix for the date label in the date-time input field in preview mode'
    },
    timeLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.time-label',
        defaultMessage: 'Time',
        description: 'Fallback label for the time picker in the date-time input field in preview mode'
    },
    dateTimeLabelSuffix: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.date-time-label-suffix',
        defaultMessage: '(Time)',
        description: 'Suffix for the time label in the date-time input field in preview mode'
    }
});

});


parcelRegister("kUW5g", function(module, exports) {
$parcel$export(module.exports, "ViewDateTimeInput", () => $ee0cd405a93b4502$export$7d8020ec92dfa4c4);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");
const $ee0cd405a93b4502$export$7d8020ec92dfa4c4 = ({ fieldId: fieldId })=>{
    var _formDateTimeField$va, _formDateTimeField$va2;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formDateTimeField = (0, $kVXLM.asFormDateTimeField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formDateTimeField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const { formattedDateValue: formattedDateValue, formattedTimeValue: formattedTimeValue } = (0, $lP1BQ.parseDateTimeValueForView)(((_formDateTimeField$va = formDateTimeField.value) === null || _formDateTimeField$va === void 0 ? void 0 : _formDateTimeField$va.date) || '', ((_formDateTimeField$va2 = formDateTimeField.value) === null || _formDateTimeField$va2 === void 0 ? void 0 : _formDateTimeField$va2.localTime) || '', intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-date-time-view-${fieldId}`
    }, formattedDateValue && !formattedTimeValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, formattedDateValue), !formattedDateValue && formattedTimeValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, formattedTimeValue), formattedDateValue && formattedTimeValue && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, `${formattedDateValue}, ${formattedTimeValue}`));
};

});


parcelRegister("aqzIR", function(module, exports) {
$parcel$export(module.exports, "EmailInput", () => $242f5dcbc32acf3b$export$20b1d7061d50817f);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $kYnge = parcelRequire("kYnge");

var $a3C5U = parcelRequire("a3C5U");

var $3GmUR = parcelRequire("3GmUR");
const $242f5dcbc32acf3b$export$20b1d7061d50817f = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kYnge.EditEmailInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a3C5U.PreviewEmailInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3GmUR.ViewEmailInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("kYnge", function(module, exports) {
$parcel$export(module.exports, "EditEmailInput", () => $5629fa3c1061b563$export$eb70e21613ee7f1b);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $5629fa3c1061b563$export$eb70e21613ee7f1b = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asTextValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [textFieldValue, setTextFieldValue] = (0, $bSJIT.useState)(currentValue);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    (0, $bSJIT.useEffect)(()=>{
        setTextFieldValue(currentValue);
    }, [
        currentValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        setTextFieldValue({
            text: event.target.value
        });
        if (event.target.value.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else debouncedUpdateModifiedValue(fieldId, {
            text: event.target.value
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: ((_asTextValue = (0, $i86qj.asTextValue)(textFieldValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text) ?? '',
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        placeholder: "",
        testId: `field-input-email-edit-${fieldId}`,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});

parcelRegister("a3C5U", function(module, exports) {
$parcel$export(module.exports, "PreviewEmailInput", () => $6e150a760e1cab3e$export$529316e15cf5256c);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $6e150a760e1cab3e$export$529316e15cf5256c = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-email-preview-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text,
        isDisabled: true
    }));
};

});

parcelRegister("3GmUR", function(module, exports) {
$parcel$export(module.exports, "ViewEmailInput", () => $aaa38e899b9a544e$export$92fdbdc1effaf040);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $aaa38e899b9a544e$export$92fdbdc1effaf040 = ({ fieldId: fieldId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-email-view-${fieldId}`
    }, (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text);
};

});


parcelRegister("hhmU3", function(module, exports) {
$parcel$export(module.exports, "FieldContainer", () => $fc69610d881ac6aa$export$b5c4b0e7cd7f148b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $2nfpZ = parcelRequire("2nfpZ");

var $5JwFL = parcelRequire("5JwFL");
const $fc69610d881ac6aa$var$styles = {
    fieldContainerStyles: "_ca0q1b66",
    fieldsetStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _ca0q1b66 _15k51osq"
};
const $fc69610d881ac6aa$export$b5c4b0e7cd7f148b = ({ children: children, fieldId: fieldId })=>{
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const shouldUseFieldset = (formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).CHECKBOX || (formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).RADIO;
    if (shouldUseFieldset && (0, $gdUUy.fg)('jsm-reqin-fieldset-update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "fieldset",
        testId: "fieldset-container",
        xcss: $fc69610d881ac6aa$var$styles.fieldsetStyles
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-container",
        xcss: $fc69610d881ac6aa$var$styles.fieldContainerStyles
    }, children);
};

});

parcelRegister("e1NVz", function(module, exports) {
$parcel$export(module.exports, "FieldHelperMessage", () => $5c299383306e41a0$export$59ca90c067f9cd3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $6l5Zu = parcelRequire("6l5Zu");

var $9PwDt = parcelRequire("9PwDt");

var $5JwFL = parcelRequire("5JwFL");
const $5c299383306e41a0$var$styles = {
    helperMessageContainerStyles: "_19pkr5cr _otyr1b66"
};
const $5c299383306e41a0$export$59ca90c067f9cd3f = ({ fieldId: fieldId })=>{
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    return formField.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $5c299383306e41a0$var$styles.helperMessageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6l5Zu.HelperMessage), {
        testId: "field-helper-message"
    }, formField.helperMessage));
};

});

parcelRegister("9eIAL", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $cdea89311af47103$export$1acdcf5a973a8414);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $ekQN1 = parcelRequire("ekQN1");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $2nfpZ = parcelRequire("2nfpZ");

var $5JwFL = parcelRequire("5JwFL");

var $c0kaW = parcelRequire("c0kaW");
const $cdea89311af47103$var$styles = {
    legend: "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t _ahbq1i6y"
};
const $cdea89311af47103$export$1acdcf5a973a8414 = ({ afterLabelIcon: afterLabelIcon, fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId })=>{
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const shouldUseLegend = (formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).CHECKBOX || (formField === null || formField === void 0 ? void 0 : formField.type) === (0, $2nfpZ.FormFieldType).RADIO;
    const labelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center"
    }, formField === null || formField === void 0 ? void 0 : formField.label, isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c0kaW.RequiredAsterisk), null), afterLabelIcon && afterLabelIcon);
    if (shouldUseLegend && (0, $gdUUy.fg)('jsm-reqin-fieldset-update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "legend",
        id: fieldLabelId,
        xcss: $cdea89311af47103$var$styles.legend
    }, labelContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ekQN1.Label), {
        htmlFor: fieldInputId,
        id: fieldLabelId
    }, labelContent);
};

});
parcelRegister("c0kaW", function(module, exports) {
$parcel$export(module.exports, "RequiredAsterisk", () => $86834e188c5d6874$export$a4bb55a1e3b8a49f);

var $bSJIT = parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $86834e188c5d6874$var$requiredIndicatorStyles = (0, $9BVpB.xcss)({
    color: 'color.text.danger',
    fontFamily: 'font.family.body',
    paddingInlineStart: 'space.025'
});
const $86834e188c5d6874$export$a4bb55a1e3b8a49f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $86834e188c5d6874$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        title: "required",
        testId: "required-asterisk"
    }, "*");

});


parcelRegister("7XK7W", function(module, exports) {
$parcel$export(module.exports, "LocalTimeInput", () => $1b77cdbe774a7efd$export$9512dfef4149bee2);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $fpaea = parcelRequire("fpaea");

var $bVJXY = parcelRequire("bVJXY");

var $g8JIE = parcelRequire("g8JIE");
const $1b77cdbe774a7efd$export$9512dfef4149bee2 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    switch(renderMode){
        case (0, $gkoaJ.FormRenderMode).EDIT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fpaea.EditLocalTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        case (0, $gkoaJ.FormRenderMode).PREVIEW:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bVJXY.PreviewLocalTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g8JIE.ViewLocalTimeInput), {
                fieldId: fieldId,
                fieldInputId: fieldInputId,
                fieldLabelId: fieldLabelId,
                fieldErrorId: fieldErrorId
            });
    }
};

});
parcelRegister("fpaea", function(module, exports) {
$parcel$export(module.exports, "EditLocalTimeInput", () => $6041856311ba3e9f$export$1982cd88b00f3c49);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $iSkY9 = parcelRequire("iSkY9");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $84Typ = parcelRequire("84Typ");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");

var $d8H7p = parcelRequire("d8H7p");
const $6041856311ba3e9f$var$styles = {
    container: "_p12f1lit"
};
const $6041856311ba3e9f$export$1982cd88b00f3c49 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asLocalTimeValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const intl = (0, $4vLTk.default)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const timePlaceholder = intl.formatMessage((0, $d8H7p.messages).timePlaceholder, {
        time: intl.formatTime(new Date(), {})
    });
    const onChange = (0, $bSJIT.useCallback)((value)=>{
        if (value.length === 0) updateModifiedValue(fieldId, null);
        else updateModifiedValue(fieldId, {
            localTime: value
        });
    }, [
        fieldId,
        updateModifiedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $6041856311ba3e9f$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iSkY9.default), {
        id: fieldInputId,
        value: (_asLocalTimeValue = (0, $i86qj.asLocalTimeValue)(currentValue)) === null || _asLocalTimeValue === void 0 ? void 0 : _asLocalTimeValue.localTime,
        isInvalid: isInvalid,
        onChange: onChange,
        locale: intl.locale,
        placeholder: timePlaceholder,
        testId: `field-input-local-time-edit-${fieldId}`,
        timeIsEditable: true,
        times: (0, $84Typ.times),
        isRequired: isRequired,
        label: (formField === null || formField === void 0 ? void 0 : formField.label) || timePlaceholder,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});
parcelRegister("d8H7p", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c3840e275240135b$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c3840e275240135b$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    timePlaceholder: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.local-time-input.edit.time-placeholder',
        description: 'Placeholder for the local time input field when no time is selected',
        defaultMessage: 'e.g. {time}'
    }
});

});


parcelRegister("bVJXY", function(module, exports) {
$parcel$export(module.exports, "PreviewLocalTimeInput", () => $90679e71cf04c658$export$416387e4840b4d52);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $iSkY9 = parcelRequire("iSkY9");

var $9PwDt = parcelRequire("9PwDt");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $4IO1T = parcelRequire("4IO1T");
const $90679e71cf04c658$var$styles = {
    container: "_p12f1lit"
};
const $90679e71cf04c658$export$416387e4840b4d52 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formLocalTimeField$v;
    const intl = (0, $4vLTk.default)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formLocalTimeField = (0, $kVXLM.asFormLocalTimeField)(formField);
    if (formLocalTimeField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $90679e71cf04c658$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iSkY9.default), {
        id: fieldInputId,
        value: (_formLocalTimeField$v = formLocalTimeField.value) === null || _formLocalTimeField$v === void 0 ? void 0 : _formLocalTimeField$v.localTime,
        locale: intl.locale,
        testId: "field-input-local-time-preview",
        isDisabled: true,
        label: (formField === null || formField === void 0 ? void 0 : formField.label) || intl.formatMessage((0, $4IO1T.messages).timeLabel)
    }));
};

});
parcelRegister("4IO1T", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4c56635bd440f210$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4c56635bd440f210$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    timeLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.local-time-input.preview.time-label',
        defaultMessage: 'Time',
        description: 'Fallback label for the local time input field in preview mode'
    }
});

});


parcelRegister("g8JIE", function(module, exports) {
$parcel$export(module.exports, "ViewLocalTimeInput", () => $8ced6a5235aeb0e2$export$f04ffbb5d62887f2);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");
const $8ced6a5235aeb0e2$export$f04ffbb5d62887f2 = ({ fieldId: fieldId })=>{
    var _formLocalTimeField$v;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formLocalTimeField = (0, $kVXLM.asFormLocalTimeField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formLocalTimeField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: "field-input-local-time-view"
    }, (0, $lP1BQ.formatLocalTimeValueForView)((_formLocalTimeField$v = formLocalTimeField.value) === null || _formLocalTimeField$v === void 0 ? void 0 : _formLocalTimeField$v.localTime, intl.locale));
};

});


parcelRegister("kyX62", function(module, exports) {
$parcel$export(module.exports, "MultipleSelectInput", () => $5b6c1eb4aabd847e$export$476c1e9d6be319e);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $1Srky = parcelRequire("1Srky");

var $5f1tv = parcelRequire("5f1tv");

var $98asE = parcelRequire("98asE");
const $5b6c1eb4aabd847e$export$476c1e9d6be319e = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1Srky.EditMultipleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5f1tv.PreviewMultipleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $98asE.ViewMultipleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("1Srky", function(module, exports) {
$parcel$export(module.exports, "EditMultipleSelectInput", () => $d96b7b4b8aab4f8d$export$1bd7c319cbf4b336);
// oxlint-disable prefer-default-export, max-lines

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $ktbTQ = parcelRequire("ktbTQ");

var $cHz95 = parcelRequire("cHz95");

var $eOzrv = parcelRequire("eOzrv");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $iQRsO = parcelRequire("iQRsO");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");

var $3qhpE = parcelRequire("3qhpE");

var $jHbkr = parcelRequire("jHbkr");
const $d96b7b4b8aab4f8d$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS = 500;
const $d96b7b4b8aab4f8d$var$optionStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.050'
});
const $d96b7b4b8aab4f8d$export$1bd7c319cbf4b336 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    const intl = (0, $4vLTk.default)();
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const currentValues = (0, $5JwFL.useCurrentValues)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const { asyncFields: asyncFields } = (0, $5JwFL.useFormRendererState)();
    const fieldAsyncConfiguration = asyncFields[fieldId];
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const [otherTextInputValue, setOtherTextInputValue] = (0, $bSJIT.useState)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    const [loadOptionsOnFocusDefaultOptions, setLoadOptionsOnFocusDefaultOptions] = (0, $bSJIT.useState)();
    const [isLoadingOptionsOnFocus, setIsLoadingOptionsOnFocus] = (0, $bSJIT.useState)(false);
    // Tracks the `currentValues` and async config used for the last focus load so we can skip a
    // refetch when nothing that could make this field's options stale has changed. `undefined`
    // means the focus options have never been loaded for this field.
    const lastLoadedValuesRef = (0, $bSJIT.useRef)(undefined);
    const lastLoadedConfigRef = (0, $bSJIT.useRef)(undefined);
    // Monotonic counter used to discard responses from superseded in-flight requests. Each fetch
    // increments the counter; a response is applied only when its captured id still matches.
    const loadRequestCounterRef = (0, $bSJIT.useRef)(0);
    (0, $bSJIT.useEffect)(()=>{
        setOtherTextInputValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        setOtherTextInputValue
    ]);
    const handleLoadOptionsOnFocus = (0, $bSJIT.useCallback)(()=>{
        if (!(fieldAsyncConfiguration !== null && fieldAsyncConfiguration !== void 0 && fieldAsyncConfiguration.loadOptions)) return;
        const previousValues = lastLoadedValuesRef.current;
        // Only (re)load on the first focus, when the async config changes, or when a field value
        // OTHER than this field's own changes. Changing this field's own selection (e.g. removing a
        // chip) cannot make its own option list stale, so we skip the refetch (avoiding an
        // unnecessary network round-trip on every reopen) and keep the already-loaded options so
        // that de-selected values reappear in the menu client-side.
        const shouldLoad = previousValues === undefined || lastLoadedConfigRef.current !== fieldAsyncConfiguration || (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId);
        if (!shouldLoad) return;
        lastLoadedValuesRef.current = currentValues;
        lastLoadedConfigRef.current = fieldAsyncConfiguration;
        loadRequestCounterRef.current += 1;
        const requestId = loadRequestCounterRef.current;
        setIsLoadingOptionsOnFocus(true);
        fieldAsyncConfiguration.loadOptions('', currentValues, fieldId)// loadRequestCounterRef check early returns are stale guards
        .then((options)=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setLoadOptionsOnFocusDefaultOptions(options);
        }).catch(()=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setLoadOptionsOnFocusDefaultOptions([]);
        }).finally(()=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setIsLoadingOptionsOnFocus(false);
        });
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId
    ]);
    const onChange = (0, $bSJIT.useCallback)((value)=>{
        const options = value.map((option)=>({
                id: option.value.toString(),
                label: option.label
            }));
        if (options.length === 0) updateModifiedValue(fieldId, null);
        else if (options.some((option)=>option.id === (0, $gjxgd.OTHER_ID))) updateModifiedValue(fieldId, {
            otherOptionText: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) ?? '',
            options: options.filter((option)=>option.id !== (0, $gjxgd.OTHER_ID))
        });
        else updateModifiedValue(fieldId, {
            options: options
        });
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        fieldId,
        updateModifiedValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const onOtherOptionTextChange = (0, $bSJIT.useCallback)((event)=>{
        setOtherTextInputValue(event.target.value);
        debouncedUpdateModifiedValue(fieldId, {
            otherOptionText: event.target.value,
            options: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? []
        });
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.options,
        debouncedUpdateModifiedValue,
        fieldId,
        setOtherTextInputValue
    ]);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const otherOption = {
        value: (0, $gjxgd.OTHER_ID),
        label: intl.formatMessage((0, $3qhpE.messages).otherOption)
    };
    if (fieldAsyncConfiguration === undefined) {
        var _currentValue$options;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            testId: `field-input-multiple-select-edit-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
            inputId: fieldInputId,
            options: formOptionField.hasOtherOption ? [
                ...(0, $kVXLM.toOptions)(formOptionField.options),
                otherOption
            ] : (0, $kVXLM.toOptions)(formOptionField.options),
            value: currentValue !== null && currentValue !== void 0 && (_currentValue$options = currentValue.options) !== null && _currentValue$options !== void 0 && _currentValue$options.length ? (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options).concat((currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) !== undefined ? [
                otherOption
            ] : []) : (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) !== undefined ? [
                otherOption
            ] : null,
            isMulti: true,
            onChange: onChange,
            isSearchable: true,
            noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownNoOptions),
            placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownSelect),
            ...(0, $lP1BQ.getDropDownMenuPosition)(),
            isInvalid: isInvalid,
            testId: `field-input-multiple-select-edit-input-${fieldId}`,
            isRequired: isRequired,
            descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined,
            components: {
                Option: (0, $iQRsO.CustomSelectOption)
            }
        }), otherTextInputValue !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $d96b7b4b8aab4f8d$var$optionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
            appearance: "standard",
            placeholder: intl.formatMessage((0, $3qhpE.messages).optionDropdownNewOption),
            minimumRows: 2,
            isMonospaced: false,
            value: otherTextInputValue,
            resize: "smart",
            spellCheck: false,
            onChange: onOtherOptionTextChange,
            isInvalid: isInvalid,
            testId: `field-input-multiple-select-edit-other-${fieldId}`,
            "aria-label": intl.formatMessage((0, $3qhpE.messages).otherOptionTextLabel, {
                label: formField.label
            }),
            "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
        })));
    }
    if (fieldAsyncConfiguration.loadPaginatedOptions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jHbkr.PaginatedEditMultipleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldErrorId: fieldErrorId,
        fieldAsyncConfiguration: fieldAsyncConfiguration,
        currentValue: currentValue,
        currentValues: currentValues,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange
    });
    const loadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))((query, callback)=>{
        var _fieldAsyncConfigurat;
        (_fieldAsyncConfigurat = fieldAsyncConfiguration.loadOptions) === null || _fieldAsyncConfigurat === void 0 || _fieldAsyncConfigurat.call(fieldAsyncConfiguration, query, currentValues, fieldId).then((options)=>callback(options)).catch(()=>callback([]));
    }, $d96b7b4b8aab4f8d$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS);
    const { createOptions: createOptions } = fieldAsyncConfiguration;
    const { isValidNewOption: isValidNewOption, onCreateOption: onCreateOption } = createOptions || {};
    const isCreateable = createOptions !== undefined;
    const getLoadOptionsOnEventBehavior = ()=>{
        const isDefaultOptionsConfigurationProvided = fieldAsyncConfiguration.defaultOptions !== undefined;
        // AsyncFieldConfiguration.defaultOptions is now not a direct mapping to the prop behavior of react-select.
        // In react-select the defaultOptions prop being undefined or explicitly false are functionally the same, just
        // like any other React component. However here, we define defaultOptions as part of a store hook for a config
        // object. Here we use the config of defaultOptions to have different behavior for `undefined`, i.e. the `onFocus`
        // triggering of `loadOptions`
        const defaultOptionsProps = {
            defaultOptions: fieldAsyncConfiguration.defaultOptions
        };
        const loadOptionsOnFocusProps = {
            onFocus: handleLoadOptionsOnFocus,
            onMenuOpen: handleLoadOptionsOnFocus,
            openMenuOnFocus: true,
            defaultOptions: loadOptionsOnFocusDefaultOptions,
            isLoading: isLoadingOptionsOnFocus
        };
        return isDefaultOptionsConfigurationProvided ? defaultOptionsProps : loadOptionsOnFocusProps;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: `field-input-multiple-select-edit-${fieldId}`
    }, isCreateable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: `field-input-multiple-select-edit-async-createable-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ktbTQ.default), {
        inputId: fieldInputId,
        ...getLoadOptionsOnEventBehavior(),
        isSearchable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownNoOptions)),
        loadOptions: loadOptions,
        onCreateOption: onCreateOption,
        isValidNewOption: isValidNewOption,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownSelect),
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? null,
        isMulti: true,
        isInvalid: isInvalid,
        testId: `field-input-multiple-select-edit-input-${fieldId}`,
        isRequired: isRequired,
        components: {
            Option: (0, $iQRsO.CustomSelectOption)
        },
        cacheOptions: fieldAsyncConfiguration.cacheOptions,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: `field-input-multiple-select-edit-async-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cHz95.default), {
        inputId: fieldInputId,
        ...getLoadOptionsOnEventBehavior(),
        isSearchable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownNoOptions)),
        loadOptions: loadOptions,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownSelect),
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? null,
        isMulti: true,
        isInvalid: isInvalid,
        testId: `field-input-multiple-select-edit-input-${fieldId}`,
        isRequired: isRequired,
        components: {
            Option: (0, $iQRsO.CustomSelectOption)
        },
        cacheOptions: fieldAsyncConfiguration.cacheOptions,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })));
};

});
parcelRegister("iQRsO", function(module, exports) {
$parcel$export(module.exports, "CustomSelectOption", () => $0518643e109c32ee$export$be7472b36ab2e901);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $6X9z7 = parcelRequire("6X9z7");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $kbBdI = parcelRequire("kbBdI");

var $e7ca5 = parcelRequire("e7ca5");
const $0518643e109c32ee$var$styles = {
    customSelectOptionWrapper: "_18zrpxbi _1rjcu2gc",
    iconBoxStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o _2hwxutpp _1o9zidpf",
    contentBoxStyle: "_k48pi7a9"
};
const $0518643e109c32ee$export$be7472b36ab2e901 = (props)=>{
    const { data: data, selectProps: selectProps } = props;
    const { Option: Option } = (0, $kbBdI.components);
    const { inputValue: inputValue } = selectProps;
    const hasAvatarOrByline = (data === null || data === void 0 ? void 0 : data.avatar) || (data === null || data === void 0 ? void 0 : data.byline);
    const displayText = (data === null || data === void 0 ? void 0 : data.displayLabel) ?? (data === null || data === void 0 ? void 0 : data.label);
    return /*#__PURE__*/ $bSJIT.createElement(Option, props, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: hasAvatarOrByline ? $0518643e109c32ee$var$styles.customSelectOptionWrapper : undefined
    }, /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        alignItems: "center"
    }, (data === null || data === void 0 ? void 0 : data.avatar) && /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $0518643e109c32ee$var$styles.iconBoxStyle,
        testId: "custom-select-option-avatar"
    }, data.avatar), displayText && /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $0518643e109c32ee$var$styles.contentBoxStyle,
        testId: "custom-select-option-label"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $dDEhr.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), null, /*#__PURE__*/ $bSJIT.createElement((0, $e7ca5.BoldMatchingText), {
        match: inputValue ?? ''
    }, displayText)), data.byline && /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        size: "small",
        testId: "custom-select-option-byline"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $e7ca5.BoldMatchingText), {
        match: inputValue ?? '',
        isSmall: true
    }, data.byline)))))));
};

});
parcelRegister("e7ca5", function(module, exports) {
$parcel$export(module.exports, "BoldMatchingText", () => $1406bc3fafd64282$export$fee117cd50d6234b);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");
const $1406bc3fafd64282$export$fee117cd50d6234b = ({ match: match, children: children, isSmall: isSmall = false })=>{
    if (match === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    // Escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, parts.map((part)=>{
        if (part.toLowerCase() === match.toLowerCase()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            testId: "custom-select-option.bold-text",
            as: "strong",
            size: isSmall ? 'small' : undefined
        }, part);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, part);
    }));
};

});


parcelRegister("3qhpE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4b10806842b6bf12$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4b10806842b6bf12$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    optionDropdownNewOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-new-option',
        defaultMessage: 'New option...',
        description: 'Placeholder text in dropdown when a new option can be created.'
    },
    optionDropdownNoOptions: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-no-options',
        defaultMessage: 'No options',
        description: 'Placeholder text in dropdown when there are no options.'
    },
    optionDropdownSelect: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.option-dropdown-select',
        defaultMessage: 'Select...',
        description: 'Placeholder text in dropdown waiting for the user to select something.'
    },
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.other-option-text-label',
        description: 'Label for the multiple select field other text box in edit mode, for accessibility',
        defaultMessage: '{label} multiple select field other option text area'
    },
    searchResultsLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.edit.search-results-label',
        defaultMessage: '{numberOfSearchResults, plural, one {# search result} other {# search results}}',
        description: 'Label above options describing how many search results were found'
    }
});

});

parcelRegister("jHbkr", function(module, exports) {
$parcel$export(module.exports, "PaginatedEditMultipleSelectInput", () => $8e668cccf4b27dac$export$6a6f0903a598ed67);
// oxlint-disable prefer-default-export

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $eOzrv = parcelRequire("eOzrv");

var $kVXLM = parcelRequire("kVXLM");

var $iQRsO = parcelRequire("iQRsO");

var $lP1BQ = parcelRequire("lP1BQ");

var $3qhpE = parcelRequire("3qhpE");
const $8e668cccf4b27dac$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS = 500;
const $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX = 0;
// Defined at module scope so react-select keeps a stable reference and does not remount the menu
// (which would reset the infinite-scroll position) on each parent render.
const $8e668cccf4b27dac$var$selectComponents = {
    Option: (0, $iQRsO.CustomSelectOption)
};
const $8e668cccf4b27dac$var$hasDefaultOptionsEnabled = ({ defaultOptions: defaultOptions })=>defaultOptions === true;
const $8e668cccf4b27dac$var$shouldLoadOptionsWhenMenuOpens = ({ defaultOptions: defaultOptions })=>defaultOptions === undefined;
const $8e668cccf4b27dac$export$6a6f0903a598ed67 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId, fieldAsyncConfiguration: fieldAsyncConfiguration, currentValue: currentValue, currentValues: currentValues, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange })=>{
    var _currentValue$options;
    const intl = (0, $4vLTk.default)();
    const [asyncOptions, setAsyncOptions] = (0, $bSJIT.useState)([]);
    const [inputValue, setInputValue] = (0, $bSJIT.useState)('');
    const [isMenuOpen, setIsMenuOpen] = (0, $bSJIT.useState)(false);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const requestCounterRef = (0, $bSJIT.useRef)(0);
    const lastLoadedValuesRef = (0, $bSJIT.useRef)(undefined);
    const lastLoadedConfigRef = (0, $bSJIT.useRef)(undefined);
    const paginationRef = (0, $bSJIT.useRef)({
        startIndex: $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX,
        hasNextPage: false,
        query: ''
    });
    const invalidateLoadedOptions = (0, $bSJIT.useCallback)(()=>{
        requestCounterRef.current += 1;
        setAsyncOptions([]);
        paginationRef.current = {
            query: '',
            startIndex: $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX,
            hasNextPage: false
        };
        setIsLoading(false);
        lastLoadedValuesRef.current = undefined;
    }, []);
    // Invalidate cached options when parent field values change or config changes
    (0, $bSJIT.useEffect)(()=>{
        const previousValues = lastLoadedValuesRef.current;
        const hasRelevantParentValueChanged = previousValues !== undefined && (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId);
        const hasConfigChanged = lastLoadedConfigRef.current !== fieldAsyncConfiguration;
        if (hasRelevantParentValueChanged || hasConfigChanged) invalidateLoadedOptions();
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId,
        invalidateLoadedOptions
    ]);
    const loadFirstPage = (0, $bSJIT.useCallback)((query)=>{
        if (!fieldAsyncConfiguration.loadPaginatedOptions) return;
        requestCounterRef.current += 1;
        const requestId = requestCounterRef.current;
        setIsLoading(true);
        paginationRef.current = {
            query: query,
            startIndex: $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX,
            hasNextPage: false
        };
        fieldAsyncConfiguration.loadPaginatedOptions(query, currentValues, fieldId, $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX).then((result)=>{
            if (requestId !== requestCounterRef.current) return;
            setAsyncOptions(result.options);
            paginationRef.current = {
                query: query,
                startIndex: result.options.length,
                hasNextPage: result.hasNextPage
            };
            lastLoadedValuesRef.current = currentValues;
            lastLoadedConfigRef.current = fieldAsyncConfiguration;
        }).catch(()=>{
            if (requestId !== requestCounterRef.current) return;
            setAsyncOptions([]);
            paginationRef.current = {
                query: query,
                startIndex: $8e668cccf4b27dac$var$FIRST_PAGE_START_INDEX,
                hasNextPage: false
            };
        }).finally(()=>{
            if (requestId !== requestCounterRef.current) return;
            setIsLoading(false);
        });
    }, [
        fieldAsyncConfiguration,
        currentValues,
        fieldId
    ]);
    const debouncedLoadFirstPage = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(loadFirstPage, $8e668cccf4b27dac$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS), [
        loadFirstPage
    ]);
    // Cleanup debounced function on unmount
    (0, $bSJIT.useEffect)(()=>()=>{
            debouncedLoadFirstPage.cancel();
        }, [
        debouncedLoadFirstPage
    ]);
    // Load options on mount when defaultOptions is true
    (0, $bSJIT.useEffect)(()=>{
        if ($8e668cccf4b27dac$var$hasDefaultOptionsEnabled(fieldAsyncConfiguration)) loadFirstPage('');
    }, [
        fieldAsyncConfiguration,
        loadFirstPage
    ]);
    const handleMenuOpen = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpen(true);
        if (!$8e668cccf4b27dac$var$shouldLoadOptionsWhenMenuOpens(fieldAsyncConfiguration)) return;
        // Only load if we haven't loaded yet, if parent values/config changed, or if the options
        // currently held are still filtered by a previous search keyword. The input is cleared on
        // close, so a previously-searched list must be reloaded unfiltered to stay in sync.
        const previousValues = lastLoadedValuesRef.current;
        const shouldLoad = previousValues === undefined || lastLoadedConfigRef.current !== fieldAsyncConfiguration || (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId) || paginationRef.current.query !== '';
        if (shouldLoad) loadFirstPage(inputValue);
    }, [
        fieldAsyncConfiguration,
        currentValues,
        fieldId,
        inputValue,
        loadFirstPage
    ]);
    const handleMenuClose = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpen(false);
        // Clear the search keyword so the field returns to its selected/default value display and
        // the next open starts from a clean, unfiltered state (matches the non-paginated AsyncSelect,
        // which clears its internal input on close). The selection itself is unaffected because the
        // displayed value is driven by `currentValue`, not `inputValue`.
        setInputValue('');
        debouncedLoadFirstPage.cancel();
    }, [
        debouncedLoadFirstPage
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        // ADS Select calls onInputChange for blur/menu-close as well as real typing.
        // Only user input should trigger keyword API searches.
        if (actionMeta.action !== 'input-change') return;
        setInputValue(newValue);
        debouncedLoadFirstPage(newValue);
    }, [
        debouncedLoadFirstPage
    ]);
    const handleMenuScrollToBottom = (0, $bSJIT.useCallback)(()=>{
        const { hasNextPage: hasNextPage, startIndex: startIndex, query: query } = paginationRef.current;
        if (!hasNextPage || isLoading || !fieldAsyncConfiguration.loadPaginatedOptions) return;
        const requestId = requestCounterRef.current;
        setIsLoading(true);
        fieldAsyncConfiguration.loadPaginatedOptions(query, currentValues, fieldId, startIndex).then((result)=>{
            if (requestId !== requestCounterRef.current) return;
            setAsyncOptions((prev)=>[
                    ...prev,
                    ...result.options
                ]);
            paginationRef.current = {
                query: query,
                startIndex: startIndex + result.options.length,
                hasNextPage: result.hasNextPage
            };
        }).catch(()=>{
        // Keep already-loaded options if an additional page fails
        }).finally(()=>{
            if (requestId !== requestCounterRef.current) return;
            setIsLoading(false);
        });
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId,
        isLoading
    ]);
    // Filter out already selected options from the dropdown list
    const selectedValues = new Set((currentValue === null || currentValue === void 0 || (_currentValue$options = currentValue.options) === null || _currentValue$options === void 0 ? void 0 : _currentValue$options.map((opt)=>opt.id)) ?? []);
    const unselectedOptions = asyncOptions.filter((opt)=>!selectedValues.has(String(opt.value)));
    const asyncOptionsWithLabel = unselectedOptions.length > 0 ? [
        {
            label: intl.formatMessage((0, $3qhpE.messages).searchResultsLabel, {
                numberOfSearchResults: unselectedOptions.length
            }),
            options: unselectedOptions
        }
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-multiple-select-edit-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-multiple-select-edit-async-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        inputId: fieldInputId,
        options: asyncOptionsWithLabel,
        formatGroupLabel: (group)=>group.label,
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options) ?? null,
        inputValue: inputValue,
        menuIsOpen: isMenuOpen,
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        isMulti: true,
        isLoading: isLoading,
        onChange: onChange,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: handleMenuScrollToBottom,
        isSearchable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownNoOptions)),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $3qhpE.messages).optionDropdownSelect),
        isInvalid: isInvalid,
        testId: `field-input-multiple-select-edit-input-${fieldId}`,
        isRequired: isRequired,
        filterOption: null,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        components: $8e668cccf4b27dac$var$selectComponents,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })));
};

});


parcelRegister("5f1tv", function(module, exports) {
$parcel$export(module.exports, "PreviewMultipleSelectInput", () => $3d1b8894af1ea46c$export$69ab2b86f8724bea);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $dDEhr = parcelRequire("dDEhr");

var $eOzrv = parcelRequire("eOzrv");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $5g341 = parcelRequire("5g341");
const $3d1b8894af1ea46c$export$69ab2b86f8724bea = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formOptionField$valu, _formOptionField$valu2, _formOptionField$valu3;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const options = ((_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.options) ?? [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        testId: `field-input-multiple-select-preview-${fieldId}`,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: fieldInputId,
        inputId: fieldInputId,
        value: ((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.otherOptionText) !== undefined ? [
            ...(0, $kVXLM.toOptions)(options),
            {
                value: (0, $gjxgd.OTHER_ID),
                label: intl.formatMessage((0, $5g341.messages).otherOption)
            }
        ] : (0, $kVXLM.toOptions)(options),
        placeholder: "",
        isDisabled: true,
        isMulti: true
    }), ((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $5g341.messages).otherOptionTextLabel, {
            label: formField.label
        })
    }));
};

});
parcelRegister("5g341", function(module, exports) {
$parcel$export(module.exports, "messages", () => $dd27a300f6186bb7$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $dd27a300f6186bb7$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.preview.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.preview.other-option-text-label',
        description: 'Label for the multiple select field other option text area in preview mode, for accessibility',
        defaultMessage: '{label} multiple select field other option text area preview'
    }
});

});


parcelRegister("98asE", function(module, exports) {
$parcel$export(module.exports, "ViewMultipleSelectInput", () => $291bc7a83cadf92d$export$36c4483a5381d628);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $6LJrW = parcelRequire("6LJrW");
const $291bc7a83cadf92d$export$36c4483a5381d628 = ({ fieldId: fieldId })=>{
    var _formOptionField$valu, _formOptionField$valu2;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
    const labels = (_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 || (_formOptionField$valu = _formOptionField$valu.options) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.map((item)=>item.label);
    if (labels && ((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.otherOptionText) !== undefined) {
        var _formOptionField$valu3;
        if (((_formOptionField$valu3 = formOptionField.value.otherOptionText) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.trim()) === '') labels.push(intl.formatMessage((0, $6LJrW.messages).otherOption));
        else labels.push(formOptionField.value.otherOptionText);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-multiple-select-view-${fieldId}`
    }, labels && labels.join(', ')));
};

});
parcelRegister("6LJrW", function(module, exports) {
$parcel$export(module.exports, "messages", () => $77955fc1e846a619$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $77955fc1e846a619$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.multiple-select-input.view.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    }
});

});



parcelRegister("36X5q", function(module, exports) {
$parcel$export(module.exports, "NumberInput", () => $52b2eeaa9645fe38$export$6bf0cd3a219bbade);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $3LRfS = parcelRequire("3LRfS");

var $dtmIH = parcelRequire("dtmIH");

var $l6Rd4 = parcelRequire("l6Rd4");
const $52b2eeaa9645fe38$export$6bf0cd3a219bbade = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3LRfS.EditNumberInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dtmIH.PreviewNumberInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $l6Rd4.ViewNumberInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("3LRfS", function(module, exports) {
$parcel$export(module.exports, "EditNumberInput", () => $939dacd3052a6fdc$export$d537a6b6aac12773);

var $bSJIT = parcelRequire("bSJIT");

var $3dmzA = parcelRequire("3dmzA");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
/**
 * Sanitises raw input into an allowed numeric string. Mirrors what the user is
 * permitted to type so the controlled input keeps a clean value rather than
 * rejecting keystrokes:
 *  - strips any character that is not a digit, decimal point or hyphen;
 *  - removes hyphens that are not at the very start (so `-` is a leading sign
 *    only);
 *  - keeps only the first decimal point, removing any subsequent ones.
 *
 * The last step intentionally uses string slicing rather than a lookbehind
 * regex because lookbehind is disallowed by the `no-lookahead-lookbehind-regexp`
 * lint rule (for cross-browser compatibility).
 */ const $939dacd3052a6fdc$var$sanitiseNumberInput = (rawValue)=>{
    const withAllowedCharacters = rawValue.trim().replace(/[^0-9.-]/g, '') // only allow numbers, periods, and hyphens
    .replace(/(?!^)-/g, ''); // remove hyphens that are not at the start
    const firstDecimalPointIndex = withAllowedCharacters.indexOf('.');
    if (firstDecimalPointIndex === -1) return withAllowedCharacters;
    // Keep everything up to and including the first decimal point, then strip any
    // remaining decimal points from the rest.
    return withAllowedCharacters.slice(0, firstDecimalPointIndex + 1) + withAllowedCharacters.slice(firstDecimalPointIndex + 1).replace(/\./g, '');
};
/**
 * Leading-only, value-less states the user must be able to type before a full
 * number exists (e.g. the start of a negative or decimal number). `decimal.js`
 * throws on these, so they are handled explicitly: echoed to local state so the
 * field stays editable, but never pushed to shared state because they have no
 * numeric value yet.
 */ const $939dacd3052a6fdc$var$ALLOWED_PREFIXES = new Set([
    '-',
    '.',
    '-.'
]);
/**
 * Determines whether the input string is a number that JavaScript can represent
 * without losing precision.
 *
 * `parseFloat` silently clamps numbers with more significant digits than a
 * double can hold to the nearest representable value — e.g.
 * `parseFloat('12345678901234567890')` returns `12345678901234567000`. Storing
 * that clamped value would make local and shared state disagree with what the
 * user typed, so we treat such inputs as unrepresentable.
 *
 * `decimal.js` parses the full-precision value from the string, so comparing it
 * against the `parseFloat` result detects any precision loss. Purely cosmetic
 * differences that do NOT change the value are still representable, so formatted
 * inputs like `1.`, `1.0`, `1.50`, `.5`, `01`, `-0` and exact small decimals
 * like `0.0000001` remain valid. Values with more significant digits than a
 * double can represent (e.g. `12345678901234567890`) are not representable.
 */ const $939dacd3052a6fdc$var$isRepresentableNumber = (value)=>{
    try {
        const exact = new (0, $3dmzA.default)(value);
        return exact.isFinite() && exact.eq(new (0, $3dmzA.default)(parseFloat(value)));
    } catch  {
        return false;
    }
};
const $939dacd3052a6fdc$export$d537a6b6aac12773 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asNumberValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [numberFieldValue, setNumberFieldValue] = (0, $bSJIT.useState)(currentValue ? (_asNumberValue = (0, $i86qj.asNumberValue)(currentValue)) === null || _asNumberValue === void 0 ? void 0 : _asNumberValue.number.toString() : '');
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        if ((0, $gdUUy.fg)('proforma_fix_number_input_precision')) {
            const number = $939dacd3052a6fdc$var$sanitiseNumberInput(event.target.value);
            if (number.length === 0) {
                // Cleared field: reset local state and clear the shared value together.
                setNumberFieldValue(number);
                debouncedUpdateModifiedValue(fieldId, null);
            } else if ($939dacd3052a6fdc$var$ALLOWED_PREFIXES.has(number)) // Value-less leading states ("-", ".", "-.") let the user start typing
            // a negative or decimal number. Echo them locally so the field stays
            // editable, but leave shared state untouched until a real number
            // exists.
            setNumberFieldValue(number);
            else if ($939dacd3052a6fdc$var$isRepresentableNumber(number)) {
                // The value is representable without precision loss. Echo the sanitised
                // string locally (so formatted inputs like "1." or "1.50" remain
                // editable) while pushing the equivalent parsed number to shared state
                // so local and shared state stay in lockstep. Numbers too big to
                // represent without precision loss fall through to a no-op, so the
                // field rejects the keystroke and the two states never diverge.
                setNumberFieldValue(number);
                debouncedUpdateModifiedValue(fieldId, {
                    number: parseFloat(number)
                });
            }
            return;
        }
        // Legacy behaviour (gate off): `setNumberFieldValue` is called
        // unconditionally, so `parseFloat` clamping a too-big number can leave
        // local and shared state inconsistent.
        const number = event.target.value.trim().replace(/[^0-9.-]/g, '') // only allow numbers, periods, and hyphens
        .replace(/(?!^)-/g, '') // remove hyphens that are not at the start
        .replace(/(\..*)\./g, '$1'); // remove duplicate decimal points
        setNumberFieldValue(number);
        if (number.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else if (!Number.isNaN(parseFloat(number))) debouncedUpdateModifiedValue(fieldId, {
            number: parseFloat(number)
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: numberFieldValue,
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        width: "small",
        placeholder: "",
        testId: `field-input-number-edit-${fieldId}`,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});
parcelRegister("3dmzA", function(module, exports) {
$parcel$export(module.exports, "default", () => $25741881e92d1003$export$2e2bcd8739ae039);
/*!
 *  decimal.js v10.6.0
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
// The maximum exponent magnitude.
// The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
var $25741881e92d1003$var$EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
$25741881e92d1003$var$MAX_DIGITS = 1e9, // Base conversion alphabet.
$25741881e92d1003$var$NUMERALS = '0123456789abcdef', // The natural logarithm of 10 (1025 digits).
$25741881e92d1003$var$LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058', // Pi (1025 digits).
$25741881e92d1003$var$PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789', // The initial configuration properties of the Decimal constructor.
$25741881e92d1003$var$DEFAULTS = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed at run-time using the `Decimal.config` method.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // The rounding mode used when rounding to `precision`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP         0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
    // FLOOR      3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN  6 The IEEE 754 remainder function.
    // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
    //
    // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
    // division (9) are commonly used for the modulus operation. The other rounding modes can also
    // be used, but they may not give useful results.
    modulo: 1,
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // The minimum exponent value, beneath which underflow to zero occurs.
    // JavaScript numbers: -324  (5e-324)
    minE: -$25741881e92d1003$var$EXP_LIMIT,
    // The maximum exponent value, above which overflow to Infinity occurs.
    // JavaScript numbers: 308  (1.7976931348623157e+308)
    maxE: $25741881e92d1003$var$EXP_LIMIT,
    // Whether to use cryptographically-secure random number generation, if available.
    crypto: false // true/false
}, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
$25741881e92d1003$var$inexact, $25741881e92d1003$var$quadrant, $25741881e92d1003$var$external = true, $25741881e92d1003$var$decimalError = '[DecimalError] ', $25741881e92d1003$var$invalidArgument = $25741881e92d1003$var$decimalError + 'Invalid argument: ', $25741881e92d1003$var$precisionLimitExceeded = $25741881e92d1003$var$decimalError + 'Precision limit exceeded', $25741881e92d1003$var$cryptoUnavailable = $25741881e92d1003$var$decimalError + 'crypto unavailable', $25741881e92d1003$var$tag = '[object Decimal]', $25741881e92d1003$var$mathfloor = Math.floor, $25741881e92d1003$var$mathpow = Math.pow, $25741881e92d1003$var$isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, $25741881e92d1003$var$isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, $25741881e92d1003$var$isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, $25741881e92d1003$var$isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $25741881e92d1003$var$BASE = 1e7, $25741881e92d1003$var$LOG_BASE = 7, $25741881e92d1003$var$MAX_SAFE_INTEGER = 9007199254740991, $25741881e92d1003$var$LN10_PRECISION = $25741881e92d1003$var$LN10.length - 1, $25741881e92d1003$var$PI_PRECISION = $25741881e92d1003$var$PI.length - 1, // Decimal.prototype object
$25741881e92d1003$var$P = {
    toStringTag: $25741881e92d1003$var$tag
};
// Decimal prototype methods
/*
 *  absoluteValue             abs
 *  ceil
 *  clampedTo                 clamp
 *  comparedTo                cmp
 *  cosine                    cos
 *  cubeRoot                  cbrt
 *  decimalPlaces             dp
 *  dividedBy                 div
 *  dividedToIntegerBy        divToInt
 *  equals                    eq
 *  floor
 *  greaterThan               gt
 *  greaterThanOrEqualTo      gte
 *  hyperbolicCosine          cosh
 *  hyperbolicSine            sinh
 *  hyperbolicTangent         tanh
 *  inverseCosine             acos
 *  inverseHyperbolicCosine   acosh
 *  inverseHyperbolicSine     asinh
 *  inverseHyperbolicTangent  atanh
 *  inverseSine               asin
 *  inverseTangent            atan
 *  isFinite
 *  isInteger                 isInt
 *  isNaN
 *  isNegative                isNeg
 *  isPositive                isPos
 *  isZero
 *  lessThan                  lt
 *  lessThanOrEqualTo         lte
 *  logarithm                 log
 *  [maximum]                 [max]
 *  [minimum]                 [min]
 *  minus                     sub
 *  modulo                    mod
 *  naturalExponential        exp
 *  naturalLogarithm          ln
 *  negated                   neg
 *  plus                      add
 *  precision                 sd
 *  round
 *  sine                      sin
 *  squareRoot                sqrt
 *  tangent                   tan
 *  times                     mul
 *  toBinary
 *  toDecimalPlaces           toDP
 *  toExponential
 *  toFixed
 *  toFraction
 *  toHexadecimal             toHex
 *  toNearest
 *  toNumber
 *  toOctal
 *  toPower                   pow
 *  toPrecision
 *  toSignificantDigits       toSD
 *  toString
 *  truncated                 trunc
 *  valueOf                   toJSON
 */ /*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */ $25741881e92d1003$var$P.absoluteValue = $25741881e92d1003$var$P.abs = function() {
    var x = new this.constructor(this);
    if (x.s < 0) x.s = 1;
    return $25741881e92d1003$var$finalise(x);
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
 * direction of positive Infinity.
 *
 */ $25741881e92d1003$var$P.ceil = function() {
    return $25741881e92d1003$var$finalise(new this.constructor(this), this.e + 1, 2);
};
/*
 * Return a new Decimal whose value is the value of this Decimal clamped to the range
 * delineated by `min` and `max`.
 *
 * min {number|string|bigint|Decimal}
 * max {number|string|bigint|Decimal}
 *
 */ $25741881e92d1003$var$P.clampedTo = $25741881e92d1003$var$P.clamp = function(min, max) {
    var k, x = this, Ctor = x.constructor;
    min = new Ctor(min);
    max = new Ctor(max);
    if (!min.s || !max.s) return new Ctor(NaN);
    if (min.gt(max)) throw Error($25741881e92d1003$var$invalidArgument + max);
    k = x.cmp(min);
    return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
};
/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value,
 *   NaN  if the value of either Decimal is NaN.
 *
 */ $25741881e92d1003$var$P.comparedTo = $25741881e92d1003$var$P.cmp = function(y) {
    var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
    // Either NaN or ±Infinity?
    if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
    // Either zero?
    if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
    // Signs differ?
    if (xs !== ys) return xs;
    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
    xdL = xd.length;
    ydL = yd.length;
    // Compare digit by digit.
    for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
        if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
    }
    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
};
/*
 * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * cos(0)         = 1
 * cos(-0)        = 1
 * cos(Infinity)  = NaN
 * cos(-Infinity) = NaN
 * cos(NaN)       = NaN
 *
 */ $25741881e92d1003$var$P.cosine = $25741881e92d1003$var$P.cos = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (!x.d) return new Ctor(NaN);
    // cos(0) = cos(-0) = 1
    if (!x.d[0]) return new Ctor(1);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + $25741881e92d1003$var$LOG_BASE;
    Ctor.rounding = 1;
    x = $25741881e92d1003$var$cosine(Ctor, $25741881e92d1003$var$toLessThanHalfPi(Ctor, x));
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return $25741881e92d1003$var$finalise($25741881e92d1003$var$quadrant == 2 || $25741881e92d1003$var$quadrant == 3 ? x.neg() : x, pr, rm, true);
};
/*
 *
 * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 *  cbrt(0)  =  0
 *  cbrt(-0) = -0
 *  cbrt(1)  =  1
 *  cbrt(-1) = -1
 *  cbrt(N)  =  N
 *  cbrt(-I) = -I
 *  cbrt(I)  =  I
 *
 * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
 *
 */ $25741881e92d1003$var$P.cubeRoot = $25741881e92d1003$var$P.cbrt = function() {
    var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
    if (!x.isFinite() || x.isZero()) return new Ctor(x);
    $25741881e92d1003$var$external = false;
    // Initial estimate.
    s = x.s * $25741881e92d1003$var$mathpow(x.s * x, 1 / 3);
    // Math.cbrt underflow/overflow?
    // Pass x to Math.pow as integer, then adjust the exponent of the result.
    if (!s || Math.abs(s) == 1 / 0) {
        n = $25741881e92d1003$var$digitsToString(x.d);
        e = x.e;
        // Adjust n exponent so it is a multiple of 3 away from x exponent.
        if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? '0' : '00';
        s = $25741881e92d1003$var$mathpow(n, 1 / 3);
        // Rarely, e may be one less than the result exponent value.
        e = $25741881e92d1003$var$mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
        if (s == 1 / 0) n = '5e' + e;
        else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf('e') + 1) + e;
        }
        r = new Ctor(n);
        r.s = x.s;
    } else r = new Ctor(s.toString());
    sd = (e = Ctor.precision) + 3;
    // Halley's method.
    // TODO? Compare Newton's method.
    for(;;){
        t = r;
        t3 = t.times(t).times(t);
        t3plusx = t3.plus(x);
        r = $25741881e92d1003$var$divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
        // TODO? Replace with for-loop and checkRoundingDigits.
        if ($25741881e92d1003$var$digitsToString(t.d).slice(0, sd) === (n = $25741881e92d1003$var$digitsToString(r.d)).slice(0, sd)) {
            n = n.slice(sd - 3, sd + 1);
            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
            // , i.e. approaching a rounding boundary, continue the iteration.
            if (n == '9999' || !rep && n == '4999') {
                // On the first iteration only, check to see if rounding up gives the exact result as the
                // nines may infinitely repeat.
                if (!rep) {
                    $25741881e92d1003$var$finalise(t, e + 1, 0);
                    if (t.times(t).times(t).eq(x)) {
                        r = t;
                        break;
                    }
                }
                sd += 4;
                rep = 1;
            } else {
                // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                // If not, then there are further digits and m will be truthy.
                if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                    // Truncate to the first rounding digit.
                    $25741881e92d1003$var$finalise(r, e + 1, 1);
                    m = !r.times(r).times(r).eq(x);
                }
                break;
            }
        }
    }
    $25741881e92d1003$var$external = true;
    return $25741881e92d1003$var$finalise(r, e, Ctor.rounding, m);
};
/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */ $25741881e92d1003$var$P.decimalPlaces = $25741881e92d1003$var$P.dp = function() {
    var w, d = this.d, n = NaN;
    if (d) {
        w = d.length - 1;
        n = (w - $25741881e92d1003$var$mathfloor(this.e / $25741881e92d1003$var$LOG_BASE)) * $25741881e92d1003$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = d[w];
        if (w) for(; w % 10 == 0; w /= 10)n--;
        if (n < 0) n = 0;
    }
    return n;
};
/*
 *  n / 0 = I
 *  n / N = N
 *  n / I = 0
 *  0 / n = 0
 *  0 / 0 = N
 *  0 / N = N
 *  0 / I = 0
 *  N / n = N
 *  N / 0 = N
 *  N / N = N
 *  N / I = N
 *  I / n = I
 *  I / 0 = I
 *  I / N = N
 *  I / I = N
 *
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.dividedBy = $25741881e92d1003$var$P.div = function(y) {
    return $25741881e92d1003$var$divide(this, new this.constructor(y));
};
/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.dividedToIntegerBy = $25741881e92d1003$var$P.divToInt = function(y) {
    var x = this, Ctor = x.constructor;
    return $25741881e92d1003$var$finalise($25741881e92d1003$var$divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
};
/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */ $25741881e92d1003$var$P.equals = $25741881e92d1003$var$P.eq = function(y) {
    return this.cmp(y) === 0;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
 * direction of negative Infinity.
 *
 */ $25741881e92d1003$var$P.floor = function() {
    return $25741881e92d1003$var$finalise(new this.constructor(this), this.e + 1, 3);
};
/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */ $25741881e92d1003$var$P.greaterThan = $25741881e92d1003$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */ $25741881e92d1003$var$P.greaterThanOrEqualTo = $25741881e92d1003$var$P.gte = function(y) {
    var k = this.cmp(y);
    return k == 1 || k === 0;
};
/*
 * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [1, Infinity]
 *
 * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
 *
 * cosh(0)         = 1
 * cosh(-0)        = 1
 * cosh(Infinity)  = Infinity
 * cosh(-Infinity) = Infinity
 * cosh(NaN)       = NaN
 *
 *  x        time taken (ms)   result
 * 1000      9                 9.8503555700852349694e+433
 * 10000     25                4.4034091128314607936e+4342
 * 100000    171               1.4033316802130615897e+43429
 * 1000000   3817              1.5166076984010437725e+434294
 * 10000000  abandoned after 2 minute wait
 *
 * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
 *
 */ $25741881e92d1003$var$P.hyperbolicCosine = $25741881e92d1003$var$P.cosh = function() {
    var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
    if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
    if (x.isZero()) return one;
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
    Ctor.rounding = 1;
    len = x.d.length;
    // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
    // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
    // Estimate the optimum number of times to use the argument reduction.
    // TODO? Estimation reused from cosine() and may not be optimal here.
    if (len < 32) {
        k = Math.ceil(len / 3);
        n = (1 / $25741881e92d1003$var$tinyPow(4, k)).toString();
    } else {
        k = 16;
        n = '2.3283064365386962890625e-10';
    }
    x = $25741881e92d1003$var$taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
    // Reverse argument reduction
    var cosh2_x, i = k, d8 = new Ctor(8);
    for(; i--;){
        cosh2_x = x.times(x);
        x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
    }
    return $25741881e92d1003$var$finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
};
/*
 * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
 *
 * sinh(0)         = 0
 * sinh(-0)        = -0
 * sinh(Infinity)  = Infinity
 * sinh(-Infinity) = -Infinity
 * sinh(NaN)       = NaN
 *
 * x        time taken (ms)
 * 10       2 ms
 * 100      5 ms
 * 1000     14 ms
 * 10000    82 ms
 * 100000   886 ms            1.4033316802130615897e+43429
 * 200000   2613 ms
 * 300000   5407 ms
 * 400000   8824 ms
 * 500000   13026 ms          8.7080643612718084129e+217146
 * 1000000  48543 ms
 *
 * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
 *
 */ $25741881e92d1003$var$P.hyperbolicSine = $25741881e92d1003$var$P.sinh = function() {
    var k, pr, rm, len, x = this, Ctor = x.constructor;
    if (!x.isFinite() || x.isZero()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
    Ctor.rounding = 1;
    len = x.d.length;
    if (len < 3) x = $25741881e92d1003$var$taylorSeries(Ctor, 2, x, x, true);
    else {
        // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
        // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
        // 3 multiplications and 1 addition
        // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
        // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
        // 4 multiplications and 2 additions
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / $25741881e92d1003$var$tinyPow(5, k));
        x = $25741881e92d1003$var$taylorSeries(Ctor, 2, x, x, true);
        // Reverse argument reduction
        var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sinh2_x = x.times(x);
            x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
        }
    }
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return $25741881e92d1003$var$finalise(x, pr, rm, true);
};
/*
 * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * tanh(x) = sinh(x) / cosh(x)
 *
 * tanh(0)         = 0
 * tanh(-0)        = -0
 * tanh(Infinity)  = 1
 * tanh(-Infinity) = -1
 * tanh(NaN)       = NaN
 *
 */ $25741881e92d1003$var$P.hyperbolicTangent = $25741881e92d1003$var$P.tanh = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (!x.isFinite()) return new Ctor(x.s);
    if (x.isZero()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 7;
    Ctor.rounding = 1;
    return $25741881e92d1003$var$divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
};
/*
 * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
 * this Decimal.
 *
 * Domain: [-1, 1]
 * Range: [0, pi]
 *
 * acos(x) = pi/2 - asin(x)
 *
 * acos(0)       = pi/2
 * acos(-0)      = pi/2
 * acos(1)       = 0
 * acos(-1)      = pi
 * acos(1/2)     = pi/3
 * acos(-1/2)    = 2*pi/3
 * acos(|x| > 1) = NaN
 * acos(NaN)     = NaN
 *
 */ $25741881e92d1003$var$P.inverseCosine = $25741881e92d1003$var$P.acos = function() {
    var x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
    if (k !== -1) return k === 0 ? x.isNeg() ? $25741881e92d1003$var$getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
    if (x.isZero()) return $25741881e92d1003$var$getPi(Ctor, pr + 4, rm).times(0.5);
    // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
    Ctor.precision = pr + 6;
    Ctor.rounding = 1;
    // See https://github.com/MikeMcl/decimal.js/pull/217
    x = new Ctor(1).minus(x).div(x.plus(1)).sqrt().atan();
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return x.times(2);
};
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
 * value of this Decimal.
 *
 * Domain: [1, Infinity]
 * Range: [0, Infinity]
 *
 * acosh(x) = ln(x + sqrt(x^2 - 1))
 *
 * acosh(x < 1)     = NaN
 * acosh(NaN)       = NaN
 * acosh(Infinity)  = Infinity
 * acosh(-Infinity) = NaN
 * acosh(0)         = NaN
 * acosh(-0)        = NaN
 * acosh(1)         = 0
 * acosh(-1)        = NaN
 *
 */ $25741881e92d1003$var$P.inverseHyperbolicCosine = $25741881e92d1003$var$P.acosh = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
    if (!x.isFinite()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
    Ctor.rounding = 1;
    $25741881e92d1003$var$external = false;
    x = x.times(x).minus(1).sqrt().plus(x);
    $25741881e92d1003$var$external = true;
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return x.ln();
};
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
 * of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * asinh(x) = ln(x + sqrt(x^2 + 1))
 *
 * asinh(NaN)       = NaN
 * asinh(Infinity)  = Infinity
 * asinh(-Infinity) = -Infinity
 * asinh(0)         = 0
 * asinh(-0)        = -0
 *
 */ $25741881e92d1003$var$P.inverseHyperbolicSine = $25741881e92d1003$var$P.asinh = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (!x.isFinite() || x.isZero()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
    Ctor.rounding = 1;
    $25741881e92d1003$var$external = false;
    x = x.times(x).plus(1).sqrt().plus(x);
    $25741881e92d1003$var$external = true;
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return x.ln();
};
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
 * value of this Decimal.
 *
 * Domain: [-1, 1]
 * Range: [-Infinity, Infinity]
 *
 * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
 *
 * atanh(|x| > 1)   = NaN
 * atanh(NaN)       = NaN
 * atanh(Infinity)  = NaN
 * atanh(-Infinity) = NaN
 * atanh(0)         = 0
 * atanh(-0)        = -0
 * atanh(1)         = Infinity
 * atanh(-1)        = -Infinity
 *
 */ $25741881e92d1003$var$P.inverseHyperbolicTangent = $25741881e92d1003$var$P.atanh = function() {
    var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
    if (!x.isFinite()) return new Ctor(NaN);
    if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    xsd = x.sd();
    if (Math.max(xsd, pr) < 2 * -x.e - 1) return $25741881e92d1003$var$finalise(new Ctor(x), pr, rm, true);
    Ctor.precision = wpr = xsd - x.e;
    x = $25741881e92d1003$var$divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
    Ctor.precision = pr + 4;
    Ctor.rounding = 1;
    x = x.ln();
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return x.times(0.5);
};
/*
 * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi/2, pi/2]
 *
 * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
 *
 * asin(0)       = 0
 * asin(-0)      = -0
 * asin(1/2)     = pi/6
 * asin(-1/2)    = -pi/6
 * asin(1)       = pi/2
 * asin(-1)      = -pi/2
 * asin(|x| > 1) = NaN
 * asin(NaN)     = NaN
 *
 * TODO? Compare performance of Taylor series.
 *
 */ $25741881e92d1003$var$P.inverseSine = $25741881e92d1003$var$P.asin = function() {
    var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
    if (x.isZero()) return new Ctor(x);
    k = x.abs().cmp(1);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    if (k !== -1) {
        // |x| is 1
        if (k === 0) {
            halfPi = $25741881e92d1003$var$getPi(Ctor, pr + 4, rm).times(0.5);
            halfPi.s = x.s;
            return halfPi;
        }
        // |x| > 1 or x is NaN
        return new Ctor(NaN);
    }
    // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
    Ctor.precision = pr + 6;
    Ctor.rounding = 1;
    x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return x.times(2);
};
/*
 * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
 * of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi/2, pi/2]
 *
 * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
 *
 * atan(0)         = 0
 * atan(-0)        = -0
 * atan(1)         = pi/4
 * atan(-1)        = -pi/4
 * atan(Infinity)  = pi/2
 * atan(-Infinity) = -pi/2
 * atan(NaN)       = NaN
 *
 */ $25741881e92d1003$var$P.inverseTangent = $25741881e92d1003$var$P.atan = function() {
    var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
    if (!x.isFinite()) {
        if (!x.s) return new Ctor(NaN);
        if (pr + 4 <= $25741881e92d1003$var$PI_PRECISION) {
            r = $25741881e92d1003$var$getPi(Ctor, pr + 4, rm).times(0.5);
            r.s = x.s;
            return r;
        }
    } else if (x.isZero()) return new Ctor(x);
    else if (x.abs().eq(1) && pr + 4 <= $25741881e92d1003$var$PI_PRECISION) {
        r = $25741881e92d1003$var$getPi(Ctor, pr + 4, rm).times(0.25);
        r.s = x.s;
        return r;
    }
    Ctor.precision = wpr = pr + 10;
    Ctor.rounding = 1;
    // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
    // Argument reduction
    // Ensure |x| < 0.42
    // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
    k = Math.min(28, wpr / $25741881e92d1003$var$LOG_BASE + 2 | 0);
    for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
    $25741881e92d1003$var$external = false;
    j = Math.ceil(wpr / $25741881e92d1003$var$LOG_BASE);
    n = 1;
    x2 = x.times(x);
    r = new Ctor(x);
    px = x;
    // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
    for(; i !== -1;){
        px = px.times(x2);
        t = r.minus(px.div(n += 2));
        px = px.times(x2);
        r = t.plus(px.div(n += 2));
        if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
    }
    if (k) r = r.times(2 << k - 1);
    $25741881e92d1003$var$external = true;
    return $25741881e92d1003$var$finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
};
/*
 * Return true if the value of this Decimal is a finite number, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isFinite = function() {
    return !!this.d;
};
/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isInteger = $25741881e92d1003$var$P.isInt = function() {
    return !!this.d && $25741881e92d1003$var$mathfloor(this.e / $25741881e92d1003$var$LOG_BASE) > this.d.length - 2;
};
/*
 * Return true if the value of this Decimal is NaN, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isNaN = function() {
    return !this.s;
};
/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isNegative = $25741881e92d1003$var$P.isNeg = function() {
    return this.s < 0;
};
/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isPositive = $25741881e92d1003$var$P.isPos = function() {
    return this.s > 0;
};
/*
 * Return true if the value of this Decimal is 0 or -0, otherwise return false.
 *
 */ $25741881e92d1003$var$P.isZero = function() {
    return !!this.d && this.d[0] === 0;
};
/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */ $25741881e92d1003$var$P.lessThan = $25741881e92d1003$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */ $25741881e92d1003$var$P.lessThanOrEqualTo = $25741881e92d1003$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * If no base is specified, return log[10](arg).
 *
 * log[base](arg) = ln(arg) / ln(base)
 *
 * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
 * otherwise:
 *
 * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
 * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
 * between the result and the correctly rounded result will be one ulp (unit in the last place).
 *
 * log[-b](a)       = NaN
 * log[0](a)        = NaN
 * log[1](a)        = NaN
 * log[NaN](a)      = NaN
 * log[Infinity](a) = NaN
 * log[b](0)        = -Infinity
 * log[b](-0)       = -Infinity
 * log[b](-a)       = NaN
 * log[b](1)        = 0
 * log[b](Infinity) = Infinity
 * log[b](NaN)      = NaN
 *
 * [base] {number|string|bigint|Decimal} The base of the logarithm.
 *
 */ $25741881e92d1003$var$P.logarithm = $25741881e92d1003$var$P.log = function(base) {
    var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
    // Default base is 10.
    if (base == null) {
        base = new Ctor(10);
        isBase10 = true;
    } else {
        base = new Ctor(base);
        d = base.d;
        // Return NaN if base is negative, or non-finite, or is 0 or 1.
        if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
        isBase10 = base.eq(10);
    }
    d = arg.d;
    // Is arg negative, non-finite, 0 or 1?
    if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
    // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
    // integer power of 10.
    if (isBase10) {
        if (d.length > 1) inf = true;
        else {
            for(k = d[0]; k % 10 === 0;)k /= 10;
            inf = k !== 1;
        }
    }
    $25741881e92d1003$var$external = false;
    sd = pr + guard;
    num = $25741881e92d1003$var$naturalLogarithm(arg, sd);
    denominator = isBase10 ? $25741881e92d1003$var$getLn10(Ctor, sd + 10) : $25741881e92d1003$var$naturalLogarithm(base, sd);
    // The result will have 5 rounding digits.
    r = $25741881e92d1003$var$divide(num, denominator, sd, 1);
    // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
    // calculate 10 further digits.
    //
    // If the result is known to have an infinite decimal expansion, repeat this until it is clear
    // that the result is above or below the boundary. Otherwise, if after calculating the 10
    // further digits, the last 14 are nines, round up and assume the result is exact.
    // Also assume the result is exact if the last 14 are zero.
    //
    // Example of a result that will be incorrectly rounded:
    // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
    // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
    // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
    // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
    // place is still 2.6.
    if ($25741881e92d1003$var$checkRoundingDigits(r.d, k = pr, rm)) do {
        sd += 10;
        num = $25741881e92d1003$var$naturalLogarithm(arg, sd);
        denominator = isBase10 ? $25741881e92d1003$var$getLn10(Ctor, sd + 10) : $25741881e92d1003$var$naturalLogarithm(base, sd);
        r = $25741881e92d1003$var$divide(num, denominator, sd, 1);
        if (!inf) {
            // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
            if (+$25741881e92d1003$var$digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = $25741881e92d1003$var$finalise(r, pr + 1, 0);
            break;
        }
    }while ($25741881e92d1003$var$checkRoundingDigits(r.d, k += 10, rm));
    $25741881e92d1003$var$external = true;
    return $25741881e92d1003$var$finalise(r, pr, rm);
};
/*
 * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
 *
 * arguments {number|string|bigint|Decimal}
 *
P.max = function () {
  Array.prototype.push.call(arguments, this);
  return maxOrMin(this.constructor, arguments, -1);
};
 */ /*
 * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
 *
 * arguments {number|string|bigint|Decimal}
 *
P.min = function () {
  Array.prototype.push.call(arguments, this);
  return maxOrMin(this.constructor, arguments, 1);
};
 */ /*
 *  n - 0 = n
 *  n - N = N
 *  n - I = -I
 *  0 - n = -n
 *  0 - 0 = 0
 *  0 - N = N
 *  0 - I = -I
 *  N - n = N
 *  N - 0 = N
 *  N - N = N
 *  N - I = N
 *  I - n = I
 *  I - 0 = I
 *  I - N = N
 *  I - I = N
 *
 * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.minus = $25741881e92d1003$var$P.sub = function(y) {
    var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
    y = new Ctor(y);
    // If either is not finite...
    if (!x.d || !y.d) {
        // Return NaN if either is NaN.
        if (!x.s || !y.s) y = new Ctor(NaN);
        else if (x.d) y.s = -y.s;
        else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
        return y;
    }
    // If signs differ...
    if (x.s != y.s) {
        y.s = -y.s;
        return x.plus(y);
    }
    xd = x.d;
    yd = y.d;
    pr = Ctor.precision;
    rm = Ctor.rounding;
    // If either is zero...
    if (!xd[0] || !yd[0]) {
        // Return y negated if x is zero and y is non-zero.
        if (yd[0]) y.s = -y.s;
        else if (xd[0]) y = new Ctor(x);
        else return new Ctor(rm === 3 ? -0 : 0);
        return $25741881e92d1003$var$external ? $25741881e92d1003$var$finalise(y, pr, rm) : y;
    }
    // x and y are finite, non-zero numbers with the same sign.
    // Calculate base 1e7 exponents.
    e = $25741881e92d1003$var$mathfloor(y.e / $25741881e92d1003$var$LOG_BASE);
    xe = $25741881e92d1003$var$mathfloor(x.e / $25741881e92d1003$var$LOG_BASE);
    xd = xd.slice();
    k = xe - e;
    // If base 1e7 exponents differ...
    if (k) {
        xLTy = k < 0;
        if (xLTy) {
            d = xd;
            k = -k;
            len = yd.length;
        } else {
            d = yd;
            e = xe;
            len = xd.length;
        }
        // Numbers with massively different exponents would result in a very high number of
        // zeros needing to be prepended, but this can be avoided while still ensuring correct
        // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
        i = Math.max(Math.ceil(pr / $25741881e92d1003$var$LOG_BASE), len) + 2;
        if (k > i) {
            k = i;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents.
        d.reverse();
        for(i = k; i--;)d.push(0);
        d.reverse();
    // Base 1e7 exponents equal.
    } else {
        // Check digits to determine which is the bigger number.
        i = xd.length;
        len = yd.length;
        xLTy = i < len;
        if (xLTy) len = i;
        for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
            xLTy = xd[i] < yd[i];
            break;
        }
        k = 0;
    }
    if (xLTy) {
        d = xd;
        xd = yd;
        yd = d;
        y.s = -y.s;
    }
    len = xd.length;
    // Append zeros to `xd` if shorter.
    // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
    for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
    // Subtract yd from xd.
    for(i = yd.length; i > k;){
        if (xd[--i] < yd[i]) {
            for(j = i; j && xd[--j] === 0;)xd[j] = $25741881e92d1003$var$BASE - 1;
            --xd[j];
            xd[i] += $25741881e92d1003$var$BASE;
        }
        xd[i] -= yd[i];
    }
    // Remove trailing zeros.
    for(; xd[--len] === 0;)xd.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xd[0] === 0; xd.shift())--e;
    // Zero?
    if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
    y.d = xd;
    y.e = $25741881e92d1003$var$getBase10Exponent(xd, e);
    return $25741881e92d1003$var$external ? $25741881e92d1003$var$finalise(y, pr, rm) : y;
};
/*
 *   n % 0 =  N
 *   n % N =  N
 *   n % I =  n
 *   0 % n =  0
 *  -0 % n = -0
 *   0 % 0 =  N
 *   0 % N =  N
 *   0 % I =  0
 *   N % n =  N
 *   N % 0 =  N
 *   N % N =  N
 *   N % I =  N
 *   I % n =  N
 *   I % 0 =  N
 *   I % N =  N
 *   I % I =  N
 *
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * The result depends on the modulo mode.
 *
 */ $25741881e92d1003$var$P.modulo = $25741881e92d1003$var$P.mod = function(y) {
    var q, x = this, Ctor = x.constructor;
    y = new Ctor(y);
    // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
    if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
    // Return x if y is ±Infinity or x is ±0.
    if (!y.d || x.d && !x.d[0]) return $25741881e92d1003$var$finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
    // Prevent rounding of intermediate calculations.
    $25741881e92d1003$var$external = false;
    if (Ctor.modulo == 9) {
        // Euclidian division: q = sign(y) * floor(x / abs(y))
        // result = x - q * y    where  0 <= result < abs(y)
        q = $25741881e92d1003$var$divide(x, y.abs(), 0, 3, 1);
        q.s *= y.s;
    } else q = $25741881e92d1003$var$divide(x, y, 0, Ctor.modulo, 1);
    q = q.times(y);
    $25741881e92d1003$var$external = true;
    return x.minus(q);
};
/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.naturalExponential = $25741881e92d1003$var$P.exp = function() {
    return $25741881e92d1003$var$naturalExponential(this);
};
/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * rounded to `precision` significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.naturalLogarithm = $25741881e92d1003$var$P.ln = function() {
    return $25741881e92d1003$var$naturalLogarithm(this);
};
/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */ $25741881e92d1003$var$P.negated = $25741881e92d1003$var$P.neg = function() {
    var x = new this.constructor(this);
    x.s = -x.s;
    return $25741881e92d1003$var$finalise(x);
};
/*
 *  n + 0 = n
 *  n + N = N
 *  n + I = I
 *  0 + n = n
 *  0 + 0 = 0
 *  0 + N = N
 *  0 + I = I
 *  N + n = N
 *  N + 0 = N
 *  N + N = N
 *  N + I = N
 *  I + n = I
 *  I + 0 = I
 *  I + N = N
 *  I + I = I
 *
 * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.plus = $25741881e92d1003$var$P.add = function(y) {
    var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
    y = new Ctor(y);
    // If either is not finite...
    if (!x.d || !y.d) {
        // Return NaN if either is NaN.
        if (!x.s || !y.s) y = new Ctor(NaN);
        else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
        return y;
    }
    // If signs differ...
    if (x.s != y.s) {
        y.s = -y.s;
        return x.minus(y);
    }
    xd = x.d;
    yd = y.d;
    pr = Ctor.precision;
    rm = Ctor.rounding;
    // If either is zero...
    if (!xd[0] || !yd[0]) {
        // Return x if y is zero.
        // Return y if y is non-zero.
        if (!yd[0]) y = new Ctor(x);
        return $25741881e92d1003$var$external ? $25741881e92d1003$var$finalise(y, pr, rm) : y;
    }
    // x and y are finite, non-zero numbers with the same sign.
    // Calculate base 1e7 exponents.
    k = $25741881e92d1003$var$mathfloor(x.e / $25741881e92d1003$var$LOG_BASE);
    e = $25741881e92d1003$var$mathfloor(y.e / $25741881e92d1003$var$LOG_BASE);
    xd = xd.slice();
    i = k - e;
    // If base 1e7 exponents differ...
    if (i) {
        if (i < 0) {
            d = xd;
            i = -i;
            len = yd.length;
        } else {
            d = yd;
            e = k;
            len = xd.length;
        }
        // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
        k = Math.ceil(pr / $25741881e92d1003$var$LOG_BASE);
        len = k > len ? k + 1 : len + 1;
        if (i > len) {
            i = len;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
        d.reverse();
        for(; i--;)d.push(0);
        d.reverse();
    }
    len = xd.length;
    i = yd.length;
    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
        i = len;
        d = yd;
        yd = xd;
        xd = d;
    }
    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for(carry = 0; i;){
        carry = (xd[--i] = xd[i] + yd[i] + carry) / $25741881e92d1003$var$BASE | 0;
        xd[i] %= $25741881e92d1003$var$BASE;
    }
    if (carry) {
        xd.unshift(carry);
        ++e;
    }
    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for(len = xd.length; xd[--len] == 0;)xd.pop();
    y.d = xd;
    y.e = $25741881e92d1003$var$getBase10Exponent(xd, e);
    return $25741881e92d1003$var$external ? $25741881e92d1003$var$finalise(y, pr, rm) : y;
};
/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */ $25741881e92d1003$var$P.precision = $25741881e92d1003$var$P.sd = function(z) {
    var k, x = this;
    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error($25741881e92d1003$var$invalidArgument + z);
    if (x.d) {
        k = $25741881e92d1003$var$getPrecision(x.d);
        if (z && x.e + 1 > k) k = x.e + 1;
    } else k = NaN;
    return k;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.round = function() {
    var x = this, Ctor = x.constructor;
    return $25741881e92d1003$var$finalise(new Ctor(x), x.e + 1, Ctor.rounding);
};
/*
 * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * sin(x) = x - x^3/3! + x^5/5! - ...
 *
 * sin(0)         = 0
 * sin(-0)        = -0
 * sin(Infinity)  = NaN
 * sin(-Infinity) = NaN
 * sin(NaN)       = NaN
 *
 */ $25741881e92d1003$var$P.sine = $25741881e92d1003$var$P.sin = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (!x.isFinite()) return new Ctor(NaN);
    if (x.isZero()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + $25741881e92d1003$var$LOG_BASE;
    Ctor.rounding = 1;
    x = $25741881e92d1003$var$sine(Ctor, $25741881e92d1003$var$toLessThanHalfPi(Ctor, x));
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return $25741881e92d1003$var$finalise($25741881e92d1003$var$quadrant > 2 ? x.neg() : x, pr, rm, true);
};
/*
 * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 *  sqrt(-n) =  N
 *  sqrt(N)  =  N
 *  sqrt(-I) =  N
 *  sqrt(I)  =  I
 *  sqrt(0)  =  0
 *  sqrt(-0) = -0
 *
 */ $25741881e92d1003$var$P.squareRoot = $25741881e92d1003$var$P.sqrt = function() {
    var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
    $25741881e92d1003$var$external = false;
    // Initial estimate.
    s = Math.sqrt(+x);
    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
        n = $25741881e92d1003$var$digitsToString(d);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(n);
        e = $25741881e92d1003$var$mathfloor((e + 1) / 2) - (e < 0 || e % 2);
        if (s == 1 / 0) n = '5e' + e;
        else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf('e') + 1) + e;
        }
        r = new Ctor(n);
    } else r = new Ctor(s.toString());
    sd = (e = Ctor.precision) + 3;
    // Newton-Raphson iteration.
    for(;;){
        t = r;
        r = t.plus($25741881e92d1003$var$divide(x, t, sd + 2, 1)).times(0.5);
        // TODO? Replace with for-loop and checkRoundingDigits.
        if ($25741881e92d1003$var$digitsToString(t.d).slice(0, sd) === (n = $25741881e92d1003$var$digitsToString(r.d)).slice(0, sd)) {
            n = n.slice(sd - 3, sd + 1);
            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
            // 4999, i.e. approaching a rounding boundary, continue the iteration.
            if (n == '9999' || !rep && n == '4999') {
                // On the first iteration only, check to see if rounding up gives the exact result as the
                // nines may infinitely repeat.
                if (!rep) {
                    $25741881e92d1003$var$finalise(t, e + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                }
                sd += 4;
                rep = 1;
            } else {
                // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                // If not, then there are further digits and m will be truthy.
                if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                    // Truncate to the first rounding digit.
                    $25741881e92d1003$var$finalise(r, e + 1, 1);
                    m = !r.times(r).eq(x);
                }
                break;
            }
        }
    }
    $25741881e92d1003$var$external = true;
    return $25741881e92d1003$var$finalise(r, e, Ctor.rounding, m);
};
/*
 * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * tan(0)         = 0
 * tan(-0)        = -0
 * tan(Infinity)  = NaN
 * tan(-Infinity) = NaN
 * tan(NaN)       = NaN
 *
 */ $25741881e92d1003$var$P.tangent = $25741881e92d1003$var$P.tan = function() {
    var pr, rm, x = this, Ctor = x.constructor;
    if (!x.isFinite()) return new Ctor(NaN);
    if (x.isZero()) return new Ctor(x);
    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 10;
    Ctor.rounding = 1;
    x = x.sin();
    x.s = 1;
    x = $25741881e92d1003$var$divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
    Ctor.precision = pr;
    Ctor.rounding = rm;
    return $25741881e92d1003$var$finalise($25741881e92d1003$var$quadrant == 2 || $25741881e92d1003$var$quadrant == 4 ? x.neg() : x, pr, rm, true);
};
/*
 *  n * 0 = 0
 *  n * N = N
 *  n * I = I
 *  0 * n = 0
 *  0 * 0 = 0
 *  0 * N = N
 *  0 * I = N
 *  N * n = N
 *  N * 0 = N
 *  N * N = N
 *  N * I = N
 *  I * n = I
 *  I * 0 = N
 *  I * N = N
 *  I * I = I
 *
 * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 */ $25741881e92d1003$var$P.times = $25741881e92d1003$var$P.mul = function(y) {
    var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
    y.s *= x.s;
    // If either is NaN, ±Infinity or ±0...
    if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
    e = $25741881e92d1003$var$mathfloor(x.e / $25741881e92d1003$var$LOG_BASE) + $25741881e92d1003$var$mathfloor(y.e / $25741881e92d1003$var$LOG_BASE);
    xdL = xd.length;
    ydL = yd.length;
    // Ensure xd points to the longer array.
    if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
    }
    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for(i = rL; i--;)r.push(0);
    // Multiply!
    for(i = ydL; --i >= 0;){
        carry = 0;
        for(k = xdL + i; k > i;){
            t = r[k] + yd[i] * xd[k - i - 1] + carry;
            r[k--] = t % $25741881e92d1003$var$BASE | 0;
            carry = t / $25741881e92d1003$var$BASE | 0;
        }
        r[k] = (r[k] + carry) % $25741881e92d1003$var$BASE | 0;
    }
    // Remove trailing zeros.
    for(; !r[--rL];)r.pop();
    if (carry) ++e;
    else r.shift();
    y.d = r;
    y.e = $25741881e92d1003$var$getBase10Exponent(r, e);
    return $25741881e92d1003$var$external ? $25741881e92d1003$var$finalise(y, Ctor.precision, Ctor.rounding) : y;
};
/*
 * Return a string representing the value of this Decimal in base 2, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toBinary = function(sd, rm) {
    return $25741881e92d1003$var$toStringBinary(this, 2, sd, rm);
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toDecimalPlaces = $25741881e92d1003$var$P.toDP = function(dp, rm) {
    var x = this, Ctor = x.constructor;
    x = new Ctor(x);
    if (dp === void 0) return x;
    $25741881e92d1003$var$checkInt32(dp, 0, $25741881e92d1003$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $25741881e92d1003$var$checkInt32(rm, 0, 8);
    return $25741881e92d1003$var$finalise(x, dp + x.e + 1, rm);
};
/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toExponential = function(dp, rm) {
    var str, x = this, Ctor = x.constructor;
    if (dp === void 0) str = $25741881e92d1003$var$finiteToString(x, true);
    else {
        $25741881e92d1003$var$checkInt32(dp, 0, $25741881e92d1003$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
        x = $25741881e92d1003$var$finalise(new Ctor(x), dp + 1, rm);
        str = $25741881e92d1003$var$finiteToString(x, true, dp + 1);
    }
    return x.isNeg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */ $25741881e92d1003$var$P.toFixed = function(dp, rm) {
    var str, y, x = this, Ctor = x.constructor;
    if (dp === void 0) str = $25741881e92d1003$var$finiteToString(x);
    else {
        $25741881e92d1003$var$checkInt32(dp, 0, $25741881e92d1003$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
        y = $25741881e92d1003$var$finalise(new Ctor(x), dp + x.e + 1, rm);
        str = $25741881e92d1003$var$finiteToString(y, false, dp + y.e + 1);
    }
    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isNeg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return an array representing the value of this Decimal as a simple fraction with an integer
 * numerator and an integer denominator.
 *
 * The denominator will be a positive non-zero value less than or equal to the specified maximum
 * denominator. If a maximum denominator is not specified, the denominator will be the lowest
 * value necessary to represent the number exactly.
 *
 * [maxD] {number|string|bigint|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
 *
 */ $25741881e92d1003$var$P.toFraction = function(maxD) {
    var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
    if (!xd) return new Ctor(x);
    n1 = d0 = new Ctor(1);
    d1 = n0 = new Ctor(0);
    d = new Ctor(d1);
    e = d.e = $25741881e92d1003$var$getPrecision(xd) - x.e - 1;
    k = e % $25741881e92d1003$var$LOG_BASE;
    d.d[0] = $25741881e92d1003$var$mathpow(10, k < 0 ? $25741881e92d1003$var$LOG_BASE + k : k);
    if (maxD == null) // d is 10**e, the minimum max-denominator needed.
    maxD = e > 0 ? d : n1;
    else {
        n = new Ctor(maxD);
        if (!n.isInt() || n.lt(n1)) throw Error($25741881e92d1003$var$invalidArgument + n);
        maxD = n.gt(d) ? e > 0 ? d : n1 : n;
    }
    $25741881e92d1003$var$external = false;
    n = new Ctor($25741881e92d1003$var$digitsToString(xd));
    pr = Ctor.precision;
    Ctor.precision = e = xd.length * $25741881e92d1003$var$LOG_BASE * 2;
    for(;;){
        q = $25741881e92d1003$var$divide(n, d, 0, 1, 1);
        d2 = d0.plus(q.times(d1));
        if (d2.cmp(maxD) == 1) break;
        d0 = d1;
        d1 = d2;
        d2 = n1;
        n1 = n0.plus(q.times(d2));
        n0 = d2;
        d2 = d;
        d = n.minus(q.times(d2));
        n = d2;
    }
    d2 = $25741881e92d1003$var$divide(maxD.minus(d0), d1, 0, 1, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;
    // Determine which fraction is closer to x, n0/d0 or n1/d1?
    r = $25741881e92d1003$var$divide(n1, d1, e, 1).minus(x).abs().cmp($25741881e92d1003$var$divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
        n1,
        d1
    ] : [
        n0,
        d0
    ];
    Ctor.precision = pr;
    $25741881e92d1003$var$external = true;
    return r;
};
/*
 * Return a string representing the value of this Decimal in base 16, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toHexadecimal = $25741881e92d1003$var$P.toHex = function(sd, rm) {
    return $25741881e92d1003$var$toStringBinary(this, 16, sd, rm);
};
/*
 * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
 * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
 *
 * The return value will always have the same sign as this Decimal, unless either this Decimal
 * or `y` is NaN, in which case the return value will be also be NaN.
 *
 * The return value is not affected by the value of `precision`.
 *
 * y {number|string|bigint|Decimal} The magnitude to round to a multiple of.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * 'toNearest() rounding mode not an integer: {rm}'
 * 'toNearest() rounding mode out of range: {rm}'
 *
 */ $25741881e92d1003$var$P.toNearest = function(y, rm) {
    var x = this, Ctor = x.constructor;
    x = new Ctor(x);
    if (y == null) {
        // If x is not finite, return x.
        if (!x.d) return x;
        y = new Ctor(1);
        rm = Ctor.rounding;
    } else {
        y = new Ctor(y);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
        // If x is not finite, return x if y is not NaN, else NaN.
        if (!x.d) return y.s ? x : y;
        // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
        if (!y.d) {
            if (y.s) y.s = x.s;
            return y;
        }
    }
    // If y is not zero, calculate the nearest multiple of y to x.
    if (y.d[0]) {
        $25741881e92d1003$var$external = false;
        x = $25741881e92d1003$var$divide(x, y, 0, rm, 1).times(y);
        $25741881e92d1003$var$external = true;
        $25741881e92d1003$var$finalise(x);
    // If y is zero, return zero with the sign of x.
    } else {
        y.s = x.s;
        x = y;
    }
    return x;
};
/*
 * Return the value of this Decimal converted to a number primitive.
 * Zero keeps its sign.
 *
 */ $25741881e92d1003$var$P.toNumber = function() {
    return +this;
};
/*
 * Return a string representing the value of this Decimal in base 8, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toOctal = function(sd, rm) {
    return $25741881e92d1003$var$toStringBinary(this, 8, sd, rm);
};
/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
 * to `precision` significant digits using rounding mode `rounding`.
 *
 * ECMAScript compliant.
 *
 *   pow(x, NaN)                           = NaN
 *   pow(x, ±0)                            = 1

 *   pow(NaN, non-zero)                    = NaN
 *   pow(abs(x) > 1, +Infinity)            = +Infinity
 *   pow(abs(x) > 1, -Infinity)            = +0
 *   pow(abs(x) == 1, ±Infinity)           = NaN
 *   pow(abs(x) < 1, +Infinity)            = +0
 *   pow(abs(x) < 1, -Infinity)            = +Infinity
 *   pow(+Infinity, y > 0)                 = +Infinity
 *   pow(+Infinity, y < 0)                 = +0
 *   pow(-Infinity, odd integer > 0)       = -Infinity
 *   pow(-Infinity, even integer > 0)      = +Infinity
 *   pow(-Infinity, odd integer < 0)       = -0
 *   pow(-Infinity, even integer < 0)      = +0
 *   pow(+0, y > 0)                        = +0
 *   pow(+0, y < 0)                        = +Infinity
 *   pow(-0, odd integer > 0)              = -0
 *   pow(-0, even integer > 0)             = +0
 *   pow(-0, odd integer < 0)              = -Infinity
 *   pow(-0, even integer < 0)             = +Infinity
 *   pow(finite x < 0, finite non-integer) = NaN
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
 * probability of an incorrectly rounded result
 * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
 * i.e. 1 in 250,000,000,000,000
 *
 * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
 *
 * y {number|string|bigint|Decimal} The power to which to raise this Decimal.
 *
 */ $25741881e92d1003$var$P.toPower = $25741881e92d1003$var$P.pow = function(y) {
    var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
    // Either ±Infinity, NaN or ±0?
    if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor($25741881e92d1003$var$mathpow(+x, yn));
    x = new Ctor(x);
    if (x.eq(1)) return x;
    pr = Ctor.precision;
    rm = Ctor.rounding;
    if (y.eq(1)) return $25741881e92d1003$var$finalise(x, pr, rm);
    // y exponent
    e = $25741881e92d1003$var$mathfloor(y.e / $25741881e92d1003$var$LOG_BASE);
    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= $25741881e92d1003$var$MAX_SAFE_INTEGER) {
        r = $25741881e92d1003$var$intPow(Ctor, x, k, pr);
        return y.s < 0 ? new Ctor(1).div(r) : $25741881e92d1003$var$finalise(r, pr, rm);
    }
    s = x.s;
    // if x is negative
    if (s < 0) {
        // if y is not an integer
        if (e < y.d.length - 1) return new Ctor(NaN);
        // Result is positive if x is negative and the last digit of integer y is even.
        if ((y.d[e] & 1) == 0) s = 1;
        // if x.eq(-1)
        if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
            x.s = s;
            return x;
        }
    }
    // Estimate result exponent.
    // x^y = 10^e,  where e = y * log10(x)
    // log10(x) = log10(x_significand) + x_exponent
    // log10(x_significand) = ln(x_significand) / ln(10)
    k = $25741881e92d1003$var$mathpow(+x, yn);
    e = k == 0 || !isFinite(k) ? $25741881e92d1003$var$mathfloor(yn * (Math.log('0.' + $25741881e92d1003$var$digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + '').e;
    // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
    // Overflow/underflow?
    if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
    $25741881e92d1003$var$external = false;
    Ctor.rounding = x.s = 1;
    // Estimate the extra guard digits needed to ensure five correct rounding digits from
    // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
    // new Decimal(2.32456).pow('2087987436534566.46411')
    // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
    k = Math.min(12, (e + '').length);
    // r = x^y = exp(y*ln(x))
    r = $25741881e92d1003$var$naturalExponential(y.times($25741881e92d1003$var$naturalLogarithm(x, pr + k)), pr);
    // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
    if (r.d) {
        // Truncate to the required precision plus five rounding digits.
        r = $25741881e92d1003$var$finalise(r, pr + 5, 1);
        // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
        // the result.
        if ($25741881e92d1003$var$checkRoundingDigits(r.d, pr, rm)) {
            e = pr + 10;
            // Truncate to the increased precision plus five rounding digits.
            r = $25741881e92d1003$var$finalise($25741881e92d1003$var$naturalExponential(y.times($25741881e92d1003$var$naturalLogarithm(x, e + k)), e), e + 5, 1);
            // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
            if (+$25741881e92d1003$var$digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = $25741881e92d1003$var$finalise(r, pr + 1, 0);
        }
    }
    r.s = s;
    $25741881e92d1003$var$external = true;
    Ctor.rounding = rm;
    return $25741881e92d1003$var$finalise(r, pr, rm);
};
/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $25741881e92d1003$var$P.toPrecision = function(sd, rm) {
    var str, x = this, Ctor = x.constructor;
    if (sd === void 0) str = $25741881e92d1003$var$finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
    else {
        $25741881e92d1003$var$checkInt32(sd, 1, $25741881e92d1003$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
        x = $25741881e92d1003$var$finalise(new Ctor(x), sd, rm);
        str = $25741881e92d1003$var$finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
    }
    return x.isNeg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * 'toSD() digits out of range: {sd}'
 * 'toSD() digits not an integer: {sd}'
 * 'toSD() rounding mode not an integer: {rm}'
 * 'toSD() rounding mode out of range: {rm}'
 *
 */ $25741881e92d1003$var$P.toSignificantDigits = $25741881e92d1003$var$P.toSD = function(sd, rm) {
    var x = this, Ctor = x.constructor;
    if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
    } else {
        $25741881e92d1003$var$checkInt32(sd, 1, $25741881e92d1003$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
    }
    return $25741881e92d1003$var$finalise(new Ctor(x), sd, rm);
};
/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */ $25741881e92d1003$var$P.toString = function() {
    var x = this, Ctor = x.constructor, str = $25741881e92d1003$var$finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
    return x.isNeg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
 *
 */ $25741881e92d1003$var$P.truncated = $25741881e92d1003$var$P.trunc = function() {
    return $25741881e92d1003$var$finalise(new this.constructor(this), this.e + 1, 1);
};
/*
 * Return a string representing the value of this Decimal.
 * Unlike `toString`, negative zero will include the minus sign.
 *
 */ $25741881e92d1003$var$P.valueOf = $25741881e92d1003$var$P.toJSON = function() {
    var x = this, Ctor = x.constructor, str = $25741881e92d1003$var$finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
    return x.isNeg() ? '-' + str : str;
};
// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
/*
 *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
 *                           finiteToString, naturalExponential, naturalLogarithm
 *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
 *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
 *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
 *  convertBase              toStringBinary, parseOther
 *  cos                      P.cos
 *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
 *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
 *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
 *                           taylorSeries, atan2, parseOther
 *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
 *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
 *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
 *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
 *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
 *                           P.truncated, divide, getLn10, getPi, naturalExponential,
 *                           naturalLogarithm, ceil, floor, round, trunc
 *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
 *                           toStringBinary
 *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
 *  getLn10                  P.logarithm, naturalLogarithm
 *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
 *  getPrecision             P.precision, P.toFraction
 *  getZeroString            digitsToString, finiteToString
 *  intPow                   P.toPower, parseOther
 *  isOdd                    toLessThanHalfPi
 *  maxOrMin                 max, min
 *  naturalExponential       P.naturalExponential, P.toPower
 *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
 *                           P.toPower, naturalExponential
 *  nonFiniteToString        finiteToString, toStringBinary
 *  parseDecimal             Decimal
 *  parseOther               Decimal
 *  sin                      P.sin
 *  taylorSeries             P.cosh, P.sinh, cos, sin
 *  toLessThanHalfPi         P.cos, P.sin
 *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
 *  truncate                 intPow
 *
 *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
 *                           naturalLogarithm, config, parseOther, random, Decimal
 */ function $25741881e92d1003$var$digitsToString(d) {
    var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
    if (indexOfLastWord > 0) {
        str += w;
        for(i = 1; i < indexOfLastWord; i++){
            ws = d[i] + '';
            k = $25741881e92d1003$var$LOG_BASE - ws.length;
            if (k) str += $25741881e92d1003$var$getZeroString(k);
            str += ws;
        }
        w = d[i];
        ws = w + '';
        k = $25741881e92d1003$var$LOG_BASE - ws.length;
        if (k) str += $25741881e92d1003$var$getZeroString(k);
    } else if (w === 0) return '0';
    // Remove trailing zeros of last w.
    for(; w % 10 === 0;)w /= 10;
    return str + w;
}
function $25741881e92d1003$var$checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) throw Error($25741881e92d1003$var$invalidArgument + i);
}
/*
 * Check 5 rounding digits if `repeating` is null, 4 otherwise.
 * `repeating == null` if caller is `log` or `pow`,
 * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
 */ function $25741881e92d1003$var$checkRoundingDigits(d, i, rm, repeating) {
    var di, k, r, rd;
    // Get the length of the first word of the array d.
    for(k = d[0]; k >= 10; k /= 10)--i;
    // Is the rounding digit in the first word of d?
    if (--i < 0) {
        i += $25741881e92d1003$var$LOG_BASE;
        di = 0;
    } else {
        di = Math.ceil((i + 1) / $25741881e92d1003$var$LOG_BASE);
        i %= $25741881e92d1003$var$LOG_BASE;
    }
    // i is the index (0 - 6) of the rounding digit.
    // E.g. if within the word 3487563 the first rounding digit is 5,
    // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
    k = $25741881e92d1003$var$mathpow(10, $25741881e92d1003$var$LOG_BASE - i);
    rd = d[di] % k | 0;
    if (repeating == null) {
        if (i < 3) {
            if (i == 0) rd = rd / 100 | 0;
            else if (i == 1) rd = rd / 10 | 0;
            r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
        } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == $25741881e92d1003$var$mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
    } else if (i < 4) {
        if (i == 0) rd = rd / 1000 | 0;
        else if (i == 1) rd = rd / 100 | 0;
        else if (i == 2) rd = rd / 10 | 0;
        r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
    } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == $25741881e92d1003$var$mathpow(10, i - 3) - 1;
    return r;
}
// Convert string of `baseIn` to an array of numbers of `baseOut`.
// Eg. convertBase('255', 10, 16) returns [15, 15].
// Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
function $25741881e92d1003$var$convertBase(str, baseIn, baseOut) {
    var j, arr = [
        0
    ], arrL, i = 0, strL = str.length;
    for(; i < strL;){
        for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
        arr[0] += $25741881e92d1003$var$NUMERALS.indexOf(str.charAt(i++));
        for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
            if (arr[j + 1] === void 0) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
        }
    }
    return arr.reverse();
}
/*
 * cos(x) = 1 - x^2/2! + x^4/4! - ...
 * |x| < pi/2
 *
 */ function $25741881e92d1003$var$cosine(Ctor, x) {
    var k, len, y;
    if (x.isZero()) return x;
    // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
    // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
    // Estimate the optimum number of times to use the argument reduction.
    len = x.d.length;
    if (len < 32) {
        k = Math.ceil(len / 3);
        y = (1 / $25741881e92d1003$var$tinyPow(4, k)).toString();
    } else {
        k = 16;
        y = '2.3283064365386962890625e-10';
    }
    Ctor.precision += k;
    x = $25741881e92d1003$var$taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
    // Reverse argument reduction
    for(var i = k; i--;){
        var cos2x = x.times(x);
        x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
    }
    Ctor.precision -= k;
    return x;
}
/*
 * Perform division in the specified base.
 */ var $25741881e92d1003$var$divide = function() {
    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k, base) {
        var temp, carry = 0, i = x.length;
        for(x = x.slice(); i--;){
            temp = x[i] * k + carry;
            x[i] = temp % base | 0;
            carry = temp / base | 0;
        }
        if (carry) x.unshift(carry);
        return x;
    }
    function compare(a, b, aL, bL) {
        var i, r;
        if (aL != bL) r = aL > bL ? 1 : -1;
        else {
            for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                r = a[i] > b[i] ? 1 : -1;
                break;
            }
        }
        return r;
    }
    function subtract(a, b, aL, base) {
        var i = 0;
        // Subtract b from a.
        for(; aL--;){
            a[aL] -= i;
            i = a[aL] < b[aL] ? 1 : 0;
            a[aL] = i * base + a[aL] - b[aL];
        }
        // Remove leading zeros.
        for(; !a[0] && a.length > 1;)a.shift();
    }
    return function(x, y, pr, rm, dp, base) {
        var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
        // Either NaN, Infinity or 0?
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
        xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
        if (base) {
            logBase = 1;
            e = x.e - y.e;
        } else {
            base = $25741881e92d1003$var$BASE;
            logBase = $25741881e92d1003$var$LOG_BASE;
            e = $25741881e92d1003$var$mathfloor(x.e / logBase) - $25741881e92d1003$var$mathfloor(y.e / logBase);
        }
        yL = yd.length;
        xL = xd.length;
        q = new Ctor(sign);
        qd = q.d = [];
        // Result exponent may be one less than e.
        // The digit array of a Decimal from toStringBinary may have trailing zeros.
        for(i = 0; yd[i] == (xd[i] || 0); i++);
        if (yd[i] > (xd[i] || 0)) e--;
        if (pr == null) {
            sd = pr = Ctor.precision;
            rm = Ctor.rounding;
        } else if (dp) sd = pr + (x.e - y.e) + 1;
        else sd = pr;
        if (sd < 0) {
            qd.push(1);
            more = true;
        } else {
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / logBase + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * base + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
                more = k || i < xL;
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= base/2
                k = base / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k, base);
                    xd = multiplyInteger(xd, k, base);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= base / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= base) k = base - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL, base);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL, base);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                more = rem[0] !== void 0;
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
        }
        // logBase is 1 when divide is being used for base conversion.
        if (logBase == 1) {
            q.e = e;
            $25741881e92d1003$var$inexact = more;
        } else {
            // To calculate q.e, first get the number of digits of qd[0].
            for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
            q.e = i + e * logBase - 1;
            $25741881e92d1003$var$finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
        }
        return q;
    };
}();
/*
 * Round `x` to `sd` significant digits using rounding mode `rm`.
 * Check for over/under-flow.
 */ function $25741881e92d1003$var$finalise(x, sd, rm, isTruncated) {
    var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
    // Don't round if sd is null or undefined.
    out: if (sd != null) {
        xd = x.d;
        // Infinity/NaN.
        if (!xd) return x;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd containing rd, a base 1e7 number.
        // xdi: the index of w within xd.
        // digits: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
        i = sd - digits;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += $25741881e92d1003$var$LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
            // Get the rounding digit at index j of w.
            rd = w / $25741881e92d1003$var$mathpow(10, digits - j - 1) % 10 | 0;
        } else {
            xdi = Math.ceil((i + 1) / $25741881e92d1003$var$LOG_BASE);
            k = xd.length;
            if (xdi >= k) {
                if (isTruncated) {
                    // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                    for(; k++ <= xdi;)xd.push(0);
                    w = rd = 0;
                    digits = 1;
                    i %= $25741881e92d1003$var$LOG_BASE;
                    j = i - $25741881e92d1003$var$LOG_BASE + 1;
                } else break out;
            } else {
                w = k = xd[xdi];
                // Get the number of digits of w.
                for(digits = 1; k >= 10; k /= 10)digits++;
                // Get the index of rd within w.
                i %= $25741881e92d1003$var$LOG_BASE;
                // Get the index of rd within w, adjusted for leading zeros.
                // The number of leading zeros of w is given by LOG_BASE - digits.
                j = i - $25741881e92d1003$var$LOG_BASE + digits;
                // Get the rounding digit at index j of w.
                rd = j < 0 ? 0 : w / $25741881e92d1003$var$mathpow(10, digits - j - 1) % 10 | 0;
            }
        }
        // Are there any non-zero digits after the rounding digit?
        isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % $25741881e92d1003$var$mathpow(10, digits - j - 1));
        // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
        // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
        // will give 714.
        roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / $25741881e92d1003$var$mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        if (sd < 1 || !xd[0]) {
            xd.length = 0;
            if (roundUp) {
                // Convert sd to decimal places.
                sd -= x.e + 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = $25741881e92d1003$var$mathpow(10, ($25741881e92d1003$var$LOG_BASE - sd % $25741881e92d1003$var$LOG_BASE) % $25741881e92d1003$var$LOG_BASE);
                x.e = -sd || 0;
            } else // Zero.
            xd[0] = x.e = 0;
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = $25741881e92d1003$var$mathpow(10, $25741881e92d1003$var$LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / $25741881e92d1003$var$mathpow(10, digits - j) % $25741881e92d1003$var$mathpow(10, j) | 0) * k : 0;
        }
        if (roundUp) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                // i will be the length of xd[0] before k is added.
                for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                j = xd[0] += k;
                for(k = 1; j >= 10; j /= 10)k++;
                // if i != k the length has increased.
                if (i != k) {
                    x.e++;
                    if (xd[0] == $25741881e92d1003$var$BASE) xd[0] = 1;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != $25741881e92d1003$var$BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
    }
    if ($25741881e92d1003$var$external) {
        // Overflow?
        if (x.e > Ctor.maxE) {
            // Infinity.
            x.d = null;
            x.e = NaN;
        // Underflow?
        } else if (x.e < Ctor.minE) {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        // Ctor.underflow = true;
        } // else Ctor.underflow = false;
    }
    return x;
}
function $25741881e92d1003$var$finiteToString(x, isExp, sd) {
    if (!x.isFinite()) return $25741881e92d1003$var$nonFiniteToString(x);
    var k, e = x.e, str = $25741881e92d1003$var$digitsToString(x.d), len = str.length;
    if (isExp) {
        if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + $25741881e92d1003$var$getZeroString(k);
        else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
        str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
    } else if (e < 0) {
        str = '0.' + $25741881e92d1003$var$getZeroString(-e - 1) + str;
        if (sd && (k = sd - len) > 0) str += $25741881e92d1003$var$getZeroString(k);
    } else if (e >= len) {
        str += $25741881e92d1003$var$getZeroString(e + 1 - len);
        if (sd && (k = sd - e - 1) > 0) str = str + '.' + $25741881e92d1003$var$getZeroString(k);
    } else {
        if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
        if (sd && (k = sd - len) > 0) {
            if (e + 1 === len) str += '.';
            str += $25741881e92d1003$var$getZeroString(k);
        }
    }
    return str;
}
// Calculate the base 10 exponent from the base 1e7 exponent.
function $25741881e92d1003$var$getBase10Exponent(digits, e) {
    var w = digits[0];
    // Add the number of digits of the first word of the digits array.
    for(e *= $25741881e92d1003$var$LOG_BASE; w >= 10; w /= 10)e++;
    return e;
}
function $25741881e92d1003$var$getLn10(Ctor, sd, pr) {
    if (sd > $25741881e92d1003$var$LN10_PRECISION) {
        // Reset global state in case the exception is caught.
        $25741881e92d1003$var$external = true;
        if (pr) Ctor.precision = pr;
        throw Error($25741881e92d1003$var$precisionLimitExceeded);
    }
    return $25741881e92d1003$var$finalise(new Ctor($25741881e92d1003$var$LN10), sd, 1, true);
}
function $25741881e92d1003$var$getPi(Ctor, sd, rm) {
    if (sd > $25741881e92d1003$var$PI_PRECISION) throw Error($25741881e92d1003$var$precisionLimitExceeded);
    return $25741881e92d1003$var$finalise(new Ctor($25741881e92d1003$var$PI), sd, rm, true);
}
function $25741881e92d1003$var$getPrecision(digits) {
    var w = digits.length - 1, len = w * $25741881e92d1003$var$LOG_BASE + 1;
    w = digits[w];
    // If non-zero...
    if (w) {
        // Subtract the number of trailing zeros of the last word.
        for(; w % 10 == 0; w /= 10)len--;
        // Add the number of digits of the first word.
        for(w = digits[0]; w >= 10; w /= 10)len++;
    }
    return len;
}
function $25741881e92d1003$var$getZeroString(k) {
    var zs = '';
    for(; k--;)zs += '0';
    return zs;
}
/*
 * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
 * integer of type number.
 *
 * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
 *
 */ function $25741881e92d1003$var$intPow(Ctor, x, n, pr) {
    var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
    // Maximum digits array length; leaves [28, 34] guard digits.
    k = Math.ceil(pr / $25741881e92d1003$var$LOG_BASE + 4);
    $25741881e92d1003$var$external = false;
    for(;;){
        if (n % 2) {
            r = r.times(x);
            if ($25741881e92d1003$var$truncate(r.d, k)) isTruncated = true;
        }
        n = $25741881e92d1003$var$mathfloor(n / 2);
        if (n === 0) {
            // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
            n = r.d.length - 1;
            if (isTruncated && r.d[n] === 0) ++r.d[n];
            break;
        }
        x = x.times(x);
        $25741881e92d1003$var$truncate(x.d, k);
    }
    $25741881e92d1003$var$external = true;
    return r;
}
function $25741881e92d1003$var$isOdd(n) {
    return n.d[n.d.length - 1] & 1;
}
/*
 * Handle `max` (`n` is -1) and `min` (`n` is 1).
 */ function $25741881e92d1003$var$maxOrMin(Ctor, args, n) {
    var k, y, x = new Ctor(args[0]), i = 0;
    for(; ++i < args.length;){
        y = new Ctor(args[i]);
        // NaN?
        if (!y.s) {
            x = y;
            break;
        }
        k = x.cmp(y);
        if (k === n || k === 0 && x.s === n) x = y;
    }
    return x;
}
/*
 * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
 * digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
 * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(Infinity)  = Infinity
 *  exp(-Infinity) = 0
 *  exp(NaN)       = NaN
 *  exp(±0)        = 1
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 *  The result will always be correctly rounded.
 *
 */ function $25741881e92d1003$var$naturalExponential(x, sd) {
    var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
    // 0/NaN/Infinity?
    if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
    if (sd == null) {
        $25741881e92d1003$var$external = false;
        wpr = pr;
    } else wpr = sd;
    t = new Ctor(0.03125);
    // while abs(x) >= 0.1
    while(x.e > -2){
        // x = x / 2^5
        x = x.times(t);
        k += 5;
    }
    // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
    // necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log($25741881e92d1003$var$mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(1);
    Ctor.precision = wpr;
    for(;;){
        pow = $25741881e92d1003$var$finalise(pow.times(x), wpr, 1);
        denominator = denominator.times(++i);
        t = sum.plus($25741881e92d1003$var$divide(pow, denominator, wpr, 1));
        if ($25741881e92d1003$var$digitsToString(t.d).slice(0, wpr) === $25741881e92d1003$var$digitsToString(sum.d).slice(0, wpr)) {
            j = k;
            while(j--)sum = $25741881e92d1003$var$finalise(sum.times(sum), wpr, 1);
            // Check to see if the first 4 rounding digits are [49]999.
            // If so, repeat the summation with a higher precision, otherwise
            // e.g. with precision: 18, rounding: 1
            // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
            // `wpr - guard` is the index of first rounding digit.
            if (sd == null) {
                if (rep < 3 && $25741881e92d1003$var$checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                    Ctor.precision = wpr += 10;
                    denominator = pow = t = new Ctor(1);
                    i = 0;
                    rep++;
                } else return $25741881e92d1003$var$finalise(sum, Ctor.precision = pr, rm, $25741881e92d1003$var$external = true);
            } else {
                Ctor.precision = pr;
                return sum;
            }
        }
        sum = t;
    }
}
/*
 * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
 * digits.
 *
 *  ln(-n)        = NaN
 *  ln(0)         = -Infinity
 *  ln(-0)        = -Infinity
 *  ln(1)         = 0
 *  ln(Infinity)  = Infinity
 *  ln(-Infinity) = NaN
 *  ln(NaN)       = NaN
 *
 *  ln(n) (n != 1) is non-terminating.
 *
 */ function $25741881e92d1003$var$naturalLogarithm(y, sd) {
    var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
    // Is x negative or Infinity, NaN, 0 or 1?
    if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
    if (sd == null) {
        $25741881e92d1003$var$external = false;
        wpr = pr;
    } else wpr = sd;
    Ctor.precision = wpr += guard;
    c = $25741881e92d1003$var$digitsToString(xd);
    c0 = c.charAt(0);
    if (Math.abs(e = x.e) < 1.5e15) {
        // Argument reduction.
        // The series converges faster the closer the argument is to 1, so using
        // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
        // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
        // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
        // later be divided by this number, then separate out the power of 10 using
        // ln(a*10^b) = ln(a) + b*ln(10).
        // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
        //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
        // max n is 6 (gives 0.7 - 1.3)
        while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
            x = x.times(y);
            c = $25741881e92d1003$var$digitsToString(x.d);
            c0 = c.charAt(0);
            n++;
        }
        e = x.e;
        if (c0 > 1) {
            x = new Ctor('0.' + c);
            e++;
        } else x = new Ctor(c0 + '.' + c.slice(1));
    } else {
        // The argument reduction method above may result in overflow if the argument y is a massive
        // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
        // function using ln(x*10^e) = ln(x) + e*ln(10).
        t = $25741881e92d1003$var$getLn10(Ctor, wpr + 2, pr).times(e + '');
        x = $25741881e92d1003$var$naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
        Ctor.precision = pr;
        return sd == null ? $25741881e92d1003$var$finalise(x, pr, rm, $25741881e92d1003$var$external = true) : x;
    }
    // x1 is x reduced to a value near 1.
    x1 = x;
    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = $25741881e92d1003$var$divide(x.minus(1), x.plus(1), wpr, 1);
    x2 = $25741881e92d1003$var$finalise(x.times(x), wpr, 1);
    denominator = 3;
    for(;;){
        numerator = $25741881e92d1003$var$finalise(numerator.times(x2), wpr, 1);
        t = sum.plus($25741881e92d1003$var$divide(numerator, new Ctor(denominator), wpr, 1));
        if ($25741881e92d1003$var$digitsToString(t.d).slice(0, wpr) === $25741881e92d1003$var$digitsToString(sum.d).slice(0, wpr)) {
            sum = sum.times(2);
            // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
            // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
            if (e !== 0) sum = sum.plus($25741881e92d1003$var$getLn10(Ctor, wpr + 2, pr).times(e + ''));
            sum = $25741881e92d1003$var$divide(sum, new Ctor(n), wpr, 1);
            // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
            // been repeated previously) and the first 4 rounding digits 9999?
            // If so, restart the summation with a higher precision, otherwise
            // e.g. with precision: 12, rounding: 1
            // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
            // `wpr - guard` is the index of first rounding digit.
            if (sd == null) {
                if ($25741881e92d1003$var$checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                    Ctor.precision = wpr += guard;
                    t = numerator = x = $25741881e92d1003$var$divide(x1.minus(1), x1.plus(1), wpr, 1);
                    x2 = $25741881e92d1003$var$finalise(x.times(x), wpr, 1);
                    denominator = rep = 1;
                } else return $25741881e92d1003$var$finalise(sum, Ctor.precision = pr, rm, $25741881e92d1003$var$external = true);
            } else {
                Ctor.precision = pr;
                return sum;
            }
        }
        sum = t;
        denominator += 2;
    }
}
// ±Infinity, NaN.
function $25741881e92d1003$var$nonFiniteToString(x) {
    // Unsigned.
    return String(x.s * x.s / 0);
}
/*
 * Parse the value of a new Decimal `x` from string `str`.
 */ function $25741881e92d1003$var$parseDecimal(x, str) {
    var e, i, len;
    // TODO BigInt str: no need to check for decimal point, exponential form or leading zeros.
    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
    } else if (e < 0) // Integer.
    e = str.length;
    // Determine leading zeros.
    for(i = 0; str.charCodeAt(i) === 48; i++);
    // Determine trailing zeros.
    for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
    str = str.slice(i, len);
    if (str) {
        len -= i;
        x.e = e = e - i - 1;
        x.d = [];
        // Transform base
        // e is the base 10 exponent.
        // i is where to slice str to get the first word of the digits array.
        i = (e + 1) % $25741881e92d1003$var$LOG_BASE;
        if (e < 0) i += $25741881e92d1003$var$LOG_BASE;
        if (i < len) {
            if (i) x.d.push(+str.slice(0, i));
            for(len -= $25741881e92d1003$var$LOG_BASE; i < len;)x.d.push(+str.slice(i, i += $25741881e92d1003$var$LOG_BASE));
            str = str.slice(i);
            i = $25741881e92d1003$var$LOG_BASE - str.length;
        } else i -= len;
        for(; i--;)str += '0';
        x.d.push(+str);
        if ($25741881e92d1003$var$external) {
            // Overflow?
            if (x.e > x.constructor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < x.constructor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // x.constructor.underflow = true;
            } // else x.constructor.underflow = false;
        }
    } else {
        // Zero.
        x.e = 0;
        x.d = [
            0
        ];
    }
    return x;
}
/*
 * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
 */ function $25741881e92d1003$var$parseOther(x, str) {
    var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
    if (str.indexOf('_') > -1) {
        str = str.replace(/(\d)_(?=\d)/g, '$1');
        if ($25741881e92d1003$var$isDecimal.test(str)) return $25741881e92d1003$var$parseDecimal(x, str);
    } else if (str === 'Infinity' || str === 'NaN') {
        if (!+str) x.s = NaN;
        x.e = NaN;
        x.d = null;
        return x;
    }
    if ($25741881e92d1003$var$isHex.test(str)) {
        base = 16;
        str = str.toLowerCase();
    } else if ($25741881e92d1003$var$isBinary.test(str)) base = 2;
    else if ($25741881e92d1003$var$isOctal.test(str)) base = 8;
    else throw Error($25741881e92d1003$var$invalidArgument + str);
    // Is there a binary exponent part?
    i = str.search(/p/i);
    if (i > 0) {
        p = +str.slice(i + 1);
        str = str.substring(2, i);
    } else str = str.slice(2);
    // Convert `str` as an integer then divide the result by `base` raised to a power such that the
    // fraction part will be restored.
    i = str.indexOf('.');
    isFloat = i >= 0;
    Ctor = x.constructor;
    if (isFloat) {
        str = str.replace('.', '');
        len = str.length;
        i = len - i;
        // log[10](16) = 1.2041... , log[10](88) = 1.9444....
        divisor = $25741881e92d1003$var$intPow(Ctor, new Ctor(base), i, i * 2);
    }
    xd = $25741881e92d1003$var$convertBase(str, base, $25741881e92d1003$var$BASE);
    xe = xd.length - 1;
    // Remove trailing zeros.
    for(i = xe; xd[i] === 0; --i)xd.pop();
    if (i < 0) return new Ctor(x.s * 0);
    x.e = $25741881e92d1003$var$getBase10Exponent(xd, xe);
    x.d = xd;
    $25741881e92d1003$var$external = false;
    // At what precision to perform the division to ensure exact conversion?
    // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
    // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
    // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
    // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
    // Therefore using 4 * the number of digits of str will always be enough.
    if (isFloat) x = $25741881e92d1003$var$divide(x, divisor, len * 4);
    // Multiply by the binary exponent part if present.
    if (p) x = x.times(Math.abs(p) < 54 ? $25741881e92d1003$var$mathpow(2, p) : $25741881e92d1003$export$95c991896bef8714.pow(2, p));
    $25741881e92d1003$var$external = true;
    return x;
}
/*
 * sin(x) = x - x^3/3! + x^5/5! - ...
 * |x| < pi/2
 *
 */ function $25741881e92d1003$var$sine(Ctor, x) {
    var k, len = x.d.length;
    if (len < 3) return x.isZero() ? x : $25741881e92d1003$var$taylorSeries(Ctor, 2, x, x);
    // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
    // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
    // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
    // Estimate the optimum number of times to use the argument reduction.
    k = 1.4 * Math.sqrt(len);
    k = k > 16 ? 16 : k | 0;
    x = x.times(1 / $25741881e92d1003$var$tinyPow(5, k));
    x = $25741881e92d1003$var$taylorSeries(Ctor, 2, x, x);
    // Reverse argument reduction
    var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
    for(; k--;){
        sin2_x = x.times(x);
        x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
    }
    return x;
}
// Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
function $25741881e92d1003$var$taylorSeries(Ctor, n, x, y, isHyperbolic) {
    var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / $25741881e92d1003$var$LOG_BASE);
    $25741881e92d1003$var$external = false;
    x2 = x.times(x);
    u = new Ctor(y);
    for(;;){
        t = $25741881e92d1003$var$divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
        u = isHyperbolic ? y.plus(t) : y.minus(t);
        y = $25741881e92d1003$var$divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
        t = u.plus(y);
        if (t.d[k] !== void 0) {
            for(j = k; t.d[j] === u.d[j] && j--;);
            if (j == -1) break;
        }
        j = u;
        u = y;
        y = t;
        t = j;
        i++;
    }
    $25741881e92d1003$var$external = true;
    t.d.length = k + 1;
    return t;
}
// Exponent e must be positive and non-zero.
function $25741881e92d1003$var$tinyPow(b, e) {
    var n = b;
    while(--e)n *= b;
    return n;
}
// Return the absolute value of `x` reduced to less than or equal to half pi.
function $25741881e92d1003$var$toLessThanHalfPi(Ctor, x) {
    var t, isNeg = x.s < 0, pi = $25741881e92d1003$var$getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
    x = x.abs();
    if (x.lte(halfPi)) {
        $25741881e92d1003$var$quadrant = isNeg ? 4 : 1;
        return x;
    }
    t = x.divToInt(pi);
    if (t.isZero()) $25741881e92d1003$var$quadrant = isNeg ? 3 : 2;
    else {
        x = x.minus(t.times(pi));
        // 0 <= x < pi
        if (x.lte(halfPi)) {
            $25741881e92d1003$var$quadrant = $25741881e92d1003$var$isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
            return x;
        }
        $25741881e92d1003$var$quadrant = $25741881e92d1003$var$isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
    }
    return x.minus(pi).abs();
}
/*
 * Return the value of Decimal `x` as a string in base `baseOut`.
 *
 * If the optional `sd` argument is present include a binary exponent suffix.
 */ function $25741881e92d1003$var$toStringBinary(x, baseOut, sd, rm) {
    var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
    if (isExp) {
        $25741881e92d1003$var$checkInt32(sd, 1, $25741881e92d1003$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $25741881e92d1003$var$checkInt32(rm, 0, 8);
    } else {
        sd = Ctor.precision;
        rm = Ctor.rounding;
    }
    if (!x.isFinite()) str = $25741881e92d1003$var$nonFiniteToString(x);
    else {
        str = $25741881e92d1003$var$finiteToString(x);
        i = str.indexOf('.');
        // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
        // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
        // minBinaryExponent = floor(decimalExponent * log[2](10))
        // log[2](10) = 3.321928094887362347870319429489390175864
        if (isExp) {
            base = 2;
            if (baseOut == 16) sd = sd * 4 - 3;
            else if (baseOut == 8) sd = sd * 3 - 2;
        } else base = baseOut;
        // Convert the number as an integer then divide the result by its base raised to a power such
        // that the fraction part will be restored.
        // Non-integer.
        if (i >= 0) {
            str = str.replace('.', '');
            y = new Ctor(1);
            y.e = str.length - i;
            y.d = $25741881e92d1003$var$convertBase($25741881e92d1003$var$finiteToString(y), 10, base);
            y.e = y.d.length;
        }
        xd = $25741881e92d1003$var$convertBase(str, 10, base);
        e = len = xd.length;
        // Remove trailing zeros.
        for(; xd[--len] == 0;)xd.pop();
        if (!xd[0]) str = isExp ? '0p+0' : '0';
        else {
            if (i < 0) e--;
            else {
                x = new Ctor(x);
                x.d = xd;
                x.e = e;
                x = $25741881e92d1003$var$divide(x, y, sd, rm, 0, base);
                xd = x.d;
                e = x.e;
                roundUp = $25741881e92d1003$var$inexact;
            }
            // The rounding digit, i.e. the digit after the digit that may be rounded up.
            i = xd[sd];
            k = base / 2;
            roundUp = roundUp || xd[sd + 1] !== void 0;
            roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
            xd.length = sd;
            if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
            for(; ++xd[--sd] > base - 1;){
                xd[sd] = 0;
                if (!sd) {
                    ++e;
                    xd.unshift(1);
                }
            }
            // Determine trailing zeros.
            for(len = xd.length; !xd[len - 1]; --len);
            // E.g. [4, 11, 15] becomes 4bf.
            for(i = 0, str = ''; i < len; i++)str += $25741881e92d1003$var$NUMERALS.charAt(xd[i]);
            // Add binary exponent suffix?
            if (isExp) {
                if (len > 1) {
                    if (baseOut == 16 || baseOut == 8) {
                        i = baseOut == 16 ? 4 : 3;
                        for(--len; len % i; len++)str += '0';
                        xd = $25741881e92d1003$var$convertBase(str, base, baseOut);
                        for(len = xd.length; !xd[len - 1]; --len);
                        // xd[0] will always be be 1
                        for(i = 1, str = '1.'; i < len; i++)str += $25741881e92d1003$var$NUMERALS.charAt(xd[i]);
                    } else str = str.charAt(0) + '.' + str.slice(1);
                }
                str = str + (e < 0 ? 'p' : 'p+') + e;
            } else if (e < 0) {
                for(; ++e;)str = '0' + str;
                str = '0.' + str;
            } else {
                if (++e > len) for(e -= len; e--;)str += '0';
                else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
            }
        }
        str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
    }
    return x.s < 0 ? '-' + str : str;
}
// Does not strip trailing zeros.
function $25741881e92d1003$var$truncate(arr, len) {
    if (arr.length > len) {
        arr.length = len;
        return true;
    }
}
// Decimal methods
/*
 *  abs
 *  acos
 *  acosh
 *  add
 *  asin
 *  asinh
 *  atan
 *  atanh
 *  atan2
 *  cbrt
 *  ceil
 *  clamp
 *  clone
 *  config
 *  cos
 *  cosh
 *  div
 *  exp
 *  floor
 *  hypot
 *  ln
 *  log
 *  log2
 *  log10
 *  max
 *  min
 *  mod
 *  mul
 *  pow
 *  random
 *  round
 *  set
 *  sign
 *  sin
 *  sinh
 *  sqrt
 *  sub
 *  sum
 *  tan
 *  tanh
 *  trunc
 */ /*
 * Return a new Decimal whose value is the absolute value of `x`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$abs(x) {
    return new this(x).abs();
}
/*
 * Return a new Decimal whose value is the arccosine in radians of `x`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$acos(x) {
    return new this(x).acos();
}
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$acosh(x) {
    return new this(x).acosh();
}
/*
 * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 * y {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$add(x, y) {
    return new this(x).plus(y);
}
/*
 * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$asin(x) {
    return new this(x).asin();
}
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$asinh(x) {
    return new this(x).asinh();
}
/*
 * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$atan(x) {
    return new this(x).atan();
}
/*
 * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$atanh(x) {
    return new this(x).atanh();
}
/*
 * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
 * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi, pi]
 *
 * y {number|string|bigint|Decimal} The y-coordinate.
 * x {number|string|bigint|Decimal} The x-coordinate.
 *
 * atan2(±0, -0)               = ±pi
 * atan2(±0, +0)               = ±0
 * atan2(±0, -x)               = ±pi for x > 0
 * atan2(±0, x)                = ±0 for x > 0
 * atan2(-y, ±0)               = -pi/2 for y > 0
 * atan2(y, ±0)                = pi/2 for y > 0
 * atan2(±y, -Infinity)        = ±pi for finite y > 0
 * atan2(±y, +Infinity)        = ±0 for finite y > 0
 * atan2(±Infinity, x)         = ±pi/2 for finite x
 * atan2(±Infinity, -Infinity) = ±3*pi/4
 * atan2(±Infinity, +Infinity) = ±pi/4
 * atan2(NaN, x) = NaN
 * atan2(y, NaN) = NaN
 *
 */ function $25741881e92d1003$var$atan2(y, x) {
    y = new this(y);
    x = new this(x);
    var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
    // Either NaN
    if (!y.s || !x.s) r = new this(NaN);
    else if (!y.d && !x.d) {
        r = $25741881e92d1003$var$getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
        r.s = y.s;
    // x is ±Infinity or y is ±0
    } else if (!x.d || y.isZero()) {
        r = x.s < 0 ? $25741881e92d1003$var$getPi(this, pr, rm) : new this(0);
        r.s = y.s;
    // y is ±Infinity or x is ±0
    } else if (!y.d || x.isZero()) {
        r = $25741881e92d1003$var$getPi(this, wpr, 1).times(0.5);
        r.s = y.s;
    // Both non-zero and finite
    } else if (x.s < 0) {
        this.precision = wpr;
        this.rounding = 1;
        r = this.atan($25741881e92d1003$var$divide(y, x, wpr, 1));
        x = $25741881e92d1003$var$getPi(this, wpr, 1);
        this.precision = pr;
        this.rounding = rm;
        r = y.s < 0 ? r.minus(x) : r.plus(x);
    } else r = this.atan($25741881e92d1003$var$divide(y, x, wpr, 1));
    return r;
}
/*
 * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$cbrt(x) {
    return new this(x).cbrt();
}
/*
 * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$ceil(x) {
    return $25741881e92d1003$var$finalise(x = new this(x), x.e + 1, 2);
}
/*
 * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
 *
 * x {number|string|bigint|Decimal}
 * min {number|string|bigint|Decimal}
 * max {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$clamp(x, min, max) {
    return new this(x).clamp(min, max);
}
/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *   maxE       {number}
 *   minE       {number}
 *   modulo     {number}
 *   crypto     {boolean|number}
 *   defaults   {true}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */ function $25741881e92d1003$var$config(obj) {
    if (!obj || typeof obj !== 'object') throw Error($25741881e92d1003$var$decimalError + 'Object expected');
    var i, p, v, useDefaults = obj.defaults === true, ps = [
        'precision',
        1,
        $25741881e92d1003$var$MAX_DIGITS,
        'rounding',
        0,
        8,
        'toExpNeg',
        -$25741881e92d1003$var$EXP_LIMIT,
        0,
        'toExpPos',
        0,
        $25741881e92d1003$var$EXP_LIMIT,
        'maxE',
        0,
        $25741881e92d1003$var$EXP_LIMIT,
        'minE',
        -$25741881e92d1003$var$EXP_LIMIT,
        0,
        'modulo',
        0,
        9
    ];
    for(i = 0; i < ps.length; i += 3){
        if (p = ps[i], useDefaults) this[p] = $25741881e92d1003$var$DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if ($25741881e92d1003$var$mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error($25741881e92d1003$var$invalidArgument + p + ': ' + v);
        }
    }
    if (p = 'crypto', useDefaults) this[p] = $25741881e92d1003$var$DEFAULTS[p];
    if ((v = obj[p]) !== void 0) {
        if (v === true || v === false || v === 0 || v === 1) {
            if (v) {
                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                else throw Error($25741881e92d1003$var$cryptoUnavailable);
            } else this[p] = false;
        } else throw Error($25741881e92d1003$var$invalidArgument + p + ': ' + v);
    }
    return this;
}
/*
 * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$cos(x) {
    return new this(x).cos();
}
/*
 * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$cosh(x) {
    return new this(x).cosh();
}
/*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */ function $25741881e92d1003$var$clone(obj) {
    var i, p, ps;
    /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * v {number|string|bigint|Decimal} A numeric value.
   *
   */ function Decimal(v) {
        var e, i, t, x = this;
        // Decimal called without new.
        if (!(x instanceof Decimal)) return new Decimal(v);
        // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
        // which points to Object.
        x.constructor = Decimal;
        if ($25741881e92d1003$var$isDecimalInstance(v)) {
            x.s = v.s;
            if ($25741881e92d1003$var$external) {
                if (!v.d || v.e > Decimal.maxE) {
                    // Infinity.
                    x.e = NaN;
                    x.d = null;
                } else if (v.e < Decimal.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                } else {
                    x.e = v.e;
                    x.d = v.d.slice();
                }
            } else {
                x.e = v.e;
                x.d = v.d ? v.d.slice() : v.d;
            }
            return;
        }
        t = typeof v;
        if (t === 'number') {
            if (v === 0) {
                x.s = 1 / v < 0 ? -1 : 1;
                x.e = 0;
                x.d = [
                    0
                ];
                return;
            }
            if (v < 0) {
                v = -v;
                x.s = -1;
            } else x.s = 1;
            // Fast path for small integers.
            if (v === ~~v && v < 1e7) {
                for(e = 0, i = v; i >= 10; i /= 10)e++;
                if ($25741881e92d1003$var$external) {
                    if (e > Decimal.maxE) {
                        x.e = NaN;
                        x.d = null;
                    } else if (e < Decimal.minE) {
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                } else {
                    x.e = e;
                    x.d = [
                        v
                    ];
                }
                return;
            }
            // Infinity or NaN?
            if (v * 0 !== 0) {
                if (!v) x.s = NaN;
                x.e = NaN;
                x.d = null;
                return;
            }
            return $25741881e92d1003$var$parseDecimal(x, v.toString());
        }
        if (t === 'string') {
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                if (i === 43) v = v.slice(1); // plus sign
                x.s = 1;
            }
            return $25741881e92d1003$var$isDecimal.test(v) ? $25741881e92d1003$var$parseDecimal(x, v) : $25741881e92d1003$var$parseOther(x, v);
        }
        if (t === 'bigint') {
            if (v < 0) {
                v = -v;
                x.s = -1;
            } else x.s = 1;
            return $25741881e92d1003$var$parseDecimal(x, v.toString());
        }
        throw Error($25741881e92d1003$var$invalidArgument + v);
    }
    Decimal.prototype = $25741881e92d1003$var$P;
    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;
    Decimal.EUCLID = 9;
    Decimal.config = Decimal.set = $25741881e92d1003$var$config;
    Decimal.clone = $25741881e92d1003$var$clone;
    Decimal.isDecimal = $25741881e92d1003$var$isDecimalInstance;
    Decimal.abs = $25741881e92d1003$var$abs;
    Decimal.acos = $25741881e92d1003$var$acos;
    Decimal.acosh = $25741881e92d1003$var$acosh; // ES6
    Decimal.add = $25741881e92d1003$var$add;
    Decimal.asin = $25741881e92d1003$var$asin;
    Decimal.asinh = $25741881e92d1003$var$asinh; // ES6
    Decimal.atan = $25741881e92d1003$var$atan;
    Decimal.atanh = $25741881e92d1003$var$atanh; // ES6
    Decimal.atan2 = $25741881e92d1003$var$atan2;
    Decimal.cbrt = $25741881e92d1003$var$cbrt; // ES6
    Decimal.ceil = $25741881e92d1003$var$ceil;
    Decimal.clamp = $25741881e92d1003$var$clamp;
    Decimal.cos = $25741881e92d1003$var$cos;
    Decimal.cosh = $25741881e92d1003$var$cosh; // ES6
    Decimal.div = $25741881e92d1003$var$div;
    Decimal.exp = $25741881e92d1003$var$exp;
    Decimal.floor = $25741881e92d1003$var$floor;
    Decimal.hypot = $25741881e92d1003$var$hypot; // ES6
    Decimal.ln = $25741881e92d1003$var$ln;
    Decimal.log = $25741881e92d1003$var$log;
    Decimal.log10 = $25741881e92d1003$var$log10; // ES6
    Decimal.log2 = $25741881e92d1003$var$log2; // ES6
    Decimal.max = $25741881e92d1003$var$max;
    Decimal.min = $25741881e92d1003$var$min;
    Decimal.mod = $25741881e92d1003$var$mod;
    Decimal.mul = $25741881e92d1003$var$mul;
    Decimal.pow = $25741881e92d1003$var$pow;
    Decimal.random = $25741881e92d1003$var$random;
    Decimal.round = $25741881e92d1003$var$round;
    Decimal.sign = $25741881e92d1003$var$sign; // ES6
    Decimal.sin = $25741881e92d1003$var$sin;
    Decimal.sinh = $25741881e92d1003$var$sinh; // ES6
    Decimal.sqrt = $25741881e92d1003$var$sqrt;
    Decimal.sub = $25741881e92d1003$var$sub;
    Decimal.sum = $25741881e92d1003$var$sum;
    Decimal.tan = $25741881e92d1003$var$tan;
    Decimal.tanh = $25741881e92d1003$var$tanh; // ES6
    Decimal.trunc = $25741881e92d1003$var$trunc; // ES6
    if (obj === void 0) obj = {};
    if (obj) {
        if (obj.defaults !== true) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'maxE',
                'minE',
                'modulo',
                'crypto'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
    }
    Decimal.config(obj);
    return Decimal;
}
/*
 * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 * y {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$div(x, y) {
    return new this(x).div(y);
}
/*
 * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} The power to which to raise the base of the natural log.
 *
 */ function $25741881e92d1003$var$exp(x) {
    return new this(x).exp();
}
/*
 * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$floor(x) {
    return $25741881e92d1003$var$finalise(x = new this(x), x.e + 1, 3);
}
/*
 * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
 * rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
 *
 * arguments {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$hypot() {
    var i, n, t = new this(0);
    $25741881e92d1003$var$external = false;
    for(i = 0; i < arguments.length;){
        n = new this(arguments[i++]);
        if (!n.d) {
            if (n.s) {
                $25741881e92d1003$var$external = true;
                return new this(1 / 0);
            }
            t = n;
        } else if (t.d) t = t.plus(n.times(n));
    }
    $25741881e92d1003$var$external = true;
    return t.sqrt();
}
/*
 * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
 * otherwise return false.
 *
 */ function $25741881e92d1003$var$isDecimalInstance(obj) {
    return obj instanceof $25741881e92d1003$export$95c991896bef8714 || obj && obj.toStringTag === $25741881e92d1003$var$tag || false;
}
/*
 * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$ln(x) {
    return new this(x).ln();
}
/*
 * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
 * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * log[y](x)
 *
 * x {number|string|bigint|Decimal} The argument of the logarithm.
 * y {number|string|bigint|Decimal} The base of the logarithm.
 *
 */ function $25741881e92d1003$var$log(x, y) {
    return new this(x).log(y);
}
/*
 * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$log2(x) {
    return new this(x).log(2);
}
/*
 * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$log10(x) {
    return new this(x).log(10);
}
/*
 * Return a new Decimal whose value is the maximum of the arguments.
 *
 * arguments {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$max() {
    return $25741881e92d1003$var$maxOrMin(this, arguments, -1);
}
/*
 * Return a new Decimal whose value is the minimum of the arguments.
 *
 * arguments {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$min() {
    return $25741881e92d1003$var$maxOrMin(this, arguments, 1);
}
/*
 * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 * y {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$mod(x, y) {
    return new this(x).mod(y);
}
/*
 * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 * y {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$mul(x, y) {
    return new this(x).mul(y);
}
/*
 * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} The base.
 * y {number|string|bigint|Decimal} The exponent.
 *
 */ function $25741881e92d1003$var$pow(x, y) {
    return new this(x).pow(y);
}
/*
 * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
 * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
 * are produced).
 *
 * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
 *
 */ function $25741881e92d1003$var$random(sd) {
    var d, e, k, n, i = 0, r = new this(1), rd = [];
    if (sd === void 0) sd = this.precision;
    else $25741881e92d1003$var$checkInt32(sd, 1, $25741881e92d1003$var$MAX_DIGITS);
    k = Math.ceil(sd / $25741881e92d1003$var$LOG_BASE);
    if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
    else if (crypto.getRandomValues) {
        d = crypto.getRandomValues(new Uint32Array(k));
        for(; i < k;){
            n = d[i];
            // 0 <= n < 4294967296
            // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
            if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
            else // 0 <= n <= 4289999999
            // 0 <= (n % 1e7) <= 9999999
            rd[i++] = n % 1e7;
        }
    // Node.js supporting crypto.randomBytes.
    } else if (crypto.randomBytes) {
        // buffer
        d = crypto.randomBytes(k *= 4);
        for(; i < k;){
            // 0 <= n < 2147483648
            n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
            // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
            if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
            else {
                // 0 <= n <= 2139999999
                // 0 <= (n % 1e7) <= 9999999
                rd.push(n % 1e7);
                i += 4;
            }
        }
        i = k / 4;
    } else throw Error($25741881e92d1003$var$cryptoUnavailable);
    k = rd[--i];
    sd %= $25741881e92d1003$var$LOG_BASE;
    // Convert trailing digits to zeros according to sd.
    if (k && sd) {
        n = $25741881e92d1003$var$mathpow(10, $25741881e92d1003$var$LOG_BASE - sd);
        rd[i] = (k / n | 0) * n;
    }
    // Remove trailing words which are zero.
    for(; rd[i] === 0; i--)rd.pop();
    // Zero?
    if (i < 0) {
        e = 0;
        rd = [
            0
        ];
    } else {
        e = -1;
        // Remove leading words which are zero and adjust exponent accordingly.
        for(; rd[0] === 0; e -= $25741881e92d1003$var$LOG_BASE)rd.shift();
        // Count the digits of the first word of rd to determine leading zeros.
        for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
        // Adjust the exponent for leading zeros of the first word of rd.
        if (k < $25741881e92d1003$var$LOG_BASE) e -= $25741881e92d1003$var$LOG_BASE - k;
    }
    r.e = e;
    r.d = rd;
    return r;
}
/*
 * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
 *
 * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$round(x) {
    return $25741881e92d1003$var$finalise(x = new this(x), x.e + 1, this.rounding);
}
/*
 * Return
 *   1    if x > 0,
 *  -1    if x < 0,
 *   0    if x is 0,
 *  -0    if x is -0,
 *   NaN  otherwise
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$sign(x) {
    x = new this(x);
    return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
}
/*
 * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$sin(x) {
    return new this(x).sin();
}
/*
 * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$sinh(x) {
    return new this(x).sinh();
}
/*
 * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$sqrt(x) {
    return new this(x).sqrt();
}
/*
 * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal}
 * y {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$sub(x, y) {
    return new this(x).sub(y);
}
/*
 * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * Only the result is rounded, not the intermediate calculations.
 *
 * arguments {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$sum() {
    var i = 0, args = arguments, x = new this(args[i]);
    $25741881e92d1003$var$external = false;
    for(; x.s && ++i < args.length;)x = x.plus(args[i]);
    $25741881e92d1003$var$external = true;
    return $25741881e92d1003$var$finalise(x, this.precision, this.rounding);
}
/*
 * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$tan(x) {
    return new this(x).tan();
}
/*
 * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|bigint|Decimal} A value in radians.
 *
 */ function $25741881e92d1003$var$tanh(x) {
    return new this(x).tanh();
}
/*
 * Return a new Decimal whose value is `x` truncated to an integer.
 *
 * x {number|string|bigint|Decimal}
 *
 */ function $25741881e92d1003$var$trunc(x) {
    return $25741881e92d1003$var$finalise(x = new this(x), x.e + 1, 1);
}
$25741881e92d1003$var$P[Symbol.for('nodejs.util.inspect.custom')] = $25741881e92d1003$var$P.toString;
$25741881e92d1003$var$P[Symbol.toStringTag] = 'Decimal';
var $25741881e92d1003$export$95c991896bef8714 = $25741881e92d1003$var$P.constructor = $25741881e92d1003$var$clone($25741881e92d1003$var$DEFAULTS);
// Create the internal constants from their string values.
$25741881e92d1003$var$LN10 = new $25741881e92d1003$export$95c991896bef8714($25741881e92d1003$var$LN10);
$25741881e92d1003$var$PI = new $25741881e92d1003$export$95c991896bef8714($25741881e92d1003$var$PI);
var $25741881e92d1003$export$2e2bcd8739ae039 = $25741881e92d1003$export$95c991896bef8714;

});


parcelRegister("dtmIH", function(module, exports) {
$parcel$export(module.exports, "PreviewNumberInput", () => $e593bde211dd2e97$export$e96c5cc6e78634b4);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $e593bde211dd2e97$export$e96c5cc6e78634b4 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formNumberField$valu;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formNumberField = (0, $kVXLM.asFormNumberField)(formField);
    if (formNumberField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-number-preview-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: (_formNumberField$valu = formNumberField.value) === null || _formNumberField$valu === void 0 ? void 0 : _formNumberField$valu.number,
        isDisabled: true,
        width: "small"
    }));
};

});

parcelRegister("l6Rd4", function(module, exports) {
$parcel$export(module.exports, "ViewNumberInput", () => $2df525a34ec6f8d9$export$1b2f97ba186e1685);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $2df525a34ec6f8d9$export$1b2f97ba186e1685 = ({ fieldId: fieldId })=>{
    var _formNumberField$valu;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formNumberField = (0, $kVXLM.asFormNumberField)(formField);
    if (formNumberField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-number-view-${fieldId}`
    }, (_formNumberField$valu = formNumberField.value) === null || _formNumberField$valu === void 0 ? void 0 : _formNumberField$valu.number);
};

});


parcelRegister("dRVn5", function(module, exports) {
$parcel$export(module.exports, "PlainTextParagraphInput", () => $7a0b0fddee086b09$export$1fbcd74e64fab470);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $1ZRKT = parcelRequire("1ZRKT");

var $6rYew = parcelRequire("6rYew");

var $j5DeW = parcelRequire("j5DeW");
const $7a0b0fddee086b09$export$1fbcd74e64fab470 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1ZRKT.EditParagraphPlainInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6rYew.PreviewParagraphPlainInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j5DeW.ViewParagraphPlainInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("1ZRKT", function(module, exports) {
$parcel$export(module.exports, "EditParagraphPlainInput", () => $fbabc7b3fdd0d473$export$9dfb54dd96f44fa2);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $5R01U = parcelRequire("5R01U");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $fbabc7b3fdd0d473$export$9dfb54dd96f44fa2 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asTextValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [textAreaValue, setTextAreaValue] = (0, $bSJIT.useState)(currentValue);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    (0, $bSJIT.useEffect)(()=>{
        setTextAreaValue(currentValue);
    }, [
        currentValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        setTextAreaValue({
            text: event.target.value
        });
        if (event.target.value.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else debouncedUpdateModifiedValue(fieldId, {
            text: event.target.value
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        appearance: "standard",
        isCompact: false,
        isDisabled: false,
        isReadOnly: false,
        id: fieldInputId,
        value: ((_asTextValue = (0, $i86qj.asTextValue)(textAreaValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text) ?? '',
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        placeholder: "",
        testId: `field-input-paragraph-plain-edit-${fieldId}`,
        minimumRows: 5,
        maxHeight: "none",
        isMonospaced: false,
        defaultValue: undefined,
        resize: "smart",
        spellCheck: false,
        onBlur: undefined,
        onFocus: undefined,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});

parcelRegister("6rYew", function(module, exports) {
$parcel$export(module.exports, "PreviewParagraphPlainInput", () => $528cf2d15cec8271$export$71e8940071126d48);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $5R01U = parcelRequire("5R01U");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $528cf2d15cec8271$export$71e8940071126d48 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formTextAreaField$va;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextAreaField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextAreaField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-paragraph-plain-preview-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        id: fieldInputId,
        value: (_formTextAreaField$va = formTextAreaField.value) === null || _formTextAreaField$va === void 0 ? void 0 : _formTextAreaField$va.text,
        isDisabled: true,
        minimumRows: 5
    }));
};

});

parcelRegister("j5DeW", function(module, exports) {
$parcel$export(module.exports, "ViewParagraphPlainInput", () => $156f49097f250475$export$d5a7064eebb0f9c4);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $156f49097f250475$export$d5a7064eebb0f9c4 = ({ fieldId: fieldId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-paragraph-plain-view-${fieldId}`
    }, (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text);
};

});


parcelRegister("cEvwV", function(module, exports) {
$parcel$export(module.exports, "RichTextParagraphInput", () => $7578e133e037fa58$export$acb4ef4e344a8de7);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $2M5rB = parcelRequire("2M5rB");

var $Rino3 = parcelRequire("Rino3");

var $lmPpd = parcelRequire("lmPpd");
const $7578e133e037fa58$export$acb4ef4e344a8de7 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2M5rB.AsyncEditParagraphRichTextInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $Rino3.PreviewParagraphRichTextInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lmPpd.ViewParagraphRichTextInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("2M5rB", function(module, exports) {
$parcel$export(module.exports, "AsyncEditParagraphRichTextInput", () => $5496a6b40ccd6464$export$4c276a0a8024474e);

var $bSJIT = parcelRequire("bSJIT");

var $cJJTb = parcelRequire("cJJTb");

const $5496a6b40ccd6464$var$LazyEditParagraphRichTextInput = (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("fR2kX")).then(({ EditParagraphRichTextInput: EditParagraphRichTextInput })=>EditParagraphRichTextInput), {
    ssr: false,
    moduleId: "../platform/packages/proforma/proforma-form-renderer/src/ui/form-renderer/form-sections/form-section/form-extension-renderer/form-field-renderer/paragraph-rich-text-input/edit/main.tsx"
});
const $5496a6b40ccd6464$export$4c276a0a8024474e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJJTb.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5496a6b40ccd6464$var$LazyEditParagraphRichTextInput, props));

});
parcelRegister("fR2kX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cW2Rw"),
    $kOunM("9Vb2H"),
    $kOunM("3BiwA"),
    $kOunM("6SRf2"),
    $kOunM("aCwaQ"),
    $kOunM("9lXEZ"),
    $kOunM("7lXW2"),
    $kOunM("cMrE6"),
    $kOunM("fAmYW"),
    $kOunM("1XLvm"),
    $kOunM("2B8pU"),
    $kOunM("ei5T3"),
    $kOunM("iCKHI"),
    $kOunM("e4VfO"),
    $kOunM("8wGm7"),
    $kOunM("lggSm"),
    $kOunM("g0v4k"),
    $kOunM("kmhkU"),
    $kOunM("7zmdH"),
    $kOunM("d3aBl"),
    $kOunM("eTibs"),
    $kOunM("hxYvx"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("5RatS")
]).then(()=>parcelRequire('h671c'));

});


parcelRegister("Rino3", function(module, exports) {
$parcel$export(module.exports, "PreviewParagraphRichTextInput", () => $71283706658670a9$export$71e0eb349b2cdfba);

var $bSJIT = parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $7uUp4 = parcelRequire("7uUp4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $71283706658670a9$var$boxStyles = (0, $9BVpB.xcss)({
    borderStyle: 'solid',
    borderColor: 'color.border.disabled',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    backgroundColor: 'color.background.disabled',
    padding: 'space.075',
    minHeight: '100px'
});
const $71283706658670a9$export$71e0eb349b2cdfba = ({ fieldId: fieldId })=>{
    var _formAdfField$value, _formAdfField$value2;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formAdfField = (0, $kVXLM.asFormAdfField)(formField);
    if (formAdfField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $71283706658670a9$var$boxStyles,
        testId: `field-input-paragraph-rich-text-preview-${fieldId}`
    }, ((_formAdfField$value = formAdfField.value) === null || _formAdfField$value === void 0 ? void 0 : _formAdfField$value.adf) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.default), {
        document: (_formAdfField$value2 = formAdfField.value) === null || _formAdfField$value2 === void 0 ? void 0 : _formAdfField$value2.adf
    }));
};

});

parcelRegister("lmPpd", function(module, exports) {
$parcel$export(module.exports, "ViewParagraphRichTextInput", () => $a507c2d17f6836f2$export$974d3b4b21adf26);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $7uUp4 = parcelRequire("7uUp4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $a507c2d17f6836f2$export$974d3b4b21adf26 = ({ fieldId: fieldId })=>{
    var _formAdfField$value, _formAdfField$value2;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formAdfField = (0, $kVXLM.asFormAdfField)(formField);
    if (formAdfField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-paragraph-rich-text-view-${fieldId}`
    }, ((_formAdfField$value = formAdfField.value) === null || _formAdfField$value === void 0 ? void 0 : _formAdfField$value.adf) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.default), {
        document: (_formAdfField$value2 = formAdfField.value) === null || _formAdfField$value2 === void 0 ? void 0 : _formAdfField$value2.adf
    }));
};

});


parcelRegister("6qOtx", function(module, exports) {
$parcel$export(module.exports, "RadioInput", () => $b3698b901e64cb58$export$83a1b8e4fcf0dd8e);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $fBZID = parcelRequire("fBZID");

var $bjcfJ = parcelRequire("bjcfJ");

var $1mCC1 = parcelRequire("1mCC1");
const $b3698b901e64cb58$export$83a1b8e4fcf0dd8e = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fBZID.EditRadioInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bjcfJ.PreviewRadioInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1mCC1.ViewRadioInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("fBZID", function(module, exports) {
$parcel$export(module.exports, "EditRadioInput", () => $4b541c3a4e02f0ca$export$3602f457e2a670f2);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $8nDF2 = parcelRequire("8nDF2");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $7qHwj = parcelRequire("7qHwj");
const $4b541c3a4e02f0ca$var$placeholderStyles = (0, $9BVpB.xcss)({
    margin: 'space.500'
});
const $4b541c3a4e02f0ca$var$optionStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.050'
});
const $4b541c3a4e02f0ca$export$3602f457e2a670f2 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const intl = (0, $4vLTk.default)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const [otherTextInputValue, setOtherTextInputValue] = (0, $bSJIT.useState)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    (0, $bSJIT.useEffect)(()=>{
        setOtherTextInputValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        setOtherTextInputValue
    ]);
    const onChange = (0, $bSJIT.useCallback)((event)=>{
        const selectedOptionId = event.target.value;
        if (selectedOptionId.length === 0 || (formOptionField === null || formOptionField === void 0 ? void 0 : formOptionField.options) === undefined) updateModifiedValue(fieldId, null);
        else if (selectedOptionId === (0, $gjxgd.OTHER_ID)) updateModifiedValue(fieldId, {
            otherOptionText: '',
            options: []
        });
        else updateModifiedValue(fieldId, {
            options: formOptionField.options.filter((option)=>option.id === selectedOptionId)
        });
    }, [
        fieldId,
        formOptionField === null || formOptionField === void 0 ? void 0 : formOptionField.options,
        updateModifiedValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const onOtherOptionTextChange = (0, $bSJIT.useCallback)((event)=>{
        setOtherTextInputValue(event.target.value);
        debouncedUpdateModifiedValue(fieldId, {
            otherOptionText: event.target.value,
            options: []
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId,
        setOtherTextInputValue
    ]);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const otherOption = {
        id: (0, $gjxgd.OTHER_ID),
        label: intl.formatMessage((0, $7qHwj.messages).otherOption)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "field-input-radio-edit"
    }, formOptionField.hasOtherOption || formOptionField.options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8nDF2.default), {
        id: fieldInputId,
        key: fieldInputId,
        name: fieldInputId,
        labelId: fieldLabelId,
        options: formOptionField.hasOtherOption ? (0, $kVXLM.toRadioOptions)([
            ...formOptionField.options,
            otherOption
        ]) : (0, $kVXLM.toRadioOptions)(formOptionField.options),
        value: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) !== undefined ? (0, $gjxgd.OTHER_ID) : currentValue !== null && currentValue !== void 0 && currentValue.options.length ? currentValue === null || currentValue === void 0 ? void 0 : currentValue.options[0].id : null,
        onChange: onChange,
        testId: `field-input-radio-edit-${fieldId}`,
        isRequired: isRequired,
        isInvalid: isInvalid,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }), otherTextInputValue !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $4b541c3a4e02f0ca$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        appearance: "standard",
        placeholder: intl.formatMessage((0, $7qHwj.messages).otherOption),
        minimumRows: 2,
        isMonospaced: false,
        value: otherTextInputValue,
        resize: "smart",
        spellCheck: false,
        onChange: onOtherOptionTextChange,
        testId: `field-input-radio-edit-other-${fieldId}`,
        "aria-label": intl.formatMessage((0, $7qHwj.messages).otherOptionTextLabel, {
            label: formField.label
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $4b541c3a4e02f0ca$var$placeholderStyles
    }));
};

});
parcelRegister("7qHwj", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9164d84e6455bcd8$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $9164d84e6455bcd8$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.edit.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.edit.other-option-text-label',
        description: 'Label for the radio choice field other text box in edit mode, for accessibility',
        defaultMessage: '{label} radio choice field other option text area'
    }
});

});


parcelRegister("bjcfJ", function(module, exports) {
$parcel$export(module.exports, "PreviewRadioInput", () => $8c2176654dd98d16$export$81f2800c1dfef5ae);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $8nDF2 = parcelRequire("8nDF2");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $3CmeT = parcelRequire("3CmeT");
const $8c2176654dd98d16$var$placeholderStyles = (0, $9BVpB.xcss)({
    margin: 'space.500'
});
const $8c2176654dd98d16$var$radioStyles = (0, $9BVpB.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $8c2176654dd98d16$export$81f2800c1dfef5ae = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId })=>{
    var _formOptionField$valu, _formOptionField$valu2, _formOptionField$valu3;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "field-input-radio-preview"
    }, formOptionField.hasOtherOption || formOptionField.options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $8c2176654dd98d16$var$radioStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8nDF2.default), {
        id: fieldInputId,
        key: fieldInputId,
        name: fieldInputId,
        labelId: fieldLabelId,
        options: formOptionField.hasOtherOption ? (0, $kVXLM.toRadioOptions)([
            ...formOptionField.options,
            {
                id: (0, $gjxgd.OTHER_ID),
                label: intl.formatMessage((0, $3CmeT.messages).otherOption)
            }
        ]) : (0, $kVXLM.toRadioOptions)(formOptionField.options),
        value: (_formOptionField$valu = formOptionField.value) !== null && _formOptionField$valu !== void 0 && _formOptionField$valu.otherOptionText ? (0, $gjxgd.OTHER_ID) : ((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 || (_formOptionField$valu2 = _formOptionField$valu2.options[0]) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.id) ?? null,
        isDisabled: true,
        testId: `field-input-radio-preview-${fieldId}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $8c2176654dd98d16$var$placeholderStyles
    }), ((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $3CmeT.messages).otherOptionTextLabel, {
            label: formField.label
        })
    }));
};

});
parcelRegister("3CmeT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b5f298e19c0ca6dd$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $b5f298e19c0ca6dd$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.preview.other-option',
        description: 'The label for the Other option in the radio choice field',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.preview.other-option-text-label',
        description: 'Label for the radio choice field other text box in preview mode, for accessibility',
        defaultMessage: '{label} radio choice field other option text area preview'
    }
});

});


parcelRegister("1mCC1", function(module, exports) {
$parcel$export(module.exports, "ViewRadioInput", () => $8067ced3a5b15c01$export$acb2e0e743f49795);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9PwDt = parcelRequire("9PwDt");

var $8nDF2 = parcelRequire("8nDF2");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $XlR3I = parcelRequire("XlR3I");
const $8067ced3a5b15c01$export$acb2e0e743f49795 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId })=>{
    var _formOptionField$valu, _formOptionField$valu2, _formOptionField$valu3;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const options = formOptionField.hasOtherOption ? (0, $kVXLM.toRadioOptions)([
        ...formOptionField.options,
        {
            id: (0, $gjxgd.OTHER_ID),
            label: intl.formatMessage((0, $XlR3I.messages).otherOption)
        }
    ]) : (0, $kVXLM.toRadioOptions)(formOptionField.options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-radio-view"
    }, formOptionField.hasOtherOption || formOptionField.options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8nDF2.default), {
        id: fieldInputId,
        key: fieldInputId,
        name: fieldInputId,
        labelId: fieldLabelId,
        options: options.map((option)=>({
                ...option,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
                    xcss: $8067ced3a5b15c01$var$styles.radioLabel
                }, option.label)
            })),
        value: (_formOptionField$valu = formOptionField.value) !== null && _formOptionField$valu !== void 0 && _formOptionField$valu.otherOptionText ? (0, $gjxgd.OTHER_ID) : ((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 || (_formOptionField$valu2 = _formOptionField$valu2.options[0]) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.id) ?? null,
        isDisabled: true,
        testId: `field-input-radio-view-${fieldId}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $8067ced3a5b15c01$var$styles.placeholderStyles
    }), ((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $XlR3I.messages).otherOptionTextLabel, {
            label: formField.label
        })
    }));
};
const $8067ced3a5b15c01$var$styles = {
    radioStyles: "_syazi7uo",
    placeholderStyles: "_19pk1jfw _2hwx1jfw _otyr1jfw _18u01jfw",
    radioLabel: "_syazi7uo"
};

});
parcelRegister("XlR3I", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f69df23a9be220dd$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f69df23a9be220dd$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.view.other-option',
        description: 'The label for the Other option in the radio choice field',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.radio-input.view.other-option-text-label',
        description: 'Label for the radio choice field other text box in view mode, for accessibility',
        defaultMessage: '{label} radio choice field other option text area view'
    }
});

});



parcelRegister("a2eVO", function(module, exports) {
$parcel$export(module.exports, "RatingInput", () => $2660bfa19833e059$export$b3046cc716629a68);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $apyID = parcelRequire("apyID");

var $iGA3x = parcelRequire("iGA3x");

var $5njvs = parcelRequire("5njvs");
const $2660bfa19833e059$export$b3046cc716629a68 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (!(0, $gdUUy.fg)('phx-3346_proforma_rating_question_type')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $apyID.EditRatingInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iGA3x.PreviewRatingInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5njvs.ViewRatingInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("apyID", function(module, exports) {
$parcel$export(module.exports, "EditRatingInput", () => $55b0723e27191ea1$export$e13db5aecc16d23a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4TRbS = parcelRequire("4TRbS");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $6B621 = parcelRequire("6B621");

var $9Abbn = parcelRequire("9Abbn");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $9WR8X = parcelRequire("9WR8X");

var $7ZEcd = parcelRequire("7ZEcd");

var $5JwFL = parcelRequire("5JwFL");
const $55b0723e27191ea1$var$styles = {
    container: "_ca0qu2gc _n3tdu2gc"
};
const $55b0723e27191ea1$export$e13db5aecc16d23a = ({ fieldId: fieldId, fieldErrorId: fieldErrorId })=>{
    var _currentValue$number;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $i86qj.asNumberValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const [hoveredOptionId, setHoveredOptionId] = (0, $bSJIT.useState)(null);
    const selectedOptionId = (currentValue === null || currentValue === void 0 || (_currentValue$number = currentValue.number) === null || _currentValue$number === void 0 ? void 0 : _currentValue$number.toString()) ?? null;
    const ratingIcon = (0, $7ZEcd.getRatingIconFromOptions)(formRankingField === null || formRankingField === void 0 ? void 0 : formRankingField.options);
    const UnselectedIcon = (0, $7ZEcd.getRatingIconComponent)(ratingIcon);
    const SelectedIcon = (0, $7ZEcd.getSelectedRatingIconComponent)(ratingIcon);
    const selectedNumericId = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.number) ?? null;
    const hoveredNumericId = hoveredOptionId !== null ? Number(hoveredOptionId) : null;
    const onSelect = (0, $bSJIT.useCallback)((optionId)=>{
        if (!formRankingField) return;
        if (optionId === selectedOptionId) updateModifiedValue(fieldId, null);
        else {
            const selected = formRankingField.options.find((o)=>o.id === optionId);
            if (selected) updateModifiedValue(fieldId, {
                number: Number(optionId)
            });
        }
    }, [
        fieldId,
        formRankingField,
        selectedOptionId,
        updateModifiedValue
    ]);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const isRatingScaleA11yFixesEnabled = (0, $gdUUy.fg)('proforma_rating_scale_a11y_fixes');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $55b0723e27191ea1$var$styles.container,
        testId: "field-input-rating-edit",
        onMouseLeave: ()=>setHoveredOptionId(null),
        "aria-invalid": isInvalid,
        "aria-describedby": isInvalid ? fieldErrorId : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.400",
        role: isRatingScaleA11yFixesEnabled ? 'radiogroup' : undefined,
        "aria-label": isRatingScaleA11yFixesEnabled ? formRankingField.label : undefined
    }, formRankingField.options.map((option)=>{
        const numericId = Number(option.id);
        const isFilledBySelection = selectedNumericId !== null && !Number.isNaN(numericId) && numericId <= selectedNumericId;
        const isFilledByHover = hoveredNumericId !== null && !Number.isNaN(numericId) && numericId <= hoveredNumericId;
        const isFilled = hoveredOptionId !== null ? isFilledByHover : isFilledBySelection;
        const IconComponent = isFilled ? SelectedIcon : UnselectedIcon;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
            key: option.id,
            alignInline: "center",
            space: "space.100",
            testId: `field-input-rating-edit-option-${option.id}-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: option.id === selectedOptionId,
            onChange: ()=>onSelect(option.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
            appearance: "subtle",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(IconComponent, {
                    ...iconProps,
                    color: isFilled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
                }),
            label: option.id,
            onClick: ()=>onSelect(option.id),
            onMouseEnter: ()=>setHoveredOptionId(option.id),
            testId: `field-input-rating-edit-option-button-${option.id}-${fieldId}`,
            "aria-hidden": true,
            tabIndex: -1
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            align: "center"
        }, option.id));
    }))));
};

});
parcelRegister("9WR8X", function(module, exports) {
$parcel$export(module.exports, "ScrollContainer", () => $49de4eaf0eb4084f$export$2631a3ab3cdd158d);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $49de4eaf0eb4084f$var$styles = {
    scrollContainer: "_1reo1wug _1itkq9kz _ouxl15ax _12vemgnk _1lrw75fu _qmxjqpfq"
};
const $49de4eaf0eb4084f$export$2631a3ab3cdd158d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $49de4eaf0eb4084f$var$styles.scrollContainer
    }, children);

});

parcelRegister("7ZEcd", function(module, exports) {
$parcel$export(module.exports, "getRatingIconFromOptions", () => $de437961154a3668$export$e4d5d6992893dde9);
$parcel$export(module.exports, "getRatingIconComponent", () => $de437961154a3668$export$ce33107748e54a91);
$parcel$export(module.exports, "getSelectedRatingIconComponent", () => $de437961154a3668$export$e998484fac55db60);

var $1qHVa = parcelRequire("1qHVa");

var $2moME = parcelRequire("2moME");
const $de437961154a3668$export$a097a9f0e92c2054 = [
    'star'
];
const $de437961154a3668$var$isValidRatingIcon = (value)=>$de437961154a3668$export$a097a9f0e92c2054.includes(value);
const $de437961154a3668$export$e4d5d6992893dde9 = (options)=>{
    var _options$;
    const firstLabel = (options === null || options === void 0 || (_options$ = options[0]) === null || _options$ === void 0 || (_options$ = _options$.label) === null || _options$ === void 0 ? void 0 : _options$.toLowerCase()) ?? '';
    return $de437961154a3668$var$isValidRatingIcon(firstLabel) ? firstLabel : 'star';
};
const $de437961154a3668$var$unselectedIconMapping = {
    star: (0, (/*@__PURE__*/$parcel$interopDefault($2moME)))
};
const $de437961154a3668$var$selectedIconMapping = {
    star: (0, (/*@__PURE__*/$parcel$interopDefault($1qHVa)))
};
const $de437961154a3668$export$ce33107748e54a91 = (ratingIcon)=>$de437961154a3668$var$unselectedIconMapping[ratingIcon] ?? (0, (/*@__PURE__*/$parcel$interopDefault($2moME)));
const $de437961154a3668$export$e998484fac55db60 = (ratingIcon)=>$de437961154a3668$var$selectedIconMapping[ratingIcon] ?? (0, (/*@__PURE__*/$parcel$interopDefault($1qHVa)));

});


parcelRegister("iGA3x", function(module, exports) {
$parcel$export(module.exports, "PreviewRatingInput", () => $a6298304bdc5cdd7$export$303dcb656480007a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4TRbS = parcelRequire("4TRbS");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $6B621 = parcelRequire("6B621");

var $9Abbn = parcelRequire("9Abbn");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $9WR8X = parcelRequire("9WR8X");

var $7ZEcd = parcelRequire("7ZEcd");

var $5JwFL = parcelRequire("5JwFL");
const $a6298304bdc5cdd7$var$styles = {
    container: "_ca0qu2gc _n3tdu2gc"
};
const $a6298304bdc5cdd7$export$303dcb656480007a = ({ fieldId: fieldId })=>{
    var _currentValue$number;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const isRatingScaleA11yFixesEnabled = (0, $gdUUy.fg)('proforma_rating_scale_a11y_fixes');
    const currentValue = (0, $i86qj.asNumberValue)(formRankingField.value);
    const selectedOptionId = (currentValue === null || currentValue === void 0 || (_currentValue$number = currentValue.number) === null || _currentValue$number === void 0 ? void 0 : _currentValue$number.toString()) ?? null;
    const selectedNumericId = selectedOptionId !== null ? Number(selectedOptionId) : null;
    const ratingIcon = (0, $7ZEcd.getRatingIconFromOptions)(formRankingField.options);
    const UnselectedIcon = (0, $7ZEcd.getRatingIconComponent)(ratingIcon);
    const SelectedIcon = (0, $7ZEcd.getSelectedRatingIconComponent)(ratingIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $a6298304bdc5cdd7$var$styles.container,
        testId: "field-input-rating-preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.400",
        role: isRatingScaleA11yFixesEnabled ? 'radiogroup' : undefined,
        "aria-label": isRatingScaleA11yFixesEnabled ? formRankingField.label : undefined
    }, formRankingField.options.map((option)=>{
        const numericId = Number(option.id);
        const isFilled = selectedNumericId !== null && !Number.isNaN(numericId) && numericId <= selectedNumericId;
        const IconComponent = isFilled ? SelectedIcon : UnselectedIcon;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
            key: option.id,
            alignInline: "center",
            space: "space.100",
            testId: `field-input-rating-preview-option-${option.id}-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: option.id === selectedOptionId,
            isDisabled: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
            appearance: "subtle",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(IconComponent, {
                    ...iconProps,
                    color: "var(--ds-icon-disabled, #080F214A)"
                }),
            label: option.id,
            isDisabled: true,
            "aria-hidden": true,
            tabIndex: -1
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            align: "center"
        }, option.id));
    }))));
};

});

parcelRegister("5njvs", function(module, exports) {
$parcel$export(module.exports, "ViewRatingInput", () => $349c1133bc690fbb$export$1af14277831a5b04);

var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $349c1133bc690fbb$var$selectedValue = (0, $f0Pt4.defineMessage)({
    id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.rating-input.view.selected-value',
    defaultMessage: '{selected}/{max}',
    description: 'Displays the selected rating value out of the maximum, e.g. "3/5". selected is the chosen rating number, max is the highest rating option.'
});
const $349c1133bc690fbb$var$noValue = (0, $f0Pt4.defineMessage)({
    id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.rating-input.view.no-value',
    defaultMessage: '-/{max}',
    description: 'Displayed when no rating has been selected, showing only the maximum rating value, e.g. "-/5".'
});
const $349c1133bc690fbb$export$1af14277831a5b04 = ({ fieldId: fieldId })=>{
    var _formRankingField$opt;
    const intl = (0, $4vLTk.default)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const currentValue = (0, $i86qj.asNumberValue)(formRankingField.value);
    const max = ((_formRankingField$opt = formRankingField.options[formRankingField.options.length - 1]) === null || _formRankingField$opt === void 0 ? void 0 : _formRankingField$opt.id) ?? '';
    const text = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.number) !== undefined ? intl.formatMessage($349c1133bc690fbb$var$selectedValue, {
        selected: currentValue.number,
        max: max
    }) : intl.formatMessage($349c1133bc690fbb$var$noValue, {
        max: max
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: "field-input-rating-view"
    }, text);
};

});


parcelRegister("kOL4b", function(module, exports) {
$parcel$export(module.exports, "ScaleInput", () => $d7c844f38b5a3a55$export$3a0fc0157d92d075);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $8mT72 = parcelRequire("8mT72");

var $1ltoo = parcelRequire("1ltoo");

var $hpxPx = parcelRequire("hpxPx");
const $d7c844f38b5a3a55$export$3a0fc0157d92d075 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (!(0, $gdUUy.fg)('phx-3346_proforma_rating_question_type')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8mT72.EditScaleInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1ltoo.PreviewScaleInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hpxPx.ViewScaleInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("8mT72", function(module, exports) {
$parcel$export(module.exports, "EditScaleInput", () => $6ad152442aec5e20$export$8c08563b6ed07ea1);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $jDsoo = parcelRequire("jDsoo");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $6B621 = parcelRequire("6B621");

var $9Abbn = parcelRequire("9Abbn");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $9WR8X = parcelRequire("9WR8X");

var $deQPj = parcelRequire("deQPj");

var $5JwFL = parcelRequire("5JwFL");
const $6ad152442aec5e20$var$styles = {
    buttonWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    labelsRow: "_19pkutpp",
    edgeLabelStack: "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm",
    edgeLabelText: "_1bsb1ris _p12f1ssb _kqswstnw _94n510v4 _o5724jg8",
    startLabelText: "_1ltvidpf _y3gnv2br",
    endLabelText: "_1xi2idpf _y3gnh9n0",
    gatedLabelSpacer: "_4t3i1k8s",
    container: "_1bsb1ns9 _1ul91osq"
};
const $6ad152442aec5e20$export$8c08563b6ed07ea1 = ({ fieldId: fieldId, fieldErrorId: fieldErrorId })=>{
    const isRatingScaleA11yFixesEnabled = (0, $gdUUy.fg)('proforma_rating_scale_a11y_fixes');
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $i86qj.asNumberValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const selectedOptionId = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.number) !== undefined ? String(currentValue.number) : null;
    const onSelect = (0, $bSJIT.useCallback)((optionId)=>{
        if (optionId === selectedOptionId) updateModifiedValue(fieldId, null);
        else {
            const selected = formRankingField === null || formRankingField === void 0 ? void 0 : formRankingField.options.find((o)=>o.id === optionId);
            if (selected) updateModifiedValue(fieldId, {
                number: Number(optionId)
            });
        }
    }, [
        fieldId,
        formRankingField,
        selectedOptionId,
        updateModifiedValue
    ]);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const { leftLabel: leftLabel, middleLabel: middleLabel, rightLabel: rightLabel } = (0, $deQPj.getScaleLabelsFromOptions)(formRankingField.options);
    const hasLabels = Boolean(leftLabel && rightLabel);
    if (!isRatingScaleA11yFixesEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-scale-edit",
        xcss: $6ad152442aec5e20$var$styles.container,
        "aria-invalid": isInvalid,
        "aria-describedby": isInvalid ? fieldErrorId : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.200"
    }, formRankingField.options.map((option)=>{
        const isSelected = option.id === selectedOptionId;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
            key: option.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: isSelected,
            onChange: ()=>onSelect(option.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: $6ad152442aec5e20$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            appearance: "default",
            isSelected: isSelected,
            shouldFitContainer: true,
            onClick: ()=>onSelect(option.id),
            "aria-hidden": true,
            tabIndex: -1,
            testId: `field-input-scale-edit-option-${option.id}-${fieldId}`
        }, option.id)));
    })), hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $6ad152442aec5e20$var$styles.labelsRow,
        testId: "field-input-scale-edit-labels"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-edit-label-left"
    }, leftLabel), middleLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-edit-label-middle"
    }, middleLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-edit-label-right"
    }, rightLabel))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-scale-edit",
        xcss: $6ad152442aec5e20$var$styles.container,
        "aria-invalid": isInvalid,
        "aria-describedby": isInvalid ? fieldErrorId : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $6ad152442aec5e20$var$styles.edgeLabelStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.200",
        alignBlock: "start",
        role: "radiogroup",
        "aria-label": formRankingField.label
    }, formRankingField.options.map((option, index)=>{
        const isSelected = option.id === selectedOptionId;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            key: option.id,
            xcss: $6ad152442aec5e20$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: isSelected,
            onChange: ()=>onSelect(option.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            appearance: "default",
            isSelected: isSelected,
            shouldFitContainer: true,
            onClick: ()=>onSelect(option.id),
            "aria-hidden": true,
            tabIndex: -1,
            testId: `field-input-scale-edit-option-${option.id}-${fieldId}`
        }, option.id), index === 0 && hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($6ad152442aec5e20$var$styles.edgeLabelText, $6ad152442aec5e20$var$styles.startLabelText),
            testId: "field-input-scale-edit-label-left"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            color: "color.text.subtle"
        }, leftLabel)), index === formRankingField.options.length - 1 && hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($6ad152442aec5e20$var$styles.edgeLabelText, $6ad152442aec5e20$var$styles.endLabelText),
            testId: "field-input-scale-edit-label-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            color: "color.text.subtle"
        }, rightLabel)));
    }))), hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $6ad152442aec5e20$var$styles.gatedLabelSpacer
    })));
};

});
parcelRegister("deQPj", function(module, exports) {
$parcel$export(module.exports, "getScaleLabelsFromOptions", () => $d91638d4730f7d10$export$d6b7956fa0f5ee66);
const $d91638d4730f7d10$export$d6b7956fa0f5ee66 = (options)=>{
    var _options$, _options$2, _options$3;
    if (!options || options.length === 0) return {};
    return {
        leftLabel: ((_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.label) || undefined,
        rightLabel: ((_options$2 = options[1]) === null || _options$2 === void 0 ? void 0 : _options$2.label) || undefined,
        middleLabel: ((_options$3 = options[2]) === null || _options$3 === void 0 ? void 0 : _options$3.label) || undefined
    };
};

});


parcelRegister("1ltoo", function(module, exports) {
$parcel$export(module.exports, "PreviewScaleInput", () => $61401a8b5bd0287b$export$9d2058d34ec2bb70);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $jDsoo = parcelRequire("jDsoo");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $6B621 = parcelRequire("6B621");

var $9Abbn = parcelRequire("9Abbn");

var $kVXLM = parcelRequire("kVXLM");

var $9WR8X = parcelRequire("9WR8X");

var $deQPj = parcelRequire("deQPj");

var $5JwFL = parcelRequire("5JwFL");
const $61401a8b5bd0287b$var$styles = {
    buttonWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    labelsRow: "_19pkutpp",
    edgeLabelStack: "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm",
    edgeLabelText: "_1bsb1ris _p12f1ssb _kqswstnw _94n510v4 _o5724jg8",
    startLabelText: "_1ltvidpf _y3gnv2br",
    endLabelText: "_1xi2idpf _y3gnh9n0",
    gatedLabelSpacer: "_4t3i1k8s",
    container: "_1bsb1ns9 _1ul91osq"
};
const $61401a8b5bd0287b$export$9d2058d34ec2bb70 = ({ fieldId: fieldId })=>{
    var _formRankingField$val;
    const isRatingScaleA11yFixesEnabled = (0, $gdUUy.fg)('proforma_rating_scale_a11y_fixes');
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const selectedOptionId = ((_formRankingField$val = formRankingField.value) === null || _formRankingField$val === void 0 ? void 0 : _formRankingField$val.number) !== undefined ? String(formRankingField.value.number) : null;
    const { leftLabel: leftLabel, middleLabel: middleLabel, rightLabel: rightLabel } = (0, $deQPj.getScaleLabelsFromOptions)(formRankingField.options);
    const hasLabels = Boolean(leftLabel && rightLabel);
    if (!isRatingScaleA11yFixesEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-scale-preview",
        xcss: $61401a8b5bd0287b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.200"
    }, formRankingField.options.map((option)=>{
        const isSelected = option.id === selectedOptionId;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
            key: option.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: isSelected,
            isDisabled: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: $61401a8b5bd0287b$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            appearance: isSelected ? 'primary' : 'default',
            shouldFitContainer: true,
            isDisabled: true,
            "aria-hidden": true,
            tabIndex: -1,
            testId: `field-input-scale-preview-option-${option.id}-${fieldId}`
        }, option.id)));
    })), hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $61401a8b5bd0287b$var$styles.labelsRow,
        testId: "field-input-scale-preview-labels"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-preview-label-left"
    }, leftLabel), middleLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-preview-label-middle"
    }, middleLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        size: "small",
        color: "color.text.subtle",
        testId: "field-input-scale-preview-label-right"
    }, rightLabel))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9WR8X.ScrollContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-scale-preview",
        xcss: $61401a8b5bd0287b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $61401a8b5bd0287b$var$styles.edgeLabelStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZ0ZI.Inline), {
        space: "space.200",
        alignBlock: "start",
        role: "radiogroup",
        "aria-label": formRankingField.label
    }, formRankingField.options.map((option, index)=>{
        const isSelected = option.id === selectedOptionId;
        const inputId = `${fieldId}-${option.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            key: option.id,
            xcss: $61401a8b5bd0287b$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Abbn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6B621.default), {
            id: inputId,
            value: option.id,
            label: option.id,
            name: fieldId,
            isChecked: isSelected,
            isDisabled: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            appearance: isSelected ? 'primary' : 'default',
            shouldFitContainer: true,
            isDisabled: true,
            "aria-hidden": true,
            tabIndex: -1,
            testId: `field-input-scale-preview-option-${option.id}-${fieldId}`
        }, option.id), index === 0 && hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($61401a8b5bd0287b$var$styles.edgeLabelText, $61401a8b5bd0287b$var$styles.startLabelText),
            testId: "field-input-scale-preview-label-left"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            color: "color.text.subtle"
        }, leftLabel)), index === formRankingField.options.length - 1 && hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($61401a8b5bd0287b$var$styles.edgeLabelText, $61401a8b5bd0287b$var$styles.endLabelText),
            testId: "field-input-scale-preview-label-right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
            size: "small",
            color: "color.text.subtle"
        }, rightLabel)));
    }))), hasLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $61401a8b5bd0287b$var$styles.gatedLabelSpacer
    })));
};

});

parcelRegister("hpxPx", function(module, exports) {
$parcel$export(module.exports, "ViewScaleInput", () => $dc3c12db0087efe0$export$9156ce9ab33e9123);

var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $dc3c12db0087efe0$var$selectedValue = (0, $f0Pt4.defineMessage)({
    id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.scale-input.view.selected-value',
    defaultMessage: '{selected}/{max}',
    description: 'Displays the selected scale value out of the maximum, e.g. "7/10". selected is the chosen scale number, max is the highest scale option.'
});
const $dc3c12db0087efe0$var$noValue = (0, $f0Pt4.defineMessage)({
    id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.scale-input.view.no-value',
    defaultMessage: '-/{max}',
    description: 'Displayed when no scale value has been selected, showing only the maximum scale value, e.g. "-/10".'
});
const $dc3c12db0087efe0$export$9156ce9ab33e9123 = ({ fieldId: fieldId })=>{
    var _formRankingField$opt, _formRankingField$val;
    const intl = (0, $4vLTk.default)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formRankingField = (0, $kVXLM.asFormRankingField)(formField);
    if (formRankingField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const max = ((_formRankingField$opt = formRankingField.options[formRankingField.options.length - 1]) === null || _formRankingField$opt === void 0 ? void 0 : _formRankingField$opt.id) ?? '';
    const text = ((_formRankingField$val = formRankingField.value) === null || _formRankingField$val === void 0 ? void 0 : _formRankingField$val.number) !== undefined ? intl.formatMessage($dc3c12db0087efe0$var$selectedValue, {
        selected: formRankingField.value.number,
        max: max
    }) : intl.formatMessage($dc3c12db0087efe0$var$noValue, {
        max: max
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: "field-input-scale-view"
    }, text);
};

});


parcelRegister("lseR1", function(module, exports) {
$parcel$export(module.exports, "SingleSelectInput", () => $b9ded060c52cd989$export$19cb58d027df0970);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $8fYi0 = parcelRequire("8fYi0");

var $6BVcP = parcelRequire("6BVcP");

var $1FjbG = parcelRequire("1FjbG");
const $b9ded060c52cd989$export$19cb58d027df0970 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8fYi0.EditSingleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6BVcP.PreviewSingleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1FjbG.ViewSingleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("8fYi0", function(module, exports) {
$parcel$export(module.exports, "EditSingleSelectInput", () => $a941b2f5ae11bc4c$export$a9d913b6a99f71d6);
// oxlint-disable prefer-default-export
// oxlint-disable max-lines -- need to ship a bug fix and this whole file needs a refractor anyway as it is getting out of control and the loadOptions behavior needs to be redesigned

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $ktbTQ = parcelRequire("ktbTQ");

var $cHz95 = parcelRequire("cHz95");

var $eOzrv = parcelRequire("eOzrv");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $kVXLM = parcelRequire("kVXLM");

var $iQRsO = parcelRequire("iQRsO");

var $lP1BQ = parcelRequire("lP1BQ");

var $5JwFL = parcelRequire("5JwFL");

var $8U0dG = parcelRequire("8U0dG");

var $44qKj = parcelRequire("44qKj");
const $a941b2f5ae11bc4c$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS = 500;
const $a941b2f5ae11bc4c$var$optionStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.050'
});
const $a941b2f5ae11bc4c$export$a9d913b6a99f71d6 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    const intl = (0, $4vLTk.default)();
    const currentValue = (0, $i86qj.asOptionsValue)((0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    }));
    const currentValues = (0, $5JwFL.useCurrentValues)();
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const { asyncFields: asyncFields } = (0, $5JwFL.useFormRendererState)();
    const fieldAsyncConfiguration = asyncFields[fieldId];
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const [otherTextInputValue, setOtherTextInputValue] = (0, $bSJIT.useState)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    const [loadOptionsOnFocusDefaultOptions, setLoadOptionsOnFocusDefaultOptions] = (0, $bSJIT.useState)();
    const [isLoadingOptionsOnFocus, setIsLoadingOptionsOnFocus] = (0, $bSJIT.useState)(false);
    // Tracks the `currentValues` and async config used for the last focus load so we can skip a
    // refetch when nothing that could make this field's options stale has changed. `undefined`
    // means the focus options have never been loaded for this field.
    const lastLoadedValuesRef = (0, $bSJIT.useRef)(undefined);
    const lastLoadedConfigRef = (0, $bSJIT.useRef)(undefined);
    // Monotonic counter used to discard responses from superseded in-flight requests. Each fetch
    // increments the counter; a response is applied only when its captured id still matches.
    const loadRequestCounterRef = (0, $bSJIT.useRef)(0);
    (0, $bSJIT.useEffect)(()=>{
        setOtherTextInputValue(currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText);
    }, [
        currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText,
        setOtherTextInputValue
    ]);
    const handleLoadOptionsOnFocus = (0, $bSJIT.useCallback)(()=>{
        if (!(fieldAsyncConfiguration !== null && fieldAsyncConfiguration !== void 0 && fieldAsyncConfiguration.loadOptions)) return;
        const previousValues = lastLoadedValuesRef.current;
        // Only (re)load on the first focus, when the async config changes, or when a field value
        // OTHER than this field's own changes. Changing this field's own selection cannot make its
        // own option list stale, so we skip the refetch (avoiding an unnecessary network round-trip
        // on every reopen) and keep the already-loaded options so that de-selected values reappear
        // in the menu client-side.
        const shouldLoad = previousValues === undefined || lastLoadedConfigRef.current !== fieldAsyncConfiguration || (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId);
        if (!shouldLoad) return;
        lastLoadedValuesRef.current = currentValues;
        lastLoadedConfigRef.current = fieldAsyncConfiguration;
        loadRequestCounterRef.current += 1;
        const requestId = loadRequestCounterRef.current;
        setIsLoadingOptionsOnFocus(true);
        fieldAsyncConfiguration.loadOptions('', currentValues, fieldId)// loadRequestCounterRef check early returns are stale guards
        .then((options)=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setLoadOptionsOnFocusDefaultOptions(options);
        }).catch(()=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setLoadOptionsOnFocusDefaultOptions([]);
        }).finally(()=>{
            if (requestId !== loadRequestCounterRef.current) return;
            setIsLoadingOptionsOnFocus(false);
        });
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId
    ]);
    const onChange = (0, $bSJIT.useCallback)((value)=>{
        if (value === null) updateModifiedValue(fieldId, null);
        else if (value.value === (0, $gjxgd.OTHER_ID)) updateModifiedValue(fieldId, {
            otherOptionText: '',
            options: []
        });
        else updateModifiedValue(fieldId, {
            options: [
                {
                    id: value.value.toString(),
                    label: value.label
                }
            ]
        });
    }, [
        fieldId,
        updateModifiedValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const onOtherOptionTextChange = (0, $bSJIT.useCallback)((event)=>{
        setOtherTextInputValue(event.target.value);
        debouncedUpdateModifiedValue(fieldId, {
            otherOptionText: event.target.value,
            options: []
        });
    }, [
        fieldId,
        debouncedUpdateModifiedValue,
        setOtherTextInputValue
    ]);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    const otherOption = {
        value: (0, $gjxgd.OTHER_ID),
        label: intl.formatMessage((0, $8U0dG.messages).otherOption)
    };
    if (fieldAsyncConfiguration === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: `field-input-single-select-edit-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        inputId: fieldInputId,
        options: formOptionField.hasOtherOption ? [
            ...(0, $kVXLM.toOptions)(formOptionField.options),
            otherOption
        ] : (0, $kVXLM.toOptions)(formOptionField.options),
        value: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.otherOptionText) !== undefined ? otherOption : currentValue !== null && currentValue !== void 0 && currentValue.options.length ? (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options)[0] : null,
        onChange: onChange,
        isSearchable: true,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownSelect),
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        isInvalid: isInvalid,
        isClearable: true,
        testId: `field-input-single-select-edit-input-${fieldId}`,
        isRequired: isRequired,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined,
        components: {
            Option: (0, $iQRsO.CustomSelectOption)
        }
    }), otherTextInputValue !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $a941b2f5ae11bc4c$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        appearance: "standard",
        placeholder: intl.formatMessage((0, $8U0dG.messages).optionDropdownNewOption),
        minimumRows: 2,
        isMonospaced: false,
        value: otherTextInputValue,
        resize: "smart",
        spellCheck: false,
        onChange: onOtherOptionTextChange,
        isInvalid: isInvalid,
        testId: `field-input-single-select-edit-other-${fieldId}`,
        "aria-label": intl.formatMessage((0, $8U0dG.messages).otherOptionTextLabel, {
            label: formField.label
        }),
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })));
    if (fieldAsyncConfiguration.loadPaginatedOptions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $44qKj.PaginatedEditSingleSelectInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldErrorId: fieldErrorId,
        fieldAsyncConfiguration: fieldAsyncConfiguration,
        currentValue: currentValue,
        currentValues: currentValues,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange
    });
    const loadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))((query, callback)=>{
        var _fieldAsyncConfigurat;
        (_fieldAsyncConfigurat = fieldAsyncConfiguration.loadOptions) === null || _fieldAsyncConfigurat === void 0 || _fieldAsyncConfigurat.call(fieldAsyncConfiguration, query, currentValues, fieldId).then((options)=>callback(options)).catch(()=>callback([]));
    }, $a941b2f5ae11bc4c$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS);
    const { createOptions: createOptions } = fieldAsyncConfiguration;
    const { isValidNewOption: isValidNewOption, onCreateOption: onCreateOption } = createOptions || {};
    const isCreateable = createOptions !== undefined;
    const getLoadOptionsOnEventBehavior = ()=>{
        const isDefaultOptionsConfigurationProvided = fieldAsyncConfiguration.defaultOptions !== undefined;
        const defaultOptionsProps = {
            defaultOptions: fieldAsyncConfiguration.defaultOptions
        };
        const loadOptionsOnFocusProps = {
            onFocus: handleLoadOptionsOnFocus,
            onMenuOpen: handleLoadOptionsOnFocus,
            openMenuOnFocus: true,
            defaultOptions: loadOptionsOnFocusDefaultOptions,
            isLoading: isLoadingOptionsOnFocus
        };
        // AsyncFieldConfiguration.defaultOptions is now not a direct mapping to the prop behavior of react-select.
        // In react-select the defaultOptions prop being undefined or explicitly false are functionally the same, just
        // like any other React component. However here, we define defaultOptions as part of a store hook for a config
        // object. Here we use the config of defaultOptions to have different behavior for `undefined`, i.e. the `onFocus`
        // triggering of `loadOptions`
        return isDefaultOptionsConfigurationProvided ? defaultOptionsProps : loadOptionsOnFocusProps;
    };
    return isCreateable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "field-input-single-select-edit-async-createable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ktbTQ.default), {
        inputId: fieldInputId,
        ...getLoadOptionsOnEventBehavior(),
        isSearchable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownNoOptions)),
        loadOptions: loadOptions,
        onCreateOption: onCreateOption,
        isValidNewOption: isValidNewOption,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownSelect),
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options)[0] ?? null,
        isInvalid: isInvalid,
        isClearable: true,
        testId: `field-input-single-select-edit-input-${fieldId}`,
        components: {
            Option: (0, $iQRsO.CustomSelectOption)
        },
        cacheOptions: fieldAsyncConfiguration.cacheOptions,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: "field-input-single-select-edit-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cHz95.default), {
        inputId: fieldInputId,
        ...getLoadOptionsOnEventBehavior(),
        isSearchable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownNoOptions)),
        loadOptions: loadOptions,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownSelect),
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options)[0] ?? null,
        isInvalid: isInvalid,
        isClearable: true,
        testId: `field-input-single-select-edit-input-${fieldId}`,
        components: {
            Option: (0, $iQRsO.CustomSelectOption)
        },
        cacheOptions: fieldAsyncConfiguration.cacheOptions,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});
parcelRegister("8U0dG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $14f3fe4e66d91605$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $14f3fe4e66d91605$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    optionDropdownNewOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.option-dropdown-new-option',
        defaultMessage: 'New option...',
        description: 'Placeholder text in dropdown when a new option can be created.'
    },
    optionDropdownNoOptions: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.option-dropdown-no-options',
        defaultMessage: 'No options',
        description: 'Placeholder text in dropdown when there are no options.'
    },
    optionDropdownSelect: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.option-dropdown-select',
        defaultMessage: 'Select...',
        description: 'Placeholder text in dropdown waiting for the user to select something.'
    },
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.other-option-text-label',
        description: 'Label for the single select input field other text box in edit mode, for accessibility',
        defaultMessage: '{label} single select input field other option text area'
    },
    searchResultsLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.edit.search-results-label',
        defaultMessage: '{numberOfSearchResults, plural, one {# search result} other {# search results}}',
        description: 'Label above options describing how many search results were found'
    }
});

});

parcelRegister("44qKj", function(module, exports) {
$parcel$export(module.exports, "PaginatedEditSingleSelectInput", () => $008a30140db61ab6$export$45f9352128af3c03);
// oxlint-disable prefer-default-export

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $eOzrv = parcelRequire("eOzrv");

var $kVXLM = parcelRequire("kVXLM");

var $iQRsO = parcelRequire("iQRsO");

var $lP1BQ = parcelRequire("lP1BQ");

var $8U0dG = parcelRequire("8U0dG");
const $008a30140db61ab6$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS = 400; // Matches Help Center CMDB debounce
const $008a30140db61ab6$var$FIRST_PAGE_START_INDEX = 0;
// Defined at module scope so react-select keeps a stable reference and does not remount the menu
// (which would reset the infinite-scroll position) on each parent render.
const $008a30140db61ab6$var$selectComponents = {
    Option: (0, $iQRsO.CustomSelectOption)
};
const $008a30140db61ab6$var$hasDefaultOptionsEnabled = ({ defaultOptions: defaultOptions })=>defaultOptions === true;
const $008a30140db61ab6$var$shouldLoadOptionsWhenMenuOpens = ({ defaultOptions: defaultOptions })=>defaultOptions === undefined;
const $008a30140db61ab6$export$45f9352128af3c03 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId, fieldAsyncConfiguration: fieldAsyncConfiguration, currentValue: currentValue, currentValues: currentValues, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange })=>{
    const intl = (0, $4vLTk.default)();
    const [options, setOptions] = (0, $bSJIT.useState)([]);
    const [inputValue, setInputValue] = (0, $bSJIT.useState)('');
    const [isMenuOpen, setIsMenuOpen] = (0, $bSJIT.useState)(false);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const requestCounterRef = (0, $bSJIT.useRef)(0);
    const lastLoadedValuesRef = (0, $bSJIT.useRef)(undefined);
    const lastLoadedConfigRef = (0, $bSJIT.useRef)(undefined);
    const paginationRef = (0, $bSJIT.useRef)({
        startIndex: $008a30140db61ab6$var$FIRST_PAGE_START_INDEX,
        hasNextPage: false,
        query: ''
    });
    const invalidateLoadedOptions = (0, $bSJIT.useCallback)(()=>{
        requestCounterRef.current += 1;
        setOptions([]);
        paginationRef.current = {
            query: '',
            startIndex: $008a30140db61ab6$var$FIRST_PAGE_START_INDEX,
            hasNextPage: false
        };
        setIsLoading(false);
        lastLoadedValuesRef.current = undefined;
    }, []);
    // Invalidate cached options when parent field values change or config changes
    (0, $bSJIT.useEffect)(()=>{
        const previousValues = lastLoadedValuesRef.current;
        const hasRelevantParentValueChanged = previousValues !== undefined && (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId);
        const hasConfigChanged = lastLoadedConfigRef.current !== fieldAsyncConfiguration;
        if (hasRelevantParentValueChanged || hasConfigChanged) invalidateLoadedOptions();
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId,
        invalidateLoadedOptions
    ]);
    const loadFirstPage = (0, $bSJIT.useCallback)((query)=>{
        if (!fieldAsyncConfiguration.loadPaginatedOptions) return;
        requestCounterRef.current += 1;
        const requestId = requestCounterRef.current;
        setIsLoading(true);
        paginationRef.current = {
            query: query,
            startIndex: $008a30140db61ab6$var$FIRST_PAGE_START_INDEX,
            hasNextPage: false
        };
        fieldAsyncConfiguration.loadPaginatedOptions(query, currentValues, fieldId, $008a30140db61ab6$var$FIRST_PAGE_START_INDEX).then((result)=>{
            if (requestId !== requestCounterRef.current) return;
            setOptions(result.options);
            paginationRef.current = {
                query: query,
                startIndex: result.options.length,
                hasNextPage: result.hasNextPage
            };
            lastLoadedValuesRef.current = currentValues;
            lastLoadedConfigRef.current = fieldAsyncConfiguration;
        }).catch(()=>{
            if (requestId !== requestCounterRef.current) return;
            setOptions([]);
            paginationRef.current = {
                query: query,
                startIndex: $008a30140db61ab6$var$FIRST_PAGE_START_INDEX,
                hasNextPage: false
            };
        }).finally(()=>{
            if (requestId !== requestCounterRef.current) return;
            setIsLoading(false);
        });
    }, [
        fieldAsyncConfiguration,
        currentValues,
        fieldId
    ]);
    const debouncedLoadFirstPage = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(loadFirstPage, $008a30140db61ab6$var$LOAD_OPTIONS_DEBOUNCE_WAIT_MS), [
        loadFirstPage
    ]);
    // Cleanup debounced function on unmount
    (0, $bSJIT.useEffect)(()=>()=>{
            debouncedLoadFirstPage.cancel();
        }, [
        debouncedLoadFirstPage
    ]);
    // Load options on mount when defaultOptions is true
    (0, $bSJIT.useEffect)(()=>{
        if ($008a30140db61ab6$var$hasDefaultOptionsEnabled(fieldAsyncConfiguration)) loadFirstPage('');
    }, [
        fieldAsyncConfiguration,
        loadFirstPage
    ]);
    const handleMenuOpen = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpen(true);
        if (!$008a30140db61ab6$var$shouldLoadOptionsWhenMenuOpens(fieldAsyncConfiguration)) return;
        // Only load if we haven't loaded yet, if parent values/config changed, or if the options
        // currently held are still filtered by a previous search keyword. The input is cleared on
        // close, so a previously-searched list must be reloaded unfiltered to stay in sync.
        const previousValues = lastLoadedValuesRef.current;
        const shouldLoad = previousValues === undefined || lastLoadedConfigRef.current !== fieldAsyncConfiguration || (0, $lP1BQ.haveOtherFieldValuesChanged)(previousValues, currentValues, fieldId) || paginationRef.current.query !== '';
        if (shouldLoad) loadFirstPage(inputValue);
    }, [
        fieldAsyncConfiguration,
        currentValues,
        fieldId,
        inputValue,
        loadFirstPage
    ]);
    const handleMenuClose = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpen(false);
        // Clear the search keyword so the field returns to its selected/default value display and
        // the next open starts from a clean, unfiltered state (matches the non-paginated AsyncSelect,
        // which clears its internal input on close). The selection itself is unaffected because the
        // displayed value is driven by `currentValue`, not `inputValue`.
        setInputValue('');
        debouncedLoadFirstPage.cancel();
    }, [
        debouncedLoadFirstPage
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((newValue, actionMeta)=>{
        // ADS Select calls onInputChange for blur/menu-close as well as real typing.
        // Only user input should trigger keyword API searches.
        if (actionMeta.action !== 'input-change') return;
        setInputValue(newValue);
        debouncedLoadFirstPage(newValue);
    }, [
        debouncedLoadFirstPage
    ]);
    const handleMenuScrollToBottom = (0, $bSJIT.useCallback)(()=>{
        const { hasNextPage: hasNextPage, startIndex: startIndex, query: query } = paginationRef.current;
        if (!hasNextPage || isLoading || !fieldAsyncConfiguration.loadPaginatedOptions) return;
        const requestId = requestCounterRef.current;
        setIsLoading(true);
        fieldAsyncConfiguration.loadPaginatedOptions(query, currentValues, fieldId, startIndex).then((result)=>{
            if (requestId !== requestCounterRef.current) return;
            setOptions((prev)=>[
                    ...prev,
                    ...result.options
                ]);
            paginationRef.current = {
                query: query,
                startIndex: startIndex + result.options.length,
                hasNextPage: result.hasNextPage
            };
        }).catch(()=>{
        // Keep already-loaded options if an additional page fails
        }).finally(()=>{
            if (requestId !== requestCounterRef.current) return;
            setIsLoading(false);
        });
    }, [
        currentValues,
        fieldAsyncConfiguration,
        fieldId,
        isLoading
    ]);
    const optionsWithLabel = options.length > 0 ? [
        {
            label: intl.formatMessage((0, $8U0dG.messages).searchResultsLabel, {
                numberOfSearchResults: options.length
            }),
            options: options
        }
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-single-select-edit-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-single-select-edit-async-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        inputId: fieldInputId,
        options: optionsWithLabel,
        formatGroupLabel: (group)=>group.label,
        value: (0, $kVXLM.toOptions)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.options)[0] ?? null,
        inputValue: inputValue,
        menuIsOpen: isMenuOpen,
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        isLoading: isLoading,
        onChange: onChange,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: handleMenuScrollToBottom,
        isSearchable: true,
        isClearable: true,
        noOptionsMessage: fieldAsyncConfiguration.noOptionsMessage ?? (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownNoOptions)),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $8U0dG.messages).optionDropdownSelect),
        isInvalid: isInvalid,
        testId: `field-input-single-select-edit-input-${fieldId}`,
        isRequired: isRequired,
        filterOption: null,
        ...(0, $lP1BQ.getDropDownMenuPosition)(),
        components: $008a30140db61ab6$var$selectComponents,
        descriptionId: isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    })));
};

});


parcelRegister("6BVcP", function(module, exports) {
$parcel$export(module.exports, "PreviewSingleSelectInput", () => $81cc56d1443c0aa5$export$c9d4f0e05cc3ef52);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $dDEhr = parcelRequire("dDEhr");

var $eOzrv = parcelRequire("eOzrv");

var $5R01U = parcelRequire("5R01U");

var $gjxgd = parcelRequire("gjxgd");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");

var $g4JJy = parcelRequire("g4JJy");
const $81cc56d1443c0aa5$export$c9d4f0e05cc3ef52 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formOptionField$valu, _formOptionField$valu2, _formOptionField$valu3;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    const intl = (0, $4vLTk.default)();
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dDEhr.Stack), {
        testId: "field-input-single-select-preview",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eOzrv.default), {
        key: fieldInputId,
        inputId: fieldInputId,
        value: ((_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.otherOptionText) !== undefined ? {
            value: (0, $gjxgd.OTHER_ID),
            label: intl.formatMessage((0, $g4JJy.messages).otherOption)
        } : (0, $kVXLM.toOptions)((_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.options)[0] ?? null,
        placeholder: "",
        isDisabled: true
    }), ((_formOptionField$valu3 = formOptionField.value) === null || _formOptionField$valu3 === void 0 ? void 0 : _formOptionField$valu3.otherOptionText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5R01U.default), {
        isDisabled: true,
        value: formOptionField.value.otherOptionText,
        "aria-label": intl.formatMessage((0, $g4JJy.messages).otherOptionTextLabel, {
            label: formField.label
        })
    }));
};

});
parcelRegister("g4JJy", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d0cbed421a220e8c$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $d0cbed421a220e8c$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    otherOption: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.preview.other-option',
        description: 'The label for the Other option in choice fields',
        defaultMessage: 'Other...'
    },
    otherOptionTextLabel: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.single-select-input.preview.other-option-text-label',
        description: 'Label for the single select field other option text area in preview mode, for accessibility',
        defaultMessage: '{label} single select field other option text area preview'
    }
});

});


parcelRegister("1FjbG", function(module, exports) {
$parcel$export(module.exports, "ViewSingleSelectInput", () => $eaf58f418f0e50f8$export$bda305f31c01c38a);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $eaf58f418f0e50f8$export$bda305f31c01c38a = ({ fieldId: fieldId })=>{
    var _formOptionField$valu, _formOptionField$valu2;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formOptionField = (0, $kVXLM.asFormOptionField)(formField);
    if (formOptionField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: "field-input-single-select-view"
    }, ((_formOptionField$valu = formOptionField.value) === null || _formOptionField$valu === void 0 ? void 0 : _formOptionField$valu.otherOptionText) !== undefined ? formOptionField.value.otherOptionText : (_formOptionField$valu2 = formOptionField.value) === null || _formOptionField$valu2 === void 0 || (_formOptionField$valu2 = _formOptionField$valu2.options[0]) === null || _formOptionField$valu2 === void 0 ? void 0 : _formOptionField$valu2.label));
};

});


parcelRegister("bsKrV", function(module, exports) {
$parcel$export(module.exports, "TextLongInput", () => $3fafd8b14ad56bef$export$d99235ceaa1034b2);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $ajYG6 = parcelRequire("ajYG6");

var $aaHfJ = parcelRequire("aaHfJ");

var $2p8IN = parcelRequire("2p8IN");
const $3fafd8b14ad56bef$export$d99235ceaa1034b2 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ajYG6.EditTextLongInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aaHfJ.PreviewTextLongInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2p8IN.ViewTextLongInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("ajYG6", function(module, exports) {
$parcel$export(module.exports, "EditTextLongInput", () => $3430b0c1af97d4bf$export$af6f271339ba1424);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $3430b0c1af97d4bf$export$af6f271339ba1424 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asTextValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [textFieldValue, setTextFieldValue] = (0, $bSJIT.useState)(currentValue);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    (0, $bSJIT.useEffect)(()=>{
        setTextFieldValue(currentValue);
    }, [
        currentValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        setTextFieldValue({
            text: event.target.value
        });
        if (event.target.value.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else debouncedUpdateModifiedValue(fieldId, {
            text: event.target.value
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: ((_asTextValue = (0, $i86qj.asTextValue)(textFieldValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text) ?? '',
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        placeholder: "",
        testId: `field-input-text-long-edit-${fieldId}`,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});

parcelRegister("aaHfJ", function(module, exports) {
$parcel$export(module.exports, "PreviewTextLongInput", () => $f15b85e3338c4dc7$export$2d2470589c1a36b1);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $f15b85e3338c4dc7$export$2d2470589c1a36b1 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-input-text-long-preview-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text,
        isDisabled: true
    }));
};

});

parcelRegister("2p8IN", function(module, exports) {
$parcel$export(module.exports, "ViewTextLongInput", () => $123e5d9e4146438c$export$dc8e6d0df99d1c2a);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $123e5d9e4146438c$export$dc8e6d0df99d1c2a = ({ fieldId: fieldId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-text-long-view-${fieldId}`
    }, (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text);
};

});


parcelRegister("h97p6", function(module, exports) {
$parcel$export(module.exports, "TextShortInput", () => $24f0fc106d6e0f19$export$1e47960f1cbe0545);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $8VB7H = parcelRequire("8VB7H");

var $03IjO = parcelRequire("03IjO");

var $beOY6 = parcelRequire("beOY6");
const $24f0fc106d6e0f19$export$1e47960f1cbe0545 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8VB7H.EditTextShortInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $03IjO.PreviewTextShortInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $beOY6.ViewTextShortInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("8VB7H", function(module, exports) {
$parcel$export(module.exports, "EditTextShortInput", () => $3ead3e4012b96dac$export$1ef92fbdfcd8d17a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $3ead3e4012b96dac$var$styles = {
    editBox: "_p12fp3fh"
};
const $3ead3e4012b96dac$export$1ef92fbdfcd8d17a = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asTextValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [textFieldValue, setTextFieldValue] = (0, $bSJIT.useState)(currentValue);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    (0, $bSJIT.useEffect)(()=>{
        setTextFieldValue(currentValue);
    }, [
        currentValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        setTextFieldValue({
            text: event.target.value
        });
        if (event.target.value.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else debouncedUpdateModifiedValue(fieldId, {
            text: event.target.value
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $3ead3e4012b96dac$var$styles.editBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: ((_asTextValue = (0, $i86qj.asTextValue)(textFieldValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text) ?? '',
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        width: "small",
        placeholder: "",
        testId: `field-input-text-short-edit-${fieldId}`,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});

parcelRegister("03IjO", function(module, exports) {
$parcel$export(module.exports, "PreviewTextShortInput", () => $53c5ba3e00b0084d$export$6444bc2c198f2a50);

var $bSJIT = parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $jgsO4 = parcelRequire("jgsO4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $53c5ba3e00b0084d$var$previewStyles = (0, $9BVpB.xcss)({
    maxWidth: '240px'
});
const $53c5ba3e00b0084d$export$6444bc2c198f2a50 = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        testId: `field-input-text-short-preview-${fieldId}`,
        xcss: $53c5ba3e00b0084d$var$previewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        value: (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text,
        isDisabled: true,
        id: fieldInputId,
        width: "small"
    }));
};

});

parcelRegister("beOY6", function(module, exports) {
$parcel$export(module.exports, "ViewTextShortInput", () => $5049121f8d4873a1$export$c429e9e2d323ec9f);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $5049121f8d4873a1$export$c429e9e2d323ec9f = ({ fieldId: fieldId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: `field-input-text-short-view-${fieldId}`
    }, (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text);
};

});


parcelRegister("2K4mp", function(module, exports) {
$parcel$export(module.exports, "UrlInput", () => $fb2ce85a85b72ec1$export$e94a5e0d272668a0);

var $bSJIT = parcelRequire("bSJIT");

var $gkoaJ = parcelRequire("gkoaJ");

var $5JwFL = parcelRequire("5JwFL");

var $cY3Bn = parcelRequire("cY3Bn");

var $lj6e8 = parcelRequire("lj6e8");

var $1vhCr = parcelRequire("1vhCr");
const $fb2ce85a85b72ec1$export$e94a5e0d272668a0 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldLabelId: fieldLabelId, fieldErrorId: fieldErrorId })=>{
    const renderMode = (0, $5JwFL.useFormRenderMode)();
    if (renderMode === (0, $gkoaJ.FormRenderMode).EDIT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cY3Bn.EditUrlInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    if (renderMode === (0, $gkoaJ.FormRenderMode).PREVIEW) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lj6e8.PreviewUrlInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1vhCr.ViewUrlInput), {
        fieldId: fieldId,
        fieldInputId: fieldInputId,
        fieldLabelId: fieldLabelId,
        fieldErrorId: fieldErrorId
    });
};

});
parcelRegister("cY3Bn", function(module, exports) {
$parcel$export(module.exports, "EditUrlInput", () => $82ec5473436a9854$export$16f0c2f494d1fbf5);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $82ec5473436a9854$export$16f0c2f494d1fbf5 = ({ fieldId: fieldId, fieldInputId: fieldInputId, fieldErrorId: fieldErrorId })=>{
    var _asTextValue;
    const isInvalid = (0, $5JwFL.useFieldInvalid)({
        fieldId: fieldId
    });
    const currentValue = (0, $5JwFL.useCurrentValue)({
        fieldId: fieldId
    });
    const [urlFieldValue, setUrlFieldValue] = (0, $bSJIT.useState)(currentValue);
    const { updateModifiedValue: updateModifiedValue } = (0, $5JwFL.useFormRendererActions)();
    const isRequired = (0, $5JwFL.useFieldRequired)({
        fieldId: fieldId
    });
    (0, $bSJIT.useEffect)(()=>{
        setUrlFieldValue(currentValue);
    }, [
        currentValue
    ]);
    const debouncedUpdateModifiedValue = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(updateModifiedValue, 500), [
        updateModifiedValue
    ]);
    const debouncedOnChange = (0, $bSJIT.useCallback)((event)=>{
        setUrlFieldValue({
            text: event.target.value
        });
        if (event.target.value.length === 0) debouncedUpdateModifiedValue(fieldId, null);
        else debouncedUpdateModifiedValue(fieldId, {
            text: event.target.value
        });
    }, [
        debouncedUpdateModifiedValue,
        fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: ((_asTextValue = (0, $i86qj.asTextValue)(urlFieldValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text) ?? '',
        isInvalid: isInvalid,
        onChange: debouncedOnChange,
        placeholder: "",
        testId: `field-input-url-edit-${fieldId}`,
        isRequired: isRequired,
        "aria-describedby": isInvalid && (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }));
};

});

parcelRegister("lj6e8", function(module, exports) {
$parcel$export(module.exports, "PreviewUrlInput", () => $512e2ef359b2fbbd$export$4ef815df67bdb72c);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $512e2ef359b2fbbd$export$4ef815df67bdb72c = ({ fieldId: fieldId, fieldInputId: fieldInputId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "field-input-url-preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        id: fieldInputId,
        value: (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text,
        isDisabled: true
    }));
};

});

parcelRegister("1vhCr", function(module, exports) {
$parcel$export(module.exports, "ViewUrlInput", () => $e16b32a4d0800e02$export$1d947c4930730576);

var $bSJIT = parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $9Rfip = parcelRequire("9Rfip");

var $8aT4G = parcelRequire("8aT4G");

var $kVXLM = parcelRequire("kVXLM");

var $5JwFL = parcelRequire("5JwFL");
const $e16b32a4d0800e02$export$1d947c4930730576 = ({ fieldId: fieldId })=>{
    var _formTextField$value;
    const formField = (0, $5JwFL.useFormField)({
        fieldId: fieldId
    });
    const formTextField = (0, $kVXLM.asFormTextField)(formField);
    if (formTextField === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        testId: "field-input-url-view"
    }, formTextField.value !== undefined && (0, $7nI18.isSafeUrl)(formTextField.value.text) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Rfip.default), {
        href: formTextField.value.text,
        target: "_blank"
    }, formTextField.value.text) : (_formTextField$value = formTextField.value) === null || _formTextField$value === void 0 ? void 0 : _formTextField$value.text);
};

});



parcelRegister("1BKyJ", function(module, exports) {
$parcel$export(module.exports, "FormFieldErrorRenderer", () => $072fc7b3970d993a$export$5aa6b82a6e70d3aa);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $k1CGD = parcelRequire("k1CGD");

var $hUIOI = parcelRequire("hUIOI");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $5JwFL = parcelRequire("5JwFL");
const $072fc7b3970d993a$var$styles = {
    errorMessage: "_11c8i4vh _k48pi7a9 _syaz1tmw",
    errorPlaceholder: "_4t3if6fq"
};
const $072fc7b3970d993a$export$5aa6b82a6e70d3aa = ({ fieldId: fieldId, fieldErrorId: fieldErrorId })=>{
    const fieldCustomError = (0, $5JwFL.useFieldCustomError)({
        fieldId: fieldId
    });
    const fieldValidationErrors = (0, $5JwFL.useFieldValidationErrors)({
        fieldId: fieldId
    });
    const errorMessage = [
        ...fieldValidationErrors.map((error)=>error.errorMessage),
        ...fieldCustomError ? [
            fieldCustomError
        ] : []
    ].join(' ');
    return errorMessage.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `field-${fieldId}-error-renderer`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hUIOI.MessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k1CGD.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $072fc7b3970d993a$var$styles.errorMessage,
        id: (0, $gdUUy.fg)('jsm-accessibility-fixes-new-renderer') ? fieldErrorId : undefined
    }, errorMessage)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $072fc7b3970d993a$var$styles.errorPlaceholder
    });
};

});

parcelRegister("eXSFU", function(module, exports) {
$parcel$export(module.exports, "UnknownField", () => $cef1d0b934f94ee7$export$64cd47482e3a83fe);

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $8LptA = parcelRequire("8LptA");

var $6otUE = parcelRequire("6otUE");
const $cef1d0b934f94ee7$export$64cd47482e3a83fe = ({ fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "unknown-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireTrackAnalytics), {
        actionSubject: (0, $6otUE.ActionSubject).FORM_FIELD,
        action: (0, $6otUE.Action).FAILED,
        actionSubjectId: "proformaFormRenderer",
        attributes: {
            fieldId: fieldId,
            isUnknownField: true
        }
    }));

});

parcelRegister("24rCT", function(module, exports) {
$parcel$export(module.exports, "getFormFieldComponentRenderer", () => $bfc0d1f9966d565a$export$9077ce6a9b493883);

var $gdUUy = parcelRequire("gdUUy");

var $2nfpZ = parcelRequire("2nfpZ");

var $166mz = parcelRequire("166mz");
const $bfc0d1f9966d565a$export$9077ce6a9b493883 = (fieldType, customFormFieldComponentRendererConfig, defaultFormFieldComponentRendererConfig)=>{
    if (!(0, $gdUUy.fg)('phx-3346_proforma_rating_question_type') && (fieldType === (0, $2nfpZ.FormFieldType).RATING || fieldType === (0, $2nfpZ.FormFieldType).SCALE)) return 0, $166mz.UnknownRenderer;
    if (customFormFieldComponentRendererConfig === undefined) return typeof defaultFormFieldComponentRendererConfig === 'object' ? defaultFormFieldComponentRendererConfig[fieldType] || (0, $166mz.UnknownRenderer) : defaultFormFieldComponentRendererConfig || (0, $166mz.UnknownRenderer);
    if (typeof customFormFieldComponentRendererConfig === 'object') {
        const customFormFieldTypeComponentRenderer = customFormFieldComponentRendererConfig[fieldType];
        if (customFormFieldTypeComponentRenderer === undefined) return typeof defaultFormFieldComponentRendererConfig === 'object' ? defaultFormFieldComponentRendererConfig[fieldType] || (0, $166mz.UnknownRenderer) : defaultFormFieldComponentRendererConfig || (0, $166mz.UnknownRenderer);
        return customFormFieldTypeComponentRenderer;
    }
    return customFormFieldComponentRendererConfig;
};

});
parcelRegister("166mz", function(module, exports) {
$parcel$export(module.exports, "UnknownRenderer", () => $d01347f2d3d09ee2$export$e8b9bd6933ae78c8);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $8LptA = parcelRequire("8LptA");

var $6otUE = parcelRequire("6otUE");

var $bHVX1 = parcelRequire("bHVX1");
const $d01347f2d3d09ee2$export$e8b9bd6933ae78c8 = ({ fieldId: fieldId })=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "unknown-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $bHVX1.messages).unknownFieldType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8LptA.FireTrackAnalytics), {
        actionSubject: (0, $6otUE.ActionSubject).FORM_FIELD,
        action: (0, $6otUE.Action).FAILED,
        actionSubjectId: "proformaFormRenderer",
        attributes: {
            fieldId: fieldId,
            isUnknownRenderer: true
        }
    }));
};

});
parcelRegister("bHVX1", function(module, exports) {
$parcel$export(module.exports, "messages", () => $32c34565e73998d2$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $32c34565e73998d2$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    unknownFieldType: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.unknown-renderer.unknown-field-type',
        description: 'The message to display for an unknown field type, that is unable to be rendered',
        defaultMessage: "We couldn't load this field at this time."
    }
});

});




parcelRegister("5Z1z9", function(module, exports) {
$parcel$export(module.exports, "HtmlRenderer", () => $aefe9428d8bb5cb6$export$58394be84159656);

var $bSJIT = parcelRequire("bSJIT");

var $auxFA = parcelRequire("auxFA");

var $7zCbp = parcelRequire("7zCbp");

var $c6WhP = parcelRequire("c6WhP");

var $9PwDt = parcelRequire("9PwDt");

var $7uUp4 = parcelRequire("7uUp4");
const $aefe9428d8bb5cb6$export$58394be84159656 = ({ fieldId: fieldId, htmlContent: htmlContent })=>{
    try {
        const jiraTransformer = new (0, $7zCbp.JIRATransformer)((0, $auxFA.defaultSchema));
        const adfTransformer = new (0, $c6WhP.JSONTransformer)();
        const pmNode = jiraTransformer.parse(htmlContent);
        const adf = adfTransformer.encode(pmNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.default), {
            key: fieldId,
            document: adf
        });
    } catch (err) {
        // TODO: REQIN-1562 - Add error handling / logging
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
            testId: `proforma-html-renderer-error-${fieldId}`
        });
    }
};

});
parcelRegister("7zCbp", function(module, exports) {
$parcel$export(module.exports, "JIRATransformer", () => $357b435753cb8c1b$export$f47bcfd72ef563cc);

var $OdqB3 = parcelRequire("OdqB3");

var $a4qWY = parcelRequire("a4qWY");

var $ijdfe = parcelRequire("ijdfe");

var $feH0p = parcelRequire("feH0p");

var $kY99u = parcelRequire("kY99u");

var $7zsBy = parcelRequire("7zsBy");

var $4gPF1 = parcelRequire("4gPF1");

var $kW8qW = parcelRequire("kW8qW");

var $7COqY = parcelRequire("7COqY");

var $g0UVH = parcelRequire("g0UVH");

var $45nYW = parcelRequire("45nYW");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $357b435753cb8c1b$var$FRAGMENT_HREF_REGEX = /^#/;
class $357b435753cb8c1b$export$f47bcfd72ef563cc {
    constructor(schema, customEncoders, mediaContextInfo){
        this.schema = schema;
        this.customEncoders = customEncoders || {};
        this.mediaContextInfo = mediaContextInfo;
    }
    encode(node) {
        this.doc = this.makeDocument();
        this.doc.body.appendChild(this.encodeFragment(node.content));
        const html = this.doc.body.innerHTML;
        // JIRA encodes empty documents as an empty string
        if (html === '<p></p>') return '';
        // Normalise to XHTML style self closing tags.
        return html// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<br><\/br>/g, '<br />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<br>/g, '<br />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<hr><\/hr>/g, '<hr />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<hr>/g, '<hr />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/&amp;/g, '&');
    }
    parse(html) {
        const convertedNodes = new WeakMap();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const dom = (0, $7COqY.default)((0, $g0UVH.default)(html)).querySelector('body');
        const nodes = (0, $45nYW.bfsOrder)(dom);
        // JIRA encodes empty content as a single nbsp
        if (nodes.length === 1 && nodes[0].textContent === '\xa0') {
            const schemaNodes = this.schema.nodes;
            return schemaNodes.doc.createChecked({}, schemaNodes.paragraph.createChecked());
        }
        // Process through nodes in reverse (so deepest child elements are first).
        for(let i = nodes.length - 1; i >= 0; i--){
            const node = nodes[i];
            // for tables we take tbody content, because tbody is not in schema so the whole bfs thing wouldn't work
            const targetNode = // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node.tagName && node.tagName.toUpperCase() === 'TABLE' ? node.firstChild : node;
            const content = this.getContent(targetNode, convertedNodes);
            const candidate = (0, $45nYW.convert)(content, node, this.schema);
            if (typeof candidate !== 'undefined') convertedNodes.set(node, candidate);
        }
        const content = this.getContent(dom, convertedNodes);
        // Dangling inline nodes can't be directly inserted into a document, so
        // we attempt to wrap in a paragraph.
        const compatibleContent = this.schema.nodes.doc.validContent(content) ? content : (0, $45nYW.ensureBlocks)(content, this.schema);
        return this.schema.nodes.doc.createChecked({}, compatibleContent);
    }
    /*
   * Contructs a struct string of replacement blocks and marks for a given node
   */ getContent(node, convertedNodes) {
        let fragment = (0, $kW8qW.Fragment).fromArray([]);
        let childIndex;
        for(childIndex = 0; childIndex < node.childNodes.length; childIndex++){
            const child = node.childNodes[childIndex];
            const thing = convertedNodes.get(child);
            if (thing instanceof (0, $kW8qW.Fragment) || thing instanceof (0, $kW8qW.Node)) fragment = fragment.append((0, $kW8qW.Fragment).from(thing));
        }
        return fragment;
    }
    encodeNode(node) {
        const { blockquote: blockquote, bulletList: bulletList, codeBlock: codeBlock, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, emoji: emoji, orderedList: orderedList, paragraph: paragraph, rule: rule, mediaInline: mediaInline, mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media, table: table } = this.schema.nodes;
        // We compare node type names in this method rather than
        // node types directly as the node comparision fails.
        // This suggests the schema which is coming from
        // the doc has been recreated after being passed
        // to this transformer on setup which is somewhat
        // unexpected.
        // This package is internally (within editor) considered
        // "obsolete", and we are aiming to either hand over
        // or deprecate.
        // This "fix" is being done to unblock an existing
        // consumer so they can apply an unrelated security
        // upgrade.
        if (node.isText) return this.encodeText(node);
        else if (node.type.name === heading.name) return this.encodeHeading(node);
        else if (node.type.name === rule.name) return this.encodeHorizontalRule();
        else if (node.type.name === paragraph.name) return this.encodeParagraph(node);
        else if (node.type.name === hardBreak.name) return this.encodeHardBreak();
        if ((0, $feH0p.isSchemaWithLists)(this.schema)) {
            if (node.type.name === bulletList.name) return this.encodeBulletList(node);
            else if (node.type.name === orderedList.name) return this.encodeOrderedList(node);
            else if (node.type.name === listItem.name) return this.encodeListItem(node);
        }
        if ((0, $7zsBy.isSchemaWithMentions)(this.schema) && node.type.name === mention.name) return this.encodeMention(node, this.customEncoders.mention);
        if ((0, $ijdfe.isSchemaWithEmojis)(this.schema) && node.type.name === emoji.name) return this.encodeEmoji(node);
        if ((0, $a4qWY.isSchemaWithCodeBlock)(this.schema) && node.type.name === codeBlock.name) return this.encodeCodeBlock(node);
        if ((0, $OdqB3.isSchemaWithBlockQuotes)(this.schema) && node.type.name === blockquote.name) return this.encodeBlockQuote(node);
        if ((0, $kY99u.isSchemaWithMedia)(this.schema)) {
            if (node.type.name === mediaGroup.name) return this.encodeMediaGroup(node);
            else if (node.type.name === mediaSingle.name) return this.encodeMediaSingle(node);
            else if (node.type.name === media.name || node.type.name === mediaInline.name) return this.encodeMedia(node);
        }
        if ((0, $4gPF1.isSchemaWithTables)(this.schema) && node.type.name === table.name) return this.encodeTable(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throw new Error(`Unexpected node '${node.type.name}' for HTML encoding`);
    }
    makeDocument() {
        const doc = document.implementation.createHTMLDocument('');
        doc.body = doc.createElement('body');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        doc.documentElement.appendChild(doc.body);
        return doc;
    }
    encodeFragment(fragment) {
        const documentFragment = this.doc.createDocumentFragment();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        fragment.forEach((node)=>documentFragment.appendChild(this.encodeNode(node)));
        return documentFragment;
    }
    encodeHeading(node) {
        function anchorNameEncode(name) {
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const noSpaces = name.replace(/ /g, '');
            const uriEncoded = encodeURIComponent(noSpaces);
            const specialsEncoded = uriEncoded.replace(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            /[!'()*]/g, (c)=>'%' + c.charCodeAt(0).toString(16));
            return specialsEncoded;
        }
        const { level: level } = node.attrs;
        // @see ED-4708
        const elem = this.doc.createElement(`h${level === 6 ? 5 : level}`);
        const anchor = this.doc.createElement('a');
        anchor.setAttribute('name', anchorNameEncode(node.textContent));
        elem.appendChild(anchor);
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeParagraph(node) {
        const elem = this.doc.createElement('p');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeText(node) {
        if (node.text) {
            const root = this.doc.createDocumentFragment();
            let elem = root;
            const { code: code, em: em, link: link, typeAheadQuery: typeAheadQuery, strike: strike, strong: strong, subsup: subsup, underline: underline, textColor: textColor } = this.schema.marks;
            for (const mark of node.marks)switch(mark.type){
                case strong:
                    elem = elem.appendChild(this.doc.createElement('b'));
                    break;
                case em:
                    elem = elem.appendChild(this.doc.createElement('em'));
                    break;
                case code:
                    elem = elem.appendChild(this.doc.createElement('tt'));
                    break;
                case strike:
                    elem = elem.appendChild(this.doc.createElement('del'));
                    break;
                case underline:
                    elem = elem.appendChild(this.doc.createElement('ins'));
                    break;
                case subsup:
                    elem = elem.appendChild(this.doc.createElement(mark.attrs['type']));
                    break;
                case link:
                    const linkElem = this.doc.createElement('a');
                    const href = mark.attrs['href'];
                    /** JIRA always expects external-link attribute set on links created via editor unless its #fragment */ if (!href.match($357b435753cb8c1b$var$FRAGMENT_HREF_REGEX)) {
                        linkElem.setAttribute('class', 'external-link');
                        linkElem.setAttribute('rel', 'nofollow');
                    }
                    linkElem.setAttribute('href', href);
                    if (mark.attrs['title']) linkElem.setAttribute('title', mark.attrs['title']);
                    elem = elem.appendChild(linkElem);
                    break;
                case textColor:
                    const fontElem = this.doc.createElement('font');
                    fontElem.setAttribute('color', mark.attrs['color']);
                    elem = elem.appendChild(fontElem);
                    break;
                case typeAheadQuery:
                    break;
                default:
                    throw new Error(`Unable to encode mark '${mark.type.name}'`);
            }
            elem.textContent = node.text;
            return root;
        } else return this.doc.createTextNode('');
    }
    encodeHardBreak() {
        return this.doc.createElement('br');
    }
    encodeHorizontalRule() {
        return this.doc.createElement('hr');
    }
    encodeBulletList(node) {
        const elem = this.doc.createElement('ul');
        elem.setAttribute('class', 'alternate');
        elem.setAttribute('type', 'disc');
        elem.appendChild(this.encodeFragment(node.content));
        for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ul');
        return elem;
    }
    encodeOrderedList(node) {
        const elem = this.doc.createElement('ol');
        elem.appendChild(this.encodeFragment(node.content));
        for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ol');
        return elem;
    }
    encodeListItem(node) {
        const elem = this.doc.createElement('li');
        if (node.content.childCount) {
            let hasBlocks = false;
            node.content.forEach((childNode)=>{
                if (childNode.type === this.schema.nodes.bulletList || childNode.type === this.schema.nodes.orderedList) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const list = this.encodeNode(childNode);
                    /**
           * Changing type for nested list:
           *
           * Second level -> circle
           * Third and deeper -> square
           */ if (list instanceof HTMLElement && list.tagName === 'UL') {
                        list.setAttribute('type', 'circle');
                        [].forEach.call(list.querySelectorAll('ul'), (ul)=>{
                            ul.setAttribute('type', 'square');
                        });
                    }
                    elem.appendChild(list);
                } else if (childNode.type.name === 'paragraph' && !hasBlocks) // Strip the paragraph node from the list item.
                elem.appendChild(this.encodeFragment(childNode.content));
                else {
                    if (childNode.isBlock) hasBlocks = true;
                    elem.appendChild(this.encodeNode(childNode));
                }
            });
        }
        return elem;
    }
    encodeMention(node, encoder) {
        const elem = this.doc.createElement('a');
        elem.setAttribute('class', 'user-hover');
        elem.setAttribute('href', encoder ? encoder(node.attrs.id) : node.attrs.id);
        elem.setAttribute('rel', node.attrs.id);
        elem.appendChild(this.doc.createTextNode(node.attrs.text));
        return elem;
    }
    encodeEmoji(node) {
        return this.doc.createTextNode(node.attrs && node.attrs.text);
    }
    encodeCodeBlock(node) {
        const elem = this.doc.createElement('div');
        elem.setAttribute('class', 'code panel');
        const content = this.doc.createElement('div');
        content.setAttribute('class', 'codeContent panelContent');
        const pre = this.doc.createElement('pre');
        // java is default language for JIRA
        pre.setAttribute('class', `code-${(node.attrs.language || 'plain').toLocaleLowerCase()}`);
        pre.appendChild(this.encodeFragment(node.content));
        content.appendChild(pre);
        elem.appendChild(content);
        return elem;
    }
    encodeBlockQuote(node) {
        const elem = this.doc.createElement('blockquote');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeMediaGroup(node) {
        const elem = this.doc.createElement('p');
        elem.setAttribute('class', 'mediaGroup');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeMediaSingle(node) {
        const elem = this.doc.createElement('p');
        elem.setAttribute('class', 'mediaSingle');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    addDataToNode(domNode, mediaNode, defaultDisplayType = 'thumbnail') {
        const { id: id, type: type, collection: collection, __fileName: __fileName, __displayType: __displayType, width: width, height: height } = mediaNode.attrs;
        // Order of dataset matters in IE Edge, please keep the current order
        domNode.setAttribute('data-attachment-type', __displayType || defaultDisplayType);
        if (__fileName) domNode.setAttribute('data-attachment-name', __fileName);
        if (width) domNode.setAttribute('data-width', width);
        if (height) domNode.setAttribute('data-height', height);
        domNode.setAttribute('data-media-services-type', type);
        domNode.setAttribute('data-media-services-id', id);
        if (collection) domNode.setAttribute('data-media-services-collection', collection);
    }
    buildURLWithContextInfo(fileId, contextInfo) {
        const { clientId: clientId, baseUrl: baseUrl, token: token, collection: collection } = contextInfo;
        return `${baseUrl}/file/${fileId}/image?token=${token}&client=${clientId}&collection=${collection}&width=200&height=200&mode=fit`;
    }
    isImageMimeType(mimeType) {
        return mimeType && mimeType.indexOf('image/') > -1;
    }
    encodeMedia(node) {
        // span.image-wrap > a > jira-attachment-thumbnail > img[data-media-*] > content
        // span.no-br > a[data-media] > content
        const elem = this.doc.createElement('span');
        const a = this.doc.createElement('a');
        if (node.attrs.__displayType === 'file' || !(node.attrs.__displayType || this.isImageMimeType(node.attrs.__fileMimeType))) {
            elem.setAttribute('class', 'nobr');
            this.addDataToNode(a, node, 'file');
            a.textContent = node.attrs.__fileName || '';
        } else {
            elem.setAttribute('class', 'image-wrap');
            const img = this.doc.createElement('img');
            img.setAttribute('alt', node.attrs.__fileName);
            // Newly uploaded items have collection
            if (node.attrs.collection && this.mediaContextInfo && this.mediaContextInfo.uploadContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.uploadContext));
            else if (this.mediaContextInfo && this.mediaContextInfo.viewContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.viewContext));
            this.addDataToNode(img, node);
            const jiraThumb = this.doc.createElement('jira-attachment-thumbnail');
            jiraThumb.appendChild(img);
            a.appendChild(jiraThumb);
        }
        elem.appendChild(a);
        return elem;
    }
    encodeTable(node) {
        const elem = this.doc.createElement('table');
        const tbody = this.doc.createElement('tbody');
        node.descendants((rowNode)=>{
            const rowElement = this.doc.createElement('tr');
            rowNode.descendants((colNode)=>{
                const cellType = colNode.type === this.schema.nodes.tableCell ? 'd' : 'h';
                const cellElement = this.doc.createElement(`t${cellType}`);
                cellElement.setAttribute('class', `confluenceT${cellType}`);
                cellElement.appendChild(this.encodeFragment(colNode.content));
                rowElement.appendChild(cellElement);
                return false;
            });
            tbody.appendChild(rowElement);
            return false;
        });
        elem.appendChild(tbody);
        elem.setAttribute('class', 'confluenceTable');
        return elem;
    }
}

});
parcelRegister("OdqB3", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithBlockQuotes", () => $48eca40a7547116e$export$2761b627be3a2c10);
function $48eca40a7547116e$export$2761b627be3a2c10(schema) {
    return !!schema.nodes.blockquote;
}

});

parcelRegister("a4qWY", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithCodeBlock", () => $e9a87a4e383bd75f$export$24f23e2680c2f593);
function $e9a87a4e383bd75f$export$24f23e2680c2f593(schema) {
    return !!schema.nodes.codeBlock;
}

});

parcelRegister("ijdfe", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithEmojis", () => $7d7e76fbcd10747a$export$85a55ee1ae0815e3);
function $7d7e76fbcd10747a$export$85a55ee1ae0815e3(schema) {
    return !!schema.nodes.emoji;
}

});

parcelRegister("feH0p", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithLists", () => $72f48af299a9a2ed$export$c7b73e631457b93a);
function $72f48af299a9a2ed$export$c7b73e631457b93a(schema) {
    return !!schema.nodes.bulletList;
}

});

parcelRegister("kY99u", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithMedia", () => $220d3a9266a98e12$export$fce37e3087e971dd);
function $220d3a9266a98e12$export$fce37e3087e971dd(schema) {
    return !!schema.nodes.mediaGroup && !!schema.nodes.media && !!schema.nodes.mediaInline;
}

});

parcelRegister("7zsBy", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithMentions", () => $2215d56cda07b173$export$9581c5c4f18e364);
function $2215d56cda07b173$export$9581c5c4f18e364(schema) {
    return !!schema.nodes.mention;
}

});

parcelRegister("4gPF1", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithTables", () => $f6cfc83496494867$export$fff0e9b2ccefb752);
function $f6cfc83496494867$export$fff0e9b2ccefb752(schema) {
    return !!schema.nodes.table && !!schema.nodes.tableCell && !!schema.nodes.tableHeader && !!schema.nodes.tableRow;
}

});

parcelRegister("7COqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f42cea45ce2adf6$export$2e2bcd8739ae039);
function $6f42cea45ce2adf6$var$getNodeName(node) {
    return node && node.nodeName.toUpperCase();
}
function $6f42cea45ce2adf6$var$isMedia(node) {
    if (!node) return false;
    if ($6f42cea45ce2adf6$var$getNodeName(node) === 'SPAN' && node instanceof HTMLElement) return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
    return false;
}
function $6f42cea45ce2adf6$var$repairParagraph(p) {
    const paragraphs = [];
    let buffer = [];
    let mediaGroupFound = false;
    let skipBuffer = false;
    const processMedia = ()=>{
        if (buffer.length) {
            const head = buffer[0];
            if ($6f42cea45ce2adf6$var$getNodeName(head) === 'BR') buffer.shift();
            paragraphs.push(buffer);
            buffer = [];
        }
    };
    for(let i = 0, length = p.childNodes.length; i < length; i++){
        const node = p.childNodes[i];
        skipBuffer = false;
        // [..., M, BR, ...]
        if ($6f42cea45ce2adf6$var$getNodeName(node) === 'BR') {
            // [mmm, M, BR, ...]
            if (mediaGroupFound) {
                processMedia();
                mediaGroupFound = false;
                skipBuffer = true;
            }
            // [..., BR, M, ...]
            if ($6f42cea45ce2adf6$var$isMedia(node.nextSibling)) {
                mediaGroupFound = true;
                if (buffer.length) {
                    paragraphs.push(buffer);
                    buffer = [];
                }
            }
        } else if ($6f42cea45ce2adf6$var$isMedia(node)) // [M, ...]
        {
            if (node.previousSibling === null) mediaGroupFound = true;
        } else if (mediaGroupFound) {
            // Skip white space characters inside media
            if ($6f42cea45ce2adf6$var$getNodeName(node) === '#TEXT' && (node.textContent || '').trim() === '') continue;
            buffer = (paragraphs.pop() || []).concat(buffer);
            mediaGroupFound = false;
        }
        if (!skipBuffer) buffer.push(node);
    }
    if (mediaGroupFound) processMedia();
    else paragraphs.push(buffer);
    if (paragraphs.length > 1) {
        const fragment = document.createDocumentFragment();
        paragraphs.forEach((childP)=>{
            const innerP = document.createElement('p');
            childP.forEach((child)=>innerP.appendChild(child));
            fragment.appendChild(innerP);
        });
        // Replace old P
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const parent = p.parentNode;
        parent.insertBefore(fragment, p.nextSibling);
        // IE11 doesn't support remove
        parent.removeChild(p);
    }
}
function $6f42cea45ce2adf6$export$2e2bcd8739ae039(doc) {
    const paragraphs = doc.querySelectorAll('p');
    for(let i = 0, length = paragraphs.length; i < length; i++)$6f42cea45ce2adf6$var$repairParagraph(paragraphs[i]);
    return doc;
}

});

parcelRegister("g0UVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc19e86b0e21e52d$export$2e2bcd8739ae039);

var $ikseH = parcelRequire("ikseH");
function $bc19e86b0e21e52d$export$2e2bcd8739ae039(fragment) {
    const html = `<!doctype html><html><body>${fragment}</body></html>`;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parser = new window.DOMParser();
    const tree = parser.parseFromString(html, 'text/html');
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ikseH.default)(tree.documentElement, $bc19e86b0e21e52d$var$isBlock);
    return tree;
}
function $bc19e86b0e21e52d$var$isBlock(node) {
    // these blocks are mainly used to collapse whitespace between the blocks
    // (preventing spurious text nodes of ' ')
    switch(node.nodeName.toUpperCase()){
        case 'ADDRESS':
        case 'ARTICLE':
        case 'ASIDE':
        case 'AUDIO':
        case 'BLOCKQUOTE':
        case 'BODY':
        case 'CANVAS':
        case 'CENTER':
        case 'DD':
        case 'DIR':
        case 'DIV':
        case 'DL':
        case 'DT':
        case 'FIELDSET':
        case 'FIGCAPTION':
        case 'FIGURE':
        case 'FOOTER':
        case 'FORM':
        case 'FRAMESET':
        case 'H1':
        case 'H2':
        case 'H3':
        case 'H4':
        case 'H5':
        case 'H6':
        case 'HEADER':
        case 'HGROUP':
        case 'HR':
        case 'HTML':
        case 'ISINDEX':
        case 'LI':
        case 'MAIN':
        case 'MENU':
        case 'NAV':
        case 'NOFRAMES':
        case 'NOSCRIPT':
        case 'OL':
        case 'OUTPUT':
        case 'P':
        case 'PRE':
        case 'SECTION':
        case 'TABLE':
        case 'TBODY':
        case 'TD':
        case 'TFOOT':
        case 'TH':
        case 'THEAD':
        case 'TR':
        case 'UL':
            return true;
    }
    return false;
}

});
parcelRegister("ikseH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea1f7543ac935fac$export$2e2bcd8739ae039);

var $ay6QT = parcelRequire("ay6QT");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea1f7543ac935fac$var$collapseWhitespace = (0, (/*@__PURE__*/$parcel$interopDefault($ay6QT)));
var $ea1f7543ac935fac$export$2e2bcd8739ae039 = $ea1f7543ac935fac$var$collapseWhitespace;

});
parcelRegister("ay6QT", function(module, exports) {
'use strict';

var $8oxfZ = parcelRequire("8oxfZ");
Object.keys($8oxfZ).forEach(function(name) {
    $8oxfZ[name.toUpperCase()] = 1;
});
var $7ae2650f91213946$var$blockElements = {};

(parcelRequire("g2T5v")).forEach(function(name) {
    $7ae2650f91213946$var$blockElements[name.toUpperCase()] = 1;
});
/**
 * isBlockElem(node) determines if the given node is a block element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $7ae2650f91213946$var$isBlockElem(node) {
    return !!(node && $7ae2650f91213946$var$blockElements[node.nodeName]);
}
/**
 * isPreElem(node) determines if the given node is a PRE element.
 * 
 * Whitespace for PRE elements are not collapsed.
 * 
 * @param {Node} node
 * @return {Boolean}
 */ function $7ae2650f91213946$var$isPreElem(node) {
    return node.nodeName === 'PRE';
}
/**
 * isVoid(node) determines if the given node is a void element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $7ae2650f91213946$var$isVoid(node) {
    return !!(node && $8oxfZ[node.nodeName]);
}
/**
 * whitespace(elem [, isBlock]) removes extraneous whitespace from an
 * the given element. The function isBlock may optionally be passed in
 * to determine whether or not an element is a block element; if none
 * is provided, defaults to using the list of block elements provided
 * by the `block-elements` module.
 *
 * @param {Node} elem
 * @param {Function} blockTest
 */ function $7ae2650f91213946$var$collapseWhitespace(elem, isBlock, isPre) {
    if (!elem.firstChild || elem.nodeName === 'PRE') return;
    if (typeof isBlock !== 'function') isBlock = $7ae2650f91213946$var$isBlockElem;
    if (typeof isPre !== 'function') isPre = $7ae2650f91213946$var$isPreElem;
    var prevText = null;
    var prevVoid = false;
    var prev = null;
    var node = $7ae2650f91213946$var$next(prev, elem, isPre);
    while(node !== elem){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !prevVoid && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $7ae2650f91213946$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                prevVoid = false;
            } else if ($7ae2650f91213946$var$isVoid(node)) {
                // Avoid trimming space around non-block, non-BR void elements.
                prevText = null;
                prevVoid = true;
            }
        } else {
            node = $7ae2650f91213946$var$remove(node);
            continue;
        }
        var nextNode = $7ae2650f91213946$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $7ae2650f91213946$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $7ae2650f91213946$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $7ae2650f91213946$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
module.exports = $7ae2650f91213946$var$collapseWhitespace;

});
parcelRegister("8oxfZ", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "keygen": true,
    "link": true,
    "menuitem": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});

parcelRegister("g2T5v", function(module, exports) {
/**
 * This file automatically generated from `build.js`.
 * Do not manually edit.
 */ module.exports = [
    "address",
    "article",
    "aside",
    "blockquote",
    "canvas",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "noscript",
    "ol",
    "output",
    "p",
    "pre",
    "section",
    "table",
    "tfoot",
    "ul",
    "video"
];

});




parcelRegister("45nYW", function(module, exports) {
$parcel$export(module.exports, "ensureBlocks", () => $dbf57785c60ea823$export$c389196451c598e2);
$parcel$export(module.exports, "convert", () => $dbf57785c60ea823$export$9c68d69a4c5bbcf9);
$parcel$export(module.exports, "bfsOrder", () => $dbf57785c60ea823$export$6f3da03763fd5ca0);

var $dlVzJ = parcelRequire("dlVzJ");

var $OdqB3 = parcelRequire("OdqB3");

var $a4qWY = parcelRequire("a4qWY");

var $eZZyQ = parcelRequire("eZZyQ");

var $feH0p = parcelRequire("feH0p");

var $kY99u = parcelRequire("kY99u");

var $7zsBy = parcelRequire("7zsBy");

var $kIzic = parcelRequire("kIzic");

var $4gPF1 = parcelRequire("4gPF1");

var $jCseO = parcelRequire("jCseO");

var $iu0j1 = parcelRequire("iu0j1");

var $kW8qW = parcelRequire("kW8qW");

var $15yEX = parcelRequire("15yEX");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $dbf57785c60ea823$var$WHITESPACE_ONLY_REGEX = /^\s*$/;
function $dbf57785c60ea823$export$c389196451c598e2(fragment, schema, nodeType) {
    // If all the nodes are inline, we want to wrap in a single paragraph.
    if (schema.nodes.paragraph.validContent(fragment)) return (0, $kW8qW.Fragment).fromArray([
        schema.nodes.paragraph.createChecked({}, fragment)
    ]);
    // Either all the nodes are blocks, or a mix of inline and blocks.
    // We convert each (if any) inline nodes to blocks.
    const blockNodes = [];
    // Following if condition has been added as fix for #ED-3431.
    // First child of list-item should be paragraph,
    // if that is not the case paragraph requires to be added.
    if (nodeType && nodeType === schema.nodes.listItem && fragment.firstChild && (fragment.firstChild.type === schema.nodes.bulletList || fragment.firstChild.type === schema.nodes.orderedList)) blockNodes.push(schema.nodes.paragraph.createAndFill());
    fragment.forEach((child)=>{
        if (child.isBlock) blockNodes.push(child);
        else blockNodes.push(schema.nodes.paragraph.createChecked({}, child));
    });
    return (0, $kW8qW.Fragment).fromArray(blockNodes);
}
const $dbf57785c60ea823$export$5cb2cb6b3b363caa = (schema, content, supportedMarks)=>{
    const result = [];
    content.forEach((node)=>{
        if (node.isInline) {
            const filteredMarks = node.marks.filter((mark)=>mark.isInSet(supportedMarks));
            result.push(node.mark(filteredMarks));
            return;
        }
        // We replace an non-inline node with UnsupportedInline node
        result.push(schema.text(node.textContent));
    });
    return (0, $kW8qW.Fragment).fromArray(result);
};
function $dbf57785c60ea823$export$9c68d69a4c5bbcf9(content, node, schema) {
    // text
    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        return text ? schema.text(text) : null;
    }
    // marks and nodes
    if (node instanceof HTMLElement) {
        const tag = node.tagName.toUpperCase();
        switch(tag){
            // Marks
            case 'DEL':
                if (!(0, $dlVzJ.isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.strike.create()
                ]);
            case 'B':
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.strong.create()
                ]);
            case 'EM':
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.em.create()
                ]);
            case 'TT':
                if (!(0, $dlVzJ.isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.code.create()
                ]);
            case 'SUB':
            case 'SUP':
                if (!(0, $kIzic.isSchemaWithSubSupMark)(schema)) return null;
                const type = tag === 'SUB' ? 'sub' : 'sup';
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.subsup.create({
                        type: type
                    })
                ]);
            case 'INS':
                return $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.underline.create()
                ]);
            case 'FONT':
                if (!(0, $jCseO.isSchemaWithTextColor)(schema)) return null;
                const color = (0, $iu0j1.normalizeHexColor)(node.getAttribute('color'), '#333333');
                return color ? $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.textColor.create({
                        color: color
                    })
                ]) : content;
            // Nodes
            case 'A':
                if (node.className === 'user-hover' && (0, $7zsBy.isSchemaWithMentions)(schema)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.mention.createChecked({
                    id: node.getAttribute('rel'),
                    text: node.textContent
                });
                if (node.className.match('jira-issue-macro-key') || !content || !(0, $eZZyQ.isSchemaWithLinks)(schema)) return null;
                const href = node.getAttribute('href');
                const title = node.getAttribute('title');
                return href ? $dbf57785c60ea823$var$addMarks(content, [
                    schema.marks.link.create({
                        href: href,
                        title: title
                    })
                ]) : content;
            case 'SPAN':
                /**
         * JIRA ISSUE MACROS
         * `````````````````
         * <span class="jira-issue-macro" data-jira-key="ED-1">
         *     <a href="https://product-fabric.atlassian.net/browse/ED-1" class="jira-issue-macro-key issue-link">
         *         <img class="icon" src="./epic.svg" />
         *         ED-1
         *     </a>
         *     <span class="aui-lozenge aui-lozenge-subtle aui-lozenge-current jira-macro-single-issue-export-pdf">
         *         In Progress
         *     </span>
         * </span>
         */ if (node.className.split(' ').indexOf('jira-issue-macro') > -1) {
                    const jiraKey = node.getAttribute('data-jira-key');
                    const link = node.getElementsByTagName('a')[0];
                    if (jiraKey && link) return $dbf57785c60ea823$var$addMarks((0, $kW8qW.Fragment).from(schema.text(jiraKey)), [
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        schema.marks.link.create({
                            href: link.getAttribute('href'),
                            title: link.getAttribute('title')
                        })
                    ]);
                    return null;
                } else if (node.className.match('jira-macro-single-issue-export-pdf')) return null;
                else if (node.className.match('code-')) // Removing spans with syntax highlighting from JIRA
                return null;
                else if ($dbf57785c60ea823$var$isMedia(node) && (0, $kY99u.isSchemaWithMedia)(schema)) {
                    const dataNode = node.querySelector('[data-media-services-id]');
                    if (dataNode && dataNode instanceof HTMLElement) {
                        const id = dataNode.getAttribute('data-media-services-id');
                        const type = dataNode.getAttribute('data-media-services-type');
                        const collection = dataNode.getAttribute('data-media-services-collection') || '';
                        const attachmentName = dataNode.getAttribute('data-attachment-name');
                        const attachmentType = dataNode.getAttribute('data-attachment-type');
                        const fileName = dataNode.getAttribute('data-file-name');
                        const displayType = dataNode.getAttribute('data-display-type');
                        const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
                        const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
                        return schema.nodes.media.createChecked({
                            id: id,
                            type: type,
                            collection: collection,
                            width: width || null,
                            height: height || null,
                            __fileName: attachmentName || fileName,
                            __displayType: attachmentType || displayType || 'thumbnail'
                        });
                    }
                }
                break;
            case 'IMG':
                if (node.parentElement && node.parentElement.className.match('jira-issue-macro-key')) return null;
                else if (node.className === 'emoticon') {
                    const emojiResult = (0, $15yEX.mapImageToEmoji)(node);
                    if (emojiResult) return schema.text(emojiResult);
                }
                break;
            case 'H1':
            case 'H2':
            case 'H3':
            case 'H4':
            case 'H5':
            case 'H6':
                const level = Number(tag.charAt(1));
                const supportedMarks = [
                    schema.marks.link
                ].filter((mark)=>!!mark);
                return schema.nodes.heading.createChecked(// @see ED-4708
                {
                    level: level === 6 ? 5 : level
                }, schema.nodes.heading.validContent(content) ? content : // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                $dbf57785c60ea823$export$5cb2cb6b3b363caa(schema, content, supportedMarks));
            case 'BR':
                return schema.nodes.hardBreak.createChecked();
            case 'HR':
                return schema.nodes.rule.createChecked();
            case 'P':
                if (node.firstElementChild && $dbf57785c60ea823$var$isMedia(node.firstElementChild)) {
                    // Filter out whitespace text nodes
                    const { mediaSingle: mediaSingle, mediaGroup: mediaGroup, paragraph: paragraph } = schema.nodes;
                    const mediaArray = [];
                    const contentArray = [];
                    const fragmentArray = [];
                    let hasNonMediaChildren = false;
                    content.forEach((child)=>{
                        if (child.type === schema.nodes.media) {
                            mediaArray.push(child);
                            return;
                        } else if (!(child.isText && $dbf57785c60ea823$var$WHITESPACE_ONLY_REGEX.test(child.text || ''))) hasNonMediaChildren = true;
                        contentArray.push(child);
                    });
                    if (hasNonMediaChildren && contentArray.length) fragmentArray.push(paragraph.createChecked({}, contentArray));
                    if ((0, $kY99u.isSchemaWithMedia)(schema) && mediaArray.length) {
                        const mediaNodeType = $dbf57785c60ea823$var$isMediaSingle(node.firstElementChild) ? mediaSingle : mediaGroup;
                        fragmentArray.push(mediaNodeType.createChecked({}, mediaArray));
                    }
                    if (fragmentArray.length) return (0, $kW8qW.Fragment).fromArray(fragmentArray);
                    return null;
                }
                return schema.nodes.paragraph.createChecked({}, content);
        }
        // lists
        if ((0, $feH0p.isSchemaWithLists)(schema)) switch(tag){
            case 'UL':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.bulletList.createChecked({}, content);
            case 'OL':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.orderedList.createChecked({}, content);
            case 'LI':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const compatibleContent = schema.nodes.listItem.validContent(content) ? content : $dbf57785c60ea823$export$c389196451c598e2(content, schema, schema.nodes.listItem);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.listItem.createChecked({}, compatibleContent);
        }
        // code block
        if ((0, $a4qWY.isSchemaWithCodeBlock)(schema)) switch(tag){
            case 'DIV':
                if (node.className === 'codeContent panelContent' || node.className.match('preformattedContent')) return null;
                else if (node.className === 'code panel' || node.className === 'preformatted panel') {
                    const pre = node.querySelector('pre');
                    if (!pre) return null;
                    const language = node.className === 'preformatted panel' ? 'plain' : pre.className.split('-')[1];
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    const textContent = (pre.textContent || '').replace(/\r\n/g, '\n');
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return schema.nodes.codeBlock.createChecked({
                        language: language
                    }, textContent ? schema.text(textContent) : undefined);
                }
                break;
            case 'PRE':
                return null;
        }
        if ((0, $OdqB3.isSchemaWithBlockQuotes)(schema) && tag === 'BLOCKQUOTE') {
            const blockquoteContent = // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content && content.content.length ? content : schema.nodes.paragraph.createChecked();
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return schema.nodes.blockquote.createChecked({}, blockquoteContent);
        }
        // table
        if ((0, $4gPF1.isSchemaWithTables)(schema)) switch(tag){
            case 'TABLE':
                return schema.nodes.table.createChecked({}, content);
            case 'TR':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.tableRow.createChecked({}, content);
            case 'TD':
                const tdContent = schema.nodes.tableCell.validContent(content) ? content : $dbf57785c60ea823$export$c389196451c598e2(content, schema);
                return schema.nodes.tableCell.createChecked({}, tdContent);
            case 'TH':
                const thContent = schema.nodes.tableHeader.validContent(content) ? content : $dbf57785c60ea823$export$c389196451c598e2(content, schema);
                return schema.nodes.tableHeader.createChecked({}, thContent);
        }
    }
    return;
}
function $dbf57785c60ea823$export$6f3da03763fd5ca0(root) {
    const inqueue = [
        root
    ];
    const outqueue = [];
    let elem;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(elem = inqueue.shift()){
        outqueue.push(elem);
        let childIndex;
        for(childIndex = 0; childIndex < elem.childNodes.length; childIndex++){
            const child = elem.childNodes[childIndex];
            switch(child.nodeType){
                case Node.ELEMENT_NODE:
                case Node.TEXT_NODE:
                    inqueue.push(child);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error(`Not pushing: ${child.nodeType} ${child.nodeName}`);
            }
        }
    }
    outqueue.shift();
    return outqueue;
}
/**
 * Create a fragment by adding a set of marks to each node.
 */ function $dbf57785c60ea823$var$addMarks(fragment, marks) {
    let result = fragment;
    for(let i = 0; i < fragment.childCount; i++){
        const child = result.child(i);
        let newChild = child;
        for (const mark of marks)newChild = newChild.mark(mark.addToSet(newChild.marks));
        result = result.replaceChild(i, newChild);
    }
    return result;
}
function $dbf57785c60ea823$var$getNodeName(node) {
    return node.nodeName.toUpperCase();
}
function $dbf57785c60ea823$var$isMedia(node) {
    if (node && node instanceof HTMLElement) {
        if (node.parentNode && $dbf57785c60ea823$var$getNodeName(node.parentNode) === 'P') {
            if ($dbf57785c60ea823$var$getNodeName(node) === 'SPAN') return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
        }
    }
    return false;
}
function $dbf57785c60ea823$var$isMediaSingle(node) {
    if ($dbf57785c60ea823$var$isMedia(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dataNode = node.querySelector('[data-media-services-id]');
        if (dataNode instanceof HTMLElement) {
            const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
            const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (node.parentNode.classList.contains('mediaSingle') && width && height) return true;
        }
    }
    return false;
}

});
parcelRegister("dlVzJ", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithAdvancedTextFormattingMarks", () => $7f44244e9380018b$export$6b152f895f3f2d6a);
function $7f44244e9380018b$export$6b152f895f3f2d6a(schema) {
    return !!schema.marks.code && !!schema.marks.strike;
}

});

parcelRegister("eZZyQ", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithLinks", () => $2571108ef497dcba$export$be604d30ea08e34c);
function $2571108ef497dcba$export$be604d30ea08e34c(schema) {
    return !!schema.marks.link;
}

});

parcelRegister("kIzic", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithSubSupMark", () => $7d30130163855d03$export$b7fbc21a18ab46d0);
function $7d30130163855d03$export$b7fbc21a18ab46d0(schema) {
    return !!schema.marks.subsup;
}

});

parcelRegister("jCseO", function(module, exports) {
$parcel$export(module.exports, "isSchemaWithTextColor", () => $aaab69919faf3507$export$6bc3d8bd3aad229);
function $aaab69919faf3507$export$6bc3d8bd3aad229(schema) {
    return !!schema.marks.textColor;
}

});

parcelRegister("15yEX", function(module, exports) {
$parcel$export(module.exports, "mapImageToEmoji", () => $a965014ad0e838a2$export$f0d20a903b124435);
const $a965014ad0e838a2$var$emojiMap = {
    'smile.png': "\uD83D\uDE42",
    'sad.png': "\u2639\uFE0F",
    'tongue.png': "\uD83D\uDE1B",
    'biggrin.png': "\uD83D\uDE01",
    'wink.png': "\uD83D\uDE09",
    'thumbs_up.png': "\uD83D\uDC4D",
    'thumbs_down.png': "\uD83D\uDC4E",
    'information.png': "\u2139\uFE0F",
    'check.png': "\u2705",
    'error.png': "\u274C",
    'warning.png': "\u26A0\uFE0F",
    'add.png': "\u2795",
    'forbidden.png': "\u2796",
    'help_16.png': "\u2753",
    'lightbulb_on.png': "\uD83D\uDCA1",
    'lightbulb.png': "\u26D4\uFE0F",
    'star_yellow.png': "\uD83D\uDC9B",
    'star_red.png': "\u2764\uFE0F",
    'star_green.png': "\uD83D\uDC9A",
    'star_blue.png': "\uD83D\uDC99",
    'flag.png': "\uD83D\uDEA9",
    'flag_gray.png': "\uD83C\uDFF3"
};
function $a965014ad0e838a2$export$f0d20a903b124435(imageElement) {
    let src = imageElement.src;
    const slashIndex = src.lastIndexOf('/');
    src = src.substr(slashIndex + 1);
    return $a965014ad0e838a2$var$emojiMap[src] || null;
}

});




parcelRegister("bN32a", function(module, exports) {
$parcel$export(module.exports, "messages", () => $684e04a31f2da608$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $684e04a31f2da608$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    extensionError: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.extension-error',
        description: 'Error message to display when a form extension is missing its ID',
        defaultMessage: 'We are unable to render this extension at this time. Please remove the extension from the form and try again.'
    }
});

});


parcelRegister("mA3R1", function(module, exports) {
$parcel$export(module.exports, "rendererEventHandlers", () => $d0166327b765be71$export$7099af1d0eb30f39);
const $d0166327b765be71$export$7099af1d0eb30f39 = {
    link: {
        onClick: (event, url)=>{
            var _window;
            // Intercept link event and open in another window stripping any opener or referrer info
            event.preventDefault();
            (_window = window) === null || _window === void 0 || _window.open(url, '_blank', 'noopener noreferrer');
        }
    }
};

});


parcelRegister("j8FrW", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b60d521ea4850387$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $b60d521ea4850387$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    hiddenSectionTitle: {
        id: 'proforma-form-renderer.ui.form-renderer.form-sections.hidden-section-title',
        description: 'Title to display at the top of a hidden section being displayed for preview',
        defaultMessage: 'Hidden section'
    }
});

});



parcelRegister("dS4H4", function(module, exports) {
$parcel$export(module.exports, "FormVisibility", () => $f5777104d5166828$export$c501a2032cd34718);
$parcel$export(module.exports, "FormStatus", () => $f5777104d5166828$export$fc8a1cc6d4fd1a88);
$parcel$export(module.exports, "FormConditionType", () => $f5777104d5166828$export$943ba666dd740a86);
$parcel$export(module.exports, "FormQuestionType", () => $f5777104d5166828$export$5fcf8ca5ea137df2);
var $f5777104d5166828$export$c501a2032cd34718 = /*#__PURE__*/ function(FormVisibility) {
    /**
   * Internal form: in the context of Jira Service Desk this means the form only appears inside Jira and not on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */ FormVisibility["Internal"] = "i";
    /**
   * External form: in the context of Jira Service Desk this means the form appears both in Jira and on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */ FormVisibility["External"] = "e";
    return FormVisibility;
}({});
var $f5777104d5166828$export$fc8a1cc6d4fd1a88 = /*#__PURE__*/ function(FormStatus) {
    FormStatus["Open"] = "o";
    FormStatus["Submitted"] = "s";
    FormStatus["Locked"] = "l";
    return FormStatus;
}({});
var $f5777104d5166828$export$943ba666dd740a86 = /*#__PURE__*/ function(FormConditionType) {
    FormConditionType["Show"] = "sh";
    FormConditionType["Hide"] = "hide";
    return FormConditionType;
}({});
var $f5777104d5166828$export$d636d1a763e6b20b = /*#__PURE__*/ function(FormSectionType) {
    FormSectionType["Block"] = "b";
    FormSectionType["Page"] = "p";
    return FormSectionType;
}({});
var $f5777104d5166828$export$5fcf8ca5ea137df2 = /*#__PURE__*/ function(FormQuestionType) {
    FormQuestionType["Attachment"] = "at";
    FormQuestionType["ChoiceCascading"] = "cc";
    FormQuestionType["ChoiceDropdown"] = "cd";
    FormQuestionType["ChoiceDropdownMultiple"] = "cl";
    FormQuestionType["ChoiceMultiple"] = "cm";
    FormQuestionType["ChoiceSingle"] = "cs";
    FormQuestionType["CmdbObject"] = "ob";
    FormQuestionType["Date"] = "da";
    FormQuestionType["DateTime"] = "dt";
    FormQuestionType["Number"] = "no";
    FormQuestionType["TextEmail"] = "te";
    FormQuestionType["TextLong"] = "tl";
    FormQuestionType["TextParagraph"] = "pg";
    FormQuestionType["RichTextParagraph"] = "rt";
    FormQuestionType["TextShort"] = "ts";
    FormQuestionType["TextUrl"] = "tu";
    FormQuestionType["Time"] = "ti";
    FormQuestionType["UserMultiple"] = "um";
    FormQuestionType["UserSingle"] = "us";
    FormQuestionType["Rating"] = "rg";
    FormQuestionType["Scale"] = "sc";
    return FormQuestionType;
}({});
const $f5777104d5166828$export$a22d71169ecf2be0 = {
    OPEN: 'open',
    RESTRICTED: 'restricted'
};

});

parcelRegister("9syXG", function(module, exports) {
$parcel$export(module.exports, "convertJiraFieldErrors", () => $a9cdc526f8eeb222$export$489b0c421a9c9605);
$parcel$export(module.exports, "convertToForm", () => $a9cdc526f8eeb222$export$23734165291ce4d3);
$parcel$export(module.exports, "convertValuesToFormAnswers", () => $a9cdc526f8eeb222$export$a8c04934ee6b8f88);

var $84Typ = parcelRequire("84Typ");

var $hsGKE = parcelRequire("hsGKE");

var $f8jmM = parcelRequire("f8jmM");

var $6SWKu = parcelRequire("6SWKu");
const $a9cdc526f8eeb222$export$489b0c421a9c9605 = (form, jiraFieldErrors)=>{
    const jiraFieldKeyMap = Object.entries(form.design.questions).reduce((jiraFieldKeys, [fieldId, field])=>{
        if (field.jiraField) return jiraFieldKeys.set(field.jiraField, fieldId);
        return jiraFieldKeys;
    }, new Map());
    return Object.entries(jiraFieldErrors).reduce((formFieldErrors, [jiraFieldKey, jiraFieldError])=>{
        const fieldId = jiraFieldKeyMap.get(jiraFieldKey);
        if (fieldId !== undefined) return {
            ...formFieldErrors,
            [fieldId]: jiraFieldError
        };
        return formFieldErrors;
    }, {});
};
const $a9cdc526f8eeb222$export$23734165291ce4d3 = (form, fieldData, formChoices, shouldApplyDefaultValues)=>{
    var _form$state, _form$state2, _form$id;
    const fields = (0, $f8jmM.convertQuestions)(form.design.questions, (_form$state = form.state) === null || _form$state === void 0 ? void 0 : _form$state.answers, (_form$state2 = form.state) === null || _form$state2 === void 0 ? void 0 : _form$state2.status, fieldData, formChoices, shouldApplyDefaultValues);
    const sections = (0, $6SWKu.convertSections)(form.design.sections, form.design.layout, form.design.conditions);
    const id = form.uuid || ((_form$id = form.id) === null || _form$id === void 0 ? void 0 : _form$id.toString()) || '';
    return {
        fields: fields,
        sections: sections,
        id: id
    };
};
const $a9cdc526f8eeb222$export$180605366c04f0cd = (form)=>form.design.settings.translatedLocale ?? form.design.settings.primaryLocale ?? (0, $84Typ.DEFAULT_LOCALE);
const $a9cdc526f8eeb222$export$5fd35827241c56e2 = (fieldValues, formQuestions)=>Object.entries(formQuestions).reduce((answers, [fieldId, formQuestion])=>({
            ...answers,
            [fieldId]: (0, $hsGKE.convertFieldValue)(fieldValues[fieldId], formQuestion)
        }), {});
const $a9cdc526f8eeb222$export$a8c04934ee6b8f88 = (fieldValues, formQuestions)=>Object.entries(formQuestions).reduce((answers, [fieldId, formQuestion])=>({
            ...answers,
            [fieldId]: (0, $hsGKE.convertFieldValue)(fieldValues[fieldId], formQuestion)
        }), {});

});
parcelRegister("hsGKE", function(module, exports) {
$parcel$export(module.exports, "convertFieldValue", () => $b98664db7f7ef0c9$export$cf100ecab738e7b1);

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $dS4H4 = parcelRequire("dS4H4");
const $b98664db7f7ef0c9$export$cf100ecab738e7b1 = (fieldValue, formQuestion)=>{
    switch(formQuestion.type){
        case (0, $dS4H4.FormQuestionType).ChoiceCascading:
        case (0, $dS4H4.FormQuestionType).CmdbObject:
        case (0, $dS4H4.FormQuestionType).ChoiceSingle:
        case (0, $dS4H4.FormQuestionType).ChoiceMultiple:
        case (0, $dS4H4.FormQuestionType).ChoiceDropdown:
        case (0, $dS4H4.FormQuestionType).ChoiceDropdownMultiple:
            {
                var _optionsWithOther$opt;
                const optionsWithOther = (0, $i86qj.asOptionsValue)(fieldValue);
                return {
                    choices: [
                        ...(optionsWithOther === null || optionsWithOther === void 0 || (_optionsWithOther$opt = optionsWithOther.options) === null || _optionsWithOther$opt === void 0 ? void 0 : _optionsWithOther$opt.map((option)=>option.id)) || [],
                        ...(optionsWithOther === null || optionsWithOther === void 0 ? void 0 : optionsWithOther.otherOptionText) !== undefined ? [
                            (0, $gjxgd.OTHER_ID)
                        ] : []
                    ],
                    ...(optionsWithOther === null || optionsWithOther === void 0 ? void 0 : optionsWithOther.otherOptionText) !== undefined ? {
                        text: optionsWithOther.otherOptionText
                    } : {}
                };
            }
        case (0, $dS4H4.FormQuestionType).Date:
            {
                const dateValue = (0, $i86qj.asDateValue)(fieldValue);
                return {
                    date: dateValue === null || dateValue === void 0 ? void 0 : dateValue.date
                };
            }
        case (0, $dS4H4.FormQuestionType).DateTime:
            {
                const dateTimeValue = (0, $i86qj.asDateTimeValue)(fieldValue);
                return {
                    date: dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.date,
                    time: dateTimeValue === null || dateTimeValue === void 0 ? void 0 : dateTimeValue.localTime
                };
            }
        case (0, $dS4H4.FormQuestionType).Time:
            {
                const timeValue = (0, $i86qj.asLocalTimeValue)(fieldValue);
                return {
                    time: timeValue === null || timeValue === void 0 ? void 0 : timeValue.localTime
                };
            }
        case (0, $dS4H4.FormQuestionType).Number:
            {
                var _numberValue$number;
                const numberValue = (0, $i86qj.asNumberValue)(fieldValue);
                return {
                    text: (numberValue === null || numberValue === void 0 || (_numberValue$number = numberValue.number) === null || _numberValue$number === void 0 ? void 0 : _numberValue$number.toString()) || ''
                };
            }
        case (0, $dS4H4.FormQuestionType).UserMultiple:
        case (0, $dS4H4.FormQuestionType).UserSingle:
            {
                var _userValue$options;
                const userValue = (0, $i86qj.asOptionsValue)(fieldValue);
                return {
                    users: (userValue === null || userValue === void 0 || (_userValue$options = userValue.options) === null || _userValue$options === void 0 ? void 0 : _userValue$options.map((option)=>({
                            name: option.label,
                            id: option.id
                        }))) || []
                };
            }
        case (0, $dS4H4.FormQuestionType).TextEmail:
        case (0, $dS4H4.FormQuestionType).TextLong:
        case (0, $dS4H4.FormQuestionType).TextParagraph:
        case (0, $dS4H4.FormQuestionType).TextShort:
        case (0, $dS4H4.FormQuestionType).TextUrl:
            {
                const textValue = (0, $i86qj.asTextValue)(fieldValue);
                return {
                    text: (textValue === null || textValue === void 0 ? void 0 : textValue.text) || ''
                };
            }
        case (0, $dS4H4.FormQuestionType).RichTextParagraph:
            {
                const richTextValue = (0, $i86qj.asAdfValue)(fieldValue);
                return {
                    adf: (richTextValue === null || richTextValue === void 0 ? void 0 : richTextValue.adf) || (0, $gjxgd.EMPTY_ADF)
                };
            }
        case (0, $dS4H4.FormQuestionType).Attachment:
            {
                var _filesValue$files;
                const filesValue = (0, $i86qj.asFilesValue)(fieldValue);
                return {
                    files: (filesValue === null || filesValue === void 0 || (_filesValue$files = filesValue.files) === null || _filesValue$files === void 0 ? void 0 : _filesValue$files.map((file)=>({
                            id: file.identifier.id,
                            name: file.name
                        }))) || []
                };
            }
        default:
            return {};
    }
};

});

parcelRegister("f8jmM", function(module, exports) {
$parcel$export(module.exports, "convertQuestions", () => $b263352833efdf75$export$8646fe19de4fc7c9);

var $ayBHA = parcelRequire("ayBHA");
const $b263352833efdf75$export$8646fe19de4fc7c9 = (questions, answers, formStatus, fieldData, formChoices, shouldApplyDefaultValues)=>{
    const fieldEntries = Object.entries(questions).map(([questionId, question])=>[
            questionId,
            (0, $ayBHA.convertQuestion)(question, answers === null || answers === void 0 ? void 0 : answers[questionId], formStatus, fieldData, formChoices, shouldApplyDefaultValues)
        ]);
    return Object.fromEntries(fieldEntries);
};

});
parcelRegister("ayBHA", function(module, exports) {
$parcel$export(module.exports, "convertQuestion", () => $d57ffacd3f3eda9c$export$fee5475e71f81b10);
/* eslint-disable max-lines */ 
var $2nfpZ = parcelRequire("2nfpZ");

var $7fzgl = parcelRequire("7fzgl");

var $imRM2 = parcelRequire("imRM2");

var $dS4H4 = parcelRequire("dS4H4");

var $59Vzn = parcelRequire("59Vzn");
const $d57ffacd3f3eda9c$export$fee5475e71f81b10 = (question, formAnswer, formStatus, apiFieldData, apiFormChoices, shouldApplyDefaultValues)=>{
    const commonFieldProperties = {
        label: question.label,
        ...question.description && {
            helperMessage: question.description
        },
        validation: (0, $59Vzn.convertValidation)(question, question.jiraField ? apiFieldData === null || apiFieldData === void 0 ? void 0 : apiFieldData[question.jiraField] : undefined, apiFormChoices)
    };
    const isFormLockedOrSubmitted = formStatus === (0, $dS4H4.FormStatus).Locked || formStatus === (0, $dS4H4.FormStatus).Submitted;
    const fieldConfiguration = question.jiraField ? apiFieldData === null || apiFieldData === void 0 ? void 0 : apiFieldData[question.jiraField] : undefined;
    // In a submitted (or locked) form, for fields that are linked to Jira fields, we don't want to use the linked Jira
    // field's value, but rather from the stored field values in the submitted form itself.
    const fieldData = isFormLockedOrSubmitted ? undefined : fieldConfiguration;
    switch(question.type){
        case (0, $dS4H4.FormQuestionType).Attachment:
            return {
                type: (0, $2nfpZ.FormFieldType).ATTACHMENT,
                ...commonFieldProperties,
                ...(formAnswer === null || formAnswer === void 0 ? void 0 : formAnswer.files) && {
                    value: (0, $7fzgl.getAttachmentValue)(formAnswer.files)
                }
            };
        case (0, $dS4H4.FormQuestionType).ChoiceCascading:
        case (0, $dS4H4.FormQuestionType).ChoiceDropdown:
        case (0, $dS4H4.FormQuestionType).ChoiceDropdownMultiple:
        case (0, $dS4H4.FormQuestionType).ChoiceMultiple:
        case (0, $dS4H4.FormQuestionType).ChoiceSingle:
            {
                var _question$choices, _question$choices2, _question$defaultAnsw, _question$defaultAnsw2;
                const type = question.type === (0, $dS4H4.FormQuestionType).ChoiceCascading ? (0, $2nfpZ.FormFieldType).CASCADING_SELECT : question.type === (0, $dS4H4.FormQuestionType).ChoiceDropdown ? (0, $2nfpZ.FormFieldType).SINGLE_SELECT : question.type === (0, $dS4H4.FormQuestionType).ChoiceDropdownMultiple ? (0, $2nfpZ.FormFieldType).MULTIPLE_SELECT : question.type === (0, $dS4H4.FormQuestionType).ChoiceMultiple ? (0, $2nfpZ.FormFieldType).CHECKBOX : (0, $2nfpZ.FormFieldType).RADIO;
                // When apiFormChoices is loaded, linkedChoices contains live choices from the API. When not
                // loaded (e.g. portal-view submitted forms), linkedChoices is undefined, falling back to question.choices.
                const linkedChoices = (0, $imRM2.getLinkedChoices)(question, apiFormChoices);
                const options = linkedChoices ? linkedChoices.map((choice)=>(0, $imRM2.convertFormChoice)(choice)) : ((_question$choices = question.choices) === null || _question$choices === void 0 ? void 0 : _question$choices.filter((choice)=>!choice.other).map((choice)=>(0, $imRM2.convertFormChoice)(choice))) || [];
                const hasOtherOption = ((_question$choices2 = question.choices) === null || _question$choices2 === void 0 ? void 0 : _question$choices2.some((choice)=>choice.other)) || false;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw = question.defaultAnswer) !== null && _question$defaultAnsw !== void 0 && _question$defaultAnsw.choices ? (0, $imRM2.getChoiceValue)(question.defaultAnswer.choices, hasOtherOption, question, type, linkedChoices, ((_question$defaultAnsw2 = question.defaultAnswer) === null || _question$defaultAnsw2 === void 0 ? void 0 : _question$defaultAnsw2.text) || undefined) : fieldData ? {
                    // fieldData contains all the choices in the correct format
                    options: fieldData.value.choices || []
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.choices ? (0, $imRM2.getChoiceValue)(formAnswer.choices, hasOtherOption, question, type, // In a submitted (or locked) form, for choice fields (except CMDB fields) that are
                // linked to Jira fields we don't want to get the choice value from the linked Jira
                // field's choice list, but rather from the stored choice list in the submitted
                // form itself.
                // - com.thinktilt.proforma.core.helper.FormTransform.withJiraFieldValues
                // - com.thinktilt.proforma.core.helper.FormTransform.withDataConnectionItems
                // Known caveat:
                // For submitted (or locked) forms in issue-view, to resolve bugs REQIN-1186,
                // JSDCLOUD-13569, and JSDCLOUD-13705, apiFormChoices are loaded with `allowSubmittedForm=true` and displayed instead,
                // meaning live choices from Jira are shown even in submitted state.
                isFormLockedOrSubmitted ? undefined : linkedChoices, formAnswer.text || undefined) : undefined;
                return {
                    type: type,
                    ...commonFieldProperties,
                    ...hasOtherOption && {
                        hasOtherOption: true
                    },
                    options: options,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).Rating:
            {
                var _question$defaultAnsw3;
                const options = (question.choices ?? []).filter((choice)=>!choice.other).map((choice)=>(0, $imRM2.convertFormChoice)(choice));
                const value = shouldApplyDefaultValues && (_question$defaultAnsw3 = question.defaultAnswer) !== null && _question$defaultAnsw3 !== void 0 && _question$defaultAnsw3.text ? {
                    number: Number(question.defaultAnswer.text)
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.text ? {
                    number: Number(fieldData.value.text)
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.text ? {
                    number: Number(formAnswer.text)
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).RATING,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    },
                    options: options
                };
            }
        case (0, $dS4H4.FormQuestionType).Scale:
            {
                var _question$defaultAnsw4;
                const options = (question.choices ?? []).filter((choice)=>!choice.other).map((choice)=>(0, $imRM2.convertFormChoice)(choice));
                const value = shouldApplyDefaultValues && (_question$defaultAnsw4 = question.defaultAnswer) !== null && _question$defaultAnsw4 !== void 0 && _question$defaultAnsw4.text ? {
                    number: Number(question.defaultAnswer.text)
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.text ? {
                    number: Number(fieldData.value.text)
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.text ? {
                    number: Number(formAnswer.text)
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).SCALE,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    },
                    options: options
                };
            }
        case (0, $dS4H4.FormQuestionType).CmdbObject:
            {
                const type = fieldConfiguration !== null && fieldConfiguration !== void 0 && fieldConfiguration.multiple ? (0, $2nfpZ.FormFieldType).MULTIPLE_SELECT : (0, $2nfpZ.FormFieldType).SINGLE_SELECT;
                let value;
                if (isFormLockedOrSubmitted) value = (formAnswer === null || formAnswer === void 0 ? void 0 : formAnswer.choices) && (0, $imRM2.getChoiceValue)(formAnswer.choices, false, question, type, // In a submitted (or locked) form, for CMDB fields, we don't want to get the choice value from
                // the linked Jira CMDB field's choice list, but rather from the stored choice list in the
                // submitted form itself.
                undefined, undefined);
                else value = (fieldData === null || fieldData === void 0 ? void 0 : fieldData.value.choices) && {
                    options: fieldData.value.choices
                };
                return {
                    type: type,
                    ...commonFieldProperties,
                    options: [],
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).Date:
            {
                var _question$defaultAnsw5;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw5 = question.defaultAnswer) !== null && _question$defaultAnsw5 !== void 0 && _question$defaultAnsw5.date ? {
                    date: question.defaultAnswer.date
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.date ? {
                    date: fieldData.value.date
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.date ? {
                    date: formAnswer.date
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).DATE,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).DateTime:
            {
                var _question$defaultAnsw6, _question$defaultAnsw7, _fieldData$value$time;
                const value = shouldApplyDefaultValues && ((_question$defaultAnsw6 = question.defaultAnswer) !== null && _question$defaultAnsw6 !== void 0 && _question$defaultAnsw6.date || (_question$defaultAnsw7 = question.defaultAnswer) !== null && _question$defaultAnsw7 !== void 0 && _question$defaultAnsw7.time) ? {
                    date: question.defaultAnswer.date || undefined,
                    localTime: question.defaultAnswer.time || undefined
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.date || fieldData !== null && fieldData !== void 0 && fieldData.value.time ? {
                    date: fieldData.value.date || undefined,
                    localTime: (_fieldData$value$time = fieldData.value.time) !== null && _fieldData$value$time !== void 0 && _fieldData$value$time.match(/^\d+:\d+:\d+$/) ? fieldData.value.time.replace(/:\d+$/, '') : fieldData.value.time
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.date || formAnswer !== null && formAnswer !== void 0 && formAnswer.time ? {
                    date: formAnswer.date || undefined,
                    localTime: formAnswer.time || undefined
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).DATE_TIME,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).Time:
            {
                var _question$defaultAnsw8;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw8 = question.defaultAnswer) !== null && _question$defaultAnsw8 !== void 0 && _question$defaultAnsw8.time ? {
                    localTime: question.defaultAnswer.time
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.time ? {
                    localTime: fieldData.value.time.match(/^\d+:\d+:\d+$/) ? fieldData.value.time.replace(/:\d+$/, '') : fieldData.value.time
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.time ? {
                    localTime: formAnswer.time
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).LOCAL_TIME,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).Number:
            {
                var _question$defaultAnsw9;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw9 = question.defaultAnswer) !== null && _question$defaultAnsw9 !== void 0 && _question$defaultAnsw9.text ? {
                    number: Number(question.defaultAnswer.text)
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.text ? {
                    number: Number(fieldData.value.text)
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.text ? {
                    number: Number(formAnswer.text)
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).NUMBER,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).RichTextParagraph:
            {
                var _question$defaultAnsw0;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw0 = question.defaultAnswer) !== null && _question$defaultAnsw0 !== void 0 && _question$defaultAnsw0.adf ? {
                    adf: question.defaultAnswer.adf
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.adf ? {
                    adf: fieldData.value.adf
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.adf ? {
                    adf: formAnswer.adf
                } : undefined;
                return {
                    type: (0, $2nfpZ.FormFieldType).RICH_TEXT_PARAGRAPH,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).UserMultiple:
        case (0, $dS4H4.FormQuestionType).UserSingle:
            {
                const value = fieldData !== null && fieldData !== void 0 && fieldData.value.users ? (0, $imRM2.getUserChoiceValue)(fieldData.value.users) : formAnswer !== null && formAnswer !== void 0 && formAnswer.users ? (0, $imRM2.getUserChoiceValue)(formAnswer.users) : undefined;
                return {
                    type: question.type === (0, $dS4H4.FormQuestionType).UserMultiple ? (0, $2nfpZ.FormFieldType).MULTIPLE_SELECT : (0, $2nfpZ.FormFieldType).SINGLE_SELECT,
                    ...commonFieldProperties,
                    options: [],
                    ...value && {
                        value: value
                    }
                };
            }
        case (0, $dS4H4.FormQuestionType).TextEmail:
        case (0, $dS4H4.FormQuestionType).TextLong:
        case (0, $dS4H4.FormQuestionType).TextParagraph:
        case (0, $dS4H4.FormQuestionType).TextShort:
        case (0, $dS4H4.FormQuestionType).TextUrl:
        default:
            {
                var _question$defaultAnsw1;
                const type = question.type === (0, $dS4H4.FormQuestionType).TextEmail ? (0, $2nfpZ.FormFieldType).EMAIL : question.type === (0, $dS4H4.FormQuestionType).TextParagraph ? (0, $2nfpZ.FormFieldType).PARAGRAPH : question.type === (0, $dS4H4.FormQuestionType).TextShort ? (0, $2nfpZ.FormFieldType).SHORT_TEXT : question.type === (0, $dS4H4.FormQuestionType).TextUrl ? (0, $2nfpZ.FormFieldType).URL : // question.type === FormQuestionType.TextLong || `default`
                (0, $2nfpZ.FormFieldType).LONG_TEXT;
                const value = shouldApplyDefaultValues && (_question$defaultAnsw1 = question.defaultAnswer) !== null && _question$defaultAnsw1 !== void 0 && _question$defaultAnsw1.text ? {
                    text: question.defaultAnswer.text
                } : fieldData !== null && fieldData !== void 0 && fieldData.value.text ? {
                    text: fieldData.value.text
                } : formAnswer !== null && formAnswer !== void 0 && formAnswer.text ? {
                    text: formAnswer.text
                } : undefined;
                return {
                    type: type,
                    ...commonFieldProperties,
                    ...value && {
                        value: value
                    }
                };
            }
    }
};

});
parcelRegister("7fzgl", function(module, exports) {
$parcel$export(module.exports, "getAttachmentValue", () => $d6162cfb8d3b1961$export$70d7f96a9435c11e);
const $d6162cfb8d3b1961$export$70d7f96a9435c11e = (files)=>{
    if (files === null) return undefined;
    // NOTE: Only ID and name are defined when we initially load a ProformaForm so we can only set
    // default values for the other properties. The other values are not stored in the Proforma form.
    return {
        files: files.map((file)=>({
                creationDate: 0,
                identifier: {
                    id: file.id,
                    mediaItemType: 'file'
                },
                name: file.name ?? '',
                size: 0,
                type: 'file'
            }))
    };
};

});

parcelRegister("imRM2", function(module, exports) {
$parcel$export(module.exports, "convertFormChoice", () => $9b0376f6a58bcaa1$export$36a44e5b0157c093);
$parcel$export(module.exports, "findChoice", () => $9b0376f6a58bcaa1$export$956bffec5f1ea36e);
$parcel$export(module.exports, "getLinkedChoices", () => $9b0376f6a58bcaa1$export$c787a65b0b5f96bc);
$parcel$export(module.exports, "getChoiceValue", () => $9b0376f6a58bcaa1$export$a1a16a8e3e6a4e37);
$parcel$export(module.exports, "getUserChoiceValue", () => $9b0376f6a58bcaa1$export$6a9570661353ef6f);

var $2nfpZ = parcelRequire("2nfpZ");

var $gjxgd = parcelRequire("gjxgd");
const $9b0376f6a58bcaa1$export$36a44e5b0157c093 = (choice)=>({
        id: choice.id,
        label: choice.label,
        ...choice.children && {
            children: choice.children.map((child)=>$9b0376f6a58bcaa1$export$36a44e5b0157c093(child))
        }
    });
const $9b0376f6a58bcaa1$export$956bffec5f1ea36e = (choices, choiceId, isCascading)=>{
    var _choices$find;
    // some Jira fields (non-cascading) have ID with colon in it as well
    if (isCascading && choiceId.includes(':')) {
        var _parent$children;
        const [parentId, childId] = choiceId.split(':');
        const parent = choices.find((c)=>c.id === parentId);
        const child = parent === null || parent === void 0 || (_parent$children = parent.children) === null || _parent$children === void 0 ? void 0 : _parent$children.find((c)=>c.id === childId);
        return child ? {
            id: choiceId,
            label: `${(parent === null || parent === void 0 ? void 0 : parent.label) || parentId} - ${child.label}`
        } : {
            id: parentId,
            label: (parent === null || parent === void 0 ? void 0 : parent.label) || parentId
        };
    }
    const choiceLabel = (_choices$find = choices.find((choice)=>choice.id === choiceId)) === null || _choices$find === void 0 ? void 0 : _choices$find.label;
    return {
        id: choiceId,
        label: choiceLabel || choiceId
    };
};
const $9b0376f6a58bcaa1$export$c787a65b0b5f96bc = (question, formChoices)=>{
    if (question.jiraField) {
        var _formChoices$fields;
        return formChoices === null || formChoices === void 0 || (_formChoices$fields = formChoices.fields) === null || _formChoices$fields === void 0 ? void 0 : _formChoices$fields[question.jiraField];
    }
    if (question.dcId) {
        var _formChoices$dataConn;
        return formChoices === null || formChoices === void 0 || (_formChoices$dataConn = formChoices.dataConnections) === null || _formChoices$dataConn === void 0 ? void 0 : _formChoices$dataConn[question.dcId];
    }
    return undefined;
};
const $9b0376f6a58bcaa1$export$a1a16a8e3e6a4e37 = (choiceIds, hasOtherOption, question, fieldType, linkedChoices, otherOptionText)=>{
    const notOtherSelectedChoiceIds = choiceIds.filter((choice)=>hasOtherOption ? choice !== (0, $gjxgd.OTHER_ID) : true);
    const otherChoiceSelected = hasOtherOption && !linkedChoices && choiceIds.includes((0, $gjxgd.OTHER_ID));
    if (notOtherSelectedChoiceIds.length < 1 && !otherChoiceSelected) return undefined;
    return {
        options: notOtherSelectedChoiceIds.map((choice)=>$9b0376f6a58bcaa1$export$956bffec5f1ea36e(linkedChoices || question.choices || [], choice, fieldType === (0, $2nfpZ.FormFieldType).CASCADING_SELECT)),
        ...otherChoiceSelected && {
            otherOptionText: otherOptionText ?? ''
        }
    };
};
const $9b0376f6a58bcaa1$export$6a9570661353ef6f = (users)=>({
        options: users.map((user)=>({
                id: user.id,
                label: user.name
            }))
    });

});

parcelRegister("59Vzn", function(module, exports) {
$parcel$export(module.exports, "convertValidation", () => $eab2757e80e611e8$export$33149f420056fafa);

var $imRM2 = parcelRequire("imRM2");

var $dS4H4 = parcelRequire("dS4H4");
const $eab2757e80e611e8$export$33149f420056fafa = (question, fieldData, formChoices)=>{
    const { validation: validation } = question;
    const result = {};
    if (validation.mxc !== undefined) result.maximumCharacters = validation.mxc;
    if (validation.mxw !== undefined) result.maximumWords = validation.mxw;
    if (validation.mxn !== undefined) result.maximumNumber = validation.mxn;
    if (validation.mxd !== undefined) result.maximumDate = validation.mxd;
    if (validation.mxt !== undefined) result.maximumTime = validation.mxt;
    if (validation.mxs !== undefined) result.maximumOptionSelections = validation.mxs;
    if (validation.mnc !== undefined) result.minimumCharacters = validation.mnc;
    if (validation.mnw !== undefined) result.minimumWords = validation.mnw;
    if (validation.mnn !== undefined) result.minimumNumber = validation.mnn;
    if (validation.mnd !== undefined) result.minimumDate = validation.mnd;
    if (validation.mnt !== undefined) result.minimumTime = validation.mnt;
    if (validation.mns !== undefined) result.minimumOptionSelections = validation.mns;
    if (validation.rgx !== undefined) result.regexValidation = {
        pattern: validation.rgx.p,
        mismatchMessage: validation.rgx.m
    };
    if (validation.rq !== undefined) result.required = validation.rq;
    if (validation.ch !== undefined && question) {
        const requiredChoiceId = validation.ch;
        const isCascading = question.type === (0, $dS4H4.FormQuestionType).ChoiceCascading;
        const linkedChoices = (0, $imRM2.getLinkedChoices)(question, formChoices);
        if (fieldData !== null && fieldData !== void 0 && fieldData.asyncRequiredChoice) result.requiredOption = {
            id: fieldData.asyncRequiredChoice.id,
            label: fieldData.asyncRequiredChoice.label
        };
        else if (linkedChoices) {
            const choice = (0, $imRM2.findChoice)(linkedChoices, requiredChoiceId, isCascading);
            result.requiredOption = {
                id: choice.id,
                label: choice.label
            };
        } else if (question.choices) {
            const choice = (0, $imRM2.findChoice)(question.choices, requiredChoiceId, isCascading);
            result.requiredOption = {
                id: choice.id,
                label: choice.label
            };
        }
    // the option could not be found at all, so we don't need to validate it
    }
    if (validation.wh !== undefined) result.wholeNumbersOnly = validation.wh;
    return result;
};

});



parcelRegister("6SWKu", function(module, exports) {
$parcel$export(module.exports, "convertSections", () => $f8d5dd573282795b$export$37e831b42c507b36);

var $gdUUy = parcelRequire("gdUUy");

var $gw4Ft = parcelRequire("gw4Ft");

var $cl2bG = parcelRequire("cl2bG");

var $dS4H4 = parcelRequire("dS4H4");
const $f8d5dd573282795b$export$37e831b42c507b36 = (sections, layout, conditions)=>{
    // Map first: `convertSection` resolves each section's conditions from `sections[i]`, where `i`
    // is the position in the original (unfiltered) layout. Filtering before mapping would attach
    // conditions to the wrong sections.
    const formSections = layout.map((layoutNode, i)=>$f8d5dd573282795b$var$convertSection(sections, layoutNode, conditions, i));
    if (!(0, $gdUUy.fg)('proforma-jsdcloud-19698-collapse-empty-sections')) return formSections;
    // Empty sections (e.g. adjacent section dividers) have nothing to show but would otherwise be
    // rendered as an unintended blank line (JSDCLOUD-19698). Everything downstream indexes into
    // the returned array, so removing them here keeps section visibility consistent.
    return formSections.filter((formSection)=>!(0, $cl2bG.isSectionLayoutEmpty)(formSection.layout));
};
const $f8d5dd573282795b$var$convertSection = (sections, layoutNode, conditions, i)=>{
    const section = sections[i];
    const sectionCondition = typeof section === 'undefined' || typeof section.conditions === 'undefined' ? undefined : $f8d5dd573282795b$var$convertConditions(section.conditions.flatMap((id)=>id in conditions ? [
            conditions[id]
        ] : []));
    return {
        layout: layoutNode,
        ...sectionCondition && {
            condition: sectionCondition
        }
    };
};
const $f8d5dd573282795b$var$convertConditions = (conditions)=>{
    var _conditions$0$i$co;
    if (!conditions || conditions.length === 0) return undefined;
    const choiceIds = (_conditions$0$i$co = conditions[0].i.co) === null || _conditions$0$i$co === void 0 ? void 0 : _conditions$0$i$co.cIds;
    const isDeprecatedDataStructure = (0, $gdUUy.fg)('proforma_acl_handle_missing_co_bugfix') ? typeof choiceIds !== 'undefined' && Object.keys(choiceIds).length !== 0 : typeof choiceIds === 'undefined' || Object.keys(choiceIds).length !== 0;
    return isDeprecatedDataStructure ? $f8d5dd573282795b$var$mapOldConditionsToNewDataStructure(conditions) : $f8d5dd573282795b$var$mapCondition(conditions[0]);
};
const $f8d5dd573282795b$var$mapOldConditionsToNewDataStructure = (conditions)=>{
    const checks = conditions.flatMap((condition)=>{
        var _condition$i$co;
        return(// only show type is supported for legacy data structure
        condition.t !== (0, $dS4H4.FormConditionType).Show || typeof ((_condition$i$co = condition.i.co) === null || _condition$i$co === void 0 ? void 0 : _condition$i$co.cIds) === 'undefined' ? [] : Object.entries(condition.i.co.cIds).map(([questionId, choiceIds])=>({
                fieldId: questionId,
                // only some_of operator and option value type is supported in legacy
                type: (0, $gw4Ft.FormSectionConditionCheckType).SOME_OF,
                constraint: choiceIds
            })));
    });
    if (checks.length === 0) return undefined;
    return {
        checkGroups: [
            {
                operator: (0, $gw4Ft.FormSectionConditionOperator).AND,
                checks: checks
            }
        ],
        visibility: (0, $gw4Ft.Visibility).SHOW,
        operator: (0, $gw4Ft.FormSectionConditionOperator).AND
    };
};
const $f8d5dd573282795b$var$mapCondition = (condition)=>{
    if (typeof condition.i.operator === 'undefined') return undefined;
    return {
        checkGroups: condition.i.groups ?? [],
        visibility: $f8d5dd573282795b$var$mapVisibility(condition.t),
        operator: condition.i.operator
    };
};
const $f8d5dd573282795b$var$mapVisibility = (visibility)=>{
    switch(visibility){
        case (0, $dS4H4.FormConditionType).Show:
            return (0, $gw4Ft.Visibility).SHOW;
        case (0, $dS4H4.FormConditionType).Hide:
            return (0, $gw4Ft.Visibility).HIDE;
        default:
            // shouldn't ever happen, here for eslint
            return (0, $gw4Ft.Visibility).SHOW;
    }
};

});



//# sourceMappingURL=shared.f61a6aae.js.map
